var MU = Object.defineProperty;
var AU = (e, t, n) => t in e ? MU(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var Et = (e, t, n) => (AU(e, typeof t != "symbol" ? t + "" : t, n), n);
import * as Ze from "react";
import Wt, { useState as L2, useMemo as lT, useEffect as B2, useRef as OO, useContext as nl, createElement as Ks, useLayoutEffect as cT, forwardRef as HE, memo as fT, Component as Rb, PureComponent as DO, version as PU, createContext as z2, Fragment as MO, Children as NU, isValidElement as OE, cloneElement as DE } from "react";
var $0 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function kU(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function AO(e) {
  var t = e.default;
  if (typeof t == "function") {
    var n = function() {
      return t.apply(this, arguments);
    };
    n.prototype = t.prototype;
  } else
    n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(e).forEach(function(r) {
    var a = Object.getOwnPropertyDescriptor(e, r);
    Object.defineProperty(n, r, a.get ? a : {
      enumerable: !0,
      get: function() {
        return e[r];
      }
    });
  }), n;
}
var V = { exports: {} }, CR = { exports: {} }, ar = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var PP;
function IU() {
  if (PP)
    return ar;
  PP = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, s = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, p = e ? Symbol.for("react.context") : 60110, h = e ? Symbol.for("react.async_mode") : 60111, y = e ? Symbol.for("react.concurrent_mode") : 60111, b = e ? Symbol.for("react.forward_ref") : 60112, E = e ? Symbol.for("react.suspense") : 60113, x = e ? Symbol.for("react.suspense_list") : 60120, C = e ? Symbol.for("react.memo") : 60115, T = e ? Symbol.for("react.lazy") : 60116, O = e ? Symbol.for("react.block") : 60121, D = e ? Symbol.for("react.fundamental") : 60117, A = e ? Symbol.for("react.responder") : 60118, B = e ? Symbol.for("react.scope") : 60119;
  function I(k) {
    if (typeof k == "object" && k !== null) {
      var $ = k.$$typeof;
      switch ($) {
        case t:
          switch (k = k.type, k) {
            case h:
            case y:
            case r:
            case s:
            case a:
            case E:
              return k;
            default:
              switch (k = k && k.$$typeof, k) {
                case p:
                case b:
                case T:
                case C:
                case l:
                  return k;
                default:
                  return $;
              }
          }
        case n:
          return $;
      }
    }
  }
  function L(k) {
    return I(k) === y;
  }
  return ar.AsyncMode = h, ar.ConcurrentMode = y, ar.ContextConsumer = p, ar.ContextProvider = l, ar.Element = t, ar.ForwardRef = b, ar.Fragment = r, ar.Lazy = T, ar.Memo = C, ar.Portal = n, ar.Profiler = s, ar.StrictMode = a, ar.Suspense = E, ar.isAsyncMode = function(k) {
    return L(k) || I(k) === h;
  }, ar.isConcurrentMode = L, ar.isContextConsumer = function(k) {
    return I(k) === p;
  }, ar.isContextProvider = function(k) {
    return I(k) === l;
  }, ar.isElement = function(k) {
    return typeof k == "object" && k !== null && k.$$typeof === t;
  }, ar.isForwardRef = function(k) {
    return I(k) === b;
  }, ar.isFragment = function(k) {
    return I(k) === r;
  }, ar.isLazy = function(k) {
    return I(k) === T;
  }, ar.isMemo = function(k) {
    return I(k) === C;
  }, ar.isPortal = function(k) {
    return I(k) === n;
  }, ar.isProfiler = function(k) {
    return I(k) === s;
  }, ar.isStrictMode = function(k) {
    return I(k) === a;
  }, ar.isSuspense = function(k) {
    return I(k) === E;
  }, ar.isValidElementType = function(k) {
    return typeof k == "string" || typeof k == "function" || k === r || k === y || k === s || k === a || k === E || k === x || typeof k == "object" && k !== null && (k.$$typeof === T || k.$$typeof === C || k.$$typeof === l || k.$$typeof === p || k.$$typeof === b || k.$$typeof === D || k.$$typeof === A || k.$$typeof === B || k.$$typeof === O);
  }, ar.typeOf = I, ar;
}
var or = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var NP;
function LU() {
  return NP || (NP = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, s = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, p = e ? Symbol.for("react.context") : 60110, h = e ? Symbol.for("react.async_mode") : 60111, y = e ? Symbol.for("react.concurrent_mode") : 60111, b = e ? Symbol.for("react.forward_ref") : 60112, E = e ? Symbol.for("react.suspense") : 60113, x = e ? Symbol.for("react.suspense_list") : 60120, C = e ? Symbol.for("react.memo") : 60115, T = e ? Symbol.for("react.lazy") : 60116, O = e ? Symbol.for("react.block") : 60121, D = e ? Symbol.for("react.fundamental") : 60117, A = e ? Symbol.for("react.responder") : 60118, B = e ? Symbol.for("react.scope") : 60119;
    function I(oe) {
      return typeof oe == "string" || typeof oe == "function" || oe === r || oe === y || oe === s || oe === a || oe === E || oe === x || typeof oe == "object" && oe !== null && (oe.$$typeof === T || oe.$$typeof === C || oe.$$typeof === l || oe.$$typeof === p || oe.$$typeof === b || oe.$$typeof === D || oe.$$typeof === A || oe.$$typeof === B || oe.$$typeof === O);
    }
    function L(oe) {
      if (typeof oe == "object" && oe !== null) {
        var it = oe.$$typeof;
        switch (it) {
          case t:
            var Le = oe.type;
            switch (Le) {
              case h:
              case y:
              case r:
              case s:
              case a:
              case E:
                return Le;
              default:
                var qe = Le && Le.$$typeof;
                switch (qe) {
                  case p:
                  case b:
                  case T:
                  case C:
                  case l:
                    return qe;
                  default:
                    return it;
                }
            }
          case n:
            return it;
        }
      }
    }
    var k = h, $ = y, U = p, K = l, X = t, Y = b, J = r, Q = T, Z = C, se = n, pe = s, be = a, _e = E, Se = !1;
    function Oe(oe) {
      return Se || (Se = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), re(oe) || L(oe) === h;
    }
    function re(oe) {
      return L(oe) === y;
    }
    function ie(oe) {
      return L(oe) === p;
    }
    function ce(oe) {
      return L(oe) === l;
    }
    function le(oe) {
      return typeof oe == "object" && oe !== null && oe.$$typeof === t;
    }
    function fe(oe) {
      return L(oe) === b;
    }
    function ve(oe) {
      return L(oe) === r;
    }
    function ee(oe) {
      return L(oe) === T;
    }
    function Ae(oe) {
      return L(oe) === C;
    }
    function he(oe) {
      return L(oe) === n;
    }
    function Fe(oe) {
      return L(oe) === s;
    }
    function Ne(oe) {
      return L(oe) === a;
    }
    function xe(oe) {
      return L(oe) === E;
    }
    or.AsyncMode = k, or.ConcurrentMode = $, or.ContextConsumer = U, or.ContextProvider = K, or.Element = X, or.ForwardRef = Y, or.Fragment = J, or.Lazy = Q, or.Memo = Z, or.Portal = se, or.Profiler = pe, or.StrictMode = be, or.Suspense = _e, or.isAsyncMode = Oe, or.isConcurrentMode = re, or.isContextConsumer = ie, or.isContextProvider = ce, or.isElement = le, or.isForwardRef = fe, or.isFragment = ve, or.isLazy = ee, or.isMemo = Ae, or.isPortal = he, or.isProfiler = Fe, or.isStrictMode = Ne, or.isSuspense = xe, or.isValidElementType = I, or.typeOf = L;
  }()), or;
}
var kP;
function F2() {
  return kP || (kP = 1, function(e) {
    process.env.NODE_ENV === "production" ? e.exports = IU() : e.exports = LU();
  }(CR)), CR.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var RR, IP;
function Tb() {
  if (IP)
    return RR;
  IP = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(s) {
    if (s == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(s);
  }
  function a() {
    try {
      if (!Object.assign)
        return !1;
      var s = new String("abc");
      if (s[5] = "de", Object.getOwnPropertyNames(s)[0] === "5")
        return !1;
      for (var l = {}, p = 0; p < 10; p++)
        l["_" + String.fromCharCode(p)] = p;
      var h = Object.getOwnPropertyNames(l).map(function(b) {
        return l[b];
      });
      if (h.join("") !== "0123456789")
        return !1;
      var y = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(b) {
        y[b] = b;
      }), Object.keys(Object.assign({}, y)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return RR = a() ? Object.assign : function(s, l) {
    for (var p, h = r(s), y, b = 1; b < arguments.length; b++) {
      p = Object(arguments[b]);
      for (var E in p)
        t.call(p, E) && (h[E] = p[E]);
      if (e) {
        y = e(p);
        for (var x = 0; x < y.length; x++)
          n.call(p, y[x]) && (h[y[x]] = p[y[x]]);
      }
    }
    return h;
  }, RR;
}
var TR, LP;
function PO() {
  if (LP)
    return TR;
  LP = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return TR = e, TR;
}
var OR, BP;
function $2() {
  return BP || (BP = 1, OR = Function.call.bind(Object.prototype.hasOwnProperty)), OR;
}
var DR, zP;
function BU() {
  if (zP)
    return DR;
  zP = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = PO(), n = {}, r = $2();
    e = function(s) {
      var l = "Warning: " + s;
      typeof console < "u" && console.error(l);
      try {
        throw new Error(l);
      } catch {
      }
    };
  }
  function a(s, l, p, h, y) {
    if (process.env.NODE_ENV !== "production") {
      for (var b in s)
        if (r(s, b)) {
          var E;
          try {
            if (typeof s[b] != "function") {
              var x = Error(
                (h || "React class") + ": " + p + " type `" + b + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof s[b] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw x.name = "Invariant Violation", x;
            }
            E = s[b](l, b, h, p, null, t);
          } catch (T) {
            E = T;
          }
          if (E && !(E instanceof Error) && e(
            (h || "React class") + ": type specification of " + p + " `" + b + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof E + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), E instanceof Error && !(E.message in n)) {
            n[E.message] = !0;
            var C = y ? y() : "";
            e(
              "Failed " + p + " type: " + E.message + (C != null ? C : "")
            );
          }
        }
    }
  }
  return a.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, DR = a, DR;
}
var MR, FP;
function zU() {
  if (FP)
    return MR;
  FP = 1;
  var e = F2(), t = Tb(), n = PO(), r = $2(), a = BU(), s = function() {
  };
  process.env.NODE_ENV !== "production" && (s = function(p) {
    var h = "Warning: " + p;
    typeof console < "u" && console.error(h);
    try {
      throw new Error(h);
    } catch {
    }
  });
  function l() {
    return null;
  }
  return MR = function(p, h) {
    var y = typeof Symbol == "function" && Symbol.iterator, b = "@@iterator";
    function E(re) {
      var ie = re && (y && re[y] || re[b]);
      if (typeof ie == "function")
        return ie;
    }
    var x = "<<anonymous>>", C = {
      array: A("array"),
      bigint: A("bigint"),
      bool: A("boolean"),
      func: A("function"),
      number: A("number"),
      object: A("object"),
      string: A("string"),
      symbol: A("symbol"),
      any: B(),
      arrayOf: I,
      element: L(),
      elementType: k(),
      instanceOf: $,
      node: Y(),
      objectOf: K,
      oneOf: U,
      oneOfType: X,
      shape: Q,
      exact: Z
    };
    function T(re, ie) {
      return re === ie ? re !== 0 || 1 / re === 1 / ie : re !== re && ie !== ie;
    }
    function O(re, ie) {
      this.message = re, this.data = ie && typeof ie == "object" ? ie : {}, this.stack = "";
    }
    O.prototype = Error.prototype;
    function D(re) {
      if (process.env.NODE_ENV !== "production")
        var ie = {}, ce = 0;
      function le(ve, ee, Ae, he, Fe, Ne, xe) {
        if (he = he || x, Ne = Ne || Ae, xe !== n) {
          if (h) {
            var oe = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw oe.name = "Invariant Violation", oe;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var it = he + ":" + Ae;
            !ie[it] && ce < 3 && (s(
              "You are manually calling a React.PropTypes validation function for the `" + Ne + "` prop on `" + he + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), ie[it] = !0, ce++);
          }
        }
        return ee[Ae] == null ? ve ? ee[Ae] === null ? new O("The " + Fe + " `" + Ne + "` is marked as required " + ("in `" + he + "`, but its value is `null`.")) : new O("The " + Fe + " `" + Ne + "` is marked as required in " + ("`" + he + "`, but its value is `undefined`.")) : null : re(ee, Ae, he, Fe, Ne);
      }
      var fe = le.bind(null, !1);
      return fe.isRequired = le.bind(null, !0), fe;
    }
    function A(re) {
      function ie(ce, le, fe, ve, ee, Ae) {
        var he = ce[le], Fe = be(he);
        if (Fe !== re) {
          var Ne = _e(he);
          return new O(
            "Invalid " + ve + " `" + ee + "` of type " + ("`" + Ne + "` supplied to `" + fe + "`, expected ") + ("`" + re + "`."),
            { expectedType: re }
          );
        }
        return null;
      }
      return D(ie);
    }
    function B() {
      return D(l);
    }
    function I(re) {
      function ie(ce, le, fe, ve, ee) {
        if (typeof re != "function")
          return new O("Property `" + ee + "` of component `" + fe + "` has invalid PropType notation inside arrayOf.");
        var Ae = ce[le];
        if (!Array.isArray(Ae)) {
          var he = be(Ae);
          return new O("Invalid " + ve + " `" + ee + "` of type " + ("`" + he + "` supplied to `" + fe + "`, expected an array."));
        }
        for (var Fe = 0; Fe < Ae.length; Fe++) {
          var Ne = re(Ae, Fe, fe, ve, ee + "[" + Fe + "]", n);
          if (Ne instanceof Error)
            return Ne;
        }
        return null;
      }
      return D(ie);
    }
    function L() {
      function re(ie, ce, le, fe, ve) {
        var ee = ie[ce];
        if (!p(ee)) {
          var Ae = be(ee);
          return new O("Invalid " + fe + " `" + ve + "` of type " + ("`" + Ae + "` supplied to `" + le + "`, expected a single ReactElement."));
        }
        return null;
      }
      return D(re);
    }
    function k() {
      function re(ie, ce, le, fe, ve) {
        var ee = ie[ce];
        if (!e.isValidElementType(ee)) {
          var Ae = be(ee);
          return new O("Invalid " + fe + " `" + ve + "` of type " + ("`" + Ae + "` supplied to `" + le + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return D(re);
    }
    function $(re) {
      function ie(ce, le, fe, ve, ee) {
        if (!(ce[le] instanceof re)) {
          var Ae = re.name || x, he = Oe(ce[le]);
          return new O("Invalid " + ve + " `" + ee + "` of type " + ("`" + he + "` supplied to `" + fe + "`, expected ") + ("instance of `" + Ae + "`."));
        }
        return null;
      }
      return D(ie);
    }
    function U(re) {
      if (!Array.isArray(re))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? s(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : s("Invalid argument supplied to oneOf, expected an array.")), l;
      function ie(ce, le, fe, ve, ee) {
        for (var Ae = ce[le], he = 0; he < re.length; he++)
          if (T(Ae, re[he]))
            return null;
        var Fe = JSON.stringify(re, function(xe, oe) {
          var it = _e(oe);
          return it === "symbol" ? String(oe) : oe;
        });
        return new O("Invalid " + ve + " `" + ee + "` of value `" + String(Ae) + "` " + ("supplied to `" + fe + "`, expected one of " + Fe + "."));
      }
      return D(ie);
    }
    function K(re) {
      function ie(ce, le, fe, ve, ee) {
        if (typeof re != "function")
          return new O("Property `" + ee + "` of component `" + fe + "` has invalid PropType notation inside objectOf.");
        var Ae = ce[le], he = be(Ae);
        if (he !== "object")
          return new O("Invalid " + ve + " `" + ee + "` of type " + ("`" + he + "` supplied to `" + fe + "`, expected an object."));
        for (var Fe in Ae)
          if (r(Ae, Fe)) {
            var Ne = re(Ae, Fe, fe, ve, ee + "." + Fe, n);
            if (Ne instanceof Error)
              return Ne;
          }
        return null;
      }
      return D(ie);
    }
    function X(re) {
      if (!Array.isArray(re))
        return process.env.NODE_ENV !== "production" && s("Invalid argument supplied to oneOfType, expected an instance of array."), l;
      for (var ie = 0; ie < re.length; ie++) {
        var ce = re[ie];
        if (typeof ce != "function")
          return s(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + Se(ce) + " at index " + ie + "."
          ), l;
      }
      function le(fe, ve, ee, Ae, he) {
        for (var Fe = [], Ne = 0; Ne < re.length; Ne++) {
          var xe = re[Ne], oe = xe(fe, ve, ee, Ae, he, n);
          if (oe == null)
            return null;
          oe.data && r(oe.data, "expectedType") && Fe.push(oe.data.expectedType);
        }
        var it = Fe.length > 0 ? ", expected one of type [" + Fe.join(", ") + "]" : "";
        return new O("Invalid " + Ae + " `" + he + "` supplied to " + ("`" + ee + "`" + it + "."));
      }
      return D(le);
    }
    function Y() {
      function re(ie, ce, le, fe, ve) {
        return se(ie[ce]) ? null : new O("Invalid " + fe + " `" + ve + "` supplied to " + ("`" + le + "`, expected a ReactNode."));
      }
      return D(re);
    }
    function J(re, ie, ce, le, fe) {
      return new O(
        (re || "React class") + ": " + ie + " type `" + ce + "." + le + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + fe + "`."
      );
    }
    function Q(re) {
      function ie(ce, le, fe, ve, ee) {
        var Ae = ce[le], he = be(Ae);
        if (he !== "object")
          return new O("Invalid " + ve + " `" + ee + "` of type `" + he + "` " + ("supplied to `" + fe + "`, expected `object`."));
        for (var Fe in re) {
          var Ne = re[Fe];
          if (typeof Ne != "function")
            return J(fe, ve, ee, Fe, _e(Ne));
          var xe = Ne(Ae, Fe, fe, ve, ee + "." + Fe, n);
          if (xe)
            return xe;
        }
        return null;
      }
      return D(ie);
    }
    function Z(re) {
      function ie(ce, le, fe, ve, ee) {
        var Ae = ce[le], he = be(Ae);
        if (he !== "object")
          return new O("Invalid " + ve + " `" + ee + "` of type `" + he + "` " + ("supplied to `" + fe + "`, expected `object`."));
        var Fe = t({}, ce[le], re);
        for (var Ne in Fe) {
          var xe = re[Ne];
          if (r(re, Ne) && typeof xe != "function")
            return J(fe, ve, ee, Ne, _e(xe));
          if (!xe)
            return new O(
              "Invalid " + ve + " `" + ee + "` key `" + Ne + "` supplied to `" + fe + "`.\nBad object: " + JSON.stringify(ce[le], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(re), null, "  ")
            );
          var oe = xe(Ae, Ne, fe, ve, ee + "." + Ne, n);
          if (oe)
            return oe;
        }
        return null;
      }
      return D(ie);
    }
    function se(re) {
      switch (typeof re) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !re;
        case "object":
          if (Array.isArray(re))
            return re.every(se);
          if (re === null || p(re))
            return !0;
          var ie = E(re);
          if (ie) {
            var ce = ie.call(re), le;
            if (ie !== re.entries) {
              for (; !(le = ce.next()).done; )
                if (!se(le.value))
                  return !1;
            } else
              for (; !(le = ce.next()).done; ) {
                var fe = le.value;
                if (fe && !se(fe[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function pe(re, ie) {
      return re === "symbol" ? !0 : ie ? ie["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && ie instanceof Symbol : !1;
    }
    function be(re) {
      var ie = typeof re;
      return Array.isArray(re) ? "array" : re instanceof RegExp ? "object" : pe(ie, re) ? "symbol" : ie;
    }
    function _e(re) {
      if (typeof re > "u" || re === null)
        return "" + re;
      var ie = be(re);
      if (ie === "object") {
        if (re instanceof Date)
          return "date";
        if (re instanceof RegExp)
          return "regexp";
      }
      return ie;
    }
    function Se(re) {
      var ie = _e(re);
      switch (ie) {
        case "array":
        case "object":
          return "an " + ie;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + ie;
        default:
          return ie;
      }
    }
    function Oe(re) {
      return !re.constructor || !re.constructor.name ? x : re.constructor.name;
    }
    return C.checkPropTypes = a, C.resetWarningCache = a.resetWarningCache, C.PropTypes = C, C;
  }, MR;
}
var AR, $P;
function FU() {
  if ($P)
    return AR;
  $P = 1;
  var e = PO();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, AR = function() {
    function r(l, p, h, y, b, E) {
      if (E !== e) {
        var x = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw x.name = "Invariant Violation", x;
      }
    }
    r.isRequired = r;
    function a() {
      return r;
    }
    var s = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: a,
      element: r,
      elementType: r,
      instanceOf: a,
      node: r,
      objectOf: a,
      oneOf: a,
      oneOfType: a,
      shape: a,
      exact: a,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return s.PropTypes = s, s;
  }, AR;
}
if (process.env.NODE_ENV !== "production") {
  var $U = F2(), UU = !0;
  V.exports = zU()($U.isElement, UU);
} else
  V.exports = FU()();
var sy = { exports: {} }, sr = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var UP;
function VU() {
  if (UP)
    return sr;
  UP = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), p = Symbol.for("react.server_context"), h = Symbol.for("react.forward_ref"), y = Symbol.for("react.suspense"), b = Symbol.for("react.suspense_list"), E = Symbol.for("react.memo"), x = Symbol.for("react.lazy"), C = Symbol.for("react.offscreen"), T;
  T = Symbol.for("react.module.reference");
  function O(D) {
    if (typeof D == "object" && D !== null) {
      var A = D.$$typeof;
      switch (A) {
        case e:
          switch (D = D.type, D) {
            case n:
            case a:
            case r:
            case y:
            case b:
              return D;
            default:
              switch (D = D && D.$$typeof, D) {
                case p:
                case l:
                case h:
                case x:
                case E:
                case s:
                  return D;
                default:
                  return A;
              }
          }
        case t:
          return A;
      }
    }
  }
  return sr.ContextConsumer = l, sr.ContextProvider = s, sr.Element = e, sr.ForwardRef = h, sr.Fragment = n, sr.Lazy = x, sr.Memo = E, sr.Portal = t, sr.Profiler = a, sr.StrictMode = r, sr.Suspense = y, sr.SuspenseList = b, sr.isAsyncMode = function() {
    return !1;
  }, sr.isConcurrentMode = function() {
    return !1;
  }, sr.isContextConsumer = function(D) {
    return O(D) === l;
  }, sr.isContextProvider = function(D) {
    return O(D) === s;
  }, sr.isElement = function(D) {
    return typeof D == "object" && D !== null && D.$$typeof === e;
  }, sr.isForwardRef = function(D) {
    return O(D) === h;
  }, sr.isFragment = function(D) {
    return O(D) === n;
  }, sr.isLazy = function(D) {
    return O(D) === x;
  }, sr.isMemo = function(D) {
    return O(D) === E;
  }, sr.isPortal = function(D) {
    return O(D) === t;
  }, sr.isProfiler = function(D) {
    return O(D) === a;
  }, sr.isStrictMode = function(D) {
    return O(D) === r;
  }, sr.isSuspense = function(D) {
    return O(D) === y;
  }, sr.isSuspenseList = function(D) {
    return O(D) === b;
  }, sr.isValidElementType = function(D) {
    return typeof D == "string" || typeof D == "function" || D === n || D === a || D === r || D === y || D === b || D === C || typeof D == "object" && D !== null && (D.$$typeof === x || D.$$typeof === E || D.$$typeof === s || D.$$typeof === l || D.$$typeof === h || D.$$typeof === T || D.getModuleId !== void 0);
  }, sr.typeOf = O, sr;
}
var ur = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var VP;
function jU() {
  return VP || (VP = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), p = Symbol.for("react.server_context"), h = Symbol.for("react.forward_ref"), y = Symbol.for("react.suspense"), b = Symbol.for("react.suspense_list"), E = Symbol.for("react.memo"), x = Symbol.for("react.lazy"), C = Symbol.for("react.offscreen"), T = !1, O = !1, D = !1, A = !1, B = !1, I;
    I = Symbol.for("react.module.reference");
    function L(Le) {
      return !!(typeof Le == "string" || typeof Le == "function" || Le === n || Le === a || B || Le === r || Le === y || Le === b || A || Le === C || T || O || D || typeof Le == "object" && Le !== null && (Le.$$typeof === x || Le.$$typeof === E || Le.$$typeof === s || Le.$$typeof === l || Le.$$typeof === h || Le.$$typeof === I || Le.getModuleId !== void 0));
    }
    function k(Le) {
      if (typeof Le == "object" && Le !== null) {
        var qe = Le.$$typeof;
        switch (qe) {
          case e:
            var Tt = Le.type;
            switch (Tt) {
              case n:
              case a:
              case r:
              case y:
              case b:
                return Tt;
              default:
                var Qe = Tt && Tt.$$typeof;
                switch (Qe) {
                  case p:
                  case l:
                  case h:
                  case x:
                  case E:
                  case s:
                    return Qe;
                  default:
                    return qe;
                }
            }
          case t:
            return qe;
        }
      }
    }
    var $ = l, U = s, K = e, X = h, Y = n, J = x, Q = E, Z = t, se = a, pe = r, be = y, _e = b, Se = !1, Oe = !1;
    function re(Le) {
      return Se || (Se = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function ie(Le) {
      return Oe || (Oe = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function ce(Le) {
      return k(Le) === l;
    }
    function le(Le) {
      return k(Le) === s;
    }
    function fe(Le) {
      return typeof Le == "object" && Le !== null && Le.$$typeof === e;
    }
    function ve(Le) {
      return k(Le) === h;
    }
    function ee(Le) {
      return k(Le) === n;
    }
    function Ae(Le) {
      return k(Le) === x;
    }
    function he(Le) {
      return k(Le) === E;
    }
    function Fe(Le) {
      return k(Le) === t;
    }
    function Ne(Le) {
      return k(Le) === a;
    }
    function xe(Le) {
      return k(Le) === r;
    }
    function oe(Le) {
      return k(Le) === y;
    }
    function it(Le) {
      return k(Le) === b;
    }
    ur.ContextConsumer = $, ur.ContextProvider = U, ur.Element = K, ur.ForwardRef = X, ur.Fragment = Y, ur.Lazy = J, ur.Memo = Q, ur.Portal = Z, ur.Profiler = se, ur.StrictMode = pe, ur.Suspense = be, ur.SuspenseList = _e, ur.isAsyncMode = re, ur.isConcurrentMode = ie, ur.isContextConsumer = ce, ur.isContextProvider = le, ur.isElement = fe, ur.isForwardRef = ve, ur.isFragment = ee, ur.isLazy = Ae, ur.isMemo = he, ur.isPortal = Fe, ur.isProfiler = Ne, ur.isStrictMode = xe, ur.isSuspense = oe, ur.isSuspenseList = it, ur.isValidElementType = L, ur.typeOf = k;
  }()), ur;
}
(function(e) {
  process.env.NODE_ENV === "production" ? e.exports = VU() : e.exports = jU();
})(sy);
var WU = function(t, n, r, a) {
  var s = r ? r.call(a, t, n) : void 0;
  if (s !== void 0)
    return !!s;
  if (t === n)
    return !0;
  if (typeof t != "object" || !t || typeof n != "object" || !n)
    return !1;
  var l = Object.keys(t), p = Object.keys(n);
  if (l.length !== p.length)
    return !1;
  for (var h = Object.prototype.hasOwnProperty.bind(n), y = 0; y < l.length; y++) {
    var b = l[y];
    if (!h(b))
      return !1;
    var E = t[b], x = n[b];
    if (s = r ? r.call(a, E, x, b) : void 0, s === !1 || s === void 0 && E !== x)
      return !1;
  }
  return !0;
};
function GU(e) {
  function t(ce, le, fe, ve, ee) {
    for (var Ae = 0, he = 0, Fe = 0, Ne = 0, xe, oe, it = 0, Le = 0, qe, Tt = qe = xe = 0, Qe = 0, pt = 0, en = 0, wt = 0, tn = fe.length, Vn = tn - 1, Kt, ft = "", Gt = "", xn = "", gn = "", rr; Qe < tn; ) {
      if (oe = fe.charCodeAt(Qe), Qe === Vn && he + Ne + Fe + Ae !== 0 && (he !== 0 && (oe = he === 47 ? 10 : 47), Ne = Fe = Ae = 0, tn++, Vn++), he + Ne + Fe + Ae === 0) {
        if (Qe === Vn && (0 < pt && (ft = ft.replace(x, "")), 0 < ft.trim().length)) {
          switch (oe) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;
            default:
              ft += fe.charAt(Qe);
          }
          oe = 59;
        }
        switch (oe) {
          case 123:
            for (ft = ft.trim(), xe = ft.charCodeAt(0), qe = 1, wt = ++Qe; Qe < tn; ) {
              switch (oe = fe.charCodeAt(Qe)) {
                case 123:
                  qe++;
                  break;
                case 125:
                  qe--;
                  break;
                case 47:
                  switch (oe = fe.charCodeAt(Qe + 1)) {
                    case 42:
                    case 47:
                      e: {
                        for (Tt = Qe + 1; Tt < Vn; ++Tt)
                          switch (fe.charCodeAt(Tt)) {
                            case 47:
                              if (oe === 42 && fe.charCodeAt(Tt - 1) === 42 && Qe + 2 !== Tt) {
                                Qe = Tt + 1;
                                break e;
                              }
                              break;
                            case 10:
                              if (oe === 47) {
                                Qe = Tt + 1;
                                break e;
                              }
                          }
                        Qe = Tt;
                      }
                  }
                  break;
                case 91:
                  oe++;
                case 40:
                  oe++;
                case 34:
                case 39:
                  for (; Qe++ < Vn && fe.charCodeAt(Qe) !== oe; )
                    ;
              }
              if (qe === 0)
                break;
              Qe++;
            }
            switch (qe = fe.substring(wt, Qe), xe === 0 && (xe = (ft = ft.replace(E, "").trim()).charCodeAt(0)), xe) {
              case 64:
                switch (0 < pt && (ft = ft.replace(x, "")), oe = ft.charCodeAt(1), oe) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    pt = le;
                    break;
                  default:
                    pt = be;
                }
                if (qe = t(le, pt, qe, oe, ee + 1), wt = qe.length, 0 < Se && (pt = n(be, ft, en), rr = p(3, qe, pt, le, Z, Q, wt, oe, ee, ve), ft = pt.join(""), rr !== void 0 && (wt = (qe = rr.trim()).length) === 0 && (oe = 0, qe = "")), 0 < wt)
                  switch (oe) {
                    case 115:
                      ft = ft.replace($, l);
                    case 100:
                    case 109:
                    case 45:
                      qe = ft + "{" + qe + "}";
                      break;
                    case 107:
                      ft = ft.replace(B, "$1 $2"), qe = ft + "{" + qe + "}", qe = pe === 1 || pe === 2 && s("@" + qe, 3) ? "@-webkit-" + qe + "@" + qe : "@" + qe;
                      break;
                    default:
                      qe = ft + qe, ve === 112 && (qe = (Gt += qe, ""));
                  }
                else
                  qe = "";
                break;
              default:
                qe = t(le, n(le, ft, en), qe, ve, ee + 1);
            }
            xn += qe, qe = en = pt = Tt = xe = 0, ft = "", oe = fe.charCodeAt(++Qe);
            break;
          case 125:
          case 59:
            if (ft = (0 < pt ? ft.replace(x, "") : ft).trim(), 1 < (wt = ft.length))
              switch (Tt === 0 && (xe = ft.charCodeAt(0), xe === 45 || 96 < xe && 123 > xe) && (wt = (ft = ft.replace(" ", ":")).length), 0 < Se && (rr = p(1, ft, le, ce, Z, Q, Gt.length, ve, ee, ve)) !== void 0 && (wt = (ft = rr.trim()).length) === 0 && (ft = "\0\0"), xe = ft.charCodeAt(0), oe = ft.charCodeAt(1), xe) {
                case 0:
                  break;
                case 64:
                  if (oe === 105 || oe === 99) {
                    gn += ft + fe.charAt(Qe);
                    break;
                  }
                default:
                  ft.charCodeAt(wt - 1) !== 58 && (Gt += a(ft, xe, oe, ft.charCodeAt(2)));
              }
            en = pt = Tt = xe = 0, ft = "", oe = fe.charCodeAt(++Qe);
        }
      }
      switch (oe) {
        case 13:
        case 10:
          he === 47 ? he = 0 : 1 + xe === 0 && ve !== 107 && 0 < ft.length && (pt = 1, ft += "\0"), 0 < Se * re && p(0, ft, le, ce, Z, Q, Gt.length, ve, ee, ve), Q = 1, Z++;
          break;
        case 59:
        case 125:
          if (he + Ne + Fe + Ae === 0) {
            Q++;
            break;
          }
        default:
          switch (Q++, Kt = fe.charAt(Qe), oe) {
            case 9:
            case 32:
              if (Ne + Ae + he === 0)
                switch (it) {
                  case 44:
                  case 58:
                  case 9:
                  case 32:
                    Kt = "";
                    break;
                  default:
                    oe !== 32 && (Kt = " ");
                }
              break;
            case 0:
              Kt = "\\0";
              break;
            case 12:
              Kt = "\\f";
              break;
            case 11:
              Kt = "\\v";
              break;
            case 38:
              Ne + he + Ae === 0 && (pt = en = 1, Kt = "\f" + Kt);
              break;
            case 108:
              if (Ne + he + Ae + se === 0 && 0 < Tt)
                switch (Qe - Tt) {
                  case 2:
                    it === 112 && fe.charCodeAt(Qe - 3) === 58 && (se = it);
                  case 8:
                    Le === 111 && (se = Le);
                }
              break;
            case 58:
              Ne + he + Ae === 0 && (Tt = Qe);
              break;
            case 44:
              he + Fe + Ne + Ae === 0 && (pt = 1, Kt += "\r");
              break;
            case 34:
            case 39:
              he === 0 && (Ne = Ne === oe ? 0 : Ne === 0 ? oe : Ne);
              break;
            case 91:
              Ne + he + Fe === 0 && Ae++;
              break;
            case 93:
              Ne + he + Fe === 0 && Ae--;
              break;
            case 41:
              Ne + he + Ae === 0 && Fe--;
              break;
            case 40:
              if (Ne + he + Ae === 0) {
                if (xe === 0)
                  switch (2 * it + 3 * Le) {
                    case 533:
                      break;
                    default:
                      xe = 1;
                  }
                Fe++;
              }
              break;
            case 64:
              he + Fe + Ne + Ae + Tt + qe === 0 && (qe = 1);
              break;
            case 42:
            case 47:
              if (!(0 < Ne + Ae + Fe))
                switch (he) {
                  case 0:
                    switch (2 * oe + 3 * fe.charCodeAt(Qe + 1)) {
                      case 235:
                        he = 47;
                        break;
                      case 220:
                        wt = Qe, he = 42;
                    }
                    break;
                  case 42:
                    oe === 47 && it === 42 && wt + 2 !== Qe && (fe.charCodeAt(wt + 2) === 33 && (Gt += fe.substring(wt, Qe + 1)), Kt = "", he = 0);
                }
          }
          he === 0 && (ft += Kt);
      }
      Le = it, it = oe, Qe++;
    }
    if (wt = Gt.length, 0 < wt) {
      if (pt = le, 0 < Se && (rr = p(2, Gt, pt, ce, Z, Q, wt, ve, ee, ve), rr !== void 0 && (Gt = rr).length === 0))
        return gn + Gt + xn;
      if (Gt = pt.join(",") + "{" + Gt + "}", pe * se !== 0) {
        switch (pe !== 2 || s(Gt, 2) || (se = 0), se) {
          case 111:
            Gt = Gt.replace(L, ":-moz-$1") + Gt;
            break;
          case 112:
            Gt = Gt.replace(I, "::-webkit-input-$1") + Gt.replace(I, "::-moz-$1") + Gt.replace(I, ":-ms-input-$1") + Gt;
        }
        se = 0;
      }
    }
    return gn + Gt + xn;
  }
  function n(ce, le, fe) {
    var ve = le.trim().split(D);
    le = ve;
    var ee = ve.length, Ae = ce.length;
    switch (Ae) {
      case 0:
      case 1:
        var he = 0;
        for (ce = Ae === 0 ? "" : ce[0] + " "; he < ee; ++he)
          le[he] = r(ce, le[he], fe).trim();
        break;
      default:
        var Fe = he = 0;
        for (le = []; he < ee; ++he)
          for (var Ne = 0; Ne < Ae; ++Ne)
            le[Fe++] = r(ce[Ne] + " ", ve[he], fe).trim();
    }
    return le;
  }
  function r(ce, le, fe) {
    var ve = le.charCodeAt(0);
    switch (33 > ve && (ve = (le = le.trim()).charCodeAt(0)), ve) {
      case 38:
        return le.replace(A, "$1" + ce.trim());
      case 58:
        return ce.trim() + le.replace(A, "$1" + ce.trim());
      default:
        if (0 < 1 * fe && 0 < le.indexOf("\f"))
          return le.replace(A, (ce.charCodeAt(0) === 58 ? "" : "$1") + ce.trim());
    }
    return ce + le;
  }
  function a(ce, le, fe, ve) {
    var ee = ce + ";", Ae = 2 * le + 3 * fe + 4 * ve;
    if (Ae === 944) {
      ce = ee.indexOf(":", 9) + 1;
      var he = ee.substring(ce, ee.length - 1).trim();
      return he = ee.substring(0, ce).trim() + he + ";", pe === 1 || pe === 2 && s(he, 1) ? "-webkit-" + he + he : he;
    }
    if (pe === 0 || pe === 2 && !s(ee, 1))
      return ee;
    switch (Ae) {
      case 1015:
        return ee.charCodeAt(10) === 97 ? "-webkit-" + ee + ee : ee;
      case 951:
        return ee.charCodeAt(3) === 116 ? "-webkit-" + ee + ee : ee;
      case 963:
        return ee.charCodeAt(5) === 110 ? "-webkit-" + ee + ee : ee;
      case 1009:
        if (ee.charCodeAt(4) !== 100)
          break;
      case 969:
      case 942:
        return "-webkit-" + ee + ee;
      case 978:
        return "-webkit-" + ee + "-moz-" + ee + ee;
      case 1019:
      case 983:
        return "-webkit-" + ee + "-moz-" + ee + "-ms-" + ee + ee;
      case 883:
        if (ee.charCodeAt(8) === 45)
          return "-webkit-" + ee + ee;
        if (0 < ee.indexOf("image-set(", 11))
          return ee.replace(J, "$1-webkit-$2") + ee;
        break;
      case 932:
        if (ee.charCodeAt(4) === 45)
          switch (ee.charCodeAt(5)) {
            case 103:
              return "-webkit-box-" + ee.replace("-grow", "") + "-webkit-" + ee + "-ms-" + ee.replace("grow", "positive") + ee;
            case 115:
              return "-webkit-" + ee + "-ms-" + ee.replace("shrink", "negative") + ee;
            case 98:
              return "-webkit-" + ee + "-ms-" + ee.replace("basis", "preferred-size") + ee;
          }
        return "-webkit-" + ee + "-ms-" + ee + ee;
      case 964:
        return "-webkit-" + ee + "-ms-flex-" + ee + ee;
      case 1023:
        if (ee.charCodeAt(8) !== 99)
          break;
        return he = ee.substring(ee.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify"), "-webkit-box-pack" + he + "-webkit-" + ee + "-ms-flex-pack" + he + ee;
      case 1005:
        return T.test(ee) ? ee.replace(C, ":-webkit-") + ee.replace(C, ":-moz-") + ee : ee;
      case 1e3:
        switch (he = ee.substring(13).trim(), le = he.indexOf("-") + 1, he.charCodeAt(0) + he.charCodeAt(le)) {
          case 226:
            he = ee.replace(k, "tb");
            break;
          case 232:
            he = ee.replace(k, "tb-rl");
            break;
          case 220:
            he = ee.replace(k, "lr");
            break;
          default:
            return ee;
        }
        return "-webkit-" + ee + "-ms-" + he + ee;
      case 1017:
        if (ee.indexOf("sticky", 9) === -1)
          break;
      case 975:
        switch (le = (ee = ce).length - 10, he = (ee.charCodeAt(le) === 33 ? ee.substring(0, le) : ee).substring(ce.indexOf(":", 7) + 1).trim(), Ae = he.charCodeAt(0) + (he.charCodeAt(7) | 0)) {
          case 203:
            if (111 > he.charCodeAt(8))
              break;
          case 115:
            ee = ee.replace(he, "-webkit-" + he) + ";" + ee;
            break;
          case 207:
          case 102:
            ee = ee.replace(he, "-webkit-" + (102 < Ae ? "inline-" : "") + "box") + ";" + ee.replace(he, "-webkit-" + he) + ";" + ee.replace(he, "-ms-" + he + "box") + ";" + ee;
        }
        return ee + ";";
      case 938:
        if (ee.charCodeAt(5) === 45)
          switch (ee.charCodeAt(6)) {
            case 105:
              return he = ee.replace("-items", ""), "-webkit-" + ee + "-webkit-box-" + he + "-ms-flex-" + he + ee;
            case 115:
              return "-webkit-" + ee + "-ms-flex-item-" + ee.replace(K, "") + ee;
            default:
              return "-webkit-" + ee + "-ms-flex-line-pack" + ee.replace("align-content", "").replace(K, "") + ee;
          }
        break;
      case 973:
      case 989:
        if (ee.charCodeAt(3) !== 45 || ee.charCodeAt(4) === 122)
          break;
      case 931:
      case 953:
        if (Y.test(ce) === !0)
          return (he = ce.substring(ce.indexOf(":") + 1)).charCodeAt(0) === 115 ? a(ce.replace("stretch", "fill-available"), le, fe, ve).replace(":fill-available", ":stretch") : ee.replace(he, "-webkit-" + he) + ee.replace(he, "-moz-" + he.replace("fill-", "")) + ee;
        break;
      case 962:
        if (ee = "-webkit-" + ee + (ee.charCodeAt(5) === 102 ? "-ms-" + ee : "") + ee, fe + ve === 211 && ee.charCodeAt(13) === 105 && 0 < ee.indexOf("transform", 10))
          return ee.substring(0, ee.indexOf(";", 27) + 1).replace(O, "$1-webkit-$2") + ee;
    }
    return ee;
  }
  function s(ce, le) {
    var fe = ce.indexOf(le === 1 ? ":" : "{"), ve = ce.substring(0, le !== 3 ? fe : 10);
    return fe = ce.substring(fe + 1, ce.length - 1), Oe(le !== 2 ? ve : ve.replace(X, "$1"), fe, le);
  }
  function l(ce, le) {
    var fe = a(le, le.charCodeAt(0), le.charCodeAt(1), le.charCodeAt(2));
    return fe !== le + ";" ? fe.replace(U, " or ($1)").substring(4) : "(" + le + ")";
  }
  function p(ce, le, fe, ve, ee, Ae, he, Fe, Ne, xe) {
    for (var oe = 0, it = le, Le; oe < Se; ++oe)
      switch (Le = _e[oe].call(b, ce, it, fe, ve, ee, Ae, he, Fe, Ne, xe)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;
        default:
          it = Le;
      }
    if (it !== le)
      return it;
  }
  function h(ce) {
    switch (ce) {
      case void 0:
      case null:
        Se = _e.length = 0;
        break;
      default:
        if (typeof ce == "function")
          _e[Se++] = ce;
        else if (typeof ce == "object")
          for (var le = 0, fe = ce.length; le < fe; ++le)
            h(ce[le]);
        else
          re = !!ce | 0;
    }
    return h;
  }
  function y(ce) {
    return ce = ce.prefix, ce !== void 0 && (Oe = null, ce ? typeof ce != "function" ? pe = 1 : (pe = 2, Oe = ce) : pe = 0), y;
  }
  function b(ce, le) {
    var fe = ce;
    if (33 > fe.charCodeAt(0) && (fe = fe.trim()), ie = fe, fe = [ie], 0 < Se) {
      var ve = p(-1, le, fe, fe, Z, Q, 0, 0, 0, 0);
      ve !== void 0 && typeof ve == "string" && (le = ve);
    }
    var ee = t(be, fe, le, 0, 0);
    return 0 < Se && (ve = p(-2, ee, fe, fe, Z, Q, ee.length, 0, 0, 0), ve !== void 0 && (ee = ve)), ie = "", se = 0, Q = Z = 1, ee;
  }
  var E = /^\0+/g, x = /[\0\r\f]/g, C = /: */g, T = /zoo|gra/, O = /([,: ])(transform)/g, D = /,\r+?/g, A = /([\t\r\n ])*\f?&/g, B = /@(k\w+)\s*(\S*)\s*/, I = /::(place)/g, L = /:(read-only)/g, k = /[svh]\w+-[tblr]{2}/, $ = /\(\s*(.*)\s*\)/g, U = /([\s\S]*?);/g, K = /-self|flex-/g, X = /[^]*?(:[rp][el]a[\w-]+)[^]*/, Y = /stretch|:\s*\w+\-(?:conte|avail)/, J = /([^-])(image-set\()/, Q = 1, Z = 1, se = 0, pe = 1, be = [], _e = [], Se = 0, Oe = null, re = 0, ie = "";
  return b.use = h, b.set = y, e !== void 0 && y(e), b;
}
var HU = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
function U2(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return t[n] === void 0 && (t[n] = e(n)), t[n];
  };
}
var YU = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, dT = /* @__PURE__ */ U2(
  function(e) {
    return YU.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
), V2 = { exports: {} }, lr = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var jP;
function qU() {
  if (jP)
    return lr;
  jP = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, s = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, p = e ? Symbol.for("react.context") : 60110, h = e ? Symbol.for("react.async_mode") : 60111, y = e ? Symbol.for("react.concurrent_mode") : 60111, b = e ? Symbol.for("react.forward_ref") : 60112, E = e ? Symbol.for("react.suspense") : 60113, x = e ? Symbol.for("react.suspense_list") : 60120, C = e ? Symbol.for("react.memo") : 60115, T = e ? Symbol.for("react.lazy") : 60116, O = e ? Symbol.for("react.block") : 60121, D = e ? Symbol.for("react.fundamental") : 60117, A = e ? Symbol.for("react.responder") : 60118, B = e ? Symbol.for("react.scope") : 60119;
  function I(k) {
    if (typeof k == "object" && k !== null) {
      var $ = k.$$typeof;
      switch ($) {
        case t:
          switch (k = k.type, k) {
            case h:
            case y:
            case r:
            case s:
            case a:
            case E:
              return k;
            default:
              switch (k = k && k.$$typeof, k) {
                case p:
                case b:
                case T:
                case C:
                case l:
                  return k;
                default:
                  return $;
              }
          }
        case n:
          return $;
      }
    }
  }
  function L(k) {
    return I(k) === y;
  }
  return lr.AsyncMode = h, lr.ConcurrentMode = y, lr.ContextConsumer = p, lr.ContextProvider = l, lr.Element = t, lr.ForwardRef = b, lr.Fragment = r, lr.Lazy = T, lr.Memo = C, lr.Portal = n, lr.Profiler = s, lr.StrictMode = a, lr.Suspense = E, lr.isAsyncMode = function(k) {
    return L(k) || I(k) === h;
  }, lr.isConcurrentMode = L, lr.isContextConsumer = function(k) {
    return I(k) === p;
  }, lr.isContextProvider = function(k) {
    return I(k) === l;
  }, lr.isElement = function(k) {
    return typeof k == "object" && k !== null && k.$$typeof === t;
  }, lr.isForwardRef = function(k) {
    return I(k) === b;
  }, lr.isFragment = function(k) {
    return I(k) === r;
  }, lr.isLazy = function(k) {
    return I(k) === T;
  }, lr.isMemo = function(k) {
    return I(k) === C;
  }, lr.isPortal = function(k) {
    return I(k) === n;
  }, lr.isProfiler = function(k) {
    return I(k) === s;
  }, lr.isStrictMode = function(k) {
    return I(k) === a;
  }, lr.isSuspense = function(k) {
    return I(k) === E;
  }, lr.isValidElementType = function(k) {
    return typeof k == "string" || typeof k == "function" || k === r || k === y || k === s || k === a || k === E || k === x || typeof k == "object" && k !== null && (k.$$typeof === T || k.$$typeof === C || k.$$typeof === l || k.$$typeof === p || k.$$typeof === b || k.$$typeof === D || k.$$typeof === A || k.$$typeof === B || k.$$typeof === O);
  }, lr.typeOf = I, lr;
}
var cr = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var WP;
function XU() {
  return WP || (WP = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, s = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, p = e ? Symbol.for("react.context") : 60110, h = e ? Symbol.for("react.async_mode") : 60111, y = e ? Symbol.for("react.concurrent_mode") : 60111, b = e ? Symbol.for("react.forward_ref") : 60112, E = e ? Symbol.for("react.suspense") : 60113, x = e ? Symbol.for("react.suspense_list") : 60120, C = e ? Symbol.for("react.memo") : 60115, T = e ? Symbol.for("react.lazy") : 60116, O = e ? Symbol.for("react.block") : 60121, D = e ? Symbol.for("react.fundamental") : 60117, A = e ? Symbol.for("react.responder") : 60118, B = e ? Symbol.for("react.scope") : 60119;
    function I(oe) {
      return typeof oe == "string" || typeof oe == "function" || oe === r || oe === y || oe === s || oe === a || oe === E || oe === x || typeof oe == "object" && oe !== null && (oe.$$typeof === T || oe.$$typeof === C || oe.$$typeof === l || oe.$$typeof === p || oe.$$typeof === b || oe.$$typeof === D || oe.$$typeof === A || oe.$$typeof === B || oe.$$typeof === O);
    }
    function L(oe) {
      if (typeof oe == "object" && oe !== null) {
        var it = oe.$$typeof;
        switch (it) {
          case t:
            var Le = oe.type;
            switch (Le) {
              case h:
              case y:
              case r:
              case s:
              case a:
              case E:
                return Le;
              default:
                var qe = Le && Le.$$typeof;
                switch (qe) {
                  case p:
                  case b:
                  case T:
                  case C:
                  case l:
                    return qe;
                  default:
                    return it;
                }
            }
          case n:
            return it;
        }
      }
    }
    var k = h, $ = y, U = p, K = l, X = t, Y = b, J = r, Q = T, Z = C, se = n, pe = s, be = a, _e = E, Se = !1;
    function Oe(oe) {
      return Se || (Se = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), re(oe) || L(oe) === h;
    }
    function re(oe) {
      return L(oe) === y;
    }
    function ie(oe) {
      return L(oe) === p;
    }
    function ce(oe) {
      return L(oe) === l;
    }
    function le(oe) {
      return typeof oe == "object" && oe !== null && oe.$$typeof === t;
    }
    function fe(oe) {
      return L(oe) === b;
    }
    function ve(oe) {
      return L(oe) === r;
    }
    function ee(oe) {
      return L(oe) === T;
    }
    function Ae(oe) {
      return L(oe) === C;
    }
    function he(oe) {
      return L(oe) === n;
    }
    function Fe(oe) {
      return L(oe) === s;
    }
    function Ne(oe) {
      return L(oe) === a;
    }
    function xe(oe) {
      return L(oe) === E;
    }
    cr.AsyncMode = k, cr.ConcurrentMode = $, cr.ContextConsumer = U, cr.ContextProvider = K, cr.Element = X, cr.ForwardRef = Y, cr.Fragment = J, cr.Lazy = Q, cr.Memo = Z, cr.Portal = se, cr.Profiler = pe, cr.StrictMode = be, cr.Suspense = _e, cr.isAsyncMode = Oe, cr.isConcurrentMode = re, cr.isContextConsumer = ie, cr.isContextProvider = ce, cr.isElement = le, cr.isForwardRef = fe, cr.isFragment = ve, cr.isLazy = ee, cr.isMemo = Ae, cr.isPortal = he, cr.isProfiler = Fe, cr.isStrictMode = Ne, cr.isSuspense = xe, cr.isValidElementType = I, cr.typeOf = L;
  }()), cr;
}
(function(e) {
  process.env.NODE_ENV === "production" ? e.exports = qU() : e.exports = XU();
})(V2);
var NO = V2.exports, KU = {
  childContextTypes: !0,
  contextType: !0,
  contextTypes: !0,
  defaultProps: !0,
  displayName: !0,
  getDefaultProps: !0,
  getDerivedStateFromError: !0,
  getDerivedStateFromProps: !0,
  mixins: !0,
  propTypes: !0,
  type: !0
}, QU = {
  name: !0,
  length: !0,
  prototype: !0,
  caller: !0,
  callee: !0,
  arguments: !0,
  arity: !0
}, ZU = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, j2 = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, kO = {};
kO[NO.ForwardRef] = ZU;
kO[NO.Memo] = j2;
function GP(e) {
  return NO.isMemo(e) ? j2 : kO[e.$$typeof] || KU;
}
var JU = Object.defineProperty, eV = Object.getOwnPropertyNames, HP = Object.getOwnPropertySymbols, tV = Object.getOwnPropertyDescriptor, nV = Object.getPrototypeOf, YP = Object.prototype;
function W2(e, t, n) {
  if (typeof t != "string") {
    if (YP) {
      var r = nV(t);
      r && r !== YP && W2(e, r, n);
    }
    var a = eV(t);
    HP && (a = a.concat(HP(t)));
    for (var s = GP(e), l = GP(t), p = 0; p < a.length; ++p) {
      var h = a[p];
      if (!QU[h] && !(n && n[h]) && !(l && l[h]) && !(s && s[h])) {
        var y = tV(t, h);
        try {
          JU(e, h, y);
        } catch {
        }
      }
    }
  }
  return e;
}
var G2 = W2;
function Ys() {
  return (Ys = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }).apply(this, arguments);
}
var qP = function(e, t) {
  for (var n = [e[0]], r = 0, a = t.length; r < a; r += 1)
    n.push(t[r], e[r + 1]);
  return n;
}, pT = function(e) {
  return e !== null && typeof e == "object" && (e.toString ? e.toString() : Object.prototype.toString.call(e)) === "[object Object]" && !sy.exports.typeOf(e);
}, YE = Object.freeze([]), Vp = Object.freeze({});
function uy(e) {
  return typeof e == "function";
}
function lb(e) {
  return process.env.NODE_ENV !== "production" && typeof e == "string" && e || e.displayName || e.name || "Component";
}
function Ox(e) {
  return e && typeof e.styledComponentId == "string";
}
var Hp = typeof process < "u" && process.env !== void 0 && (process.env.REACT_APP_SC_ATTR || process.env.SC_ATTR) || "data-styled", rV = "5.3.11", IO = typeof window < "u" && "HTMLElement" in window, iV = Boolean(typeof SC_DISABLE_SPEEDY == "boolean" ? SC_DISABLE_SPEEDY : typeof process < "u" && process.env !== void 0 && (process.env.REACT_APP_SC_DISABLE_SPEEDY !== void 0 && process.env.REACT_APP_SC_DISABLE_SPEEDY !== "" ? process.env.REACT_APP_SC_DISABLE_SPEEDY !== "false" && process.env.REACT_APP_SC_DISABLE_SPEEDY : process.env.SC_DISABLE_SPEEDY !== void 0 && process.env.SC_DISABLE_SPEEDY !== "" ? process.env.SC_DISABLE_SPEEDY !== "false" && process.env.SC_DISABLE_SPEEDY : process.env.NODE_ENV !== "production")), aV = {}, oV = process.env.NODE_ENV !== "production" ? { 1: `Cannot create styled-component for component: %s.

`, 2: `Can't collect styles once you've consumed a \`ServerStyleSheet\`'s styles! \`ServerStyleSheet\` is a one off instance for each server-side render cycle.

- Are you trying to reuse it across renders?
- Are you accidentally calling collectStyles twice?

`, 3: `Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.

`, 4: `The \`StyleSheetManager\` expects a valid target or sheet prop!

- Does this error occur on the client and is your target falsy?
- Does this error occur on the server and is the sheet falsy?

`, 5: `The clone method cannot be used on the client!

- Are you running in a client-like environment on the server?
- Are you trying to run SSR on the client?

`, 6: `Trying to insert a new style tag, but the given Node is unmounted!

- Are you using a custom target that isn't mounted?
- Does your document not have a valid head element?
- Have you accidentally removed a style tag manually?

`, 7: 'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n', 8: `ThemeProvider: Please make your "theme" prop an object.

`, 9: "Missing document `<head>`\n\n", 10: `Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021

`, 11: `_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.

`, 12: "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n", 13: `%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.

`, 14: `ThemeProvider: "theme" prop is required.

`, 15: "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n", 16: `Reached the limit of how many styled components may be created at group %s.
You may only create up to 1,073,741,824 components. If you're creating components dynamically,
as for instance in your render method then you may be running into this limitation.

`, 17: `CSSStyleSheet could not be found on HTMLStyleElement.
Has styled-components' style tag been unmounted or altered by another script?
` } : {};
function sV() {
  for (var e = arguments.length <= 0 ? void 0 : arguments[0], t = [], n = 1, r = arguments.length; n < r; n += 1)
    t.push(n < 0 || arguments.length <= n ? void 0 : arguments[n]);
  return t.forEach(function(a) {
    e = e.replace(/%[a-z]/, a);
  }), e;
}
function qs(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  throw process.env.NODE_ENV === "production" ? new Error("An error occurred. See https://git.io/JUIaE#" + e + " for more information." + (n.length > 0 ? " Args: " + n.join(", ") : "")) : new Error(sV.apply(void 0, [oV[e]].concat(n)).trim());
}
var uV = function() {
  function e(n) {
    this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = n;
  }
  var t = e.prototype;
  return t.indexOfGroup = function(n) {
    for (var r = 0, a = 0; a < n; a++)
      r += this.groupSizes[a];
    return r;
  }, t.insertRules = function(n, r) {
    if (n >= this.groupSizes.length) {
      for (var a = this.groupSizes, s = a.length, l = s; n >= l; )
        (l <<= 1) < 0 && qs(16, "" + n);
      this.groupSizes = new Uint32Array(l), this.groupSizes.set(a), this.length = l;
      for (var p = s; p < l; p++)
        this.groupSizes[p] = 0;
    }
    for (var h = this.indexOfGroup(n + 1), y = 0, b = r.length; y < b; y++)
      this.tag.insertRule(h, r[y]) && (this.groupSizes[n]++, h++);
  }, t.clearGroup = function(n) {
    if (n < this.length) {
      var r = this.groupSizes[n], a = this.indexOfGroup(n), s = a + r;
      this.groupSizes[n] = 0;
      for (var l = a; l < s; l++)
        this.tag.deleteRule(a);
    }
  }, t.getGroup = function(n) {
    var r = "";
    if (n >= this.length || this.groupSizes[n] === 0)
      return r;
    for (var a = this.groupSizes[n], s = this.indexOfGroup(n), l = s + a, p = s; p < l; p++)
      r += this.tag.getRule(p) + `/*!sc*/
`;
    return r;
  }, e;
}(), ME = /* @__PURE__ */ new Map(), qE = /* @__PURE__ */ new Map(), eb = 1, rE = function(e) {
  if (ME.has(e))
    return ME.get(e);
  for (; qE.has(eb); )
    eb++;
  var t = eb++;
  return process.env.NODE_ENV !== "production" && ((0 | t) < 0 || t > 1 << 30) && qs(16, "" + t), ME.set(e, t), qE.set(t, e), t;
}, lV = function(e) {
  return qE.get(e);
}, cV = function(e, t) {
  t >= eb && (eb = t + 1), ME.set(e, t), qE.set(t, e);
}, fV = "style[" + Hp + '][data-styled-version="5.3.11"]', dV = new RegExp("^" + Hp + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), pV = function(e, t, n) {
  for (var r, a = n.split(","), s = 0, l = a.length; s < l; s++)
    (r = a[s]) && e.registerName(t, r);
}, vV = function(e, t) {
  for (var n = (t.textContent || "").split(`/*!sc*/
`), r = [], a = 0, s = n.length; a < s; a++) {
    var l = n[a].trim();
    if (l) {
      var p = l.match(dV);
      if (p) {
        var h = 0 | parseInt(p[1], 10), y = p[2];
        h !== 0 && (cV(y, h), pV(e, y, p[3]), e.getTag().insertRules(h, r)), r.length = 0;
      } else
        r.push(l);
    }
  }
}, vT = function() {
  return typeof __webpack_nonce__ < "u" ? __webpack_nonce__ : null;
}, H2 = function(e) {
  var t = document.head, n = e || t, r = document.createElement("style"), a = function(p) {
    for (var h = p.childNodes, y = h.length; y >= 0; y--) {
      var b = h[y];
      if (b && b.nodeType === 1 && b.hasAttribute(Hp))
        return b;
    }
  }(n), s = a !== void 0 ? a.nextSibling : null;
  r.setAttribute(Hp, "active"), r.setAttribute("data-styled-version", "5.3.11");
  var l = vT();
  return l && r.setAttribute("nonce", l), n.insertBefore(r, s), r;
}, hV = function() {
  function e(n) {
    var r = this.element = H2(n);
    r.appendChild(document.createTextNode("")), this.sheet = function(a) {
      if (a.sheet)
        return a.sheet;
      for (var s = document.styleSheets, l = 0, p = s.length; l < p; l++) {
        var h = s[l];
        if (h.ownerNode === a)
          return h;
      }
      qs(17);
    }(r), this.length = 0;
  }
  var t = e.prototype;
  return t.insertRule = function(n, r) {
    try {
      return this.sheet.insertRule(r, n), this.length++, !0;
    } catch {
      return !1;
    }
  }, t.deleteRule = function(n) {
    this.sheet.deleteRule(n), this.length--;
  }, t.getRule = function(n) {
    var r = this.sheet.cssRules[n];
    return r !== void 0 && typeof r.cssText == "string" ? r.cssText : "";
  }, e;
}(), gV = function() {
  function e(n) {
    var r = this.element = H2(n);
    this.nodes = r.childNodes, this.length = 0;
  }
  var t = e.prototype;
  return t.insertRule = function(n, r) {
    if (n <= this.length && n >= 0) {
      var a = document.createTextNode(r), s = this.nodes[n];
      return this.element.insertBefore(a, s || null), this.length++, !0;
    }
    return !1;
  }, t.deleteRule = function(n) {
    this.element.removeChild(this.nodes[n]), this.length--;
  }, t.getRule = function(n) {
    return n < this.length ? this.nodes[n].textContent : "";
  }, e;
}(), mV = function() {
  function e(n) {
    this.rules = [], this.length = 0;
  }
  var t = e.prototype;
  return t.insertRule = function(n, r) {
    return n <= this.length && (this.rules.splice(n, 0, r), this.length++, !0);
  }, t.deleteRule = function(n) {
    this.rules.splice(n, 1), this.length--;
  }, t.getRule = function(n) {
    return n < this.length ? this.rules[n] : "";
  }, e;
}(), XP = IO, yV = { isServer: !IO, useCSSOMInjection: !iV }, ly = function() {
  function e(n, r, a) {
    n === void 0 && (n = Vp), r === void 0 && (r = {}), this.options = Ys({}, yV, {}, n), this.gs = r, this.names = new Map(a), this.server = !!n.isServer, !this.server && IO && XP && (XP = !1, function(s) {
      for (var l = document.querySelectorAll(fV), p = 0, h = l.length; p < h; p++) {
        var y = l[p];
        y && y.getAttribute(Hp) !== "active" && (vV(s, y), y.parentNode && y.parentNode.removeChild(y));
      }
    }(this));
  }
  e.registerId = function(n) {
    return rE(n);
  };
  var t = e.prototype;
  return t.reconstructWithOptions = function(n, r) {
    return r === void 0 && (r = !0), new e(Ys({}, this.options, {}, n), this.gs, r && this.names || void 0);
  }, t.allocateGSInstance = function(n) {
    return this.gs[n] = (this.gs[n] || 0) + 1;
  }, t.getTag = function() {
    return this.tag || (this.tag = (a = (r = this.options).isServer, s = r.useCSSOMInjection, l = r.target, n = a ? new mV(l) : s ? new hV(l) : new gV(l), new uV(n)));
    var n, r, a, s, l;
  }, t.hasNameForId = function(n, r) {
    return this.names.has(n) && this.names.get(n).has(r);
  }, t.registerName = function(n, r) {
    if (rE(n), this.names.has(n))
      this.names.get(n).add(r);
    else {
      var a = /* @__PURE__ */ new Set();
      a.add(r), this.names.set(n, a);
    }
  }, t.insertRules = function(n, r, a) {
    this.registerName(n, r), this.getTag().insertRules(rE(n), a);
  }, t.clearNames = function(n) {
    this.names.has(n) && this.names.get(n).clear();
  }, t.clearRules = function(n) {
    this.getTag().clearGroup(rE(n)), this.clearNames(n);
  }, t.clearTag = function() {
    this.tag = void 0;
  }, t.toString = function() {
    return function(n) {
      for (var r = n.getTag(), a = r.length, s = "", l = 0; l < a; l++) {
        var p = lV(l);
        if (p !== void 0) {
          var h = n.names.get(p), y = r.getGroup(l);
          if (h && y && h.size) {
            var b = Hp + ".g" + l + '[id="' + p + '"]', E = "";
            h !== void 0 && h.forEach(function(x) {
              x.length > 0 && (E += x + ",");
            }), s += "" + y + b + '{content:"' + E + `"}/*!sc*/
`;
          }
        }
      }
      return s;
    }(this);
  }, e;
}(), bV = /(a)(d)/gi, KP = function(e) {
  return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function hT(e) {
  var t, n = "";
  for (t = Math.abs(e); t > 52; t = t / 52 | 0)
    n = KP(t % 52) + n;
  return (KP(t % 52) + n).replace(bV, "$1-$2");
}
var zh = function(e, t) {
  for (var n = t.length; n; )
    e = 33 * e ^ t.charCodeAt(--n);
  return e;
}, Y2 = function(e) {
  return zh(5381, e);
};
function q2(e) {
  for (var t = 0; t < e.length; t += 1) {
    var n = e[t];
    if (uy(n) && !Ox(n))
      return !1;
  }
  return !0;
}
var _V = Y2("5.3.11"), EV = function() {
  function e(t, n, r) {
    this.rules = t, this.staticRulesId = "", this.isStatic = process.env.NODE_ENV === "production" && (r === void 0 || r.isStatic) && q2(t), this.componentId = n, this.baseHash = zh(_V, n), this.baseStyle = r, ly.registerId(n);
  }
  return e.prototype.generateAndInjectStyles = function(t, n, r) {
    var a = this.componentId, s = [];
    if (this.baseStyle && s.push(this.baseStyle.generateAndInjectStyles(t, n, r)), this.isStatic && !r.hash)
      if (this.staticRulesId && n.hasNameForId(a, this.staticRulesId))
        s.push(this.staticRulesId);
      else {
        var l = Hh(this.rules, t, n, r).join(""), p = hT(zh(this.baseHash, l) >>> 0);
        if (!n.hasNameForId(a, p)) {
          var h = r(l, "." + p, void 0, a);
          n.insertRules(a, p, h);
        }
        s.push(p), this.staticRulesId = p;
      }
    else {
      for (var y = this.rules.length, b = zh(this.baseHash, r.hash), E = "", x = 0; x < y; x++) {
        var C = this.rules[x];
        if (typeof C == "string")
          E += C, process.env.NODE_ENV !== "production" && (b = zh(b, C + x));
        else if (C) {
          var T = Hh(C, t, n, r), O = Array.isArray(T) ? T.join("") : T;
          b = zh(b, O + x), E += O;
        }
      }
      if (E) {
        var D = hT(b >>> 0);
        if (!n.hasNameForId(a, D)) {
          var A = r(E, "." + D, void 0, a);
          n.insertRules(a, D, A);
        }
        s.push(D);
      }
    }
    return s.join(" ");
  }, e;
}(), xV = /^\s*\/\/.*$/gm, SV = [":", "[", ".", "#"];
function X2(e) {
  var t, n, r, a, s = e === void 0 ? Vp : e, l = s.options, p = l === void 0 ? Vp : l, h = s.plugins, y = h === void 0 ? YE : h, b = new GU(p), E = [], x = function(O) {
    function D(A) {
      if (A)
        try {
          O(A + "}");
        } catch {
        }
    }
    return function(A, B, I, L, k, $, U, K, X, Y) {
      switch (A) {
        case 1:
          if (X === 0 && B.charCodeAt(0) === 64)
            return O(B + ";"), "";
          break;
        case 2:
          if (K === 0)
            return B + "/*|*/";
          break;
        case 3:
          switch (K) {
            case 102:
            case 112:
              return O(I[0] + B), "";
            default:
              return B + (Y === 0 ? "/*|*/" : "");
          }
        case -2:
          B.split("/*|*/}").forEach(D);
      }
    };
  }(function(O) {
    E.push(O);
  }), C = function(O, D, A) {
    return D === 0 && SV.indexOf(A[n.length]) !== -1 || A.match(a) ? O : "." + t;
  };
  function T(O, D, A, B) {
    B === void 0 && (B = "&");
    var I = O.replace(xV, ""), L = D && A ? A + " " + D + " { " + I + " }" : I;
    return t = B, n = D, r = new RegExp("\\" + n + "\\b", "g"), a = new RegExp("(\\" + n + "\\b){2,}"), b(A || !D ? "" : D, L);
  }
  return b.use([].concat(y, [function(O, D, A) {
    O === 2 && A.length && A[0].lastIndexOf(n) > 0 && (A[0] = A[0].replace(r, C));
  }, x, function(O) {
    if (O === -2) {
      var D = E;
      return E = [], D;
    }
  }])), T.hash = y.length ? y.reduce(function(O, D) {
    return D.name || qs(15), zh(O, D.name);
  }, 5381).toString() : "", T;
}
var Dx = Wt.createContext(), wV = Dx.Consumer, LO = Wt.createContext(), K2 = (LO.Consumer, new ly()), gT = X2();
function BO() {
  return nl(Dx) || K2;
}
function Q2() {
  return nl(LO) || gT;
}
function Z2(e) {
  var t = L2(e.stylisPlugins), n = t[0], r = t[1], a = BO(), s = lT(function() {
    var p = a;
    return e.sheet ? p = e.sheet : e.target && (p = p.reconstructWithOptions({ target: e.target }, !1)), e.disableCSSOMInjection && (p = p.reconstructWithOptions({ useCSSOMInjection: !1 })), p;
  }, [e.disableCSSOMInjection, e.sheet, e.target]), l = lT(function() {
    return X2({ options: { prefix: !e.disableVendorPrefixes }, plugins: n });
  }, [e.disableVendorPrefixes, n]);
  return B2(function() {
    WU(n, e.stylisPlugins) || r(e.stylisPlugins);
  }, [e.stylisPlugins]), Wt.createElement(Dx.Provider, { value: s }, Wt.createElement(LO.Provider, { value: l }, process.env.NODE_ENV !== "production" ? Wt.Children.only(e.children) : e.children));
}
var J2 = function() {
  function e(t, n) {
    var r = this;
    this.inject = function(a, s) {
      s === void 0 && (s = gT);
      var l = r.name + s.hash;
      a.hasNameForId(r.id, l) || a.insertRules(r.id, l, s(r.rules, l, "@keyframes"));
    }, this.toString = function() {
      return qs(12, String(r.name));
    }, this.name = t, this.id = "sc-keyframes-" + t, this.rules = n;
  }
  return e.prototype.getName = function(t) {
    return t === void 0 && (t = gT), this.name + t.hash;
  }, e;
}(), CV = /([A-Z])/, RV = /([A-Z])/g, TV = /^ms-/, OV = function(e) {
  return "-" + e.toLowerCase();
};
function QP(e) {
  return CV.test(e) ? e.replace(RV, OV).replace(TV, "-ms-") : e;
}
var ZP = function(e) {
  return e == null || e === !1 || e === "";
};
function Hh(e, t, n, r) {
  if (Array.isArray(e)) {
    for (var a, s = [], l = 0, p = e.length; l < p; l += 1)
      (a = Hh(e[l], t, n, r)) !== "" && (Array.isArray(a) ? s.push.apply(s, a) : s.push(a));
    return s;
  }
  if (ZP(e))
    return "";
  if (Ox(e))
    return "." + e.styledComponentId;
  if (uy(e)) {
    if (typeof (y = e) != "function" || y.prototype && y.prototype.isReactComponent || !t)
      return e;
    var h = e(t);
    return process.env.NODE_ENV !== "production" && sy.exports.isElement(h) && console.warn(lb(e) + " is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details."), Hh(h, t, n, r);
  }
  var y;
  return e instanceof J2 ? n ? (e.inject(n, r), e.getName(r)) : e : pT(e) ? function b(E, x) {
    var C, T, O = [];
    for (var D in E)
      E.hasOwnProperty(D) && !ZP(E[D]) && (Array.isArray(E[D]) && E[D].isCss || uy(E[D]) ? O.push(QP(D) + ":", E[D], ";") : pT(E[D]) ? O.push.apply(O, b(E[D], D)) : O.push(QP(D) + ": " + (C = D, (T = E[D]) == null || typeof T == "boolean" || T === "" ? "" : typeof T != "number" || T === 0 || C in HU || C.startsWith("--") ? String(T).trim() : T + "px") + ";"));
    return x ? [x + " {"].concat(O, ["}"]) : O;
  }(e) : e.toString();
}
var JP = function(e) {
  return Array.isArray(e) && (e.isCss = !0), e;
};
function wy(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  return uy(e) || pT(e) ? JP(Hh(qP(YE, [e].concat(n)))) : n.length === 0 && e.length === 1 && typeof e[0] == "string" ? e : JP(Hh(qP(e, n)));
}
var eN = /invalid hook call/i, iE = /* @__PURE__ */ new Set(), eI = function(e, t) {
  if (process.env.NODE_ENV !== "production") {
    var n = "The component " + e + (t ? ' with the id of "' + t + '"' : "") + ` has been created dynamically.
You may see this warning because you've called styled inside another component.
To resolve this only create new StyledComponents outside of any render method and function component.`, r = console.error;
    try {
      var a = !0;
      console.error = function(s) {
        if (eN.test(s))
          a = !1, iE.delete(n);
        else {
          for (var l = arguments.length, p = new Array(l > 1 ? l - 1 : 0), h = 1; h < l; h++)
            p[h - 1] = arguments[h];
          r.apply(void 0, [s].concat(p));
        }
      }, OO(), a && !iE.has(n) && (console.warn(n), iE.add(n));
    } catch (s) {
      eN.test(s.message) && iE.delete(n);
    } finally {
      console.error = r;
    }
  }
}, zO = function(e, t, n) {
  return n === void 0 && (n = Vp), e.theme !== n.theme && e.theme || t || n.theme;
}, DV = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, MV = /(^-|-$)/g;
function PR(e) {
  return e.replace(DV, "-").replace(MV, "");
}
var FO = function(e) {
  return hT(Y2(e) >>> 0);
};
function aE(e) {
  return typeof e == "string" && (process.env.NODE_ENV === "production" || e.charAt(0) === e.charAt(0).toLowerCase());
}
var mT = function(e) {
  return typeof e == "function" || typeof e == "object" && e !== null && !Array.isArray(e);
}, AV = function(e) {
  return e !== "__proto__" && e !== "constructor" && e !== "prototype";
};
function PV(e, t, n) {
  var r = e[n];
  mT(t) && mT(r) ? tI(r, t) : e[n] = t;
}
function tI(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  for (var a = 0, s = n; a < s.length; a++) {
    var l = s[a];
    if (mT(l))
      for (var p in l)
        AV(p) && PV(e, l[p], p);
  }
  return e;
}
var Yp = Wt.createContext(), NV = Yp.Consumer;
function kV(e) {
  var t = nl(Yp), n = lT(function() {
    return function(r, a) {
      if (!r)
        return qs(14);
      if (uy(r)) {
        var s = r(a);
        return process.env.NODE_ENV === "production" || s !== null && !Array.isArray(s) && typeof s == "object" ? s : qs(7);
      }
      return Array.isArray(r) || typeof r != "object" ? qs(8) : a ? Ys({}, a, {}, r) : r;
    }(e.theme, t);
  }, [e.theme, t]);
  return e.children ? Wt.createElement(Yp.Provider, { value: n }, e.children) : null;
}
var NR = {};
function nI(e, t, n) {
  var r = Ox(e), a = !aE(e), s = t.attrs, l = s === void 0 ? YE : s, p = t.componentId, h = p === void 0 ? function(B, I) {
    var L = typeof B != "string" ? "sc" : PR(B);
    NR[L] = (NR[L] || 0) + 1;
    var k = L + "-" + FO("5.3.11" + L + NR[L]);
    return I ? I + "-" + k : k;
  }(t.displayName, t.parentComponentId) : p, y = t.displayName, b = y === void 0 ? function(B) {
    return aE(B) ? "styled." + B : "Styled(" + lb(B) + ")";
  }(e) : y, E = t.displayName && t.componentId ? PR(t.displayName) + "-" + t.componentId : t.componentId || h, x = r && e.attrs ? Array.prototype.concat(e.attrs, l).filter(Boolean) : l, C = t.shouldForwardProp;
  r && e.shouldForwardProp && (C = t.shouldForwardProp ? function(B, I, L) {
    return e.shouldForwardProp(B, I, L) && t.shouldForwardProp(B, I, L);
  } : e.shouldForwardProp);
  var T, O = new EV(n, E, r ? e.componentStyle : void 0), D = O.isStatic && l.length === 0, A = function(B, I) {
    return function(L, k, $, U) {
      var K = L.attrs, X = L.componentStyle, Y = L.defaultProps, J = L.foldedComponentIds, Q = L.shouldForwardProp, Z = L.styledComponentId, se = L.target, pe = function(ve, ee, Ae) {
        ve === void 0 && (ve = Vp);
        var he = Ys({}, ee, { theme: ve }), Fe = {};
        return Ae.forEach(function(Ne) {
          var xe, oe, it, Le = Ne;
          for (xe in uy(Le) && (Le = Le(he)), Le)
            he[xe] = Fe[xe] = xe === "className" ? (oe = Fe[xe], it = Le[xe], oe && it ? oe + " " + it : oe || it) : Le[xe];
        }), [he, Fe];
      }(zO(k, nl(Yp), Y) || Vp, k, K), be = pe[0], _e = pe[1], Se = function(ve, ee, Ae, he) {
        var Fe = BO(), Ne = Q2(), xe = ee ? ve.generateAndInjectStyles(Vp, Fe, Ne) : ve.generateAndInjectStyles(Ae, Fe, Ne);
        return process.env.NODE_ENV !== "production" && !ee && he && he(xe), xe;
      }(X, U, be, process.env.NODE_ENV !== "production" ? L.warnTooManyClasses : void 0), Oe = $, re = _e.$as || k.$as || _e.as || k.as || se, ie = aE(re), ce = _e !== k ? Ys({}, k, {}, _e) : k, le = {};
      for (var fe in ce)
        fe[0] !== "$" && fe !== "as" && (fe === "forwardedAs" ? le.as = ce[fe] : (Q ? Q(fe, dT, re) : !ie || dT(fe)) && (le[fe] = ce[fe]));
      return k.style && _e.style !== k.style && (le.style = Ys({}, k.style, {}, _e.style)), le.className = Array.prototype.concat(J, Z, Se !== Z ? Se : null, k.className, _e.className).filter(Boolean).join(" "), le.ref = Oe, Ks(re, le);
    }(T, B, I, D);
  };
  return A.displayName = b, (T = Wt.forwardRef(A)).attrs = x, T.componentStyle = O, T.displayName = b, T.shouldForwardProp = C, T.foldedComponentIds = r ? Array.prototype.concat(e.foldedComponentIds, e.styledComponentId) : YE, T.styledComponentId = E, T.target = r ? e.target : e, T.withComponent = function(B) {
    var I = t.componentId, L = function($, U) {
      if ($ == null)
        return {};
      var K, X, Y = {}, J = Object.keys($);
      for (X = 0; X < J.length; X++)
        K = J[X], U.indexOf(K) >= 0 || (Y[K] = $[K]);
      return Y;
    }(t, ["componentId"]), k = I && I + "-" + (aE(B) ? B : PR(lb(B)));
    return nI(B, Ys({}, L, { attrs: x, componentId: k }), n);
  }, Object.defineProperty(T, "defaultProps", { get: function() {
    return this._foldedDefaultProps;
  }, set: function(B) {
    this._foldedDefaultProps = r ? tI({}, e.defaultProps, B) : B;
  } }), process.env.NODE_ENV !== "production" && (eI(b, E), T.warnTooManyClasses = function(B, I) {
    var L = {}, k = !1;
    return function($) {
      if (!k && (L[$] = !0, Object.keys(L).length >= 200)) {
        var U = I ? ' with the id of "' + I + '"' : "";
        console.warn("Over 200 classes were generated for component " + B + U + `.
Consider using the attrs method, together with a style object for frequently changed styles.
Example:
  const Component = styled.div.attrs(props => ({
    style: {
      background: props.background,
    },
  }))\`width: 100%;\`

  <Component />`), k = !0, L = {};
      }
    };
  }(b, E)), Object.defineProperty(T, "toString", { value: function() {
    return "." + T.styledComponentId;
  } }), a && G2(T, e, { attrs: !0, componentStyle: !0, displayName: !0, foldedComponentIds: !0, shouldForwardProp: !0, styledComponentId: !0, target: !0, withComponent: !0 }), T;
}
var yT = function(e) {
  return function t(n, r, a) {
    if (a === void 0 && (a = Vp), !sy.exports.isValidElementType(r))
      return qs(1, String(r));
    var s = function() {
      return n(r, a, wy.apply(void 0, arguments));
    };
    return s.withConfig = function(l) {
      return t(n, r, Ys({}, a, {}, l));
    }, s.attrs = function(l) {
      return t(n, r, Ys({}, a, { attrs: Array.prototype.concat(a.attrs, l).filter(Boolean) }));
    }, s;
  }(nI, e);
};
["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "marquee", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "textPath", "tspan"].forEach(function(e) {
  yT[e] = yT(e);
});
var IV = function() {
  function e(n, r) {
    this.rules = n, this.componentId = r, this.isStatic = q2(n), ly.registerId(this.componentId + 1);
  }
  var t = e.prototype;
  return t.createStyles = function(n, r, a, s) {
    var l = s(Hh(this.rules, r, a, s).join(""), ""), p = this.componentId + n;
    a.insertRules(p, p, l);
  }, t.removeStyles = function(n, r) {
    r.clearRules(this.componentId + n);
  }, t.renderStyles = function(n, r, a, s) {
    n > 2 && ly.registerId(this.componentId + n), this.removeStyles(n, a), this.createStyles(n, r, a, s);
  }, e;
}();
function LV(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  var a = wy.apply(void 0, [e].concat(n)), s = "sc-global-" + FO(JSON.stringify(a)), l = new IV(a, s);
  function p(y) {
    var b = BO(), E = Q2(), x = nl(Yp), C = OO(b.allocateGSInstance(s)).current;
    return process.env.NODE_ENV !== "production" && Wt.Children.count(y.children) && console.warn("The global style component " + s + " was given child JSX. createGlobalStyle does not render children."), process.env.NODE_ENV !== "production" && a.some(function(T) {
      return typeof T == "string" && T.indexOf("@import") !== -1;
    }) && console.warn("Please do not use @import CSS syntax in createGlobalStyle at this time, as the CSSOM APIs we use in production do not handle it well. Instead, we recommend using a library such as react-helmet to inject a typical <link> meta tag to the stylesheet, or simply embedding it manually in your index.html <head> section for a simpler app."), b.server && h(C, y, b, x, E), cT(function() {
      if (!b.server)
        return h(C, y, b, x, E), function() {
          return l.removeStyles(C, b);
        };
    }, [C, y, b, x, E]), null;
  }
  function h(y, b, E, x, C) {
    if (l.isStatic)
      l.renderStyles(y, aV, E, C);
    else {
      var T = Ys({}, b, { theme: zO(b, x, p.defaultProps) });
      l.renderStyles(y, T, E, C);
    }
  }
  return process.env.NODE_ENV !== "production" && eI(s), Wt.memo(p);
}
function BV(e) {
  process.env.NODE_ENV !== "production" && typeof navigator < "u" && navigator.product === "ReactNative" && console.warn("`keyframes` cannot be used on ReactNative, only on the web. To do animation in ReactNative please use Animated.");
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  var a = wy.apply(void 0, [e].concat(n)).join(""), s = FO(a);
  return new J2(s, a);
}
var zV = function() {
  function e() {
    var n = this;
    this._emitSheetCSS = function() {
      var r = n.instance.toString();
      if (!r)
        return "";
      var a = vT();
      return "<style " + [a && 'nonce="' + a + '"', Hp + '="true"', 'data-styled-version="5.3.11"'].filter(Boolean).join(" ") + ">" + r + "</style>";
    }, this.getStyleTags = function() {
      return n.sealed ? qs(2) : n._emitSheetCSS();
    }, this.getStyleElement = function() {
      var r;
      if (n.sealed)
        return qs(2);
      var a = ((r = {})[Hp] = "", r["data-styled-version"] = "5.3.11", r.dangerouslySetInnerHTML = { __html: n.instance.toString() }, r), s = vT();
      return s && (a.nonce = s), [Wt.createElement("style", Ys({}, a, { key: "sc-0-0" }))];
    }, this.seal = function() {
      n.sealed = !0;
    }, this.instance = new ly({ isServer: !0 }), this.sealed = !1;
  }
  var t = e.prototype;
  return t.collectStyles = function(n) {
    return this.sealed ? qs(2) : Wt.createElement(Z2, { sheet: this.instance }, n);
  }, t.interleaveWithNodeStream = function(n) {
    return qs(3);
  }, e;
}(), FV = function(e) {
  var t = Wt.forwardRef(function(n, r) {
    var a = nl(Yp), s = e.defaultProps, l = zO(n, a, s);
    return process.env.NODE_ENV !== "production" && l === void 0 && console.warn('[withTheme] You are not using a ThemeProvider nor passing a theme prop or a theme in defaultProps in component class "' + lb(e) + '"'), Wt.createElement(e, Ys({}, n, { theme: l, ref: r }));
  });
  return G2(t, e), t.displayName = "WithTheme(" + lb(e) + ")", t;
}, $V = function() {
  return nl(Yp);
}, UV = { StyleSheet: ly, masterSheet: K2 };
process.env.NODE_ENV !== "production" && typeof navigator < "u" && navigator.product === "ReactNative" && console.warn(`It looks like you've imported 'styled-components' on React Native.
Perhaps you're looking to import 'styled-components/native'?
Read more about this at https://www.styled-components.com/docs/basics#react-native`), process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && typeof window < "u" && (window["__styled-components-init__"] = window["__styled-components-init__"] || 0, window["__styled-components-init__"] === 1 && console.warn(`It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.

See https://s-c.sh/2BAXzed for more info.`), window["__styled-components-init__"] += 1);
const qu = yT, VV = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: qu,
  ServerStyleSheet: zV,
  StyleSheetConsumer: wV,
  StyleSheetContext: Dx,
  StyleSheetManager: Z2,
  ThemeConsumer: NV,
  ThemeContext: Yp,
  ThemeProvider: kV,
  __PRIVATE__: UV,
  createGlobalStyle: LV,
  css: wy,
  isStyledComponent: Ox,
  keyframes: BV,
  useTheme: $V,
  version: rV,
  withTheme: FV
}, Symbol.toStringTag, { value: "Module" }));
var jV = {
  0: "Invalid value for configuration 'enforceActions', expected 'never', 'always' or 'observed'",
  1: function(t, n) {
    return "Cannot apply '" + t + "' to '" + n.toString() + "': Field not found.";
  },
  5: "'keys()' can only be used on observable objects, arrays, sets and maps",
  6: "'values()' can only be used on observable objects, arrays, sets and maps",
  7: "'entries()' can only be used on observable objects, arrays and maps",
  8: "'set()' can only be used on observable objects, arrays and maps",
  9: "'remove()' can only be used on observable objects, arrays and maps",
  10: "'has()' can only be used on observable objects, arrays and maps",
  11: "'get()' can only be used on observable objects, arrays and maps",
  12: "Invalid annotation",
  13: "Dynamic observable objects cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
  14: "Intercept handlers should return nothing or a change object",
  15: "Observable arrays cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
  16: "Modification exception: the internal structure of an observable array was changed.",
  17: function(t, n) {
    return "[mobx.array] Index out of bounds, " + t + " is larger than " + n;
  },
  18: "mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js",
  19: function(t) {
    return "Cannot initialize from classes that inherit from Map: " + t.constructor.name;
  },
  20: function(t) {
    return "Cannot initialize map from " + t;
  },
  21: function(t) {
    return "Cannot convert to map from '" + t + "'";
  },
  22: "mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js",
  23: "It is not possible to get index atoms from arrays",
  24: function(t) {
    return "Cannot obtain administration from " + t;
  },
  25: function(t, n) {
    return "the entry '" + t + "' does not exist in the observable map '" + n + "'";
  },
  26: "please specify a property",
  27: function(t, n) {
    return "no observable property '" + t.toString() + "' found on the observable object '" + n + "'";
  },
  28: function(t) {
    return "Cannot obtain atom from " + t;
  },
  29: "Expecting some object",
  30: "invalid action stack. did you forget to finish an action?",
  31: "missing option for computed: get",
  32: function(t, n) {
    return "Cycle detected in computation " + t + ": " + n;
  },
  33: function(t) {
    return "The setter of computed value '" + t + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?";
  },
  34: function(t) {
    return "[ComputedValue '" + t + "'] It is not possible to assign a new value to a computed value.";
  },
  35: "There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`",
  36: "isolateGlobalState should be called before MobX is running any reactions",
  37: function(t) {
    return "[mobx] `observableArray." + t + "()` mutates the array in-place, which is not allowed inside a derivation. Use `array.slice()." + t + "()` instead";
  },
  38: "'ownKeys()' can only be used on observable objects",
  39: "'defineProperty()' can only be used on observable objects"
}, WV = process.env.NODE_ENV !== "production" ? jV : {};
function xt(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  if (process.env.NODE_ENV !== "production") {
    var a = typeof e == "string" ? e : WV[e];
    throw typeof a == "function" && (a = a.apply(null, n)), new Error("[MobX] " + a);
  }
  throw new Error(typeof e == "number" ? "[MobX] minified error nr: " + e + (n.length ? " " + n.map(String).join(",") : "") + ". Find the full error at: https://github.com/mobxjs/mobx/blob/main/packages/mobx/src/errors.ts" : "[MobX] " + e);
}
var GV = {};
function $O() {
  return typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : GV;
}
var rI = Object.assign, XE = Object.getOwnPropertyDescriptor, Zc = Object.defineProperty, Mx = Object.prototype, KE = [];
Object.freeze(KE);
var iI = {};
Object.freeze(iI);
var HV = typeof Proxy < "u", YV = /* @__PURE__ */ Object.toString();
function aI() {
  HV || xt(process.env.NODE_ENV !== "production" ? "`Proxy` objects are not available in the current environment. Please configure MobX to enable a fallback implementation.`" : "Proxy not available");
}
function U0(e) {
  process.env.NODE_ENV !== "production" && nt.verifyProxies && xt("MobX is currently configured to be able to run in ES5 mode, but in ES5 MobX won't be able to " + e);
}
function ic() {
  return ++nt.mobxGuid;
}
function UO(e) {
  var t = !1;
  return function() {
    if (!t)
      return t = !0, e.apply(this, arguments);
  };
}
var Hm = function() {
};
function Xi(e) {
  return typeof e == "function";
}
function Yh(e) {
  var t = typeof e;
  switch (t) {
    case "string":
    case "symbol":
    case "number":
      return !0;
  }
  return !1;
}
function Ax(e) {
  return e !== null && typeof e == "object";
}
function Qs(e) {
  if (!Ax(e))
    return !1;
  var t = Object.getPrototypeOf(e);
  if (t == null)
    return !0;
  var n = Object.hasOwnProperty.call(t, "constructor") && t.constructor;
  return typeof n == "function" && n.toString() === YV;
}
function oI(e) {
  var t = e == null ? void 0 : e.constructor;
  return t ? t.name === "GeneratorFunction" || t.displayName === "GeneratorFunction" : !1;
}
function Ob(e, t, n) {
  Zc(e, t, {
    enumerable: !1,
    writable: !0,
    configurable: !0,
    value: n
  });
}
function sI(e, t, n) {
  Zc(e, t, {
    enumerable: !1,
    writable: !1,
    configurable: !0,
    value: n
  });
}
function tg(e, t) {
  var n = "isMobX" + e;
  return t.prototype[n] = !0, function(r) {
    return Ax(r) && r[n] === !0;
  };
}
function Cy(e) {
  return e instanceof Map;
}
function Db(e) {
  return e instanceof Set;
}
var uI = typeof Object.getOwnPropertySymbols < "u";
function qV(e) {
  var t = Object.keys(e);
  if (!uI)
    return t;
  var n = Object.getOwnPropertySymbols(e);
  return n.length ? [].concat(t, n.filter(function(r) {
    return Mx.propertyIsEnumerable.call(e, r);
  })) : t;
}
var cy = typeof Reflect < "u" && Reflect.ownKeys ? Reflect.ownKeys : uI ? function(e) {
  return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
} : Object.getOwnPropertyNames;
function bT(e) {
  return typeof e == "string" ? e : typeof e == "symbol" ? e.toString() : new String(e).toString();
}
function lI(e) {
  return e === null ? null : typeof e == "object" ? "" + e : e;
}
function Zu(e, t) {
  return Mx.hasOwnProperty.call(e, t);
}
var XV = Object.getOwnPropertyDescriptors || function(t) {
  var n = {};
  return cy(t).forEach(function(r) {
    n[r] = XE(t, r);
  }), n;
};
function tN(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, ZV(r.key), r);
  }
}
function VO(e, t, n) {
  return t && tN(e.prototype, t), n && tN(e, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function qp() {
  return qp = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, qp.apply(this, arguments);
}
function cI(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, _T(e, t);
}
function _T(e, t) {
  return _T = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, a) {
    return r.__proto__ = a, r;
  }, _T(e, t);
}
function AE(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function KV(e, t) {
  if (!!e) {
    if (typeof e == "string")
      return nN(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return nN(e, t);
  }
}
function nN(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function Ym(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n)
    return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = KV(e)) || t && e && typeof e.length == "number") {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? {
        done: !0
      } : {
        done: !1,
        value: e[r++]
      };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function QV(e, t) {
  if (typeof e != "object" || e === null)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (typeof r != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function ZV(e) {
  var t = QV(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
var Co = /* @__PURE__ */ Symbol("mobx-stored-annotations");
function Jc(e) {
  function t(n, r) {
    Mb(n, r, e);
  }
  return Object.assign(t, e);
}
function Mb(e, t, n) {
  if (Zu(e, Co) || Ob(e, Co, qp({}, e[Co])), process.env.NODE_ENV !== "production" && ZE(n) && !Zu(e[Co], t)) {
    var r = e.constructor.name + ".prototype." + t.toString();
    xt("'" + r + "' is decorated with 'override', but no such decorated member was found on prototype.");
  }
  JV(e, n, t), ZE(n) || (e[Co][t] = n);
}
function JV(e, t, n) {
  if (process.env.NODE_ENV !== "production" && !ZE(t) && Zu(e[Co], n)) {
    var r = e.constructor.name + ".prototype." + n.toString(), a = e[Co][n].annotationType_, s = t.annotationType_;
    xt("Cannot apply '@" + s + "' to '" + r + "':" + (`
The field is already decorated with '@` + a + "'.") + `
Re-decorating fields is not allowed.
Use '@override' decorator for methods overridden by subclass.`);
  }
}
function ej(e) {
  return Zu(e, Co) || (process.env.NODE_ENV !== "production" && !e[Co] && xt("No annotations were passed to makeObservable, but no decorated members have been found either"), Ob(e, Co, qp({}, e[Co]))), e[Co];
}
var fn = /* @__PURE__ */ Symbol("mobx administration"), Ab = /* @__PURE__ */ function() {
  function e(n) {
    n === void 0 && (n = process.env.NODE_ENV !== "production" ? "Atom@" + ic() : "Atom"), this.name_ = void 0, this.isPendingUnobservation_ = !1, this.isBeingObserved_ = !1, this.observers_ = /* @__PURE__ */ new Set(), this.diffValue_ = 0, this.lastAccessedBy_ = 0, this.lowestObserverState_ = Xn.NOT_TRACKING_, this.onBOL = void 0, this.onBUOL = void 0, this.name_ = n;
  }
  var t = e.prototype;
  return t.onBO = function() {
    this.onBOL && this.onBOL.forEach(function(r) {
      return r();
    });
  }, t.onBUO = function() {
    this.onBUOL && this.onBUOL.forEach(function(r) {
      return r();
    });
  }, t.reportObserved = function() {
    return AI(this);
  }, t.reportChanged = function() {
    ts(), PI(this), nt.stateVersion = nt.stateVersion < Number.MAX_SAFE_INTEGER ? nt.stateVersion + 1 : Number.MIN_SAFE_INTEGER, ns();
  }, t.toString = function() {
    return this.name_;
  }, e;
}(), jO = /* @__PURE__ */ tg("Atom", Ab);
function WO(e, t, n) {
  t === void 0 && (t = Hm), n === void 0 && (n = Hm);
  var r = new Ab(e);
  return t !== Hm && u4(r, t), n !== Hm && UI(r, n), r;
}
function tj(e, t) {
  return e === t;
}
function nj(e, t) {
  return KO(e, t);
}
function rj(e, t) {
  return KO(e, t, 1);
}
function ij(e, t) {
  return Object.is ? Object.is(e, t) : e === t ? e !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
var QE = {
  identity: tj,
  structural: nj,
  default: ij,
  shallow: rj
};
function fy(e, t, n) {
  return db(e) ? e : Array.isArray(e) ? _a.array(e, {
    name: n
  }) : Qs(e) ? _a.object(e, void 0, {
    name: n
  }) : Cy(e) ? _a.map(e, {
    name: n
  }) : Db(e) ? _a.set(e, {
    name: n
  }) : typeof e == "function" && !Lx(e) && !nx(e) ? oI(e) ? fb(e) : cb(n, e) : e;
}
function aj(e, t, n) {
  if (e == null || Xh(e) || Bb(e) || Sd(e) || Ty(e))
    return e;
  if (Array.isArray(e))
    return _a.array(e, {
      name: n,
      deep: !1
    });
  if (Qs(e))
    return _a.object(e, void 0, {
      name: n,
      deep: !1
    });
  if (Cy(e))
    return _a.map(e, {
      name: n,
      deep: !1
    });
  if (Db(e))
    return _a.set(e, {
      name: n,
      deep: !1
    });
  process.env.NODE_ENV !== "production" && xt("The shallow modifier / decorator can only used in combination with arrays, objects, maps and sets");
}
function Px(e) {
  return e;
}
function oj(e, t) {
  return process.env.NODE_ENV !== "production" && db(e) && xt("observable.struct should not be used with observable values"), KO(e, t) ? t : e;
}
var sj = "override";
function ZE(e) {
  return e.annotationType_ === sj;
}
function Pb(e, t) {
  return {
    annotationType_: e,
    options_: t,
    make_: uj,
    extend_: lj
  };
}
function uj(e, t, n, r) {
  var a;
  if ((a = this.options_) != null && a.bound)
    return this.extend_(e, t, n, !1) === null ? 0 : 1;
  if (r === e.target_)
    return this.extend_(e, t, n, !1) === null ? 0 : 2;
  if (Lx(n.value))
    return 1;
  var s = fI(e, this, t, n, !1);
  return Zc(r, t, s), 2;
}
function lj(e, t, n, r) {
  var a = fI(e, this, t, n);
  return e.defineProperty_(t, a, r);
}
function cj(e, t, n, r) {
  var a = t.annotationType_, s = r.value;
  process.env.NODE_ENV !== "production" && !Xi(s) && xt("Cannot apply '" + a + "' to '" + e.name_ + "." + n.toString() + "':" + (`
'` + a + "' can only be used on properties with a function value."));
}
function fI(e, t, n, r, a) {
  var s, l, p, h, y, b, E;
  a === void 0 && (a = nt.safeDescriptors), cj(e, t, n, r);
  var x = r.value;
  if ((s = t.options_) != null && s.bound) {
    var C;
    x = x.bind((C = e.proxy_) != null ? C : e.target_);
  }
  return {
    value: dy(
      (l = (p = t.options_) == null ? void 0 : p.name) != null ? l : n.toString(),
      x,
      (h = (y = t.options_) == null ? void 0 : y.autoAction) != null ? h : !1,
      (b = t.options_) != null && b.bound ? (E = e.proxy_) != null ? E : e.target_ : void 0
    ),
    configurable: a ? e.isPlainObject_ : !0,
    enumerable: !1,
    writable: !a
  };
}
function dI(e, t) {
  return {
    annotationType_: e,
    options_: t,
    make_: fj,
    extend_: dj
  };
}
function fj(e, t, n, r) {
  var a;
  if (r === e.target_)
    return this.extend_(e, t, n, !1) === null ? 0 : 2;
  if ((a = this.options_) != null && a.bound && (!Zu(e.target_, t) || !nx(e.target_[t])) && this.extend_(e, t, n, !1) === null)
    return 0;
  if (nx(n.value))
    return 1;
  var s = pI(e, this, t, n, !1, !1);
  return Zc(r, t, s), 2;
}
function dj(e, t, n, r) {
  var a, s = pI(e, this, t, n, (a = this.options_) == null ? void 0 : a.bound);
  return e.defineProperty_(t, s, r);
}
function pj(e, t, n, r) {
  var a = t.annotationType_, s = r.value;
  process.env.NODE_ENV !== "production" && !Xi(s) && xt("Cannot apply '" + a + "' to '" + e.name_ + "." + n.toString() + "':" + (`
'` + a + "' can only be used on properties with a generator function value."));
}
function pI(e, t, n, r, a, s) {
  s === void 0 && (s = nt.safeDescriptors), pj(e, t, n, r);
  var l = r.value;
  if (nx(l) || (l = fb(l)), a) {
    var p;
    l = l.bind((p = e.proxy_) != null ? p : e.target_), l.isMobXFlow = !0;
  }
  return {
    value: l,
    configurable: s ? e.isPlainObject_ : !0,
    enumerable: !1,
    writable: !s
  };
}
function GO(e, t) {
  return {
    annotationType_: e,
    options_: t,
    make_: vj,
    extend_: hj
  };
}
function vj(e, t, n) {
  return this.extend_(e, t, n, !1) === null ? 0 : 1;
}
function hj(e, t, n, r) {
  return gj(e, this, t, n), e.defineComputedProperty_(t, qp({}, this.options_, {
    get: n.get,
    set: n.set
  }), r);
}
function gj(e, t, n, r) {
  var a = t.annotationType_, s = r.get;
  process.env.NODE_ENV !== "production" && !s && xt("Cannot apply '" + a + "' to '" + e.name_ + "." + n.toString() + "':" + (`
'` + a + "' can only be used on getter(+setter) properties."));
}
function Nx(e, t) {
  return {
    annotationType_: e,
    options_: t,
    make_: mj,
    extend_: yj
  };
}
function mj(e, t, n) {
  return this.extend_(e, t, n, !1) === null ? 0 : 1;
}
function yj(e, t, n, r) {
  var a, s;
  return bj(e, this, t, n), e.defineObservableProperty_(t, n.value, (a = (s = this.options_) == null ? void 0 : s.enhancer) != null ? a : fy, r);
}
function bj(e, t, n, r) {
  var a = t.annotationType_;
  process.env.NODE_ENV !== "production" && !("value" in r) && xt("Cannot apply '" + a + "' to '" + e.name_ + "." + n.toString() + "':" + (`
'` + a + "' cannot be used on getter/setter properties"));
}
var _j = "true", Ej = /* @__PURE__ */ vI();
function vI(e) {
  return {
    annotationType_: _j,
    options_: e,
    make_: xj,
    extend_: Sj
  };
}
function xj(e, t, n, r) {
  var a, s;
  if (n.get)
    return kx.make_(e, t, n, r);
  if (n.set) {
    var l = dy(t.toString(), n.set);
    return r === e.target_ ? e.defineProperty_(t, {
      configurable: nt.safeDescriptors ? e.isPlainObject_ : !0,
      set: l
    }) === null ? 0 : 2 : (Zc(r, t, {
      configurable: !0,
      set: l
    }), 2);
  }
  if (r !== e.target_ && typeof n.value == "function") {
    var p;
    if (oI(n.value)) {
      var h, y = (h = this.options_) != null && h.autoBind ? fb.bound : fb;
      return y.make_(e, t, n, r);
    }
    var b = (p = this.options_) != null && p.autoBind ? cb.bound : cb;
    return b.make_(e, t, n, r);
  }
  var E = ((a = this.options_) == null ? void 0 : a.deep) === !1 ? _a.ref : _a;
  if (typeof n.value == "function" && (s = this.options_) != null && s.autoBind) {
    var x;
    n.value = n.value.bind((x = e.proxy_) != null ? x : e.target_);
  }
  return E.make_(e, t, n, r);
}
function Sj(e, t, n, r) {
  var a, s;
  if (n.get)
    return kx.extend_(e, t, n, r);
  if (n.set)
    return e.defineProperty_(t, {
      configurable: nt.safeDescriptors ? e.isPlainObject_ : !0,
      set: dy(t.toString(), n.set)
    }, r);
  if (typeof n.value == "function" && (a = this.options_) != null && a.autoBind) {
    var l;
    n.value = n.value.bind((l = e.proxy_) != null ? l : e.target_);
  }
  var p = ((s = this.options_) == null ? void 0 : s.deep) === !1 ? _a.ref : _a;
  return p.extend_(e, t, n, r);
}
var wj = "observable", Cj = "observable.ref", Rj = "observable.shallow", Tj = "observable.struct", hI = {
  deep: !0,
  name: void 0,
  defaultDecorator: void 0,
  proxy: !0
};
Object.freeze(hI);
function oE(e) {
  return e || hI;
}
var gI = /* @__PURE__ */ Nx(wj), Oj = /* @__PURE__ */ Nx(Cj, {
  enhancer: Px
}), Dj = /* @__PURE__ */ Nx(Rj, {
  enhancer: aj
}), Mj = /* @__PURE__ */ Nx(Tj, {
  enhancer: oj
}), mI = /* @__PURE__ */ Jc(gI);
function sE(e) {
  return e.deep === !0 ? fy : e.deep === !1 ? Px : Pj(e.defaultDecorator);
}
function Aj(e) {
  var t;
  return e ? (t = e.defaultDecorator) != null ? t : vI(e) : void 0;
}
function Pj(e) {
  var t, n;
  return e && (t = (n = e.options_) == null ? void 0 : n.enhancer) != null ? t : fy;
}
function yI(e, t, n) {
  if (Yh(t)) {
    Mb(e, t, gI);
    return;
  }
  return db(e) ? e : Qs(e) ? _a.object(e, t, n) : Array.isArray(e) ? _a.array(e, t) : Cy(e) ? _a.map(e, t) : Db(e) ? _a.set(e, t) : typeof e == "object" && e !== null ? e : _a.box(e, t);
}
rI(yI, mI);
var Nj = {
  box: function(t, n) {
    var r = oE(n);
    return new ey(t, sE(r), r.name, !0, r.equals);
  },
  array: function(t, n) {
    var r = oE(n);
    return (nt.useProxies === !1 || r.proxy === !1 ? P4 : S4)(t, sE(r), r.name);
  },
  map: function(t, n) {
    var r = oE(n);
    return new KI(t, sE(r), r.name);
  },
  set: function(t, n) {
    var r = oE(n);
    return new JI(t, sE(r), r.name);
  },
  object: function(t, n, r) {
    return jI(nt.useProxies === !1 || (r == null ? void 0 : r.proxy) === !1 ? zb({}, r) : b4({}, r), t, n);
  },
  ref: /* @__PURE__ */ Jc(Oj),
  shallow: /* @__PURE__ */ Jc(Dj),
  deep: mI,
  struct: /* @__PURE__ */ Jc(Mj)
}, _a = /* @__PURE__ */ rI(yI, Nj), bI = "computed", kj = "computed.struct", _I = /* @__PURE__ */ GO(bI), Ij = /* @__PURE__ */ GO(kj, {
  equals: QE.structural
}), kx = function(t, n) {
  if (Yh(n))
    return Mb(t, n, _I);
  if (Qs(t))
    return Jc(GO(bI, t));
  process.env.NODE_ENV !== "production" && (Xi(t) || xt("First argument to `computed` should be an expression."), Xi(n) && xt("A setter as second argument is no longer supported, use `{ set: fn }` option instead"));
  var r = Qs(n) ? n : {};
  return r.get = t, r.name || (r.name = t.name || ""), new py(r);
};
Object.assign(kx, _I);
kx.struct = /* @__PURE__ */ Jc(Ij);
var rN, iN, JE = 0, Lj = 1, Bj = (rN = (iN = /* @__PURE__ */ XE(function() {
}, "name")) == null ? void 0 : iN.configurable) != null ? rN : !1, aN = {
  value: "action",
  configurable: !0,
  writable: !1,
  enumerable: !1
};
function dy(e, t, n, r) {
  n === void 0 && (n = !1), process.env.NODE_ENV !== "production" && (Xi(t) || xt("`action` can only be invoked on functions"), (typeof e != "string" || !e) && xt("actions should have valid names, got: '" + e + "'"));
  function a() {
    return EI(e, n, t, r || this, arguments);
  }
  return a.isMobxAction = !0, Bj && (aN.value = e, Zc(a, "name", aN)), a;
}
function EI(e, t, n, r, a) {
  var s = zj(e, t, r, a);
  try {
    return n.apply(r, a);
  } catch (l) {
    throw s.error_ = l, l;
  } finally {
    Fj(s);
  }
}
function zj(e, t, n, r) {
  var a = process.env.NODE_ENV !== "production" && Fa() && !!e, s = 0;
  if (process.env.NODE_ENV !== "production" && a) {
    s = Date.now();
    var l = r ? Array.from(r) : KE;
    Zs({
      type: HO,
      name: e,
      object: n,
      arguments: l
    });
  }
  var p = nt.trackingDerivation, h = !t || !p;
  ts();
  var y = nt.allowStateChanges;
  h && (Ry(), y = Nb(!0));
  var b = ty(!0), E = {
    runAsAction_: h,
    prevDerivation_: p,
    prevAllowStateChanges_: y,
    prevAllowStateReads_: b,
    notifySpy_: a,
    startTime_: s,
    actionId_: Lj++,
    parentActionId_: JE
  };
  return JE = E.actionId_, E;
}
function Fj(e) {
  JE !== e.actionId_ && xt(30), JE = e.parentActionId_, e.error_ !== void 0 && (nt.suppressReactionErrors = !0), kb(e.prevAllowStateChanges_), Wp(e.prevAllowStateReads_), ns(), e.runAsAction_ && jp(e.prevDerivation_), process.env.NODE_ENV !== "production" && e.notifySpy_ && Js({
    time: Date.now() - e.startTime_
  }), nt.suppressReactionErrors = !1;
}
function xI(e, t) {
  var n = Nb(e);
  try {
    return t();
  } finally {
    kb(n);
  }
}
function Nb(e) {
  var t = nt.allowStateChanges;
  return nt.allowStateChanges = e, t;
}
function kb(e) {
  nt.allowStateChanges = e;
}
var SI, $j = "create";
SI = Symbol.toPrimitive;
var ey = /* @__PURE__ */ function(e) {
  cI(t, e);
  function t(r, a, s, l, p) {
    var h;
    return s === void 0 && (s = process.env.NODE_ENV !== "production" ? "ObservableValue@" + ic() : "ObservableValue"), l === void 0 && (l = !0), p === void 0 && (p = QE.default), h = e.call(this, s) || this, h.enhancer = void 0, h.name_ = void 0, h.equals = void 0, h.hasUnreportedChange_ = !1, h.interceptors_ = void 0, h.changeListeners_ = void 0, h.value_ = void 0, h.dehancer = void 0, h.enhancer = a, h.name_ = s, h.equals = p, h.value_ = a(r, void 0, s), process.env.NODE_ENV !== "production" && l && Fa() && qh({
      type: $j,
      object: AE(h),
      observableKind: "value",
      debugObjectName: h.name_,
      newValue: "" + h.value_
    }), h;
  }
  var n = t.prototype;
  return n.dehanceValue = function(a) {
    return this.dehancer !== void 0 ? this.dehancer(a) : a;
  }, n.set = function(a) {
    var s = this.value_;
    if (a = this.prepareNewValue_(a), a !== nt.UNCHANGED) {
      var l = Fa();
      process.env.NODE_ENV !== "production" && l && Zs({
        type: Kl,
        object: this,
        observableKind: "value",
        debugObjectName: this.name_,
        newValue: a,
        oldValue: s
      }), this.setNewValue_(a), process.env.NODE_ENV !== "production" && l && Js();
    }
  }, n.prepareNewValue_ = function(a) {
    if (vy(this), Xu(this)) {
      var s = Ku(this, {
        object: this,
        type: Kl,
        newValue: a
      });
      if (!s)
        return nt.UNCHANGED;
      a = s.newValue;
    }
    return a = this.enhancer(a, this.value_, this.name_), this.equals(this.value_, a) ? nt.UNCHANGED : a;
  }, n.setNewValue_ = function(a) {
    var s = this.value_;
    this.value_ = a, this.reportChanged(), Ql(this) && Zl(this, {
      type: Kl,
      object: this,
      newValue: a,
      oldValue: s
    });
  }, n.get = function() {
    return this.reportObserved(), this.dehanceValue(this.value_);
  }, n.intercept_ = function(a) {
    return Ib(this, a);
  }, n.observe_ = function(a, s) {
    return s && a({
      observableKind: "value",
      debugObjectName: this.name_,
      object: this,
      type: Kl,
      newValue: this.value_,
      oldValue: void 0
    }), Lb(this, a);
  }, n.raw = function() {
    return this.value_;
  }, n.toJSON = function() {
    return this.get();
  }, n.toString = function() {
    return this.name_ + "[" + this.value_ + "]";
  }, n.valueOf = function() {
    return lI(this.get());
  }, n[SI] = function() {
    return this.valueOf();
  }, t;
}(Ab), wI;
wI = Symbol.toPrimitive;
var py = /* @__PURE__ */ function() {
  function e(n) {
    this.dependenciesState_ = Xn.NOT_TRACKING_, this.observing_ = [], this.newObserving_ = null, this.isBeingObserved_ = !1, this.isPendingUnobservation_ = !1, this.observers_ = /* @__PURE__ */ new Set(), this.diffValue_ = 0, this.runId_ = 0, this.lastAccessedBy_ = 0, this.lowestObserverState_ = Xn.UP_TO_DATE_, this.unboundDepsCount_ = 0, this.value_ = new ex(null), this.name_ = void 0, this.triggeredBy_ = void 0, this.isComputing_ = !1, this.isRunningSetter_ = !1, this.derivation = void 0, this.setter_ = void 0, this.isTracing_ = Ju.NONE, this.scope_ = void 0, this.equals_ = void 0, this.requiresReaction_ = void 0, this.keepAlive_ = void 0, this.onBOL = void 0, this.onBUOL = void 0, n.get || xt(31), this.derivation = n.get, this.name_ = n.name || (process.env.NODE_ENV !== "production" ? "ComputedValue@" + ic() : "ComputedValue"), n.set && (this.setter_ = dy(process.env.NODE_ENV !== "production" ? this.name_ + "-setter" : "ComputedValue-setter", n.set)), this.equals_ = n.equals || (n.compareStructural || n.struct ? QE.structural : QE.default), this.scope_ = n.context, this.requiresReaction_ = n.requiresReaction, this.keepAlive_ = !!n.keepAlive;
  }
  var t = e.prototype;
  return t.onBecomeStale_ = function() {
    Yj(this);
  }, t.onBO = function() {
    this.onBOL && this.onBOL.forEach(function(r) {
      return r();
    });
  }, t.onBUO = function() {
    this.onBUOL && this.onBUOL.forEach(function(r) {
      return r();
    });
  }, t.get = function() {
    if (this.isComputing_ && xt(32, this.name_, this.derivation), nt.inBatch === 0 && this.observers_.size === 0 && !this.keepAlive_)
      ET(this) && (this.warnAboutUntrackedRead_(), ts(), this.value_ = this.computeValue_(!1), ns());
    else if (AI(this), ET(this)) {
      var r = nt.trackingContext;
      this.keepAlive_ && !r && (nt.trackingContext = this), this.trackAndCompute() && Hj(this), nt.trackingContext = r;
    }
    var a = this.value_;
    if (PE(a))
      throw a.cause;
    return a;
  }, t.set = function(r) {
    if (this.setter_) {
      this.isRunningSetter_ && xt(33, this.name_), this.isRunningSetter_ = !0;
      try {
        this.setter_.call(this.scope_, r);
      } finally {
        this.isRunningSetter_ = !1;
      }
    } else
      xt(34, this.name_);
  }, t.trackAndCompute = function() {
    var r = this.value_, a = this.dependenciesState_ === Xn.NOT_TRACKING_, s = this.computeValue_(!0), l = a || PE(r) || PE(s) || !this.equals_(r, s);
    return l && (this.value_ = s, process.env.NODE_ENV !== "production" && Fa() && qh({
      observableKind: "computed",
      debugObjectName: this.name_,
      object: this.scope_,
      type: "update",
      oldValue: r,
      newValue: s
    })), l;
  }, t.computeValue_ = function(r) {
    this.isComputing_ = !0;
    var a = Nb(!1), s;
    if (r)
      s = CI(this, this.derivation, this.scope_);
    else if (nt.disableErrorBoundaries === !0)
      s = this.derivation.call(this.scope_);
    else
      try {
        s = this.derivation.call(this.scope_);
      } catch (l) {
        s = new ex(l);
      }
    return kb(a), this.isComputing_ = !1, s;
  }, t.suspend_ = function() {
    this.keepAlive_ || (xT(this), this.value_ = void 0, process.env.NODE_ENV !== "production" && this.isTracing_ !== Ju.NONE && console.log("[mobx.trace] Computed value '" + this.name_ + "' was suspended and it will recompute on the next access."));
  }, t.observe_ = function(r, a) {
    var s = this, l = !0, p = void 0;
    return r4(function() {
      var h = s.get();
      if (!l || a) {
        var y = Ry();
        r({
          observableKind: "computed",
          debugObjectName: s.name_,
          type: Kl,
          object: s,
          newValue: h,
          oldValue: p
        }), jp(y);
      }
      l = !1, p = h;
    });
  }, t.warnAboutUntrackedRead_ = function() {
    process.env.NODE_ENV !== "production" && (this.isTracing_ !== Ju.NONE && console.log("[mobx.trace] Computed value '" + this.name_ + "' is being read outside a reactive context. Doing a full recompute."), (typeof this.requiresReaction_ == "boolean" ? this.requiresReaction_ : nt.computedRequiresReaction) && console.warn("[mobx] Computed value '" + this.name_ + "' is being read outside a reactive context. Doing a full recompute."));
  }, t.toString = function() {
    return this.name_ + "[" + this.derivation.toString() + "]";
  }, t.valueOf = function() {
    return lI(this.get());
  }, t[wI] = function() {
    return this.valueOf();
  }, e;
}(), Ix = /* @__PURE__ */ tg("ComputedValue", py), Xn;
(function(e) {
  e[e.NOT_TRACKING_ = -1] = "NOT_TRACKING_", e[e.UP_TO_DATE_ = 0] = "UP_TO_DATE_", e[e.POSSIBLY_STALE_ = 1] = "POSSIBLY_STALE_", e[e.STALE_ = 2] = "STALE_";
})(Xn || (Xn = {}));
var Ju;
(function(e) {
  e[e.NONE = 0] = "NONE", e[e.LOG = 1] = "LOG", e[e.BREAK = 2] = "BREAK";
})(Ju || (Ju = {}));
var ex = function(t) {
  this.cause = void 0, this.cause = t;
};
function PE(e) {
  return e instanceof ex;
}
function ET(e) {
  switch (e.dependenciesState_) {
    case Xn.UP_TO_DATE_:
      return !1;
    case Xn.NOT_TRACKING_:
    case Xn.STALE_:
      return !0;
    case Xn.POSSIBLY_STALE_: {
      for (var t = ty(!0), n = Ry(), r = e.observing_, a = r.length, s = 0; s < a; s++) {
        var l = r[s];
        if (Ix(l)) {
          if (nt.disableErrorBoundaries)
            l.get();
          else
            try {
              l.get();
            } catch {
              return jp(n), Wp(t), !0;
            }
          if (e.dependenciesState_ === Xn.STALE_)
            return jp(n), Wp(t), !0;
        }
      }
      return TI(e), jp(n), Wp(t), !1;
    }
  }
}
function vy(e) {
  if (process.env.NODE_ENV !== "production") {
    var t = e.observers_.size > 0;
    !nt.allowStateChanges && (t || nt.enforceActions === "always") && console.warn("[MobX] " + (nt.enforceActions ? "Since strict-mode is enabled, changing (observed) observable values without using an action is not allowed. Tried to modify: " : "Side effects like changing state are not allowed at this point. Are you trying to modify state from, for example, a computed value or the render function of a React component? You can wrap side effects in 'runInAction' (or decorate functions with 'action') if needed. Tried to modify: ") + e.name_);
  }
}
function Uj(e) {
  process.env.NODE_ENV !== "production" && !nt.allowStateReads && nt.observableRequiresReaction && console.warn("[mobx] Observable '" + e.name_ + "' being read outside a reactive context.");
}
function CI(e, t, n) {
  var r = ty(!0);
  TI(e), e.newObserving_ = new Array(e.observing_.length + 100), e.unboundDepsCount_ = 0, e.runId_ = ++nt.runId;
  var a = nt.trackingDerivation;
  nt.trackingDerivation = e, nt.inBatch++;
  var s;
  if (nt.disableErrorBoundaries === !0)
    s = t.call(n);
  else
    try {
      s = t.call(n);
    } catch (l) {
      s = new ex(l);
    }
  return nt.inBatch--, nt.trackingDerivation = a, jj(e), Vj(e), Wp(r), s;
}
function Vj(e) {
  process.env.NODE_ENV !== "production" && e.observing_.length === 0 && (typeof e.requiresObservable_ == "boolean" ? e.requiresObservable_ : nt.reactionRequiresObservable) && console.warn("[mobx] Derivation '" + e.name_ + "' is created/updated without reading any observable value.");
}
function jj(e) {
  for (var t = e.observing_, n = e.observing_ = e.newObserving_, r = Xn.UP_TO_DATE_, a = 0, s = e.unboundDepsCount_, l = 0; l < s; l++) {
    var p = n[l];
    p.diffValue_ === 0 && (p.diffValue_ = 1, a !== l && (n[a] = p), a++), p.dependenciesState_ > r && (r = p.dependenciesState_);
  }
  for (n.length = a, e.newObserving_ = null, s = t.length; s--; ) {
    var h = t[s];
    h.diffValue_ === 0 && DI(h, e), h.diffValue_ = 0;
  }
  for (; a--; ) {
    var y = n[a];
    y.diffValue_ === 1 && (y.diffValue_ = 0, Gj(y, e));
  }
  r !== Xn.UP_TO_DATE_ && (e.dependenciesState_ = r, e.onBecomeStale_());
}
function xT(e) {
  var t = e.observing_;
  e.observing_ = [];
  for (var n = t.length; n--; )
    DI(t[n], e);
  e.dependenciesState_ = Xn.NOT_TRACKING_;
}
function RI(e) {
  var t = Ry();
  try {
    return e();
  } finally {
    jp(t);
  }
}
function Ry() {
  var e = nt.trackingDerivation;
  return nt.trackingDerivation = null, e;
}
function jp(e) {
  nt.trackingDerivation = e;
}
function ty(e) {
  var t = nt.allowStateReads;
  return nt.allowStateReads = e, t;
}
function Wp(e) {
  nt.allowStateReads = e;
}
function TI(e) {
  if (e.dependenciesState_ !== Xn.UP_TO_DATE_) {
    e.dependenciesState_ = Xn.UP_TO_DATE_;
    for (var t = e.observing_, n = t.length; n--; )
      t[n].lowestObserverState_ = Xn.UP_TO_DATE_;
  }
}
var NE = function() {
  this.version = 6, this.UNCHANGED = {}, this.trackingDerivation = null, this.trackingContext = null, this.runId = 0, this.mobxGuid = 0, this.inBatch = 0, this.pendingUnobservations = [], this.pendingReactions = [], this.isRunningReactions = !1, this.allowStateChanges = !1, this.allowStateReads = !0, this.enforceActions = !0, this.spyListeners = [], this.globalReactionErrorHandlers = [], this.computedRequiresReaction = !1, this.reactionRequiresObservable = !1, this.observableRequiresReaction = !1, this.disableErrorBoundaries = !1, this.suppressReactionErrors = !1, this.useProxies = !0, this.verifyProxies = !1, this.safeDescriptors = !0, this.stateVersion = Number.MIN_SAFE_INTEGER;
}, kE = !0, OI = !1, nt = /* @__PURE__ */ function() {
  var e = /* @__PURE__ */ $O();
  return e.__mobxInstanceCount > 0 && !e.__mobxGlobals && (kE = !1), e.__mobxGlobals && e.__mobxGlobals.version !== new NE().version && (kE = !1), kE ? e.__mobxGlobals ? (e.__mobxInstanceCount += 1, e.__mobxGlobals.UNCHANGED || (e.__mobxGlobals.UNCHANGED = {}), e.__mobxGlobals) : (e.__mobxInstanceCount = 1, e.__mobxGlobals = /* @__PURE__ */ new NE()) : (setTimeout(function() {
    OI || xt(35);
  }, 1), new NE());
}();
function Wj() {
  if ((nt.pendingReactions.length || nt.inBatch || nt.isRunningReactions) && xt(36), OI = !0, kE) {
    var e = $O();
    --e.__mobxInstanceCount === 0 && (e.__mobxGlobals = void 0), nt = new NE();
  }
}
function Gj(e, t) {
  e.observers_.add(t), e.lowestObserverState_ > t.dependenciesState_ && (e.lowestObserverState_ = t.dependenciesState_);
}
function DI(e, t) {
  e.observers_.delete(t), e.observers_.size === 0 && MI(e);
}
function MI(e) {
  e.isPendingUnobservation_ === !1 && (e.isPendingUnobservation_ = !0, nt.pendingUnobservations.push(e));
}
function ts() {
  nt.inBatch++;
}
function ns() {
  if (--nt.inBatch === 0) {
    II();
    for (var e = nt.pendingUnobservations, t = 0; t < e.length; t++) {
      var n = e[t];
      n.isPendingUnobservation_ = !1, n.observers_.size === 0 && (n.isBeingObserved_ && (n.isBeingObserved_ = !1, n.onBUO()), n instanceof py && n.suspend_());
    }
    nt.pendingUnobservations = [];
  }
}
function AI(e) {
  Uj(e);
  var t = nt.trackingDerivation;
  return t !== null ? (t.runId_ !== e.lastAccessedBy_ && (e.lastAccessedBy_ = t.runId_, t.newObserving_[t.unboundDepsCount_++] = e, !e.isBeingObserved_ && nt.trackingContext && (e.isBeingObserved_ = !0, e.onBO())), e.isBeingObserved_) : (e.observers_.size === 0 && nt.inBatch > 0 && MI(e), !1);
}
function PI(e) {
  e.lowestObserverState_ !== Xn.STALE_ && (e.lowestObserverState_ = Xn.STALE_, e.observers_.forEach(function(t) {
    t.dependenciesState_ === Xn.UP_TO_DATE_ && (process.env.NODE_ENV !== "production" && t.isTracing_ !== Ju.NONE && NI(t, e), t.onBecomeStale_()), t.dependenciesState_ = Xn.STALE_;
  }));
}
function Hj(e) {
  e.lowestObserverState_ !== Xn.STALE_ && (e.lowestObserverState_ = Xn.STALE_, e.observers_.forEach(function(t) {
    t.dependenciesState_ === Xn.POSSIBLY_STALE_ ? (t.dependenciesState_ = Xn.STALE_, process.env.NODE_ENV !== "production" && t.isTracing_ !== Ju.NONE && NI(t, e)) : t.dependenciesState_ === Xn.UP_TO_DATE_ && (e.lowestObserverState_ = Xn.UP_TO_DATE_);
  }));
}
function Yj(e) {
  e.lowestObserverState_ === Xn.UP_TO_DATE_ && (e.lowestObserverState_ = Xn.POSSIBLY_STALE_, e.observers_.forEach(function(t) {
    t.dependenciesState_ === Xn.UP_TO_DATE_ && (t.dependenciesState_ = Xn.POSSIBLY_STALE_, t.onBecomeStale_());
  }));
}
function NI(e, t) {
  if (console.log("[mobx.trace] '" + e.name_ + "' is invalidated due to a change in: '" + t.name_ + "'"), e.isTracing_ === Ju.BREAK) {
    var n = [];
    kI(WI(e), n, 1), new Function(`debugger;
/*
Tracing '` + e.name_ + `'

You are entering this break point because derivation '` + e.name_ + "' is being traced and '" + t.name_ + `' is now forcing it to update.
Just follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update
The stackframe you are looking for is at least ~6-8 stack-frames up.

` + (e instanceof py ? e.derivation.toString().replace(/[*]\//g, "/") : "") + `

The dependencies for this derivation are:

` + n.join(`
`) + `
*/
    `)();
  }
}
function kI(e, t, n) {
  if (t.length >= 1e3) {
    t.push("(and many more)");
    return;
  }
  t.push("" + "	".repeat(n - 1) + e.name), e.dependencies && e.dependencies.forEach(function(r) {
    return kI(r, t, n + 1);
  });
}
var hy = /* @__PURE__ */ function() {
  function e(n, r, a, s) {
    n === void 0 && (n = process.env.NODE_ENV !== "production" ? "Reaction@" + ic() : "Reaction"), this.name_ = void 0, this.onInvalidate_ = void 0, this.errorHandler_ = void 0, this.requiresObservable_ = void 0, this.observing_ = [], this.newObserving_ = [], this.dependenciesState_ = Xn.NOT_TRACKING_, this.diffValue_ = 0, this.runId_ = 0, this.unboundDepsCount_ = 0, this.isDisposed_ = !1, this.isScheduled_ = !1, this.isTrackPending_ = !1, this.isRunning_ = !1, this.isTracing_ = Ju.NONE, this.name_ = n, this.onInvalidate_ = r, this.errorHandler_ = a, this.requiresObservable_ = s;
  }
  var t = e.prototype;
  return t.onBecomeStale_ = function() {
    this.schedule_();
  }, t.schedule_ = function() {
    this.isScheduled_ || (this.isScheduled_ = !0, nt.pendingReactions.push(this), II());
  }, t.isScheduled = function() {
    return this.isScheduled_;
  }, t.runReaction_ = function() {
    if (!this.isDisposed_) {
      ts(), this.isScheduled_ = !1;
      var r = nt.trackingContext;
      if (nt.trackingContext = this, ET(this)) {
        this.isTrackPending_ = !0;
        try {
          this.onInvalidate_(), process.env.NODE_ENV !== "production" && this.isTrackPending_ && Fa() && qh({
            name: this.name_,
            type: "scheduled-reaction"
          });
        } catch (a) {
          this.reportExceptionInDerivation_(a);
        }
      }
      nt.trackingContext = r, ns();
    }
  }, t.track = function(r) {
    if (!this.isDisposed_) {
      ts();
      var a = Fa(), s;
      process.env.NODE_ENV !== "production" && a && (s = Date.now(), Zs({
        name: this.name_,
        type: "reaction"
      })), this.isRunning_ = !0;
      var l = nt.trackingContext;
      nt.trackingContext = this;
      var p = CI(this, r, void 0);
      nt.trackingContext = l, this.isRunning_ = !1, this.isTrackPending_ = !1, this.isDisposed_ && xT(this), PE(p) && this.reportExceptionInDerivation_(p.cause), process.env.NODE_ENV !== "production" && a && Js({
        time: Date.now() - s
      }), ns();
    }
  }, t.reportExceptionInDerivation_ = function(r) {
    var a = this;
    if (this.errorHandler_) {
      this.errorHandler_(r, this);
      return;
    }
    if (nt.disableErrorBoundaries)
      throw r;
    var s = process.env.NODE_ENV !== "production" ? "[mobx] Encountered an uncaught exception that was thrown by a reaction or observer component, in: '" + this + "'" : "[mobx] uncaught error in '" + this + "'";
    nt.suppressReactionErrors ? process.env.NODE_ENV !== "production" && console.warn("[mobx] (error in reaction '" + this.name_ + "' suppressed, fix error of causing action below)") : console.error(s, r), process.env.NODE_ENV !== "production" && Fa() && qh({
      type: "error",
      name: this.name_,
      message: s,
      error: "" + r
    }), nt.globalReactionErrorHandlers.forEach(function(l) {
      return l(r, a);
    });
  }, t.dispose = function() {
    this.isDisposed_ || (this.isDisposed_ = !0, this.isRunning_ || (ts(), xT(this), ns()));
  }, t.getDisposer_ = function() {
    var r = this.dispose.bind(this);
    return r[fn] = this, r;
  }, t.toString = function() {
    return "Reaction[" + this.name_ + "]";
  }, t.trace = function(r) {
    r === void 0 && (r = !1), g4(this, r);
  }, e;
}(), oN = 100, ST = function(t) {
  return t();
};
function II() {
  nt.inBatch > 0 || nt.isRunningReactions || ST(qj);
}
function qj() {
  nt.isRunningReactions = !0;
  for (var e = nt.pendingReactions, t = 0; e.length > 0; ) {
    ++t === oN && (console.error(process.env.NODE_ENV !== "production" ? "Reaction doesn't converge to a stable state after " + oN + " iterations." + (" Probably there is a cycle in the reactive function: " + e[0]) : "[mobx] cycle in reaction: " + e[0]), e.splice(0));
    for (var n = e.splice(0), r = 0, a = n.length; r < a; r++)
      n[r].runReaction_();
  }
  nt.isRunningReactions = !1;
}
var tx = /* @__PURE__ */ tg("Reaction", hy);
function Xj(e) {
  var t = ST;
  ST = function(r) {
    return e(function() {
      return t(r);
    });
  };
}
function Fa() {
  return process.env.NODE_ENV !== "production" && !!nt.spyListeners.length;
}
function qh(e) {
  if (process.env.NODE_ENV !== "production" && !!nt.spyListeners.length)
    for (var t = nt.spyListeners, n = 0, r = t.length; n < r; n++)
      t[n](e);
}
function Zs(e) {
  if (process.env.NODE_ENV !== "production") {
    var t = qp({}, e, {
      spyReportStart: !0
    });
    qh(t);
  }
}
var Kj = {
  type: "report-end",
  spyReportEnd: !0
};
function Js(e) {
  process.env.NODE_ENV !== "production" && qh(e ? qp({}, e, {
    type: "report-end",
    spyReportEnd: !0
  }) : Kj);
}
function Qj(e) {
  return process.env.NODE_ENV === "production" ? (console.warn("[mobx.spy] Is a no-op in production builds"), function() {
  }) : (nt.spyListeners.push(e), UO(function() {
    nt.spyListeners = nt.spyListeners.filter(function(t) {
      return t !== e;
    });
  }));
}
var HO = "action", Zj = "action.bound", LI = "autoAction", Jj = "autoAction.bound", BI = "<unnamed action>", zI = /* @__PURE__ */ Pb(HO), e4 = /* @__PURE__ */ Pb(Zj, {
  bound: !0
}), FI = /* @__PURE__ */ Pb(LI, {
  autoAction: !0
}), t4 = /* @__PURE__ */ Pb(Jj, {
  autoAction: !0,
  bound: !0
});
function $I(e) {
  var t = function(r, a) {
    if (Xi(r))
      return dy(r.name || BI, r, e);
    if (Xi(a))
      return dy(r, a, e);
    if (Yh(a))
      return Mb(r, a, e ? FI : zI);
    if (Yh(r))
      return Jc(Pb(e ? LI : HO, {
        name: r,
        autoAction: e
      }));
    process.env.NODE_ENV !== "production" && xt("Invalid arguments for `action`");
  };
  return t;
}
var qm = /* @__PURE__ */ $I(!1);
Object.assign(qm, zI);
var cb = /* @__PURE__ */ $I(!0);
Object.assign(cb, FI);
qm.bound = /* @__PURE__ */ Jc(e4);
cb.bound = /* @__PURE__ */ Jc(t4);
function n4(e) {
  return EI(e.name || BI, !1, e, this, void 0);
}
function Lx(e) {
  return Xi(e) && e.isMobxAction === !0;
}
function r4(e, t) {
  var n, r;
  t === void 0 && (t = iI), process.env.NODE_ENV !== "production" && (Xi(e) || xt("Autorun expects a function as first argument"), Lx(e) && xt("Autorun does not accept actions since actions are untrackable"));
  var a = (n = (r = t) == null ? void 0 : r.name) != null ? n : process.env.NODE_ENV !== "production" ? e.name || "Autorun@" + ic() : "Autorun", s = !t.scheduler && !t.delay, l;
  if (s)
    l = new hy(a, function() {
      this.track(y);
    }, t.onError, t.requiresObservable);
  else {
    var p = a4(t), h = !1;
    l = new hy(a, function() {
      h || (h = !0, p(function() {
        h = !1, l.isDisposed_ || l.track(y);
      }));
    }, t.onError, t.requiresObservable);
  }
  function y() {
    e(l);
  }
  return l.schedule_(), l.getDisposer_();
}
var i4 = function(t) {
  return t();
};
function a4(e) {
  return e.scheduler ? e.scheduler : e.delay ? function(t) {
    return setTimeout(t, e.delay);
  } : i4;
}
var o4 = "onBO", s4 = "onBUO";
function u4(e, t, n) {
  return VI(o4, e, t, n);
}
function UI(e, t, n) {
  return VI(s4, e, t, n);
}
function VI(e, t, n, r) {
  var a = typeof r == "function" ? Xp(t, n) : Xp(t), s = Xi(r) ? r : n, l = e + "L";
  return a[l] ? a[l].add(s) : a[l] = /* @__PURE__ */ new Set([s]), function() {
    var p = a[l];
    p && (p.delete(s), p.size === 0 && delete a[l]);
  };
}
var l4 = "never", uE = "always", c4 = "observed";
function f4(e) {
  e.isolateGlobalState === !0 && Wj();
  var t = e.useProxies, n = e.enforceActions;
  if (t !== void 0 && (nt.useProxies = t === uE ? !0 : t === l4 ? !1 : typeof Proxy < "u"), t === "ifavailable" && (nt.verifyProxies = !0), n !== void 0) {
    var r = n === uE ? uE : n === c4;
    nt.enforceActions = r, nt.allowStateChanges = !(r === !0 || r === uE);
  }
  ["computedRequiresReaction", "reactionRequiresObservable", "observableRequiresReaction", "disableErrorBoundaries", "safeDescriptors"].forEach(function(a) {
    a in e && (nt[a] = !!e[a]);
  }), nt.allowStateReads = !nt.observableRequiresReaction, process.env.NODE_ENV !== "production" && nt.disableErrorBoundaries === !0 && console.warn("WARNING: Debug feature only. MobX will NOT recover from errors when `disableErrorBoundaries` is enabled."), e.reactionScheduler && Xj(e.reactionScheduler);
}
function jI(e, t, n, r) {
  process.env.NODE_ENV !== "production" && (arguments.length > 4 && xt("'extendObservable' expected 2-4 arguments"), typeof e != "object" && xt("'extendObservable' expects an object as first argument"), Sd(e) && xt("'extendObservable' should not be used on maps, use map.merge instead"), Qs(t) || xt("'extendObservable' only accepts plain objects as second argument"), (db(t) || db(n)) && xt("Extending an object with another observable (object) is not supported"));
  var a = XV(t), s = zb(e, r)[fn];
  ts();
  try {
    cy(a).forEach(function(l) {
      s.extend_(
        l,
        a[l],
        n && l in n ? n[l] : !0
      );
    });
  } finally {
    ns();
  }
  return e;
}
function WI(e, t) {
  return GI(Xp(e, t));
}
function GI(e) {
  var t = {
    name: e.name_
  };
  return e.observing_ && e.observing_.length > 0 && (t.dependencies = d4(e.observing_).map(GI)), t;
}
function d4(e) {
  return Array.from(new Set(e));
}
var p4 = 0;
function HI() {
  this.message = "FLOW_CANCELLED";
}
HI.prototype = /* @__PURE__ */ Object.create(Error.prototype);
var sN = /* @__PURE__ */ dI("flow"), v4 = /* @__PURE__ */ dI("flow.bound", {
  bound: !0
}), fb = /* @__PURE__ */ Object.assign(function(t, n) {
  if (Yh(n))
    return Mb(t, n, sN);
  process.env.NODE_ENV !== "production" && arguments.length !== 1 && xt("Flow expects single argument with generator function");
  var r = t, a = r.name || "<unnamed flow>", s = function() {
    var p = this, h = arguments, y = ++p4, b = qm(a + " - runid: " + y + " - init", r).apply(p, h), E, x = void 0, C = new Promise(function(T, O) {
      var D = 0;
      E = O;
      function A(L) {
        x = void 0;
        var k;
        try {
          k = qm(a + " - runid: " + y + " - yield " + D++, b.next).call(b, L);
        } catch ($) {
          return O($);
        }
        I(k);
      }
      function B(L) {
        x = void 0;
        var k;
        try {
          k = qm(a + " - runid: " + y + " - yield " + D++, b.throw).call(b, L);
        } catch ($) {
          return O($);
        }
        I(k);
      }
      function I(L) {
        if (Xi(L == null ? void 0 : L.then)) {
          L.then(I, O);
          return;
        }
        return L.done ? T(L.value) : (x = Promise.resolve(L.value), x.then(A, B));
      }
      A(void 0);
    });
    return C.cancel = qm(a + " - runid: " + y + " - cancel", function() {
      try {
        x && uN(x);
        var T = b.return(void 0), O = Promise.resolve(T.value);
        O.then(Hm, Hm), uN(O), E(new HI());
      } catch (D) {
        E(D);
      }
    }), C;
  };
  return s.isMobXFlow = !0, s;
}, sN);
fb.bound = /* @__PURE__ */ Jc(v4);
function uN(e) {
  Xi(e.cancel) && e.cancel();
}
function nx(e) {
  return (e == null ? void 0 : e.isMobXFlow) === !0;
}
function h4(e, t) {
  return e ? t !== void 0 ? process.env.NODE_ENV !== "production" && (Sd(e) || Bb(e)) ? xt("isObservable(object, propertyName) is not supported for arrays and maps. Use map.has or array.length instead.") : Xh(e) ? e[fn].values_.has(t) : !1 : Xh(e) || !!e[fn] || jO(e) || tx(e) || Ix(e) : !1;
}
function db(e) {
  return process.env.NODE_ENV !== "production" && arguments.length !== 1 && xt("isObservable expects only 1 argument. Use isObservableProp to inspect the observability of a property"), h4(e);
}
function g4() {
  process.env.NODE_ENV === "production" && xt("trace() is not available in production builds");
  for (var e = !1, t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  typeof n[n.length - 1] == "boolean" && (e = n.pop());
  var a = m4(n);
  if (!a)
    return xt("'trace(break?)' can only be used inside a tracked computed value or a Reaction. Consider passing in the computed value or reaction explicitly");
  a.isTracing_ === Ju.NONE && console.log("[mobx.trace] '" + a.name_ + "' tracing enabled"), a.isTracing_ = e ? Ju.BREAK : Ju.LOG;
}
function m4(e) {
  switch (e.length) {
    case 0:
      return nt.trackingDerivation;
    case 1:
      return Xp(e[0]);
    case 2:
      return Xp(e[0], e[1]);
  }
}
function pd(e, t) {
  t === void 0 && (t = void 0), ts();
  try {
    return e.apply(t);
  } finally {
    ns();
  }
}
function Nh(e) {
  return e[fn];
}
var y4 = {
  has: function(t, n) {
    return process.env.NODE_ENV !== "production" && nt.trackingDerivation && U0("detect new properties using the 'in' operator. Use 'has' from 'mobx' instead."), Nh(t).has_(n);
  },
  get: function(t, n) {
    return Nh(t).get_(n);
  },
  set: function(t, n, r) {
    var a;
    return Yh(n) ? (process.env.NODE_ENV !== "production" && !Nh(t).values_.has(n) && U0("add a new observable property through direct assignment. Use 'set' from 'mobx' instead."), (a = Nh(t).set_(n, r, !0)) != null ? a : !0) : !1;
  },
  deleteProperty: function(t, n) {
    var r;
    return process.env.NODE_ENV !== "production" && U0("delete properties from an observable object. Use 'remove' from 'mobx' instead."), Yh(n) ? (r = Nh(t).delete_(n, !0)) != null ? r : !0 : !1;
  },
  defineProperty: function(t, n, r) {
    var a;
    return process.env.NODE_ENV !== "production" && U0("define property on an observable object. Use 'defineProperty' from 'mobx' instead."), (a = Nh(t).defineProperty_(n, r)) != null ? a : !0;
  },
  ownKeys: function(t) {
    return process.env.NODE_ENV !== "production" && nt.trackingDerivation && U0("iterate keys to detect added / removed properties. Use 'keys' from 'mobx' instead."), Nh(t).ownKeys_();
  },
  preventExtensions: function(t) {
    xt(13);
  }
};
function b4(e, t) {
  var n, r;
  return aI(), e = zb(e, t), (r = (n = e[fn]).proxy_) != null ? r : n.proxy_ = new Proxy(e, y4);
}
function Xu(e) {
  return e.interceptors_ !== void 0 && e.interceptors_.length > 0;
}
function Ib(e, t) {
  var n = e.interceptors_ || (e.interceptors_ = []);
  return n.push(t), UO(function() {
    var r = n.indexOf(t);
    r !== -1 && n.splice(r, 1);
  });
}
function Ku(e, t) {
  var n = Ry();
  try {
    for (var r = [].concat(e.interceptors_ || []), a = 0, s = r.length; a < s && (t = r[a](t), t && !t.type && xt(14), !!t); a++)
      ;
    return t;
  } finally {
    jp(n);
  }
}
function Ql(e) {
  return e.changeListeners_ !== void 0 && e.changeListeners_.length > 0;
}
function Lb(e, t) {
  var n = e.changeListeners_ || (e.changeListeners_ = []);
  return n.push(t), UO(function() {
    var r = n.indexOf(t);
    r !== -1 && n.splice(r, 1);
  });
}
function Zl(e, t) {
  var n = Ry(), r = e.changeListeners_;
  if (!!r) {
    r = r.slice();
    for (var a = 0, s = r.length; a < s; a++)
      r[a](t);
    jp(n);
  }
}
function _4(e, t, n) {
  var r = zb(e, n)[fn];
  ts();
  try {
    var a;
    process.env.NODE_ENV !== "production" && t && e[Co] && xt("makeObservable second arg must be nullish when using decorators. Mixing @decorator syntax with annotations is not supported."), (a = t) != null || (t = ej(e)), cy(t).forEach(function(s) {
      return r.make_(s, t[s]);
    });
  } finally {
    ns();
  }
  return e;
}
var kR = /* @__PURE__ */ Symbol("mobx-keys");
function ng(e, t, n) {
  if (process.env.NODE_ENV !== "production" && (!Qs(e) && !Qs(Object.getPrototypeOf(e)) && xt("'makeAutoObservable' can only be used for classes that don't have a superclass"), Xh(e) && xt("makeAutoObservable can only be used on objects not already made observable")), Qs(e))
    return jI(e, e, t, n);
  var r = zb(e, n)[fn];
  if (!e[kR]) {
    var a = Object.getPrototypeOf(e), s = new Set([].concat(cy(e), cy(a)));
    s.delete("constructor"), s.delete(fn), Ob(a, kR, s);
  }
  ts();
  try {
    e[kR].forEach(function(l) {
      return r.make_(
        l,
        t && l in t ? t[l] : !0
      );
    });
  } finally {
    ns();
  }
  return e;
}
var lN = "splice", Kl = "update", E4 = 1e4, x4 = {
  get: function(t, n) {
    var r = t[fn];
    return n === fn ? r : n === "length" ? r.getArrayLength_() : typeof n == "string" && !isNaN(n) ? r.get_(parseInt(n)) : Zu(rx, n) ? rx[n] : t[n];
  },
  set: function(t, n, r) {
    var a = t[fn];
    return n === "length" && a.setArrayLength_(r), typeof n == "symbol" || isNaN(n) ? t[n] = r : a.set_(parseInt(n), r), !0;
  },
  preventExtensions: function() {
    xt(15);
  }
}, YO = /* @__PURE__ */ function() {
  function e(n, r, a, s) {
    n === void 0 && (n = process.env.NODE_ENV !== "production" ? "ObservableArray@" + ic() : "ObservableArray"), this.owned_ = void 0, this.legacyMode_ = void 0, this.atom_ = void 0, this.values_ = [], this.interceptors_ = void 0, this.changeListeners_ = void 0, this.enhancer_ = void 0, this.dehancer = void 0, this.proxy_ = void 0, this.lastKnownLength_ = 0, this.owned_ = a, this.legacyMode_ = s, this.atom_ = new Ab(n), this.enhancer_ = function(l, p) {
      return r(l, p, process.env.NODE_ENV !== "production" ? n + "[..]" : "ObservableArray[..]");
    };
  }
  var t = e.prototype;
  return t.dehanceValue_ = function(r) {
    return this.dehancer !== void 0 ? this.dehancer(r) : r;
  }, t.dehanceValues_ = function(r) {
    return this.dehancer !== void 0 && r.length > 0 ? r.map(this.dehancer) : r;
  }, t.intercept_ = function(r) {
    return Ib(this, r);
  }, t.observe_ = function(r, a) {
    return a === void 0 && (a = !1), a && r({
      observableKind: "array",
      object: this.proxy_,
      debugObjectName: this.atom_.name_,
      type: "splice",
      index: 0,
      added: this.values_.slice(),
      addedCount: this.values_.length,
      removed: [],
      removedCount: 0
    }), Lb(this, r);
  }, t.getArrayLength_ = function() {
    return this.atom_.reportObserved(), this.values_.length;
  }, t.setArrayLength_ = function(r) {
    (typeof r != "number" || isNaN(r) || r < 0) && xt("Out of range: " + r);
    var a = this.values_.length;
    if (r !== a)
      if (r > a) {
        for (var s = new Array(r - a), l = 0; l < r - a; l++)
          s[l] = void 0;
        this.spliceWithArray_(a, 0, s);
      } else
        this.spliceWithArray_(r, a - r);
  }, t.updateArrayLength_ = function(r, a) {
    r !== this.lastKnownLength_ && xt(16), this.lastKnownLength_ += a, this.legacyMode_ && a > 0 && nL(r + a + 1);
  }, t.spliceWithArray_ = function(r, a, s) {
    var l = this;
    vy(this.atom_);
    var p = this.values_.length;
    if (r === void 0 ? r = 0 : r > p ? r = p : r < 0 && (r = Math.max(0, p + r)), arguments.length === 1 ? a = p - r : a == null ? a = 0 : a = Math.max(0, Math.min(a, p - r)), s === void 0 && (s = KE), Xu(this)) {
      var h = Ku(this, {
        object: this.proxy_,
        type: lN,
        index: r,
        removedCount: a,
        added: s
      });
      if (!h)
        return KE;
      a = h.removedCount, s = h.added;
    }
    if (s = s.length === 0 ? s : s.map(function(E) {
      return l.enhancer_(E, void 0);
    }), this.legacyMode_ || process.env.NODE_ENV !== "production") {
      var y = s.length - a;
      this.updateArrayLength_(p, y);
    }
    var b = this.spliceItemsIntoValues_(r, a, s);
    return (a !== 0 || s.length !== 0) && this.notifyArraySplice_(r, s, b), this.dehanceValues_(b);
  }, t.spliceItemsIntoValues_ = function(r, a, s) {
    if (s.length < E4) {
      var l;
      return (l = this.values_).splice.apply(l, [r, a].concat(s));
    } else {
      var p = this.values_.slice(r, r + a), h = this.values_.slice(r + a);
      this.values_.length += s.length - a;
      for (var y = 0; y < s.length; y++)
        this.values_[r + y] = s[y];
      for (var b = 0; b < h.length; b++)
        this.values_[r + s.length + b] = h[b];
      return p;
    }
  }, t.notifyArrayChildUpdate_ = function(r, a, s) {
    var l = !this.owned_ && Fa(), p = Ql(this), h = p || l ? {
      observableKind: "array",
      object: this.proxy_,
      type: Kl,
      debugObjectName: this.atom_.name_,
      index: r,
      newValue: a,
      oldValue: s
    } : null;
    process.env.NODE_ENV !== "production" && l && Zs(h), this.atom_.reportChanged(), p && Zl(this, h), process.env.NODE_ENV !== "production" && l && Js();
  }, t.notifyArraySplice_ = function(r, a, s) {
    var l = !this.owned_ && Fa(), p = Ql(this), h = p || l ? {
      observableKind: "array",
      object: this.proxy_,
      debugObjectName: this.atom_.name_,
      type: lN,
      index: r,
      removed: s,
      added: a,
      removedCount: s.length,
      addedCount: a.length
    } : null;
    process.env.NODE_ENV !== "production" && l && Zs(h), this.atom_.reportChanged(), p && Zl(this, h), process.env.NODE_ENV !== "production" && l && Js();
  }, t.get_ = function(r) {
    if (this.legacyMode_ && r >= this.values_.length) {
      console.warn(process.env.NODE_ENV !== "production" ? "[mobx.array] Attempt to read an array index (" + r + ") that is out of bounds (" + this.values_.length + "). Please check length first. Out of bound indices will not be tracked by MobX" : "[mobx] Out of bounds read: " + r);
      return;
    }
    return this.atom_.reportObserved(), this.dehanceValue_(this.values_[r]);
  }, t.set_ = function(r, a) {
    var s = this.values_;
    if (this.legacyMode_ && r > s.length && xt(17, r, s.length), r < s.length) {
      vy(this.atom_);
      var l = s[r];
      if (Xu(this)) {
        var p = Ku(this, {
          type: Kl,
          object: this.proxy_,
          index: r,
          newValue: a
        });
        if (!p)
          return;
        a = p.newValue;
      }
      a = this.enhancer_(a, l);
      var h = a !== l;
      h && (s[r] = a, this.notifyArrayChildUpdate_(r, a, l));
    } else {
      for (var y = new Array(r + 1 - s.length), b = 0; b < y.length - 1; b++)
        y[b] = void 0;
      y[y.length - 1] = a, this.spliceWithArray_(s.length, 0, y);
    }
  }, e;
}();
function S4(e, t, n, r) {
  n === void 0 && (n = process.env.NODE_ENV !== "production" ? "ObservableArray@" + ic() : "ObservableArray"), r === void 0 && (r = !1), aI();
  var a = new YO(n, t, r, !1);
  sI(a.values_, fn, a);
  var s = new Proxy(a.values_, x4);
  if (a.proxy_ = s, e && e.length) {
    var l = Nb(!0);
    a.spliceWithArray_(0, 0, e), kb(l);
  }
  return s;
}
var rx = {
  clear: function() {
    return this.splice(0);
  },
  replace: function(t) {
    var n = this[fn];
    return n.spliceWithArray_(0, n.values_.length, t);
  },
  toJSON: function() {
    return this.slice();
  },
  splice: function(t, n) {
    for (var r = arguments.length, a = new Array(r > 2 ? r - 2 : 0), s = 2; s < r; s++)
      a[s - 2] = arguments[s];
    var l = this[fn];
    switch (arguments.length) {
      case 0:
        return [];
      case 1:
        return l.spliceWithArray_(t);
      case 2:
        return l.spliceWithArray_(t, n);
    }
    return l.spliceWithArray_(t, n, a);
  },
  spliceWithArray: function(t, n, r) {
    return this[fn].spliceWithArray_(t, n, r);
  },
  push: function() {
    for (var t = this[fn], n = arguments.length, r = new Array(n), a = 0; a < n; a++)
      r[a] = arguments[a];
    return t.spliceWithArray_(t.values_.length, 0, r), t.values_.length;
  },
  pop: function() {
    return this.splice(Math.max(this[fn].values_.length - 1, 0), 1)[0];
  },
  shift: function() {
    return this.splice(0, 1)[0];
  },
  unshift: function() {
    for (var t = this[fn], n = arguments.length, r = new Array(n), a = 0; a < n; a++)
      r[a] = arguments[a];
    return t.spliceWithArray_(0, 0, r), t.values_.length;
  },
  reverse: function() {
    return nt.trackingDerivation && xt(37, "reverse"), this.replace(this.slice().reverse()), this;
  },
  sort: function() {
    nt.trackingDerivation && xt(37, "sort");
    var t = this.slice();
    return t.sort.apply(t, arguments), this.replace(t), this;
  },
  remove: function(t) {
    var n = this[fn], r = n.dehanceValues_(n.values_).indexOf(t);
    return r > -1 ? (this.splice(r, 1), !0) : !1;
  }
};
Qi("concat", xd);
Qi("flat", xd);
Qi("includes", xd);
Qi("indexOf", xd);
Qi("join", xd);
Qi("lastIndexOf", xd);
Qi("slice", xd);
Qi("toString", xd);
Qi("toLocaleString", xd);
Qi("every", nv);
Qi("filter", nv);
Qi("find", nv);
Qi("findIndex", nv);
Qi("flatMap", nv);
Qi("forEach", nv);
Qi("map", nv);
Qi("some", nv);
Qi("reduce", YI);
Qi("reduceRight", YI);
function Qi(e, t) {
  typeof Array.prototype[e] == "function" && (rx[e] = t(e));
}
function xd(e) {
  return function() {
    var t = this[fn];
    t.atom_.reportObserved();
    var n = t.dehanceValues_(t.values_);
    return n[e].apply(n, arguments);
  };
}
function nv(e) {
  return function(t, n) {
    var r = this, a = this[fn];
    a.atom_.reportObserved();
    var s = a.dehanceValues_(a.values_);
    return s[e](function(l, p) {
      return t.call(n, l, p, r);
    });
  };
}
function YI(e) {
  return function() {
    var t = this, n = this[fn];
    n.atom_.reportObserved();
    var r = n.dehanceValues_(n.values_), a = arguments[0];
    return arguments[0] = function(s, l, p) {
      return a(s, l, p, t);
    }, r[e].apply(r, arguments);
  };
}
var w4 = /* @__PURE__ */ tg("ObservableArrayAdministration", YO);
function Bb(e) {
  return Ax(e) && w4(e[fn]);
}
var qI, XI, C4 = {}, $p = "add", ix = "delete";
qI = Symbol.iterator;
XI = Symbol.toStringTag;
var KI = /* @__PURE__ */ function() {
  function e(n, r, a) {
    var s = this;
    r === void 0 && (r = fy), a === void 0 && (a = process.env.NODE_ENV !== "production" ? "ObservableMap@" + ic() : "ObservableMap"), this.enhancer_ = void 0, this.name_ = void 0, this[fn] = C4, this.data_ = void 0, this.hasMap_ = void 0, this.keysAtom_ = void 0, this.interceptors_ = void 0, this.changeListeners_ = void 0, this.dehancer = void 0, this.enhancer_ = r, this.name_ = a, Xi(Map) || xt(18), this.keysAtom_ = WO(process.env.NODE_ENV !== "production" ? this.name_ + ".keys()" : "ObservableMap.keys()"), this.data_ = /* @__PURE__ */ new Map(), this.hasMap_ = /* @__PURE__ */ new Map(), xI(!0, function() {
      s.merge(n);
    });
  }
  var t = e.prototype;
  return t.has_ = function(r) {
    return this.data_.has(r);
  }, t.has = function(r) {
    var a = this;
    if (!nt.trackingDerivation)
      return this.has_(r);
    var s = this.hasMap_.get(r);
    if (!s) {
      var l = s = new ey(this.has_(r), Px, process.env.NODE_ENV !== "production" ? this.name_ + "." + bT(r) + "?" : "ObservableMap.key?", !1);
      this.hasMap_.set(r, l), UI(l, function() {
        return a.hasMap_.delete(r);
      });
    }
    return s.get();
  }, t.set = function(r, a) {
    var s = this.has_(r);
    if (Xu(this)) {
      var l = Ku(this, {
        type: s ? Kl : $p,
        object: this,
        newValue: a,
        name: r
      });
      if (!l)
        return this;
      a = l.newValue;
    }
    return s ? this.updateValue_(r, a) : this.addValue_(r, a), this;
  }, t.delete = function(r) {
    var a = this;
    if (vy(this.keysAtom_), Xu(this)) {
      var s = Ku(this, {
        type: ix,
        object: this,
        name: r
      });
      if (!s)
        return !1;
    }
    if (this.has_(r)) {
      var l = Fa(), p = Ql(this), h = p || l ? {
        observableKind: "map",
        debugObjectName: this.name_,
        type: ix,
        object: this,
        oldValue: this.data_.get(r).value_,
        name: r
      } : null;
      return process.env.NODE_ENV !== "production" && l && Zs(h), pd(function() {
        var y;
        a.keysAtom_.reportChanged(), (y = a.hasMap_.get(r)) == null || y.setNewValue_(!1);
        var b = a.data_.get(r);
        b.setNewValue_(void 0), a.data_.delete(r);
      }), p && Zl(this, h), process.env.NODE_ENV !== "production" && l && Js(), !0;
    }
    return !1;
  }, t.updateValue_ = function(r, a) {
    var s = this.data_.get(r);
    if (a = s.prepareNewValue_(a), a !== nt.UNCHANGED) {
      var l = Fa(), p = Ql(this), h = p || l ? {
        observableKind: "map",
        debugObjectName: this.name_,
        type: Kl,
        object: this,
        oldValue: s.value_,
        name: r,
        newValue: a
      } : null;
      process.env.NODE_ENV !== "production" && l && Zs(h), s.setNewValue_(a), p && Zl(this, h), process.env.NODE_ENV !== "production" && l && Js();
    }
  }, t.addValue_ = function(r, a) {
    var s = this;
    vy(this.keysAtom_), pd(function() {
      var y, b = new ey(a, s.enhancer_, process.env.NODE_ENV !== "production" ? s.name_ + "." + bT(r) : "ObservableMap.key", !1);
      s.data_.set(r, b), a = b.value_, (y = s.hasMap_.get(r)) == null || y.setNewValue_(!0), s.keysAtom_.reportChanged();
    });
    var l = Fa(), p = Ql(this), h = p || l ? {
      observableKind: "map",
      debugObjectName: this.name_,
      type: $p,
      object: this,
      name: r,
      newValue: a
    } : null;
    process.env.NODE_ENV !== "production" && l && Zs(h), p && Zl(this, h), process.env.NODE_ENV !== "production" && l && Js();
  }, t.get = function(r) {
    return this.has(r) ? this.dehanceValue_(this.data_.get(r).get()) : this.dehanceValue_(void 0);
  }, t.dehanceValue_ = function(r) {
    return this.dehancer !== void 0 ? this.dehancer(r) : r;
  }, t.keys = function() {
    return this.keysAtom_.reportObserved(), this.data_.keys();
  }, t.values = function() {
    var r = this, a = this.keys();
    return pb({
      next: function() {
        var l = a.next(), p = l.done, h = l.value;
        return {
          done: p,
          value: p ? void 0 : r.get(h)
        };
      }
    });
  }, t.entries = function() {
    var r = this, a = this.keys();
    return pb({
      next: function() {
        var l = a.next(), p = l.done, h = l.value;
        return {
          done: p,
          value: p ? void 0 : [h, r.get(h)]
        };
      }
    });
  }, t[qI] = function() {
    return this.entries();
  }, t.forEach = function(r, a) {
    for (var s = Ym(this), l; !(l = s()).done; ) {
      var p = l.value, h = p[0], y = p[1];
      r.call(a, y, h, this);
    }
  }, t.merge = function(r) {
    var a = this;
    return Sd(r) && (r = new Map(r)), pd(function() {
      Qs(r) ? qV(r).forEach(function(s) {
        return a.set(s, r[s]);
      }) : Array.isArray(r) ? r.forEach(function(s) {
        var l = s[0], p = s[1];
        return a.set(l, p);
      }) : Cy(r) ? (r.constructor !== Map && xt(19, r), r.forEach(function(s, l) {
        return a.set(l, s);
      })) : r != null && xt(20, r);
    }), this;
  }, t.clear = function() {
    var r = this;
    pd(function() {
      RI(function() {
        for (var a = Ym(r.keys()), s; !(s = a()).done; ) {
          var l = s.value;
          r.delete(l);
        }
      });
    });
  }, t.replace = function(r) {
    var a = this;
    return pd(function() {
      for (var s = R4(r), l = /* @__PURE__ */ new Map(), p = !1, h = Ym(a.data_.keys()), y; !(y = h()).done; ) {
        var b = y.value;
        if (!s.has(b)) {
          var E = a.delete(b);
          if (E)
            p = !0;
          else {
            var x = a.data_.get(b);
            l.set(b, x);
          }
        }
      }
      for (var C = Ym(s.entries()), T; !(T = C()).done; ) {
        var O = T.value, D = O[0], A = O[1], B = a.data_.has(D);
        if (a.set(D, A), a.data_.has(D)) {
          var I = a.data_.get(D);
          l.set(D, I), B || (p = !0);
        }
      }
      if (!p)
        if (a.data_.size !== l.size)
          a.keysAtom_.reportChanged();
        else
          for (var L = a.data_.keys(), k = l.keys(), $ = L.next(), U = k.next(); !$.done; ) {
            if ($.value !== U.value) {
              a.keysAtom_.reportChanged();
              break;
            }
            $ = L.next(), U = k.next();
          }
      a.data_ = l;
    }), this;
  }, t.toString = function() {
    return "[object ObservableMap]";
  }, t.toJSON = function() {
    return Array.from(this);
  }, t.observe_ = function(r, a) {
    return process.env.NODE_ENV !== "production" && a === !0 && xt("`observe` doesn't support fireImmediately=true in combination with maps."), Lb(this, r);
  }, t.intercept_ = function(r) {
    return Ib(this, r);
  }, VO(e, [{
    key: "size",
    get: function() {
      return this.keysAtom_.reportObserved(), this.data_.size;
    }
  }, {
    key: XI,
    get: function() {
      return "Map";
    }
  }]), e;
}(), Sd = /* @__PURE__ */ tg("ObservableMap", KI);
function R4(e) {
  if (Cy(e) || Sd(e))
    return e;
  if (Array.isArray(e))
    return new Map(e);
  if (Qs(e)) {
    var t = /* @__PURE__ */ new Map();
    for (var n in e)
      t.set(n, e[n]);
    return t;
  } else
    return xt(21, e);
}
var QI, ZI, T4 = {};
QI = Symbol.iterator;
ZI = Symbol.toStringTag;
var JI = /* @__PURE__ */ function() {
  function e(n, r, a) {
    r === void 0 && (r = fy), a === void 0 && (a = process.env.NODE_ENV !== "production" ? "ObservableSet@" + ic() : "ObservableSet"), this.name_ = void 0, this[fn] = T4, this.data_ = /* @__PURE__ */ new Set(), this.atom_ = void 0, this.changeListeners_ = void 0, this.interceptors_ = void 0, this.dehancer = void 0, this.enhancer_ = void 0, this.name_ = a, Xi(Set) || xt(22), this.atom_ = WO(this.name_), this.enhancer_ = function(s, l) {
      return r(s, l, a);
    }, n && this.replace(n);
  }
  var t = e.prototype;
  return t.dehanceValue_ = function(r) {
    return this.dehancer !== void 0 ? this.dehancer(r) : r;
  }, t.clear = function() {
    var r = this;
    pd(function() {
      RI(function() {
        for (var a = Ym(r.data_.values()), s; !(s = a()).done; ) {
          var l = s.value;
          r.delete(l);
        }
      });
    });
  }, t.forEach = function(r, a) {
    for (var s = Ym(this), l; !(l = s()).done; ) {
      var p = l.value;
      r.call(a, p, p, this);
    }
  }, t.add = function(r) {
    var a = this;
    if (vy(this.atom_), Xu(this)) {
      var s = Ku(this, {
        type: $p,
        object: this,
        newValue: r
      });
      if (!s)
        return this;
    }
    if (!this.has(r)) {
      pd(function() {
        a.data_.add(a.enhancer_(r, void 0)), a.atom_.reportChanged();
      });
      var l = process.env.NODE_ENV !== "production" && Fa(), p = Ql(this), h = p || l ? {
        observableKind: "set",
        debugObjectName: this.name_,
        type: $p,
        object: this,
        newValue: r
      } : null;
      l && process.env.NODE_ENV !== "production" && Zs(h), p && Zl(this, h), l && process.env.NODE_ENV !== "production" && Js();
    }
    return this;
  }, t.delete = function(r) {
    var a = this;
    if (Xu(this)) {
      var s = Ku(this, {
        type: ix,
        object: this,
        oldValue: r
      });
      if (!s)
        return !1;
    }
    if (this.has(r)) {
      var l = process.env.NODE_ENV !== "production" && Fa(), p = Ql(this), h = p || l ? {
        observableKind: "set",
        debugObjectName: this.name_,
        type: ix,
        object: this,
        oldValue: r
      } : null;
      return l && process.env.NODE_ENV !== "production" && Zs(h), pd(function() {
        a.atom_.reportChanged(), a.data_.delete(r);
      }), p && Zl(this, h), l && process.env.NODE_ENV !== "production" && Js(), !0;
    }
    return !1;
  }, t.has = function(r) {
    return this.atom_.reportObserved(), this.data_.has(this.dehanceValue_(r));
  }, t.entries = function() {
    var r = 0, a = Array.from(this.keys()), s = Array.from(this.values());
    return pb({
      next: function() {
        var p = r;
        return r += 1, p < s.length ? {
          value: [a[p], s[p]],
          done: !1
        } : {
          done: !0
        };
      }
    });
  }, t.keys = function() {
    return this.values();
  }, t.values = function() {
    this.atom_.reportObserved();
    var r = this, a = 0, s = Array.from(this.data_.values());
    return pb({
      next: function() {
        return a < s.length ? {
          value: r.dehanceValue_(s[a++]),
          done: !1
        } : {
          done: !0
        };
      }
    });
  }, t.replace = function(r) {
    var a = this;
    return Ty(r) && (r = new Set(r)), pd(function() {
      Array.isArray(r) ? (a.clear(), r.forEach(function(s) {
        return a.add(s);
      })) : Db(r) ? (a.clear(), r.forEach(function(s) {
        return a.add(s);
      })) : r != null && xt("Cannot initialize set from " + r);
    }), this;
  }, t.observe_ = function(r, a) {
    return process.env.NODE_ENV !== "production" && a === !0 && xt("`observe` doesn't support fireImmediately=true in combination with sets."), Lb(this, r);
  }, t.intercept_ = function(r) {
    return Ib(this, r);
  }, t.toJSON = function() {
    return Array.from(this);
  }, t.toString = function() {
    return "[object ObservableSet]";
  }, t[QI] = function() {
    return this.values();
  }, VO(e, [{
    key: "size",
    get: function() {
      return this.atom_.reportObserved(), this.data_.size;
    }
  }, {
    key: ZI,
    get: function() {
      return "Set";
    }
  }]), e;
}(), Ty = /* @__PURE__ */ tg("ObservableSet", JI), cN = /* @__PURE__ */ Object.create(null), fN = "remove", wT = /* @__PURE__ */ function() {
  function e(n, r, a, s) {
    r === void 0 && (r = /* @__PURE__ */ new Map()), s === void 0 && (s = Ej), this.target_ = void 0, this.values_ = void 0, this.name_ = void 0, this.defaultAnnotation_ = void 0, this.keysAtom_ = void 0, this.changeListeners_ = void 0, this.interceptors_ = void 0, this.proxy_ = void 0, this.isPlainObject_ = void 0, this.appliedAnnotations_ = void 0, this.pendingKeys_ = void 0, this.target_ = n, this.values_ = r, this.name_ = a, this.defaultAnnotation_ = s, this.keysAtom_ = new Ab(process.env.NODE_ENV !== "production" ? this.name_ + ".keys" : "ObservableObject.keys"), this.isPlainObject_ = Qs(this.target_), process.env.NODE_ENV !== "production" && !rL(this.defaultAnnotation_) && xt("defaultAnnotation must be valid annotation"), process.env.NODE_ENV !== "production" && (this.appliedAnnotations_ = {});
  }
  var t = e.prototype;
  return t.getObservablePropValue_ = function(r) {
    return this.values_.get(r).get();
  }, t.setObservablePropValue_ = function(r, a) {
    var s = this.values_.get(r);
    if (s instanceof py)
      return s.set(a), !0;
    if (Xu(this)) {
      var l = Ku(this, {
        type: Kl,
        object: this.proxy_ || this.target_,
        name: r,
        newValue: a
      });
      if (!l)
        return null;
      a = l.newValue;
    }
    if (a = s.prepareNewValue_(a), a !== nt.UNCHANGED) {
      var p = Ql(this), h = process.env.NODE_ENV !== "production" && Fa(), y = p || h ? {
        type: Kl,
        observableKind: "object",
        debugObjectName: this.name_,
        object: this.proxy_ || this.target_,
        oldValue: s.value_,
        name: r,
        newValue: a
      } : null;
      process.env.NODE_ENV !== "production" && h && Zs(y), s.setNewValue_(a), p && Zl(this, y), process.env.NODE_ENV !== "production" && h && Js();
    }
    return !0;
  }, t.get_ = function(r) {
    return nt.trackingDerivation && !Zu(this.target_, r) && this.has_(r), this.target_[r];
  }, t.set_ = function(r, a, s) {
    return s === void 0 && (s = !1), Zu(this.target_, r) ? this.values_.has(r) ? this.setObservablePropValue_(r, a) : s ? Reflect.set(this.target_, r, a) : (this.target_[r] = a, !0) : this.extend_(r, {
      value: a,
      enumerable: !0,
      writable: !0,
      configurable: !0
    }, this.defaultAnnotation_, s);
  }, t.has_ = function(r) {
    if (!nt.trackingDerivation)
      return r in this.target_;
    this.pendingKeys_ || (this.pendingKeys_ = /* @__PURE__ */ new Map());
    var a = this.pendingKeys_.get(r);
    return a || (a = new ey(r in this.target_, Px, process.env.NODE_ENV !== "production" ? this.name_ + "." + bT(r) + "?" : "ObservableObject.key?", !1), this.pendingKeys_.set(r, a)), a.get();
  }, t.make_ = function(r, a) {
    if (a === !0 && (a = this.defaultAnnotation_), a !== !1) {
      if (vN(this, a, r), !(r in this.target_)) {
        var s;
        if ((s = this.target_[Co]) != null && s[r])
          return;
        xt(1, a.annotationType_, this.name_ + "." + r.toString());
      }
      for (var l = this.target_; l && l !== Mx; ) {
        var p = XE(l, r);
        if (p) {
          var h = a.make_(this, r, p, l);
          if (h === 0)
            return;
          if (h === 1)
            break;
        }
        l = Object.getPrototypeOf(l);
      }
      pN(this, a, r);
    }
  }, t.extend_ = function(r, a, s, l) {
    if (l === void 0 && (l = !1), s === !0 && (s = this.defaultAnnotation_), s === !1)
      return this.defineProperty_(r, a, l);
    vN(this, s, r);
    var p = s.extend_(this, r, a, l);
    return p && pN(this, s, r), p;
  }, t.defineProperty_ = function(r, a, s) {
    s === void 0 && (s = !1);
    try {
      ts();
      var l = this.delete_(r);
      if (!l)
        return l;
      if (Xu(this)) {
        var p = Ku(this, {
          object: this.proxy_ || this.target_,
          name: r,
          type: $p,
          newValue: a.value
        });
        if (!p)
          return null;
        var h = p.newValue;
        a.value !== h && (a = qp({}, a, {
          value: h
        }));
      }
      if (s) {
        if (!Reflect.defineProperty(this.target_, r, a))
          return !1;
      } else
        Zc(this.target_, r, a);
      this.notifyPropertyAddition_(r, a.value);
    } finally {
      ns();
    }
    return !0;
  }, t.defineObservableProperty_ = function(r, a, s, l) {
    l === void 0 && (l = !1);
    try {
      ts();
      var p = this.delete_(r);
      if (!p)
        return p;
      if (Xu(this)) {
        var h = Ku(this, {
          object: this.proxy_ || this.target_,
          name: r,
          type: $p,
          newValue: a
        });
        if (!h)
          return null;
        a = h.newValue;
      }
      var y = dN(r), b = {
        configurable: nt.safeDescriptors ? this.isPlainObject_ : !0,
        enumerable: !0,
        get: y.get,
        set: y.set
      };
      if (l) {
        if (!Reflect.defineProperty(this.target_, r, b))
          return !1;
      } else
        Zc(this.target_, r, b);
      var E = new ey(a, s, process.env.NODE_ENV !== "production" ? this.name_ + "." + r.toString() : "ObservableObject.key", !1);
      this.values_.set(r, E), this.notifyPropertyAddition_(r, E.value_);
    } finally {
      ns();
    }
    return !0;
  }, t.defineComputedProperty_ = function(r, a, s) {
    s === void 0 && (s = !1);
    try {
      ts();
      var l = this.delete_(r);
      if (!l)
        return l;
      if (Xu(this)) {
        var p = Ku(this, {
          object: this.proxy_ || this.target_,
          name: r,
          type: $p,
          newValue: void 0
        });
        if (!p)
          return null;
      }
      a.name || (a.name = process.env.NODE_ENV !== "production" ? this.name_ + "." + r.toString() : "ObservableObject.key"), a.context = this.proxy_ || this.target_;
      var h = dN(r), y = {
        configurable: nt.safeDescriptors ? this.isPlainObject_ : !0,
        enumerable: !1,
        get: h.get,
        set: h.set
      };
      if (s) {
        if (!Reflect.defineProperty(this.target_, r, y))
          return !1;
      } else
        Zc(this.target_, r, y);
      this.values_.set(r, new py(a)), this.notifyPropertyAddition_(r, void 0);
    } finally {
      ns();
    }
    return !0;
  }, t.delete_ = function(r, a) {
    if (a === void 0 && (a = !1), !Zu(this.target_, r))
      return !0;
    if (Xu(this)) {
      var s = Ku(this, {
        object: this.proxy_ || this.target_,
        name: r,
        type: fN
      });
      if (!s)
        return null;
    }
    try {
      var l, p;
      ts();
      var h = Ql(this), y = process.env.NODE_ENV !== "production" && Fa(), b = this.values_.get(r), E = void 0;
      if (!b && (h || y)) {
        var x;
        E = (x = XE(this.target_, r)) == null ? void 0 : x.value;
      }
      if (a) {
        if (!Reflect.deleteProperty(this.target_, r))
          return !1;
      } else
        delete this.target_[r];
      if (process.env.NODE_ENV !== "production" && delete this.appliedAnnotations_[r], b && (this.values_.delete(r), b instanceof ey && (E = b.value_), PI(b)), this.keysAtom_.reportChanged(), (l = this.pendingKeys_) == null || (p = l.get(r)) == null || p.set(r in this.target_), h || y) {
        var C = {
          type: fN,
          observableKind: "object",
          object: this.proxy_ || this.target_,
          debugObjectName: this.name_,
          oldValue: E,
          name: r
        };
        process.env.NODE_ENV !== "production" && y && Zs(C), h && Zl(this, C), process.env.NODE_ENV !== "production" && y && Js();
      }
    } finally {
      ns();
    }
    return !0;
  }, t.observe_ = function(r, a) {
    return process.env.NODE_ENV !== "production" && a === !0 && xt("`observe` doesn't support the fire immediately property for observable objects."), Lb(this, r);
  }, t.intercept_ = function(r) {
    return Ib(this, r);
  }, t.notifyPropertyAddition_ = function(r, a) {
    var s, l, p = Ql(this), h = process.env.NODE_ENV !== "production" && Fa();
    if (p || h) {
      var y = p || h ? {
        type: $p,
        observableKind: "object",
        debugObjectName: this.name_,
        object: this.proxy_ || this.target_,
        name: r,
        newValue: a
      } : null;
      process.env.NODE_ENV !== "production" && h && Zs(y), p && Zl(this, y), process.env.NODE_ENV !== "production" && h && Js();
    }
    (s = this.pendingKeys_) == null || (l = s.get(r)) == null || l.set(!0), this.keysAtom_.reportChanged();
  }, t.ownKeys_ = function() {
    return this.keysAtom_.reportObserved(), cy(this.target_);
  }, t.keys_ = function() {
    return this.keysAtom_.reportObserved(), Object.keys(this.target_);
  }, e;
}();
function zb(e, t) {
  var n;
  if (process.env.NODE_ENV !== "production" && t && Xh(e) && xt("Options can't be provided for already observable objects."), Zu(e, fn))
    return process.env.NODE_ENV !== "production" && !(XO(e) instanceof wT) && xt("Cannot convert '" + ax(e) + `' into observable object:
The target is already observable of different type.
Extending builtins is not supported.`), e;
  process.env.NODE_ENV !== "production" && !Object.isExtensible(e) && xt("Cannot make the designated object observable; it is not extensible");
  var r = (n = t == null ? void 0 : t.name) != null ? n : process.env.NODE_ENV !== "production" ? (Qs(e) ? "ObservableObject" : e.constructor.name) + "@" + ic() : "ObservableObject", a = new wT(e, /* @__PURE__ */ new Map(), String(r), Aj(t));
  return Ob(e, fn, a), e;
}
var O4 = /* @__PURE__ */ tg("ObservableObjectAdministration", wT);
function dN(e) {
  return cN[e] || (cN[e] = {
    get: function() {
      return this[fn].getObservablePropValue_(e);
    },
    set: function(n) {
      return this[fn].setObservablePropValue_(e, n);
    }
  });
}
function Xh(e) {
  return Ax(e) ? O4(e[fn]) : !1;
}
function pN(e, t, n) {
  var r;
  process.env.NODE_ENV !== "production" && (e.appliedAnnotations_[n] = t), (r = e.target_[Co]) == null || delete r[n];
}
function vN(e, t, n) {
  if (process.env.NODE_ENV !== "production" && !rL(t) && xt("Cannot annotate '" + e.name_ + "." + n.toString() + "': Invalid annotation."), process.env.NODE_ENV !== "production" && !ZE(t) && Zu(e.appliedAnnotations_, n)) {
    var r = e.name_ + "." + n.toString(), a = e.appliedAnnotations_[n].annotationType_, s = t.annotationType_;
    xt("Cannot apply '" + s + "' to '" + r + "':" + (`
The field is already annotated with '` + a + "'.") + `
Re-annotating fields is not allowed.
Use 'override' annotation for methods overridden by subclass.`);
  }
}
var D4 = /* @__PURE__ */ tL(0), IR = 0, eL = function() {
};
function M4(e, t) {
  Object.setPrototypeOf ? Object.setPrototypeOf(e.prototype, t) : e.prototype.__proto__ !== void 0 ? e.prototype.__proto__ = t : e.prototype = t;
}
M4(eL, Array.prototype);
var qO = /* @__PURE__ */ function(e, t, n) {
  cI(r, e);
  function r(s, l, p, h) {
    var y;
    p === void 0 && (p = process.env.NODE_ENV !== "production" ? "ObservableArray@" + ic() : "ObservableArray"), h === void 0 && (h = !1), y = e.call(this) || this;
    var b = new YO(p, l, h, !0);
    if (b.proxy_ = AE(y), sI(AE(y), fn, b), s && s.length) {
      var E = Nb(!0);
      y.spliceWithArray(0, 0, s), kb(E);
    }
    return Object.defineProperty(AE(y), "0", D4), y;
  }
  var a = r.prototype;
  return a.concat = function() {
    this[fn].atom_.reportObserved();
    for (var l = arguments.length, p = new Array(l), h = 0; h < l; h++)
      p[h] = arguments[h];
    return Array.prototype.concat.apply(
      this.slice(),
      p.map(function(y) {
        return Bb(y) ? y.slice() : y;
      })
    );
  }, a[n] = function() {
    var s = this, l = 0;
    return pb({
      next: function() {
        return l < s.length ? {
          value: s[l++],
          done: !1
        } : {
          done: !0,
          value: void 0
        };
      }
    });
  }, VO(r, [{
    key: "length",
    get: function() {
      return this[fn].getArrayLength_();
    },
    set: function(l) {
      this[fn].setArrayLength_(l);
    }
  }, {
    key: t,
    get: function() {
      return "Array";
    }
  }]), r;
}(eL, Symbol.toStringTag, Symbol.iterator);
Object.entries(rx).forEach(function(e) {
  var t = e[0], n = e[1];
  t !== "concat" && Ob(qO.prototype, t, n);
});
function tL(e) {
  return {
    enumerable: !1,
    configurable: !0,
    get: function() {
      return this[fn].get_(e);
    },
    set: function(n) {
      this[fn].set_(e, n);
    }
  };
}
function A4(e) {
  Zc(qO.prototype, "" + e, tL(e));
}
function nL(e) {
  if (e > IR) {
    for (var t = IR; t < e + 100; t++)
      A4(t);
    IR = e;
  }
}
nL(1e3);
function P4(e, t, n) {
  return new qO(e, t, n);
}
function Xp(e, t) {
  if (typeof e == "object" && e !== null) {
    if (Bb(e))
      return t !== void 0 && xt(23), e[fn].atom_;
    if (Ty(e))
      return e.atom_;
    if (Sd(e)) {
      if (t === void 0)
        return e.keysAtom_;
      var n = e.data_.get(t) || e.hasMap_.get(t);
      return n || xt(25, t, ax(e)), n;
    }
    if (Xh(e)) {
      if (!t)
        return xt(26);
      var r = e[fn].values_.get(t);
      return r || xt(27, t, ax(e)), r;
    }
    if (jO(e) || Ix(e) || tx(e))
      return e;
  } else if (Xi(e) && tx(e[fn]))
    return e[fn];
  xt(28);
}
function XO(e, t) {
  if (e || xt(29), t !== void 0)
    return XO(Xp(e, t));
  if (jO(e) || Ix(e) || tx(e) || Sd(e) || Ty(e))
    return e;
  if (e[fn])
    return e[fn];
  xt(24, e);
}
function ax(e, t) {
  var n;
  if (t !== void 0)
    n = Xp(e, t);
  else {
    if (Lx(e))
      return e.name;
    Xh(e) || Sd(e) || Ty(e) ? n = XO(e) : n = Xp(e);
  }
  return n.name_;
}
var hN = Mx.toString;
function KO(e, t, n) {
  return n === void 0 && (n = -1), CT(e, t, n);
}
function CT(e, t, n, r, a) {
  if (e === t)
    return e !== 0 || 1 / e === 1 / t;
  if (e == null || t == null)
    return !1;
  if (e !== e)
    return t !== t;
  var s = typeof e;
  if (s !== "function" && s !== "object" && typeof t != "object")
    return !1;
  var l = hN.call(e);
  if (l !== hN.call(t))
    return !1;
  switch (l) {
    case "[object RegExp]":
    case "[object String]":
      return "" + e == "" + t;
    case "[object Number]":
      return +e != +e ? +t != +t : +e == 0 ? 1 / +e === 1 / t : +e == +t;
    case "[object Date]":
    case "[object Boolean]":
      return +e == +t;
    case "[object Symbol]":
      return typeof Symbol < "u" && Symbol.valueOf.call(e) === Symbol.valueOf.call(t);
    case "[object Map]":
    case "[object Set]":
      n >= 0 && n++;
      break;
  }
  e = gN(e), t = gN(t);
  var p = l === "[object Array]";
  if (!p) {
    if (typeof e != "object" || typeof t != "object")
      return !1;
    var h = e.constructor, y = t.constructor;
    if (h !== y && !(Xi(h) && h instanceof h && Xi(y) && y instanceof y) && "constructor" in e && "constructor" in t)
      return !1;
  }
  if (n === 0)
    return !1;
  n < 0 && (n = -1), r = r || [], a = a || [];
  for (var b = r.length; b--; )
    if (r[b] === e)
      return a[b] === t;
  if (r.push(e), a.push(t), p) {
    if (b = e.length, b !== t.length)
      return !1;
    for (; b--; )
      if (!CT(e[b], t[b], n - 1, r, a))
        return !1;
  } else {
    var E = Object.keys(e), x;
    if (b = E.length, Object.keys(t).length !== b)
      return !1;
    for (; b--; )
      if (x = E[b], !(Zu(t, x) && CT(e[x], t[x], n - 1, r, a)))
        return !1;
  }
  return r.pop(), a.pop(), !0;
}
function gN(e) {
  return Bb(e) ? e.slice() : Cy(e) || Sd(e) || Db(e) || Ty(e) ? Array.from(e.entries()) : e;
}
function pb(e) {
  return e[Symbol.iterator] = N4, e;
}
function N4() {
  return this;
}
function rL(e) {
  return e instanceof Object && typeof e.annotationType_ == "string" && Xi(e.make_) && Xi(e.extend_);
}
["Symbol", "Map", "Set"].forEach(function(e) {
  var t = $O();
  typeof t[e] > "u" && xt("MobX requires global '" + e + "' to be available or polyfilled");
});
typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ == "object" && __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
  spy: Qj,
  extras: {
    getDebugName: ax
  },
  $mobx: fn
});
if (!L2)
  throw new Error("mobx-react-lite requires React with Hooks support");
if (!_4)
  throw new Error("mobx-react-lite@3 requires mobx at least version 6 to be available");
var Bx = { exports: {} }, Ws = {}, LR = { exports: {} }, BR = {};
/** @license React v0.20.2
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var mN;
function k4() {
  return mN || (mN = 1, function(e) {
    var t, n, r, a;
    if (typeof performance == "object" && typeof performance.now == "function") {
      var s = performance;
      e.unstable_now = function() {
        return s.now();
      };
    } else {
      var l = Date, p = l.now();
      e.unstable_now = function() {
        return l.now() - p;
      };
    }
    if (typeof window > "u" || typeof MessageChannel != "function") {
      var h = null, y = null, b = function() {
        if (h !== null)
          try {
            var ie = e.unstable_now();
            h(!0, ie), h = null;
          } catch (ce) {
            throw setTimeout(b, 0), ce;
          }
      };
      t = function(ie) {
        h !== null ? setTimeout(t, 0, ie) : (h = ie, setTimeout(b, 0));
      }, n = function(ie, ce) {
        y = setTimeout(ie, ce);
      }, r = function() {
        clearTimeout(y);
      }, e.unstable_shouldYield = function() {
        return !1;
      }, a = e.unstable_forceFrameRate = function() {
      };
    } else {
      var E = window.setTimeout, x = window.clearTimeout;
      if (typeof console < "u") {
        var C = window.cancelAnimationFrame;
        typeof window.requestAnimationFrame != "function" && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"), typeof C != "function" && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
      }
      var T = !1, O = null, D = -1, A = 5, B = 0;
      e.unstable_shouldYield = function() {
        return e.unstable_now() >= B;
      }, a = function() {
      }, e.unstable_forceFrameRate = function(ie) {
        0 > ie || 125 < ie ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : A = 0 < ie ? Math.floor(1e3 / ie) : 5;
      };
      var I = new MessageChannel(), L = I.port2;
      I.port1.onmessage = function() {
        if (O !== null) {
          var ie = e.unstable_now();
          B = ie + A;
          try {
            O(!0, ie) ? L.postMessage(null) : (T = !1, O = null);
          } catch (ce) {
            throw L.postMessage(null), ce;
          }
        } else
          T = !1;
      }, t = function(ie) {
        O = ie, T || (T = !0, L.postMessage(null));
      }, n = function(ie, ce) {
        D = E(function() {
          ie(e.unstable_now());
        }, ce);
      }, r = function() {
        x(D), D = -1;
      };
    }
    function k(ie, ce) {
      var le = ie.length;
      ie.push(ce);
      e:
        for (; ; ) {
          var fe = le - 1 >>> 1, ve = ie[fe];
          if (ve !== void 0 && 0 < K(ve, ce))
            ie[fe] = ce, ie[le] = ve, le = fe;
          else
            break e;
        }
    }
    function $(ie) {
      return ie = ie[0], ie === void 0 ? null : ie;
    }
    function U(ie) {
      var ce = ie[0];
      if (ce !== void 0) {
        var le = ie.pop();
        if (le !== ce) {
          ie[0] = le;
          e:
            for (var fe = 0, ve = ie.length; fe < ve; ) {
              var ee = 2 * (fe + 1) - 1, Ae = ie[ee], he = ee + 1, Fe = ie[he];
              if (Ae !== void 0 && 0 > K(Ae, le))
                Fe !== void 0 && 0 > K(Fe, Ae) ? (ie[fe] = Fe, ie[he] = le, fe = he) : (ie[fe] = Ae, ie[ee] = le, fe = ee);
              else if (Fe !== void 0 && 0 > K(Fe, le))
                ie[fe] = Fe, ie[he] = le, fe = he;
              else
                break e;
            }
        }
        return ce;
      }
      return null;
    }
    function K(ie, ce) {
      var le = ie.sortIndex - ce.sortIndex;
      return le !== 0 ? le : ie.id - ce.id;
    }
    var X = [], Y = [], J = 1, Q = null, Z = 3, se = !1, pe = !1, be = !1;
    function _e(ie) {
      for (var ce = $(Y); ce !== null; ) {
        if (ce.callback === null)
          U(Y);
        else if (ce.startTime <= ie)
          U(Y), ce.sortIndex = ce.expirationTime, k(X, ce);
        else
          break;
        ce = $(Y);
      }
    }
    function Se(ie) {
      if (be = !1, _e(ie), !pe)
        if ($(X) !== null)
          pe = !0, t(Oe);
        else {
          var ce = $(Y);
          ce !== null && n(Se, ce.startTime - ie);
        }
    }
    function Oe(ie, ce) {
      pe = !1, be && (be = !1, r()), se = !0;
      var le = Z;
      try {
        for (_e(ce), Q = $(X); Q !== null && (!(Q.expirationTime > ce) || ie && !e.unstable_shouldYield()); ) {
          var fe = Q.callback;
          if (typeof fe == "function") {
            Q.callback = null, Z = Q.priorityLevel;
            var ve = fe(Q.expirationTime <= ce);
            ce = e.unstable_now(), typeof ve == "function" ? Q.callback = ve : Q === $(X) && U(X), _e(ce);
          } else
            U(X);
          Q = $(X);
        }
        if (Q !== null)
          var ee = !0;
        else {
          var Ae = $(Y);
          Ae !== null && n(Se, Ae.startTime - ce), ee = !1;
        }
        return ee;
      } finally {
        Q = null, Z = le, se = !1;
      }
    }
    var re = a;
    e.unstable_IdlePriority = 5, e.unstable_ImmediatePriority = 1, e.unstable_LowPriority = 4, e.unstable_NormalPriority = 3, e.unstable_Profiling = null, e.unstable_UserBlockingPriority = 2, e.unstable_cancelCallback = function(ie) {
      ie.callback = null;
    }, e.unstable_continueExecution = function() {
      pe || se || (pe = !0, t(Oe));
    }, e.unstable_getCurrentPriorityLevel = function() {
      return Z;
    }, e.unstable_getFirstCallbackNode = function() {
      return $(X);
    }, e.unstable_next = function(ie) {
      switch (Z) {
        case 1:
        case 2:
        case 3:
          var ce = 3;
          break;
        default:
          ce = Z;
      }
      var le = Z;
      Z = ce;
      try {
        return ie();
      } finally {
        Z = le;
      }
    }, e.unstable_pauseExecution = function() {
    }, e.unstable_requestPaint = re, e.unstable_runWithPriority = function(ie, ce) {
      switch (ie) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          ie = 3;
      }
      var le = Z;
      Z = ie;
      try {
        return ce();
      } finally {
        Z = le;
      }
    }, e.unstable_scheduleCallback = function(ie, ce, le) {
      var fe = e.unstable_now();
      switch (typeof le == "object" && le !== null ? (le = le.delay, le = typeof le == "number" && 0 < le ? fe + le : fe) : le = fe, ie) {
        case 1:
          var ve = -1;
          break;
        case 2:
          ve = 250;
          break;
        case 5:
          ve = 1073741823;
          break;
        case 4:
          ve = 1e4;
          break;
        default:
          ve = 5e3;
      }
      return ve = le + ve, ie = { id: J++, callback: ce, priorityLevel: ie, startTime: le, expirationTime: ve, sortIndex: -1 }, le > fe ? (ie.sortIndex = le, k(Y, ie), $(X) === null && ie === $(Y) && (be ? r() : be = !0, n(Se, le - fe))) : (ie.sortIndex = ve, k(X, ie), pe || se || (pe = !0, t(Oe))), ie;
    }, e.unstable_wrapCallback = function(ie) {
      var ce = Z;
      return function() {
        var le = Z;
        Z = ce;
        try {
          return ie.apply(this, arguments);
        } finally {
          Z = le;
        }
      };
    };
  }(BR)), BR;
}
var zR = {};
/** @license React v0.20.2
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var yN;
function I4() {
  return yN || (yN = 1, function(e) {
    process.env.NODE_ENV !== "production" && function() {
      var t = !1, n = !1, r, a, s, l, p = typeof performance == "object" && typeof performance.now == "function";
      if (p) {
        var h = performance;
        e.unstable_now = function() {
          return h.now();
        };
      } else {
        var y = Date, b = y.now();
        e.unstable_now = function() {
          return y.now() - b;
        };
      }
      if (typeof window > "u" || typeof MessageChannel != "function") {
        var E = null, x = null, C = function() {
          if (E !== null)
            try {
              var at = e.unstable_now(), bt = !0;
              E(bt, at), E = null;
            } catch (Pt) {
              throw setTimeout(C, 0), Pt;
            }
        };
        r = function(at) {
          E !== null ? setTimeout(r, 0, at) : (E = at, setTimeout(C, 0));
        }, a = function(at, bt) {
          x = setTimeout(at, bt);
        }, s = function() {
          clearTimeout(x);
        }, e.unstable_shouldYield = function() {
          return !1;
        }, l = e.unstable_forceFrameRate = function() {
        };
      } else {
        var T = window.setTimeout, O = window.clearTimeout;
        if (typeof console < "u") {
          var D = window.requestAnimationFrame, A = window.cancelAnimationFrame;
          typeof D != "function" && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"), typeof A != "function" && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
        }
        var B = !1, I = null, L = -1, k = 5, $ = 0;
        e.unstable_shouldYield = function() {
          return e.unstable_now() >= $;
        }, l = function() {
        }, e.unstable_forceFrameRate = function(at) {
          if (at < 0 || at > 125) {
            console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported");
            return;
          }
          at > 0 ? k = Math.floor(1e3 / at) : k = 5;
        };
        var U = function() {
          if (I !== null) {
            var at = e.unstable_now();
            $ = at + k;
            var bt = !0;
            try {
              var Pt = I(bt, at);
              Pt ? X.postMessage(null) : (B = !1, I = null);
            } catch (dn) {
              throw X.postMessage(null), dn;
            }
          } else
            B = !1;
        }, K = new MessageChannel(), X = K.port2;
        K.port1.onmessage = U, r = function(at) {
          I = at, B || (B = !0, X.postMessage(null));
        }, a = function(at, bt) {
          L = T(function() {
            at(e.unstable_now());
          }, bt);
        }, s = function() {
          O(L), L = -1;
        };
      }
      function Y(at, bt) {
        var Pt = at.length;
        at.push(bt), Z(at, bt, Pt);
      }
      function J(at) {
        var bt = at[0];
        return bt === void 0 ? null : bt;
      }
      function Q(at) {
        var bt = at[0];
        if (bt !== void 0) {
          var Pt = at.pop();
          return Pt !== bt && (at[0] = Pt, se(at, Pt, 0)), bt;
        } else
          return null;
      }
      function Z(at, bt, Pt) {
        for (var dn = Pt; ; ) {
          var Nn = dn - 1 >>> 1, kn = at[Nn];
          if (kn !== void 0 && pe(kn, bt) > 0)
            at[Nn] = bt, at[dn] = kn, dn = Nn;
          else
            return;
        }
      }
      function se(at, bt, Pt) {
        for (var dn = Pt, Nn = at.length; dn < Nn; ) {
          var kn = (dn + 1) * 2 - 1, In = at[kn], Cr = kn + 1, Nt = at[Cr];
          if (In !== void 0 && pe(In, bt) < 0)
            Nt !== void 0 && pe(Nt, In) < 0 ? (at[dn] = Nt, at[Cr] = bt, dn = Cr) : (at[dn] = In, at[kn] = bt, dn = kn);
          else if (Nt !== void 0 && pe(Nt, bt) < 0)
            at[dn] = Nt, at[Cr] = bt, dn = Cr;
          else
            return;
        }
      }
      function pe(at, bt) {
        var Pt = at.sortIndex - bt.sortIndex;
        return Pt !== 0 ? Pt : at.id - bt.id;
      }
      var be = 1, _e = 2, Se = 3, Oe = 4, re = 5;
      function ie(at, bt) {
      }
      var ce = 1073741823, le = -1, fe = 250, ve = 5e3, ee = 1e4, Ae = ce, he = [], Fe = [], Ne = 1, xe = null, oe = Se, it = !1, Le = !1, qe = !1;
      function Tt(at) {
        for (var bt = J(Fe); bt !== null; ) {
          if (bt.callback === null)
            Q(Fe);
          else if (bt.startTime <= at)
            Q(Fe), bt.sortIndex = bt.expirationTime, Y(he, bt);
          else
            return;
          bt = J(Fe);
        }
      }
      function Qe(at) {
        if (qe = !1, Tt(at), !Le)
          if (J(he) !== null)
            Le = !0, r(pt);
          else {
            var bt = J(Fe);
            bt !== null && a(Qe, bt.startTime - at);
          }
      }
      function pt(at, bt) {
        Le = !1, qe && (qe = !1, s()), it = !0;
        var Pt = oe;
        try {
          var dn;
          if (!n)
            return en(at, bt);
        } finally {
          xe = null, oe = Pt, it = !1;
        }
      }
      function en(at, bt) {
        var Pt = bt;
        for (Tt(Pt), xe = J(he); xe !== null && !t && !(xe.expirationTime > Pt && (!at || e.unstable_shouldYield())); ) {
          var dn = xe.callback;
          if (typeof dn == "function") {
            xe.callback = null, oe = xe.priorityLevel;
            var Nn = xe.expirationTime <= Pt, kn = dn(Nn);
            Pt = e.unstable_now(), typeof kn == "function" ? xe.callback = kn : xe === J(he) && Q(he), Tt(Pt);
          } else
            Q(he);
          xe = J(he);
        }
        if (xe !== null)
          return !0;
        var In = J(Fe);
        return In !== null && a(Qe, In.startTime - Pt), !1;
      }
      function wt(at, bt) {
        switch (at) {
          case be:
          case _e:
          case Se:
          case Oe:
          case re:
            break;
          default:
            at = Se;
        }
        var Pt = oe;
        oe = at;
        try {
          return bt();
        } finally {
          oe = Pt;
        }
      }
      function tn(at) {
        var bt;
        switch (oe) {
          case be:
          case _e:
          case Se:
            bt = Se;
            break;
          default:
            bt = oe;
            break;
        }
        var Pt = oe;
        oe = bt;
        try {
          return at();
        } finally {
          oe = Pt;
        }
      }
      function Vn(at) {
        var bt = oe;
        return function() {
          var Pt = oe;
          oe = bt;
          try {
            return at.apply(this, arguments);
          } finally {
            oe = Pt;
          }
        };
      }
      function Kt(at, bt, Pt) {
        var dn = e.unstable_now(), Nn;
        if (typeof Pt == "object" && Pt !== null) {
          var kn = Pt.delay;
          typeof kn == "number" && kn > 0 ? Nn = dn + kn : Nn = dn;
        } else
          Nn = dn;
        var In;
        switch (at) {
          case be:
            In = le;
            break;
          case _e:
            In = fe;
            break;
          case re:
            In = Ae;
            break;
          case Oe:
            In = ee;
            break;
          case Se:
          default:
            In = ve;
            break;
        }
        var Cr = Nn + In, Nt = {
          id: Ne++,
          callback: bt,
          priorityLevel: at,
          startTime: Nn,
          expirationTime: Cr,
          sortIndex: -1
        };
        return Nn > dn ? (Nt.sortIndex = Nn, Y(Fe, Nt), J(he) === null && Nt === J(Fe) && (qe ? s() : qe = !0, a(Qe, Nn - dn))) : (Nt.sortIndex = Cr, Y(he, Nt), !Le && !it && (Le = !0, r(pt))), Nt;
      }
      function ft() {
      }
      function Gt() {
        !Le && !it && (Le = !0, r(pt));
      }
      function xn() {
        return J(he);
      }
      function gn(at) {
        at.callback = null;
      }
      function rr() {
        return oe;
      }
      var Zi = l, At = null;
      e.unstable_IdlePriority = re, e.unstable_ImmediatePriority = be, e.unstable_LowPriority = Oe, e.unstable_NormalPriority = Se, e.unstable_Profiling = At, e.unstable_UserBlockingPriority = _e, e.unstable_cancelCallback = gn, e.unstable_continueExecution = Gt, e.unstable_getCurrentPriorityLevel = rr, e.unstable_getFirstCallbackNode = xn, e.unstable_next = tn, e.unstable_pauseExecution = ft, e.unstable_requestPaint = Zi, e.unstable_runWithPriority = wt, e.unstable_scheduleCallback = Kt, e.unstable_wrapCallback = Vn;
    }();
  }(zR)), zR;
}
var bN;
function iL() {
  return bN || (bN = 1, function(e) {
    process.env.NODE_ENV === "production" ? e.exports = k4() : e.exports = I4();
  }(LR)), LR.exports;
}
/** @license React v17.0.2
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var _N;
function L4() {
  if (_N)
    return Ws;
  _N = 1;
  var e = Wt, t = Tb(), n = iL();
  function r(u) {
    for (var d = "https://reactjs.org/docs/error-decoder.html?invariant=" + u, m = 1; m < arguments.length; m++)
      d += "&args[]=" + encodeURIComponent(arguments[m]);
    return "Minified React error #" + u + "; visit " + d + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  if (!e)
    throw Error(r(227));
  var a = /* @__PURE__ */ new Set(), s = {};
  function l(u, d) {
    p(u, d), p(u + "Capture", d);
  }
  function p(u, d) {
    for (s[u] = d, u = 0; u < d.length; u++)
      a.add(d[u]);
  }
  var h = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), y = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, b = Object.prototype.hasOwnProperty, E = {}, x = {};
  function C(u) {
    return b.call(x, u) ? !0 : b.call(E, u) ? !1 : y.test(u) ? x[u] = !0 : (E[u] = !0, !1);
  }
  function T(u, d, m, w) {
    if (m !== null && m.type === 0)
      return !1;
    switch (typeof d) {
      case "function":
      case "symbol":
        return !0;
      case "boolean":
        return w ? !1 : m !== null ? !m.acceptsBooleans : (u = u.toLowerCase().slice(0, 5), u !== "data-" && u !== "aria-");
      default:
        return !1;
    }
  }
  function O(u, d, m, w) {
    if (d === null || typeof d > "u" || T(u, d, m, w))
      return !0;
    if (w)
      return !1;
    if (m !== null)
      switch (m.type) {
        case 3:
          return !d;
        case 4:
          return d === !1;
        case 5:
          return isNaN(d);
        case 6:
          return isNaN(d) || 1 > d;
      }
    return !1;
  }
  function D(u, d, m, w, M, F, H) {
    this.acceptsBooleans = d === 2 || d === 3 || d === 4, this.attributeName = w, this.attributeNamespace = M, this.mustUseProperty = m, this.propertyName = u, this.type = d, this.sanitizeURL = F, this.removeEmptyString = H;
  }
  var A = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(u) {
    A[u] = new D(u, 0, !1, u, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(u) {
    var d = u[0];
    A[d] = new D(d, 1, !1, u[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(u) {
    A[u] = new D(u, 2, !1, u.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(u) {
    A[u] = new D(u, 2, !1, u, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(u) {
    A[u] = new D(u, 3, !1, u.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function(u) {
    A[u] = new D(u, 3, !0, u, null, !1, !1);
  }), ["capture", "download"].forEach(function(u) {
    A[u] = new D(u, 4, !1, u, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function(u) {
    A[u] = new D(u, 6, !1, u, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function(u) {
    A[u] = new D(u, 5, !1, u.toLowerCase(), null, !1, !1);
  });
  var B = /[\-:]([a-z])/g;
  function I(u) {
    return u[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(u) {
    var d = u.replace(
      B,
      I
    );
    A[d] = new D(d, 1, !1, u, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(u) {
    var d = u.replace(B, I);
    A[d] = new D(d, 1, !1, u, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function(u) {
    var d = u.replace(B, I);
    A[d] = new D(d, 1, !1, u, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function(u) {
    A[u] = new D(u, 1, !1, u.toLowerCase(), null, !1, !1);
  }), A.xlinkHref = new D("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function(u) {
    A[u] = new D(u, 1, !1, u.toLowerCase(), null, !0, !0);
  });
  function L(u, d, m, w) {
    var M = A.hasOwnProperty(d) ? A[d] : null, F = M !== null ? M.type === 0 : w ? !1 : !(!(2 < d.length) || d[0] !== "o" && d[0] !== "O" || d[1] !== "n" && d[1] !== "N");
    F || (O(d, m, M, w) && (m = null), w || M === null ? C(d) && (m === null ? u.removeAttribute(d) : u.setAttribute(d, "" + m)) : M.mustUseProperty ? u[M.propertyName] = m === null ? M.type === 3 ? !1 : "" : m : (d = M.attributeName, w = M.attributeNamespace, m === null ? u.removeAttribute(d) : (M = M.type, m = M === 3 || M === 4 && m === !0 ? "" : "" + m, w ? u.setAttributeNS(w, d, m) : u.setAttribute(d, m))));
  }
  var k = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $ = 60103, U = 60106, K = 60107, X = 60108, Y = 60114, J = 60109, Q = 60110, Z = 60112, se = 60113, pe = 60120, be = 60115, _e = 60116, Se = 60121, Oe = 60128, re = 60129, ie = 60130, ce = 60131;
  if (typeof Symbol == "function" && Symbol.for) {
    var le = Symbol.for;
    $ = le("react.element"), U = le("react.portal"), K = le("react.fragment"), X = le("react.strict_mode"), Y = le("react.profiler"), J = le("react.provider"), Q = le("react.context"), Z = le("react.forward_ref"), se = le("react.suspense"), pe = le("react.suspense_list"), be = le("react.memo"), _e = le("react.lazy"), Se = le("react.block"), le("react.scope"), Oe = le("react.opaque.id"), re = le("react.debug_trace_mode"), ie = le("react.offscreen"), ce = le("react.legacy_hidden");
  }
  var fe = typeof Symbol == "function" && Symbol.iterator;
  function ve(u) {
    return u === null || typeof u != "object" ? null : (u = fe && u[fe] || u["@@iterator"], typeof u == "function" ? u : null);
  }
  var ee;
  function Ae(u) {
    if (ee === void 0)
      try {
        throw Error();
      } catch (m) {
        var d = m.stack.trim().match(/\n( *(at )?)/);
        ee = d && d[1] || "";
      }
    return `
` + ee + u;
  }
  var he = !1;
  function Fe(u, d) {
    if (!u || he)
      return "";
    he = !0;
    var m = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      if (d)
        if (d = function() {
          throw Error();
        }, Object.defineProperty(d.prototype, "props", { set: function() {
          throw Error();
        } }), typeof Reflect == "object" && Reflect.construct) {
          try {
            Reflect.construct(d, []);
          } catch (me) {
            var w = me;
          }
          Reflect.construct(u, [], d);
        } else {
          try {
            d.call();
          } catch (me) {
            w = me;
          }
          u.call(d.prototype);
        }
      else {
        try {
          throw Error();
        } catch (me) {
          w = me;
        }
        u();
      }
    } catch (me) {
      if (me && w && typeof me.stack == "string") {
        for (var M = me.stack.split(`
`), F = w.stack.split(`
`), H = M.length - 1, te = F.length - 1; 1 <= H && 0 <= te && M[H] !== F[te]; )
          te--;
        for (; 1 <= H && 0 <= te; H--, te--)
          if (M[H] !== F[te]) {
            if (H !== 1 || te !== 1)
              do
                if (H--, te--, 0 > te || M[H] !== F[te])
                  return `
` + M[H].replace(" at new ", " at ");
              while (1 <= H && 0 <= te);
            break;
          }
      }
    } finally {
      he = !1, Error.prepareStackTrace = m;
    }
    return (u = u ? u.displayName || u.name : "") ? Ae(u) : "";
  }
  function Ne(u) {
    switch (u.tag) {
      case 5:
        return Ae(u.type);
      case 16:
        return Ae("Lazy");
      case 13:
        return Ae("Suspense");
      case 19:
        return Ae("SuspenseList");
      case 0:
      case 2:
      case 15:
        return u = Fe(u.type, !1), u;
      case 11:
        return u = Fe(u.type.render, !1), u;
      case 22:
        return u = Fe(u.type._render, !1), u;
      case 1:
        return u = Fe(u.type, !0), u;
      default:
        return "";
    }
  }
  function xe(u) {
    if (u == null)
      return null;
    if (typeof u == "function")
      return u.displayName || u.name || null;
    if (typeof u == "string")
      return u;
    switch (u) {
      case K:
        return "Fragment";
      case U:
        return "Portal";
      case Y:
        return "Profiler";
      case X:
        return "StrictMode";
      case se:
        return "Suspense";
      case pe:
        return "SuspenseList";
    }
    if (typeof u == "object")
      switch (u.$$typeof) {
        case Q:
          return (u.displayName || "Context") + ".Consumer";
        case J:
          return (u._context.displayName || "Context") + ".Provider";
        case Z:
          var d = u.render;
          return d = d.displayName || d.name || "", u.displayName || (d !== "" ? "ForwardRef(" + d + ")" : "ForwardRef");
        case be:
          return xe(u.type);
        case Se:
          return xe(u._render);
        case _e:
          d = u._payload, u = u._init;
          try {
            return xe(u(d));
          } catch {
          }
      }
    return null;
  }
  function oe(u) {
    switch (typeof u) {
      case "boolean":
      case "number":
      case "object":
      case "string":
      case "undefined":
        return u;
      default:
        return "";
    }
  }
  function it(u) {
    var d = u.type;
    return (u = u.nodeName) && u.toLowerCase() === "input" && (d === "checkbox" || d === "radio");
  }
  function Le(u) {
    var d = it(u) ? "checked" : "value", m = Object.getOwnPropertyDescriptor(u.constructor.prototype, d), w = "" + u[d];
    if (!u.hasOwnProperty(d) && typeof m < "u" && typeof m.get == "function" && typeof m.set == "function") {
      var M = m.get, F = m.set;
      return Object.defineProperty(u, d, { configurable: !0, get: function() {
        return M.call(this);
      }, set: function(H) {
        w = "" + H, F.call(this, H);
      } }), Object.defineProperty(u, d, { enumerable: m.enumerable }), { getValue: function() {
        return w;
      }, setValue: function(H) {
        w = "" + H;
      }, stopTracking: function() {
        u._valueTracker = null, delete u[d];
      } };
    }
  }
  function qe(u) {
    u._valueTracker || (u._valueTracker = Le(u));
  }
  function Tt(u) {
    if (!u)
      return !1;
    var d = u._valueTracker;
    if (!d)
      return !0;
    var m = d.getValue(), w = "";
    return u && (w = it(u) ? u.checked ? "true" : "false" : u.value), u = w, u !== m ? (d.setValue(u), !0) : !1;
  }
  function Qe(u) {
    if (u = u || (typeof document < "u" ? document : void 0), typeof u > "u")
      return null;
    try {
      return u.activeElement || u.body;
    } catch {
      return u.body;
    }
  }
  function pt(u, d) {
    var m = d.checked;
    return t({}, d, { defaultChecked: void 0, defaultValue: void 0, value: void 0, checked: m != null ? m : u._wrapperState.initialChecked });
  }
  function en(u, d) {
    var m = d.defaultValue == null ? "" : d.defaultValue, w = d.checked != null ? d.checked : d.defaultChecked;
    m = oe(d.value != null ? d.value : m), u._wrapperState = { initialChecked: w, initialValue: m, controlled: d.type === "checkbox" || d.type === "radio" ? d.checked != null : d.value != null };
  }
  function wt(u, d) {
    d = d.checked, d != null && L(u, "checked", d, !1);
  }
  function tn(u, d) {
    wt(u, d);
    var m = oe(d.value), w = d.type;
    if (m != null)
      w === "number" ? (m === 0 && u.value === "" || u.value != m) && (u.value = "" + m) : u.value !== "" + m && (u.value = "" + m);
    else if (w === "submit" || w === "reset") {
      u.removeAttribute("value");
      return;
    }
    d.hasOwnProperty("value") ? Kt(u, d.type, m) : d.hasOwnProperty("defaultValue") && Kt(u, d.type, oe(d.defaultValue)), d.checked == null && d.defaultChecked != null && (u.defaultChecked = !!d.defaultChecked);
  }
  function Vn(u, d, m) {
    if (d.hasOwnProperty("value") || d.hasOwnProperty("defaultValue")) {
      var w = d.type;
      if (!(w !== "submit" && w !== "reset" || d.value !== void 0 && d.value !== null))
        return;
      d = "" + u._wrapperState.initialValue, m || d === u.value || (u.value = d), u.defaultValue = d;
    }
    m = u.name, m !== "" && (u.name = ""), u.defaultChecked = !!u._wrapperState.initialChecked, m !== "" && (u.name = m);
  }
  function Kt(u, d, m) {
    (d !== "number" || Qe(u.ownerDocument) !== u) && (m == null ? u.defaultValue = "" + u._wrapperState.initialValue : u.defaultValue !== "" + m && (u.defaultValue = "" + m));
  }
  function ft(u) {
    var d = "";
    return e.Children.forEach(u, function(m) {
      m != null && (d += m);
    }), d;
  }
  function Gt(u, d) {
    return u = t({ children: void 0 }, d), (d = ft(d.children)) && (u.children = d), u;
  }
  function xn(u, d, m, w) {
    if (u = u.options, d) {
      d = {};
      for (var M = 0; M < m.length; M++)
        d["$" + m[M]] = !0;
      for (m = 0; m < u.length; m++)
        M = d.hasOwnProperty("$" + u[m].value), u[m].selected !== M && (u[m].selected = M), M && w && (u[m].defaultSelected = !0);
    } else {
      for (m = "" + oe(m), d = null, M = 0; M < u.length; M++) {
        if (u[M].value === m) {
          u[M].selected = !0, w && (u[M].defaultSelected = !0);
          return;
        }
        d !== null || u[M].disabled || (d = u[M]);
      }
      d !== null && (d.selected = !0);
    }
  }
  function gn(u, d) {
    if (d.dangerouslySetInnerHTML != null)
      throw Error(r(91));
    return t({}, d, { value: void 0, defaultValue: void 0, children: "" + u._wrapperState.initialValue });
  }
  function rr(u, d) {
    var m = d.value;
    if (m == null) {
      if (m = d.children, d = d.defaultValue, m != null) {
        if (d != null)
          throw Error(r(92));
        if (Array.isArray(m)) {
          if (!(1 >= m.length))
            throw Error(r(93));
          m = m[0];
        }
        d = m;
      }
      d == null && (d = ""), m = d;
    }
    u._wrapperState = { initialValue: oe(m) };
  }
  function Zi(u, d) {
    var m = oe(d.value), w = oe(d.defaultValue);
    m != null && (m = "" + m, m !== u.value && (u.value = m), d.defaultValue == null && u.defaultValue !== m && (u.defaultValue = m)), w != null && (u.defaultValue = "" + w);
  }
  function At(u) {
    var d = u.textContent;
    d === u._wrapperState.initialValue && d !== "" && d !== null && (u.value = d);
  }
  var at = { html: "http://www.w3.org/1999/xhtml", mathml: "http://www.w3.org/1998/Math/MathML", svg: "http://www.w3.org/2000/svg" };
  function bt(u) {
    switch (u) {
      case "svg":
        return "http://www.w3.org/2000/svg";
      case "math":
        return "http://www.w3.org/1998/Math/MathML";
      default:
        return "http://www.w3.org/1999/xhtml";
    }
  }
  function Pt(u, d) {
    return u == null || u === "http://www.w3.org/1999/xhtml" ? bt(d) : u === "http://www.w3.org/2000/svg" && d === "foreignObject" ? "http://www.w3.org/1999/xhtml" : u;
  }
  var dn, Nn = function(u) {
    return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(d, m, w, M) {
      MSApp.execUnsafeLocalFunction(function() {
        return u(d, m, w, M);
      });
    } : u;
  }(function(u, d) {
    if (u.namespaceURI !== at.svg || "innerHTML" in u)
      u.innerHTML = d;
    else {
      for (dn = dn || document.createElement("div"), dn.innerHTML = "<svg>" + d.valueOf().toString() + "</svg>", d = dn.firstChild; u.firstChild; )
        u.removeChild(u.firstChild);
      for (; d.firstChild; )
        u.appendChild(d.firstChild);
    }
  });
  function kn(u, d) {
    if (d) {
      var m = u.firstChild;
      if (m && m === u.lastChild && m.nodeType === 3) {
        m.nodeValue = d;
        return;
      }
    }
    u.textContent = d;
  }
  var In = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  }, Cr = ["Webkit", "ms", "Moz", "O"];
  Object.keys(In).forEach(function(u) {
    Cr.forEach(function(d) {
      d = d + u.charAt(0).toUpperCase() + u.substring(1), In[d] = In[u];
    });
  });
  function Nt(u, d, m) {
    return d == null || typeof d == "boolean" || d === "" ? "" : m || typeof d != "number" || d === 0 || In.hasOwnProperty(u) && In[u] ? ("" + d).trim() : d + "px";
  }
  function jn(u, d) {
    u = u.style;
    for (var m in d)
      if (d.hasOwnProperty(m)) {
        var w = m.indexOf("--") === 0, M = Nt(m, d[m], w);
        m === "float" && (m = "cssFloat"), w ? u.setProperty(m, M) : u[m] = M;
      }
  }
  var ss = t({ menuitem: !0 }, { area: !0, base: !0, br: !0, col: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 });
  function Ji(u, d) {
    if (d) {
      if (ss[u] && (d.children != null || d.dangerouslySetInnerHTML != null))
        throw Error(r(137, u));
      if (d.dangerouslySetInnerHTML != null) {
        if (d.children != null)
          throw Error(r(60));
        if (!(typeof d.dangerouslySetInnerHTML == "object" && "__html" in d.dangerouslySetInnerHTML))
          throw Error(r(61));
      }
      if (d.style != null && typeof d.style != "object")
        throw Error(r(62));
    }
  }
  function so(u, d) {
    if (u.indexOf("-") === -1)
      return typeof d.is == "string";
    switch (u) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  function Ua(u) {
    return u = u.target || u.srcElement || window, u.correspondingUseElement && (u = u.correspondingUseElement), u.nodeType === 3 ? u.parentNode : u;
  }
  var uo = null, ea = null, ta = null;
  function us(u) {
    if (u = ai(u)) {
      if (typeof uo != "function")
        throw Error(r(280));
      var d = u.stateNode;
      d && (d = Ta(d), uo(u.stateNode, u.type, d));
    }
  }
  function Va(u) {
    ea ? ta ? ta.push(u) : ta = [u] : ea = u;
  }
  function il() {
    if (ea) {
      var u = ea, d = ta;
      if (ta = ea = null, us(u), d)
        for (u = 0; u < d.length; u++)
          us(d[u]);
    }
  }
  function de(u, d) {
    return u(d);
  }
  function tt(u, d, m, w, M) {
    return u(d, m, w, M);
  }
  function ct() {
  }
  var kt = de, mn = !1, zt = !1;
  function yn() {
    (ea !== null || ta !== null) && (ct(), il());
  }
  function Sn(u, d, m) {
    if (zt)
      return u(d, m);
    zt = !0;
    try {
      return kt(u, d, m);
    } finally {
      zt = !1, yn();
    }
  }
  function Kn(u, d) {
    var m = u.stateNode;
    if (m === null)
      return null;
    var w = Ta(m);
    if (w === null)
      return null;
    m = w[d];
    e:
      switch (d) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
          (w = !w.disabled) || (u = u.type, w = !(u === "button" || u === "input" || u === "select" || u === "textarea")), u = !w;
          break e;
        default:
          u = !1;
      }
    if (u)
      return null;
    if (m && typeof m != "function")
      throw Error(r(231, d, typeof m));
    return m;
  }
  var Fn = !1;
  if (h)
    try {
      var Qn = {};
      Object.defineProperty(Qn, "passive", { get: function() {
        Fn = !0;
      } }), window.addEventListener("test", Qn, Qn), window.removeEventListener("test", Qn, Qn);
    } catch {
      Fn = !1;
    }
  function Ea(u, d, m, w, M, F, H, te, me) {
    var ze = Array.prototype.slice.call(arguments, 3);
    try {
      d.apply(m, ze);
    } catch (vt) {
      this.onError(vt);
    }
  }
  var xa = !1, ru = null, Vi = !1, Td = null, ig = { onError: function(u) {
    xa = !0, ru = u;
  } };
  function ag(u, d, m, w, M, F, H, te, me) {
    xa = !1, ru = null, Ea.apply(ig, arguments);
  }
  function Sa(u, d, m, w, M, F, H, te, me) {
    if (ag.apply(this, arguments), xa) {
      if (xa) {
        var ze = ru;
        xa = !1, ru = null;
      } else
        throw Error(r(198));
      Vi || (Vi = !0, Td = ze);
    }
  }
  function Di(u) {
    var d = u, m = u;
    if (u.alternate)
      for (; d.return; )
        d = d.return;
    else {
      u = d;
      do
        d = u, (d.flags & 1026) !== 0 && (m = d.return), u = d.return;
      while (u);
    }
    return d.tag === 3 ? m : null;
  }
  function al(u) {
    if (u.tag === 13) {
      var d = u.memoizedState;
      if (d === null && (u = u.alternate, u !== null && (d = u.memoizedState)), d !== null)
        return d.dehydrated;
    }
    return null;
  }
  function Od(u) {
    if (Di(u) !== u)
      throw Error(r(188));
  }
  function iu(u) {
    var d = u.alternate;
    if (!d) {
      if (d = Di(u), d === null)
        throw Error(r(188));
      return d !== u ? null : u;
    }
    for (var m = u, w = d; ; ) {
      var M = m.return;
      if (M === null)
        break;
      var F = M.alternate;
      if (F === null) {
        if (w = M.return, w !== null) {
          m = w;
          continue;
        }
        break;
      }
      if (M.child === F.child) {
        for (F = M.child; F; ) {
          if (F === m)
            return Od(M), u;
          if (F === w)
            return Od(M), d;
          F = F.sibling;
        }
        throw Error(r(188));
      }
      if (m.return !== w.return)
        m = M, w = F;
      else {
        for (var H = !1, te = M.child; te; ) {
          if (te === m) {
            H = !0, m = M, w = F;
            break;
          }
          if (te === w) {
            H = !0, w = M, m = F;
            break;
          }
          te = te.sibling;
        }
        if (!H) {
          for (te = F.child; te; ) {
            if (te === m) {
              H = !0, m = F, w = M;
              break;
            }
            if (te === w) {
              H = !0, w = F, m = M;
              break;
            }
            te = te.sibling;
          }
          if (!H)
            throw Error(r(189));
        }
      }
      if (m.alternate !== w)
        throw Error(r(190));
    }
    if (m.tag !== 3)
      throw Error(r(188));
    return m.stateNode.current === m ? u : d;
  }
  function Dd(u) {
    if (u = iu(u), !u)
      return null;
    for (var d = u; ; ) {
      if (d.tag === 5 || d.tag === 6)
        return d;
      if (d.child)
        d.child.return = d, d = d.child;
      else {
        if (d === u)
          break;
        for (; !d.sibling; ) {
          if (!d.return || d.return === u)
            return null;
          d = d.return;
        }
        d.sibling.return = d.return, d = d.sibling;
      }
    }
    return null;
  }
  function oc(u, d) {
    for (var m = u.alternate; d !== null; ) {
      if (d === u || d === m)
        return !0;
      d = d.return;
    }
    return !1;
  }
  var av, sc, og, uc, ov = !1, ja = [], ls = null, To = null, cs = null, au = /* @__PURE__ */ new Map(), dt = /* @__PURE__ */ new Map(), ol = [], ri = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
  function fs(u, d, m, w, M) {
    return { blockedOn: u, domEventName: d, eventSystemFlags: m | 16, nativeEvent: M, targetContainers: [w] };
  }
  function lc(u, d) {
    switch (u) {
      case "focusin":
      case "focusout":
        ls = null;
        break;
      case "dragenter":
      case "dragleave":
        To = null;
        break;
      case "mouseover":
      case "mouseout":
        cs = null;
        break;
      case "pointerover":
      case "pointerout":
        au.delete(d.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        dt.delete(d.pointerId);
    }
  }
  function cc(u, d, m, w, M, F) {
    return u === null || u.nativeEvent !== F ? (u = fs(d, m, w, M, F), d !== null && (d = ai(d), d !== null && sc(d)), u) : (u.eventSystemFlags |= w, d = u.targetContainers, M !== null && d.indexOf(M) === -1 && d.push(M), u);
  }
  function ji(u, d, m, w, M) {
    switch (d) {
      case "focusin":
        return ls = cc(ls, u, d, m, w, M), !0;
      case "dragenter":
        return To = cc(To, u, d, m, w, M), !0;
      case "mouseover":
        return cs = cc(cs, u, d, m, w, M), !0;
      case "pointerover":
        var F = M.pointerId;
        return au.set(F, cc(au.get(F) || null, u, d, m, w, M)), !0;
      case "gotpointercapture":
        return F = M.pointerId, dt.set(F, cc(dt.get(F) || null, u, d, m, w, M)), !0;
    }
    return !1;
  }
  function $r(u) {
    var d = Es(u.target);
    if (d !== null) {
      var m = Di(d);
      if (m !== null) {
        if (d = m.tag, d === 13) {
          if (d = al(m), d !== null) {
            u.blockedOn = d, uc(u.lanePriority, function() {
              n.unstable_runWithPriority(u.priority, function() {
                og(m);
              });
            });
            return;
          }
        } else if (d === 3 && m.stateNode.hydrate) {
          u.blockedOn = m.tag === 3 ? m.stateNode.containerInfo : null;
          return;
        }
      }
    }
    u.blockedOn = null;
  }
  function wa(u) {
    if (u.blockedOn !== null)
      return !1;
    for (var d = u.targetContainers; 0 < d.length; ) {
      var m = cf(u.domEventName, u.eventSystemFlags, d[0], u.nativeEvent);
      if (m !== null)
        return d = ai(m), d !== null && sc(d), u.blockedOn = m, !1;
      d.shift();
    }
    return !0;
  }
  function sv(u, d, m) {
    wa(u) && m.delete(d);
  }
  function na() {
    for (ov = !1; 0 < ja.length; ) {
      var u = ja[0];
      if (u.blockedOn !== null) {
        u = ai(u.blockedOn), u !== null && av(u);
        break;
      }
      for (var d = u.targetContainers; 0 < d.length; ) {
        var m = cf(u.domEventName, u.eventSystemFlags, d[0], u.nativeEvent);
        if (m !== null) {
          u.blockedOn = m;
          break;
        }
        d.shift();
      }
      u.blockedOn === null && ja.shift();
    }
    ls !== null && wa(ls) && (ls = null), To !== null && wa(To) && (To = null), cs !== null && wa(cs) && (cs = null), au.forEach(sv), dt.forEach(sv);
  }
  function ra(u, d) {
    u.blockedOn === d && (u.blockedOn = null, ov || (ov = !0, n.unstable_scheduleCallback(n.unstable_NormalPriority, na)));
  }
  function sl(u) {
    function d(M) {
      return ra(M, u);
    }
    if (0 < ja.length) {
      ra(ja[0], u);
      for (var m = 1; m < ja.length; m++) {
        var w = ja[m];
        w.blockedOn === u && (w.blockedOn = null);
      }
    }
    for (ls !== null && ra(ls, u), To !== null && ra(To, u), cs !== null && ra(cs, u), au.forEach(d), dt.forEach(d), m = 0; m < ol.length; m++)
      w = ol[m], w.blockedOn === u && (w.blockedOn = null);
    for (; 0 < ol.length && (m = ol[0], m.blockedOn === null); )
      $r(m), m.blockedOn === null && ol.shift();
  }
  function ul(u, d) {
    var m = {};
    return m[u.toLowerCase()] = d.toLowerCase(), m["Webkit" + u] = "webkit" + d, m["Moz" + u] = "moz" + d, m;
  }
  var ou = { animationend: ul("Animation", "AnimationEnd"), animationiteration: ul("Animation", "AnimationIteration"), animationstart: ul("Animation", "AnimationStart"), transitionend: ul("Transition", "TransitionEnd") }, Md = {}, uv = {};
  h && (uv = document.createElement("div").style, "AnimationEvent" in window || (delete ou.animationend.animation, delete ou.animationiteration.animation, delete ou.animationstart.animation), "TransitionEvent" in window || delete ou.transitionend.transition);
  function af(u) {
    if (Md[u])
      return Md[u];
    if (!ou[u])
      return u;
    var d = ou[u], m;
    for (m in d)
      if (d.hasOwnProperty(m) && m in uv)
        return Md[u] = d[m];
    return u;
  }
  var lv = af("animationend"), fc = af("animationiteration"), cv = af("animationstart"), of = af("transitionend"), fv = /* @__PURE__ */ new Map(), sf = /* @__PURE__ */ new Map(), sg = [
    "abort",
    "abort",
    lv,
    "animationEnd",
    fc,
    "animationIteration",
    cv,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    of,
    "transitionEnd",
    "waiting",
    "waiting"
  ];
  function Ad(u, d) {
    for (var m = 0; m < u.length; m += 2) {
      var w = u[m], M = u[m + 1];
      M = "on" + (M[0].toUpperCase() + M.slice(1)), sf.set(w, d), fv.set(w, M), l(M, [w]);
    }
  }
  var ug = n.unstable_now;
  ug();
  var Wn = 8;
  function ds(u) {
    if ((1 & u) !== 0)
      return Wn = 15, 1;
    if ((2 & u) !== 0)
      return Wn = 14, 2;
    if ((4 & u) !== 0)
      return Wn = 13, 4;
    var d = 24 & u;
    return d !== 0 ? (Wn = 12, d) : (u & 32) !== 0 ? (Wn = 11, 32) : (d = 192 & u, d !== 0 ? (Wn = 10, d) : (u & 256) !== 0 ? (Wn = 9, 256) : (d = 3584 & u, d !== 0 ? (Wn = 8, d) : (u & 4096) !== 0 ? (Wn = 7, 4096) : (d = 4186112 & u, d !== 0 ? (Wn = 6, d) : (d = 62914560 & u, d !== 0 ? (Wn = 5, d) : u & 67108864 ? (Wn = 4, 67108864) : (u & 134217728) !== 0 ? (Wn = 3, 134217728) : (d = 805306368 & u, d !== 0 ? (Wn = 2, d) : (1073741824 & u) !== 0 ? (Wn = 1, 1073741824) : (Wn = 8, u))))));
  }
  function lg(u) {
    switch (u) {
      case 99:
        return 15;
      case 98:
        return 10;
      case 97:
      case 96:
        return 8;
      case 95:
        return 2;
      default:
        return 0;
    }
  }
  function dv(u) {
    switch (u) {
      case 15:
      case 14:
        return 99;
      case 13:
      case 12:
      case 11:
      case 10:
        return 98;
      case 9:
      case 8:
      case 7:
      case 6:
      case 4:
      case 5:
        return 97;
      case 3:
      case 2:
      case 1:
        return 95;
      case 0:
        return 90;
      default:
        throw Error(r(358, u));
    }
  }
  function dc(u, d) {
    var m = u.pendingLanes;
    if (m === 0)
      return Wn = 0;
    var w = 0, M = 0, F = u.expiredLanes, H = u.suspendedLanes, te = u.pingedLanes;
    if (F !== 0)
      w = F, M = Wn = 15;
    else if (F = m & 134217727, F !== 0) {
      var me = F & ~H;
      me !== 0 ? (w = ds(me), M = Wn) : (te &= F, te !== 0 && (w = ds(te), M = Wn));
    } else
      F = m & ~H, F !== 0 ? (w = ds(F), M = Wn) : te !== 0 && (w = ds(te), M = Wn);
    if (w === 0)
      return 0;
    if (w = 31 - su(w), w = m & ((0 > w ? 0 : 1 << w) << 1) - 1, d !== 0 && d !== w && (d & H) === 0) {
      if (ds(d), M <= Wn)
        return d;
      Wn = M;
    }
    if (d = u.entangledLanes, d !== 0)
      for (u = u.entanglements, d &= w; 0 < d; )
        m = 31 - su(d), M = 1 << m, w |= u[m], d &= ~M;
    return w;
  }
  function cg(u) {
    return u = u.pendingLanes & -1073741825, u !== 0 ? u : u & 1073741824 ? 1073741824 : 0;
  }
  function Pd(u, d) {
    switch (u) {
      case 15:
        return 1;
      case 14:
        return 2;
      case 12:
        return u = Dn(24 & ~d), u === 0 ? Pd(10, d) : u;
      case 10:
        return u = Dn(192 & ~d), u === 0 ? Pd(8, d) : u;
      case 8:
        return u = Dn(3584 & ~d), u === 0 && (u = Dn(4186112 & ~d), u === 0 && (u = 512)), u;
      case 2:
        return d = Dn(805306368 & ~d), d === 0 && (d = 268435456), d;
    }
    throw Error(r(358, u));
  }
  function Dn(u) {
    return u & -u;
  }
  function $n(u) {
    for (var d = [], m = 0; 31 > m; m++)
      d.push(u);
    return d;
  }
  function uf(u, d, m) {
    u.pendingLanes |= d;
    var w = d - 1;
    u.suspendedLanes &= w, u.pingedLanes &= w, u = u.eventTimes, d = 31 - su(d), u[d] = m;
  }
  var su = Math.clz32 ? Math.clz32 : pv, fg = Math.log, Iy = Math.LN2;
  function pv(u) {
    return u === 0 ? 32 : 31 - (fg(u) / Iy | 0) | 0;
  }
  var vv = n.unstable_UserBlockingPriority, hv = n.unstable_runWithPriority, lf = !0;
  function yi(u, d, m, w) {
    mn || ct();
    var M = lo, F = mn;
    mn = !0;
    try {
      tt(M, u, d, m, w);
    } finally {
      (mn = F) || yn();
    }
  }
  function uu(u, d, m, w) {
    hv(vv, lo.bind(null, u, d, m, w));
  }
  function lo(u, d, m, w) {
    if (lf) {
      var M;
      if ((M = (d & 4) === 0) && 0 < ja.length && -1 < ri.indexOf(u))
        u = fs(null, u, d, m, w), ja.push(u);
      else {
        var F = cf(u, d, m, w);
        if (F === null)
          M && lc(u, w);
        else {
          if (M) {
            if (-1 < ri.indexOf(u)) {
              u = fs(F, u, d, m, w), ja.push(u);
              return;
            }
            if (ji(F, u, d, m, w))
              return;
            lc(u, w);
          }
          yf(u, d, w, null, m);
        }
      }
    }
  }
  function cf(u, d, m, w) {
    var M = Ua(w);
    if (M = Es(M), M !== null) {
      var F = Di(M);
      if (F === null)
        M = null;
      else {
        var H = F.tag;
        if (H === 13) {
          if (M = al(F), M !== null)
            return M;
          M = null;
        } else if (H === 3) {
          if (F.stateNode.hydrate)
            return F.tag === 3 ? F.stateNode.containerInfo : null;
          M = null;
        } else
          F !== M && (M = null);
      }
    }
    return yf(u, d, w, M, m), null;
  }
  var Oo = null, ia = null, ff = null;
  function Nd() {
    if (ff)
      return ff;
    var u, d = ia, m = d.length, w, M = "value" in Oo ? Oo.value : Oo.textContent, F = M.length;
    for (u = 0; u < m && d[u] === M[u]; u++)
      ;
    var H = m - u;
    for (w = 1; w <= H && d[m - w] === M[F - w]; w++)
      ;
    return ff = M.slice(u, 1 < w ? 1 - w : void 0);
  }
  function ll(u) {
    var d = u.keyCode;
    return "charCode" in u ? (u = u.charCode, u === 0 && d === 13 && (u = 13)) : u = d, u === 10 && (u = 13), 32 <= u || u === 13 ? u : 0;
  }
  function pc() {
    return !0;
  }
  function kd() {
    return !1;
  }
  function Wi(u) {
    function d(m, w, M, F, H) {
      this._reactName = m, this._targetInst = M, this.type = w, this.nativeEvent = F, this.target = H, this.currentTarget = null;
      for (var te in u)
        u.hasOwnProperty(te) && (m = u[te], this[te] = m ? m(F) : F[te]);
      return this.isDefaultPrevented = (F.defaultPrevented != null ? F.defaultPrevented : F.returnValue === !1) ? pc : kd, this.isPropagationStopped = kd, this;
    }
    return t(d.prototype, { preventDefault: function() {
      this.defaultPrevented = !0;
      var m = this.nativeEvent;
      m && (m.preventDefault ? m.preventDefault() : typeof m.returnValue != "unknown" && (m.returnValue = !1), this.isDefaultPrevented = pc);
    }, stopPropagation: function() {
      var m = this.nativeEvent;
      m && (m.stopPropagation ? m.stopPropagation() : typeof m.cancelBubble != "unknown" && (m.cancelBubble = !0), this.isPropagationStopped = pc);
    }, persist: function() {
    }, isPersistent: pc }), d;
  }
  var ii = { eventPhase: 0, bubbles: 0, cancelable: 0, timeStamp: function(u) {
    return u.timeStamp || Date.now();
  }, defaultPrevented: 0, isTrusted: 0 }, vc = Wi(ii), bi = t({}, ii, { view: 0, detail: 0 }), gv = Wi(bi), df, Wa, Do, hc = t({}, bi, { screenX: 0, screenY: 0, clientX: 0, clientY: 0, pageX: 0, pageY: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, getModifierState: pf, button: 0, buttons: 0, relatedTarget: function(u) {
    return u.relatedTarget === void 0 ? u.fromElement === u.srcElement ? u.toElement : u.fromElement : u.relatedTarget;
  }, movementX: function(u) {
    return "movementX" in u ? u.movementX : (u !== Do && (Do && u.type === "mousemove" ? (df = u.screenX - Do.screenX, Wa = u.screenY - Do.screenY) : Wa = df = 0, Do = u), df);
  }, movementY: function(u) {
    return "movementY" in u ? u.movementY : Wa;
  } }), Gn = Wi(hc), ps = t({}, hc, { dataTransfer: 0 }), aa = Wi(ps), vs = t({}, bi, { relatedTarget: 0 }), _i = Wi(vs), lu = t({}, ii, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }), dg = Wi(lu), Id = t({}, ii, { clipboardData: function(u) {
    return "clipboardData" in u ? u.clipboardData : window.clipboardData;
  } }), pg = Wi(Id), cu = t({}, ii, { data: 0 }), cl = Wi(cu), Ly = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  }, Ld = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, vg = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };
  function mv(u) {
    var d = this.nativeEvent;
    return d.getModifierState ? d.getModifierState(u) : (u = vg[u]) ? !!d[u] : !1;
  }
  function pf() {
    return mv;
  }
  var yv = t({}, bi, { key: function(u) {
    if (u.key) {
      var d = Ly[u.key] || u.key;
      if (d !== "Unidentified")
        return d;
    }
    return u.type === "keypress" ? (u = ll(u), u === 13 ? "Enter" : String.fromCharCode(u)) : u.type === "keydown" || u.type === "keyup" ? Ld[u.keyCode] || "Unidentified" : "";
  }, code: 0, location: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, repeat: 0, locale: 0, getModifierState: pf, charCode: function(u) {
    return u.type === "keypress" ? ll(u) : 0;
  }, keyCode: function(u) {
    return u.type === "keydown" || u.type === "keyup" ? u.keyCode : 0;
  }, which: function(u) {
    return u.type === "keypress" ? ll(u) : u.type === "keydown" || u.type === "keyup" ? u.keyCode : 0;
  } }), By = Wi(yv), bv = t({}, hc, { pointerId: 0, width: 0, height: 0, pressure: 0, tangentialPressure: 0, tiltX: 0, tiltY: 0, twist: 0, pointerType: 0, isPrimary: 0 }), Bd = Wi(bv), hg = t({}, bi, { touches: 0, targetTouches: 0, changedTouches: 0, altKey: 0, metaKey: 0, ctrlKey: 0, shiftKey: 0, getModifierState: pf }), fl = Wi(hg), Gi = t({}, ii, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }), zd = Wi(Gi), gc = t({}, hc, {
    deltaX: function(u) {
      return "deltaX" in u ? u.deltaX : "wheelDeltaX" in u ? -u.wheelDeltaX : 0;
    },
    deltaY: function(u) {
      return "deltaY" in u ? u.deltaY : "wheelDeltaY" in u ? -u.wheelDeltaY : "wheelDelta" in u ? -u.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }), gg = Wi(gc), mg = [9, 13, 27, 32], _v = h && "CompositionEvent" in window, vf = null;
  h && "documentMode" in document && (vf = document.documentMode);
  var zy = h && "TextEvent" in window && !vf, yg = h && (!_v || vf && 8 < vf && 11 >= vf), bg = String.fromCharCode(32), dl = !1;
  function Ev(u, d) {
    switch (u) {
      case "keyup":
        return mg.indexOf(d.keyCode) !== -1;
      case "keydown":
        return d.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function _g(u) {
    return u = u.detail, typeof u == "object" && "data" in u ? u.data : null;
  }
  var hs = !1;
  function Eg(u, d) {
    switch (u) {
      case "compositionend":
        return _g(d);
      case "keypress":
        return d.which !== 32 ? null : (dl = !0, bg);
      case "textInput":
        return u = d.data, u === bg && dl ? null : u;
      default:
        return null;
    }
  }
  function fu(u, d) {
    if (hs)
      return u === "compositionend" || !_v && Ev(u, d) ? (u = Nd(), ff = ia = Oo = null, hs = !1, u) : null;
    switch (u) {
      case "paste":
        return null;
      case "keypress":
        if (!(d.ctrlKey || d.altKey || d.metaKey) || d.ctrlKey && d.altKey) {
          if (d.char && 1 < d.char.length)
            return d.char;
          if (d.which)
            return String.fromCharCode(d.which);
        }
        return null;
      case "compositionend":
        return yg && d.locale !== "ko" ? null : d.data;
      default:
        return null;
    }
  }
  var Fd = { color: !0, date: !0, datetime: !0, "datetime-local": !0, email: !0, month: !0, number: !0, password: !0, range: !0, search: !0, tel: !0, text: !0, time: !0, url: !0, week: !0 };
  function xg(u) {
    var d = u && u.nodeName && u.nodeName.toLowerCase();
    return d === "input" ? !!Fd[u.type] : d === "textarea";
  }
  function $d(u, d, m, w) {
    Va(w), d = ko(d, "onChange"), 0 < d.length && (m = new vc("onChange", "change", null, m, w), u.push({ event: m, listeners: d }));
  }
  var co = null, Ca = null;
  function Ga(u) {
    gl(u, 0);
  }
  function Mo(u) {
    var d = Qr(u);
    if (Tt(d))
      return u;
  }
  function Fy(u, d) {
    if (u === "change")
      return d;
  }
  var Sg = !1;
  if (h) {
    var xv;
    if (h) {
      var Sv = "oninput" in document;
      if (!Sv) {
        var wg = document.createElement("div");
        wg.setAttribute("oninput", "return;"), Sv = typeof wg.oninput == "function";
      }
      xv = Sv;
    } else
      xv = !1;
    Sg = xv && (!document.documentMode || 9 < document.documentMode);
  }
  function pl() {
    co && (co.detachEvent("onpropertychange", Ce), Ca = co = null);
  }
  function Ce(u) {
    if (u.propertyName === "value" && Mo(Ca)) {
      var d = [];
      if ($d(d, Ca, u, Ua(u)), u = Ga, mn)
        u(d);
      else {
        mn = !0;
        try {
          de(u, d);
        } finally {
          mn = !1, yn();
        }
      }
    }
  }
  function $e(u, d, m) {
    u === "focusin" ? (pl(), co = d, Ca = m, co.attachEvent("onpropertychange", Ce)) : u === "focusout" && pl();
  }
  function Be(u) {
    if (u === "selectionchange" || u === "keyup" || u === "keydown")
      return Mo(Ca);
  }
  function ot(u, d) {
    if (u === "click")
      return Mo(d);
  }
  function an(u, d) {
    if (u === "input" || u === "change")
      return Mo(d);
  }
  function Mn(u, d) {
    return u === d && (u !== 0 || 1 / u === 1 / d) || u !== u && d !== d;
  }
  var Ln = typeof Object.is == "function" ? Object.is : Mn, Zn = Object.prototype.hasOwnProperty;
  function vl(u, d) {
    if (Ln(u, d))
      return !0;
    if (typeof u != "object" || u === null || typeof d != "object" || d === null)
      return !1;
    var m = Object.keys(u), w = Object.keys(d);
    if (m.length !== w.length)
      return !1;
    for (w = 0; w < m.length; w++)
      if (!Zn.call(d, m[w]) || !Ln(u[m[w]], d[m[w]]))
        return !1;
    return !0;
  }
  function Cg(u) {
    for (; u && u.firstChild; )
      u = u.firstChild;
    return u;
  }
  function Ra(u, d) {
    var m = Cg(u);
    u = 0;
    for (var w; m; ) {
      if (m.nodeType === 3) {
        if (w = u + m.textContent.length, u <= d && w >= d)
          return { node: m, offset: d - u };
        u = w;
      }
      e: {
        for (; m; ) {
          if (m.nextSibling) {
            m = m.nextSibling;
            break e;
          }
          m = m.parentNode;
        }
        m = void 0;
      }
      m = Cg(m);
    }
  }
  function mc(u, d) {
    return u && d ? u === d ? !0 : u && u.nodeType === 3 ? !1 : d && d.nodeType === 3 ? mc(u, d.parentNode) : "contains" in u ? u.contains(d) : u.compareDocumentPosition ? !!(u.compareDocumentPosition(d) & 16) : !1 : !1;
  }
  function hf() {
    for (var u = window, d = Qe(); d instanceof u.HTMLIFrameElement; ) {
      try {
        var m = typeof d.contentWindow.location.href == "string";
      } catch {
        m = !1;
      }
      if (m)
        u = d.contentWindow;
      else
        break;
      d = Qe(u.document);
    }
    return d;
  }
  function Ha(u) {
    var d = u && u.nodeName && u.nodeName.toLowerCase();
    return d && (d === "input" && (u.type === "text" || u.type === "search" || u.type === "tel" || u.type === "url" || u.type === "password") || d === "textarea" || u.contentEditable === "true");
  }
  var gf = h && "documentMode" in document && 11 >= document.documentMode, gs = null, Tn = null, hl = null, ms = !1;
  function Ao(u, d, m) {
    var w = m.window === m ? m.document : m.nodeType === 9 ? m : m.ownerDocument;
    ms || gs == null || gs !== Qe(w) || (w = gs, "selectionStart" in w && Ha(w) ? w = { start: w.selectionStart, end: w.selectionEnd } : (w = (w.ownerDocument && w.ownerDocument.defaultView || window).getSelection(), w = { anchorNode: w.anchorNode, anchorOffset: w.anchorOffset, focusNode: w.focusNode, focusOffset: w.focusOffset }), hl && vl(hl, w) || (hl = w, w = ko(Tn, "onSelect"), 0 < w.length && (d = new vc("onSelect", "select", null, d, m), u.push({ event: d, listeners: w }), d.target = gs)));
  }
  Ad(
    "cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),
    0
  ), Ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1), Ad(sg, 2);
  for (var wv = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), Cv = 0; Cv < wv.length; Cv++)
    sf.set(wv[Cv], 0);
  p("onMouseEnter", ["mouseout", "mouseover"]), p("onMouseLeave", ["mouseout", "mouseover"]), p("onPointerEnter", ["pointerout", "pointerover"]), p("onPointerLeave", ["pointerout", "pointerover"]), l("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), l("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), l("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), l("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), l("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), l("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
  var yc = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), mf = new Set("cancel close invalid load scroll toggle".split(" ").concat(yc));
  function Po(u, d, m) {
    var w = u.type || "unknown-event";
    u.currentTarget = m, Sa(w, d, void 0, u), u.currentTarget = null;
  }
  function gl(u, d) {
    d = (d & 4) !== 0;
    for (var m = 0; m < u.length; m++) {
      var w = u[m], M = w.event;
      w = w.listeners;
      e: {
        var F = void 0;
        if (d)
          for (var H = w.length - 1; 0 <= H; H--) {
            var te = w[H], me = te.instance, ze = te.currentTarget;
            if (te = te.listener, me !== F && M.isPropagationStopped())
              break e;
            Po(M, te, ze), F = me;
          }
        else
          for (H = 0; H < w.length; H++) {
            if (te = w[H], me = te.instance, ze = te.currentTarget, te = te.listener, me !== F && M.isPropagationStopped())
              break e;
            Po(M, te, ze), F = me;
          }
      }
    }
    if (Vi)
      throw u = Td, Vi = !1, Td = null, u;
  }
  function Jn(u, d) {
    var m = bf(d), w = u + "__bubble";
    m.has(w) || (yl(d, u, 2, !1), m.add(w));
  }
  var ml = "_reactListening" + Math.random().toString(36).slice(2);
  function Ud(u) {
    u[ml] || (u[ml] = !0, a.forEach(function(d) {
      mf.has(d) || No(d, !1, u, null), No(d, !0, u, null);
    }));
  }
  function No(u, d, m, w) {
    var M = 4 < arguments.length && arguments[4] !== void 0 ? arguments[4] : 0, F = m;
    if (u === "selectionchange" && m.nodeType !== 9 && (F = m.ownerDocument), w !== null && !d && mf.has(u)) {
      if (u !== "scroll")
        return;
      M |= 2, F = w;
    }
    var H = bf(F), te = u + "__" + (d ? "capture" : "bubble");
    H.has(te) || (d && (M |= 4), yl(F, u, M, d), H.add(te));
  }
  function yl(u, d, m, w) {
    var M = sf.get(d);
    switch (M === void 0 ? 2 : M) {
      case 0:
        M = yi;
        break;
      case 1:
        M = uu;
        break;
      default:
        M = lo;
    }
    m = M.bind(null, d, m, u), M = void 0, !Fn || d !== "touchstart" && d !== "touchmove" && d !== "wheel" || (M = !0), w ? M !== void 0 ? u.addEventListener(d, m, { capture: !0, passive: M }) : u.addEventListener(d, m, !0) : M !== void 0 ? u.addEventListener(d, m, { passive: M }) : u.addEventListener(d, m, !1);
  }
  function yf(u, d, m, w, M) {
    var F = w;
    if ((d & 1) === 0 && (d & 2) === 0 && w !== null)
      e:
        for (; ; ) {
          if (w === null)
            return;
          var H = w.tag;
          if (H === 3 || H === 4) {
            var te = w.stateNode.containerInfo;
            if (te === M || te.nodeType === 8 && te.parentNode === M)
              break;
            if (H === 4)
              for (H = w.return; H !== null; ) {
                var me = H.tag;
                if ((me === 3 || me === 4) && (me = H.stateNode.containerInfo, me === M || me.nodeType === 8 && me.parentNode === M))
                  return;
                H = H.return;
              }
            for (; te !== null; ) {
              if (H = Es(te), H === null)
                return;
              if (me = H.tag, me === 5 || me === 6) {
                w = F = H;
                continue e;
              }
              te = te.parentNode;
            }
          }
          w = w.return;
        }
    Sn(function() {
      var ze = F, vt = Ua(m), qt = [];
      e: {
        var Je = fv.get(u);
        if (Je !== void 0) {
          var Mt = vc, Qt = u;
          switch (u) {
            case "keypress":
              if (ll(m) === 0)
                break e;
            case "keydown":
            case "keyup":
              Mt = By;
              break;
            case "focusin":
              Qt = "focus", Mt = _i;
              break;
            case "focusout":
              Qt = "blur", Mt = _i;
              break;
            case "beforeblur":
            case "afterblur":
              Mt = _i;
              break;
            case "click":
              if (m.button === 2)
                break e;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              Mt = Gn;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              Mt = aa;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              Mt = fl;
              break;
            case lv:
            case fc:
            case cv:
              Mt = dg;
              break;
            case of:
              Mt = zd;
              break;
            case "scroll":
              Mt = gv;
              break;
            case "wheel":
              Mt = gg;
              break;
            case "copy":
            case "cut":
            case "paste":
              Mt = pg;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              Mt = Bd;
          }
          var It = (d & 4) !== 0, Me = !It && u === "scroll", Ee = It ? Je !== null ? Je + "Capture" : null : Je;
          It = [];
          for (var Te = ze, We; Te !== null; ) {
            We = Te;
            var Ye = We.stateNode;
            if (We.tag === 5 && Ye !== null && (We = Ye, Ee !== null && (Ye = Kn(Te, Ee), Ye != null && It.push(ys(Te, Ye, We)))), Me)
              break;
            Te = Te.return;
          }
          0 < It.length && (Je = new Mt(Je, Qt, null, m, vt), qt.push({ event: Je, listeners: It }));
        }
      }
      if ((d & 7) === 0) {
        e: {
          if (Je = u === "mouseover" || u === "pointerover", Mt = u === "mouseout" || u === "pointerout", Je && (d & 16) === 0 && (Qt = m.relatedTarget || m.fromElement) && (Es(Qt) || Qt[Ei]))
            break e;
          if ((Mt || Je) && (Je = vt.window === vt ? vt : (Je = vt.ownerDocument) ? Je.defaultView || Je.parentWindow : window, Mt ? (Qt = m.relatedTarget || m.toElement, Mt = ze, Qt = Qt ? Es(Qt) : null, Qt !== null && (Me = Di(Qt), Qt !== Me || Qt.tag !== 5 && Qt.tag !== 6) && (Qt = null)) : (Mt = null, Qt = ze), Mt !== Qt)) {
            if (It = Gn, Ye = "onMouseLeave", Ee = "onMouseEnter", Te = "mouse", (u === "pointerout" || u === "pointerover") && (It = Bd, Ye = "onPointerLeave", Ee = "onPointerEnter", Te = "pointer"), Me = Mt == null ? Je : Qr(Mt), We = Qt == null ? Je : Qr(Qt), Je = new It(Ye, Te + "leave", Mt, m, vt), Je.target = Me, Je.relatedTarget = We, Ye = null, Es(vt) === ze && (It = new It(Ee, Te + "enter", Qt, m, vt), It.target = We, It.relatedTarget = Me, Ye = It), Me = Ye, Mt && Qt)
              t: {
                for (It = Mt, Ee = Qt, Te = 0, We = It; We; We = bs(We))
                  Te++;
                for (We = 0, Ye = Ee; Ye; Ye = bs(Ye))
                  We++;
                for (; 0 < Te - We; )
                  It = bs(It), Te--;
                for (; 0 < We - Te; )
                  Ee = bs(Ee), We--;
                for (; Te--; ) {
                  if (It === Ee || Ee !== null && It === Ee.alternate)
                    break t;
                  It = bs(It), Ee = bs(Ee);
                }
                It = null;
              }
            else
              It = null;
            Mt !== null && Rg(qt, Je, Mt, It, !1), Qt !== null && Me !== null && Rg(qt, Me, Qt, It, !0);
          }
        }
        e: {
          if (Je = ze ? Qr(ze) : window, Mt = Je.nodeName && Je.nodeName.toLowerCase(), Mt === "select" || Mt === "input" && Je.type === "file")
            var rn = Fy;
          else if (xg(Je))
            if (Sg)
              rn = an;
            else {
              rn = Be;
              var yt = $e;
            }
          else
            (Mt = Je.nodeName) && Mt.toLowerCase() === "input" && (Je.type === "checkbox" || Je.type === "radio") && (rn = ot);
          if (rn && (rn = rn(u, ze))) {
            $d(qt, rn, m, vt);
            break e;
          }
          yt && yt(u, Je, ze), u === "focusout" && (yt = Je._wrapperState) && yt.controlled && Je.type === "number" && Kt(Je, "number", Je.value);
        }
        switch (yt = ze ? Qr(ze) : window, u) {
          case "focusin":
            (xg(yt) || yt.contentEditable === "true") && (gs = yt, Tn = ze, hl = null);
            break;
          case "focusout":
            hl = Tn = gs = null;
            break;
          case "mousedown":
            ms = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            ms = !1, Ao(qt, m, vt);
            break;
          case "selectionchange":
            if (gf)
              break;
          case "keydown":
          case "keyup":
            Ao(qt, m, vt);
        }
        var Ut;
        if (_v)
          e: {
            switch (u) {
              case "compositionstart":
                var sn = "onCompositionStart";
                break e;
              case "compositionend":
                sn = "onCompositionEnd";
                break e;
              case "compositionupdate":
                sn = "onCompositionUpdate";
                break e;
            }
            sn = void 0;
          }
        else
          hs ? Ev(u, m) && (sn = "onCompositionEnd") : u === "keydown" && m.keyCode === 229 && (sn = "onCompositionStart");
        sn && (yg && m.locale !== "ko" && (hs || sn !== "onCompositionStart" ? sn === "onCompositionEnd" && hs && (Ut = Nd()) : (Oo = vt, ia = "value" in Oo ? Oo.value : Oo.textContent, hs = !0)), yt = ko(ze, sn), 0 < yt.length && (sn = new cl(sn, u, null, m, vt), qt.push({ event: sn, listeners: yt }), Ut ? sn.data = Ut : (Ut = _g(m), Ut !== null && (sn.data = Ut)))), (Ut = zy ? Eg(u, m) : fu(u, m)) && (ze = ko(ze, "onBeforeInput"), 0 < ze.length && (vt = new cl(
          "onBeforeInput",
          "beforeinput",
          null,
          m,
          vt
        ), qt.push({ event: vt, listeners: ze }), vt.data = Ut));
      }
      gl(qt, d);
    });
  }
  function ys(u, d, m) {
    return { instance: u, listener: d, currentTarget: m };
  }
  function ko(u, d) {
    for (var m = d + "Capture", w = []; u !== null; ) {
      var M = u, F = M.stateNode;
      M.tag === 5 && F !== null && (M = F, F = Kn(u, m), F != null && w.unshift(ys(u, F, M)), F = Kn(u, d), F != null && w.push(ys(u, F, M))), u = u.return;
    }
    return w;
  }
  function bs(u) {
    if (u === null)
      return null;
    do
      u = u.return;
    while (u && u.tag !== 5);
    return u || null;
  }
  function Rg(u, d, m, w, M) {
    for (var F = d._reactName, H = []; m !== null && m !== w; ) {
      var te = m, me = te.alternate, ze = te.stateNode;
      if (me !== null && me === w)
        break;
      te.tag === 5 && ze !== null && (te = ze, M ? (me = Kn(m, F), me != null && H.unshift(ys(m, me, te))) : M || (me = Kn(m, F), me != null && H.push(ys(m, me, te)))), m = m.return;
    }
    H.length !== 0 && u.push({ event: d, listeners: H });
  }
  function Vd() {
  }
  var Rv = null, bc = null;
  function _s(u, d) {
    switch (u) {
      case "button":
      case "input":
      case "select":
      case "textarea":
        return !!d.autoFocus;
    }
    return !1;
  }
  function bl(u, d) {
    return u === "textarea" || u === "option" || u === "noscript" || typeof d.children == "string" || typeof d.children == "number" || typeof d.dangerouslySetInnerHTML == "object" && d.dangerouslySetInnerHTML !== null && d.dangerouslySetInnerHTML.__html != null;
  }
  var _c = typeof setTimeout == "function" ? setTimeout : void 0, Tv = typeof clearTimeout == "function" ? clearTimeout : void 0;
  function jd(u) {
    u.nodeType === 1 ? u.textContent = "" : u.nodeType === 9 && (u = u.body, u != null && (u.textContent = ""));
  }
  function du(u) {
    for (; u != null; u = u.nextSibling) {
      var d = u.nodeType;
      if (d === 1 || d === 3)
        break;
    }
    return u;
  }
  function Ur(u) {
    u = u.previousSibling;
    for (var d = 0; u; ) {
      if (u.nodeType === 8) {
        var m = u.data;
        if (m === "$" || m === "$!" || m === "$?") {
          if (d === 0)
            return u;
          d--;
        } else
          m === "/$" && d++;
      }
      u = u.previousSibling;
    }
    return null;
  }
  var br = 0;
  function Wd(u) {
    return { $$typeof: Oe, toString: u, valueOf: u };
  }
  var _l = Math.random().toString(36).slice(2), fo = "__reactFiber$" + _l, Gd = "__reactProps$" + _l, Ei = "__reactContainer$" + _l, Ec = "__reactEvents$" + _l;
  function Es(u) {
    var d = u[fo];
    if (d)
      return d;
    for (var m = u.parentNode; m; ) {
      if (d = m[Ei] || m[fo]) {
        if (m = d.alternate, d.child !== null || m !== null && m.child !== null)
          for (u = Ur(u); u !== null; ) {
            if (m = u[fo])
              return m;
            u = Ur(u);
          }
        return d;
      }
      u = m, m = u.parentNode;
    }
    return null;
  }
  function ai(u) {
    return u = u[fo] || u[Ei], !u || u.tag !== 5 && u.tag !== 6 && u.tag !== 13 && u.tag !== 3 ? null : u;
  }
  function Qr(u) {
    if (u.tag === 5 || u.tag === 6)
      return u.stateNode;
    throw Error(r(33));
  }
  function Ta(u) {
    return u[Gd] || null;
  }
  function bf(u) {
    var d = u[Ec];
    return d === void 0 && (d = u[Ec] = /* @__PURE__ */ new Set()), d;
  }
  var pu = [], Hn = -1;
  function Hi(u) {
    return { current: u };
  }
  function nn(u) {
    0 > Hn || (u.current = pu[Hn], pu[Hn] = null, Hn--);
  }
  function Ht(u, d) {
    Hn++, pu[Hn] = u.current, u.current = d;
  }
  var vu = {}, er = Hi(vu), Lr = Hi(!1), xs = vu;
  function G(u, d) {
    var m = u.type.contextTypes;
    if (!m)
      return vu;
    var w = u.stateNode;
    if (w && w.__reactInternalMemoizedUnmaskedChildContext === d)
      return w.__reactInternalMemoizedMaskedChildContext;
    var M = {}, F;
    for (F in m)
      M[F] = d[F];
    return w && (u = u.stateNode, u.__reactInternalMemoizedUnmaskedChildContext = d, u.__reactInternalMemoizedMaskedChildContext = M), M;
  }
  function Rr(u) {
    return u = u.childContextTypes, u != null;
  }
  function Oa() {
    nn(Lr), nn(er);
  }
  function xi(u, d, m) {
    if (er.current !== vu)
      throw Error(r(168));
    Ht(er, d), Ht(Lr, m);
  }
  function un(u, d, m) {
    var w = u.stateNode;
    if (u = d.childContextTypes, typeof w.getChildContext != "function")
      return m;
    w = w.getChildContext();
    for (var M in w)
      if (!(M in u))
        throw Error(r(108, xe(d) || "Unknown", M));
    return t({}, m, w);
  }
  function Ya(u) {
    return u = (u = u.stateNode) && u.__reactInternalMemoizedMergedChildContext || vu, xs = er.current, Ht(er, u), Ht(Lr, Lr.current), !0;
  }
  function Tg(u, d, m) {
    var w = u.stateNode;
    if (!w)
      throw Error(r(169));
    m ? (u = un(u, d, xs), w.__reactInternalMemoizedMergedChildContext = u, nn(Lr), nn(er), Ht(er, u)) : nn(Lr), Ht(Lr, m);
  }
  var Ov = null, Da = null, _f = n.unstable_runWithPriority, po = n.unstable_scheduleCallback, Ef = n.unstable_cancelCallback, $y = n.unstable_shouldYield, hu = n.unstable_requestPaint, qa = n.unstable_now, Og = n.unstable_getCurrentPriorityLevel, Hd = n.unstable_ImmediatePriority, Dg = n.unstable_UserBlockingPriority, Dv = n.unstable_NormalPriority, Mv = n.unstable_LowPriority, vo = n.unstable_IdlePriority, Av = {}, Mg = hu !== void 0 ? hu : function() {
  }, Io = null, Yd = null, xf = !1, gu = qa(), Si = 1e4 > gu ? qa : function() {
    return qa() - gu;
  };
  function xc() {
    switch (Og()) {
      case Hd:
        return 99;
      case Dg:
        return 98;
      case Dv:
        return 97;
      case Mv:
        return 96;
      case vo:
        return 95;
      default:
        throw Error(r(332));
    }
  }
  function Ma(u) {
    switch (u) {
      case 99:
        return Hd;
      case 98:
        return Dg;
      case 97:
        return Dv;
      case 96:
        return Mv;
      case 95:
        return vo;
      default:
        throw Error(r(332));
    }
  }
  function El(u, d) {
    return u = Ma(u), _f(u, d);
  }
  function xl(u, d, m) {
    return u = Ma(u), po(u, d, m);
  }
  function oi() {
    if (Yd !== null) {
      var u = Yd;
      Yd = null, Ef(u);
    }
    Ss();
  }
  function Ss() {
    if (!xf && Io !== null) {
      xf = !0;
      var u = 0;
      try {
        var d = Io;
        El(99, function() {
          for (; u < d.length; u++) {
            var m = d[u];
            do
              m = m(!0);
            while (m !== null);
          }
        }), Io = null;
      } catch (m) {
        throw Io !== null && (Io = Io.slice(u + 1)), po(Hd, oi), m;
      } finally {
        xf = !1;
      }
    }
  }
  var mu = k.ReactCurrentBatchConfig;
  function Zr(u, d) {
    if (u && u.defaultProps) {
      d = t({}, d), u = u.defaultProps;
      for (var m in u)
        d[m] === void 0 && (d[m] = u[m]);
      return d;
    }
    return d;
  }
  var ws = Hi(null), yu = null, Lo = null, Sc = null;
  function Sl() {
    Sc = Lo = yu = null;
  }
  function wl(u) {
    var d = ws.current;
    nn(ws), u.type._context._currentValue = d;
  }
  function Pv(u, d) {
    for (; u !== null; ) {
      var m = u.alternate;
      if ((u.childLanes & d) === d) {
        if (m === null || (m.childLanes & d) === d)
          break;
        m.childLanes |= d;
      } else
        u.childLanes |= d, m !== null && (m.childLanes |= d);
      u = u.return;
    }
  }
  function bu(u, d) {
    yu = u, Sc = Lo = null, u = u.dependencies, u !== null && u.firstContext !== null && ((u.lanes & d) !== 0 && (ti = !0), u.firstContext = null);
  }
  function Aa(u, d) {
    if (Sc !== u && d !== !1 && d !== 0)
      if ((typeof d != "number" || d === 1073741823) && (Sc = u, d = 1073741823), d = { context: u, observedBits: d, next: null }, Lo === null) {
        if (yu === null)
          throw Error(r(308));
        Lo = d, yu.dependencies = { lanes: 0, firstContext: d, responders: null };
      } else
        Lo = Lo.next = d;
    return u._currentValue;
  }
  var Vr = !1;
  function Sf(u) {
    u.updateQueue = { baseState: u.memoizedState, firstBaseUpdate: null, lastBaseUpdate: null, shared: { pending: null }, effects: null };
  }
  function _u(u, d) {
    u = u.updateQueue, d.updateQueue === u && (d.updateQueue = { baseState: u.baseState, firstBaseUpdate: u.firstBaseUpdate, lastBaseUpdate: u.lastBaseUpdate, shared: u.shared, effects: u.effects });
  }
  function Tr(u, d) {
    return { eventTime: u, lane: d, tag: 0, payload: null, callback: null, next: null };
  }
  function Cs(u, d) {
    if (u = u.updateQueue, u !== null) {
      u = u.shared;
      var m = u.pending;
      m === null ? d.next = d : (d.next = m.next, m.next = d), u.pending = d;
    }
  }
  function Nv(u, d) {
    var m = u.updateQueue, w = u.alternate;
    if (w !== null && (w = w.updateQueue, m === w)) {
      var M = null, F = null;
      if (m = m.firstBaseUpdate, m !== null) {
        do {
          var H = { eventTime: m.eventTime, lane: m.lane, tag: m.tag, payload: m.payload, callback: m.callback, next: null };
          F === null ? M = F = H : F = F.next = H, m = m.next;
        } while (m !== null);
        F === null ? M = F = d : F = F.next = d;
      } else
        M = F = d;
      m = { baseState: w.baseState, firstBaseUpdate: M, lastBaseUpdate: F, shared: w.shared, effects: w.effects }, u.updateQueue = m;
      return;
    }
    u = m.lastBaseUpdate, u === null ? m.firstBaseUpdate = d : u.next = d, m.lastBaseUpdate = d;
  }
  function Bo(u, d, m, w) {
    var M = u.updateQueue;
    Vr = !1;
    var F = M.firstBaseUpdate, H = M.lastBaseUpdate, te = M.shared.pending;
    if (te !== null) {
      M.shared.pending = null;
      var me = te, ze = me.next;
      me.next = null, H === null ? F = ze : H.next = ze, H = me;
      var vt = u.alternate;
      if (vt !== null) {
        vt = vt.updateQueue;
        var qt = vt.lastBaseUpdate;
        qt !== H && (qt === null ? vt.firstBaseUpdate = ze : qt.next = ze, vt.lastBaseUpdate = me);
      }
    }
    if (F !== null) {
      qt = M.baseState, H = 0, vt = ze = me = null;
      do {
        te = F.lane;
        var Je = F.eventTime;
        if ((w & te) === te) {
          vt !== null && (vt = vt.next = {
            eventTime: Je,
            lane: 0,
            tag: F.tag,
            payload: F.payload,
            callback: F.callback,
            next: null
          });
          e: {
            var Mt = u, Qt = F;
            switch (te = d, Je = m, Qt.tag) {
              case 1:
                if (Mt = Qt.payload, typeof Mt == "function") {
                  qt = Mt.call(Je, qt, te);
                  break e;
                }
                qt = Mt;
                break e;
              case 3:
                Mt.flags = Mt.flags & -4097 | 64;
              case 0:
                if (Mt = Qt.payload, te = typeof Mt == "function" ? Mt.call(Je, qt, te) : Mt, te == null)
                  break e;
                qt = t({}, qt, te);
                break e;
              case 2:
                Vr = !0;
            }
          }
          F.callback !== null && (u.flags |= 32, te = M.effects, te === null ? M.effects = [F] : te.push(F));
        } else
          Je = { eventTime: Je, lane: te, tag: F.tag, payload: F.payload, callback: F.callback, next: null }, vt === null ? (ze = vt = Je, me = qt) : vt = vt.next = Je, H |= te;
        if (F = F.next, F === null) {
          if (te = M.shared.pending, te === null)
            break;
          F = te.next, te.next = null, M.lastBaseUpdate = te, M.shared.pending = null;
        }
      } while (1);
      vt === null && (me = qt), M.baseState = me, M.firstBaseUpdate = ze, M.lastBaseUpdate = vt, Is |= H, u.lanes = H, u.memoizedState = qt;
    }
  }
  function Cl(u, d, m) {
    if (u = d.effects, d.effects = null, u !== null)
      for (d = 0; d < u.length; d++) {
        var w = u[d], M = w.callback;
        if (M !== null) {
          if (w.callback = null, w = m, typeof M != "function")
            throw Error(r(191, M));
          M.call(w);
        }
      }
  }
  var ho = new e.Component().refs;
  function wc(u, d, m, w) {
    d = u.memoizedState, m = m(w, d), m = m == null ? d : t({}, d, m), u.memoizedState = m, u.lanes === 0 && (u.updateQueue.baseState = m);
  }
  var Cc = { isMounted: function(u) {
    return (u = u._reactInternals) ? Di(u) === u : !1;
  }, enqueueSetState: function(u, d, m) {
    u = u._reactInternals;
    var w = ka(), M = bo(u), F = Tr(w, M);
    F.payload = d, m != null && (F.callback = m), Cs(u, F), Bs(u, M, w);
  }, enqueueReplaceState: function(u, d, m) {
    u = u._reactInternals;
    var w = ka(), M = bo(u), F = Tr(w, M);
    F.tag = 1, F.payload = d, m != null && (F.callback = m), Cs(u, F), Bs(u, M, w);
  }, enqueueForceUpdate: function(u, d) {
    u = u._reactInternals;
    var m = ka(), w = bo(u), M = Tr(m, w);
    M.tag = 2, d != null && (M.callback = d), Cs(u, M), Bs(u, w, m);
  } };
  function Eu(u, d, m, w, M, F, H) {
    return u = u.stateNode, typeof u.shouldComponentUpdate == "function" ? u.shouldComponentUpdate(w, F, H) : d.prototype && d.prototype.isPureReactComponent ? !vl(m, w) || !vl(M, F) : !0;
  }
  function Rl(u, d, m) {
    var w = !1, M = vu, F = d.contextType;
    return typeof F == "object" && F !== null ? F = Aa(F) : (M = Rr(d) ? xs : er.current, w = d.contextTypes, F = (w = w != null) ? G(u, M) : vu), d = new d(m, F), u.memoizedState = d.state !== null && d.state !== void 0 ? d.state : null, d.updater = Cc, u.stateNode = d, d._reactInternals = u, w && (u = u.stateNode, u.__reactInternalMemoizedUnmaskedChildContext = M, u.__reactInternalMemoizedMaskedChildContext = F), d;
  }
  function wf(u, d, m, w) {
    u = d.state, typeof d.componentWillReceiveProps == "function" && d.componentWillReceiveProps(m, w), typeof d.UNSAFE_componentWillReceiveProps == "function" && d.UNSAFE_componentWillReceiveProps(m, w), d.state !== u && Cc.enqueueReplaceState(d, d.state, null);
  }
  function jr(u, d, m, w) {
    var M = u.stateNode;
    M.props = m, M.state = u.memoizedState, M.refs = ho, Sf(u);
    var F = d.contextType;
    typeof F == "object" && F !== null ? M.context = Aa(F) : (F = Rr(d) ? xs : er.current, M.context = G(u, F)), Bo(u, m, M, w), M.state = u.memoizedState, F = d.getDerivedStateFromProps, typeof F == "function" && (wc(u, d, F, m), M.state = u.memoizedState), typeof d.getDerivedStateFromProps == "function" || typeof M.getSnapshotBeforeUpdate == "function" || typeof M.UNSAFE_componentWillMount != "function" && typeof M.componentWillMount != "function" || (d = M.state, typeof M.componentWillMount == "function" && M.componentWillMount(), typeof M.UNSAFE_componentWillMount == "function" && M.UNSAFE_componentWillMount(), d !== M.state && Cc.enqueueReplaceState(M, M.state, null), Bo(u, m, M, w), M.state = u.memoizedState), typeof M.componentDidMount == "function" && (u.flags |= 4);
  }
  var Rs = Array.isArray;
  function Tl(u, d, m) {
    if (u = m.ref, u !== null && typeof u != "function" && typeof u != "object") {
      if (m._owner) {
        if (m = m._owner, m) {
          if (m.tag !== 1)
            throw Error(r(309));
          var w = m.stateNode;
        }
        if (!w)
          throw Error(r(147, u));
        var M = "" + u;
        return d !== null && d.ref !== null && typeof d.ref == "function" && d.ref._stringRef === M ? d.ref : (d = function(F) {
          var H = w.refs;
          H === ho && (H = w.refs = {}), F === null ? delete H[M] : H[M] = F;
        }, d._stringRef = M, d);
      }
      if (typeof u != "string")
        throw Error(r(284));
      if (!m._owner)
        throw Error(r(290, u));
    }
    return u;
  }
  function oa(u, d) {
    if (u.type !== "textarea")
      throw Error(r(31, Object.prototype.toString.call(d) === "[object Object]" ? "object with keys {" + Object.keys(d).join(", ") + "}" : d));
  }
  function Cf(u) {
    function d(Me, Ee) {
      if (u) {
        var Te = Me.lastEffect;
        Te !== null ? (Te.nextEffect = Ee, Me.lastEffect = Ee) : Me.firstEffect = Me.lastEffect = Ee, Ee.nextEffect = null, Ee.flags = 8;
      }
    }
    function m(Me, Ee) {
      if (!u)
        return null;
      for (; Ee !== null; )
        d(Me, Ee), Ee = Ee.sibling;
      return null;
    }
    function w(Me, Ee) {
      for (Me = /* @__PURE__ */ new Map(); Ee !== null; )
        Ee.key !== null ? Me.set(Ee.key, Ee) : Me.set(Ee.index, Ee), Ee = Ee.sibling;
      return Me;
    }
    function M(Me, Ee) {
      return Me = ku(Me, Ee), Me.index = 0, Me.sibling = null, Me;
    }
    function F(Me, Ee, Te) {
      return Me.index = Te, u ? (Te = Me.alternate, Te !== null ? (Te = Te.index, Te < Ee ? (Me.flags = 2, Ee) : Te) : (Me.flags = 2, Ee)) : Ee;
    }
    function H(Me) {
      return u && Me.alternate === null && (Me.flags = 2), Me;
    }
    function te(Me, Ee, Te, We) {
      return Ee === null || Ee.tag !== 6 ? (Ee = th(Te, Me.mode, We), Ee.return = Me, Ee) : (Ee = M(Ee, Te), Ee.return = Me, Ee);
    }
    function me(Me, Ee, Te, We) {
      return Ee !== null && Ee.elementType === Te.type ? (We = M(Ee, Te.props), We.ref = Tl(Me, Ee, Te), We.return = Me, We) : (We = Zf(Te.type, Te.key, Te.props, null, Me.mode, We), We.ref = Tl(Me, Ee, Te), We.return = Me, We);
    }
    function ze(Me, Ee, Te, We) {
      return Ee === null || Ee.tag !== 4 || Ee.stateNode.containerInfo !== Te.containerInfo || Ee.stateNode.implementation !== Te.implementation ? (Ee = nh(Te, Me.mode, We), Ee.return = Me, Ee) : (Ee = M(Ee, Te.children || []), Ee.return = Me, Ee);
    }
    function vt(Me, Ee, Te, We, Ye) {
      return Ee === null || Ee.tag !== 7 ? (Ee = Yo(Te, Me.mode, We, Ye), Ee.return = Me, Ee) : (Ee = M(Ee, Te), Ee.return = Me, Ee);
    }
    function qt(Me, Ee, Te) {
      if (typeof Ee == "string" || typeof Ee == "number")
        return Ee = th("" + Ee, Me.mode, Te), Ee.return = Me, Ee;
      if (typeof Ee == "object" && Ee !== null) {
        switch (Ee.$$typeof) {
          case $:
            return Te = Zf(Ee.type, Ee.key, Ee.props, null, Me.mode, Te), Te.ref = Tl(Me, null, Ee), Te.return = Me, Te;
          case U:
            return Ee = nh(Ee, Me.mode, Te), Ee.return = Me, Ee;
        }
        if (Rs(Ee) || ve(Ee))
          return Ee = Yo(
            Ee,
            Me.mode,
            Te,
            null
          ), Ee.return = Me, Ee;
        oa(Me, Ee);
      }
      return null;
    }
    function Je(Me, Ee, Te, We) {
      var Ye = Ee !== null ? Ee.key : null;
      if (typeof Te == "string" || typeof Te == "number")
        return Ye !== null ? null : te(Me, Ee, "" + Te, We);
      if (typeof Te == "object" && Te !== null) {
        switch (Te.$$typeof) {
          case $:
            return Te.key === Ye ? Te.type === K ? vt(Me, Ee, Te.props.children, We, Ye) : me(Me, Ee, Te, We) : null;
          case U:
            return Te.key === Ye ? ze(Me, Ee, Te, We) : null;
        }
        if (Rs(Te) || ve(Te))
          return Ye !== null ? null : vt(Me, Ee, Te, We, null);
        oa(Me, Te);
      }
      return null;
    }
    function Mt(Me, Ee, Te, We, Ye) {
      if (typeof We == "string" || typeof We == "number")
        return Me = Me.get(Te) || null, te(Ee, Me, "" + We, Ye);
      if (typeof We == "object" && We !== null) {
        switch (We.$$typeof) {
          case $:
            return Me = Me.get(We.key === null ? Te : We.key) || null, We.type === K ? vt(Ee, Me, We.props.children, Ye, We.key) : me(Ee, Me, We, Ye);
          case U:
            return Me = Me.get(We.key === null ? Te : We.key) || null, ze(Ee, Me, We, Ye);
        }
        if (Rs(We) || ve(We))
          return Me = Me.get(Te) || null, vt(Ee, Me, We, Ye, null);
        oa(Ee, We);
      }
      return null;
    }
    function Qt(Me, Ee, Te, We) {
      for (var Ye = null, rn = null, yt = Ee, Ut = Ee = 0, sn = null; yt !== null && Ut < Te.length; Ut++) {
        yt.index > Ut ? (sn = yt, yt = null) : sn = yt.sibling;
        var on = Je(Me, yt, Te[Ut], We);
        if (on === null) {
          yt === null && (yt = sn);
          break;
        }
        u && yt && on.alternate === null && d(Me, yt), Ee = F(on, Ee, Ut), rn === null ? Ye = on : rn.sibling = on, rn = on, yt = sn;
      }
      if (Ut === Te.length)
        return m(Me, yt), Ye;
      if (yt === null) {
        for (; Ut < Te.length; Ut++)
          yt = qt(Me, Te[Ut], We), yt !== null && (Ee = F(yt, Ee, Ut), rn === null ? Ye = yt : rn.sibling = yt, rn = yt);
        return Ye;
      }
      for (yt = w(Me, yt); Ut < Te.length; Ut++)
        sn = Mt(yt, Me, Ut, Te[Ut], We), sn !== null && (u && sn.alternate !== null && yt.delete(sn.key === null ? Ut : sn.key), Ee = F(sn, Ee, Ut), rn === null ? Ye = sn : rn.sibling = sn, rn = sn);
      return u && yt.forEach(function(Iu) {
        return d(Me, Iu);
      }), Ye;
    }
    function It(Me, Ee, Te, We) {
      var Ye = ve(Te);
      if (typeof Ye != "function")
        throw Error(r(150));
      if (Te = Ye.call(Te), Te == null)
        throw Error(r(151));
      for (var rn = Ye = null, yt = Ee, Ut = Ee = 0, sn = null, on = Te.next(); yt !== null && !on.done; Ut++, on = Te.next()) {
        yt.index > Ut ? (sn = yt, yt = null) : sn = yt.sibling;
        var Iu = Je(Me, yt, on.value, We);
        if (Iu === null) {
          yt === null && (yt = sn);
          break;
        }
        u && yt && Iu.alternate === null && d(Me, yt), Ee = F(Iu, Ee, Ut), rn === null ? Ye = Iu : rn.sibling = Iu, rn = Iu, yt = sn;
      }
      if (on.done)
        return m(Me, yt), Ye;
      if (yt === null) {
        for (; !on.done; Ut++, on = Te.next())
          on = qt(Me, on.value, We), on !== null && (Ee = F(on, Ee, Ut), rn === null ? Ye = on : rn.sibling = on, rn = on);
        return Ye;
      }
      for (yt = w(Me, yt); !on.done; Ut++, on = Te.next())
        on = Mt(yt, Me, Ut, on.value, We), on !== null && (u && on.alternate !== null && yt.delete(on.key === null ? Ut : on.key), Ee = F(on, Ee, Ut), rn === null ? Ye = on : rn.sibling = on, rn = on);
      return u && yt.forEach(function(Zy) {
        return d(Me, Zy);
      }), Ye;
    }
    return function(Me, Ee, Te, We) {
      var Ye = typeof Te == "object" && Te !== null && Te.type === K && Te.key === null;
      Ye && (Te = Te.props.children);
      var rn = typeof Te == "object" && Te !== null;
      if (rn)
        switch (Te.$$typeof) {
          case $:
            e: {
              for (rn = Te.key, Ye = Ee; Ye !== null; ) {
                if (Ye.key === rn) {
                  switch (Ye.tag) {
                    case 7:
                      if (Te.type === K) {
                        m(Me, Ye.sibling), Ee = M(Ye, Te.props.children), Ee.return = Me, Me = Ee;
                        break e;
                      }
                      break;
                    default:
                      if (Ye.elementType === Te.type) {
                        m(Me, Ye.sibling), Ee = M(Ye, Te.props), Ee.ref = Tl(Me, Ye, Te), Ee.return = Me, Me = Ee;
                        break e;
                      }
                  }
                  m(Me, Ye);
                  break;
                } else
                  d(Me, Ye);
                Ye = Ye.sibling;
              }
              Te.type === K ? (Ee = Yo(Te.props.children, Me.mode, We, Te.key), Ee.return = Me, Me = Ee) : (We = Zf(Te.type, Te.key, Te.props, null, Me.mode, We), We.ref = Tl(Me, Ee, Te), We.return = Me, Me = We);
            }
            return H(Me);
          case U:
            e: {
              for (Ye = Te.key; Ee !== null; ) {
                if (Ee.key === Ye)
                  if (Ee.tag === 4 && Ee.stateNode.containerInfo === Te.containerInfo && Ee.stateNode.implementation === Te.implementation) {
                    m(Me, Ee.sibling), Ee = M(Ee, Te.children || []), Ee.return = Me, Me = Ee;
                    break e;
                  } else {
                    m(Me, Ee);
                    break;
                  }
                else
                  d(Me, Ee);
                Ee = Ee.sibling;
              }
              Ee = nh(Te, Me.mode, We), Ee.return = Me, Me = Ee;
            }
            return H(Me);
        }
      if (typeof Te == "string" || typeof Te == "number")
        return Te = "" + Te, Ee !== null && Ee.tag === 6 ? (m(Me, Ee.sibling), Ee = M(Ee, Te), Ee.return = Me, Me = Ee) : (m(Me, Ee), Ee = th(Te, Me.mode, We), Ee.return = Me, Me = Ee), H(Me);
      if (Rs(Te))
        return Qt(Me, Ee, Te, We);
      if (ve(Te))
        return It(Me, Ee, Te, We);
      if (rn && oa(Me, Te), typeof Te > "u" && !Ye)
        switch (Me.tag) {
          case 1:
          case 22:
          case 0:
          case 11:
          case 15:
            throw Error(r(152, xe(Me.type) || "Component"));
        }
      return m(Me, Ee);
    };
  }
  var xu = Cf(!0), Ts = Cf(!1), Su = {}, pr = Hi(Su), Ol = Hi(Su), Rf = Hi(Su);
  function Dl(u) {
    if (u === Su)
      throw Error(r(174));
    return u;
  }
  function Tf(u, d) {
    switch (Ht(Rf, d), Ht(Ol, u), Ht(pr, Su), u = d.nodeType, u) {
      case 9:
      case 11:
        d = (d = d.documentElement) ? d.namespaceURI : Pt(null, "");
        break;
      default:
        u = u === 8 ? d.parentNode : d, d = u.namespaceURI || null, u = u.tagName, d = Pt(d, u);
    }
    nn(pr), Ht(pr, d);
  }
  function wu() {
    nn(pr), nn(Ol), nn(Rf);
  }
  function Ag(u) {
    Dl(Rf.current);
    var d = Dl(pr.current), m = Pt(d, u.type);
    d !== m && (Ht(Ol, u), Ht(pr, m));
  }
  function Ml(u) {
    Ol.current === u && (nn(pr), nn(Ol));
  }
  var _r = Hi(0);
  function Of(u) {
    for (var d = u; d !== null; ) {
      if (d.tag === 13) {
        var m = d.memoizedState;
        if (m !== null && (m = m.dehydrated, m === null || m.data === "$?" || m.data === "$!"))
          return d;
      } else if (d.tag === 19 && d.memoizedProps.revealOrder !== void 0) {
        if ((d.flags & 64) !== 0)
          return d;
      } else if (d.child !== null) {
        d.child.return = d, d = d.child;
        continue;
      }
      if (d === u)
        break;
      for (; d.sibling === null; ) {
        if (d.return === null || d.return === u)
          return null;
        d = d.return;
      }
      d.sibling.return = d.return, d = d.sibling;
    }
    return null;
  }
  var zo = null, Pa = null, Fo = !1;
  function kv(u, d) {
    var m = Qa(5, null, null, 0);
    m.elementType = "DELETED", m.type = "DELETED", m.stateNode = d, m.return = u, m.flags = 8, u.lastEffect !== null ? (u.lastEffect.nextEffect = m, u.lastEffect = m) : u.firstEffect = u.lastEffect = m;
  }
  function qd(u, d) {
    switch (u.tag) {
      case 5:
        var m = u.type;
        return d = d.nodeType !== 1 || m.toLowerCase() !== d.nodeName.toLowerCase() ? null : d, d !== null ? (u.stateNode = d, !0) : !1;
      case 6:
        return d = u.pendingProps === "" || d.nodeType !== 3 ? null : d, d !== null ? (u.stateNode = d, !0) : !1;
      case 13:
        return !1;
      default:
        return !1;
    }
  }
  function Os(u) {
    if (Fo) {
      var d = Pa;
      if (d) {
        var m = d;
        if (!qd(u, d)) {
          if (d = du(m.nextSibling), !d || !qd(u, d)) {
            u.flags = u.flags & -1025 | 2, Fo = !1, zo = u;
            return;
          }
          kv(zo, m);
        }
        zo = u, Pa = du(d.firstChild);
      } else
        u.flags = u.flags & -1025 | 2, Fo = !1, zo = u;
    }
  }
  function Df(u) {
    for (u = u.return; u !== null && u.tag !== 5 && u.tag !== 3 && u.tag !== 13; )
      u = u.return;
    zo = u;
  }
  function Mf(u) {
    if (u !== zo)
      return !1;
    if (!Fo)
      return Df(u), Fo = !0, !1;
    var d = u.type;
    if (u.tag !== 5 || d !== "head" && d !== "body" && !bl(d, u.memoizedProps))
      for (d = Pa; d; )
        kv(u, d), d = du(d.nextSibling);
    if (Df(u), u.tag === 13) {
      if (u = u.memoizedState, u = u !== null ? u.dehydrated : null, !u)
        throw Error(r(317));
      e: {
        for (u = u.nextSibling, d = 0; u; ) {
          if (u.nodeType === 8) {
            var m = u.data;
            if (m === "/$") {
              if (d === 0) {
                Pa = du(u.nextSibling);
                break e;
              }
              d--;
            } else
              m !== "$" && m !== "$!" && m !== "$?" || d++;
          }
          u = u.nextSibling;
        }
        Pa = null;
      }
    } else
      Pa = zo ? du(u.stateNode.nextSibling) : null;
    return !0;
  }
  function Rc() {
    Pa = zo = null, Fo = !1;
  }
  var Cu = [];
  function $o() {
    for (var u = 0; u < Cu.length; u++)
      Cu[u]._workInProgressVersionPrimary = null;
    Cu.length = 0;
  }
  var Tc = k.ReactCurrentDispatcher, Wr = k.ReactCurrentBatchConfig, Al = 0, dr = null, Jr = null, Br = null, Af = !1, Ds = !1;
  function Mi() {
    throw Error(r(321));
  }
  function Ms(u, d) {
    if (d === null)
      return !1;
    for (var m = 0; m < d.length && m < u.length; m++)
      if (!Ln(u[m], d[m]))
        return !1;
    return !0;
  }
  function Xd(u, d, m, w, M, F) {
    if (Al = F, dr = d, d.memoizedState = null, d.updateQueue = null, d.lanes = 0, Tc.current = u === null || u.memoizedState === null ? Il : Pg, u = m(w, M), Ds) {
      F = 0;
      do {
        if (Ds = !1, !(25 > F))
          throw Error(r(301));
        F += 1, Br = Jr = null, d.updateQueue = null, Tc.current = Lv, u = m(w, M);
      } while (Ds);
    }
    if (Tc.current = kf, d = Jr !== null && Jr.next !== null, Al = 0, Br = Jr = dr = null, Af = !1, d)
      throw Error(r(300));
    return u;
  }
  function Ge() {
    var u = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
    return Br === null ? dr.memoizedState = Br = u : Br = Br.next = u, Br;
  }
  function Or() {
    if (Jr === null) {
      var u = dr.alternate;
      u = u !== null ? u.memoizedState : null;
    } else
      u = Jr.next;
    var d = Br === null ? dr.memoizedState : Br.next;
    if (d !== null)
      Br = d, Jr = u;
    else {
      if (u === null)
        throw Error(r(310));
      Jr = u, u = { memoizedState: Jr.memoizedState, baseState: Jr.baseState, baseQueue: Jr.baseQueue, queue: Jr.queue, next: null }, Br === null ? dr.memoizedState = Br = u : Br = Br.next = u;
    }
    return Br;
  }
  function bn(u, d) {
    return typeof d == "function" ? d(u) : d;
  }
  function go(u) {
    var d = Or(), m = d.queue;
    if (m === null)
      throw Error(r(311));
    m.lastRenderedReducer = u;
    var w = Jr, M = w.baseQueue, F = m.pending;
    if (F !== null) {
      if (M !== null) {
        var H = M.next;
        M.next = F.next, F.next = H;
      }
      w.baseQueue = M = F, m.pending = null;
    }
    if (M !== null) {
      M = M.next, w = w.baseState;
      var te = H = F = null, me = M;
      do {
        var ze = me.lane;
        if ((Al & ze) === ze)
          te !== null && (te = te.next = { lane: 0, action: me.action, eagerReducer: me.eagerReducer, eagerState: me.eagerState, next: null }), w = me.eagerReducer === u ? me.eagerState : u(w, me.action);
        else {
          var vt = {
            lane: ze,
            action: me.action,
            eagerReducer: me.eagerReducer,
            eagerState: me.eagerState,
            next: null
          };
          te === null ? (H = te = vt, F = w) : te = te.next = vt, dr.lanes |= ze, Is |= ze;
        }
        me = me.next;
      } while (me !== null && me !== M);
      te === null ? F = w : te.next = H, Ln(w, d.memoizedState) || (ti = !0), d.memoizedState = w, d.baseState = F, d.baseQueue = te, m.lastRenderedState = w;
    }
    return [d.memoizedState, m.dispatch];
  }
  function Pl(u) {
    var d = Or(), m = d.queue;
    if (m === null)
      throw Error(r(311));
    m.lastRenderedReducer = u;
    var w = m.dispatch, M = m.pending, F = d.memoizedState;
    if (M !== null) {
      m.pending = null;
      var H = M = M.next;
      do
        F = u(F, H.action), H = H.next;
      while (H !== M);
      Ln(F, d.memoizedState) || (ti = !0), d.memoizedState = F, d.baseQueue === null && (d.baseState = F), m.lastRenderedState = F;
    }
    return [F, w];
  }
  function Nl(u, d, m) {
    var w = d._getVersion;
    w = w(d._source);
    var M = d._workInProgressVersionPrimary;
    if (M !== null ? u = M === w : (u = u.mutableReadLanes, (u = (Al & u) === u) && (d._workInProgressVersionPrimary = w, Cu.push(d))), u)
      return m(d._source);
    throw Cu.push(d), Error(r(350));
  }
  function ln(u, d, m, w) {
    var M = Ci;
    if (M === null)
      throw Error(r(349));
    var F = d._getVersion, H = F(d._source), te = Tc.current, me = te.useState(function() {
      return Nl(M, d, m);
    }), ze = me[1], vt = me[0];
    me = Br;
    var qt = u.memoizedState, Je = qt.refs, Mt = Je.getSnapshot, Qt = qt.source;
    qt = qt.subscribe;
    var It = dr;
    return u.memoizedState = { refs: Je, source: d, subscribe: w }, te.useEffect(function() {
      Je.getSnapshot = m, Je.setSnapshot = ze;
      var Me = F(d._source);
      if (!Ln(H, Me)) {
        Me = m(d._source), Ln(vt, Me) || (ze(Me), Me = bo(It), M.mutableReadLanes |= Me & M.pendingLanes), Me = M.mutableReadLanes, M.entangledLanes |= Me;
        for (var Ee = M.entanglements, Te = Me; 0 < Te; ) {
          var We = 31 - su(Te), Ye = 1 << We;
          Ee[We] |= Me, Te &= ~Ye;
        }
      }
    }, [m, d, w]), te.useEffect(function() {
      return w(d._source, function() {
        var Me = Je.getSnapshot, Ee = Je.setSnapshot;
        try {
          Ee(Me(d._source));
          var Te = bo(It);
          M.mutableReadLanes |= Te & M.pendingLanes;
        } catch (We) {
          Ee(function() {
            throw We;
          });
        }
      });
    }, [d, w]), Ln(Mt, m) && Ln(Qt, d) && Ln(qt, w) || (u = { pending: null, dispatch: null, lastRenderedReducer: bn, lastRenderedState: vt }, u.dispatch = ze = Mc.bind(null, dr, u), me.queue = u, me.baseQueue = null, vt = Nl(M, d, m), me.memoizedState = me.baseState = vt), vt;
  }
  function Iv(u, d, m) {
    var w = Or();
    return ln(w, u, d, m);
  }
  function Oc(u) {
    var d = Ge();
    return typeof u == "function" && (u = u()), d.memoizedState = d.baseState = u, u = d.queue = { pending: null, dispatch: null, lastRenderedReducer: bn, lastRenderedState: u }, u = u.dispatch = Mc.bind(null, dr, u), [d.memoizedState, u];
  }
  function Uo(u, d, m, w) {
    return u = { tag: u, create: d, destroy: m, deps: w, next: null }, d = dr.updateQueue, d === null ? (d = { lastEffect: null }, dr.updateQueue = d, d.lastEffect = u.next = u) : (m = d.lastEffect, m === null ? d.lastEffect = u.next = u : (w = m.next, m.next = u, u.next = w, d.lastEffect = u)), u;
  }
  function Kd(u) {
    var d = Ge();
    return u = { current: u }, d.memoizedState = u;
  }
  function As() {
    return Or().memoizedState;
  }
  function Dc(u, d, m, w) {
    var M = Ge();
    dr.flags |= u, M.memoizedState = Uo(1 | d, m, void 0, w === void 0 ? null : w);
  }
  function ei(u, d, m, w) {
    var M = Or();
    w = w === void 0 ? null : w;
    var F = void 0;
    if (Jr !== null) {
      var H = Jr.memoizedState;
      if (F = H.destroy, w !== null && Ms(w, H.deps)) {
        Uo(d, m, F, w);
        return;
      }
    }
    dr.flags |= u, M.memoizedState = Uo(1 | d, m, F, w);
  }
  function Qd(u, d) {
    return Dc(516, 4, u, d);
  }
  function Ru(u, d) {
    return ei(516, 4, u, d);
  }
  function Pf(u, d) {
    return ei(4, 2, u, d);
  }
  function Nf(u, d) {
    if (typeof d == "function")
      return u = u(), d(u), function() {
        d(null);
      };
    if (d != null)
      return u = u(), d.current = u, function() {
        d.current = null;
      };
  }
  function Xa(u, d, m) {
    return m = m != null ? m.concat([u]) : null, ei(4, 2, Nf.bind(null, d, u), m);
  }
  function Cn() {
  }
  function Tu(u, d) {
    var m = Or();
    d = d === void 0 ? null : d;
    var w = m.memoizedState;
    return w !== null && d !== null && Ms(d, w[1]) ? w[0] : (m.memoizedState = [u, d], u);
  }
  function Un(u, d) {
    var m = Or();
    d = d === void 0 ? null : d;
    var w = m.memoizedState;
    return w !== null && d !== null && Ms(d, w[1]) ? w[0] : (u = u(), m.memoizedState = [u, d], u);
  }
  function kl(u, d) {
    var m = xc();
    El(98 > m ? 98 : m, function() {
      u(!0);
    }), El(97 < m ? 97 : m, function() {
      var w = Wr.transition;
      Wr.transition = 1;
      try {
        u(!1), d();
      } finally {
        Wr.transition = w;
      }
    });
  }
  function Mc(u, d, m) {
    var w = ka(), M = bo(u), F = { lane: M, action: m, eagerReducer: null, eagerState: null, next: null }, H = d.pending;
    if (H === null ? F.next = F : (F.next = H.next, H.next = F), d.pending = F, H = u.alternate, u === dr || H !== null && H === dr)
      Ds = Af = !0;
    else {
      if (u.lanes === 0 && (H === null || H.lanes === 0) && (H = d.lastRenderedReducer, H !== null))
        try {
          var te = d.lastRenderedState, me = H(te, m);
          if (F.eagerReducer = H, F.eagerState = me, Ln(me, te))
            return;
        } catch {
        } finally {
        }
      Bs(u, M, w);
    }
  }
  var kf = { readContext: Aa, useCallback: Mi, useContext: Mi, useEffect: Mi, useImperativeHandle: Mi, useLayoutEffect: Mi, useMemo: Mi, useReducer: Mi, useRef: Mi, useState: Mi, useDebugValue: Mi, useDeferredValue: Mi, useTransition: Mi, useMutableSource: Mi, useOpaqueIdentifier: Mi, unstable_isNewReconciler: !1 }, Il = { readContext: Aa, useCallback: function(u, d) {
    return Ge().memoizedState = [u, d === void 0 ? null : d], u;
  }, useContext: Aa, useEffect: Qd, useImperativeHandle: function(u, d, m) {
    return m = m != null ? m.concat([u]) : null, Dc(4, 2, Nf.bind(
      null,
      d,
      u
    ), m);
  }, useLayoutEffect: function(u, d) {
    return Dc(4, 2, u, d);
  }, useMemo: function(u, d) {
    var m = Ge();
    return d = d === void 0 ? null : d, u = u(), m.memoizedState = [u, d], u;
  }, useReducer: function(u, d, m) {
    var w = Ge();
    return d = m !== void 0 ? m(d) : d, w.memoizedState = w.baseState = d, u = w.queue = { pending: null, dispatch: null, lastRenderedReducer: u, lastRenderedState: d }, u = u.dispatch = Mc.bind(null, dr, u), [w.memoizedState, u];
  }, useRef: Kd, useState: Oc, useDebugValue: Cn, useDeferredValue: function(u) {
    var d = Oc(u), m = d[0], w = d[1];
    return Qd(function() {
      var M = Wr.transition;
      Wr.transition = 1;
      try {
        w(u);
      } finally {
        Wr.transition = M;
      }
    }, [u]), m;
  }, useTransition: function() {
    var u = Oc(!1), d = u[0];
    return u = kl.bind(null, u[1]), Kd(u), [u, d];
  }, useMutableSource: function(u, d, m) {
    var w = Ge();
    return w.memoizedState = { refs: { getSnapshot: d, setSnapshot: null }, source: u, subscribe: m }, ln(w, u, d, m);
  }, useOpaqueIdentifier: function() {
    if (Fo) {
      var u = !1, d = Wd(function() {
        throw u || (u = !0, m("r:" + (br++).toString(36))), Error(r(355));
      }), m = Oc(d)[1];
      return (dr.mode & 2) === 0 && (dr.flags |= 516, Uo(
        5,
        function() {
          m("r:" + (br++).toString(36));
        },
        void 0,
        null
      )), d;
    }
    return d = "r:" + (br++).toString(36), Oc(d), d;
  }, unstable_isNewReconciler: !1 }, Pg = { readContext: Aa, useCallback: Tu, useContext: Aa, useEffect: Ru, useImperativeHandle: Xa, useLayoutEffect: Pf, useMemo: Un, useReducer: go, useRef: As, useState: function() {
    return go(bn);
  }, useDebugValue: Cn, useDeferredValue: function(u) {
    var d = go(bn), m = d[0], w = d[1];
    return Ru(function() {
      var M = Wr.transition;
      Wr.transition = 1;
      try {
        w(u);
      } finally {
        Wr.transition = M;
      }
    }, [u]), m;
  }, useTransition: function() {
    var u = go(bn)[0];
    return [
      As().current,
      u
    ];
  }, useMutableSource: Iv, useOpaqueIdentifier: function() {
    return go(bn)[0];
  }, unstable_isNewReconciler: !1 }, Lv = { readContext: Aa, useCallback: Tu, useContext: Aa, useEffect: Ru, useImperativeHandle: Xa, useLayoutEffect: Pf, useMemo: Un, useReducer: Pl, useRef: As, useState: function() {
    return Pl(bn);
  }, useDebugValue: Cn, useDeferredValue: function(u) {
    var d = Pl(bn), m = d[0], w = d[1];
    return Ru(function() {
      var M = Wr.transition;
      Wr.transition = 1;
      try {
        w(u);
      } finally {
        Wr.transition = M;
      }
    }, [u]), m;
  }, useTransition: function() {
    var u = Pl(bn)[0];
    return [
      As().current,
      u
    ];
  }, useMutableSource: Iv, useOpaqueIdentifier: function() {
    return Pl(bn)[0];
  }, unstable_isNewReconciler: !1 }, Bv = k.ReactCurrentOwner, ti = !1;
  function sa(u, d, m, w) {
    d.child = u === null ? Ts(d, null, m, w) : xu(d, u.child, m, w);
  }
  function Vo(u, d, m, w, M) {
    m = m.render;
    var F = d.ref;
    return bu(d, M), w = Xd(u, d, m, w, F, M), u !== null && !ti ? (d.updateQueue = u.updateQueue, d.flags &= -517, u.lanes &= ~M, ua(u, d, M)) : (d.flags |= 1, sa(u, d, w, M), d.child);
  }
  function Zd(u, d, m, w, M, F) {
    if (u === null) {
      var H = m.type;
      return typeof H == "function" && !fp(H) && H.defaultProps === void 0 && m.compare === null && m.defaultProps === void 0 ? (d.tag = 15, d.type = H, zv(u, d, H, w, M, F)) : (u = Zf(m.type, null, w, d, d.mode, F), u.ref = d.ref, u.return = d, d.child = u);
    }
    return H = u.child, (M & F) === 0 && (M = H.memoizedProps, m = m.compare, m = m !== null ? m : vl, m(M, w) && u.ref === d.ref) ? ua(u, d, F) : (d.flags |= 1, u = ku(H, w), u.ref = d.ref, u.return = d, d.child = u);
  }
  function zv(u, d, m, w, M, F) {
    if (u !== null && vl(u.memoizedProps, w) && u.ref === d.ref)
      if (ti = !1, (F & M) !== 0)
        (u.flags & 16384) !== 0 && (ti = !0);
      else
        return d.lanes = u.lanes, ua(u, d, F);
    return Fv(u, d, m, w, F);
  }
  function Ou(u, d, m) {
    var w = d.pendingProps, M = w.children, F = u !== null ? u.memoizedState : null;
    if (w.mode === "hidden" || w.mode === "unstable-defer-without-hiding")
      if ((d.mode & 4) === 0)
        d.memoizedState = { baseLanes: 0 }, Kf(d, m);
      else if ((m & 1073741824) !== 0)
        d.memoizedState = { baseLanes: 0 }, Kf(d, F !== null ? F.baseLanes : m);
      else
        return u = F !== null ? F.baseLanes | m : m, d.lanes = d.childLanes = 1073741824, d.memoizedState = { baseLanes: u }, Kf(d, u), null;
    else
      F !== null ? (w = F.baseLanes | m, d.memoizedState = null) : w = m, Kf(d, w);
    return sa(u, d, M, m), d.child;
  }
  function Ng(u, d) {
    var m = d.ref;
    (u === null && m !== null || u !== null && u.ref !== m) && (d.flags |= 128);
  }
  function Fv(u, d, m, w, M) {
    var F = Rr(m) ? xs : er.current;
    return F = G(d, F), bu(d, M), m = Xd(u, d, m, w, F, M), u !== null && !ti ? (d.updateQueue = u.updateQueue, d.flags &= -517, u.lanes &= ~M, ua(u, d, M)) : (d.flags |= 1, sa(u, d, m, M), d.child);
  }
  function kg(u, d, m, w, M) {
    if (Rr(m)) {
      var F = !0;
      Ya(d);
    } else
      F = !1;
    if (bu(d, M), d.stateNode === null)
      u !== null && (u.alternate = null, d.alternate = null, d.flags |= 2), Rl(d, m, w), jr(d, m, w, M), w = !0;
    else if (u === null) {
      var H = d.stateNode, te = d.memoizedProps;
      H.props = te;
      var me = H.context, ze = m.contextType;
      typeof ze == "object" && ze !== null ? ze = Aa(ze) : (ze = Rr(m) ? xs : er.current, ze = G(d, ze));
      var vt = m.getDerivedStateFromProps, qt = typeof vt == "function" || typeof H.getSnapshotBeforeUpdate == "function";
      qt || typeof H.UNSAFE_componentWillReceiveProps != "function" && typeof H.componentWillReceiveProps != "function" || (te !== w || me !== ze) && wf(d, H, w, ze), Vr = !1;
      var Je = d.memoizedState;
      H.state = Je, Bo(d, w, H, M), me = d.memoizedState, te !== w || Je !== me || Lr.current || Vr ? (typeof vt == "function" && (wc(d, m, vt, w), me = d.memoizedState), (te = Vr || Eu(d, m, te, w, Je, me, ze)) ? (qt || typeof H.UNSAFE_componentWillMount != "function" && typeof H.componentWillMount != "function" || (typeof H.componentWillMount == "function" && H.componentWillMount(), typeof H.UNSAFE_componentWillMount == "function" && H.UNSAFE_componentWillMount()), typeof H.componentDidMount == "function" && (d.flags |= 4)) : (typeof H.componentDidMount == "function" && (d.flags |= 4), d.memoizedProps = w, d.memoizedState = me), H.props = w, H.state = me, H.context = ze, w = te) : (typeof H.componentDidMount == "function" && (d.flags |= 4), w = !1);
    } else {
      H = d.stateNode, _u(u, d), te = d.memoizedProps, ze = d.type === d.elementType ? te : Zr(d.type, te), H.props = ze, qt = d.pendingProps, Je = H.context, me = m.contextType, typeof me == "object" && me !== null ? me = Aa(me) : (me = Rr(m) ? xs : er.current, me = G(d, me));
      var Mt = m.getDerivedStateFromProps;
      (vt = typeof Mt == "function" || typeof H.getSnapshotBeforeUpdate == "function") || typeof H.UNSAFE_componentWillReceiveProps != "function" && typeof H.componentWillReceiveProps != "function" || (te !== qt || Je !== me) && wf(d, H, w, me), Vr = !1, Je = d.memoizedState, H.state = Je, Bo(d, w, H, M);
      var Qt = d.memoizedState;
      te !== qt || Je !== Qt || Lr.current || Vr ? (typeof Mt == "function" && (wc(d, m, Mt, w), Qt = d.memoizedState), (ze = Vr || Eu(d, m, ze, w, Je, Qt, me)) ? (vt || typeof H.UNSAFE_componentWillUpdate != "function" && typeof H.componentWillUpdate != "function" || (typeof H.componentWillUpdate == "function" && H.componentWillUpdate(
        w,
        Qt,
        me
      ), typeof H.UNSAFE_componentWillUpdate == "function" && H.UNSAFE_componentWillUpdate(w, Qt, me)), typeof H.componentDidUpdate == "function" && (d.flags |= 4), typeof H.getSnapshotBeforeUpdate == "function" && (d.flags |= 256)) : (typeof H.componentDidUpdate != "function" || te === u.memoizedProps && Je === u.memoizedState || (d.flags |= 4), typeof H.getSnapshotBeforeUpdate != "function" || te === u.memoizedProps && Je === u.memoizedState || (d.flags |= 256), d.memoizedProps = w, d.memoizedState = Qt), H.props = w, H.state = Qt, H.context = me, w = ze) : (typeof H.componentDidUpdate != "function" || te === u.memoizedProps && Je === u.memoizedState || (d.flags |= 4), typeof H.getSnapshotBeforeUpdate != "function" || te === u.memoizedProps && Je === u.memoizedState || (d.flags |= 256), w = !1);
    }
    return Jd(u, d, m, w, F, M);
  }
  function Jd(u, d, m, w, M, F) {
    Ng(u, d);
    var H = (d.flags & 64) !== 0;
    if (!w && !H)
      return M && Tg(d, m, !1), ua(u, d, F);
    w = d.stateNode, Bv.current = d;
    var te = H && typeof m.getDerivedStateFromError != "function" ? null : w.render();
    return d.flags |= 1, u !== null && H ? (d.child = xu(d, u.child, null, F), d.child = xu(d, null, te, F)) : sa(u, d, te, F), d.memoizedState = w.state, M && Tg(d, m, !0), d.child;
  }
  function $v(u) {
    var d = u.stateNode;
    d.pendingContext ? xi(u, d.pendingContext, d.pendingContext !== d.context) : d.context && xi(u, d.context, !1), Tf(u, d.containerInfo);
  }
  var si = { dehydrated: null, retryLane: 0 };
  function Ps(u, d, m) {
    var w = d.pendingProps, M = _r.current, F = !1, H;
    return (H = (d.flags & 64) !== 0) || (H = u !== null && u.memoizedState === null ? !1 : (M & 2) !== 0), H ? (F = !0, d.flags &= -65) : u !== null && u.memoizedState === null || w.fallback === void 0 || w.unstable_avoidThisFallback === !0 || (M |= 1), Ht(_r, M & 1), u === null ? (w.fallback !== void 0 && Os(d), u = w.children, M = w.fallback, F ? (u = Uv(d, u, M, m), d.child.memoizedState = { baseLanes: m }, d.memoizedState = si, u) : typeof w.unstable_expectedLoadTime == "number" ? (u = Uv(d, u, M, m), d.child.memoizedState = { baseLanes: m }, d.memoizedState = si, d.lanes = 33554432, u) : (m = li({ mode: "visible", children: u }, d.mode, m, null), m.return = d, d.child = m)) : u.memoizedState !== null ? F ? (w = wi(u, d, w.children, w.fallback, m), F = d.child, M = u.child.memoizedState, F.memoizedState = M === null ? { baseLanes: m } : { baseLanes: M.baseLanes | m }, F.childLanes = u.childLanes & ~m, d.memoizedState = si, w) : (m = Bn(u, d, w.children, m), d.memoizedState = null, m) : F ? (w = wi(u, d, w.children, w.fallback, m), F = d.child, M = u.child.memoizedState, F.memoizedState = M === null ? { baseLanes: m } : { baseLanes: M.baseLanes | m }, F.childLanes = u.childLanes & ~m, d.memoizedState = si, w) : (m = Bn(u, d, w.children, m), d.memoizedState = null, m);
  }
  function Uv(u, d, m, w) {
    var M = u.mode, F = u.child;
    return d = { mode: "hidden", children: d }, (M & 2) === 0 && F !== null ? (F.childLanes = 0, F.pendingProps = d) : F = li(d, M, 0, null), m = Yo(m, M, w, null), F.return = u, m.return = u, F.sibling = m, u.child = F, m;
  }
  function Bn(u, d, m, w) {
    var M = u.child;
    return u = M.sibling, m = ku(M, { mode: "visible", children: m }), (d.mode & 2) === 0 && (m.lanes = w), m.return = d, m.sibling = null, u !== null && (u.nextEffect = null, u.flags = 8, d.firstEffect = d.lastEffect = u), d.child = m;
  }
  function wi(u, d, m, w, M) {
    var F = d.mode, H = u.child;
    u = H.sibling;
    var te = { mode: "hidden", children: m };
    return (F & 2) === 0 && d.child !== H ? (m = d.child, m.childLanes = 0, m.pendingProps = te, H = m.lastEffect, H !== null ? (d.firstEffect = m.firstEffect, d.lastEffect = H, H.nextEffect = null) : d.firstEffect = d.lastEffect = null) : m = ku(H, te), u !== null ? w = ku(u, w) : (w = Yo(w, F, M, null), w.flags |= 2), w.return = d, m.return = d, m.sibling = w, d.child = m, w;
  }
  function Pn(u, d) {
    u.lanes |= d;
    var m = u.alternate;
    m !== null && (m.lanes |= d), Pv(u.return, d);
  }
  function Ac(u, d, m, w, M, F) {
    var H = u.memoizedState;
    H === null ? u.memoizedState = { isBackwards: d, rendering: null, renderingStartTime: 0, last: w, tail: m, tailMode: M, lastEffect: F } : (H.isBackwards = d, H.rendering = null, H.renderingStartTime = 0, H.last = w, H.tail = m, H.tailMode = M, H.lastEffect = F);
  }
  function ep(u, d, m) {
    var w = d.pendingProps, M = w.revealOrder, F = w.tail;
    if (sa(u, d, w.children, m), w = _r.current, (w & 2) !== 0)
      w = w & 1 | 2, d.flags |= 64;
    else {
      if (u !== null && (u.flags & 64) !== 0)
        e:
          for (u = d.child; u !== null; ) {
            if (u.tag === 13)
              u.memoizedState !== null && Pn(u, m);
            else if (u.tag === 19)
              Pn(u, m);
            else if (u.child !== null) {
              u.child.return = u, u = u.child;
              continue;
            }
            if (u === d)
              break e;
            for (; u.sibling === null; ) {
              if (u.return === null || u.return === d)
                break e;
              u = u.return;
            }
            u.sibling.return = u.return, u = u.sibling;
          }
      w &= 1;
    }
    if (Ht(_r, w), (d.mode & 2) === 0)
      d.memoizedState = null;
    else
      switch (M) {
        case "forwards":
          for (m = d.child, M = null; m !== null; )
            u = m.alternate, u !== null && Of(u) === null && (M = m), m = m.sibling;
          m = M, m === null ? (M = d.child, d.child = null) : (M = m.sibling, m.sibling = null), Ac(d, !1, M, m, F, d.lastEffect);
          break;
        case "backwards":
          for (m = null, M = d.child, d.child = null; M !== null; ) {
            if (u = M.alternate, u !== null && Of(u) === null) {
              d.child = M;
              break;
            }
            u = M.sibling, M.sibling = m, m = M, M = u;
          }
          Ac(d, !0, m, null, F, d.lastEffect);
          break;
        case "together":
          Ac(d, !1, null, null, void 0, d.lastEffect);
          break;
        default:
          d.memoizedState = null;
      }
    return d.child;
  }
  function ua(u, d, m) {
    if (u !== null && (d.dependencies = u.dependencies), Is |= d.lanes, (m & d.childLanes) !== 0) {
      if (u !== null && d.child !== u.child)
        throw Error(r(153));
      if (d.child !== null) {
        for (u = d.child, m = ku(u, u.pendingProps), d.child = m, m.return = d; u.sibling !== null; )
          u = u.sibling, m = m.sibling = ku(u, u.pendingProps), m.return = d;
        m.sibling = null;
      }
      return d.child;
    }
    return null;
  }
  var If, Ll, Ig, tp;
  If = function(u, d) {
    for (var m = d.child; m !== null; ) {
      if (m.tag === 5 || m.tag === 6)
        u.appendChild(m.stateNode);
      else if (m.tag !== 4 && m.child !== null) {
        m.child.return = m, m = m.child;
        continue;
      }
      if (m === d)
        break;
      for (; m.sibling === null; ) {
        if (m.return === null || m.return === d)
          return;
        m = m.return;
      }
      m.sibling.return = m.return, m = m.sibling;
    }
  }, Ll = function() {
  }, Ig = function(u, d, m, w) {
    var M = u.memoizedProps;
    if (M !== w) {
      u = d.stateNode, Dl(pr.current);
      var F = null;
      switch (m) {
        case "input":
          M = pt(u, M), w = pt(u, w), F = [];
          break;
        case "option":
          M = Gt(u, M), w = Gt(u, w), F = [];
          break;
        case "select":
          M = t({}, M, { value: void 0 }), w = t({}, w, { value: void 0 }), F = [];
          break;
        case "textarea":
          M = gn(u, M), w = gn(u, w), F = [];
          break;
        default:
          typeof M.onClick != "function" && typeof w.onClick == "function" && (u.onclick = Vd);
      }
      Ji(m, w);
      var H;
      m = null;
      for (ze in M)
        if (!w.hasOwnProperty(ze) && M.hasOwnProperty(ze) && M[ze] != null)
          if (ze === "style") {
            var te = M[ze];
            for (H in te)
              te.hasOwnProperty(H) && (m || (m = {}), m[H] = "");
          } else
            ze !== "dangerouslySetInnerHTML" && ze !== "children" && ze !== "suppressContentEditableWarning" && ze !== "suppressHydrationWarning" && ze !== "autoFocus" && (s.hasOwnProperty(ze) ? F || (F = []) : (F = F || []).push(ze, null));
      for (ze in w) {
        var me = w[ze];
        if (te = M != null ? M[ze] : void 0, w.hasOwnProperty(ze) && me !== te && (me != null || te != null))
          if (ze === "style")
            if (te) {
              for (H in te)
                !te.hasOwnProperty(H) || me && me.hasOwnProperty(H) || (m || (m = {}), m[H] = "");
              for (H in me)
                me.hasOwnProperty(H) && te[H] !== me[H] && (m || (m = {}), m[H] = me[H]);
            } else
              m || (F || (F = []), F.push(ze, m)), m = me;
          else
            ze === "dangerouslySetInnerHTML" ? (me = me ? me.__html : void 0, te = te ? te.__html : void 0, me != null && te !== me && (F = F || []).push(ze, me)) : ze === "children" ? typeof me != "string" && typeof me != "number" || (F = F || []).push(ze, "" + me) : ze !== "suppressContentEditableWarning" && ze !== "suppressHydrationWarning" && (s.hasOwnProperty(ze) ? (me != null && ze === "onScroll" && Jn("scroll", u), F || te === me || (F = [])) : typeof me == "object" && me !== null && me.$$typeof === Oe ? me.toString() : (F = F || []).push(ze, me));
      }
      m && (F = F || []).push(
        "style",
        m
      );
      var ze = F;
      (d.updateQueue = ze) && (d.flags |= 4);
    }
  }, tp = function(u, d, m, w) {
    m !== w && (d.flags |= 4);
  };
  function jo(u, d) {
    if (!Fo)
      switch (u.tailMode) {
        case "hidden":
          d = u.tail;
          for (var m = null; d !== null; )
            d.alternate !== null && (m = d), d = d.sibling;
          m === null ? u.tail = null : m.sibling = null;
          break;
        case "collapsed":
          m = u.tail;
          for (var w = null; m !== null; )
            m.alternate !== null && (w = m), m = m.sibling;
          w === null ? d || u.tail === null ? u.tail = null : u.tail.sibling = null : w.sibling = null;
      }
  }
  function Lf(u, d, m) {
    var w = d.pendingProps;
    switch (d.tag) {
      case 2:
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return null;
      case 1:
        return Rr(d.type) && Oa(), null;
      case 3:
        return wu(), nn(Lr), nn(er), $o(), w = d.stateNode, w.pendingContext && (w.context = w.pendingContext, w.pendingContext = null), (u === null || u.child === null) && (Mf(d) ? d.flags |= 4 : w.hydrate || (d.flags |= 256)), Ll(d), null;
      case 5:
        Ml(d);
        var M = Dl(Rf.current);
        if (m = d.type, u !== null && d.stateNode != null)
          Ig(u, d, m, w, M), u.ref !== d.ref && (d.flags |= 128);
        else {
          if (!w) {
            if (d.stateNode === null)
              throw Error(r(166));
            return null;
          }
          if (u = Dl(pr.current), Mf(d)) {
            w = d.stateNode, m = d.type;
            var F = d.memoizedProps;
            switch (w[fo] = d, w[Gd] = F, m) {
              case "dialog":
                Jn("cancel", w), Jn("close", w);
                break;
              case "iframe":
              case "object":
              case "embed":
                Jn("load", w);
                break;
              case "video":
              case "audio":
                for (u = 0; u < yc.length; u++)
                  Jn(yc[u], w);
                break;
              case "source":
                Jn("error", w);
                break;
              case "img":
              case "image":
              case "link":
                Jn("error", w), Jn("load", w);
                break;
              case "details":
                Jn("toggle", w);
                break;
              case "input":
                en(w, F), Jn("invalid", w);
                break;
              case "select":
                w._wrapperState = { wasMultiple: !!F.multiple }, Jn("invalid", w);
                break;
              case "textarea":
                rr(w, F), Jn("invalid", w);
            }
            Ji(m, F), u = null;
            for (var H in F)
              F.hasOwnProperty(H) && (M = F[H], H === "children" ? typeof M == "string" ? w.textContent !== M && (u = ["children", M]) : typeof M == "number" && w.textContent !== "" + M && (u = ["children", "" + M]) : s.hasOwnProperty(H) && M != null && H === "onScroll" && Jn("scroll", w));
            switch (m) {
              case "input":
                qe(w), Vn(w, F, !0);
                break;
              case "textarea":
                qe(w), At(w);
                break;
              case "select":
              case "option":
                break;
              default:
                typeof F.onClick == "function" && (w.onclick = Vd);
            }
            w = u, d.updateQueue = w, w !== null && (d.flags |= 4);
          } else {
            switch (H = M.nodeType === 9 ? M : M.ownerDocument, u === at.html && (u = bt(m)), u === at.html ? m === "script" ? (u = H.createElement("div"), u.innerHTML = "<script><\/script>", u = u.removeChild(u.firstChild)) : typeof w.is == "string" ? u = H.createElement(m, { is: w.is }) : (u = H.createElement(m), m === "select" && (H = u, w.multiple ? H.multiple = !0 : w.size && (H.size = w.size))) : u = H.createElementNS(u, m), u[fo] = d, u[Gd] = w, If(u, d, !1, !1), d.stateNode = u, H = so(m, w), m) {
              case "dialog":
                Jn("cancel", u), Jn("close", u), M = w;
                break;
              case "iframe":
              case "object":
              case "embed":
                Jn("load", u), M = w;
                break;
              case "video":
              case "audio":
                for (M = 0; M < yc.length; M++)
                  Jn(yc[M], u);
                M = w;
                break;
              case "source":
                Jn("error", u), M = w;
                break;
              case "img":
              case "image":
              case "link":
                Jn("error", u), Jn("load", u), M = w;
                break;
              case "details":
                Jn("toggle", u), M = w;
                break;
              case "input":
                en(u, w), M = pt(u, w), Jn("invalid", u);
                break;
              case "option":
                M = Gt(u, w);
                break;
              case "select":
                u._wrapperState = { wasMultiple: !!w.multiple }, M = t({}, w, { value: void 0 }), Jn("invalid", u);
                break;
              case "textarea":
                rr(u, w), M = gn(u, w), Jn("invalid", u);
                break;
              default:
                M = w;
            }
            Ji(m, M);
            var te = M;
            for (F in te)
              if (te.hasOwnProperty(F)) {
                var me = te[F];
                F === "style" ? jn(u, me) : F === "dangerouslySetInnerHTML" ? (me = me ? me.__html : void 0, me != null && Nn(u, me)) : F === "children" ? typeof me == "string" ? (m !== "textarea" || me !== "") && kn(u, me) : typeof me == "number" && kn(u, "" + me) : F !== "suppressContentEditableWarning" && F !== "suppressHydrationWarning" && F !== "autoFocus" && (s.hasOwnProperty(F) ? me != null && F === "onScroll" && Jn("scroll", u) : me != null && L(u, F, me, H));
              }
            switch (m) {
              case "input":
                qe(u), Vn(u, w, !1);
                break;
              case "textarea":
                qe(u), At(u);
                break;
              case "option":
                w.value != null && u.setAttribute("value", "" + oe(w.value));
                break;
              case "select":
                u.multiple = !!w.multiple, F = w.value, F != null ? xn(u, !!w.multiple, F, !1) : w.defaultValue != null && xn(u, !!w.multiple, w.defaultValue, !0);
                break;
              default:
                typeof M.onClick == "function" && (u.onclick = Vd);
            }
            _s(m, w) && (d.flags |= 4);
          }
          d.ref !== null && (d.flags |= 128);
        }
        return null;
      case 6:
        if (u && d.stateNode != null)
          tp(u, d, u.memoizedProps, w);
        else {
          if (typeof w != "string" && d.stateNode === null)
            throw Error(r(166));
          m = Dl(Rf.current), Dl(pr.current), Mf(d) ? (w = d.stateNode, m = d.memoizedProps, w[fo] = d, w.nodeValue !== m && (d.flags |= 4)) : (w = (m.nodeType === 9 ? m : m.ownerDocument).createTextNode(w), w[fo] = d, d.stateNode = w);
        }
        return null;
      case 13:
        return nn(_r), w = d.memoizedState, (d.flags & 64) !== 0 ? (d.lanes = m, d) : (w = w !== null, m = !1, u === null ? d.memoizedProps.fallback !== void 0 && Mf(d) : m = u.memoizedState !== null, w && !m && (d.mode & 2) !== 0 && (u === null && d.memoizedProps.unstable_avoidThisFallback !== !0 || (_r.current & 1) !== 0 ? Gr === 0 && (Gr = 3) : ((Gr === 0 || Gr === 3) && (Gr = 4), Ci === null || (Is & 134217727) === 0 && (yo & 134217727) === 0 || Ho(Ci, Dr))), (w || m) && (d.flags |= 4), null);
      case 4:
        return wu(), Ll(d), u === null && Ud(d.stateNode.containerInfo), null;
      case 10:
        return wl(d), null;
      case 17:
        return Rr(d.type) && Oa(), null;
      case 19:
        if (nn(_r), w = d.memoizedState, w === null)
          return null;
        if (F = (d.flags & 64) !== 0, H = w.rendering, H === null)
          if (F)
            jo(w, !1);
          else {
            if (Gr !== 0 || u !== null && (u.flags & 64) !== 0)
              for (u = d.child; u !== null; ) {
                if (H = Of(u), H !== null) {
                  for (d.flags |= 64, jo(w, !1), F = H.updateQueue, F !== null && (d.updateQueue = F, d.flags |= 4), w.lastEffect === null && (d.firstEffect = null), d.lastEffect = w.lastEffect, w = m, m = d.child; m !== null; )
                    F = m, u = w, F.flags &= 2, F.nextEffect = null, F.firstEffect = null, F.lastEffect = null, H = F.alternate, H === null ? (F.childLanes = 0, F.lanes = u, F.child = null, F.memoizedProps = null, F.memoizedState = null, F.updateQueue = null, F.dependencies = null, F.stateNode = null) : (F.childLanes = H.childLanes, F.lanes = H.lanes, F.child = H.child, F.memoizedProps = H.memoizedProps, F.memoizedState = H.memoizedState, F.updateQueue = H.updateQueue, F.type = H.type, u = H.dependencies, F.dependencies = u === null ? null : { lanes: u.lanes, firstContext: u.firstContext }), m = m.sibling;
                  return Ht(_r, _r.current & 1 | 2), d.child;
                }
                u = u.sibling;
              }
            w.tail !== null && Si() > Du && (d.flags |= 64, F = !0, jo(w, !1), d.lanes = 33554432);
          }
        else {
          if (!F)
            if (u = Of(H), u !== null) {
              if (d.flags |= 64, F = !0, m = u.updateQueue, m !== null && (d.updateQueue = m, d.flags |= 4), jo(w, !0), w.tail === null && w.tailMode === "hidden" && !H.alternate && !Fo)
                return d = d.lastEffect = w.lastEffect, d !== null && (d.nextEffect = null), null;
            } else
              2 * Si() - w.renderingStartTime > Du && m !== 1073741824 && (d.flags |= 64, F = !0, jo(w, !1), d.lanes = 33554432);
          w.isBackwards ? (H.sibling = d.child, d.child = H) : (m = w.last, m !== null ? m.sibling = H : d.child = H, w.last = H);
        }
        return w.tail !== null ? (m = w.tail, w.rendering = m, w.tail = m.sibling, w.lastEffect = d.lastEffect, w.renderingStartTime = Si(), m.sibling = null, d = _r.current, Ht(_r, F ? d & 1 | 2 : d & 1), m) : null;
      case 23:
      case 24:
        return Ka(), u !== null && u.memoizedState !== null != (d.memoizedState !== null) && w.mode !== "unstable-defer-without-hiding" && (d.flags |= 4), null;
    }
    throw Error(r(156, d.tag));
  }
  function Lg(u) {
    switch (u.tag) {
      case 1:
        Rr(u.type) && Oa();
        var d = u.flags;
        return d & 4096 ? (u.flags = d & -4097 | 64, u) : null;
      case 3:
        if (wu(), nn(Lr), nn(er), $o(), d = u.flags, (d & 64) !== 0)
          throw Error(r(285));
        return u.flags = d & -4097 | 64, u;
      case 5:
        return Ml(u), null;
      case 13:
        return nn(_r), d = u.flags, d & 4096 ? (u.flags = d & -4097 | 64, u) : null;
      case 19:
        return nn(_r), null;
      case 4:
        return wu(), null;
      case 10:
        return wl(u), null;
      case 23:
      case 24:
        return Ka(), null;
      default:
        return null;
    }
  }
  function np(u, d) {
    try {
      var m = "", w = d;
      do
        m += Ne(w), w = w.return;
      while (w);
      var M = m;
    } catch (F) {
      M = `
Error generating stack: ` + F.message + `
` + F.stack;
    }
    return { value: u, source: d, stack: M };
  }
  function rp(u, d) {
    try {
      console.error(d.value);
    } catch (m) {
      setTimeout(function() {
        throw m;
      });
    }
  }
  var Bf = typeof WeakMap == "function" ? WeakMap : Map;
  function Vv(u, d, m) {
    m = Tr(-1, m), m.tag = 3, m.payload = { element: null };
    var w = d.value;
    return m.callback = function() {
      jf || (jf = !0, Xv = w), rp(u, d);
    }, m;
  }
  function zf(u, d, m) {
    m = Tr(-1, m), m.tag = 3;
    var w = u.type.getDerivedStateFromError;
    if (typeof w == "function") {
      var M = d.value;
      m.payload = function() {
        return rp(u, d), w(M);
      };
    }
    var F = u.stateNode;
    return F !== null && typeof F.componentDidCatch == "function" && (m.callback = function() {
      typeof w != "function" && (Wo === null ? Wo = /* @__PURE__ */ new Set([this]) : Wo.add(this), rp(u, d));
      var H = d.stack;
      this.componentDidCatch(d.value, { componentStack: H !== null ? H : "" });
    }), m;
  }
  var jv = typeof WeakSet == "function" ? WeakSet : Set;
  function Ff(u) {
    var d = u.ref;
    if (d !== null)
      if (typeof d == "function")
        try {
          d(null);
        } catch (m) {
          zs(u, m);
        }
      else
        d.current = null;
  }
  function Uy(u, d) {
    switch (d.tag) {
      case 0:
      case 11:
      case 15:
      case 22:
        return;
      case 1:
        if (d.flags & 256 && u !== null) {
          var m = u.memoizedProps, w = u.memoizedState;
          u = d.stateNode, d = u.getSnapshotBeforeUpdate(d.elementType === d.type ? m : Zr(d.type, m), w), u.__reactInternalSnapshotBeforeUpdate = d;
        }
        return;
      case 3:
        d.flags & 256 && jd(d.stateNode.containerInfo);
        return;
      case 5:
      case 6:
      case 4:
      case 17:
        return;
    }
    throw Error(r(163));
  }
  function ip(u, d, m) {
    switch (m.tag) {
      case 0:
      case 11:
      case 15:
      case 22:
        if (d = m.updateQueue, d = d !== null ? d.lastEffect : null, d !== null) {
          u = d = d.next;
          do {
            if ((u.tag & 3) === 3) {
              var w = u.create;
              u.destroy = w();
            }
            u = u.next;
          } while (u !== d);
        }
        if (d = m.updateQueue, d = d !== null ? d.lastEffect : null, d !== null) {
          u = d = d.next;
          do {
            var M = u;
            w = M.next, M = M.tag, (M & 4) !== 0 && (M & 1) !== 0 && (Jv(m, u), Vg(m, u)), u = w;
          } while (u !== d);
        }
        return;
      case 1:
        u = m.stateNode, m.flags & 4 && (d === null ? u.componentDidMount() : (w = m.elementType === m.type ? d.memoizedProps : Zr(m.type, d.memoizedProps), u.componentDidUpdate(
          w,
          d.memoizedState,
          u.__reactInternalSnapshotBeforeUpdate
        ))), d = m.updateQueue, d !== null && Cl(m, d, u);
        return;
      case 3:
        if (d = m.updateQueue, d !== null) {
          if (u = null, m.child !== null)
            switch (m.child.tag) {
              case 5:
                u = m.child.stateNode;
                break;
              case 1:
                u = m.child.stateNode;
            }
          Cl(m, d, u);
        }
        return;
      case 5:
        u = m.stateNode, d === null && m.flags & 4 && _s(m.type, m.memoizedProps) && u.focus();
        return;
      case 6:
        return;
      case 4:
        return;
      case 12:
        return;
      case 13:
        m.memoizedState === null && (m = m.alternate, m !== null && (m = m.memoizedState, m !== null && (m = m.dehydrated, m !== null && sl(m))));
        return;
      case 19:
      case 17:
      case 20:
      case 21:
      case 23:
      case 24:
        return;
    }
    throw Error(r(163));
  }
  function Pc(u, d) {
    for (var m = u; ; ) {
      if (m.tag === 5) {
        var w = m.stateNode;
        if (d)
          w = w.style, typeof w.setProperty == "function" ? w.setProperty("display", "none", "important") : w.display = "none";
        else {
          w = m.stateNode;
          var M = m.memoizedProps.style;
          M = M != null && M.hasOwnProperty("display") ? M.display : null, w.style.display = Nt("display", M);
        }
      } else if (m.tag === 6)
        m.stateNode.nodeValue = d ? "" : m.memoizedProps;
      else if ((m.tag !== 23 && m.tag !== 24 || m.memoizedState === null || m === u) && m.child !== null) {
        m.child.return = m, m = m.child;
        continue;
      }
      if (m === u)
        break;
      for (; m.sibling === null; ) {
        if (m.return === null || m.return === u)
          return;
        m = m.return;
      }
      m.sibling.return = m.return, m = m.sibling;
    }
  }
  function Wv(u, d) {
    if (Da && typeof Da.onCommitFiberUnmount == "function")
      try {
        Da.onCommitFiberUnmount(Ov, d);
      } catch {
      }
    switch (d.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
      case 22:
        if (u = d.updateQueue, u !== null && (u = u.lastEffect, u !== null)) {
          var m = u = u.next;
          do {
            var w = m, M = w.destroy;
            if (w = w.tag, M !== void 0)
              if ((w & 4) !== 0)
                Jv(d, m);
              else {
                w = d;
                try {
                  M();
                } catch (F) {
                  zs(w, F);
                }
              }
            m = m.next;
          } while (m !== u);
        }
        break;
      case 1:
        if (Ff(d), u = d.stateNode, typeof u.componentWillUnmount == "function")
          try {
            u.props = d.memoizedProps, u.state = d.memoizedState, u.componentWillUnmount();
          } catch (F) {
            zs(
              d,
              F
            );
          }
        break;
      case 5:
        Ff(d);
        break;
      case 4:
        Hv(u, d);
    }
  }
  function ap(u) {
    u.alternate = null, u.child = null, u.dependencies = null, u.firstEffect = null, u.lastEffect = null, u.memoizedProps = null, u.memoizedState = null, u.pendingProps = null, u.return = null, u.updateQueue = null;
  }
  function Bg(u) {
    return u.tag === 5 || u.tag === 3 || u.tag === 4;
  }
  function Gv(u) {
    e: {
      for (var d = u.return; d !== null; ) {
        if (Bg(d))
          break e;
        d = d.return;
      }
      throw Error(r(160));
    }
    var m = d;
    switch (d = m.stateNode, m.tag) {
      case 5:
        var w = !1;
        break;
      case 3:
        d = d.containerInfo, w = !0;
        break;
      case 4:
        d = d.containerInfo, w = !0;
        break;
      default:
        throw Error(r(161));
    }
    m.flags & 16 && (kn(d, ""), m.flags &= -17);
    e:
      t:
        for (m = u; ; ) {
          for (; m.sibling === null; ) {
            if (m.return === null || Bg(m.return)) {
              m = null;
              break e;
            }
            m = m.return;
          }
          for (m.sibling.return = m.return, m = m.sibling; m.tag !== 5 && m.tag !== 6 && m.tag !== 18; ) {
            if (m.flags & 2 || m.child === null || m.tag === 4)
              continue t;
            m.child.return = m, m = m.child;
          }
          if (!(m.flags & 2)) {
            m = m.stateNode;
            break e;
          }
        }
    w ? Na(u, m, d) : Nc(u, m, d);
  }
  function Na(u, d, m) {
    var w = u.tag, M = w === 5 || w === 6;
    if (M)
      u = M ? u.stateNode : u.stateNode.instance, d ? m.nodeType === 8 ? m.parentNode.insertBefore(u, d) : m.insertBefore(u, d) : (m.nodeType === 8 ? (d = m.parentNode, d.insertBefore(u, m)) : (d = m, d.appendChild(u)), m = m._reactRootContainer, m != null || d.onclick !== null || (d.onclick = Vd));
    else if (w !== 4 && (u = u.child, u !== null))
      for (Na(u, d, m), u = u.sibling; u !== null; )
        Na(u, d, m), u = u.sibling;
  }
  function Nc(u, d, m) {
    var w = u.tag, M = w === 5 || w === 6;
    if (M)
      u = M ? u.stateNode : u.stateNode.instance, d ? m.insertBefore(u, d) : m.appendChild(u);
    else if (w !== 4 && (u = u.child, u !== null))
      for (Nc(u, d, m), u = u.sibling; u !== null; )
        Nc(u, d, m), u = u.sibling;
  }
  function Hv(u, d) {
    for (var m = d, w = !1, M, F; ; ) {
      if (!w) {
        w = m.return;
        e:
          for (; ; ) {
            if (w === null)
              throw Error(r(160));
            switch (M = w.stateNode, w.tag) {
              case 5:
                F = !1;
                break e;
              case 3:
                M = M.containerInfo, F = !0;
                break e;
              case 4:
                M = M.containerInfo, F = !0;
                break e;
            }
            w = w.return;
          }
        w = !0;
      }
      if (m.tag === 5 || m.tag === 6) {
        e:
          for (var H = u, te = m, me = te; ; )
            if (Wv(H, me), me.child !== null && me.tag !== 4)
              me.child.return = me, me = me.child;
            else {
              if (me === te)
                break e;
              for (; me.sibling === null; ) {
                if (me.return === null || me.return === te)
                  break e;
                me = me.return;
              }
              me.sibling.return = me.return, me = me.sibling;
            }
        F ? (H = M, te = m.stateNode, H.nodeType === 8 ? H.parentNode.removeChild(te) : H.removeChild(te)) : M.removeChild(m.stateNode);
      } else if (m.tag === 4) {
        if (m.child !== null) {
          M = m.stateNode.containerInfo, F = !0, m.child.return = m, m = m.child;
          continue;
        }
      } else if (Wv(u, m), m.child !== null) {
        m.child.return = m, m = m.child;
        continue;
      }
      if (m === d)
        break;
      for (; m.sibling === null; ) {
        if (m.return === null || m.return === d)
          return;
        m = m.return, m.tag === 4 && (w = !1);
      }
      m.sibling.return = m.return, m = m.sibling;
    }
  }
  function Yv(u, d) {
    switch (d.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
      case 22:
        var m = d.updateQueue;
        if (m = m !== null ? m.lastEffect : null, m !== null) {
          var w = m = m.next;
          do
            (w.tag & 3) === 3 && (u = w.destroy, w.destroy = void 0, u !== void 0 && u()), w = w.next;
          while (w !== m);
        }
        return;
      case 1:
        return;
      case 5:
        if (m = d.stateNode, m != null) {
          w = d.memoizedProps;
          var M = u !== null ? u.memoizedProps : w;
          u = d.type;
          var F = d.updateQueue;
          if (d.updateQueue = null, F !== null) {
            for (m[Gd] = w, u === "input" && w.type === "radio" && w.name != null && wt(m, w), so(u, M), d = so(u, w), M = 0; M < F.length; M += 2) {
              var H = F[M], te = F[M + 1];
              H === "style" ? jn(m, te) : H === "dangerouslySetInnerHTML" ? Nn(m, te) : H === "children" ? kn(m, te) : L(m, H, te, d);
            }
            switch (u) {
              case "input":
                tn(m, w);
                break;
              case "textarea":
                Zi(m, w);
                break;
              case "select":
                u = m._wrapperState.wasMultiple, m._wrapperState.wasMultiple = !!w.multiple, F = w.value, F != null ? xn(m, !!w.multiple, F, !1) : u !== !!w.multiple && (w.defaultValue != null ? xn(m, !!w.multiple, w.defaultValue, !0) : xn(m, !!w.multiple, w.multiple ? [] : "", !1));
            }
          }
        }
        return;
      case 6:
        if (d.stateNode === null)
          throw Error(r(162));
        d.stateNode.nodeValue = d.memoizedProps;
        return;
      case 3:
        m = d.stateNode, m.hydrate && (m.hydrate = !1, sl(m.containerInfo));
        return;
      case 12:
        return;
      case 13:
        d.memoizedState !== null && (Vf = Si(), Pc(d.child, !0)), qv(d);
        return;
      case 19:
        qv(d);
        return;
      case 17:
        return;
      case 23:
      case 24:
        Pc(d, d.memoizedState !== null);
        return;
    }
    throw Error(r(163));
  }
  function qv(u) {
    var d = u.updateQueue;
    if (d !== null) {
      u.updateQueue = null;
      var m = u.stateNode;
      m === null && (m = u.stateNode = new jv()), d.forEach(function(w) {
        var M = Hy.bind(null, u, w);
        m.has(w) || (m.add(w), w.then(M, M));
      });
    }
  }
  function Vy(u, d) {
    return u !== null && (u = u.memoizedState, u === null || u.dehydrated !== null) ? (d = d.memoizedState, d !== null && d.dehydrated === null) : !1;
  }
  var $f = Math.ceil, la = k.ReactCurrentDispatcher, Ns = k.ReactCurrentOwner, Yt = 0, Ci = null, Er = null, Dr = 0, Dt = 0, ks = Hi(0), Gr = 0, Mr = null, mo = 0, Is = 0, yo = 0, ui = 0, Uf = null, Vf = 0, Du = 1 / 0;
  function kc() {
    Du = Si() + 500;
  }
  var gt = null, jf = !1, Xv = null, Wo = null, Ai = !1, zr = null, Bl = 90, Kv = [], Wf = [], Ls = null, Gf = 0, Mu = null, Hf = -1, Go = 0, op = 0, Yf = null, sp = !1;
  function ka() {
    return (Yt & 48) !== 0 ? Si() : Hf !== -1 ? Hf : Hf = Si();
  }
  function bo(u) {
    if (u = u.mode, (u & 2) === 0)
      return 1;
    if ((u & 4) === 0)
      return xc() === 99 ? 1 : 2;
    if (Go === 0 && (Go = mo), mu.transition !== 0) {
      op !== 0 && (op = Uf !== null ? Uf.pendingLanes : 0), u = Go;
      var d = 4186112 & ~op;
      return d &= -d, d === 0 && (u = 4186112 & ~u, d = u & -u, d === 0 && (d = 8192)), d;
    }
    return u = xc(), (Yt & 4) !== 0 && u === 98 ? u = Pd(12, Go) : (u = lg(u), u = Pd(u, Go)), u;
  }
  function Bs(u, d, m) {
    if (50 < Gf)
      throw Gf = 0, Mu = null, Error(r(185));
    if (u = up(u, d), u === null)
      return null;
    uf(u, d, m), u === Ci && (yo |= d, Gr === 4 && Ho(u, Dr));
    var w = xc();
    d === 1 ? (Yt & 8) !== 0 && (Yt & 48) === 0 ? qf(u) : (ca(u, m), Yt === 0 && (kc(), oi())) : ((Yt & 4) === 0 || w !== 98 && w !== 99 || (Ls === null ? Ls = /* @__PURE__ */ new Set([u]) : Ls.add(u)), ca(u, m)), Uf = u;
  }
  function up(u, d) {
    u.lanes |= d;
    var m = u.alternate;
    for (m !== null && (m.lanes |= d), m = u, u = u.return; u !== null; )
      u.childLanes |= d, m = u.alternate, m !== null && (m.childLanes |= d), m = u, u = u.return;
    return m.tag === 3 ? m.stateNode : null;
  }
  function ca(u, d) {
    for (var m = u.callbackNode, w = u.suspendedLanes, M = u.pingedLanes, F = u.expirationTimes, H = u.pendingLanes; 0 < H; ) {
      var te = 31 - su(H), me = 1 << te, ze = F[te];
      if (ze === -1) {
        if ((me & w) === 0 || (me & M) !== 0) {
          ze = d, ds(me);
          var vt = Wn;
          F[te] = 10 <= vt ? ze + 250 : 6 <= vt ? ze + 5e3 : -1;
        }
      } else
        ze <= d && (u.expiredLanes |= me);
      H &= ~me;
    }
    if (w = dc(u, u === Ci ? Dr : 0), d = Wn, w === 0)
      m !== null && (m !== Av && Ef(m), u.callbackNode = null, u.callbackPriority = 0);
    else {
      if (m !== null) {
        if (u.callbackPriority === d)
          return;
        m !== Av && Ef(m);
      }
      d === 15 ? (m = qf.bind(null, u), Io === null ? (Io = [m], Yd = po(Hd, Ss)) : Io.push(m), m = Av) : d === 14 ? m = xl(99, qf.bind(null, u)) : (m = dv(d), m = xl(m, lp.bind(null, u))), u.callbackPriority = d, u.callbackNode = m;
    }
  }
  function lp(u) {
    if (Hf = -1, op = Go = 0, (Yt & 48) !== 0)
      throw Error(r(327));
    var d = u.callbackNode;
    if (Pu() && u.callbackNode !== d)
      return null;
    var m = dc(u, u === Ci ? Dr : 0);
    if (m === 0)
      return null;
    var w = m, M = Yt;
    Yt |= 16;
    var F = zl();
    (Ci !== u || Dr !== w) && (kc(), Ia(u, w));
    do
      try {
        $g();
        break;
      } catch (te) {
        cp(u, te);
      }
    while (1);
    if (Sl(), la.current = F, Yt = M, Er !== null ? w = 0 : (Ci = null, Dr = 0, w = Gr), (mo & yo) !== 0)
      Ia(u, 0);
    else if (w !== 0) {
      if (w === 2 && (Yt |= 64, u.hydrate && (u.hydrate = !1, jd(u.containerInfo)), m = cg(u), m !== 0 && (w = Qf(u, m))), w === 1)
        throw d = Mr, Ia(u, 0), Ho(u, m), ca(u, Si()), d;
      switch (u.finishedWork = u.current.alternate, u.finishedLanes = m, w) {
        case 0:
        case 1:
          throw Error(r(345));
        case 2:
          Au(u);
          break;
        case 3:
          if (Ho(u, m), (m & 62914560) === m && (w = Vf + 500 - Si(), 10 < w)) {
            if (dc(u, 0) !== 0)
              break;
            if (M = u.suspendedLanes, (M & m) !== m) {
              ka(), u.pingedLanes |= u.suspendedLanes & M;
              break;
            }
            u.timeoutHandle = _c(Au.bind(null, u), w);
            break;
          }
          Au(u);
          break;
        case 4:
          if (Ho(u, m), (m & 4186112) === m)
            break;
          for (w = u.eventTimes, M = -1; 0 < m; ) {
            var H = 31 - su(m);
            F = 1 << H, H = w[H], H > M && (M = H), m &= ~F;
          }
          if (m = M, m = Si() - m, m = (120 > m ? 120 : 480 > m ? 480 : 1080 > m ? 1080 : 1920 > m ? 1920 : 3e3 > m ? 3e3 : 4320 > m ? 4320 : 1960 * $f(m / 1960)) - m, 10 < m) {
            u.timeoutHandle = _c(Au.bind(null, u), m);
            break;
          }
          Au(u);
          break;
        case 5:
          Au(u);
          break;
        default:
          throw Error(r(329));
      }
    }
    return ca(u, Si()), u.callbackNode === d ? lp.bind(null, u) : null;
  }
  function Ho(u, d) {
    for (d &= ~ui, d &= ~yo, u.suspendedLanes |= d, u.pingedLanes &= ~d, u = u.expirationTimes; 0 < d; ) {
      var m = 31 - su(d), w = 1 << m;
      u[m] = -1, d &= ~w;
    }
  }
  function qf(u) {
    if ((Yt & 48) !== 0)
      throw Error(r(327));
    if (Pu(), u === Ci && (u.expiredLanes & Dr) !== 0) {
      var d = Dr, m = Qf(u, d);
      (mo & yo) !== 0 && (d = dc(u, d), m = Qf(u, d));
    } else
      d = dc(u, 0), m = Qf(u, d);
    if (u.tag !== 0 && m === 2 && (Yt |= 64, u.hydrate && (u.hydrate = !1, jd(u.containerInfo)), d = cg(u), d !== 0 && (m = Qf(u, d))), m === 1)
      throw m = Mr, Ia(u, 0), Ho(u, d), ca(u, Si()), m;
    return u.finishedWork = u.current.alternate, u.finishedLanes = d, Au(u), ca(u, Si()), null;
  }
  function zg() {
    if (Ls !== null) {
      var u = Ls;
      Ls = null, u.forEach(function(d) {
        d.expiredLanes |= 24 & d.pendingLanes, ca(d, Si());
      });
    }
    oi();
  }
  function Qv(u, d) {
    var m = Yt;
    Yt |= 1;
    try {
      return u(d);
    } finally {
      Yt = m, Yt === 0 && (kc(), oi());
    }
  }
  function Xf(u, d) {
    var m = Yt;
    Yt &= -2, Yt |= 8;
    try {
      return u(d);
    } finally {
      Yt = m, Yt === 0 && (kc(), oi());
    }
  }
  function Kf(u, d) {
    Ht(ks, Dt), Dt |= d, mo |= d;
  }
  function Ka() {
    Dt = ks.current, nn(ks);
  }
  function Ia(u, d) {
    u.finishedWork = null, u.finishedLanes = 0;
    var m = u.timeoutHandle;
    if (m !== -1 && (u.timeoutHandle = -1, Tv(m)), Er !== null)
      for (m = Er.return; m !== null; ) {
        var w = m;
        switch (w.tag) {
          case 1:
            w = w.type.childContextTypes, w != null && Oa();
            break;
          case 3:
            wu(), nn(Lr), nn(er), $o();
            break;
          case 5:
            Ml(w);
            break;
          case 4:
            wu();
            break;
          case 13:
            nn(_r);
            break;
          case 19:
            nn(_r);
            break;
          case 10:
            wl(w);
            break;
          case 23:
          case 24:
            Ka();
        }
        m = m.return;
      }
    Ci = u, Er = ku(u.current, null), Dr = Dt = mo = d, Gr = 0, Mr = null, ui = yo = Is = 0;
  }
  function cp(u, d) {
    do {
      var m = Er;
      try {
        if (Sl(), Tc.current = kf, Af) {
          for (var w = dr.memoizedState; w !== null; ) {
            var M = w.queue;
            M !== null && (M.pending = null), w = w.next;
          }
          Af = !1;
        }
        if (Al = 0, Br = Jr = dr = null, Ds = !1, Ns.current = null, m === null || m.return === null) {
          Gr = 1, Mr = d, Er = null;
          break;
        }
        e: {
          var F = u, H = m.return, te = m, me = d;
          if (d = Dr, te.flags |= 2048, te.firstEffect = te.lastEffect = null, me !== null && typeof me == "object" && typeof me.then == "function") {
            var ze = me;
            if ((te.mode & 2) === 0) {
              var vt = te.alternate;
              vt ? (te.updateQueue = vt.updateQueue, te.memoizedState = vt.memoizedState, te.lanes = vt.lanes) : (te.updateQueue = null, te.memoizedState = null);
            }
            var qt = (_r.current & 1) !== 0, Je = H;
            do {
              var Mt;
              if (Mt = Je.tag === 13) {
                var Qt = Je.memoizedState;
                if (Qt !== null)
                  Mt = Qt.dehydrated !== null;
                else {
                  var It = Je.memoizedProps;
                  Mt = It.fallback === void 0 ? !1 : It.unstable_avoidThisFallback !== !0 ? !0 : !qt;
                }
              }
              if (Mt) {
                var Me = Je.updateQueue;
                if (Me === null) {
                  var Ee = /* @__PURE__ */ new Set();
                  Ee.add(ze), Je.updateQueue = Ee;
                } else
                  Me.add(ze);
                if ((Je.mode & 2) === 0) {
                  if (Je.flags |= 64, te.flags |= 16384, te.flags &= -2981, te.tag === 1)
                    if (te.alternate === null)
                      te.tag = 17;
                    else {
                      var Te = Tr(-1, 1);
                      Te.tag = 2, Cs(te, Te);
                    }
                  te.lanes |= 1;
                  break e;
                }
                me = void 0, te = d;
                var We = F.pingCache;
                if (We === null ? (We = F.pingCache = new Bf(), me = /* @__PURE__ */ new Set(), We.set(ze, me)) : (me = We.get(ze), me === void 0 && (me = /* @__PURE__ */ new Set(), We.set(ze, me))), !me.has(te)) {
                  me.add(te);
                  var Ye = Gy.bind(null, F, ze, te);
                  ze.then(Ye, Ye);
                }
                Je.flags |= 4096, Je.lanes = d;
                break e;
              }
              Je = Je.return;
            } while (Je !== null);
            me = Error((xe(te.type) || "A React component") + ` suspended while rendering, but no fallback UI was specified.

Add a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.`);
          }
          Gr !== 5 && (Gr = 2), me = np(me, te), Je = H;
          do {
            switch (Je.tag) {
              case 3:
                F = me, Je.flags |= 4096, d &= -d, Je.lanes |= d;
                var rn = Vv(Je, F, d);
                Nv(Je, rn);
                break e;
              case 1:
                F = me;
                var yt = Je.type, Ut = Je.stateNode;
                if ((Je.flags & 64) === 0 && (typeof yt.getDerivedStateFromError == "function" || Ut !== null && typeof Ut.componentDidCatch == "function" && (Wo === null || !Wo.has(Ut)))) {
                  Je.flags |= 4096, d &= -d, Je.lanes |= d;
                  var sn = zf(Je, F, d);
                  Nv(Je, sn);
                  break e;
                }
            }
            Je = Je.return;
          } while (Je !== null);
        }
        Ug(m);
      } catch (on) {
        d = on, Er === m && m !== null && (Er = m = m.return);
        continue;
      }
      break;
    } while (1);
  }
  function zl() {
    var u = la.current;
    return la.current = kf, u === null ? kf : u;
  }
  function Qf(u, d) {
    var m = Yt;
    Yt |= 16;
    var w = zl();
    Ci === u && Dr === d || Ia(u, d);
    do
      try {
        Fg();
        break;
      } catch (M) {
        cp(u, M);
      }
    while (1);
    if (Sl(), Yt = m, la.current = w, Er !== null)
      throw Error(r(261));
    return Ci = null, Dr = 0, Gr;
  }
  function Fg() {
    for (; Er !== null; )
      Zv(Er);
  }
  function $g() {
    for (; Er !== null && !$y(); )
      Zv(Er);
  }
  function Zv(u) {
    var d = jg(u.alternate, u, Dt);
    u.memoizedProps = u.pendingProps, d === null ? Ug(u) : Er = d, Ns.current = null;
  }
  function Ug(u) {
    var d = u;
    do {
      var m = d.alternate;
      if (u = d.return, (d.flags & 2048) === 0) {
        if (m = Lf(m, d, Dt), m !== null) {
          Er = m;
          return;
        }
        if (m = d, m.tag !== 24 && m.tag !== 23 || m.memoizedState === null || (Dt & 1073741824) !== 0 || (m.mode & 4) === 0) {
          for (var w = 0, M = m.child; M !== null; )
            w |= M.lanes | M.childLanes, M = M.sibling;
          m.childLanes = w;
        }
        u !== null && (u.flags & 2048) === 0 && (u.firstEffect === null && (u.firstEffect = d.firstEffect), d.lastEffect !== null && (u.lastEffect !== null && (u.lastEffect.nextEffect = d.firstEffect), u.lastEffect = d.lastEffect), 1 < d.flags && (u.lastEffect !== null ? u.lastEffect.nextEffect = d : u.firstEffect = d, u.lastEffect = d));
      } else {
        if (m = Lg(d), m !== null) {
          m.flags &= 2047, Er = m;
          return;
        }
        u !== null && (u.firstEffect = u.lastEffect = null, u.flags |= 2048);
      }
      if (d = d.sibling, d !== null) {
        Er = d;
        return;
      }
      Er = d = u;
    } while (d !== null);
    Gr === 0 && (Gr = 5);
  }
  function Au(u) {
    var d = xc();
    return El(99, jy.bind(null, u, d)), null;
  }
  function jy(u, d) {
    do
      Pu();
    while (zr !== null);
    if ((Yt & 48) !== 0)
      throw Error(r(327));
    var m = u.finishedWork;
    if (m === null)
      return null;
    if (u.finishedWork = null, u.finishedLanes = 0, m === u.current)
      throw Error(r(177));
    u.callbackNode = null;
    var w = m.lanes | m.childLanes, M = w, F = u.pendingLanes & ~M;
    u.pendingLanes = M, u.suspendedLanes = 0, u.pingedLanes = 0, u.expiredLanes &= M, u.mutableReadLanes &= M, u.entangledLanes &= M, M = u.entanglements;
    for (var H = u.eventTimes, te = u.expirationTimes; 0 < F; ) {
      var me = 31 - su(F), ze = 1 << me;
      M[me] = 0, H[me] = -1, te[me] = -1, F &= ~ze;
    }
    if (Ls !== null && (w & 24) === 0 && Ls.has(u) && Ls.delete(u), u === Ci && (Er = Ci = null, Dr = 0), 1 < m.flags ? m.lastEffect !== null ? (m.lastEffect.nextEffect = m, w = m.firstEffect) : w = m : w = m.firstEffect, w !== null) {
      if (M = Yt, Yt |= 32, Ns.current = null, Rv = lf, H = hf(), Ha(H)) {
        if ("selectionStart" in H)
          te = { start: H.selectionStart, end: H.selectionEnd };
        else
          e:
            if (te = (te = H.ownerDocument) && te.defaultView || window, (ze = te.getSelection && te.getSelection()) && ze.rangeCount !== 0) {
              te = ze.anchorNode, F = ze.anchorOffset, me = ze.focusNode, ze = ze.focusOffset;
              try {
                te.nodeType, me.nodeType;
              } catch {
                te = null;
                break e;
              }
              var vt = 0, qt = -1, Je = -1, Mt = 0, Qt = 0, It = H, Me = null;
              t:
                for (; ; ) {
                  for (var Ee; It !== te || F !== 0 && It.nodeType !== 3 || (qt = vt + F), It !== me || ze !== 0 && It.nodeType !== 3 || (Je = vt + ze), It.nodeType === 3 && (vt += It.nodeValue.length), (Ee = It.firstChild) !== null; )
                    Me = It, It = Ee;
                  for (; ; ) {
                    if (It === H)
                      break t;
                    if (Me === te && ++Mt === F && (qt = vt), Me === me && ++Qt === ze && (Je = vt), (Ee = It.nextSibling) !== null)
                      break;
                    It = Me, Me = It.parentNode;
                  }
                  It = Ee;
                }
              te = qt === -1 || Je === -1 ? null : { start: qt, end: Je };
            } else
              te = null;
        te = te || { start: 0, end: 0 };
      } else
        te = null;
      bc = { focusedElem: H, selectionRange: te }, lf = !1, Yf = null, sp = !1, gt = w;
      do
        try {
          Wy();
        } catch (on) {
          if (gt === null)
            throw Error(r(330));
          zs(gt, on), gt = gt.nextEffect;
        }
      while (gt !== null);
      Yf = null, gt = w;
      do
        try {
          for (H = u; gt !== null; ) {
            var Te = gt.flags;
            if (Te & 16 && kn(gt.stateNode, ""), Te & 128) {
              var We = gt.alternate;
              if (We !== null) {
                var Ye = We.ref;
                Ye !== null && (typeof Ye == "function" ? Ye(null) : Ye.current = null);
              }
            }
            switch (Te & 1038) {
              case 2:
                Gv(gt), gt.flags &= -3;
                break;
              case 6:
                Gv(gt), gt.flags &= -3, Yv(gt.alternate, gt);
                break;
              case 1024:
                gt.flags &= -1025;
                break;
              case 1028:
                gt.flags &= -1025, Yv(gt.alternate, gt);
                break;
              case 4:
                Yv(gt.alternate, gt);
                break;
              case 8:
                te = gt, Hv(H, te);
                var rn = te.alternate;
                ap(te), rn !== null && ap(rn);
            }
            gt = gt.nextEffect;
          }
        } catch (on) {
          if (gt === null)
            throw Error(r(330));
          zs(gt, on), gt = gt.nextEffect;
        }
      while (gt !== null);
      if (Ye = bc, We = hf(), Te = Ye.focusedElem, H = Ye.selectionRange, We !== Te && Te && Te.ownerDocument && mc(Te.ownerDocument.documentElement, Te)) {
        for (H !== null && Ha(Te) && (We = H.start, Ye = H.end, Ye === void 0 && (Ye = We), "selectionStart" in Te ? (Te.selectionStart = We, Te.selectionEnd = Math.min(Ye, Te.value.length)) : (Ye = (We = Te.ownerDocument || document) && We.defaultView || window, Ye.getSelection && (Ye = Ye.getSelection(), te = Te.textContent.length, rn = Math.min(H.start, te), H = H.end === void 0 ? rn : Math.min(H.end, te), !Ye.extend && rn > H && (te = H, H = rn, rn = te), te = Ra(Te, rn), F = Ra(Te, H), te && F && (Ye.rangeCount !== 1 || Ye.anchorNode !== te.node || Ye.anchorOffset !== te.offset || Ye.focusNode !== F.node || Ye.focusOffset !== F.offset) && (We = We.createRange(), We.setStart(te.node, te.offset), Ye.removeAllRanges(), rn > H ? (Ye.addRange(We), Ye.extend(F.node, F.offset)) : (We.setEnd(F.node, F.offset), Ye.addRange(We)))))), We = [], Ye = Te; Ye = Ye.parentNode; )
          Ye.nodeType === 1 && We.push({ element: Ye, left: Ye.scrollLeft, top: Ye.scrollTop });
        for (typeof Te.focus == "function" && Te.focus(), Te = 0; Te < We.length; Te++)
          Ye = We[Te], Ye.element.scrollLeft = Ye.left, Ye.element.scrollTop = Ye.top;
      }
      lf = !!Rv, bc = Rv = null, u.current = m, gt = w;
      do
        try {
          for (Te = u; gt !== null; ) {
            var yt = gt.flags;
            if (yt & 36 && ip(Te, gt.alternate, gt), yt & 128) {
              We = void 0;
              var Ut = gt.ref;
              if (Ut !== null) {
                var sn = gt.stateNode;
                switch (gt.tag) {
                  case 5:
                    We = sn;
                    break;
                  default:
                    We = sn;
                }
                typeof Ut == "function" ? Ut(We) : Ut.current = We;
              }
            }
            gt = gt.nextEffect;
          }
        } catch (on) {
          if (gt === null)
            throw Error(r(330));
          zs(gt, on), gt = gt.nextEffect;
        }
      while (gt !== null);
      gt = null, Mg(), Yt = M;
    } else
      u.current = m;
    if (Ai)
      Ai = !1, zr = u, Bl = d;
    else
      for (gt = w; gt !== null; )
        d = gt.nextEffect, gt.nextEffect = null, gt.flags & 8 && (yt = gt, yt.sibling = null, yt.stateNode = null), gt = d;
    if (w = u.pendingLanes, w === 0 && (Wo = null), w === 1 ? u === Mu ? Gf++ : (Gf = 0, Mu = u) : Gf = 0, m = m.stateNode, Da && typeof Da.onCommitFiberRoot == "function")
      try {
        Da.onCommitFiberRoot(Ov, m, void 0, (m.current.flags & 64) === 64);
      } catch {
      }
    if (ca(u, Si()), jf)
      throw jf = !1, u = Xv, Xv = null, u;
    return (Yt & 8) !== 0 || oi(), null;
  }
  function Wy() {
    for (; gt !== null; ) {
      var u = gt.alternate;
      sp || Yf === null || ((gt.flags & 8) !== 0 ? oc(gt, Yf) && (sp = !0) : gt.tag === 13 && Vy(u, gt) && oc(gt, Yf) && (sp = !0));
      var d = gt.flags;
      (d & 256) !== 0 && Uy(u, gt), (d & 512) === 0 || Ai || (Ai = !0, xl(97, function() {
        return Pu(), null;
      })), gt = gt.nextEffect;
    }
  }
  function Pu() {
    if (Bl !== 90) {
      var u = 97 < Bl ? 97 : Bl;
      return Bl = 90, El(u, eh);
    }
    return !1;
  }
  function Vg(u, d) {
    Kv.push(d, u), Ai || (Ai = !0, xl(97, function() {
      return Pu(), null;
    }));
  }
  function Jv(u, d) {
    Wf.push(d, u), Ai || (Ai = !0, xl(97, function() {
      return Pu(), null;
    }));
  }
  function eh() {
    if (zr === null)
      return !1;
    var u = zr;
    if (zr = null, (Yt & 48) !== 0)
      throw Error(r(331));
    var d = Yt;
    Yt |= 32;
    var m = Wf;
    Wf = [];
    for (var w = 0; w < m.length; w += 2) {
      var M = m[w], F = m[w + 1], H = M.destroy;
      if (M.destroy = void 0, typeof H == "function")
        try {
          H();
        } catch (me) {
          if (F === null)
            throw Error(r(330));
          zs(F, me);
        }
    }
    for (m = Kv, Kv = [], w = 0; w < m.length; w += 2) {
      M = m[w], F = m[w + 1];
      try {
        var te = M.create;
        M.destroy = te();
      } catch (me) {
        if (F === null)
          throw Error(r(330));
        zs(F, me);
      }
    }
    for (te = u.current.firstEffect; te !== null; )
      u = te.nextEffect, te.nextEffect = null, te.flags & 8 && (te.sibling = null, te.stateNode = null), te = u;
    return Yt = d, oi(), !0;
  }
  function Nu(u, d, m) {
    d = np(m, d), d = Vv(u, d, 1), Cs(u, d), d = ka(), u = up(u, 1), u !== null && (uf(u, 1, d), ca(u, d));
  }
  function zs(u, d) {
    if (u.tag === 3)
      Nu(u, u, d);
    else
      for (var m = u.return; m !== null; ) {
        if (m.tag === 3) {
          Nu(m, u, d);
          break;
        } else if (m.tag === 1) {
          var w = m.stateNode;
          if (typeof m.type.getDerivedStateFromError == "function" || typeof w.componentDidCatch == "function" && (Wo === null || !Wo.has(w))) {
            u = np(d, u);
            var M = zf(m, u, 1);
            if (Cs(m, M), M = ka(), m = up(m, 1), m !== null)
              uf(m, 1, M), ca(m, M);
            else if (typeof w.componentDidCatch == "function" && (Wo === null || !Wo.has(w)))
              try {
                w.componentDidCatch(d, u);
              } catch {
              }
            break;
          }
        }
        m = m.return;
      }
  }
  function Gy(u, d, m) {
    var w = u.pingCache;
    w !== null && w.delete(d), d = ka(), u.pingedLanes |= u.suspendedLanes & m, Ci === u && (Dr & m) === m && (Gr === 4 || Gr === 3 && (Dr & 62914560) === Dr && 500 > Si() - Vf ? Ia(u, 0) : ui |= m), ca(u, d);
  }
  function Hy(u, d) {
    var m = u.stateNode;
    m !== null && m.delete(d), d = 0, d === 0 && (d = u.mode, (d & 2) === 0 ? d = 1 : (d & 4) === 0 ? d = xc() === 99 ? 1 : 2 : (Go === 0 && (Go = mo), d = Dn(62914560 & ~Go), d === 0 && (d = 4194304))), m = ka(), u = up(u, d), u !== null && (uf(u, d, m), ca(u, m));
  }
  var jg;
  jg = function(u, d, m) {
    var w = d.lanes;
    if (u !== null)
      if (u.memoizedProps !== d.pendingProps || Lr.current)
        ti = !0;
      else if ((m & w) !== 0)
        ti = (u.flags & 16384) !== 0;
      else {
        switch (ti = !1, d.tag) {
          case 3:
            $v(d), Rc();
            break;
          case 5:
            Ag(d);
            break;
          case 1:
            Rr(d.type) && Ya(d);
            break;
          case 4:
            Tf(d, d.stateNode.containerInfo);
            break;
          case 10:
            w = d.memoizedProps.value;
            var M = d.type._context;
            Ht(ws, M._currentValue), M._currentValue = w;
            break;
          case 13:
            if (d.memoizedState !== null)
              return (m & d.child.childLanes) !== 0 ? Ps(u, d, m) : (Ht(_r, _r.current & 1), d = ua(u, d, m), d !== null ? d.sibling : null);
            Ht(_r, _r.current & 1);
            break;
          case 19:
            if (w = (m & d.childLanes) !== 0, (u.flags & 64) !== 0) {
              if (w)
                return ep(u, d, m);
              d.flags |= 64;
            }
            if (M = d.memoizedState, M !== null && (M.rendering = null, M.tail = null, M.lastEffect = null), Ht(_r, _r.current), w)
              break;
            return null;
          case 23:
          case 24:
            return d.lanes = 0, Ou(u, d, m);
        }
        return ua(u, d, m);
      }
    else
      ti = !1;
    switch (d.lanes = 0, d.tag) {
      case 2:
        if (w = d.type, u !== null && (u.alternate = null, d.alternate = null, d.flags |= 2), u = d.pendingProps, M = G(d, er.current), bu(d, m), M = Xd(null, d, w, u, M, m), d.flags |= 1, typeof M == "object" && M !== null && typeof M.render == "function" && M.$$typeof === void 0) {
          if (d.tag = 1, d.memoizedState = null, d.updateQueue = null, Rr(w)) {
            var F = !0;
            Ya(d);
          } else
            F = !1;
          d.memoizedState = M.state !== null && M.state !== void 0 ? M.state : null, Sf(d);
          var H = w.getDerivedStateFromProps;
          typeof H == "function" && wc(d, w, H, u), M.updater = Cc, d.stateNode = M, M._reactInternals = d, jr(d, w, u, m), d = Jd(null, d, w, !0, F, m);
        } else
          d.tag = 0, sa(null, d, M, m), d = d.child;
        return d;
      case 16:
        M = d.elementType;
        e: {
          switch (u !== null && (u.alternate = null, d.alternate = null, d.flags |= 2), u = d.pendingProps, F = M._init, M = F(M._payload), d.type = M, F = d.tag = Yy(M), u = Zr(M, u), F) {
            case 0:
              d = Fv(null, d, M, u, m);
              break e;
            case 1:
              d = kg(null, d, M, u, m);
              break e;
            case 11:
              d = Vo(null, d, M, u, m);
              break e;
            case 14:
              d = Zd(null, d, M, Zr(M.type, u), w, m);
              break e;
          }
          throw Error(r(306, M, ""));
        }
        return d;
      case 0:
        return w = d.type, M = d.pendingProps, M = d.elementType === w ? M : Zr(w, M), Fv(u, d, w, M, m);
      case 1:
        return w = d.type, M = d.pendingProps, M = d.elementType === w ? M : Zr(w, M), kg(u, d, w, M, m);
      case 3:
        if ($v(d), w = d.updateQueue, u === null || w === null)
          throw Error(r(282));
        if (w = d.pendingProps, M = d.memoizedState, M = M !== null ? M.element : null, _u(u, d), Bo(d, w, null, m), w = d.memoizedState.element, w === M)
          Rc(), d = ua(u, d, m);
        else {
          if (M = d.stateNode, (F = M.hydrate) && (Pa = du(d.stateNode.containerInfo.firstChild), zo = d, F = Fo = !0), F) {
            if (u = M.mutableSourceEagerHydrationData, u != null)
              for (M = 0; M < u.length; M += 2)
                F = u[M], F._workInProgressVersionPrimary = u[M + 1], Cu.push(F);
            for (m = Ts(d, null, w, m), d.child = m; m; )
              m.flags = m.flags & -3 | 1024, m = m.sibling;
          } else
            sa(u, d, w, m), Rc();
          d = d.child;
        }
        return d;
      case 5:
        return Ag(d), u === null && Os(d), w = d.type, M = d.pendingProps, F = u !== null ? u.memoizedProps : null, H = M.children, bl(w, M) ? H = null : F !== null && bl(w, F) && (d.flags |= 16), Ng(u, d), sa(u, d, H, m), d.child;
      case 6:
        return u === null && Os(d), null;
      case 13:
        return Ps(u, d, m);
      case 4:
        return Tf(d, d.stateNode.containerInfo), w = d.pendingProps, u === null ? d.child = xu(d, null, w, m) : sa(u, d, w, m), d.child;
      case 11:
        return w = d.type, M = d.pendingProps, M = d.elementType === w ? M : Zr(w, M), Vo(u, d, w, M, m);
      case 7:
        return sa(u, d, d.pendingProps, m), d.child;
      case 8:
        return sa(
          u,
          d,
          d.pendingProps.children,
          m
        ), d.child;
      case 12:
        return sa(u, d, d.pendingProps.children, m), d.child;
      case 10:
        e: {
          w = d.type._context, M = d.pendingProps, H = d.memoizedProps, F = M.value;
          var te = d.type._context;
          if (Ht(ws, te._currentValue), te._currentValue = F, H !== null)
            if (te = H.value, F = Ln(te, F) ? 0 : (typeof w._calculateChangedBits == "function" ? w._calculateChangedBits(te, F) : 1073741823) | 0, F === 0) {
              if (H.children === M.children && !Lr.current) {
                d = ua(u, d, m);
                break e;
              }
            } else
              for (te = d.child, te !== null && (te.return = d); te !== null; ) {
                var me = te.dependencies;
                if (me !== null) {
                  H = te.child;
                  for (var ze = me.firstContext; ze !== null; ) {
                    if (ze.context === w && (ze.observedBits & F) !== 0) {
                      te.tag === 1 && (ze = Tr(-1, m & -m), ze.tag = 2, Cs(te, ze)), te.lanes |= m, ze = te.alternate, ze !== null && (ze.lanes |= m), Pv(te.return, m), me.lanes |= m;
                      break;
                    }
                    ze = ze.next;
                  }
                } else
                  H = te.tag === 10 && te.type === d.type ? null : te.child;
                if (H !== null)
                  H.return = te;
                else
                  for (H = te; H !== null; ) {
                    if (H === d) {
                      H = null;
                      break;
                    }
                    if (te = H.sibling, te !== null) {
                      te.return = H.return, H = te;
                      break;
                    }
                    H = H.return;
                  }
                te = H;
              }
          sa(u, d, M.children, m), d = d.child;
        }
        return d;
      case 9:
        return M = d.type, F = d.pendingProps, w = F.children, bu(d, m), M = Aa(
          M,
          F.unstable_observedBits
        ), w = w(M), d.flags |= 1, sa(u, d, w, m), d.child;
      case 14:
        return M = d.type, F = Zr(M, d.pendingProps), F = Zr(M.type, F), Zd(u, d, M, F, w, m);
      case 15:
        return zv(u, d, d.type, d.pendingProps, w, m);
      case 17:
        return w = d.type, M = d.pendingProps, M = d.elementType === w ? M : Zr(w, M), u !== null && (u.alternate = null, d.alternate = null, d.flags |= 2), d.tag = 1, Rr(w) ? (u = !0, Ya(d)) : u = !1, bu(d, m), Rl(d, w, M), jr(d, w, M, m), Jd(null, d, w, !0, u, m);
      case 19:
        return ep(u, d, m);
      case 23:
        return Ou(u, d, m);
      case 24:
        return Ou(u, d, m);
    }
    throw Error(r(156, d.tag));
  };
  function Wg(u, d, m, w) {
    this.tag = u, this.key = m, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = d, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = w, this.flags = 0, this.lastEffect = this.firstEffect = this.nextEffect = null, this.childLanes = this.lanes = 0, this.alternate = null;
  }
  function Qa(u, d, m, w) {
    return new Wg(u, d, m, w);
  }
  function fp(u) {
    return u = u.prototype, !(!u || !u.isReactComponent);
  }
  function Yy(u) {
    if (typeof u == "function")
      return fp(u) ? 1 : 0;
    if (u != null) {
      if (u = u.$$typeof, u === Z)
        return 11;
      if (u === be)
        return 14;
    }
    return 2;
  }
  function ku(u, d) {
    var m = u.alternate;
    return m === null ? (m = Qa(u.tag, d, u.key, u.mode), m.elementType = u.elementType, m.type = u.type, m.stateNode = u.stateNode, m.alternate = u, u.alternate = m) : (m.pendingProps = d, m.type = u.type, m.flags = 0, m.nextEffect = null, m.firstEffect = null, m.lastEffect = null), m.childLanes = u.childLanes, m.lanes = u.lanes, m.child = u.child, m.memoizedProps = u.memoizedProps, m.memoizedState = u.memoizedState, m.updateQueue = u.updateQueue, d = u.dependencies, m.dependencies = d === null ? null : { lanes: d.lanes, firstContext: d.firstContext }, m.sibling = u.sibling, m.index = u.index, m.ref = u.ref, m;
  }
  function Zf(u, d, m, w, M, F) {
    var H = 2;
    if (w = u, typeof u == "function")
      fp(u) && (H = 1);
    else if (typeof u == "string")
      H = 5;
    else
      e:
        switch (u) {
          case K:
            return Yo(m.children, M, F, d);
          case re:
            H = 8, M |= 16;
            break;
          case X:
            H = 8, M |= 1;
            break;
          case Y:
            return u = Qa(12, m, d, M | 8), u.elementType = Y, u.type = Y, u.lanes = F, u;
          case se:
            return u = Qa(13, m, d, M), u.type = se, u.elementType = se, u.lanes = F, u;
          case pe:
            return u = Qa(19, m, d, M), u.elementType = pe, u.lanes = F, u;
          case ie:
            return li(m, M, F, d);
          case ce:
            return u = Qa(24, m, d, M), u.elementType = ce, u.lanes = F, u;
          default:
            if (typeof u == "object" && u !== null)
              switch (u.$$typeof) {
                case J:
                  H = 10;
                  break e;
                case Q:
                  H = 9;
                  break e;
                case Z:
                  H = 11;
                  break e;
                case be:
                  H = 14;
                  break e;
                case _e:
                  H = 16, w = null;
                  break e;
                case Se:
                  H = 22;
                  break e;
              }
            throw Error(r(130, u == null ? u : typeof u, ""));
        }
    return d = Qa(H, m, d, M), d.elementType = u, d.type = w, d.lanes = F, d;
  }
  function Yo(u, d, m, w) {
    return u = Qa(7, u, w, d), u.lanes = m, u;
  }
  function li(u, d, m, w) {
    return u = Qa(23, u, w, d), u.elementType = ie, u.lanes = m, u;
  }
  function th(u, d, m) {
    return u = Qa(6, u, null, d), u.lanes = m, u;
  }
  function nh(u, d, m) {
    return d = Qa(4, u.children !== null ? u.children : [], u.key, d), d.lanes = m, d.stateNode = { containerInfo: u.containerInfo, pendingChildren: null, implementation: u.implementation }, d;
  }
  function qy(u, d, m) {
    this.tag = d, this.containerInfo = u, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.pendingContext = this.context = null, this.hydrate = m, this.callbackNode = null, this.callbackPriority = 0, this.eventTimes = $n(0), this.expirationTimes = $n(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = $n(0), this.mutableSourceEagerHydrationData = null;
  }
  function Jf(u, d, m) {
    var w = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
    return { $$typeof: U, key: w == null ? null : "" + w, children: u, containerInfo: d, implementation: m };
  }
  function dp(u, d, m, w) {
    var M = d.current, F = ka(), H = bo(M);
    e:
      if (m) {
        m = m._reactInternals;
        t: {
          if (Di(m) !== m || m.tag !== 1)
            throw Error(r(170));
          var te = m;
          do {
            switch (te.tag) {
              case 3:
                te = te.stateNode.context;
                break t;
              case 1:
                if (Rr(te.type)) {
                  te = te.stateNode.__reactInternalMemoizedMergedChildContext;
                  break t;
                }
            }
            te = te.return;
          } while (te !== null);
          throw Error(r(171));
        }
        if (m.tag === 1) {
          var me = m.type;
          if (Rr(me)) {
            m = un(m, me, te);
            break e;
          }
        }
        m = te;
      } else
        m = vu;
    return d.context === null ? d.context = m : d.pendingContext = m, d = Tr(F, H), d.payload = { element: u }, w = w === void 0 ? null : w, w !== null && (d.callback = w), Cs(M, d), Bs(M, H, F), H;
  }
  function pp(u) {
    if (u = u.current, !u.child)
      return null;
    switch (u.child.tag) {
      case 5:
        return u.child.stateNode;
      default:
        return u.child.stateNode;
    }
  }
  function Gg(u, d) {
    if (u = u.memoizedState, u !== null && u.dehydrated !== null) {
      var m = u.retryLane;
      u.retryLane = m !== 0 && m < d ? m : d;
    }
  }
  function vp(u, d) {
    Gg(u, d), (u = u.alternate) && Gg(u, d);
  }
  function hp() {
    return null;
  }
  function rh(u, d, m) {
    var w = m != null && m.hydrationOptions != null && m.hydrationOptions.mutableSources || null;
    if (m = new qy(u, d, m != null && m.hydrate === !0), d = Qa(3, null, null, d === 2 ? 7 : d === 1 ? 3 : 0), m.current = d, d.stateNode = m, Sf(d), u[Ei] = m.current, Ud(u.nodeType === 8 ? u.parentNode : u), w)
      for (u = 0; u < w.length; u++) {
        d = w[u];
        var M = d._getVersion;
        M = M(d._source), m.mutableSourceEagerHydrationData == null ? m.mutableSourceEagerHydrationData = [d, M] : m.mutableSourceEagerHydrationData.push(d, M);
      }
    this._internalRoot = m;
  }
  rh.prototype.render = function(u) {
    dp(u, this._internalRoot, null, null);
  }, rh.prototype.unmount = function() {
    var u = this._internalRoot, d = u.containerInfo;
    dp(null, u, null, function() {
      d[Ei] = null;
    });
  };
  function ed(u) {
    return !(!u || u.nodeType !== 1 && u.nodeType !== 9 && u.nodeType !== 11 && (u.nodeType !== 8 || u.nodeValue !== " react-mount-point-unstable "));
  }
  function Xy(u, d) {
    if (d || (d = u ? u.nodeType === 9 ? u.documentElement : u.firstChild : null, d = !(!d || d.nodeType !== 1 || !d.hasAttribute("data-reactroot"))), !d)
      for (var m; m = u.lastChild; )
        u.removeChild(m);
    return new rh(u, 0, d ? { hydrate: !0 } : void 0);
  }
  function gp(u, d, m, w, M) {
    var F = m._reactRootContainer;
    if (F) {
      var H = F._internalRoot;
      if (typeof M == "function") {
        var te = M;
        M = function() {
          var ze = pp(H);
          te.call(ze);
        };
      }
      dp(d, H, u, M);
    } else {
      if (F = m._reactRootContainer = Xy(m, w), H = F._internalRoot, typeof M == "function") {
        var me = M;
        M = function() {
          var ze = pp(H);
          me.call(ze);
        };
      }
      Xf(function() {
        dp(d, H, u, M);
      });
    }
    return pp(H);
  }
  av = function(u) {
    if (u.tag === 13) {
      var d = ka();
      Bs(u, 4, d), vp(u, 4);
    }
  }, sc = function(u) {
    if (u.tag === 13) {
      var d = ka();
      Bs(u, 67108864, d), vp(u, 67108864);
    }
  }, og = function(u) {
    if (u.tag === 13) {
      var d = ka(), m = bo(u);
      Bs(u, m, d), vp(u, m);
    }
  }, uc = function(u, d) {
    return d();
  }, uo = function(u, d, m) {
    switch (d) {
      case "input":
        if (tn(u, m), d = m.name, m.type === "radio" && d != null) {
          for (m = u; m.parentNode; )
            m = m.parentNode;
          for (m = m.querySelectorAll("input[name=" + JSON.stringify("" + d) + '][type="radio"]'), d = 0; d < m.length; d++) {
            var w = m[d];
            if (w !== u && w.form === u.form) {
              var M = Ta(w);
              if (!M)
                throw Error(r(90));
              Tt(w), tn(w, M);
            }
          }
        }
        break;
      case "textarea":
        Zi(u, m);
        break;
      case "select":
        d = m.value, d != null && xn(u, !!m.multiple, d, !1);
    }
  }, de = Qv, tt = function(u, d, m, w, M) {
    var F = Yt;
    Yt |= 4;
    try {
      return El(98, u.bind(null, d, m, w, M));
    } finally {
      Yt = F, Yt === 0 && (kc(), oi());
    }
  }, ct = function() {
    (Yt & 49) === 0 && (zg(), Pu());
  }, kt = function(u, d) {
    var m = Yt;
    Yt |= 2;
    try {
      return u(d);
    } finally {
      Yt = m, Yt === 0 && (kc(), oi());
    }
  };
  function Hg(u, d) {
    var m = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
    if (!ed(d))
      throw Error(r(200));
    return Jf(u, d, null, m);
  }
  var Ky = { Events: [ai, Qr, Ta, Va, il, Pu, { current: !1 }] }, td = { findFiberByHostInstance: Es, bundleType: 0, version: "17.0.2", rendererPackageName: "react-dom" }, Qy = { bundleType: td.bundleType, version: td.version, rendererPackageName: td.rendererPackageName, rendererConfig: td.rendererConfig, overrideHookState: null, overrideHookStateDeletePath: null, overrideHookStateRenamePath: null, overrideProps: null, overridePropsDeletePath: null, overridePropsRenamePath: null, setSuspenseHandler: null, scheduleUpdate: null, currentDispatcherRef: k.ReactCurrentDispatcher, findHostInstanceByFiber: function(u) {
    return u = Dd(u), u === null ? null : u.stateNode;
  }, findFiberByHostInstance: td.findFiberByHostInstance || hp, findHostInstancesForRefresh: null, scheduleRefresh: null, scheduleRoot: null, setRefreshHandler: null, getCurrentFiber: null };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var mp = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!mp.isDisabled && mp.supportsFiber)
      try {
        Ov = mp.inject(Qy), Da = mp;
      } catch {
      }
  }
  return Ws.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Ky, Ws.createPortal = Hg, Ws.findDOMNode = function(u) {
    if (u == null)
      return null;
    if (u.nodeType === 1)
      return u;
    var d = u._reactInternals;
    if (d === void 0)
      throw typeof u.render == "function" ? Error(r(188)) : Error(r(268, Object.keys(u)));
    return u = Dd(d), u = u === null ? null : u.stateNode, u;
  }, Ws.flushSync = function(u, d) {
    var m = Yt;
    if ((m & 48) !== 0)
      return u(d);
    Yt |= 1;
    try {
      if (u)
        return El(99, u.bind(null, d));
    } finally {
      Yt = m, oi();
    }
  }, Ws.hydrate = function(u, d, m) {
    if (!ed(d))
      throw Error(r(200));
    return gp(null, u, d, !0, m);
  }, Ws.render = function(u, d, m) {
    if (!ed(d))
      throw Error(r(200));
    return gp(null, u, d, !1, m);
  }, Ws.unmountComponentAtNode = function(u) {
    if (!ed(u))
      throw Error(r(40));
    return u._reactRootContainer ? (Xf(function() {
      gp(null, null, u, !1, function() {
        u._reactRootContainer = null, u[Ei] = null;
      });
    }), !0) : !1;
  }, Ws.unstable_batchedUpdates = Qv, Ws.unstable_createPortal = function(u, d) {
    return Hg(u, d, 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null);
  }, Ws.unstable_renderSubtreeIntoContainer = function(u, d, m, w) {
    if (!ed(m))
      throw Error(r(200));
    if (u == null || u._reactInternals === void 0)
      throw Error(r(38));
    return gp(u, d, m, !1, w);
  }, Ws.version = "17.0.2", Ws;
}
var Gs = {}, FR = { exports: {} }, Hl = {};
/** @license React v0.20.2
 * scheduler-tracing.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var EN;
function B4() {
  if (EN)
    return Hl;
  EN = 1;
  var e = 0;
  return Hl.__interactionsRef = null, Hl.__subscriberRef = null, Hl.unstable_clear = function(t) {
    return t();
  }, Hl.unstable_getCurrent = function() {
    return null;
  }, Hl.unstable_getThreadID = function() {
    return ++e;
  }, Hl.unstable_subscribe = function() {
  }, Hl.unstable_trace = function(t, n, r) {
    return r();
  }, Hl.unstable_unsubscribe = function() {
  }, Hl.unstable_wrap = function(t) {
    return t;
  }, Hl;
}
var $R = {};
/** @license React v0.20.2
 * scheduler-tracing.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var xN;
function z4() {
  return xN || (xN = 1, function(e) {
    process.env.NODE_ENV !== "production" && function() {
      var t = 0, n = 0, r = 0;
      e.__interactionsRef = null, e.__subscriberRef = null, e.__interactionsRef = {
        current: /* @__PURE__ */ new Set()
      }, e.__subscriberRef = {
        current: null
      };
      function a(B) {
        var I = e.__interactionsRef.current;
        e.__interactionsRef.current = /* @__PURE__ */ new Set();
        try {
          return B();
        } finally {
          e.__interactionsRef.current = I;
        }
      }
      function s() {
        return e.__interactionsRef.current;
      }
      function l() {
        return ++r;
      }
      function p(B, I, L) {
        var k = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : t, $ = {
          __count: 1,
          id: n++,
          name: B,
          timestamp: I
        }, U = e.__interactionsRef.current, K = new Set(U);
        K.add($), e.__interactionsRef.current = K;
        var X = e.__subscriberRef.current, Y;
        try {
          X !== null && X.onInteractionTraced($);
        } finally {
          try {
            X !== null && X.onWorkStarted(K, k);
          } finally {
            try {
              Y = L();
            } finally {
              e.__interactionsRef.current = U;
              try {
                X !== null && X.onWorkStopped(K, k);
              } finally {
                $.__count--, X !== null && $.__count === 0 && X.onInteractionScheduledWorkCompleted($);
              }
            }
          }
        }
        return Y;
      }
      function h(B) {
        var I = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : t, L = e.__interactionsRef.current, k = e.__subscriberRef.current;
        k !== null && k.onWorkScheduled(L, I), L.forEach(function(K) {
          K.__count++;
        });
        var $ = !1;
        function U() {
          var K = e.__interactionsRef.current;
          e.__interactionsRef.current = L, k = e.__subscriberRef.current;
          try {
            var X;
            try {
              k !== null && k.onWorkStarted(L, I);
            } finally {
              try {
                X = B.apply(void 0, arguments);
              } finally {
                e.__interactionsRef.current = K, k !== null && k.onWorkStopped(L, I);
              }
            }
            return X;
          } finally {
            $ || ($ = !0, L.forEach(function(Y) {
              Y.__count--, k !== null && Y.__count === 0 && k.onInteractionScheduledWorkCompleted(Y);
            }));
          }
        }
        return U.cancel = function() {
          k = e.__subscriberRef.current;
          try {
            k !== null && k.onWorkCanceled(L, I);
          } finally {
            L.forEach(function(X) {
              X.__count--, k && X.__count === 0 && k.onInteractionScheduledWorkCompleted(X);
            });
          }
        }, U;
      }
      var y = null;
      y = /* @__PURE__ */ new Set();
      function b(B) {
        y.add(B), y.size === 1 && (e.__subscriberRef.current = {
          onInteractionScheduledWorkCompleted: C,
          onInteractionTraced: x,
          onWorkCanceled: A,
          onWorkScheduled: T,
          onWorkStarted: O,
          onWorkStopped: D
        });
      }
      function E(B) {
        y.delete(B), y.size === 0 && (e.__subscriberRef.current = null);
      }
      function x(B) {
        var I = !1, L = null;
        if (y.forEach(function(k) {
          try {
            k.onInteractionTraced(B);
          } catch ($) {
            I || (I = !0, L = $);
          }
        }), I)
          throw L;
      }
      function C(B) {
        var I = !1, L = null;
        if (y.forEach(function(k) {
          try {
            k.onInteractionScheduledWorkCompleted(B);
          } catch ($) {
            I || (I = !0, L = $);
          }
        }), I)
          throw L;
      }
      function T(B, I) {
        var L = !1, k = null;
        if (y.forEach(function($) {
          try {
            $.onWorkScheduled(B, I);
          } catch (U) {
            L || (L = !0, k = U);
          }
        }), L)
          throw k;
      }
      function O(B, I) {
        var L = !1, k = null;
        if (y.forEach(function($) {
          try {
            $.onWorkStarted(B, I);
          } catch (U) {
            L || (L = !0, k = U);
          }
        }), L)
          throw k;
      }
      function D(B, I) {
        var L = !1, k = null;
        if (y.forEach(function($) {
          try {
            $.onWorkStopped(B, I);
          } catch (U) {
            L || (L = !0, k = U);
          }
        }), L)
          throw k;
      }
      function A(B, I) {
        var L = !1, k = null;
        if (y.forEach(function($) {
          try {
            $.onWorkCanceled(B, I);
          } catch (U) {
            L || (L = !0, k = U);
          }
        }), L)
          throw k;
      }
      e.unstable_clear = a, e.unstable_getCurrent = s, e.unstable_getThreadID = l, e.unstable_subscribe = b, e.unstable_trace = p, e.unstable_unsubscribe = E, e.unstable_wrap = h;
    }();
  }($R)), $R;
}
var SN;
function F4() {
  return SN || (SN = 1, function(e) {
    process.env.NODE_ENV === "production" ? e.exports = B4() : e.exports = z4();
  }(FR)), FR.exports;
}
/** @license React v17.0.2
 * react-dom.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var wN;
function $4() {
  return wN || (wN = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Wt, t = Tb(), n = iL(), r = F4(), a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function s(i) {
      {
        for (var o = arguments.length, f = new Array(o > 1 ? o - 1 : 0), g = 1; g < o; g++)
          f[g - 1] = arguments[g];
        p("warn", i, f);
      }
    }
    function l(i) {
      {
        for (var o = arguments.length, f = new Array(o > 1 ? o - 1 : 0), g = 1; g < o; g++)
          f[g - 1] = arguments[g];
        p("error", i, f);
      }
    }
    function p(i, o, f) {
      {
        var g = a.ReactDebugCurrentFrame, _ = g.getStackAddendum();
        _ !== "" && (o += "%s", f = f.concat([_]));
        var R = f.map(function(N) {
          return "" + N;
        });
        R.unshift("Warning: " + o), Function.prototype.apply.call(console[i], console, R);
      }
    }
    if (!e)
      throw Error("ReactDOM was loaded before React. Make sure you load the React package before loading ReactDOM.");
    var h = 0, y = 1, b = 2, E = 3, x = 4, C = 5, T = 6, O = 7, D = 8, A = 9, B = 10, I = 11, L = 12, k = 13, $ = 14, U = 15, K = 16, X = 17, Y = 18, J = 19, Q = 20, Z = 21, se = 22, pe = 23, be = 24, _e = !0, Se = !1, Oe = !1, re = !1, ie = /* @__PURE__ */ new Set(), ce = {}, le = {};
    function fe(i, o) {
      ve(i, o), ve(i + "Capture", o);
    }
    function ve(i, o) {
      ce[i] && l("EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.", i), ce[i] = o;
      {
        var f = i.toLowerCase();
        le[f] = i, i === "onDoubleClick" && (le.ondblclick = i);
      }
      for (var g = 0; g < o.length; g++)
        ie.add(o[g]);
    }
    var ee = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", Ae = 0, he = 1, Fe = 2, Ne = 3, xe = 4, oe = 5, it = 6, Le = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", qe = Le + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040", Tt = "data-reactroot", Qe = new RegExp("^[" + Le + "][" + qe + "]*$"), pt = Object.prototype.hasOwnProperty, en = {}, wt = {};
    function tn(i) {
      return pt.call(wt, i) ? !0 : pt.call(en, i) ? !1 : Qe.test(i) ? (wt[i] = !0, !0) : (en[i] = !0, l("Invalid attribute name: `%s`", i), !1);
    }
    function Vn(i, o, f) {
      return o !== null ? o.type === Ae : f ? !1 : i.length > 2 && (i[0] === "o" || i[0] === "O") && (i[1] === "n" || i[1] === "N");
    }
    function Kt(i, o, f, g) {
      if (f !== null && f.type === Ae)
        return !1;
      switch (typeof o) {
        case "function":
        case "symbol":
          return !0;
        case "boolean": {
          if (g)
            return !1;
          if (f !== null)
            return !f.acceptsBooleans;
          var _ = i.toLowerCase().slice(0, 5);
          return _ !== "data-" && _ !== "aria-";
        }
        default:
          return !1;
      }
    }
    function ft(i, o, f, g) {
      if (o === null || typeof o > "u" || Kt(i, o, f, g))
        return !0;
      if (g)
        return !1;
      if (f !== null)
        switch (f.type) {
          case Ne:
            return !o;
          case xe:
            return o === !1;
          case oe:
            return isNaN(o);
          case it:
            return isNaN(o) || o < 1;
        }
      return !1;
    }
    function Gt(i) {
      return gn.hasOwnProperty(i) ? gn[i] : null;
    }
    function xn(i, o, f, g, _, R, N) {
      this.acceptsBooleans = o === Fe || o === Ne || o === xe, this.attributeName = g, this.attributeNamespace = _, this.mustUseProperty = f, this.propertyName = i, this.type = o, this.sanitizeURL = R, this.removeEmptyString = N;
    }
    var gn = {}, rr = [
      "children",
      "dangerouslySetInnerHTML",
      "defaultValue",
      "defaultChecked",
      "innerHTML",
      "suppressContentEditableWarning",
      "suppressHydrationWarning",
      "style"
    ];
    rr.forEach(function(i) {
      gn[i] = new xn(
        i,
        Ae,
        !1,
        i,
        null,
        !1,
        !1
      );
    }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(i) {
      var o = i[0], f = i[1];
      gn[o] = new xn(
        o,
        he,
        !1,
        f,
        null,
        !1,
        !1
      );
    }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(i) {
      gn[i] = new xn(
        i,
        Fe,
        !1,
        i.toLowerCase(),
        null,
        !1,
        !1
      );
    }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(i) {
      gn[i] = new xn(
        i,
        Fe,
        !1,
        i,
        null,
        !1,
        !1
      );
    }), [
      "allowFullScreen",
      "async",
      "autoFocus",
      "autoPlay",
      "controls",
      "default",
      "defer",
      "disabled",
      "disablePictureInPicture",
      "disableRemotePlayback",
      "formNoValidate",
      "hidden",
      "loop",
      "noModule",
      "noValidate",
      "open",
      "playsInline",
      "readOnly",
      "required",
      "reversed",
      "scoped",
      "seamless",
      "itemScope"
    ].forEach(function(i) {
      gn[i] = new xn(
        i,
        Ne,
        !1,
        i.toLowerCase(),
        null,
        !1,
        !1
      );
    }), [
      "checked",
      "multiple",
      "muted",
      "selected"
    ].forEach(function(i) {
      gn[i] = new xn(
        i,
        Ne,
        !0,
        i,
        null,
        !1,
        !1
      );
    }), [
      "capture",
      "download"
    ].forEach(function(i) {
      gn[i] = new xn(
        i,
        xe,
        !1,
        i,
        null,
        !1,
        !1
      );
    }), [
      "cols",
      "rows",
      "size",
      "span"
    ].forEach(function(i) {
      gn[i] = new xn(
        i,
        it,
        !1,
        i,
        null,
        !1,
        !1
      );
    }), ["rowSpan", "start"].forEach(function(i) {
      gn[i] = new xn(
        i,
        oe,
        !1,
        i.toLowerCase(),
        null,
        !1,
        !1
      );
    });
    var Zi = /[\-\:]([a-z])/g, At = function(i) {
      return i[1].toUpperCase();
    };
    [
      "accent-height",
      "alignment-baseline",
      "arabic-form",
      "baseline-shift",
      "cap-height",
      "clip-path",
      "clip-rule",
      "color-interpolation",
      "color-interpolation-filters",
      "color-profile",
      "color-rendering",
      "dominant-baseline",
      "enable-background",
      "fill-opacity",
      "fill-rule",
      "flood-color",
      "flood-opacity",
      "font-family",
      "font-size",
      "font-size-adjust",
      "font-stretch",
      "font-style",
      "font-variant",
      "font-weight",
      "glyph-name",
      "glyph-orientation-horizontal",
      "glyph-orientation-vertical",
      "horiz-adv-x",
      "horiz-origin-x",
      "image-rendering",
      "letter-spacing",
      "lighting-color",
      "marker-end",
      "marker-mid",
      "marker-start",
      "overline-position",
      "overline-thickness",
      "paint-order",
      "panose-1",
      "pointer-events",
      "rendering-intent",
      "shape-rendering",
      "stop-color",
      "stop-opacity",
      "strikethrough-position",
      "strikethrough-thickness",
      "stroke-dasharray",
      "stroke-dashoffset",
      "stroke-linecap",
      "stroke-linejoin",
      "stroke-miterlimit",
      "stroke-opacity",
      "stroke-width",
      "text-anchor",
      "text-decoration",
      "text-rendering",
      "underline-position",
      "underline-thickness",
      "unicode-bidi",
      "unicode-range",
      "units-per-em",
      "v-alphabetic",
      "v-hanging",
      "v-ideographic",
      "v-mathematical",
      "vector-effect",
      "vert-adv-y",
      "vert-origin-x",
      "vert-origin-y",
      "word-spacing",
      "writing-mode",
      "xmlns:xlink",
      "x-height"
    ].forEach(function(i) {
      var o = i.replace(Zi, At);
      gn[o] = new xn(
        o,
        he,
        !1,
        i,
        null,
        !1,
        !1
      );
    }), [
      "xlink:actuate",
      "xlink:arcrole",
      "xlink:role",
      "xlink:show",
      "xlink:title",
      "xlink:type"
    ].forEach(function(i) {
      var o = i.replace(Zi, At);
      gn[o] = new xn(
        o,
        he,
        !1,
        i,
        "http://www.w3.org/1999/xlink",
        !1,
        !1
      );
    }), [
      "xml:base",
      "xml:lang",
      "xml:space"
    ].forEach(function(i) {
      var o = i.replace(Zi, At);
      gn[o] = new xn(
        o,
        he,
        !1,
        i,
        "http://www.w3.org/XML/1998/namespace",
        !1,
        !1
      );
    }), ["tabIndex", "crossOrigin"].forEach(function(i) {
      gn[i] = new xn(
        i,
        he,
        !1,
        i.toLowerCase(),
        null,
        !1,
        !1
      );
    });
    var at = "xlinkHref";
    gn[at] = new xn(
      "xlinkHref",
      he,
      !1,
      "xlink:href",
      "http://www.w3.org/1999/xlink",
      !0,
      !1
    ), ["src", "href", "action", "formAction"].forEach(function(i) {
      gn[i] = new xn(
        i,
        he,
        !1,
        i.toLowerCase(),
        null,
        !0,
        !0
      );
    });
    var bt = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i, Pt = !1;
    function dn(i) {
      !Pt && bt.test(i) && (Pt = !0, l("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(i)));
    }
    function Nn(i, o, f, g) {
      if (g.mustUseProperty) {
        var _ = g.propertyName;
        return i[_];
      } else {
        g.sanitizeURL && dn("" + f);
        var R = g.attributeName, N = null;
        if (g.type === xe) {
          if (i.hasAttribute(R)) {
            var z = i.getAttribute(R);
            return z === "" ? !0 : ft(o, f, g, !1) ? z : z === "" + f ? f : z;
          }
        } else if (i.hasAttribute(R)) {
          if (ft(o, f, g, !1))
            return i.getAttribute(R);
          if (g.type === Ne)
            return f;
          N = i.getAttribute(R);
        }
        return ft(o, f, g, !1) ? N === null ? f : N : N === "" + f ? f : N;
      }
    }
    function kn(i, o, f) {
      {
        if (!tn(o))
          return;
        if (M1(f))
          return f;
        if (!i.hasAttribute(o))
          return f === void 0 ? void 0 : null;
        var g = i.getAttribute(o);
        return g === "" + f ? f : g;
      }
    }
    function In(i, o, f, g) {
      var _ = Gt(o);
      if (!Vn(o, _, g)) {
        if (ft(o, f, _, g) && (f = null), g || _ === null) {
          if (tn(o)) {
            var R = o;
            f === null ? i.removeAttribute(R) : i.setAttribute(R, "" + f);
          }
          return;
        }
        var N = _.mustUseProperty;
        if (N) {
          var z = _.propertyName;
          if (f === null) {
            var W = _.type;
            i[z] = W === Ne ? !1 : "";
          } else
            i[z] = f;
          return;
        }
        var ne = _.attributeName, ae = _.attributeNamespace;
        if (f === null)
          i.removeAttribute(ne);
        else {
          var Pe = _.type, ye;
          Pe === Ne || Pe === xe && f === !0 ? ye = "" : (ye = "" + f, _.sanitizeURL && dn(ye.toString())), ae ? i.setAttributeNS(ae, ne, ye) : i.setAttribute(ne, ye);
        }
      }
    }
    var Cr = 60103, Nt = 60106, jn = 60107, ss = 60108, Ji = 60114, so = 60109, Ua = 60110, uo = 60112, ea = 60113, ta = 60120, us = 60115, Va = 60116, il = 60121, de = 60119, tt = 60128, ct = 60129, kt = 60130, mn = 60131;
    if (typeof Symbol == "function" && Symbol.for) {
      var zt = Symbol.for;
      Cr = zt("react.element"), Nt = zt("react.portal"), jn = zt("react.fragment"), ss = zt("react.strict_mode"), Ji = zt("react.profiler"), so = zt("react.provider"), Ua = zt("react.context"), uo = zt("react.forward_ref"), ea = zt("react.suspense"), ta = zt("react.suspense_list"), us = zt("react.memo"), Va = zt("react.lazy"), il = zt("react.block"), zt("react.server.block"), zt("react.fundamental"), de = zt("react.scope"), tt = zt("react.opaque.id"), ct = zt("react.debug_trace_mode"), kt = zt("react.offscreen"), mn = zt("react.legacy_hidden");
    }
    var yn = typeof Symbol == "function" && Symbol.iterator, Sn = "@@iterator";
    function Kn(i) {
      if (i === null || typeof i != "object")
        return null;
      var o = yn && i[yn] || i[Sn];
      return typeof o == "function" ? o : null;
    }
    var Fn = 0, Qn, Ea, xa, ru, Vi, Td, ig;
    function ag() {
    }
    ag.__reactDisabledLog = !0;
    function Sa() {
      {
        if (Fn === 0) {
          Qn = console.log, Ea = console.info, xa = console.warn, ru = console.error, Vi = console.group, Td = console.groupCollapsed, ig = console.groupEnd;
          var i = {
            configurable: !0,
            enumerable: !0,
            value: ag,
            writable: !0
          };
          Object.defineProperties(console, {
            info: i,
            log: i,
            warn: i,
            error: i,
            group: i,
            groupCollapsed: i,
            groupEnd: i
          });
        }
        Fn++;
      }
    }
    function Di() {
      {
        if (Fn--, Fn === 0) {
          var i = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: t({}, i, {
              value: Qn
            }),
            info: t({}, i, {
              value: Ea
            }),
            warn: t({}, i, {
              value: xa
            }),
            error: t({}, i, {
              value: ru
            }),
            group: t({}, i, {
              value: Vi
            }),
            groupCollapsed: t({}, i, {
              value: Td
            }),
            groupEnd: t({}, i, {
              value: ig
            })
          });
        }
        Fn < 0 && l("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var al = a.ReactCurrentDispatcher, Od;
    function iu(i, o, f) {
      {
        if (Od === void 0)
          try {
            throw Error();
          } catch (_) {
            var g = _.stack.trim().match(/\n( *(at )?)/);
            Od = g && g[1] || "";
          }
        return `
` + Od + i;
      }
    }
    var Dd = !1, oc;
    {
      var av = typeof WeakMap == "function" ? WeakMap : Map;
      oc = new av();
    }
    function sc(i, o) {
      if (!i || Dd)
        return "";
      {
        var f = oc.get(i);
        if (f !== void 0)
          return f;
      }
      var g;
      Dd = !0;
      var _ = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var R;
      R = al.current, al.current = null, Sa();
      try {
        if (o) {
          var N = function() {
            throw Error();
          };
          if (Object.defineProperty(N.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(N, []);
            } catch (Ke) {
              g = Ke;
            }
            Reflect.construct(i, [], N);
          } else {
            try {
              N.call();
            } catch (Ke) {
              g = Ke;
            }
            i.call(N.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Ke) {
            g = Ke;
          }
          i();
        }
      } catch (Ke) {
        if (Ke && g && typeof Ke.stack == "string") {
          for (var z = Ke.stack.split(`
`), W = g.stack.split(`
`), ne = z.length - 1, ae = W.length - 1; ne >= 1 && ae >= 0 && z[ne] !== W[ae]; )
            ae--;
          for (; ne >= 1 && ae >= 0; ne--, ae--)
            if (z[ne] !== W[ae]) {
              if (ne !== 1 || ae !== 1)
                do
                  if (ne--, ae--, ae < 0 || z[ne] !== W[ae]) {
                    var Pe = `
` + z[ne].replace(" at new ", " at ");
                    return typeof i == "function" && oc.set(i, Pe), Pe;
                  }
                while (ne >= 1 && ae >= 0);
              break;
            }
        }
      } finally {
        Dd = !1, al.current = R, Di(), Error.prepareStackTrace = _;
      }
      var ye = i ? i.displayName || i.name : "", Ie = ye ? iu(ye) : "";
      return typeof i == "function" && oc.set(i, Ie), Ie;
    }
    function og(i, o, f) {
      return sc(i, !0);
    }
    function uc(i, o, f) {
      return sc(i, !1);
    }
    function ov(i) {
      var o = i.prototype;
      return !!(o && o.isReactComponent);
    }
    function ja(i, o, f) {
      if (i == null)
        return "";
      if (typeof i == "function")
        return sc(i, ov(i));
      if (typeof i == "string")
        return iu(i);
      switch (i) {
        case ea:
          return iu("Suspense");
        case ta:
          return iu("SuspenseList");
      }
      if (typeof i == "object")
        switch (i.$$typeof) {
          case uo:
            return uc(i.render);
          case us:
            return ja(i.type, o, f);
          case il:
            return uc(i._render);
          case Va: {
            var g = i, _ = g._payload, R = g._init;
            try {
              return ja(R(_), o, f);
            } catch {
            }
          }
        }
      return "";
    }
    function ls(i) {
      switch (i._debugOwner && i._debugOwner.type, i._debugSource, i.tag) {
        case C:
          return iu(i.type);
        case K:
          return iu("Lazy");
        case k:
          return iu("Suspense");
        case J:
          return iu("SuspenseList");
        case h:
        case b:
        case U:
          return uc(i.type);
        case I:
          return uc(i.type.render);
        case se:
          return uc(i.type._render);
        case y:
          return og(i.type);
        default:
          return "";
      }
    }
    function To(i) {
      try {
        var o = "", f = i;
        do
          o += ls(f), f = f.return;
        while (f);
        return o;
      } catch (g) {
        return `
Error generating stack: ` + g.message + `
` + g.stack;
      }
    }
    function cs(i, o, f) {
      var g = o.displayName || o.name || "";
      return i.displayName || (g !== "" ? f + "(" + g + ")" : f);
    }
    function au(i) {
      return i.displayName || "Context";
    }
    function dt(i) {
      if (i == null)
        return null;
      if (typeof i.tag == "number" && l("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof i == "function")
        return i.displayName || i.name || null;
      if (typeof i == "string")
        return i;
      switch (i) {
        case jn:
          return "Fragment";
        case Nt:
          return "Portal";
        case Ji:
          return "Profiler";
        case ss:
          return "StrictMode";
        case ea:
          return "Suspense";
        case ta:
          return "SuspenseList";
      }
      if (typeof i == "object")
        switch (i.$$typeof) {
          case Ua:
            var o = i;
            return au(o) + ".Consumer";
          case so:
            var f = i;
            return au(f._context) + ".Provider";
          case uo:
            return cs(i, i.render, "ForwardRef");
          case us:
            return dt(i.type);
          case il:
            return dt(i._render);
          case Va: {
            var g = i, _ = g._payload, R = g._init;
            try {
              return dt(R(_));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var ol = a.ReactDebugCurrentFrame, ri = null, fs = !1;
    function lc() {
      {
        if (ri === null)
          return null;
        var i = ri._debugOwner;
        if (i !== null && typeof i < "u")
          return dt(i.type);
      }
      return null;
    }
    function cc() {
      return ri === null ? "" : To(ri);
    }
    function ji() {
      ol.getCurrentStack = null, ri = null, fs = !1;
    }
    function $r(i) {
      ol.getCurrentStack = cc, ri = i, fs = !1;
    }
    function wa(i) {
      fs = i;
    }
    function sv() {
      return fs;
    }
    function na(i) {
      return "" + i;
    }
    function ra(i) {
      switch (typeof i) {
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
          return i;
        default:
          return "";
      }
    }
    var sl = {
      button: !0,
      checkbox: !0,
      image: !0,
      hidden: !0,
      radio: !0,
      reset: !0,
      submit: !0
    };
    function ul(i, o) {
      sl[o.type] || o.onChange || o.onInput || o.readOnly || o.disabled || o.value == null || l("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."), o.onChange || o.readOnly || o.disabled || o.checked == null || l("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function ou(i) {
      var o = i.type, f = i.nodeName;
      return f && f.toLowerCase() === "input" && (o === "checkbox" || o === "radio");
    }
    function Md(i) {
      return i._valueTracker;
    }
    function uv(i) {
      i._valueTracker = null;
    }
    function af(i) {
      var o = "";
      return i && (ou(i) ? o = i.checked ? "true" : "false" : o = i.value), o;
    }
    function lv(i) {
      var o = ou(i) ? "checked" : "value", f = Object.getOwnPropertyDescriptor(i.constructor.prototype, o), g = "" + i[o];
      if (!(i.hasOwnProperty(o) || typeof f > "u" || typeof f.get != "function" || typeof f.set != "function")) {
        var _ = f.get, R = f.set;
        Object.defineProperty(i, o, {
          configurable: !0,
          get: function() {
            return _.call(this);
          },
          set: function(z) {
            g = "" + z, R.call(this, z);
          }
        }), Object.defineProperty(i, o, {
          enumerable: f.enumerable
        });
        var N = {
          getValue: function() {
            return g;
          },
          setValue: function(z) {
            g = "" + z;
          },
          stopTracking: function() {
            uv(i), delete i[o];
          }
        };
        return N;
      }
    }
    function fc(i) {
      Md(i) || (i._valueTracker = lv(i));
    }
    function cv(i) {
      if (!i)
        return !1;
      var o = Md(i);
      if (!o)
        return !0;
      var f = o.getValue(), g = af(i);
      return g !== f ? (o.setValue(g), !0) : !1;
    }
    function of(i) {
      if (i = i || (typeof document < "u" ? document : void 0), typeof i > "u")
        return null;
      try {
        return i.activeElement || i.body;
      } catch {
        return i.body;
      }
    }
    var fv = !1, sf = !1, sg = !1, Ad = !1;
    function ug(i) {
      var o = i.type === "checkbox" || i.type === "radio";
      return o ? i.checked != null : i.value != null;
    }
    function Wn(i, o) {
      var f = i, g = o.checked, _ = t({}, o, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: g != null ? g : f._wrapperState.initialChecked
      });
      return _;
    }
    function ds(i, o) {
      ul("input", o), o.checked !== void 0 && o.defaultChecked !== void 0 && !sf && (l("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", lc() || "A component", o.type), sf = !0), o.value !== void 0 && o.defaultValue !== void 0 && !fv && (l("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", lc() || "A component", o.type), fv = !0);
      var f = i, g = o.defaultValue == null ? "" : o.defaultValue;
      f._wrapperState = {
        initialChecked: o.checked != null ? o.checked : o.defaultChecked,
        initialValue: ra(o.value != null ? o.value : g),
        controlled: ug(o)
      };
    }
    function lg(i, o) {
      var f = i, g = o.checked;
      g != null && In(f, "checked", g, !1);
    }
    function dv(i, o) {
      var f = i;
      {
        var g = ug(o);
        !f._wrapperState.controlled && g && !Ad && (l("A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), Ad = !0), f._wrapperState.controlled && !g && !sg && (l("A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), sg = !0);
      }
      lg(i, o);
      var _ = ra(o.value), R = o.type;
      if (_ != null)
        R === "number" ? (_ === 0 && f.value === "" || f.value != _) && (f.value = na(_)) : f.value !== na(_) && (f.value = na(_));
      else if (R === "submit" || R === "reset") {
        f.removeAttribute("value");
        return;
      }
      o.hasOwnProperty("value") ? Dn(f, o.type, _) : o.hasOwnProperty("defaultValue") && Dn(f, o.type, ra(o.defaultValue)), o.checked == null && o.defaultChecked != null && (f.defaultChecked = !!o.defaultChecked);
    }
    function dc(i, o, f) {
      var g = i;
      if (o.hasOwnProperty("value") || o.hasOwnProperty("defaultValue")) {
        var _ = o.type, R = _ === "submit" || _ === "reset";
        if (R && (o.value === void 0 || o.value === null))
          return;
        var N = na(g._wrapperState.initialValue);
        f || N !== g.value && (g.value = N), g.defaultValue = N;
      }
      var z = g.name;
      z !== "" && (g.name = ""), g.defaultChecked = !g.defaultChecked, g.defaultChecked = !!g._wrapperState.initialChecked, z !== "" && (g.name = z);
    }
    function cg(i, o) {
      var f = i;
      dv(f, o), Pd(f, o);
    }
    function Pd(i, o) {
      var f = o.name;
      if (o.type === "radio" && f != null) {
        for (var g = i; g.parentNode; )
          g = g.parentNode;
        for (var _ = g.querySelectorAll("input[name=" + JSON.stringify("" + f) + '][type="radio"]'), R = 0; R < _.length; R++) {
          var N = _[R];
          if (!(N === i || N.form !== i.form)) {
            var z = om(N);
            if (!z)
              throw Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
            cv(N), dv(N, z);
          }
        }
      }
    }
    function Dn(i, o, f) {
      (o !== "number" || of(i.ownerDocument) !== i) && (f == null ? i.defaultValue = na(i._wrapperState.initialValue) : i.defaultValue !== na(f) && (i.defaultValue = na(f)));
    }
    var $n = !1, uf = !1;
    function su(i) {
      var o = "";
      return e.Children.forEach(i, function(f) {
        f != null && (o += f);
      }), o;
    }
    function fg(i, o) {
      typeof o.children == "object" && o.children !== null && e.Children.forEach(o.children, function(f) {
        f != null && (typeof f == "string" || typeof f == "number" || typeof f.type == "string" && (uf || (uf = !0, l("Only strings and numbers are supported as <option> children."))));
      }), o.selected != null && !$n && (l("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."), $n = !0);
    }
    function Iy(i, o) {
      o.value != null && i.setAttribute("value", na(ra(o.value)));
    }
    function pv(i, o) {
      var f = t({
        children: void 0
      }, o), g = su(o.children);
      return g && (f.children = g), f;
    }
    var vv;
    vv = !1;
    function hv() {
      var i = lc();
      return i ? `

Check the render method of \`` + i + "`." : "";
    }
    var lf = ["value", "defaultValue"];
    function yi(i) {
      {
        ul("select", i);
        for (var o = 0; o < lf.length; o++) {
          var f = lf[o];
          if (i[f] != null) {
            var g = Array.isArray(i[f]);
            i.multiple && !g ? l("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", f, hv()) : !i.multiple && g && l("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", f, hv());
          }
        }
      }
    }
    function uu(i, o, f, g) {
      var _ = i.options;
      if (o) {
        for (var R = f, N = {}, z = 0; z < R.length; z++)
          N["$" + R[z]] = !0;
        for (var W = 0; W < _.length; W++) {
          var ne = N.hasOwnProperty("$" + _[W].value);
          _[W].selected !== ne && (_[W].selected = ne), ne && g && (_[W].defaultSelected = !0);
        }
      } else {
        for (var ae = na(ra(f)), Pe = null, ye = 0; ye < _.length; ye++) {
          if (_[ye].value === ae) {
            _[ye].selected = !0, g && (_[ye].defaultSelected = !0);
            return;
          }
          Pe === null && !_[ye].disabled && (Pe = _[ye]);
        }
        Pe !== null && (Pe.selected = !0);
      }
    }
    function lo(i, o) {
      return t({}, o, {
        value: void 0
      });
    }
    function cf(i, o) {
      var f = i;
      yi(o), f._wrapperState = {
        wasMultiple: !!o.multiple
      }, o.value !== void 0 && o.defaultValue !== void 0 && !vv && (l("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components"), vv = !0);
    }
    function Oo(i, o) {
      var f = i;
      f.multiple = !!o.multiple;
      var g = o.value;
      g != null ? uu(f, !!o.multiple, g, !1) : o.defaultValue != null && uu(f, !!o.multiple, o.defaultValue, !0);
    }
    function ia(i, o) {
      var f = i, g = f._wrapperState.wasMultiple;
      f._wrapperState.wasMultiple = !!o.multiple;
      var _ = o.value;
      _ != null ? uu(f, !!o.multiple, _, !1) : g !== !!o.multiple && (o.defaultValue != null ? uu(f, !!o.multiple, o.defaultValue, !0) : uu(f, !!o.multiple, o.multiple ? [] : "", !1));
    }
    function ff(i, o) {
      var f = i, g = o.value;
      g != null && uu(f, !!o.multiple, g, !1);
    }
    var Nd = !1;
    function ll(i, o) {
      var f = i;
      if (o.dangerouslySetInnerHTML != null)
        throw Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
      var g = t({}, o, {
        value: void 0,
        defaultValue: void 0,
        children: na(f._wrapperState.initialValue)
      });
      return g;
    }
    function pc(i, o) {
      var f = i;
      ul("textarea", o), o.value !== void 0 && o.defaultValue !== void 0 && !Nd && (l("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components", lc() || "A component"), Nd = !0);
      var g = o.value;
      if (g == null) {
        var _ = o.children, R = o.defaultValue;
        if (_ != null) {
          l("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
          {
            if (R != null)
              throw Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
            if (Array.isArray(_)) {
              if (!(_.length <= 1))
                throw Error("<textarea> can only have at most one child.");
              _ = _[0];
            }
            R = _;
          }
        }
        R == null && (R = ""), g = R;
      }
      f._wrapperState = {
        initialValue: ra(g)
      };
    }
    function kd(i, o) {
      var f = i, g = ra(o.value), _ = ra(o.defaultValue);
      if (g != null) {
        var R = na(g);
        R !== f.value && (f.value = R), o.defaultValue == null && f.defaultValue !== R && (f.defaultValue = R);
      }
      _ != null && (f.defaultValue = na(_));
    }
    function Wi(i, o) {
      var f = i, g = f.textContent;
      g === f._wrapperState.initialValue && g !== "" && g !== null && (f.value = g);
    }
    function ii(i, o) {
      kd(i, o);
    }
    var vc = "http://www.w3.org/1999/xhtml", bi = "http://www.w3.org/1998/Math/MathML", gv = "http://www.w3.org/2000/svg", df = {
      html: vc,
      mathml: bi,
      svg: gv
    };
    function Wa(i) {
      switch (i) {
        case "svg":
          return gv;
        case "math":
          return bi;
        default:
          return vc;
      }
    }
    function Do(i, o) {
      return i == null || i === vc ? Wa(o) : i === gv && o === "foreignObject" ? vc : i;
    }
    var hc = function(i) {
      return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(o, f, g, _) {
        MSApp.execUnsafeLocalFunction(function() {
          return i(o, f, g, _);
        });
      } : i;
    }, Gn, ps = hc(function(i, o) {
      if (i.namespaceURI === df.svg && !("innerHTML" in i)) {
        Gn = Gn || document.createElement("div"), Gn.innerHTML = "<svg>" + o.valueOf().toString() + "</svg>";
        for (var f = Gn.firstChild; i.firstChild; )
          i.removeChild(i.firstChild);
        for (; f.firstChild; )
          i.appendChild(f.firstChild);
        return;
      }
      i.innerHTML = o;
    }), aa = 1, vs = 3, _i = 8, lu = 9, dg = 11, Id = function(i, o) {
      if (o) {
        var f = i.firstChild;
        if (f && f === i.lastChild && f.nodeType === vs) {
          f.nodeValue = o;
          return;
        }
      }
      i.textContent = o;
    }, pg = {
      animation: ["animationDelay", "animationDirection", "animationDuration", "animationFillMode", "animationIterationCount", "animationName", "animationPlayState", "animationTimingFunction"],
      background: ["backgroundAttachment", "backgroundClip", "backgroundColor", "backgroundImage", "backgroundOrigin", "backgroundPositionX", "backgroundPositionY", "backgroundRepeat", "backgroundSize"],
      backgroundPosition: ["backgroundPositionX", "backgroundPositionY"],
      border: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth", "borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth", "borderLeftColor", "borderLeftStyle", "borderLeftWidth", "borderRightColor", "borderRightStyle", "borderRightWidth", "borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderBlockEnd: ["borderBlockEndColor", "borderBlockEndStyle", "borderBlockEndWidth"],
      borderBlockStart: ["borderBlockStartColor", "borderBlockStartStyle", "borderBlockStartWidth"],
      borderBottom: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth"],
      borderColor: ["borderBottomColor", "borderLeftColor", "borderRightColor", "borderTopColor"],
      borderImage: ["borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth"],
      borderInlineEnd: ["borderInlineEndColor", "borderInlineEndStyle", "borderInlineEndWidth"],
      borderInlineStart: ["borderInlineStartColor", "borderInlineStartStyle", "borderInlineStartWidth"],
      borderLeft: ["borderLeftColor", "borderLeftStyle", "borderLeftWidth"],
      borderRadius: ["borderBottomLeftRadius", "borderBottomRightRadius", "borderTopLeftRadius", "borderTopRightRadius"],
      borderRight: ["borderRightColor", "borderRightStyle", "borderRightWidth"],
      borderStyle: ["borderBottomStyle", "borderLeftStyle", "borderRightStyle", "borderTopStyle"],
      borderTop: ["borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderWidth: ["borderBottomWidth", "borderLeftWidth", "borderRightWidth", "borderTopWidth"],
      columnRule: ["columnRuleColor", "columnRuleStyle", "columnRuleWidth"],
      columns: ["columnCount", "columnWidth"],
      flex: ["flexBasis", "flexGrow", "flexShrink"],
      flexFlow: ["flexDirection", "flexWrap"],
      font: ["fontFamily", "fontFeatureSettings", "fontKerning", "fontLanguageOverride", "fontSize", "fontSizeAdjust", "fontStretch", "fontStyle", "fontVariant", "fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition", "fontWeight", "lineHeight"],
      fontVariant: ["fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition"],
      gap: ["columnGap", "rowGap"],
      grid: ["gridAutoColumns", "gridAutoFlow", "gridAutoRows", "gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
      gridArea: ["gridColumnEnd", "gridColumnStart", "gridRowEnd", "gridRowStart"],
      gridColumn: ["gridColumnEnd", "gridColumnStart"],
      gridColumnGap: ["columnGap"],
      gridGap: ["columnGap", "rowGap"],
      gridRow: ["gridRowEnd", "gridRowStart"],
      gridRowGap: ["rowGap"],
      gridTemplate: ["gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
      listStyle: ["listStyleImage", "listStylePosition", "listStyleType"],
      margin: ["marginBottom", "marginLeft", "marginRight", "marginTop"],
      marker: ["markerEnd", "markerMid", "markerStart"],
      mask: ["maskClip", "maskComposite", "maskImage", "maskMode", "maskOrigin", "maskPositionX", "maskPositionY", "maskRepeat", "maskSize"],
      maskPosition: ["maskPositionX", "maskPositionY"],
      outline: ["outlineColor", "outlineStyle", "outlineWidth"],
      overflow: ["overflowX", "overflowY"],
      padding: ["paddingBottom", "paddingLeft", "paddingRight", "paddingTop"],
      placeContent: ["alignContent", "justifyContent"],
      placeItems: ["alignItems", "justifyItems"],
      placeSelf: ["alignSelf", "justifySelf"],
      textDecoration: ["textDecorationColor", "textDecorationLine", "textDecorationStyle"],
      textEmphasis: ["textEmphasisColor", "textEmphasisStyle"],
      transition: ["transitionDelay", "transitionDuration", "transitionProperty", "transitionTimingFunction"],
      wordWrap: ["overflowWrap"]
    }, cu = {
      animationIterationCount: !0,
      borderImageOutset: !0,
      borderImageSlice: !0,
      borderImageWidth: !0,
      boxFlex: !0,
      boxFlexGroup: !0,
      boxOrdinalGroup: !0,
      columnCount: !0,
      columns: !0,
      flex: !0,
      flexGrow: !0,
      flexPositive: !0,
      flexShrink: !0,
      flexNegative: !0,
      flexOrder: !0,
      gridArea: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowSpan: !0,
      gridRowStart: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnSpan: !0,
      gridColumnStart: !0,
      fontWeight: !0,
      lineClamp: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      tabSize: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
      fillOpacity: !0,
      floodOpacity: !0,
      stopOpacity: !0,
      strokeDasharray: !0,
      strokeDashoffset: !0,
      strokeMiterlimit: !0,
      strokeOpacity: !0,
      strokeWidth: !0
    };
    function cl(i, o) {
      return i + o.charAt(0).toUpperCase() + o.substring(1);
    }
    var Ly = ["Webkit", "ms", "Moz", "O"];
    Object.keys(cu).forEach(function(i) {
      Ly.forEach(function(o) {
        cu[cl(o, i)] = cu[i];
      });
    });
    function Ld(i, o, f) {
      var g = o == null || typeof o == "boolean" || o === "";
      return g ? "" : !f && typeof o == "number" && o !== 0 && !(cu.hasOwnProperty(i) && cu[i]) ? o + "px" : ("" + o).trim();
    }
    var vg = /([A-Z])/g, mv = /^ms-/;
    function pf(i) {
      return i.replace(vg, "-$1").toLowerCase().replace(mv, "-ms-");
    }
    var yv = function() {
    };
    {
      var By = /^(?:webkit|moz|o)[A-Z]/, bv = /^-ms-/, Bd = /-(.)/g, hg = /;\s*$/, fl = {}, Gi = {}, zd = !1, gc = !1, gg = function(i) {
        return i.replace(Bd, function(o, f) {
          return f.toUpperCase();
        });
      }, mg = function(i) {
        fl.hasOwnProperty(i) && fl[i] || (fl[i] = !0, l(
          "Unsupported style property %s. Did you mean %s?",
          i,
          gg(i.replace(bv, "ms-"))
        ));
      }, _v = function(i) {
        fl.hasOwnProperty(i) && fl[i] || (fl[i] = !0, l("Unsupported vendor-prefixed style property %s. Did you mean %s?", i, i.charAt(0).toUpperCase() + i.slice(1)));
      }, vf = function(i, o) {
        Gi.hasOwnProperty(o) && Gi[o] || (Gi[o] = !0, l(`Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`, i, o.replace(hg, "")));
      }, zy = function(i, o) {
        zd || (zd = !0, l("`NaN` is an invalid value for the `%s` css style property.", i));
      }, yg = function(i, o) {
        gc || (gc = !0, l("`Infinity` is an invalid value for the `%s` css style property.", i));
      };
      yv = function(i, o) {
        i.indexOf("-") > -1 ? mg(i) : By.test(i) ? _v(i) : hg.test(o) && vf(i, o), typeof o == "number" && (isNaN(o) ? zy(i, o) : isFinite(o) || yg(i, o));
      };
    }
    var bg = yv;
    function dl(i) {
      {
        var o = "", f = "";
        for (var g in i)
          if (!!i.hasOwnProperty(g)) {
            var _ = i[g];
            if (_ != null) {
              var R = g.indexOf("--") === 0;
              o += f + (R ? g : pf(g)) + ":", o += Ld(g, _, R), f = ";";
            }
          }
        return o || null;
      }
    }
    function Ev(i, o) {
      var f = i.style;
      for (var g in o)
        if (!!o.hasOwnProperty(g)) {
          var _ = g.indexOf("--") === 0;
          _ || bg(g, o[g]);
          var R = Ld(g, o[g], _);
          g === "float" && (g = "cssFloat"), _ ? f.setProperty(g, R) : f[g] = R;
        }
    }
    function _g(i) {
      return i == null || typeof i == "boolean" || i === "";
    }
    function hs(i) {
      var o = {};
      for (var f in i)
        for (var g = pg[f] || [f], _ = 0; _ < g.length; _++)
          o[g[_]] = f;
      return o;
    }
    function Eg(i, o) {
      {
        if (!o)
          return;
        var f = hs(i), g = hs(o), _ = {};
        for (var R in f) {
          var N = f[R], z = g[R];
          if (z && N !== z) {
            var W = N + "," + z;
            if (_[W])
              continue;
            _[W] = !0, l("%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", _g(i[N]) ? "Removing" : "Updating", N, z);
          }
        }
      }
    }
    var fu = {
      area: !0,
      base: !0,
      br: !0,
      col: !0,
      embed: !0,
      hr: !0,
      img: !0,
      input: !0,
      keygen: !0,
      link: !0,
      meta: !0,
      param: !0,
      source: !0,
      track: !0,
      wbr: !0
    }, Fd = t({
      menuitem: !0
    }, fu), xg = "__html";
    function $d(i, o) {
      if (!!o) {
        if (Fd[i] && !(o.children == null && o.dangerouslySetInnerHTML == null))
          throw Error(i + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
        if (o.dangerouslySetInnerHTML != null) {
          if (o.children != null)
            throw Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
          if (!(typeof o.dangerouslySetInnerHTML == "object" && xg in o.dangerouslySetInnerHTML))
            throw Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        }
        if (!o.suppressContentEditableWarning && o.contentEditable && o.children != null && l("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."), !(o.style == null || typeof o.style == "object"))
          throw Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
      }
    }
    function co(i, o) {
      if (i.indexOf("-") === -1)
        return typeof o.is == "string";
      switch (i) {
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    var Ca = {
      accept: "accept",
      acceptcharset: "acceptCharset",
      "accept-charset": "acceptCharset",
      accesskey: "accessKey",
      action: "action",
      allowfullscreen: "allowFullScreen",
      alt: "alt",
      as: "as",
      async: "async",
      autocapitalize: "autoCapitalize",
      autocomplete: "autoComplete",
      autocorrect: "autoCorrect",
      autofocus: "autoFocus",
      autoplay: "autoPlay",
      autosave: "autoSave",
      capture: "capture",
      cellpadding: "cellPadding",
      cellspacing: "cellSpacing",
      challenge: "challenge",
      charset: "charSet",
      checked: "checked",
      children: "children",
      cite: "cite",
      class: "className",
      classid: "classID",
      classname: "className",
      cols: "cols",
      colspan: "colSpan",
      content: "content",
      contenteditable: "contentEditable",
      contextmenu: "contextMenu",
      controls: "controls",
      controlslist: "controlsList",
      coords: "coords",
      crossorigin: "crossOrigin",
      dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
      data: "data",
      datetime: "dateTime",
      default: "default",
      defaultchecked: "defaultChecked",
      defaultvalue: "defaultValue",
      defer: "defer",
      dir: "dir",
      disabled: "disabled",
      disablepictureinpicture: "disablePictureInPicture",
      disableremoteplayback: "disableRemotePlayback",
      download: "download",
      draggable: "draggable",
      enctype: "encType",
      enterkeyhint: "enterKeyHint",
      for: "htmlFor",
      form: "form",
      formmethod: "formMethod",
      formaction: "formAction",
      formenctype: "formEncType",
      formnovalidate: "formNoValidate",
      formtarget: "formTarget",
      frameborder: "frameBorder",
      headers: "headers",
      height: "height",
      hidden: "hidden",
      high: "high",
      href: "href",
      hreflang: "hrefLang",
      htmlfor: "htmlFor",
      httpequiv: "httpEquiv",
      "http-equiv": "httpEquiv",
      icon: "icon",
      id: "id",
      innerhtml: "innerHTML",
      inputmode: "inputMode",
      integrity: "integrity",
      is: "is",
      itemid: "itemID",
      itemprop: "itemProp",
      itemref: "itemRef",
      itemscope: "itemScope",
      itemtype: "itemType",
      keyparams: "keyParams",
      keytype: "keyType",
      kind: "kind",
      label: "label",
      lang: "lang",
      list: "list",
      loop: "loop",
      low: "low",
      manifest: "manifest",
      marginwidth: "marginWidth",
      marginheight: "marginHeight",
      max: "max",
      maxlength: "maxLength",
      media: "media",
      mediagroup: "mediaGroup",
      method: "method",
      min: "min",
      minlength: "minLength",
      multiple: "multiple",
      muted: "muted",
      name: "name",
      nomodule: "noModule",
      nonce: "nonce",
      novalidate: "noValidate",
      open: "open",
      optimum: "optimum",
      pattern: "pattern",
      placeholder: "placeholder",
      playsinline: "playsInline",
      poster: "poster",
      preload: "preload",
      profile: "profile",
      radiogroup: "radioGroup",
      readonly: "readOnly",
      referrerpolicy: "referrerPolicy",
      rel: "rel",
      required: "required",
      reversed: "reversed",
      role: "role",
      rows: "rows",
      rowspan: "rowSpan",
      sandbox: "sandbox",
      scope: "scope",
      scoped: "scoped",
      scrolling: "scrolling",
      seamless: "seamless",
      selected: "selected",
      shape: "shape",
      size: "size",
      sizes: "sizes",
      span: "span",
      spellcheck: "spellCheck",
      src: "src",
      srcdoc: "srcDoc",
      srclang: "srcLang",
      srcset: "srcSet",
      start: "start",
      step: "step",
      style: "style",
      summary: "summary",
      tabindex: "tabIndex",
      target: "target",
      title: "title",
      type: "type",
      usemap: "useMap",
      value: "value",
      width: "width",
      wmode: "wmode",
      wrap: "wrap",
      about: "about",
      accentheight: "accentHeight",
      "accent-height": "accentHeight",
      accumulate: "accumulate",
      additive: "additive",
      alignmentbaseline: "alignmentBaseline",
      "alignment-baseline": "alignmentBaseline",
      allowreorder: "allowReorder",
      alphabetic: "alphabetic",
      amplitude: "amplitude",
      arabicform: "arabicForm",
      "arabic-form": "arabicForm",
      ascent: "ascent",
      attributename: "attributeName",
      attributetype: "attributeType",
      autoreverse: "autoReverse",
      azimuth: "azimuth",
      basefrequency: "baseFrequency",
      baselineshift: "baselineShift",
      "baseline-shift": "baselineShift",
      baseprofile: "baseProfile",
      bbox: "bbox",
      begin: "begin",
      bias: "bias",
      by: "by",
      calcmode: "calcMode",
      capheight: "capHeight",
      "cap-height": "capHeight",
      clip: "clip",
      clippath: "clipPath",
      "clip-path": "clipPath",
      clippathunits: "clipPathUnits",
      cliprule: "clipRule",
      "clip-rule": "clipRule",
      color: "color",
      colorinterpolation: "colorInterpolation",
      "color-interpolation": "colorInterpolation",
      colorinterpolationfilters: "colorInterpolationFilters",
      "color-interpolation-filters": "colorInterpolationFilters",
      colorprofile: "colorProfile",
      "color-profile": "colorProfile",
      colorrendering: "colorRendering",
      "color-rendering": "colorRendering",
      contentscripttype: "contentScriptType",
      contentstyletype: "contentStyleType",
      cursor: "cursor",
      cx: "cx",
      cy: "cy",
      d: "d",
      datatype: "datatype",
      decelerate: "decelerate",
      descent: "descent",
      diffuseconstant: "diffuseConstant",
      direction: "direction",
      display: "display",
      divisor: "divisor",
      dominantbaseline: "dominantBaseline",
      "dominant-baseline": "dominantBaseline",
      dur: "dur",
      dx: "dx",
      dy: "dy",
      edgemode: "edgeMode",
      elevation: "elevation",
      enablebackground: "enableBackground",
      "enable-background": "enableBackground",
      end: "end",
      exponent: "exponent",
      externalresourcesrequired: "externalResourcesRequired",
      fill: "fill",
      fillopacity: "fillOpacity",
      "fill-opacity": "fillOpacity",
      fillrule: "fillRule",
      "fill-rule": "fillRule",
      filter: "filter",
      filterres: "filterRes",
      filterunits: "filterUnits",
      floodopacity: "floodOpacity",
      "flood-opacity": "floodOpacity",
      floodcolor: "floodColor",
      "flood-color": "floodColor",
      focusable: "focusable",
      fontfamily: "fontFamily",
      "font-family": "fontFamily",
      fontsize: "fontSize",
      "font-size": "fontSize",
      fontsizeadjust: "fontSizeAdjust",
      "font-size-adjust": "fontSizeAdjust",
      fontstretch: "fontStretch",
      "font-stretch": "fontStretch",
      fontstyle: "fontStyle",
      "font-style": "fontStyle",
      fontvariant: "fontVariant",
      "font-variant": "fontVariant",
      fontweight: "fontWeight",
      "font-weight": "fontWeight",
      format: "format",
      from: "from",
      fx: "fx",
      fy: "fy",
      g1: "g1",
      g2: "g2",
      glyphname: "glyphName",
      "glyph-name": "glyphName",
      glyphorientationhorizontal: "glyphOrientationHorizontal",
      "glyph-orientation-horizontal": "glyphOrientationHorizontal",
      glyphorientationvertical: "glyphOrientationVertical",
      "glyph-orientation-vertical": "glyphOrientationVertical",
      glyphref: "glyphRef",
      gradienttransform: "gradientTransform",
      gradientunits: "gradientUnits",
      hanging: "hanging",
      horizadvx: "horizAdvX",
      "horiz-adv-x": "horizAdvX",
      horizoriginx: "horizOriginX",
      "horiz-origin-x": "horizOriginX",
      ideographic: "ideographic",
      imagerendering: "imageRendering",
      "image-rendering": "imageRendering",
      in2: "in2",
      in: "in",
      inlist: "inlist",
      intercept: "intercept",
      k1: "k1",
      k2: "k2",
      k3: "k3",
      k4: "k4",
      k: "k",
      kernelmatrix: "kernelMatrix",
      kernelunitlength: "kernelUnitLength",
      kerning: "kerning",
      keypoints: "keyPoints",
      keysplines: "keySplines",
      keytimes: "keyTimes",
      lengthadjust: "lengthAdjust",
      letterspacing: "letterSpacing",
      "letter-spacing": "letterSpacing",
      lightingcolor: "lightingColor",
      "lighting-color": "lightingColor",
      limitingconeangle: "limitingConeAngle",
      local: "local",
      markerend: "markerEnd",
      "marker-end": "markerEnd",
      markerheight: "markerHeight",
      markermid: "markerMid",
      "marker-mid": "markerMid",
      markerstart: "markerStart",
      "marker-start": "markerStart",
      markerunits: "markerUnits",
      markerwidth: "markerWidth",
      mask: "mask",
      maskcontentunits: "maskContentUnits",
      maskunits: "maskUnits",
      mathematical: "mathematical",
      mode: "mode",
      numoctaves: "numOctaves",
      offset: "offset",
      opacity: "opacity",
      operator: "operator",
      order: "order",
      orient: "orient",
      orientation: "orientation",
      origin: "origin",
      overflow: "overflow",
      overlineposition: "overlinePosition",
      "overline-position": "overlinePosition",
      overlinethickness: "overlineThickness",
      "overline-thickness": "overlineThickness",
      paintorder: "paintOrder",
      "paint-order": "paintOrder",
      panose1: "panose1",
      "panose-1": "panose1",
      pathlength: "pathLength",
      patterncontentunits: "patternContentUnits",
      patterntransform: "patternTransform",
      patternunits: "patternUnits",
      pointerevents: "pointerEvents",
      "pointer-events": "pointerEvents",
      points: "points",
      pointsatx: "pointsAtX",
      pointsaty: "pointsAtY",
      pointsatz: "pointsAtZ",
      prefix: "prefix",
      preservealpha: "preserveAlpha",
      preserveaspectratio: "preserveAspectRatio",
      primitiveunits: "primitiveUnits",
      property: "property",
      r: "r",
      radius: "radius",
      refx: "refX",
      refy: "refY",
      renderingintent: "renderingIntent",
      "rendering-intent": "renderingIntent",
      repeatcount: "repeatCount",
      repeatdur: "repeatDur",
      requiredextensions: "requiredExtensions",
      requiredfeatures: "requiredFeatures",
      resource: "resource",
      restart: "restart",
      result: "result",
      results: "results",
      rotate: "rotate",
      rx: "rx",
      ry: "ry",
      scale: "scale",
      security: "security",
      seed: "seed",
      shaperendering: "shapeRendering",
      "shape-rendering": "shapeRendering",
      slope: "slope",
      spacing: "spacing",
      specularconstant: "specularConstant",
      specularexponent: "specularExponent",
      speed: "speed",
      spreadmethod: "spreadMethod",
      startoffset: "startOffset",
      stddeviation: "stdDeviation",
      stemh: "stemh",
      stemv: "stemv",
      stitchtiles: "stitchTiles",
      stopcolor: "stopColor",
      "stop-color": "stopColor",
      stopopacity: "stopOpacity",
      "stop-opacity": "stopOpacity",
      strikethroughposition: "strikethroughPosition",
      "strikethrough-position": "strikethroughPosition",
      strikethroughthickness: "strikethroughThickness",
      "strikethrough-thickness": "strikethroughThickness",
      string: "string",
      stroke: "stroke",
      strokedasharray: "strokeDasharray",
      "stroke-dasharray": "strokeDasharray",
      strokedashoffset: "strokeDashoffset",
      "stroke-dashoffset": "strokeDashoffset",
      strokelinecap: "strokeLinecap",
      "stroke-linecap": "strokeLinecap",
      strokelinejoin: "strokeLinejoin",
      "stroke-linejoin": "strokeLinejoin",
      strokemiterlimit: "strokeMiterlimit",
      "stroke-miterlimit": "strokeMiterlimit",
      strokewidth: "strokeWidth",
      "stroke-width": "strokeWidth",
      strokeopacity: "strokeOpacity",
      "stroke-opacity": "strokeOpacity",
      suppresscontenteditablewarning: "suppressContentEditableWarning",
      suppresshydrationwarning: "suppressHydrationWarning",
      surfacescale: "surfaceScale",
      systemlanguage: "systemLanguage",
      tablevalues: "tableValues",
      targetx: "targetX",
      targety: "targetY",
      textanchor: "textAnchor",
      "text-anchor": "textAnchor",
      textdecoration: "textDecoration",
      "text-decoration": "textDecoration",
      textlength: "textLength",
      textrendering: "textRendering",
      "text-rendering": "textRendering",
      to: "to",
      transform: "transform",
      typeof: "typeof",
      u1: "u1",
      u2: "u2",
      underlineposition: "underlinePosition",
      "underline-position": "underlinePosition",
      underlinethickness: "underlineThickness",
      "underline-thickness": "underlineThickness",
      unicode: "unicode",
      unicodebidi: "unicodeBidi",
      "unicode-bidi": "unicodeBidi",
      unicoderange: "unicodeRange",
      "unicode-range": "unicodeRange",
      unitsperem: "unitsPerEm",
      "units-per-em": "unitsPerEm",
      unselectable: "unselectable",
      valphabetic: "vAlphabetic",
      "v-alphabetic": "vAlphabetic",
      values: "values",
      vectoreffect: "vectorEffect",
      "vector-effect": "vectorEffect",
      version: "version",
      vertadvy: "vertAdvY",
      "vert-adv-y": "vertAdvY",
      vertoriginx: "vertOriginX",
      "vert-origin-x": "vertOriginX",
      vertoriginy: "vertOriginY",
      "vert-origin-y": "vertOriginY",
      vhanging: "vHanging",
      "v-hanging": "vHanging",
      videographic: "vIdeographic",
      "v-ideographic": "vIdeographic",
      viewbox: "viewBox",
      viewtarget: "viewTarget",
      visibility: "visibility",
      vmathematical: "vMathematical",
      "v-mathematical": "vMathematical",
      vocab: "vocab",
      widths: "widths",
      wordspacing: "wordSpacing",
      "word-spacing": "wordSpacing",
      writingmode: "writingMode",
      "writing-mode": "writingMode",
      x1: "x1",
      x2: "x2",
      x: "x",
      xchannelselector: "xChannelSelector",
      xheight: "xHeight",
      "x-height": "xHeight",
      xlinkactuate: "xlinkActuate",
      "xlink:actuate": "xlinkActuate",
      xlinkarcrole: "xlinkArcrole",
      "xlink:arcrole": "xlinkArcrole",
      xlinkhref: "xlinkHref",
      "xlink:href": "xlinkHref",
      xlinkrole: "xlinkRole",
      "xlink:role": "xlinkRole",
      xlinkshow: "xlinkShow",
      "xlink:show": "xlinkShow",
      xlinktitle: "xlinkTitle",
      "xlink:title": "xlinkTitle",
      xlinktype: "xlinkType",
      "xlink:type": "xlinkType",
      xmlbase: "xmlBase",
      "xml:base": "xmlBase",
      xmllang: "xmlLang",
      "xml:lang": "xmlLang",
      xmlns: "xmlns",
      "xml:space": "xmlSpace",
      xmlnsxlink: "xmlnsXlink",
      "xmlns:xlink": "xmlnsXlink",
      xmlspace: "xmlSpace",
      y1: "y1",
      y2: "y2",
      y: "y",
      ychannelselector: "yChannelSelector",
      z: "z",
      zoomandpan: "zoomAndPan"
    }, Ga = {
      "aria-current": 0,
      "aria-details": 0,
      "aria-disabled": 0,
      "aria-hidden": 0,
      "aria-invalid": 0,
      "aria-keyshortcuts": 0,
      "aria-label": 0,
      "aria-roledescription": 0,
      "aria-autocomplete": 0,
      "aria-checked": 0,
      "aria-expanded": 0,
      "aria-haspopup": 0,
      "aria-level": 0,
      "aria-modal": 0,
      "aria-multiline": 0,
      "aria-multiselectable": 0,
      "aria-orientation": 0,
      "aria-placeholder": 0,
      "aria-pressed": 0,
      "aria-readonly": 0,
      "aria-required": 0,
      "aria-selected": 0,
      "aria-sort": 0,
      "aria-valuemax": 0,
      "aria-valuemin": 0,
      "aria-valuenow": 0,
      "aria-valuetext": 0,
      "aria-atomic": 0,
      "aria-busy": 0,
      "aria-live": 0,
      "aria-relevant": 0,
      "aria-dropeffect": 0,
      "aria-grabbed": 0,
      "aria-activedescendant": 0,
      "aria-colcount": 0,
      "aria-colindex": 0,
      "aria-colspan": 0,
      "aria-controls": 0,
      "aria-describedby": 0,
      "aria-errormessage": 0,
      "aria-flowto": 0,
      "aria-labelledby": 0,
      "aria-owns": 0,
      "aria-posinset": 0,
      "aria-rowcount": 0,
      "aria-rowindex": 0,
      "aria-rowspan": 0,
      "aria-setsize": 0
    }, Mo = {}, Fy = new RegExp("^(aria)-[" + qe + "]*$"), Sg = new RegExp("^(aria)[A-Z][" + qe + "]*$"), xv = Object.prototype.hasOwnProperty;
    function Sv(i, o) {
      {
        if (xv.call(Mo, o) && Mo[o])
          return !0;
        if (Sg.test(o)) {
          var f = "aria-" + o.slice(4).toLowerCase(), g = Ga.hasOwnProperty(f) ? f : null;
          if (g == null)
            return l("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", o), Mo[o] = !0, !0;
          if (o !== g)
            return l("Invalid ARIA attribute `%s`. Did you mean `%s`?", o, g), Mo[o] = !0, !0;
        }
        if (Fy.test(o)) {
          var _ = o.toLowerCase(), R = Ga.hasOwnProperty(_) ? _ : null;
          if (R == null)
            return Mo[o] = !0, !1;
          if (o !== R)
            return l("Unknown ARIA attribute `%s`. Did you mean `%s`?", o, R), Mo[o] = !0, !0;
        }
      }
      return !0;
    }
    function wg(i, o) {
      {
        var f = [];
        for (var g in o) {
          var _ = Sv(i, g);
          _ || f.push(g);
        }
        var R = f.map(function(N) {
          return "`" + N + "`";
        }).join(", ");
        f.length === 1 ? l("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", R, i) : f.length > 1 && l("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", R, i);
      }
    }
    function pl(i, o) {
      co(i, o) || wg(i, o);
    }
    var Ce = !1;
    function $e(i, o) {
      {
        if (i !== "input" && i !== "textarea" && i !== "select")
          return;
        o != null && o.value === null && !Ce && (Ce = !0, i === "select" && o.multiple ? l("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", i) : l("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", i));
      }
    }
    var Be = function() {
    };
    {
      var ot = {}, an = Object.prototype.hasOwnProperty, Mn = /^on./, Ln = /^on[^A-Z]/, Zn = new RegExp("^(aria)-[" + qe + "]*$"), vl = new RegExp("^(aria)[A-Z][" + qe + "]*$");
      Be = function(i, o, f, g) {
        if (an.call(ot, o) && ot[o])
          return !0;
        var _ = o.toLowerCase();
        if (_ === "onfocusin" || _ === "onfocusout")
          return l("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."), ot[o] = !0, !0;
        if (g != null) {
          var R = g.registrationNameDependencies, N = g.possibleRegistrationNames;
          if (R.hasOwnProperty(o))
            return !0;
          var z = N.hasOwnProperty(_) ? N[_] : null;
          if (z != null)
            return l("Invalid event handler property `%s`. Did you mean `%s`?", o, z), ot[o] = !0, !0;
          if (Mn.test(o))
            return l("Unknown event handler property `%s`. It will be ignored.", o), ot[o] = !0, !0;
        } else if (Mn.test(o))
          return Ln.test(o) && l("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", o), ot[o] = !0, !0;
        if (Zn.test(o) || vl.test(o))
          return !0;
        if (_ === "innerhtml")
          return l("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."), ot[o] = !0, !0;
        if (_ === "aria")
          return l("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."), ot[o] = !0, !0;
        if (_ === "is" && f !== null && f !== void 0 && typeof f != "string")
          return l("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof f), ot[o] = !0, !0;
        if (typeof f == "number" && isNaN(f))
          return l("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", o), ot[o] = !0, !0;
        var W = Gt(o), ne = W !== null && W.type === Ae;
        if (Ca.hasOwnProperty(_)) {
          var ae = Ca[_];
          if (ae !== o)
            return l("Invalid DOM property `%s`. Did you mean `%s`?", o, ae), ot[o] = !0, !0;
        } else if (!ne && o !== _)
          return l("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", o, _), ot[o] = !0, !0;
        return typeof f == "boolean" && Kt(o, f, W, !1) ? (f ? l('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', f, o, o, f, o) : l('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', f, o, o, f, o, o, o), ot[o] = !0, !0) : ne ? !0 : Kt(o, f, W, !1) ? (ot[o] = !0, !1) : ((f === "false" || f === "true") && W !== null && W.type === Ne && (l("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", f, o, f === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', o, f), ot[o] = !0), !0);
      };
    }
    var Cg = function(i, o, f) {
      {
        var g = [];
        for (var _ in o) {
          var R = Be(i, _, o[_], f);
          R || g.push(_);
        }
        var N = g.map(function(z) {
          return "`" + z + "`";
        }).join(", ");
        g.length === 1 ? l("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", N, i) : g.length > 1 && l("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", N, i);
      }
    };
    function Ra(i, o, f) {
      co(i, o) || Cg(i, o, f);
    }
    var mc = 1, hf = 1 << 1, Ha = 1 << 2, gf = 1 << 4, gs = mc | hf | Ha;
    function Tn(i) {
      var o = i.target || i.srcElement || window;
      return o.correspondingUseElement && (o = o.correspondingUseElement), o.nodeType === vs ? o.parentNode : o;
    }
    var hl = null, ms = null, Ao = null;
    function wv(i) {
      var o = Fc(i);
      if (!!o) {
        if (typeof hl != "function")
          throw Error("setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.");
        var f = o.stateNode;
        if (f) {
          var g = om(f);
          hl(o.stateNode, o.type, g);
        }
      }
    }
    function Cv(i) {
      hl = i;
    }
    function yc(i) {
      ms ? Ao ? Ao.push(i) : Ao = [i] : ms = i;
    }
    function mf() {
      return ms !== null || Ao !== null;
    }
    function Po() {
      if (!!ms) {
        var i = ms, o = Ao;
        if (ms = null, Ao = null, wv(i), o)
          for (var f = 0; f < o.length; f++)
            wv(o[f]);
      }
    }
    var gl = function(i, o) {
      return i(o);
    }, Jn = function(i, o, f, g, _) {
      return i(o, f, g, _);
    }, ml = function() {
    }, Ud = gl, No = !1, yl = !1;
    function yf() {
      var i = mf();
      i && (ml(), Po());
    }
    function ys(i, o) {
      if (No)
        return i(o);
      No = !0;
      try {
        return gl(i, o);
      } finally {
        No = !1, yf();
      }
    }
    function ko(i, o, f) {
      if (yl)
        return i(o, f);
      yl = !0;
      try {
        return Ud(i, o, f);
      } finally {
        yl = !1, yf();
      }
    }
    function bs(i, o, f, g, _) {
      var R = No;
      No = !0;
      try {
        return Jn(i, o, f, g, _);
      } finally {
        No = R, No || yf();
      }
    }
    function Rg(i) {
      No || ml();
    }
    function Vd(i, o, f, g) {
      gl = i, Jn = o, ml = f, Ud = g;
    }
    function Rv(i) {
      return i === "button" || i === "input" || i === "select" || i === "textarea";
    }
    function bc(i, o, f) {
      switch (i) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
          return !!(f.disabled && Rv(o));
        default:
          return !1;
      }
    }
    function _s(i, o) {
      var f = i.stateNode;
      if (f === null)
        return null;
      var g = om(f);
      if (g === null)
        return null;
      var _ = g[o];
      if (bc(o, i.type, g))
        return null;
      if (!(!_ || typeof _ == "function"))
        throw Error("Expected `" + o + "` listener to be a function, instead got a value of `" + typeof _ + "` type.");
      return _;
    }
    var bl = !1;
    if (ee)
      try {
        var _c = {};
        Object.defineProperty(_c, "passive", {
          get: function() {
            bl = !0;
          }
        }), window.addEventListener("test", _c, _c), window.removeEventListener("test", _c, _c);
      } catch {
        bl = !1;
      }
    function Tv(i, o, f, g, _, R, N, z, W) {
      var ne = Array.prototype.slice.call(arguments, 3);
      try {
        o.apply(f, ne);
      } catch (ae) {
        this.onError(ae);
      }
    }
    var jd = Tv;
    if (typeof window < "u" && typeof window.dispatchEvent == "function" && typeof document < "u" && typeof document.createEvent == "function") {
      var du = document.createElement("react");
      jd = function(o, f, g, _, R, N, z, W, ne) {
        if (!(typeof document < "u"))
          throw Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
        var ae = document.createEvent("Event"), Pe = !1, ye = !0, Ie = window.event, Ke = Object.getOwnPropertyDescriptor(window, "event");
        function lt() {
          du.removeEventListener(Ue, vn, !1), typeof window.event < "u" && window.hasOwnProperty("event") && (window.event = Ie);
        }
        var Ft = Array.prototype.slice.call(arguments, 3);
        function vn() {
          Pe = !0, lt(), f.apply(g, Ft), ye = !1;
        }
        var Jt, zn = !1, hr = !1;
        function ke(De) {
          if (Jt = De.error, zn = !0, Jt === null && De.colno === 0 && De.lineno === 0 && (hr = !0), De.defaultPrevented && Jt != null && typeof Jt == "object")
            try {
              Jt._suppressLogging = !0;
            } catch {
            }
        }
        var Ue = "react-" + (o || "invokeguardedcallback");
        if (window.addEventListener("error", ke), du.addEventListener(Ue, vn, !1), ae.initEvent(Ue, !1, !1), du.dispatchEvent(ae), Ke && Object.defineProperty(window, "event", Ke), Pe && ye && (zn ? hr && (Jt = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.")) : Jt = new Error(`An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the "Pause on exceptions" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.`), this.onError(Jt)), window.removeEventListener("error", ke), !Pe)
          return lt(), Tv.apply(this, arguments);
      };
    }
    var Ur = jd, br = !1, Wd = null, _l = !1, fo = null, Gd = {
      onError: function(i) {
        br = !0, Wd = i;
      }
    };
    function Ei(i, o, f, g, _, R, N, z, W) {
      br = !1, Wd = null, Ur.apply(Gd, arguments);
    }
    function Ec(i, o, f, g, _, R, N, z, W) {
      if (Ei.apply(this, arguments), br) {
        var ne = Qr();
        _l || (_l = !0, fo = ne);
      }
    }
    function Es() {
      if (_l) {
        var i = fo;
        throw _l = !1, fo = null, i;
      }
    }
    function ai() {
      return br;
    }
    function Qr() {
      if (br) {
        var i = Wd;
        return br = !1, Wd = null, i;
      } else
        throw Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
    }
    function Ta(i) {
      return i._reactInternals;
    }
    function bf(i) {
      return i._reactInternals !== void 0;
    }
    function pu(i, o) {
      i._reactInternals = o;
    }
    var Hn = 0, Hi = 1, nn = 2, Ht = 4, vu = 6, er = 8, Lr = 16, xs = 32, G = 64, Rr = 128, Oa = 256, xi = 512, un = 8192, Ya = 1024, Tg = 1028, Ov = 932, Da = 2047, _f = 2048, po = 4096, Ef = 16384, $y = a.ReactCurrentOwner;
    function hu(i) {
      var o = i, f = i;
      if (i.alternate)
        for (; o.return; )
          o = o.return;
      else {
        var g = o;
        do
          o = g, (o.flags & (nn | Ya)) !== Hn && (f = o.return), g = o.return;
        while (g);
      }
      return o.tag === E ? f : null;
    }
    function qa(i) {
      if (i.tag === k) {
        var o = i.memoizedState;
        if (o === null) {
          var f = i.alternate;
          f !== null && (o = f.memoizedState);
        }
        if (o !== null)
          return o.dehydrated;
      }
      return null;
    }
    function Og(i) {
      return i.tag === E ? i.stateNode.containerInfo : null;
    }
    function Hd(i) {
      return hu(i) === i;
    }
    function Dg(i) {
      {
        var o = $y.current;
        if (o !== null && o.tag === y) {
          var f = o, g = f.stateNode;
          g._warnedAboutRefsInRender || l("%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", dt(f.type) || "A component"), g._warnedAboutRefsInRender = !0;
        }
      }
      var _ = Ta(i);
      return _ ? hu(_) === _ : !1;
    }
    function Dv(i) {
      if (hu(i) !== i)
        throw Error("Unable to find node on an unmounted component.");
    }
    function Mv(i) {
      var o = i.alternate;
      if (!o) {
        var f = hu(i);
        if (f === null)
          throw Error("Unable to find node on an unmounted component.");
        return f !== i ? null : i;
      }
      for (var g = i, _ = o; ; ) {
        var R = g.return;
        if (R === null)
          break;
        var N = R.alternate;
        if (N === null) {
          var z = R.return;
          if (z !== null) {
            g = _ = z;
            continue;
          }
          break;
        }
        if (R.child === N.child) {
          for (var W = R.child; W; ) {
            if (W === g)
              return Dv(R), i;
            if (W === _)
              return Dv(R), o;
            W = W.sibling;
          }
          throw Error("Unable to find node on an unmounted component.");
        }
        if (g.return !== _.return)
          g = R, _ = N;
        else {
          for (var ne = !1, ae = R.child; ae; ) {
            if (ae === g) {
              ne = !0, g = R, _ = N;
              break;
            }
            if (ae === _) {
              ne = !0, _ = R, g = N;
              break;
            }
            ae = ae.sibling;
          }
          if (!ne) {
            for (ae = N.child; ae; ) {
              if (ae === g) {
                ne = !0, g = N, _ = R;
                break;
              }
              if (ae === _) {
                ne = !0, _ = N, g = R;
                break;
              }
              ae = ae.sibling;
            }
            if (!ne)
              throw Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
          }
        }
        if (g.alternate !== _)
          throw Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
      }
      if (g.tag !== E)
        throw Error("Unable to find node on an unmounted component.");
      return g.stateNode.current === g ? i : o;
    }
    function vo(i) {
      var o = Mv(i);
      if (!o)
        return null;
      for (var f = o; ; ) {
        if (f.tag === C || f.tag === T)
          return f;
        if (f.child) {
          f.child.return = f, f = f.child;
          continue;
        }
        if (f === o)
          return null;
        for (; !f.sibling; ) {
          if (!f.return || f.return === o)
            return null;
          f = f.return;
        }
        f.sibling.return = f.return, f = f.sibling;
      }
      return null;
    }
    function Av(i) {
      var o = Mv(i);
      if (!o)
        return null;
      for (var f = o; ; ) {
        if (f.tag === C || f.tag === T || Se)
          return f;
        if (f.child && f.tag !== x) {
          f.child.return = f, f = f.child;
          continue;
        }
        if (f === o)
          return null;
        for (; !f.sibling; ) {
          if (!f.return || f.return === o)
            return null;
          f = f.return;
        }
        f.sibling.return = f.return, f = f.sibling;
      }
      return null;
    }
    function Mg(i, o) {
      for (var f = o, g = i.alternate; f !== null; ) {
        if (f === i || f === g)
          return !0;
        f = f.return;
      }
      return !1;
    }
    var Io;
    function Yd(i) {
      Io = i;
    }
    var xf;
    function gu(i) {
      xf = i;
    }
    var Si;
    function xc(i) {
      Si = i;
    }
    var Ma;
    function El(i) {
      Ma = i;
    }
    var xl = !1, oi = [], Ss = null, mu = null, Zr = null, ws = /* @__PURE__ */ new Map(), yu = /* @__PURE__ */ new Map(), Lo = [];
    function Sc() {
      return oi.length > 0;
    }
    var Sl = [
      "mousedown",
      "mouseup",
      "touchcancel",
      "touchend",
      "touchstart",
      "auxclick",
      "dblclick",
      "pointercancel",
      "pointerdown",
      "pointerup",
      "dragend",
      "dragstart",
      "drop",
      "compositionend",
      "compositionstart",
      "keydown",
      "keypress",
      "keyup",
      "input",
      "textInput",
      "copy",
      "cut",
      "paste",
      "click",
      "change",
      "contextmenu",
      "reset",
      "submit"
    ];
    function wl(i) {
      return Sl.indexOf(i) > -1;
    }
    function Pv(i, o, f, g, _) {
      return {
        blockedOn: i,
        domEventName: o,
        eventSystemFlags: f | gf,
        nativeEvent: _,
        targetContainers: [g]
      };
    }
    function bu(i, o, f, g, _) {
      var R = Pv(i, o, f, g, _);
      oi.push(R);
    }
    function Aa(i, o) {
      switch (i) {
        case "focusin":
        case "focusout":
          Ss = null;
          break;
        case "dragenter":
        case "dragleave":
          mu = null;
          break;
        case "mouseover":
        case "mouseout":
          Zr = null;
          break;
        case "pointerover":
        case "pointerout": {
          var f = o.pointerId;
          ws.delete(f);
          break;
        }
        case "gotpointercapture":
        case "lostpointercapture": {
          var g = o.pointerId;
          yu.delete(g);
          break;
        }
      }
    }
    function Vr(i, o, f, g, _, R) {
      if (i === null || i.nativeEvent !== R) {
        var N = Pv(o, f, g, _, R);
        if (o !== null) {
          var z = Fc(o);
          z !== null && xf(z);
        }
        return N;
      }
      i.eventSystemFlags |= g;
      var W = i.targetContainers;
      return _ !== null && W.indexOf(_) === -1 && W.push(_), i;
    }
    function Sf(i, o, f, g, _) {
      switch (o) {
        case "focusin": {
          var R = _;
          return Ss = Vr(Ss, i, o, f, g, R), !0;
        }
        case "dragenter": {
          var N = _;
          return mu = Vr(mu, i, o, f, g, N), !0;
        }
        case "mouseover": {
          var z = _;
          return Zr = Vr(Zr, i, o, f, g, z), !0;
        }
        case "pointerover": {
          var W = _, ne = W.pointerId;
          return ws.set(ne, Vr(ws.get(ne) || null, i, o, f, g, W)), !0;
        }
        case "gotpointercapture": {
          var ae = _, Pe = ae.pointerId;
          return yu.set(Pe, Vr(yu.get(Pe) || null, i, o, f, g, ae)), !0;
        }
      }
      return !1;
    }
    function _u(i) {
      var o = id(i.target);
      if (o !== null) {
        var f = hu(o);
        if (f !== null) {
          var g = f.tag;
          if (g === k) {
            var _ = qa(f);
            if (_ !== null) {
              i.blockedOn = _, Ma(i.lanePriority, function() {
                n.unstable_runWithPriority(i.priority, function() {
                  Si(f);
                });
              });
              return;
            }
          } else if (g === E) {
            var R = f.stateNode;
            if (R.hydrate) {
              i.blockedOn = Og(f);
              return;
            }
          }
        }
      }
      i.blockedOn = null;
    }
    function Tr(i) {
      if (i.blockedOn !== null)
        return !1;
      for (var o = i.targetContainers; o.length > 0; ) {
        var f = o[0], g = Nc(i.domEventName, i.eventSystemFlags, f, i.nativeEvent);
        if (g !== null) {
          var _ = Fc(g);
          return _ !== null && xf(_), i.blockedOn = g, !1;
        }
        o.shift();
      }
      return !0;
    }
    function Cs(i, o, f) {
      Tr(i) && f.delete(o);
    }
    function Nv() {
      for (xl = !1; oi.length > 0; ) {
        var i = oi[0];
        if (i.blockedOn !== null) {
          var o = Fc(i.blockedOn);
          o !== null && Io(o);
          break;
        }
        for (var f = i.targetContainers; f.length > 0; ) {
          var g = f[0], _ = Nc(i.domEventName, i.eventSystemFlags, g, i.nativeEvent);
          if (_ !== null) {
            i.blockedOn = _;
            break;
          }
          f.shift();
        }
        i.blockedOn === null && oi.shift();
      }
      Ss !== null && Tr(Ss) && (Ss = null), mu !== null && Tr(mu) && (mu = null), Zr !== null && Tr(Zr) && (Zr = null), ws.forEach(Cs), yu.forEach(Cs);
    }
    function Bo(i, o) {
      i.blockedOn === o && (i.blockedOn = null, xl || (xl = !0, n.unstable_scheduleCallback(n.unstable_NormalPriority, Nv)));
    }
    function Cl(i) {
      if (oi.length > 0) {
        Bo(oi[0], i);
        for (var o = 1; o < oi.length; o++) {
          var f = oi[o];
          f.blockedOn === i && (f.blockedOn = null);
        }
      }
      Ss !== null && Bo(Ss, i), mu !== null && Bo(mu, i), Zr !== null && Bo(Zr, i);
      var g = function(z) {
        return Bo(z, i);
      };
      ws.forEach(g), yu.forEach(g);
      for (var _ = 0; _ < Lo.length; _++) {
        var R = Lo[_];
        R.blockedOn === i && (R.blockedOn = null);
      }
      for (; Lo.length > 0; ) {
        var N = Lo[0];
        if (N.blockedOn !== null)
          break;
        _u(N), N.blockedOn === null && Lo.shift();
      }
    }
    var ho = 0, wc = 1, Cc = 2;
    function Eu(i, o) {
      var f = {};
      return f[i.toLowerCase()] = o.toLowerCase(), f["Webkit" + i] = "webkit" + o, f["Moz" + i] = "moz" + o, f;
    }
    var Rl = {
      animationend: Eu("Animation", "AnimationEnd"),
      animationiteration: Eu("Animation", "AnimationIteration"),
      animationstart: Eu("Animation", "AnimationStart"),
      transitionend: Eu("Transition", "TransitionEnd")
    }, wf = {}, jr = {};
    ee && (jr = document.createElement("div").style, "AnimationEvent" in window || (delete Rl.animationend.animation, delete Rl.animationiteration.animation, delete Rl.animationstart.animation), "TransitionEvent" in window || delete Rl.transitionend.transition);
    function Rs(i) {
      if (wf[i])
        return wf[i];
      if (!Rl[i])
        return i;
      var o = Rl[i];
      for (var f in o)
        if (o.hasOwnProperty(f) && f in jr)
          return wf[i] = o[f];
      return i;
    }
    var Tl = Rs("animationend"), oa = Rs("animationiteration"), Cf = Rs("animationstart"), xu = Rs("transitionend"), Ts = /* @__PURE__ */ new Map(), Su = /* @__PURE__ */ new Map(), pr = [
      "cancel",
      "cancel",
      "click",
      "click",
      "close",
      "close",
      "contextmenu",
      "contextMenu",
      "copy",
      "copy",
      "cut",
      "cut",
      "auxclick",
      "auxClick",
      "dblclick",
      "doubleClick",
      "dragend",
      "dragEnd",
      "dragstart",
      "dragStart",
      "drop",
      "drop",
      "focusin",
      "focus",
      "focusout",
      "blur",
      "input",
      "input",
      "invalid",
      "invalid",
      "keydown",
      "keyDown",
      "keypress",
      "keyPress",
      "keyup",
      "keyUp",
      "mousedown",
      "mouseDown",
      "mouseup",
      "mouseUp",
      "paste",
      "paste",
      "pause",
      "pause",
      "play",
      "play",
      "pointercancel",
      "pointerCancel",
      "pointerdown",
      "pointerDown",
      "pointerup",
      "pointerUp",
      "ratechange",
      "rateChange",
      "reset",
      "reset",
      "seeked",
      "seeked",
      "submit",
      "submit",
      "touchcancel",
      "touchCancel",
      "touchend",
      "touchEnd",
      "touchstart",
      "touchStart",
      "volumechange",
      "volumeChange"
    ], Ol = ["change", "selectionchange", "textInput", "compositionstart", "compositionend", "compositionupdate"], Rf = ["drag", "drag", "dragenter", "dragEnter", "dragexit", "dragExit", "dragleave", "dragLeave", "dragover", "dragOver", "mousemove", "mouseMove", "mouseout", "mouseOut", "mouseover", "mouseOver", "pointermove", "pointerMove", "pointerout", "pointerOut", "pointerover", "pointerOver", "scroll", "scroll", "toggle", "toggle", "touchmove", "touchMove", "wheel", "wheel"], Dl = ["abort", "abort", Tl, "animationEnd", oa, "animationIteration", Cf, "animationStart", "canplay", "canPlay", "canplaythrough", "canPlayThrough", "durationchange", "durationChange", "emptied", "emptied", "encrypted", "encrypted", "ended", "ended", "error", "error", "gotpointercapture", "gotPointerCapture", "load", "load", "loadeddata", "loadedData", "loadedmetadata", "loadedMetadata", "loadstart", "loadStart", "lostpointercapture", "lostPointerCapture", "playing", "playing", "progress", "progress", "seeking", "seeking", "stalled", "stalled", "suspend", "suspend", "timeupdate", "timeUpdate", xu, "transitionEnd", "waiting", "waiting"];
    function Tf(i, o) {
      for (var f = 0; f < i.length; f += 2) {
        var g = i[f], _ = i[f + 1], R = _[0].toUpperCase() + _.slice(1), N = "on" + R;
        Su.set(g, o), Ts.set(g, N), fe(N, [g]);
      }
    }
    function wu(i, o) {
      for (var f = 0; f < i.length; f++)
        Su.set(i[f], o);
    }
    function Ag(i) {
      var o = Su.get(i);
      return o === void 0 ? Cc : o;
    }
    function Ml() {
      Tf(pr, ho), Tf(Rf, wc), Tf(Dl, Cc), wu(Ol, ho);
    }
    var _r = n.unstable_now;
    if (!(r.__interactionsRef != null && r.__interactionsRef.current != null))
      throw Error("It is not supported to run the profiling version of a renderer (for example, `react-dom/profiling`) without also replacing the `scheduler/tracing` module with `scheduler/tracing-profiling`. Your bundler might have a setting for aliasing both modules. Learn more at https://reactjs.org/link/profiling");
    var Of = 99, zo = 98, Pa = 97, Fo = 96, kv = 95, qd = 90;
    _r();
    var Os = 15, Df = 14, Mf = 13, Rc = 12, Cu = 11, $o = 10, Tc = 9, Wr = 8, Al = 7, dr = 6, Jr = 5, Br = 4, Af = 3, Ds = 2, Mi = 1, Ms = 0, Xd = 31, Ge = 0, Or = 0, bn = 1, go = 2, Pl = 4, Nl = 24, ln = 32, Iv = 192, Oc = 256, Uo = 3584, Kd = 4096, As = 4186112, Dc = 62914560, ei = 33554432, Qd = 67108864, Ru = 134217727, Pf = 134217728, Nf = 805306368, Xa = 1073741824, Cn = -1;
    function Tu(i) {
    }
    var Un = Wr;
    function kl(i) {
      if ((bn & i) !== Ge)
        return Un = Os, bn;
      if ((go & i) !== Ge)
        return Un = Df, go;
      if ((Pl & i) !== Ge)
        return Un = Mf, Pl;
      var o = Nl & i;
      if (o !== Ge)
        return Un = Rc, o;
      if ((i & ln) !== Ge)
        return Un = Cu, ln;
      var f = Iv & i;
      if (f !== Ge)
        return Un = $o, f;
      if ((i & Oc) !== Ge)
        return Un = Tc, Oc;
      var g = Uo & i;
      if (g !== Ge)
        return Un = Wr, g;
      if ((i & Kd) !== Ge)
        return Un = Al, Kd;
      var _ = As & i;
      if (_ !== Ge)
        return Un = dr, _;
      var R = Dc & i;
      if (R !== Ge)
        return Un = Jr, R;
      if (i & Qd)
        return Un = Br, Qd;
      if ((i & Pf) !== Ge)
        return Un = Af, Pf;
      var N = Nf & i;
      return N !== Ge ? (Un = Ds, N) : (Xa & i) !== Ge ? (Un = Mi, Xa) : (l("Should have found matching lanes. This is a bug in React."), Un = Wr, i);
    }
    function Mc(i) {
      switch (i) {
        case Of:
          return Os;
        case zo:
          return $o;
        case Pa:
        case Fo:
          return Wr;
        case kv:
          return Ds;
        default:
          return Ms;
      }
    }
    function kf(i) {
      switch (i) {
        case Os:
        case Df:
          return Of;
        case Mf:
        case Rc:
        case Cu:
        case $o:
          return zo;
        case Tc:
        case Wr:
        case Al:
        case dr:
        case Br:
        case Jr:
          return Pa;
        case Af:
        case Ds:
        case Mi:
          return kv;
        case Ms:
          return qd;
        default:
          throw Error("Invalid update priority: " + i + ". This is a bug in React.");
      }
    }
    function Il(i, o) {
      var f = i.pendingLanes;
      if (f === Ge)
        return Un = Ms, Ge;
      var g = Ge, _ = Ms, R = i.expiredLanes, N = i.suspendedLanes, z = i.pingedLanes;
      if (R !== Ge)
        g = R, _ = Un = Os;
      else {
        var W = f & Ru;
        if (W !== Ge) {
          var ne = W & ~N;
          if (ne !== Ge)
            g = kl(ne), _ = Un;
          else {
            var ae = W & z;
            ae !== Ge && (g = kl(ae), _ = Un);
          }
        } else {
          var Pe = f & ~N;
          Pe !== Ge ? (g = kl(Pe), _ = Un) : z !== Ge && (g = kl(z), _ = Un);
        }
      }
      if (g === Ge)
        return Ge;
      if (g = f & $v(g), o !== Ge && o !== g && (o & N) === Ge) {
        kl(o);
        var ye = Un;
        if (_ <= ye)
          return o;
        Un = _;
      }
      var Ie = i.entangledLanes;
      if (Ie !== Ge)
        for (var Ke = i.entanglements, lt = g & Ie; lt > 0; ) {
          var Ft = Ps(lt), vn = 1 << Ft;
          g |= Ke[Ft], lt &= ~vn;
        }
      return g;
    }
    function Pg(i, o) {
      for (var f = i.eventTimes, g = Cn; o > 0; ) {
        var _ = Ps(o), R = 1 << _, N = f[_];
        N > g && (g = N), o &= ~R;
      }
      return g;
    }
    function Lv(i, o) {
      kl(i);
      var f = Un;
      return f >= $o ? o + 250 : f >= dr ? o + 5e3 : Cn;
    }
    function Bv(i, o) {
      for (var f = i.pendingLanes, g = i.suspendedLanes, _ = i.pingedLanes, R = i.expirationTimes, N = f; N > 0; ) {
        var z = Ps(N), W = 1 << z, ne = R[z];
        ne === Cn ? ((W & g) === Ge || (W & _) !== Ge) && (R[z] = Lv(W, o)) : ne <= o && (i.expiredLanes |= W), N &= ~W;
      }
    }
    function ti(i) {
      var o = i.pendingLanes & ~Xa;
      return o !== Ge ? o : o & Xa ? Xa : Ge;
    }
    function sa() {
      return Un;
    }
    function Vo(i) {
      return (i & Ru) !== Ge;
    }
    function Zd(i) {
      return (i & Dc) === i;
    }
    function zv(i) {
      return (i & As) === i;
    }
    function Ou(i, o) {
      switch (i) {
        case Ms:
          break;
        case Os:
          return bn;
        case Df:
          return go;
        case Rc: {
          var f = si(Nl & ~o);
          return f === Or ? Ou($o, o) : f;
        }
        case $o: {
          var g = si(Iv & ~o);
          return g === Or ? Ou(Wr, o) : g;
        }
        case Wr: {
          var _ = si(Uo & ~o);
          return _ === Or && (_ = si(As & ~o), _ === Or && (_ = si(Uo))), _;
        }
        case dr:
        case Jr:
          break;
        case Ds:
          var R = si(Nf & ~o);
          return R === Or && (R = si(Nf)), R;
      }
      throw Error("Invalid update priority: " + i + ". This is a bug in React.");
    }
    function Ng(i, o) {
      var f = si(As & ~o);
      return f === Or && (f = si(As & ~i), f === Or && (f = si(As))), f;
    }
    function Fv(i) {
      var o = si(Dc & ~i);
      return o === Or && (o = si(Dc)), o;
    }
    function kg(i) {
      return i & -i;
    }
    function Jd(i) {
      var o = 31 - Bf(i);
      return o < 0 ? Ge : 1 << o;
    }
    function $v(i) {
      return (Jd(i) << 1) - 1;
    }
    function si(i) {
      return kg(i);
    }
    function Ps(i) {
      return 31 - Bf(i);
    }
    function Uv(i) {
      return Ps(i);
    }
    function Bn(i, o) {
      return (i & o) !== Ge;
    }
    function wi(i, o) {
      return (i & o) === o;
    }
    function Pn(i, o) {
      return i | o;
    }
    function Ac(i, o) {
      return i & ~o;
    }
    function ep(i) {
      return i;
    }
    function ua(i, o) {
      return i !== Or && i < o ? i : o;
    }
    function If(i) {
      for (var o = [], f = 0; f < Xd; f++)
        o.push(i);
      return o;
    }
    function Ll(i, o, f) {
      i.pendingLanes |= o;
      var g = o - 1;
      i.suspendedLanes &= g, i.pingedLanes &= g;
      var _ = i.eventTimes, R = Uv(o);
      _[R] = f;
    }
    function Ig(i, o) {
      i.suspendedLanes |= o, i.pingedLanes &= ~o;
      for (var f = i.expirationTimes, g = o; g > 0; ) {
        var _ = Ps(g), R = 1 << _;
        f[_] = Cn, g &= ~R;
      }
    }
    function tp(i, o, f) {
      i.pingedLanes |= i.suspendedLanes & o;
    }
    function jo(i) {
      i.expiredLanes |= Nl & i.pendingLanes;
    }
    function Lf(i) {
      return (i & Nl) !== Ge;
    }
    function Lg(i, o) {
      i.mutableReadLanes |= o & i.pendingLanes;
    }
    function np(i, o) {
      var f = i.pendingLanes & ~o;
      i.pendingLanes = o, i.suspendedLanes = 0, i.pingedLanes = 0, i.expiredLanes &= o, i.mutableReadLanes &= o, i.entangledLanes &= o;
      for (var g = i.entanglements, _ = i.eventTimes, R = i.expirationTimes, N = f; N > 0; ) {
        var z = Ps(N), W = 1 << z;
        g[z] = Ge, _[z] = Cn, R[z] = Cn, N &= ~W;
      }
    }
    function rp(i, o) {
      i.entangledLanes |= o;
      for (var f = i.entanglements, g = o; g > 0; ) {
        var _ = Ps(g), R = 1 << _;
        f[_] |= o, g &= ~R;
      }
    }
    var Bf = Math.clz32 ? Math.clz32 : jv, Vv = Math.log, zf = Math.LN2;
    function jv(i) {
      return i === 0 ? 32 : 31 - (Vv(i) / zf | 0) | 0;
    }
    var Ff = n.unstable_UserBlockingPriority, Uy = n.unstable_runWithPriority, ip = !0;
    function Pc(i) {
      ip = !!i;
    }
    function Wv() {
      return ip;
    }
    function ap(i, o, f) {
      var g = Ag(o), _;
      switch (g) {
        case ho:
          _ = Bg;
          break;
        case wc:
          _ = Gv;
          break;
        case Cc:
        default:
          _ = Na;
          break;
      }
      return _.bind(null, o, f, i);
    }
    function Bg(i, o, f, g) {
      Rg(g.timeStamp), bs(Na, i, o, f, g);
    }
    function Gv(i, o, f, g) {
      Uy(Ff, Na.bind(null, i, o, f, g));
    }
    function Na(i, o, f, g) {
      if (!!ip) {
        var _ = !0;
        if (_ = (o & Ha) === 0, _ && Sc() && wl(i)) {
          bu(
            null,
            i,
            o,
            f,
            g
          );
          return;
        }
        var R = Nc(i, o, f, g);
        if (R === null) {
          _ && Aa(i, g);
          return;
        }
        if (_) {
          if (wl(i)) {
            bu(R, i, o, f, g);
            return;
          }
          if (Sf(R, i, o, f, g))
            return;
          Aa(i, g);
        }
        o1(i, o, g, null, f);
      }
    }
    function Nc(i, o, f, g) {
      var _ = Tn(g), R = id(_);
      if (R !== null) {
        var N = hu(R);
        if (N === null)
          R = null;
        else {
          var z = N.tag;
          if (z === k) {
            var W = qa(N);
            if (W !== null)
              return W;
            R = null;
          } else if (z === E) {
            var ne = N.stateNode;
            if (ne.hydrate)
              return Og(N);
            R = null;
          } else
            N !== R && (R = null);
        }
      }
      return o1(i, o, g, R, f), null;
    }
    function Hv(i, o, f) {
      return i.addEventListener(o, f, !1), f;
    }
    function Yv(i, o, f) {
      return i.addEventListener(o, f, !0), f;
    }
    function qv(i, o, f, g) {
      return i.addEventListener(o, f, {
        capture: !0,
        passive: g
      }), f;
    }
    function Vy(i, o, f, g) {
      return i.addEventListener(o, f, {
        passive: g
      }), f;
    }
    var $f = null, la = null, Ns = null;
    function Yt(i) {
      return $f = i, la = Dr(), !0;
    }
    function Ci() {
      $f = null, la = null, Ns = null;
    }
    function Er() {
      if (Ns)
        return Ns;
      var i, o = la, f = o.length, g, _ = Dr(), R = _.length;
      for (i = 0; i < f && o[i] === _[i]; i++)
        ;
      var N = f - i;
      for (g = 1; g <= N && o[f - g] === _[R - g]; g++)
        ;
      var z = g > 1 ? 1 - g : void 0;
      return Ns = _.slice(i, z), Ns;
    }
    function Dr() {
      return "value" in $f ? $f.value : $f.textContent;
    }
    function Dt(i) {
      var o, f = i.keyCode;
      return "charCode" in i ? (o = i.charCode, o === 0 && f === 13 && (o = 13)) : o = f, o === 10 && (o = 13), o >= 32 || o === 13 ? o : 0;
    }
    function ks() {
      return !0;
    }
    function Gr() {
      return !1;
    }
    function Mr(i) {
      function o(f, g, _, R, N) {
        this._reactName = f, this._targetInst = _, this.type = g, this.nativeEvent = R, this.target = N, this.currentTarget = null;
        for (var z in i)
          if (!!i.hasOwnProperty(z)) {
            var W = i[z];
            W ? this[z] = W(R) : this[z] = R[z];
          }
        var ne = R.defaultPrevented != null ? R.defaultPrevented : R.returnValue === !1;
        return ne ? this.isDefaultPrevented = ks : this.isDefaultPrevented = Gr, this.isPropagationStopped = Gr, this;
      }
      return t(o.prototype, {
        preventDefault: function() {
          this.defaultPrevented = !0;
          var f = this.nativeEvent;
          !f || (f.preventDefault ? f.preventDefault() : typeof f.returnValue != "unknown" && (f.returnValue = !1), this.isDefaultPrevented = ks);
        },
        stopPropagation: function() {
          var f = this.nativeEvent;
          !f || (f.stopPropagation ? f.stopPropagation() : typeof f.cancelBubble != "unknown" && (f.cancelBubble = !0), this.isPropagationStopped = ks);
        },
        persist: function() {
        },
        isPersistent: ks
      }), o;
    }
    var mo = {
      eventPhase: 0,
      bubbles: 0,
      cancelable: 0,
      timeStamp: function(i) {
        return i.timeStamp || Date.now();
      },
      defaultPrevented: 0,
      isTrusted: 0
    }, Is = Mr(mo), yo = t({}, mo, {
      view: 0,
      detail: 0
    }), ui = Mr(yo), Uf, Vf, Du;
    function kc(i) {
      i !== Du && (Du && i.type === "mousemove" ? (Uf = i.screenX - Du.screenX, Vf = i.screenY - Du.screenY) : (Uf = 0, Vf = 0), Du = i);
    }
    var gt = t({}, yo, {
      screenX: 0,
      screenY: 0,
      clientX: 0,
      clientY: 0,
      pageX: 0,
      pageY: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      getModifierState: bo,
      button: 0,
      buttons: 0,
      relatedTarget: function(i) {
        return i.relatedTarget === void 0 ? i.fromElement === i.srcElement ? i.toElement : i.fromElement : i.relatedTarget;
      },
      movementX: function(i) {
        return "movementX" in i ? i.movementX : (kc(i), Uf);
      },
      movementY: function(i) {
        return "movementY" in i ? i.movementY : Vf;
      }
    }), jf = Mr(gt), Xv = t({}, gt, {
      dataTransfer: 0
    }), Wo = Mr(Xv), Ai = t({}, yo, {
      relatedTarget: 0
    }), zr = Mr(Ai), Bl = t({}, mo, {
      animationName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), Kv = Mr(Bl), Wf = t({}, mo, {
      clipboardData: function(i) {
        return "clipboardData" in i ? i.clipboardData : window.clipboardData;
      }
    }), Ls = Mr(Wf), Gf = t({}, mo, {
      data: 0
    }), Mu = Mr(Gf), Hf = Mu, Go = {
      Esc: "Escape",
      Spacebar: " ",
      Left: "ArrowLeft",
      Up: "ArrowUp",
      Right: "ArrowRight",
      Down: "ArrowDown",
      Del: "Delete",
      Win: "OS",
      Menu: "ContextMenu",
      Apps: "ContextMenu",
      Scroll: "ScrollLock",
      MozPrintableKey: "Unidentified"
    }, op = {
      8: "Backspace",
      9: "Tab",
      12: "Clear",
      13: "Enter",
      16: "Shift",
      17: "Control",
      18: "Alt",
      19: "Pause",
      20: "CapsLock",
      27: "Escape",
      32: " ",
      33: "PageUp",
      34: "PageDown",
      35: "End",
      36: "Home",
      37: "ArrowLeft",
      38: "ArrowUp",
      39: "ArrowRight",
      40: "ArrowDown",
      45: "Insert",
      46: "Delete",
      112: "F1",
      113: "F2",
      114: "F3",
      115: "F4",
      116: "F5",
      117: "F6",
      118: "F7",
      119: "F8",
      120: "F9",
      121: "F10",
      122: "F11",
      123: "F12",
      144: "NumLock",
      145: "ScrollLock",
      224: "Meta"
    };
    function Yf(i) {
      if (i.key) {
        var o = Go[i.key] || i.key;
        if (o !== "Unidentified")
          return o;
      }
      if (i.type === "keypress") {
        var f = Dt(i);
        return f === 13 ? "Enter" : String.fromCharCode(f);
      }
      return i.type === "keydown" || i.type === "keyup" ? op[i.keyCode] || "Unidentified" : "";
    }
    var sp = {
      Alt: "altKey",
      Control: "ctrlKey",
      Meta: "metaKey",
      Shift: "shiftKey"
    };
    function ka(i) {
      var o = this, f = o.nativeEvent;
      if (f.getModifierState)
        return f.getModifierState(i);
      var g = sp[i];
      return g ? !!f[g] : !1;
    }
    function bo(i) {
      return ka;
    }
    var Bs = t({}, yo, {
      key: Yf,
      code: 0,
      location: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      repeat: 0,
      locale: 0,
      getModifierState: bo,
      charCode: function(i) {
        return i.type === "keypress" ? Dt(i) : 0;
      },
      keyCode: function(i) {
        return i.type === "keydown" || i.type === "keyup" ? i.keyCode : 0;
      },
      which: function(i) {
        return i.type === "keypress" ? Dt(i) : i.type === "keydown" || i.type === "keyup" ? i.keyCode : 0;
      }
    }), up = Mr(Bs), ca = t({}, gt, {
      pointerId: 0,
      width: 0,
      height: 0,
      pressure: 0,
      tangentialPressure: 0,
      tiltX: 0,
      tiltY: 0,
      twist: 0,
      pointerType: 0,
      isPrimary: 0
    }), lp = Mr(ca), Ho = t({}, yo, {
      touches: 0,
      targetTouches: 0,
      changedTouches: 0,
      altKey: 0,
      metaKey: 0,
      ctrlKey: 0,
      shiftKey: 0,
      getModifierState: bo
    }), qf = Mr(Ho), zg = t({}, mo, {
      propertyName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), Qv = Mr(zg), Xf = t({}, gt, {
      deltaX: function(i) {
        return "deltaX" in i ? i.deltaX : "wheelDeltaX" in i ? -i.wheelDeltaX : 0;
      },
      deltaY: function(i) {
        return "deltaY" in i ? i.deltaY : "wheelDeltaY" in i ? -i.wheelDeltaY : "wheelDelta" in i ? -i.wheelDelta : 0;
      },
      deltaZ: 0,
      deltaMode: 0
    }), Kf = Mr(Xf), Ka = [9, 13, 27, 32], Ia = 229, cp = ee && "CompositionEvent" in window, zl = null;
    ee && "documentMode" in document && (zl = document.documentMode);
    var Qf = ee && "TextEvent" in window && !zl, Fg = ee && (!cp || zl && zl > 8 && zl <= 11), $g = 32, Zv = String.fromCharCode($g);
    function Ug() {
      fe("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), fe("onCompositionEnd", ["compositionend", "focusout", "keydown", "keypress", "keyup", "mousedown"]), fe("onCompositionStart", ["compositionstart", "focusout", "keydown", "keypress", "keyup", "mousedown"]), fe("onCompositionUpdate", ["compositionupdate", "focusout", "keydown", "keypress", "keyup", "mousedown"]);
    }
    var Au = !1;
    function jy(i) {
      return (i.ctrlKey || i.altKey || i.metaKey) && !(i.ctrlKey && i.altKey);
    }
    function Wy(i) {
      switch (i) {
        case "compositionstart":
          return "onCompositionStart";
        case "compositionend":
          return "onCompositionEnd";
        case "compositionupdate":
          return "onCompositionUpdate";
      }
    }
    function Pu(i, o) {
      return i === "keydown" && o.keyCode === Ia;
    }
    function Vg(i, o) {
      switch (i) {
        case "keyup":
          return Ka.indexOf(o.keyCode) !== -1;
        case "keydown":
          return o.keyCode !== Ia;
        case "keypress":
        case "mousedown":
        case "focusout":
          return !0;
        default:
          return !1;
      }
    }
    function Jv(i) {
      var o = i.detail;
      return typeof o == "object" && "data" in o ? o.data : null;
    }
    function eh(i) {
      return i.locale === "ko";
    }
    var Nu = !1;
    function zs(i, o, f, g, _) {
      var R, N;
      if (cp ? R = Wy(o) : Nu ? Vg(o, g) && (R = "onCompositionEnd") : Pu(o, g) && (R = "onCompositionStart"), !R)
        return null;
      Fg && !eh(g) && (!Nu && R === "onCompositionStart" ? Nu = Yt(_) : R === "onCompositionEnd" && Nu && (N = Er()));
      var z = qg(f, R);
      if (z.length > 0) {
        var W = new Mu(R, o, null, g, _);
        if (i.push({
          event: W,
          listeners: z
        }), N)
          W.data = N;
        else {
          var ne = Jv(g);
          ne !== null && (W.data = ne);
        }
      }
    }
    function Gy(i, o) {
      switch (i) {
        case "compositionend":
          return Jv(o);
        case "keypress":
          var f = o.which;
          return f !== $g ? null : (Au = !0, Zv);
        case "textInput":
          var g = o.data;
          return g === Zv && Au ? null : g;
        default:
          return null;
      }
    }
    function Hy(i, o) {
      if (Nu) {
        if (i === "compositionend" || !cp && Vg(i, o)) {
          var f = Er();
          return Ci(), Nu = !1, f;
        }
        return null;
      }
      switch (i) {
        case "paste":
          return null;
        case "keypress":
          if (!jy(o)) {
            if (o.char && o.char.length > 1)
              return o.char;
            if (o.which)
              return String.fromCharCode(o.which);
          }
          return null;
        case "compositionend":
          return Fg && !eh(o) ? null : o.data;
        default:
          return null;
      }
    }
    function jg(i, o, f, g, _) {
      var R;
      if (Qf ? R = Gy(o, g) : R = Hy(o, g), !R)
        return null;
      var N = qg(f, "onBeforeInput");
      if (N.length > 0) {
        var z = new Hf("onBeforeInput", "beforeinput", null, g, _);
        i.push({
          event: z,
          listeners: N
        }), z.data = R;
      }
    }
    function Wg(i, o, f, g, _, R, N) {
      zs(i, o, f, g, _), jg(i, o, f, g, _);
    }
    var Qa = {
      color: !0,
      date: !0,
      datetime: !0,
      "datetime-local": !0,
      email: !0,
      month: !0,
      number: !0,
      password: !0,
      range: !0,
      search: !0,
      tel: !0,
      text: !0,
      time: !0,
      url: !0,
      week: !0
    };
    function fp(i) {
      var o = i && i.nodeName && i.nodeName.toLowerCase();
      return o === "input" ? !!Qa[i.type] : o === "textarea";
    }
    /**
     * Checks if an event is supported in the current execution environment.
     *
     * NOTE: This will not work correctly for non-generic events such as `change`,
     * `reset`, `load`, `error`, and `select`.
     *
     * Borrows from Modernizr.
     *
     * @param {string} eventNameSuffix Event name, e.g. "click".
     * @return {boolean} True if the event is supported.
     * @internal
     * @license Modernizr 3.0.0pre (Custom Build) | MIT
     */
    function Yy(i) {
      if (!ee)
        return !1;
      var o = "on" + i, f = o in document;
      if (!f) {
        var g = document.createElement("div");
        g.setAttribute(o, "return;"), f = typeof g[o] == "function";
      }
      return f;
    }
    function ku() {
      fe("onChange", ["change", "click", "focusin", "focusout", "input", "keydown", "keyup", "selectionchange"]);
    }
    function Zf(i, o, f, g) {
      yc(g);
      var _ = qg(o, "onChange");
      if (_.length > 0) {
        var R = new Is("onChange", "change", null, f, g);
        i.push({
          event: R,
          listeners: _
        });
      }
    }
    var Yo = null, li = null;
    function th(i) {
      var o = i.nodeName && i.nodeName.toLowerCase();
      return o === "select" || o === "input" && i.type === "file";
    }
    function nh(i) {
      var o = [];
      Zf(o, li, i, Tn(i)), ys(qy, o);
    }
    function qy(i) {
      n1(i, 0);
    }
    function Jf(i) {
      var o = Fs(i);
      if (cv(o))
        return i;
    }
    function dp(i, o) {
      if (i === "change")
        return o;
    }
    var pp = !1;
    ee && (pp = Yy("input") && (!document.documentMode || document.documentMode > 9));
    function Gg(i, o) {
      Yo = i, li = o, Yo.attachEvent("onpropertychange", hp);
    }
    function vp() {
      !Yo || (Yo.detachEvent("onpropertychange", hp), Yo = null, li = null);
    }
    function hp(i) {
      i.propertyName === "value" && Jf(li) && nh(i);
    }
    function rh(i, o, f) {
      i === "focusin" ? (vp(), Gg(o, f)) : i === "focusout" && vp();
    }
    function ed(i, o) {
      if (i === "selectionchange" || i === "keyup" || i === "keydown")
        return Jf(li);
    }
    function Xy(i) {
      var o = i.nodeName;
      return o && o.toLowerCase() === "input" && (i.type === "checkbox" || i.type === "radio");
    }
    function gp(i, o) {
      if (i === "click")
        return Jf(o);
    }
    function Hg(i, o) {
      if (i === "input" || i === "change")
        return Jf(o);
    }
    function Ky(i) {
      var o = i._wrapperState;
      !o || !o.controlled || i.type !== "number" || Dn(i, "number", i.value);
    }
    function td(i, o, f, g, _, R, N) {
      var z = f ? Fs(f) : window, W, ne;
      if (th(z) ? W = dp : fp(z) ? pp ? W = Hg : (W = ed, ne = rh) : Xy(z) && (W = gp), W) {
        var ae = W(o, f);
        if (ae) {
          Zf(i, ae, g, _);
          return;
        }
      }
      ne && ne(o, z, f), o === "focusout" && Ky(z);
    }
    function Qy() {
      ve("onMouseEnter", ["mouseout", "mouseover"]), ve("onMouseLeave", ["mouseout", "mouseover"]), ve("onPointerEnter", ["pointerout", "pointerover"]), ve("onPointerLeave", ["pointerout", "pointerover"]);
    }
    function mp(i, o, f, g, _, R, N) {
      var z = o === "mouseover" || o === "pointerover", W = o === "mouseout" || o === "pointerout";
      if (z && (R & gf) === 0) {
        var ne = g.relatedTarget || g.fromElement;
        if (ne && (id(ne) || am(ne)))
          return;
      }
      if (!(!W && !z)) {
        var ae;
        if (_.window === _)
          ae = _;
        else {
          var Pe = _.ownerDocument;
          Pe ? ae = Pe.defaultView || Pe.parentWindow : ae = window;
        }
        var ye, Ie;
        if (W) {
          var Ke = g.relatedTarget || g.toElement;
          if (ye = f, Ie = Ke ? id(Ke) : null, Ie !== null) {
            var lt = hu(Ie);
            (Ie !== lt || Ie.tag !== C && Ie.tag !== T) && (Ie = null);
          }
        } else
          ye = null, Ie = f;
        if (ye !== Ie) {
          var Ft = jf, vn = "onMouseLeave", Jt = "onMouseEnter", zn = "mouse";
          (o === "pointerout" || o === "pointerover") && (Ft = lp, vn = "onPointerLeave", Jt = "onPointerEnter", zn = "pointer");
          var hr = ye == null ? ae : Fs(ye), ke = Ie == null ? ae : Fs(Ie), Ue = new Ft(vn, zn + "leave", ye, g, _);
          Ue.target = hr, Ue.relatedTarget = ke;
          var De = null, rt = id(_);
          if (rt === f) {
            var ht = new Ft(Jt, zn + "enter", Ie, g, _);
            ht.target = ke, ht.relatedTarget = hr, De = ht;
          }
          xS(i, Ue, De, ye, Ie);
        }
      }
    }
    function u(i, o) {
      return i === o && (i !== 0 || 1 / i === 1 / o) || i !== i && o !== o;
    }
    var d = typeof Object.is == "function" ? Object.is : u, m = Object.prototype.hasOwnProperty;
    function w(i, o) {
      if (d(i, o))
        return !0;
      if (typeof i != "object" || i === null || typeof o != "object" || o === null)
        return !1;
      var f = Object.keys(i), g = Object.keys(o);
      if (f.length !== g.length)
        return !1;
      for (var _ = 0; _ < f.length; _++)
        if (!m.call(o, f[_]) || !d(i[f[_]], o[f[_]]))
          return !1;
      return !0;
    }
    function M(i) {
      for (; i && i.firstChild; )
        i = i.firstChild;
      return i;
    }
    function F(i) {
      for (; i; ) {
        if (i.nextSibling)
          return i.nextSibling;
        i = i.parentNode;
      }
    }
    function H(i, o) {
      for (var f = M(i), g = 0, _ = 0; f; ) {
        if (f.nodeType === vs) {
          if (_ = g + f.textContent.length, g <= o && _ >= o)
            return {
              node: f,
              offset: o - g
            };
          g = _;
        }
        f = M(F(f));
      }
    }
    function te(i) {
      var o = i.ownerDocument, f = o && o.defaultView || window, g = f.getSelection && f.getSelection();
      if (!g || g.rangeCount === 0)
        return null;
      var _ = g.anchorNode, R = g.anchorOffset, N = g.focusNode, z = g.focusOffset;
      try {
        _.nodeType, N.nodeType;
      } catch {
        return null;
      }
      return me(i, _, R, N, z);
    }
    function me(i, o, f, g, _) {
      var R = 0, N = -1, z = -1, W = 0, ne = 0, ae = i, Pe = null;
      e:
        for (; ; ) {
          for (var ye = null; ae === o && (f === 0 || ae.nodeType === vs) && (N = R + f), ae === g && (_ === 0 || ae.nodeType === vs) && (z = R + _), ae.nodeType === vs && (R += ae.nodeValue.length), (ye = ae.firstChild) !== null; )
            Pe = ae, ae = ye;
          for (; ; ) {
            if (ae === i)
              break e;
            if (Pe === o && ++W === f && (N = R), Pe === g && ++ne === _ && (z = R), (ye = ae.nextSibling) !== null)
              break;
            ae = Pe, Pe = ae.parentNode;
          }
          ae = ye;
        }
      return N === -1 || z === -1 ? null : {
        start: N,
        end: z
      };
    }
    function ze(i, o) {
      var f = i.ownerDocument || document, g = f && f.defaultView || window;
      if (!!g.getSelection) {
        var _ = g.getSelection(), R = i.textContent.length, N = Math.min(o.start, R), z = o.end === void 0 ? N : Math.min(o.end, R);
        if (!_.extend && N > z) {
          var W = z;
          z = N, N = W;
        }
        var ne = H(i, N), ae = H(i, z);
        if (ne && ae) {
          if (_.rangeCount === 1 && _.anchorNode === ne.node && _.anchorOffset === ne.offset && _.focusNode === ae.node && _.focusOffset === ae.offset)
            return;
          var Pe = f.createRange();
          Pe.setStart(ne.node, ne.offset), _.removeAllRanges(), N > z ? (_.addRange(Pe), _.extend(ae.node, ae.offset)) : (Pe.setEnd(ae.node, ae.offset), _.addRange(Pe));
        }
      }
    }
    function vt(i) {
      return i && i.nodeType === vs;
    }
    function qt(i, o) {
      return !i || !o ? !1 : i === o ? !0 : vt(i) ? !1 : vt(o) ? qt(i, o.parentNode) : "contains" in i ? i.contains(o) : i.compareDocumentPosition ? !!(i.compareDocumentPosition(o) & 16) : !1;
    }
    function Je(i) {
      return i && i.ownerDocument && qt(i.ownerDocument.documentElement, i);
    }
    function Mt(i) {
      try {
        return typeof i.contentWindow.location.href == "string";
      } catch {
        return !1;
      }
    }
    function Qt() {
      for (var i = window, o = of(); o instanceof i.HTMLIFrameElement; ) {
        if (Mt(o))
          i = o.contentWindow;
        else
          return o;
        o = of(i.document);
      }
      return o;
    }
    function It(i) {
      var o = i && i.nodeName && i.nodeName.toLowerCase();
      return o && (o === "input" && (i.type === "text" || i.type === "search" || i.type === "tel" || i.type === "url" || i.type === "password") || o === "textarea" || i.contentEditable === "true");
    }
    function Me() {
      var i = Qt();
      return {
        focusedElem: i,
        selectionRange: It(i) ? Te(i) : null
      };
    }
    function Ee(i) {
      var o = Qt(), f = i.focusedElem, g = i.selectionRange;
      if (o !== f && Je(f)) {
        g !== null && It(f) && We(f, g);
        for (var _ = [], R = f; R = R.parentNode; )
          R.nodeType === aa && _.push({
            element: R,
            left: R.scrollLeft,
            top: R.scrollTop
          });
        typeof f.focus == "function" && f.focus();
        for (var N = 0; N < _.length; N++) {
          var z = _[N];
          z.element.scrollLeft = z.left, z.element.scrollTop = z.top;
        }
      }
    }
    function Te(i) {
      var o;
      return "selectionStart" in i ? o = {
        start: i.selectionStart,
        end: i.selectionEnd
      } : o = te(i), o || {
        start: 0,
        end: 0
      };
    }
    function We(i, o) {
      var f = o.start, g = o.end;
      g === void 0 && (g = f), "selectionStart" in i ? (i.selectionStart = f, i.selectionEnd = Math.min(g, i.value.length)) : ze(i, o);
    }
    var Ye = ee && "documentMode" in document && document.documentMode <= 11;
    function rn() {
      fe("onSelect", ["focusout", "contextmenu", "dragend", "focusin", "keydown", "keyup", "mousedown", "mouseup", "selectionchange"]);
    }
    var yt = null, Ut = null, sn = null, on = !1;
    function Iu(i) {
      if ("selectionStart" in i && It(i))
        return {
          start: i.selectionStart,
          end: i.selectionEnd
        };
      var o = i.ownerDocument && i.ownerDocument.defaultView || window, f = o.getSelection();
      return {
        anchorNode: f.anchorNode,
        anchorOffset: f.anchorOffset,
        focusNode: f.focusNode,
        focusOffset: f.focusOffset
      };
    }
    function Zy(i) {
      return i.window === i ? i.document : i.nodeType === lu ? i : i.ownerDocument;
    }
    function Jb(i, o, f) {
      var g = Zy(f);
      if (!(on || yt == null || yt !== of(g))) {
        var _ = Iu(yt);
        if (!sn || !w(sn, _)) {
          sn = _;
          var R = qg(Ut, "onSelect");
          if (R.length > 0) {
            var N = new Is("onSelect", "select", null, o, f);
            i.push({
              event: N,
              listeners: R
            }), N.target = yt;
          }
        }
      }
    }
    function gS(i, o, f, g, _, R, N) {
      var z = f ? Fs(f) : window;
      switch (o) {
        case "focusin":
          (fp(z) || z.contentEditable === "true") && (yt = z, Ut = f, sn = null);
          break;
        case "focusout":
          yt = null, Ut = null, sn = null;
          break;
        case "mousedown":
          on = !0;
          break;
        case "contextmenu":
        case "mouseup":
        case "dragend":
          on = !1, Jb(i, g, _);
          break;
        case "selectionchange":
          if (Ye)
            break;
        case "keydown":
        case "keyup":
          Jb(i, g, _);
      }
    }
    function mS(i, o, f, g, _, R, N) {
      var z = Ts.get(o);
      if (z !== void 0) {
        var W = Is, ne = o;
        switch (o) {
          case "keypress":
            if (Dt(g) === 0)
              return;
          case "keydown":
          case "keyup":
            W = up;
            break;
          case "focusin":
            ne = "focus", W = zr;
            break;
          case "focusout":
            ne = "blur", W = zr;
            break;
          case "beforeblur":
          case "afterblur":
            W = zr;
            break;
          case "click":
            if (g.button === 2)
              return;
          case "auxclick":
          case "dblclick":
          case "mousedown":
          case "mousemove":
          case "mouseup":
          case "mouseout":
          case "mouseover":
          case "contextmenu":
            W = jf;
            break;
          case "drag":
          case "dragend":
          case "dragenter":
          case "dragexit":
          case "dragleave":
          case "dragover":
          case "dragstart":
          case "drop":
            W = Wo;
            break;
          case "touchcancel":
          case "touchend":
          case "touchmove":
          case "touchstart":
            W = qf;
            break;
          case Tl:
          case oa:
          case Cf:
            W = Kv;
            break;
          case xu:
            W = Qv;
            break;
          case "scroll":
            W = ui;
            break;
          case "wheel":
            W = Kf;
            break;
          case "copy":
          case "cut":
          case "paste":
            W = Ls;
            break;
          case "gotpointercapture":
          case "lostpointercapture":
          case "pointercancel":
          case "pointerdown":
          case "pointermove":
          case "pointerout":
          case "pointerover":
          case "pointerup":
            W = lp;
            break;
        }
        var ae = (R & Ha) !== 0;
        {
          var Pe = !ae && o === "scroll", ye = Yg(f, z, g.type, ae, Pe);
          if (ye.length > 0) {
            var Ie = new W(z, ne, null, g, _);
            i.push({
              event: Ie,
              listeners: ye
            });
          }
        }
      }
    }
    Ml(), Qy(), ku(), rn(), Ug();
    function yS(i, o, f, g, _, R, N) {
      mS(i, o, f, g, _, R);
      var z = (R & gs) === 0;
      z && (mp(i, o, f, g, _, R), td(i, o, f, g, _), gS(i, o, f, g, _), Wg(i, o, f, g, _));
    }
    var ih = ["abort", "canplay", "canplaythrough", "durationchange", "emptied", "encrypted", "ended", "error", "loadeddata", "loadedmetadata", "loadstart", "pause", "play", "playing", "progress", "ratechange", "seeked", "seeking", "stalled", "suspend", "timeupdate", "volumechange", "waiting"], e1 = new Set(["cancel", "close", "invalid", "load", "scroll", "toggle"].concat(ih));
    function t1(i, o, f) {
      var g = i.type || "unknown-event";
      i.currentTarget = f, Ec(g, o, void 0, i), i.currentTarget = null;
    }
    function bS(i, o, f) {
      var g;
      if (f)
        for (var _ = o.length - 1; _ >= 0; _--) {
          var R = o[_], N = R.instance, z = R.currentTarget, W = R.listener;
          if (N !== g && i.isPropagationStopped())
            return;
          t1(i, W, z), g = N;
        }
      else
        for (var ne = 0; ne < o.length; ne++) {
          var ae = o[ne], Pe = ae.instance, ye = ae.currentTarget, Ie = ae.listener;
          if (Pe !== g && i.isPropagationStopped())
            return;
          t1(i, Ie, ye), g = Pe;
        }
    }
    function n1(i, o) {
      for (var f = (o & Ha) !== 0, g = 0; g < i.length; g++) {
        var _ = i[g], R = _.event, N = _.listeners;
        bS(R, N, f);
      }
      Es();
    }
    function _S(i, o, f, g, _) {
      var R = Tn(f), N = [];
      yS(N, i, g, f, R, o), n1(N, o);
    }
    function xr(i, o) {
      var f = !1, g = I1(o), _ = u1(i, f);
      g.has(_) || (i1(o, i, hf, f), g.add(_));
    }
    var r1 = "_reactListening" + Math.random().toString(36).slice(2);
    function Jy(i) {
      {
        if (i[r1])
          return;
        i[r1] = !0, ie.forEach(function(o) {
          e1.has(o) || e0(o, !1, i, null), e0(o, !0, i, null);
        });
      }
    }
    function e0(i, o, f, g) {
      var _ = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0, R = f;
      if (i === "selectionchange" && f.nodeType !== lu && (R = f.ownerDocument), g !== null && !o && e1.has(i)) {
        if (i !== "scroll")
          return;
        _ |= hf, R = g;
      }
      var N = I1(R), z = u1(i, o);
      N.has(z) || (o && (_ |= Ha), i1(R, i, _, o), N.add(z));
    }
    function i1(i, o, f, g, _) {
      var R = ap(i, o, f), N = void 0;
      bl && (o === "touchstart" || o === "touchmove" || o === "wheel") && (N = !0), i = i, g ? N !== void 0 ? qv(i, o, R, N) : Yv(i, o, R) : N !== void 0 ? Vy(i, o, R, N) : Hv(i, o, R);
    }
    function a1(i, o) {
      return i === o || i.nodeType === _i && i.parentNode === o;
    }
    function o1(i, o, f, g, _) {
      var R = g;
      if ((o & mc) === 0 && (o & hf) === 0) {
        var N = _;
        if (g !== null) {
          var z = g;
          e:
            for (; ; ) {
              if (z === null)
                return;
              var W = z.tag;
              if (W === E || W === x) {
                var ne = z.stateNode.containerInfo;
                if (a1(ne, N))
                  break;
                if (W === x)
                  for (var ae = z.return; ae !== null; ) {
                    var Pe = ae.tag;
                    if (Pe === E || Pe === x) {
                      var ye = ae.stateNode.containerInfo;
                      if (a1(ye, N))
                        return;
                    }
                    ae = ae.return;
                  }
                for (; ne !== null; ) {
                  var Ie = id(ne);
                  if (Ie === null)
                    return;
                  var Ke = Ie.tag;
                  if (Ke === C || Ke === T) {
                    z = R = Ie;
                    continue e;
                  }
                  ne = ne.parentNode;
                }
              }
              z = z.return;
            }
        }
      }
      ko(function() {
        return _S(i, o, f, R);
      });
    }
    function ah(i, o, f) {
      return {
        instance: i,
        listener: o,
        currentTarget: f
      };
    }
    function Yg(i, o, f, g, _) {
      for (var R = o !== null ? o + "Capture" : null, N = g ? R : o, z = [], W = i, ne = null; W !== null; ) {
        var ae = W, Pe = ae.stateNode, ye = ae.tag;
        if (ye === C && Pe !== null && (ne = Pe, N !== null)) {
          var Ie = _s(W, N);
          Ie != null && z.push(ah(W, Ie, ne));
        }
        if (_)
          break;
        W = W.return;
      }
      return z;
    }
    function qg(i, o) {
      for (var f = o + "Capture", g = [], _ = i; _ !== null; ) {
        var R = _, N = R.stateNode, z = R.tag;
        if (z === C && N !== null) {
          var W = N, ne = _s(_, f);
          ne != null && g.unshift(ah(_, ne, W));
          var ae = _s(_, o);
          ae != null && g.push(ah(_, ae, W));
        }
        _ = _.return;
      }
      return g;
    }
    function yp(i) {
      if (i === null)
        return null;
      do
        i = i.return;
      while (i && i.tag !== C);
      return i || null;
    }
    function ES(i, o) {
      for (var f = i, g = o, _ = 0, R = f; R; R = yp(R))
        _++;
      for (var N = 0, z = g; z; z = yp(z))
        N++;
      for (; _ - N > 0; )
        f = yp(f), _--;
      for (; N - _ > 0; )
        g = yp(g), N--;
      for (var W = _; W--; ) {
        if (f === g || g !== null && f === g.alternate)
          return f;
        f = yp(f), g = yp(g);
      }
      return null;
    }
    function s1(i, o, f, g, _) {
      for (var R = o._reactName, N = [], z = f; z !== null && z !== g; ) {
        var W = z, ne = W.alternate, ae = W.stateNode, Pe = W.tag;
        if (ne !== null && ne === g)
          break;
        if (Pe === C && ae !== null) {
          var ye = ae;
          if (_) {
            var Ie = _s(z, R);
            Ie != null && N.unshift(ah(z, Ie, ye));
          } else if (!_) {
            var Ke = _s(z, R);
            Ke != null && N.push(ah(z, Ke, ye));
          }
        }
        z = z.return;
      }
      N.length !== 0 && i.push({
        event: o,
        listeners: N
      });
    }
    function xS(i, o, f, g, _) {
      var R = g && _ ? ES(g, _) : null;
      g !== null && s1(i, o, g, R, !1), _ !== null && f !== null && s1(i, f, _, R, !0);
    }
    function u1(i, o) {
      return i + "__" + (o ? "capture" : "bubble");
    }
    var Za = !1, oh = "dangerouslySetInnerHTML", Xg = "suppressContentEditableWarning", sh = "suppressHydrationWarning", l1 = "autoFocus", Lu = "children", nd = "style", uh = "__html", rd = df.html, lh, bp, ch, fh, _p, c1, Kg, f1, Ic, dh;
    {
      lh = {
        dialog: !0,
        webview: !0
      }, ch = function(i, o) {
        pl(i, o), $e(i, o), Ra(i, o, {
          registrationNameDependencies: ce,
          possibleRegistrationNames: le
        });
      }, f1 = ee && !document.documentMode;
      var SS = /\r\n?/g, wS = /\u0000|\uFFFD/g;
      Ic = function(i) {
        var o = typeof i == "string" ? i : "" + i;
        return o.replace(SS, `
`).replace(wS, "");
      }, fh = function(i, o) {
        if (!Za) {
          var f = Ic(o), g = Ic(i);
          g !== f && (Za = !0, l('Text content did not match. Server: "%s" Client: "%s"', g, f));
        }
      }, _p = function(i, o, f) {
        if (!Za) {
          var g = Ic(f), _ = Ic(o);
          _ !== g && (Za = !0, l("Prop `%s` did not match. Server: %s Client: %s", i, JSON.stringify(_), JSON.stringify(g)));
        }
      }, c1 = function(i) {
        if (!Za) {
          Za = !0;
          var o = [];
          i.forEach(function(f) {
            o.push(f);
          }), l("Extra attributes from the server: %s", o);
        }
      }, Kg = function(i, o) {
        o === !1 ? l("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", i, i, i) : l("Expected `%s` listener to be a function, instead got a value of `%s` type.", i, typeof o);
      }, dh = function(i, o) {
        var f = i.namespaceURI === rd ? i.ownerDocument.createElement(i.tagName) : i.ownerDocument.createElementNS(i.namespaceURI, i.tagName);
        return f.innerHTML = o, f.innerHTML;
      };
    }
    function Qg(i) {
      return i.nodeType === lu ? i : i.ownerDocument;
    }
    function d1() {
    }
    function Zg(i) {
      i.onclick = d1;
    }
    function CS(i, o, f, g, _) {
      for (var R in g)
        if (!!g.hasOwnProperty(R)) {
          var N = g[R];
          if (R === nd)
            N && Object.freeze(N), Ev(o, N);
          else if (R === oh) {
            var z = N ? N[uh] : void 0;
            z != null && ps(o, z);
          } else if (R === Lu)
            if (typeof N == "string") {
              var W = i !== "textarea" || N !== "";
              W && Id(o, N);
            } else
              typeof N == "number" && Id(o, "" + N);
          else
            R === Xg || R === sh || R === l1 || (ce.hasOwnProperty(R) ? N != null && (typeof N != "function" && Kg(R, N), R === "onScroll" && xr("scroll", o)) : N != null && In(o, R, N, _));
        }
    }
    function RS(i, o, f, g) {
      for (var _ = 0; _ < o.length; _ += 2) {
        var R = o[_], N = o[_ + 1];
        R === nd ? Ev(i, N) : R === oh ? ps(i, N) : R === Lu ? Id(i, N) : In(i, R, N, g);
      }
    }
    function TS(i, o, f, g) {
      var _, R = Qg(f), N, z = g;
      if (z === rd && (z = Wa(i)), z === rd) {
        if (_ = co(i, o), !_ && i !== i.toLowerCase() && l("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", i), i === "script") {
          var W = R.createElement("div");
          W.innerHTML = "<script><\/script>";
          var ne = W.firstChild;
          N = W.removeChild(ne);
        } else if (typeof o.is == "string")
          N = R.createElement(i, {
            is: o.is
          });
        else if (N = R.createElement(i), i === "select") {
          var ae = N;
          o.multiple ? ae.multiple = !0 : o.size && (ae.size = o.size);
        }
      } else
        N = R.createElementNS(z, i);
      return z === rd && !_ && Object.prototype.toString.call(N) === "[object HTMLUnknownElement]" && !Object.prototype.hasOwnProperty.call(lh, i) && (lh[i] = !0, l("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", i)), N;
    }
    function OS(i, o) {
      return Qg(o).createTextNode(i);
    }
    function DS(i, o, f, g) {
      var _ = co(o, f);
      ch(o, f);
      var R;
      switch (o) {
        case "dialog":
          xr("cancel", i), xr("close", i), R = f;
          break;
        case "iframe":
        case "object":
        case "embed":
          xr("load", i), R = f;
          break;
        case "video":
        case "audio":
          for (var N = 0; N < ih.length; N++)
            xr(ih[N], i);
          R = f;
          break;
        case "source":
          xr("error", i), R = f;
          break;
        case "img":
        case "image":
        case "link":
          xr("error", i), xr("load", i), R = f;
          break;
        case "details":
          xr("toggle", i), R = f;
          break;
        case "input":
          ds(i, f), R = Wn(i, f), xr("invalid", i);
          break;
        case "option":
          fg(i, f), R = pv(i, f);
          break;
        case "select":
          cf(i, f), R = lo(i, f), xr("invalid", i);
          break;
        case "textarea":
          pc(i, f), R = ll(i, f), xr("invalid", i);
          break;
        default:
          R = f;
      }
      switch ($d(o, R), CS(o, i, g, R, _), o) {
        case "input":
          fc(i), dc(i, f, !1);
          break;
        case "textarea":
          fc(i), Wi(i);
          break;
        case "option":
          Iy(i, f);
          break;
        case "select":
          Oo(i, f);
          break;
        default:
          typeof R.onClick == "function" && Zg(i);
          break;
      }
    }
    function MS(i, o, f, g, _) {
      ch(o, g);
      var R = null, N, z;
      switch (o) {
        case "input":
          N = Wn(i, f), z = Wn(i, g), R = [];
          break;
        case "option":
          N = pv(i, f), z = pv(i, g), R = [];
          break;
        case "select":
          N = lo(i, f), z = lo(i, g), R = [];
          break;
        case "textarea":
          N = ll(i, f), z = ll(i, g), R = [];
          break;
        default:
          N = f, z = g, typeof N.onClick != "function" && typeof z.onClick == "function" && Zg(i);
          break;
      }
      $d(o, z);
      var W, ne, ae = null;
      for (W in N)
        if (!(z.hasOwnProperty(W) || !N.hasOwnProperty(W) || N[W] == null))
          if (W === nd) {
            var Pe = N[W];
            for (ne in Pe)
              Pe.hasOwnProperty(ne) && (ae || (ae = {}), ae[ne] = "");
          } else
            W === oh || W === Lu || W === Xg || W === sh || W === l1 || (ce.hasOwnProperty(W) ? R || (R = []) : (R = R || []).push(W, null));
      for (W in z) {
        var ye = z[W], Ie = N != null ? N[W] : void 0;
        if (!(!z.hasOwnProperty(W) || ye === Ie || ye == null && Ie == null))
          if (W === nd)
            if (ye && Object.freeze(ye), Ie) {
              for (ne in Ie)
                Ie.hasOwnProperty(ne) && (!ye || !ye.hasOwnProperty(ne)) && (ae || (ae = {}), ae[ne] = "");
              for (ne in ye)
                ye.hasOwnProperty(ne) && Ie[ne] !== ye[ne] && (ae || (ae = {}), ae[ne] = ye[ne]);
            } else
              ae || (R || (R = []), R.push(W, ae)), ae = ye;
          else if (W === oh) {
            var Ke = ye ? ye[uh] : void 0, lt = Ie ? Ie[uh] : void 0;
            Ke != null && lt !== Ke && (R = R || []).push(W, Ke);
          } else
            W === Lu ? (typeof ye == "string" || typeof ye == "number") && (R = R || []).push(W, "" + ye) : W === Xg || W === sh || (ce.hasOwnProperty(W) ? (ye != null && (typeof ye != "function" && Kg(W, ye), W === "onScroll" && xr("scroll", i)), !R && Ie !== ye && (R = [])) : typeof ye == "object" && ye !== null && ye.$$typeof === tt ? ye.toString() : (R = R || []).push(W, ye));
      }
      return ae && (Eg(ae, z[nd]), (R = R || []).push(nd, ae)), R;
    }
    function AS(i, o, f, g, _) {
      f === "input" && _.type === "radio" && _.name != null && lg(i, _);
      var R = co(f, g), N = co(f, _);
      switch (RS(i, o, R, N), f) {
        case "input":
          dv(i, _);
          break;
        case "textarea":
          kd(i, _);
          break;
        case "select":
          ia(i, _);
          break;
      }
    }
    function PS(i) {
      {
        var o = i.toLowerCase();
        return Ca.hasOwnProperty(o) && Ca[o] || null;
      }
    }
    function NS(i, o, f, g, _) {
      var R, N;
      switch (bp = f[sh] === !0, R = co(o, f), ch(o, f), o) {
        case "dialog":
          xr("cancel", i), xr("close", i);
          break;
        case "iframe":
        case "object":
        case "embed":
          xr("load", i);
          break;
        case "video":
        case "audio":
          for (var z = 0; z < ih.length; z++)
            xr(ih[z], i);
          break;
        case "source":
          xr("error", i);
          break;
        case "img":
        case "image":
        case "link":
          xr("error", i), xr("load", i);
          break;
        case "details":
          xr("toggle", i);
          break;
        case "input":
          ds(i, f), xr("invalid", i);
          break;
        case "option":
          fg(i, f);
          break;
        case "select":
          cf(i, f), xr("invalid", i);
          break;
        case "textarea":
          pc(i, f), xr("invalid", i);
          break;
      }
      $d(o, f);
      {
        N = /* @__PURE__ */ new Set();
        for (var W = i.attributes, ne = 0; ne < W.length; ne++) {
          var ae = W[ne].name.toLowerCase();
          switch (ae) {
            case "data-reactroot":
              break;
            case "value":
              break;
            case "checked":
              break;
            case "selected":
              break;
            default:
              N.add(W[ne].name);
          }
        }
      }
      var Pe = null;
      for (var ye in f)
        if (!!f.hasOwnProperty(ye)) {
          var Ie = f[ye];
          if (ye === Lu)
            typeof Ie == "string" ? i.textContent !== Ie && (bp || fh(i.textContent, Ie), Pe = [Lu, Ie]) : typeof Ie == "number" && i.textContent !== "" + Ie && (bp || fh(i.textContent, Ie), Pe = [Lu, "" + Ie]);
          else if (ce.hasOwnProperty(ye))
            Ie != null && (typeof Ie != "function" && Kg(ye, Ie), ye === "onScroll" && xr("scroll", i));
          else if (typeof R == "boolean") {
            var Ke = void 0, lt = Gt(ye);
            if (!bp) {
              if (!(ye === Xg || ye === sh || ye === "value" || ye === "checked" || ye === "selected")) {
                if (ye === oh) {
                  var Ft = i.innerHTML, vn = Ie ? Ie[uh] : void 0;
                  if (vn != null) {
                    var Jt = dh(i, vn);
                    Jt !== Ft && _p(ye, Ft, Jt);
                  }
                } else if (ye === nd) {
                  if (N.delete(ye), f1) {
                    var zn = dl(Ie);
                    Ke = i.getAttribute("style"), zn !== Ke && _p(ye, Ke, zn);
                  }
                } else if (R)
                  N.delete(ye.toLowerCase()), Ke = kn(i, ye, Ie), Ie !== Ke && _p(ye, Ke, Ie);
                else if (!Vn(ye, lt, R) && !ft(ye, Ie, lt, R)) {
                  var hr = !1;
                  if (lt !== null)
                    N.delete(lt.attributeName), Ke = Nn(i, ye, Ie, lt);
                  else {
                    var ke = g;
                    if (ke === rd && (ke = Wa(o)), ke === rd)
                      N.delete(ye.toLowerCase());
                    else {
                      var Ue = PS(ye);
                      Ue !== null && Ue !== ye && (hr = !0, N.delete(Ue)), N.delete(ye);
                    }
                    Ke = kn(i, ye, Ie);
                  }
                  Ie !== Ke && !hr && _p(ye, Ke, Ie);
                }
              }
            }
          }
        }
      switch (N.size > 0 && !bp && c1(N), o) {
        case "input":
          fc(i), dc(i, f, !0);
          break;
        case "textarea":
          fc(i), Wi(i);
          break;
        case "select":
        case "option":
          break;
        default:
          typeof f.onClick == "function" && Zg(i);
          break;
      }
      return Pe;
    }
    function kS(i, o) {
      var f = i.nodeValue !== o;
      return f;
    }
    function p1(i, o) {
      fh(i.nodeValue, o);
    }
    function qo(i, o) {
      {
        if (Za)
          return;
        Za = !0, l("Did not expect server HTML to contain a <%s> in <%s>.", o.nodeName.toLowerCase(), i.nodeName.toLowerCase());
      }
    }
    function v1(i, o) {
      {
        if (Za)
          return;
        Za = !0, l('Did not expect server HTML to contain the text node "%s" in <%s>.', o.nodeValue, i.nodeName.toLowerCase());
      }
    }
    function h1(i, o, f) {
      {
        if (Za)
          return;
        Za = !0, l("Expected server HTML to contain a matching <%s> in <%s>.", o, i.nodeName.toLowerCase());
      }
    }
    function Lc(i, o) {
      {
        if (o === "" || Za)
          return;
        Za = !0, l('Expected server HTML to contain a matching text node for "%s" in <%s>.', o, i.nodeName.toLowerCase());
      }
    }
    function cn(i, o, f) {
      switch (o) {
        case "input":
          cg(i, f);
          return;
        case "textarea":
          ii(i, f);
          return;
        case "select":
          ff(i, f);
          return;
      }
    }
    var ph = function() {
    }, Pi = function() {
    };
    {
      var ni = ["address", "applet", "area", "article", "aside", "base", "basefont", "bgsound", "blockquote", "body", "br", "button", "caption", "center", "col", "colgroup", "dd", "details", "dir", "div", "dl", "dt", "embed", "fieldset", "figcaption", "figure", "footer", "form", "frame", "frameset", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "iframe", "img", "input", "isindex", "li", "link", "listing", "main", "marquee", "menu", "menuitem", "meta", "nav", "noembed", "noframes", "noscript", "object", "ol", "p", "param", "plaintext", "pre", "script", "section", "select", "source", "style", "summary", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "title", "tr", "track", "ul", "wbr", "xmp"], g1 = [
        "applet",
        "caption",
        "html",
        "table",
        "td",
        "th",
        "marquee",
        "object",
        "template",
        "foreignObject",
        "desc",
        "title"
      ], Bc = g1.concat(["button"]), IS = ["dd", "dt", "li", "option", "optgroup", "p", "rp", "rt"], m1 = {
        current: null,
        formTag: null,
        aTagInScope: null,
        buttonTagInScope: null,
        nobrTagInScope: null,
        pTagInButtonScope: null,
        listItemTagAutoclosing: null,
        dlItemTagAutoclosing: null
      };
      Pi = function(i, o) {
        var f = t({}, i || m1), g = {
          tag: o
        };
        return g1.indexOf(o) !== -1 && (f.aTagInScope = null, f.buttonTagInScope = null, f.nobrTagInScope = null), Bc.indexOf(o) !== -1 && (f.pTagInButtonScope = null), ni.indexOf(o) !== -1 && o !== "address" && o !== "div" && o !== "p" && (f.listItemTagAutoclosing = null, f.dlItemTagAutoclosing = null), f.current = g, o === "form" && (f.formTag = g), o === "a" && (f.aTagInScope = g), o === "button" && (f.buttonTagInScope = g), o === "nobr" && (f.nobrTagInScope = g), o === "p" && (f.pTagInButtonScope = g), o === "li" && (f.listItemTagAutoclosing = g), (o === "dd" || o === "dt") && (f.dlItemTagAutoclosing = g), f;
      };
      var LS = function(i, o) {
        switch (o) {
          case "select":
            return i === "option" || i === "optgroup" || i === "#text";
          case "optgroup":
            return i === "option" || i === "#text";
          case "option":
            return i === "#text";
          case "tr":
            return i === "th" || i === "td" || i === "style" || i === "script" || i === "template";
          case "tbody":
          case "thead":
          case "tfoot":
            return i === "tr" || i === "style" || i === "script" || i === "template";
          case "colgroup":
            return i === "col" || i === "template";
          case "table":
            return i === "caption" || i === "colgroup" || i === "tbody" || i === "tfoot" || i === "thead" || i === "style" || i === "script" || i === "template";
          case "head":
            return i === "base" || i === "basefont" || i === "bgsound" || i === "link" || i === "meta" || i === "title" || i === "noscript" || i === "noframes" || i === "style" || i === "script" || i === "template";
          case "html":
            return i === "head" || i === "body" || i === "frameset";
          case "frameset":
            return i === "frame";
          case "#document":
            return i === "html";
        }
        switch (i) {
          case "h1":
          case "h2":
          case "h3":
          case "h4":
          case "h5":
          case "h6":
            return o !== "h1" && o !== "h2" && o !== "h3" && o !== "h4" && o !== "h5" && o !== "h6";
          case "rp":
          case "rt":
            return IS.indexOf(o) === -1;
          case "body":
          case "caption":
          case "col":
          case "colgroup":
          case "frameset":
          case "frame":
          case "head":
          case "html":
          case "tbody":
          case "td":
          case "tfoot":
          case "th":
          case "thead":
          case "tr":
            return o == null;
        }
        return !0;
      }, BS = function(i, o) {
        switch (i) {
          case "address":
          case "article":
          case "aside":
          case "blockquote":
          case "center":
          case "details":
          case "dialog":
          case "dir":
          case "div":
          case "dl":
          case "fieldset":
          case "figcaption":
          case "figure":
          case "footer":
          case "header":
          case "hgroup":
          case "main":
          case "menu":
          case "nav":
          case "ol":
          case "p":
          case "section":
          case "summary":
          case "ul":
          case "pre":
          case "listing":
          case "table":
          case "hr":
          case "xmp":
          case "h1":
          case "h2":
          case "h3":
          case "h4":
          case "h5":
          case "h6":
            return o.pTagInButtonScope;
          case "form":
            return o.formTag || o.pTagInButtonScope;
          case "li":
            return o.listItemTagAutoclosing;
          case "dd":
          case "dt":
            return o.dlItemTagAutoclosing;
          case "button":
            return o.buttonTagInScope;
          case "a":
            return o.aTagInScope;
          case "nobr":
            return o.nobrTagInScope;
        }
        return null;
      }, y1 = {};
      ph = function(i, o, f) {
        f = f || m1;
        var g = f.current, _ = g && g.tag;
        o != null && (i != null && l("validateDOMNesting: when childText is passed, childTag should be null"), i = "#text");
        var R = LS(i, _) ? null : g, N = R ? null : BS(i, f), z = R || N;
        if (!!z) {
          var W = z.tag, ne = !!R + "|" + i + "|" + W;
          if (!y1[ne]) {
            y1[ne] = !0;
            var ae = i, Pe = "";
            if (i === "#text" ? /\S/.test(o) ? ae = "Text nodes" : (ae = "Whitespace text nodes", Pe = " Make sure you don't have any extra whitespace between tags on each line of your source code.") : ae = "<" + i + ">", R) {
              var ye = "";
              W === "table" && i === "tr" && (ye += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser."), l("validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s", ae, W, Pe, ye);
            } else
              l("validateDOMNesting(...): %s cannot appear as a descendant of <%s>.", ae, W);
          }
        }
      };
    }
    var zc;
    zc = "suppressHydrationWarning";
    var b1 = "$", Bu = "/$", Jg = "$?", Ep = "$!", Fr = "style", Ar = null, em = null;
    function _1(i, o) {
      switch (i) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          return !!o.autoFocus;
      }
      return !1;
    }
    function zS(i) {
      var o, f, g = i.nodeType;
      switch (g) {
        case lu:
        case dg: {
          o = g === lu ? "#document" : "#fragment";
          var _ = i.documentElement;
          f = _ ? _.namespaceURI : Do(null, "");
          break;
        }
        default: {
          var R = g === _i ? i.parentNode : i, N = R.namespaceURI || null;
          o = R.tagName, f = Do(N, o);
          break;
        }
      }
      {
        var z = o.toLowerCase(), W = Pi(null, z);
        return {
          namespace: f,
          ancestorInfo: W
        };
      }
    }
    function FS(i, o, f) {
      {
        var g = i, _ = Do(g.namespace, o), R = Pi(g.ancestorInfo, o);
        return {
          namespace: _,
          ancestorInfo: R
        };
      }
    }
    function lM(i) {
      return i;
    }
    function $S(i) {
      Ar = Wv(), em = Me();
      var o = null;
      return Pc(!1), o;
    }
    function US(i) {
      Ee(em), Pc(Ar), Ar = null, em = null;
    }
    function E1(i, o, f, g, _) {
      var R;
      {
        var N = g;
        if (ph(i, null, N.ancestorInfo), typeof o.children == "string" || typeof o.children == "number") {
          var z = "" + o.children, W = Pi(N.ancestorInfo, i);
          ph(null, z, W);
        }
        R = N.namespace;
      }
      var ne = TS(i, o, f, R);
      return gh(_, ne), a0(ne, o), ne;
    }
    function vh(i, o) {
      i.appendChild(o);
    }
    function t0(i, o, f, g, _) {
      return DS(i, o, f, g), _1(o, f);
    }
    function VS(i, o, f, g, _, R) {
      {
        var N = R;
        if (typeof g.children != typeof f.children && (typeof g.children == "string" || typeof g.children == "number")) {
          var z = "" + g.children, W = Pi(N.ancestorInfo, o);
          ph(null, z, W);
        }
      }
      return MS(i, o, f, g);
    }
    function tm(i, o) {
      return i === "textarea" || i === "option" || i === "noscript" || typeof o.children == "string" || typeof o.children == "number" || typeof o.dangerouslySetInnerHTML == "object" && o.dangerouslySetInnerHTML !== null && o.dangerouslySetInnerHTML.__html != null;
    }
    function nm(i, o, f, g) {
      {
        var _ = f;
        ph(null, i, _.ancestorInfo);
      }
      var R = OS(i, o);
      return gh(g, R), R;
    }
    var Ja = typeof setTimeout == "function" ? setTimeout : void 0, xp = typeof clearTimeout == "function" ? clearTimeout : void 0, n0 = -1;
    function jS(i, o, f, g) {
      _1(o, f) && i.focus();
    }
    function WS(i, o, f, g, _, R) {
      a0(i, _), AS(i, o, f, g, _);
    }
    function x1(i) {
      Id(i, "");
    }
    function GS(i, o, f) {
      i.nodeValue = f;
    }
    function S1(i, o) {
      i.appendChild(o);
    }
    function Fl(i, o) {
      var f;
      i.nodeType === _i ? (f = i.parentNode, f.insertBefore(o, i)) : (f = i, f.appendChild(o));
      var g = i._reactRootContainer;
      g == null && f.onclick === null && Zg(f);
    }
    function pn(i, o, f) {
      i.insertBefore(o, f);
    }
    function w1(i, o, f) {
      i.nodeType === _i ? i.parentNode.insertBefore(o, f) : i.insertBefore(o, f);
    }
    function Xo(i, o) {
      i.removeChild(o);
    }
    function C1(i, o) {
      i.nodeType === _i ? i.parentNode.removeChild(o) : i.removeChild(o);
    }
    function HS(i) {
      i = i;
      var o = i.style;
      typeof o.setProperty == "function" ? o.setProperty("display", "none", "important") : o.display = "none";
    }
    function Yn(i) {
      i.nodeValue = "";
    }
    function YS(i, o) {
      i = i;
      var f = o[Fr], g = f != null && f.hasOwnProperty("display") ? f.display : null;
      i.style.display = Ld("display", g);
    }
    function R1(i, o) {
      i.nodeValue = o;
    }
    function Sp(i) {
      if (i.nodeType === aa)
        i.textContent = "";
      else if (i.nodeType === lu) {
        var o = i.body;
        o != null && (o.textContent = "");
      }
    }
    function qS(i, o, f) {
      return i.nodeType !== aa || o.toLowerCase() !== i.nodeName.toLowerCase() ? null : i;
    }
    function XS(i, o) {
      return o === "" || i.nodeType !== vs ? null : i;
    }
    function KS(i) {
      return i.data === Jg;
    }
    function QS(i) {
      return i.data === Ep;
    }
    function T1(i) {
      for (; i != null; i = i.nextSibling) {
        var o = i.nodeType;
        if (o === aa || o === vs)
          break;
      }
      return i;
    }
    function rm(i) {
      return T1(i.nextSibling);
    }
    function O1(i) {
      return T1(i.firstChild);
    }
    function ZS(i, o, f, g, _, R) {
      gh(R, i), a0(i, f);
      var N;
      {
        var z = _;
        N = z.namespace;
      }
      return NS(i, o, f, N);
    }
    function JS(i, o, f) {
      return gh(f, i), kS(i, o);
    }
    function ew(i) {
      for (var o = i.nextSibling, f = 0; o; ) {
        if (o.nodeType === _i) {
          var g = o.data;
          if (g === Bu) {
            if (f === 0)
              return rm(o);
            f--;
          } else
            (g === b1 || g === Ep || g === Jg) && f++;
        }
        o = o.nextSibling;
      }
      return null;
    }
    function D1(i) {
      for (var o = i.previousSibling, f = 0; o; ) {
        if (o.nodeType === _i) {
          var g = o.data;
          if (g === b1 || g === Ep || g === Jg) {
            if (f === 0)
              return o;
            f--;
          } else
            g === Bu && f++;
        }
        o = o.previousSibling;
      }
      return null;
    }
    function tw(i) {
      Cl(i);
    }
    function nw(i) {
      Cl(i);
    }
    function r0(i, o, f) {
      p1(o, f);
    }
    function rw(i, o, f, g, _) {
      o[zc] !== !0 && p1(g, _);
    }
    function i0(i, o) {
      o.nodeType === aa ? qo(i, o) : o.nodeType === _i || v1(i, o);
    }
    function iw(i, o, f, g) {
      o[zc] !== !0 && (g.nodeType === aa ? qo(f, g) : g.nodeType === _i || v1(f, g));
    }
    function aw(i, o, f) {
      h1(i, o);
    }
    function ow(i, o) {
      Lc(i, o);
    }
    function Ni(i, o, f, g, _) {
      o[zc] !== !0 && h1(f, g);
    }
    function eo(i, o, f, g) {
      o[zc] !== !0 && Lc(f, g);
    }
    function sw(i, o, f) {
      o[zc];
    }
    var uw = 0;
    function lw(i) {
      var o = "r:" + (uw++).toString(36);
      return {
        toString: function() {
          return i(), o;
        },
        valueOf: function() {
          return i(), o;
        }
      };
    }
    function M1(i) {
      return i !== null && typeof i == "object" && i.$$typeof === tt;
    }
    function cw(i) {
      return {
        $$typeof: tt,
        toString: i,
        valueOf: i
      };
    }
    function fw(i) {
      Jy(i);
    }
    var im = Math.random().toString(36).slice(2), wp = "__reactFiber$" + im, A1 = "__reactProps$" + im, hh = "__reactContainer$" + im, P1 = "__reactEvents$" + im;
    function gh(i, o) {
      o[wp] = i;
    }
    function N1(i, o) {
      o[hh] = i;
    }
    function k1(i) {
      i[hh] = null;
    }
    function am(i) {
      return !!i[hh];
    }
    function id(i) {
      var o = i[wp];
      if (o)
        return o;
      for (var f = i.parentNode; f; ) {
        if (o = f[hh] || f[wp], o) {
          var g = o.alternate;
          if (o.child !== null || g !== null && g.child !== null)
            for (var _ = D1(i); _ !== null; ) {
              var R = _[wp];
              if (R)
                return R;
              _ = D1(_);
            }
          return o;
        }
        i = f, f = i.parentNode;
      }
      return null;
    }
    function Fc(i) {
      var o = i[wp] || i[hh];
      return o && (o.tag === C || o.tag === T || o.tag === k || o.tag === E) ? o : null;
    }
    function Fs(i) {
      if (i.tag === C || i.tag === T)
        return i.stateNode;
      throw Error("getNodeFromInstance: Invalid argument.");
    }
    function om(i) {
      return i[A1] || null;
    }
    function a0(i, o) {
      i[A1] = o;
    }
    function I1(i) {
      var o = i[P1];
      return o === void 0 && (o = i[P1] = /* @__PURE__ */ new Set()), o;
    }
    var L1 = {}, B1 = a.ReactDebugCurrentFrame;
    function mh(i) {
      if (i) {
        var o = i._owner, f = ja(i.type, i._source, o ? o.type : null);
        B1.setExtraStackFrame(f);
      } else
        B1.setExtraStackFrame(null);
    }
    function Ko(i, o, f, g, _) {
      {
        var R = Function.call.bind(Object.prototype.hasOwnProperty);
        for (var N in i)
          if (R(i, N)) {
            var z = void 0;
            try {
              if (typeof i[N] != "function") {
                var W = Error((g || "React class") + ": " + f + " type `" + N + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[N] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw W.name = "Invariant Violation", W;
              }
              z = i[N](o, N, g, f, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ne) {
              z = ne;
            }
            z && !(z instanceof Error) && (mh(_), l("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", f, N, typeof z), mh(null)), z instanceof Error && !(z.message in L1) && (L1[z.message] = !0, mh(_), l("Failed %s type: %s", f, z.message), mh(null));
          }
      }
    }
    var o0 = [], sm;
    sm = [];
    var $l = -1;
    function $c(i) {
      return {
        current: i
      };
    }
    function fa(i, o) {
      if ($l < 0) {
        l("Unexpected pop.");
        return;
      }
      o !== sm[$l] && l("Unexpected Fiber popped."), i.current = o0[$l], o0[$l] = null, sm[$l] = null, $l--;
    }
    function da(i, o, f) {
      $l++, o0[$l] = i.current, sm[$l] = f, i.current = o;
    }
    var s0;
    s0 = {};
    var _o = {};
    Object.freeze(_o);
    var Ul = $c(_o), zu = $c(!1), u0 = _o;
    function Cp(i, o, f) {
      return f && Fu(o) ? u0 : Ul.current;
    }
    function z1(i, o, f) {
      {
        var g = i.stateNode;
        g.__reactInternalMemoizedUnmaskedChildContext = o, g.__reactInternalMemoizedMaskedChildContext = f;
      }
    }
    function Rp(i, o) {
      {
        var f = i.type, g = f.contextTypes;
        if (!g)
          return _o;
        var _ = i.stateNode;
        if (_ && _.__reactInternalMemoizedUnmaskedChildContext === o)
          return _.__reactInternalMemoizedMaskedChildContext;
        var R = {};
        for (var N in g)
          R[N] = o[N];
        {
          var z = dt(f) || "Unknown";
          Ko(g, R, "context", z);
        }
        return _ && z1(i, o, R), R;
      }
    }
    function um() {
      return zu.current;
    }
    function Fu(i) {
      {
        var o = i.childContextTypes;
        return o != null;
      }
    }
    function lm(i) {
      fa(zu, i), fa(Ul, i);
    }
    function l0(i) {
      fa(zu, i), fa(Ul, i);
    }
    function F1(i, o, f) {
      {
        if (Ul.current !== _o)
          throw Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
        da(Ul, o, i), da(zu, f, i);
      }
    }
    function $1(i, o, f) {
      {
        var g = i.stateNode, _ = o.childContextTypes;
        if (typeof g.getChildContext != "function") {
          {
            var R = dt(o) || "Unknown";
            s0[R] || (s0[R] = !0, l("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", R, R));
          }
          return f;
        }
        var N = g.getChildContext();
        for (var z in N)
          if (!(z in _))
            throw Error((dt(o) || "Unknown") + '.getChildContext(): key "' + z + '" is not defined in childContextTypes.');
        {
          var W = dt(o) || "Unknown";
          Ko(_, N, "child context", W);
        }
        return t({}, f, N);
      }
    }
    function cm(i) {
      {
        var o = i.stateNode, f = o && o.__reactInternalMemoizedMergedChildContext || _o;
        return u0 = Ul.current, da(Ul, f, i), da(zu, zu.current, i), !0;
      }
    }
    function U1(i, o, f) {
      {
        var g = i.stateNode;
        if (!g)
          throw Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
        if (f) {
          var _ = $1(i, o, u0);
          g.__reactInternalMemoizedMergedChildContext = _, fa(zu, i), fa(Ul, i), da(Ul, _, i), da(zu, f, i);
        } else
          fa(zu, i), da(zu, f, i);
      }
    }
    function dw(i) {
      {
        if (!(Hd(i) && i.tag === y))
          throw Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
        var o = i;
        do {
          switch (o.tag) {
            case E:
              return o.stateNode.context;
            case y: {
              var f = o.type;
              if (Fu(f))
                return o.stateNode.__reactInternalMemoizedMergedChildContext;
              break;
            }
          }
          o = o.return;
        } while (o !== null);
        throw Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
      }
    }
    var c0 = 0, V1 = 1, fm = 2, yh = null, $s = null, Tp = !1, pw = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u";
    function vw(i) {
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u")
        return !1;
      var o = __REACT_DEVTOOLS_GLOBAL_HOOK__;
      if (o.isDisabled)
        return !0;
      if (!o.supportsFiber)
        return l("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://reactjs.org/link/react-devtools"), !0;
      try {
        yh = o.inject(i), $s = o;
      } catch (f) {
        l("React instrumentation encountered an error: %s.", f);
      }
      return !0;
    }
    function f0(i, o) {
      if ($s && typeof $s.onScheduleFiberRoot == "function")
        try {
          $s.onScheduleFiberRoot(yh, i, o);
        } catch (f) {
          Tp || (Tp = !0, l("React instrumentation encountered an error: %s", f));
        }
    }
    function hw(i, o) {
      if ($s && typeof $s.onCommitFiberRoot == "function")
        try {
          var f = (i.current.flags & G) === G;
          _e && $s.onCommitFiberRoot(yh, i, o, f);
        } catch (g) {
          Tp || (Tp = !0, l("React instrumentation encountered an error: %s", g));
        }
    }
    function gw(i) {
      if ($s && typeof $s.onCommitFiberUnmount == "function")
        try {
          $s.onCommitFiberUnmount(yh, i);
        } catch (o) {
          Tp || (Tp = !0, l("React instrumentation encountered an error: %s", o));
        }
    }
    var mw = n.unstable_runWithPriority, pa = n.unstable_scheduleCallback, dm = n.unstable_cancelCallback, yw = n.unstable_shouldYield, j1 = n.unstable_requestPaint, d0 = n.unstable_now, bw = n.unstable_getCurrentPriorityLevel, Op = n.unstable_ImmediatePriority, W1 = n.unstable_UserBlockingPriority, pm = n.unstable_NormalPriority, G1 = n.unstable_LowPriority, H1 = n.unstable_IdlePriority;
    if (!(r.__interactionsRef != null && r.__interactionsRef.current != null))
      throw Error("It is not supported to run the profiling version of a renderer (for example, `react-dom/profiling`) without also replacing the `scheduler/tracing` module with `scheduler/tracing-profiling`. Your bundler might have a setting for aliasing both modules. Learn more at https://reactjs.org/link/profiling");
    var Y1 = {}, Qo = 99, Uc = 98, Vl = 97, q1 = 96, X1 = 95, bh = 90, p0 = yw, _w = j1 !== void 0 ? j1 : function() {
    }, jl = null, vm = null, v0 = !1, K1 = d0(), va = K1 < 1e4 ? d0 : function() {
      return d0() - K1;
    };
    function Dp() {
      switch (bw()) {
        case Op:
          return Qo;
        case W1:
          return Uc;
        case pm:
          return Vl;
        case G1:
          return q1;
        case H1:
          return X1;
        default:
          throw Error("Unknown priority level.");
      }
    }
    function Q1(i) {
      switch (i) {
        case Qo:
          return Op;
        case Uc:
          return W1;
        case Vl:
          return pm;
        case q1:
          return G1;
        case X1:
          return H1;
        default:
          throw Error("Unknown priority level.");
      }
    }
    function ad(i, o) {
      var f = Q1(i);
      return mw(f, o);
    }
    function Vc(i, o, f) {
      var g = Q1(i);
      return pa(g, o, f);
    }
    function Ew(i) {
      return jl === null ? (jl = [i], vm = pa(Op, J1)) : jl.push(i), Y1;
    }
    function Z1(i) {
      i !== Y1 && dm(i);
    }
    function $u() {
      if (vm !== null) {
        var i = vm;
        vm = null, dm(i);
      }
      J1();
    }
    function J1() {
      if (!v0 && jl !== null) {
        v0 = !0;
        var i = 0;
        try {
          var o = !0, f = jl;
          ad(Qo, function() {
            for (; i < f.length; i++) {
              var g = f[i];
              do
                g = g(o);
              while (g !== null);
            }
          }), jl = null;
        } catch (g) {
          throw jl !== null && (jl = jl.slice(i + 1)), pa(Op, $u), g;
        } finally {
          v0 = !1;
        }
      }
    }
    var e_ = "17.0.2", Pr = 0, Hr = 1, to = 2, od = 4, Eo = 8, xw = 16, c = a.ReactCurrentBatchConfig, v = 0;
    function S() {
      return c.transition;
    }
    var P = {
      recordUnsafeLifecycleWarnings: function(i, o) {
      },
      flushPendingUnsafeLifecycleWarnings: function() {
      },
      recordLegacyContextWarning: function(i, o) {
      },
      flushLegacyContextWarning: function() {
      },
      discardPendingWarnings: function() {
      }
    };
    {
      var j = function(i) {
        for (var o = null, f = i; f !== null; )
          f.mode & Hr && (o = f), f = f.return;
        return o;
      }, q = function(i) {
        var o = [];
        return i.forEach(function(f) {
          o.push(f);
        }), o.sort().join(", ");
      }, ue = [], ge = [], Re = [], Ve = [], je = [], Xe = [], ut = /* @__PURE__ */ new Set();
      P.recordUnsafeLifecycleWarnings = function(i, o) {
        ut.has(i.type) || (typeof o.componentWillMount == "function" && o.componentWillMount.__suppressDeprecationWarning !== !0 && ue.push(i), i.mode & Hr && typeof o.UNSAFE_componentWillMount == "function" && ge.push(i), typeof o.componentWillReceiveProps == "function" && o.componentWillReceiveProps.__suppressDeprecationWarning !== !0 && Re.push(i), i.mode & Hr && typeof o.UNSAFE_componentWillReceiveProps == "function" && Ve.push(i), typeof o.componentWillUpdate == "function" && o.componentWillUpdate.__suppressDeprecationWarning !== !0 && je.push(i), i.mode & Hr && typeof o.UNSAFE_componentWillUpdate == "function" && Xe.push(i));
      }, P.flushPendingUnsafeLifecycleWarnings = function() {
        var i = /* @__PURE__ */ new Set();
        ue.length > 0 && (ue.forEach(function(ye) {
          i.add(dt(ye.type) || "Component"), ut.add(ye.type);
        }), ue = []);
        var o = /* @__PURE__ */ new Set();
        ge.length > 0 && (ge.forEach(function(ye) {
          o.add(dt(ye.type) || "Component"), ut.add(ye.type);
        }), ge = []);
        var f = /* @__PURE__ */ new Set();
        Re.length > 0 && (Re.forEach(function(ye) {
          f.add(dt(ye.type) || "Component"), ut.add(ye.type);
        }), Re = []);
        var g = /* @__PURE__ */ new Set();
        Ve.length > 0 && (Ve.forEach(function(ye) {
          g.add(dt(ye.type) || "Component"), ut.add(ye.type);
        }), Ve = []);
        var _ = /* @__PURE__ */ new Set();
        je.length > 0 && (je.forEach(function(ye) {
          _.add(dt(ye.type) || "Component"), ut.add(ye.type);
        }), je = []);
        var R = /* @__PURE__ */ new Set();
        if (Xe.length > 0 && (Xe.forEach(function(ye) {
          R.add(dt(ye.type) || "Component"), ut.add(ye.type);
        }), Xe = []), o.size > 0) {
          var N = q(o);
          l(`Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.

Please update the following components: %s`, N);
        }
        if (g.size > 0) {
          var z = q(g);
          l(`Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state

Please update the following components: %s`, z);
        }
        if (R.size > 0) {
          var W = q(R);
          l(`Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.

Please update the following components: %s`, W);
        }
        if (i.size > 0) {
          var ne = q(i);
          s(`componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.
* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, ne);
        }
        if (f.size > 0) {
          var ae = q(f);
          s(`componentWillReceiveProps has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state
* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, ae);
        }
        if (_.size > 0) {
          var Pe = q(_);
          s(`componentWillUpdate has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, Pe);
        }
      };
      var Ot = /* @__PURE__ */ new Map(), Vt = /* @__PURE__ */ new Set();
      P.recordLegacyContextWarning = function(i, o) {
        var f = j(i);
        if (f === null) {
          l("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");
          return;
        }
        if (!Vt.has(i.type)) {
          var g = Ot.get(f);
          (i.type.contextTypes != null || i.type.childContextTypes != null || o !== null && typeof o.getChildContext == "function") && (g === void 0 && (g = [], Ot.set(f, g)), g.push(i));
        }
      }, P.flushLegacyContextWarning = function() {
        Ot.forEach(function(i, o) {
          if (i.length !== 0) {
            var f = i[0], g = /* @__PURE__ */ new Set();
            i.forEach(function(R) {
              g.add(dt(R.type) || "Component"), Vt.add(R.type);
            });
            var _ = q(g);
            try {
              $r(f), l(`Legacy context API has been detected within a strict-mode tree.

The old API will be supported in all 16.x releases, but applications using it should migrate to the new version.

Please update the following components: %s

Learn more about this warning here: https://reactjs.org/link/legacy-context`, _);
            } finally {
              ji();
            }
          }
        });
      }, P.discardPendingWarnings = function() {
        ue = [], ge = [], Re = [], Ve = [], je = [], Xe = [], Ot = /* @__PURE__ */ new Map();
      };
    }
    function Xt(i, o) {
      if (i && i.defaultProps) {
        var f = t({}, o), g = i.defaultProps;
        for (var _ in g)
          f[_] === void 0 && (f[_] = g[_]);
        return f;
      }
      return o;
    }
    var Lt = 1073741823, wn = $c(null), Rn;
    Rn = {};
    var ha = null, ci = null, ga = null, Nr = !1;
    function no() {
      ha = null, ci = null, ga = null, Nr = !1;
    }
    function Uu() {
      Nr = !0;
    }
    function h0() {
      Nr = !1;
    }
    function cM(i, o) {
      var f = i.type._context;
      da(wn, f._currentValue, i), f._currentValue = o, f._currentRenderer !== void 0 && f._currentRenderer !== null && f._currentRenderer !== Rn && l("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), f._currentRenderer = Rn;
    }
    function Sw(i) {
      var o = wn.current;
      fa(wn, i);
      var f = i.type._context;
      f._currentValue = o;
    }
    function x3(i, o, f) {
      if (d(f, o))
        return 0;
      var g = typeof i._calculateChangedBits == "function" ? i._calculateChangedBits(f, o) : Lt;
      return (g & Lt) !== g && l("calculateChangedBits: Expected the return value to be a 31-bit integer. Instead received: %s", g), g | 0;
    }
    function fM(i, o) {
      for (var f = i; f !== null; ) {
        var g = f.alternate;
        if (!wi(f.childLanes, o))
          f.childLanes = Pn(f.childLanes, o), g !== null && (g.childLanes = Pn(g.childLanes, o));
        else if (g !== null && !wi(g.childLanes, o))
          g.childLanes = Pn(g.childLanes, o);
        else
          break;
        f = f.return;
      }
    }
    function S3(i, o, f, g) {
      var _ = i.child;
      for (_ !== null && (_.return = i); _ !== null; ) {
        var R = void 0, N = _.dependencies;
        if (N !== null) {
          R = _.child;
          for (var z = N.firstContext; z !== null; ) {
            if (z.context === o && (z.observedBits & f) !== 0) {
              if (_.tag === y) {
                var W = Mp(Cn, si(g));
                W.tag = t_, Ap(_, W);
              }
              _.lanes = Pn(_.lanes, g);
              var ne = _.alternate;
              ne !== null && (ne.lanes = Pn(ne.lanes, g)), fM(_.return, g), N.lanes = Pn(N.lanes, g);
              break;
            }
            z = z.next;
          }
        } else
          _.tag === B ? R = _.type === i.type ? null : _.child : R = _.child;
        if (R !== null)
          R.return = _;
        else
          for (R = _; R !== null; ) {
            if (R === i) {
              R = null;
              break;
            }
            var ae = R.sibling;
            if (ae !== null) {
              ae.return = R.return, R = ae;
              break;
            }
            R = R.return;
          }
        _ = R;
      }
    }
    function hm(i, o) {
      ha = i, ci = null, ga = null;
      var f = i.dependencies;
      if (f !== null) {
        var g = f.firstContext;
        g !== null && (Bn(f.lanes, o) && AC(), f.firstContext = null);
      }
    }
    function ki(i, o) {
      if (Nr && l("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()."), ga !== i) {
        if (!(o === !1 || o === 0)) {
          var f;
          typeof o != "number" || o === Lt ? (ga = i, f = Lt) : f = o;
          var g = {
            context: i,
            observedBits: f,
            next: null
          };
          if (ci === null) {
            if (ha === null)
              throw Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
            ci = g, ha.dependencies = {
              lanes: Ge,
              firstContext: g,
              responders: null
            };
          } else
            ci = ci.next = g;
        }
      }
      return i._currentValue;
    }
    var dM = 0, pM = 1, t_ = 2, ww = 3, n_ = !1, Cw, r_;
    Cw = !1, r_ = null;
    function Rw(i) {
      var o = {
        baseState: i.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
          pending: null
        },
        effects: null
      };
      i.updateQueue = o;
    }
    function vM(i, o) {
      var f = o.updateQueue, g = i.updateQueue;
      if (f === g) {
        var _ = {
          baseState: g.baseState,
          firstBaseUpdate: g.firstBaseUpdate,
          lastBaseUpdate: g.lastBaseUpdate,
          shared: g.shared,
          effects: g.effects
        };
        o.updateQueue = _;
      }
    }
    function Mp(i, o) {
      var f = {
        eventTime: i,
        lane: o,
        tag: dM,
        payload: null,
        callback: null,
        next: null
      };
      return f;
    }
    function Ap(i, o) {
      var f = i.updateQueue;
      if (f !== null) {
        var g = f.shared, _ = g.pending;
        _ === null ? o.next = o : (o.next = _.next, _.next = o), g.pending = o, r_ === g && !Cw && (l("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback."), Cw = !0);
      }
    }
    function hM(i, o) {
      var f = i.updateQueue, g = i.alternate;
      if (g !== null) {
        var _ = g.updateQueue;
        if (f === _) {
          var R = null, N = null, z = f.firstBaseUpdate;
          if (z !== null) {
            var W = z;
            do {
              var ne = {
                eventTime: W.eventTime,
                lane: W.lane,
                tag: W.tag,
                payload: W.payload,
                callback: W.callback,
                next: null
              };
              N === null ? R = N = ne : (N.next = ne, N = ne), W = W.next;
            } while (W !== null);
            N === null ? R = N = o : (N.next = o, N = o);
          } else
            R = N = o;
          f = {
            baseState: _.baseState,
            firstBaseUpdate: R,
            lastBaseUpdate: N,
            shared: _.shared,
            effects: _.effects
          }, i.updateQueue = f;
          return;
        }
      }
      var ae = f.lastBaseUpdate;
      ae === null ? f.firstBaseUpdate = o : ae.next = o, f.lastBaseUpdate = o;
    }
    function w3(i, o, f, g, _, R) {
      switch (f.tag) {
        case pM: {
          var N = f.payload;
          if (typeof N == "function") {
            Uu();
            var z = N.call(R, g, _);
            {
              if (i.mode & Hr) {
                Sa();
                try {
                  N.call(R, g, _);
                } finally {
                  Di();
                }
              }
              h0();
            }
            return z;
          }
          return N;
        }
        case ww:
          i.flags = i.flags & ~po | G;
        case dM: {
          var W = f.payload, ne;
          if (typeof W == "function") {
            Uu(), ne = W.call(R, g, _);
            {
              if (i.mode & Hr) {
                Sa();
                try {
                  W.call(R, g, _);
                } finally {
                  Di();
                }
              }
              h0();
            }
          } else
            ne = W;
          return ne == null ? g : t({}, g, ne);
        }
        case t_:
          return n_ = !0, g;
      }
      return g;
    }
    function g0(i, o, f, g) {
      var _ = i.updateQueue;
      n_ = !1, r_ = _.shared;
      var R = _.firstBaseUpdate, N = _.lastBaseUpdate, z = _.shared.pending;
      if (z !== null) {
        _.shared.pending = null;
        var W = z, ne = W.next;
        W.next = null, N === null ? R = ne : N.next = ne, N = W;
        var ae = i.alternate;
        if (ae !== null) {
          var Pe = ae.updateQueue, ye = Pe.lastBaseUpdate;
          ye !== N && (ye === null ? Pe.firstBaseUpdate = ne : ye.next = ne, Pe.lastBaseUpdate = W);
        }
      }
      if (R !== null) {
        var Ie = _.baseState, Ke = Ge, lt = null, Ft = null, vn = null, Jt = R;
        do {
          var zn = Jt.lane, hr = Jt.eventTime;
          if (wi(g, zn)) {
            if (vn !== null) {
              var Ue = {
                eventTime: hr,
                lane: Or,
                tag: Jt.tag,
                payload: Jt.payload,
                callback: Jt.callback,
                next: null
              };
              vn = vn.next = Ue;
            }
            Ie = w3(i, _, Jt, Ie, o, f);
            var De = Jt.callback;
            if (De !== null) {
              i.flags |= xs;
              var rt = _.effects;
              rt === null ? _.effects = [Jt] : rt.push(Jt);
            }
          } else {
            var ke = {
              eventTime: hr,
              lane: zn,
              tag: Jt.tag,
              payload: Jt.payload,
              callback: Jt.callback,
              next: null
            };
            vn === null ? (Ft = vn = ke, lt = Ie) : vn = vn.next = ke, Ke = Pn(Ke, zn);
          }
          if (Jt = Jt.next, Jt === null) {
            if (z = _.shared.pending, z === null)
              break;
            var ht = z, Rt = ht.next;
            ht.next = null, Jt = Rt, _.lastBaseUpdate = ht, _.shared.pending = null;
          }
        } while (!0);
        vn === null && (lt = Ie), _.baseState = lt, _.firstBaseUpdate = Ft, _.lastBaseUpdate = vn, nR(Ke), i.lanes = Ke, i.memoizedState = Ie;
      }
      r_ = null;
    }
    function C3(i, o) {
      if (typeof i != "function")
        throw Error("Invalid argument passed as callback. Expected a function. Instead received: " + i);
      i.call(o);
    }
    function gM() {
      n_ = !1;
    }
    function i_() {
      return n_;
    }
    function mM(i, o, f) {
      var g = o.effects;
      if (o.effects = null, g !== null)
        for (var _ = 0; _ < g.length; _++) {
          var R = g[_], N = R.callback;
          N !== null && (R.callback = null, C3(N, f));
        }
    }
    var Tw = {}, R3 = Array.isArray, yM = new e.Component().refs, Ow, Dw, Mw, Aw, Pw, bM, a_, Nw, kw, Iw;
    {
      Ow = /* @__PURE__ */ new Set(), Dw = /* @__PURE__ */ new Set(), Mw = /* @__PURE__ */ new Set(), Aw = /* @__PURE__ */ new Set(), Nw = /* @__PURE__ */ new Set(), Pw = /* @__PURE__ */ new Set(), kw = /* @__PURE__ */ new Set(), Iw = /* @__PURE__ */ new Set();
      var _M = /* @__PURE__ */ new Set();
      a_ = function(i, o) {
        if (!(i === null || typeof i == "function")) {
          var f = o + "_" + i;
          _M.has(f) || (_M.add(f), l("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", o, i));
        }
      }, bM = function(i, o) {
        if (o === void 0) {
          var f = dt(i) || "Component";
          Pw.has(f) || (Pw.add(f), l("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", f));
        }
      }, Object.defineProperty(Tw, "_processChildContext", {
        enumerable: !1,
        value: function() {
          throw Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
        }
      }), Object.freeze(Tw);
    }
    function o_(i, o, f, g) {
      var _ = i.memoizedState;
      if (i.mode & Hr) {
        Sa();
        try {
          f(g, _);
        } finally {
          Di();
        }
      }
      var R = f(g, _);
      bM(o, R);
      var N = R == null ? _ : t({}, _, R);
      if (i.memoizedState = N, i.lanes === Ge) {
        var z = i.updateQueue;
        z.baseState = N;
      }
    }
    var Lw = {
      isMounted: Dg,
      enqueueSetState: function(i, o, f) {
        var g = Ta(i), _ = Vs(), R = Ip(g), N = Mp(_, R);
        N.payload = o, f != null && (a_(f, "setState"), N.callback = f), Ap(g, N), io(g, R, _);
      },
      enqueueReplaceState: function(i, o, f) {
        var g = Ta(i), _ = Vs(), R = Ip(g), N = Mp(_, R);
        N.tag = pM, N.payload = o, f != null && (a_(f, "replaceState"), N.callback = f), Ap(g, N), io(g, R, _);
      },
      enqueueForceUpdate: function(i, o) {
        var f = Ta(i), g = Vs(), _ = Ip(f), R = Mp(g, _);
        R.tag = t_, o != null && (a_(o, "forceUpdate"), R.callback = o), Ap(f, R), io(f, _, g);
      }
    };
    function EM(i, o, f, g, _, R, N) {
      var z = i.stateNode;
      if (typeof z.shouldComponentUpdate == "function") {
        if (i.mode & Hr) {
          Sa();
          try {
            z.shouldComponentUpdate(g, R, N);
          } finally {
            Di();
          }
        }
        var W = z.shouldComponentUpdate(g, R, N);
        return W === void 0 && l("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", dt(o) || "Component"), W;
      }
      return o.prototype && o.prototype.isPureReactComponent ? !w(f, g) || !w(_, R) : !0;
    }
    function T3(i, o, f) {
      var g = i.stateNode;
      {
        var _ = dt(o) || "Component", R = g.render;
        R || (o.prototype && typeof o.prototype.render == "function" ? l("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", _) : l("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", _)), g.getInitialState && !g.getInitialState.isReactClassApproved && !g.state && l("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", _), g.getDefaultProps && !g.getDefaultProps.isReactClassApproved && l("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", _), g.propTypes && l("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", _), g.contextType && l("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", _), g.contextTypes && l("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", _), o.contextType && o.contextTypes && !kw.has(o) && (kw.add(o), l("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", _)), typeof g.componentShouldUpdate == "function" && l("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", _), o.prototype && o.prototype.isPureReactComponent && typeof g.shouldComponentUpdate < "u" && l("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", dt(o) || "A pure component"), typeof g.componentDidUnmount == "function" && l("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", _), typeof g.componentDidReceiveProps == "function" && l("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", _), typeof g.componentWillRecieveProps == "function" && l("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", _), typeof g.UNSAFE_componentWillRecieveProps == "function" && l("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", _);
        var N = g.props !== f;
        g.props !== void 0 && N && l("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", _, _), g.defaultProps && l("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", _, _), typeof g.getSnapshotBeforeUpdate == "function" && typeof g.componentDidUpdate != "function" && !Mw.has(o) && (Mw.add(o), l("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", dt(o))), typeof g.getDerivedStateFromProps == "function" && l("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", _), typeof g.getDerivedStateFromError == "function" && l("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", _), typeof o.getSnapshotBeforeUpdate == "function" && l("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", _);
        var z = g.state;
        z && (typeof z != "object" || R3(z)) && l("%s.state: must be set to an object or null", _), typeof g.getChildContext == "function" && typeof o.childContextTypes != "object" && l("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", _);
      }
    }
    function xM(i, o) {
      o.updater = Lw, i.stateNode = o, pu(o, i), o._reactInternalInstance = Tw;
    }
    function SM(i, o, f) {
      var g = !1, _ = _o, R = _o, N = o.contextType;
      if ("contextType" in o) {
        var z = N === null || N !== void 0 && N.$$typeof === Ua && N._context === void 0;
        if (!z && !Iw.has(o)) {
          Iw.add(o);
          var W = "";
          N === void 0 ? W = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof N != "object" ? W = " However, it is set to a " + typeof N + "." : N.$$typeof === so ? W = " Did you accidentally pass the Context.Provider instead?" : N._context !== void 0 ? W = " Did you accidentally pass the Context.Consumer instead?" : W = " However, it is set to an object with keys {" + Object.keys(N).join(", ") + "}.", l("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", dt(o) || "Component", W);
        }
      }
      if (typeof N == "object" && N !== null)
        R = ki(N);
      else {
        _ = Cp(i, o, !0);
        var ne = o.contextTypes;
        g = ne != null, R = g ? Rp(i, _) : _o;
      }
      if (i.mode & Hr) {
        Sa();
        try {
          new o(f, R);
        } finally {
          Di();
        }
      }
      var ae = new o(f, R), Pe = i.memoizedState = ae.state !== null && ae.state !== void 0 ? ae.state : null;
      xM(i, ae);
      {
        if (typeof o.getDerivedStateFromProps == "function" && Pe === null) {
          var ye = dt(o) || "Component";
          Dw.has(ye) || (Dw.add(ye), l("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", ye, ae.state === null ? "null" : "undefined", ye));
        }
        if (typeof o.getDerivedStateFromProps == "function" || typeof ae.getSnapshotBeforeUpdate == "function") {
          var Ie = null, Ke = null, lt = null;
          if (typeof ae.componentWillMount == "function" && ae.componentWillMount.__suppressDeprecationWarning !== !0 ? Ie = "componentWillMount" : typeof ae.UNSAFE_componentWillMount == "function" && (Ie = "UNSAFE_componentWillMount"), typeof ae.componentWillReceiveProps == "function" && ae.componentWillReceiveProps.__suppressDeprecationWarning !== !0 ? Ke = "componentWillReceiveProps" : typeof ae.UNSAFE_componentWillReceiveProps == "function" && (Ke = "UNSAFE_componentWillReceiveProps"), typeof ae.componentWillUpdate == "function" && ae.componentWillUpdate.__suppressDeprecationWarning !== !0 ? lt = "componentWillUpdate" : typeof ae.UNSAFE_componentWillUpdate == "function" && (lt = "UNSAFE_componentWillUpdate"), Ie !== null || Ke !== null || lt !== null) {
            var Ft = dt(o) || "Component", vn = typeof o.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
            Aw.has(Ft) || (Aw.add(Ft), l(`Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://reactjs.org/link/unsafe-component-lifecycles`, Ft, vn, Ie !== null ? `
  ` + Ie : "", Ke !== null ? `
  ` + Ke : "", lt !== null ? `
  ` + lt : ""));
          }
        }
      }
      return g && z1(i, _, R), ae;
    }
    function O3(i, o) {
      var f = o.state;
      typeof o.componentWillMount == "function" && o.componentWillMount(), typeof o.UNSAFE_componentWillMount == "function" && o.UNSAFE_componentWillMount(), f !== o.state && (l("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", dt(i.type) || "Component"), Lw.enqueueReplaceState(o, o.state, null));
    }
    function wM(i, o, f, g) {
      var _ = o.state;
      if (typeof o.componentWillReceiveProps == "function" && o.componentWillReceiveProps(f, g), typeof o.UNSAFE_componentWillReceiveProps == "function" && o.UNSAFE_componentWillReceiveProps(f, g), o.state !== _) {
        {
          var R = dt(i.type) || "Component";
          Ow.has(R) || (Ow.add(R), l("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", R));
        }
        Lw.enqueueReplaceState(o, o.state, null);
      }
    }
    function Bw(i, o, f, g) {
      T3(i, o, f);
      var _ = i.stateNode;
      _.props = f, _.state = i.memoizedState, _.refs = yM, Rw(i);
      var R = o.contextType;
      if (typeof R == "object" && R !== null)
        _.context = ki(R);
      else {
        var N = Cp(i, o, !0);
        _.context = Rp(i, N);
      }
      {
        if (_.state === f) {
          var z = dt(o) || "Component";
          Nw.has(z) || (Nw.add(z), l("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", z));
        }
        i.mode & Hr && P.recordLegacyContextWarning(i, _), P.recordUnsafeLifecycleWarnings(i, _);
      }
      g0(i, f, _, g), _.state = i.memoizedState;
      var W = o.getDerivedStateFromProps;
      typeof W == "function" && (o_(i, o, W, f), _.state = i.memoizedState), typeof o.getDerivedStateFromProps != "function" && typeof _.getSnapshotBeforeUpdate != "function" && (typeof _.UNSAFE_componentWillMount == "function" || typeof _.componentWillMount == "function") && (O3(i, _), g0(i, f, _, g), _.state = i.memoizedState), typeof _.componentDidMount == "function" && (i.flags |= Ht);
    }
    function D3(i, o, f, g) {
      var _ = i.stateNode, R = i.memoizedProps;
      _.props = R;
      var N = _.context, z = o.contextType, W = _o;
      if (typeof z == "object" && z !== null)
        W = ki(z);
      else {
        var ne = Cp(i, o, !0);
        W = Rp(i, ne);
      }
      var ae = o.getDerivedStateFromProps, Pe = typeof ae == "function" || typeof _.getSnapshotBeforeUpdate == "function";
      !Pe && (typeof _.UNSAFE_componentWillReceiveProps == "function" || typeof _.componentWillReceiveProps == "function") && (R !== f || N !== W) && wM(i, _, f, W), gM();
      var ye = i.memoizedState, Ie = _.state = ye;
      if (g0(i, f, _, g), Ie = i.memoizedState, R === f && ye === Ie && !um() && !i_())
        return typeof _.componentDidMount == "function" && (i.flags |= Ht), !1;
      typeof ae == "function" && (o_(i, o, ae, f), Ie = i.memoizedState);
      var Ke = i_() || EM(i, o, R, f, ye, Ie, W);
      return Ke ? (!Pe && (typeof _.UNSAFE_componentWillMount == "function" || typeof _.componentWillMount == "function") && (typeof _.componentWillMount == "function" && _.componentWillMount(), typeof _.UNSAFE_componentWillMount == "function" && _.UNSAFE_componentWillMount()), typeof _.componentDidMount == "function" && (i.flags |= Ht)) : (typeof _.componentDidMount == "function" && (i.flags |= Ht), i.memoizedProps = f, i.memoizedState = Ie), _.props = f, _.state = Ie, _.context = W, Ke;
    }
    function M3(i, o, f, g, _) {
      var R = o.stateNode;
      vM(i, o);
      var N = o.memoizedProps, z = o.type === o.elementType ? N : Xt(o.type, N);
      R.props = z;
      var W = o.pendingProps, ne = R.context, ae = f.contextType, Pe = _o;
      if (typeof ae == "object" && ae !== null)
        Pe = ki(ae);
      else {
        var ye = Cp(o, f, !0);
        Pe = Rp(o, ye);
      }
      var Ie = f.getDerivedStateFromProps, Ke = typeof Ie == "function" || typeof R.getSnapshotBeforeUpdate == "function";
      !Ke && (typeof R.UNSAFE_componentWillReceiveProps == "function" || typeof R.componentWillReceiveProps == "function") && (N !== W || ne !== Pe) && wM(o, R, g, Pe), gM();
      var lt = o.memoizedState, Ft = R.state = lt;
      if (g0(o, g, R, _), Ft = o.memoizedState, N === W && lt === Ft && !um() && !i_())
        return typeof R.componentDidUpdate == "function" && (N !== i.memoizedProps || lt !== i.memoizedState) && (o.flags |= Ht), typeof R.getSnapshotBeforeUpdate == "function" && (N !== i.memoizedProps || lt !== i.memoizedState) && (o.flags |= Oa), !1;
      typeof Ie == "function" && (o_(o, f, Ie, g), Ft = o.memoizedState);
      var vn = i_() || EM(o, f, z, g, lt, Ft, Pe);
      return vn ? (!Ke && (typeof R.UNSAFE_componentWillUpdate == "function" || typeof R.componentWillUpdate == "function") && (typeof R.componentWillUpdate == "function" && R.componentWillUpdate(g, Ft, Pe), typeof R.UNSAFE_componentWillUpdate == "function" && R.UNSAFE_componentWillUpdate(g, Ft, Pe)), typeof R.componentDidUpdate == "function" && (o.flags |= Ht), typeof R.getSnapshotBeforeUpdate == "function" && (o.flags |= Oa)) : (typeof R.componentDidUpdate == "function" && (N !== i.memoizedProps || lt !== i.memoizedState) && (o.flags |= Ht), typeof R.getSnapshotBeforeUpdate == "function" && (N !== i.memoizedProps || lt !== i.memoizedState) && (o.flags |= Oa), o.memoizedProps = g, o.memoizedState = Ft), R.props = g, R.state = Ft, R.context = Pe, vn;
    }
    var zw, Fw, $w, Uw, Vw, CM = function(i, o) {
    };
    zw = !1, Fw = !1, $w = {}, Uw = {}, Vw = {}, CM = function(i, o) {
      if (!(i === null || typeof i != "object") && !(!i._store || i._store.validated || i.key != null)) {
        if (typeof i._store != "object")
          throw Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
        i._store.validated = !0;
        var f = dt(o.type) || "Component";
        Uw[f] || (Uw[f] = !0, l('Each child in a list should have a unique "key" prop. See https://reactjs.org/link/warning-keys for more information.'));
      }
    };
    var s_ = Array.isArray;
    function m0(i, o, f) {
      var g = f.ref;
      if (g !== null && typeof g != "function" && typeof g != "object") {
        if ((i.mode & Hr || re) && !(f._owner && f._self && f._owner.stateNode !== f._self)) {
          var _ = dt(i.type) || "Component";
          $w[_] || (l('A string ref, "%s", has been found within a strict mode tree. String refs are a source of potential bugs and should be avoided. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', g), $w[_] = !0);
        }
        if (f._owner) {
          var R = f._owner, N;
          if (R) {
            var z = R;
            if (z.tag !== y)
              throw Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref");
            N = z.stateNode;
          }
          if (!N)
            throw Error("Missing owner for string ref " + g + ". This error is likely caused by a bug in React. Please file an issue.");
          var W = "" + g;
          if (o !== null && o.ref !== null && typeof o.ref == "function" && o.ref._stringRef === W)
            return o.ref;
          var ne = function(ae) {
            var Pe = N.refs;
            Pe === yM && (Pe = N.refs = {}), ae === null ? delete Pe[W] : Pe[W] = ae;
          };
          return ne._stringRef = W, ne;
        } else {
          if (typeof g != "string")
            throw Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");
          if (!f._owner)
            throw Error("Element ref was specified as a string (" + g + `) but no owner was set. This could happen for one of the following reasons:
1. You may be adding a ref to a function component
2. You may be adding a ref to a component that was not created inside a component's render method
3. You have multiple copies of React loaded
See https://reactjs.org/link/refs-must-have-owner for more information.`);
        }
      }
      return g;
    }
    function u_(i, o) {
      if (i.type !== "textarea")
        throw Error("Objects are not valid as a React child (found: " + (Object.prototype.toString.call(o) === "[object Object]" ? "object with keys {" + Object.keys(o).join(", ") + "}" : o) + "). If you meant to render a collection of children, use an array instead.");
    }
    function l_(i) {
      {
        var o = dt(i.type) || "Component";
        if (Vw[o])
          return;
        Vw[o] = !0, l("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
      }
    }
    function RM(i) {
      function o(ke, Ue) {
        if (!!i) {
          var De = ke.lastEffect;
          De !== null ? (De.nextEffect = Ue, ke.lastEffect = Ue) : ke.firstEffect = ke.lastEffect = Ue, Ue.nextEffect = null, Ue.flags = er;
        }
      }
      function f(ke, Ue) {
        if (!i)
          return null;
        for (var De = Ue; De !== null; )
          o(ke, De), De = De.sibling;
        return null;
      }
      function g(ke, Ue) {
        for (var De = /* @__PURE__ */ new Map(), rt = Ue; rt !== null; )
          rt.key !== null ? De.set(rt.key, rt) : De.set(rt.index, rt), rt = rt.sibling;
        return De;
      }
      function _(ke, Ue) {
        var De = Mh(ke, Ue);
        return De.index = 0, De.sibling = null, De;
      }
      function R(ke, Ue, De) {
        if (ke.index = De, !i)
          return Ue;
        var rt = ke.alternate;
        if (rt !== null) {
          var ht = rt.index;
          return ht < Ue ? (ke.flags = nn, Ue) : ht;
        } else
          return ke.flags = nn, Ue;
      }
      function N(ke) {
        return i && ke.alternate === null && (ke.flags = nn), ke;
      }
      function z(ke, Ue, De, rt) {
        if (Ue === null || Ue.tag !== T) {
          var ht = gR(De, ke.mode, rt);
          return ht.return = ke, ht;
        } else {
          var Rt = _(Ue, De);
          return Rt.return = ke, Rt;
        }
      }
      function W(ke, Ue, De, rt) {
        if (Ue !== null && (Ue.elementType === De.type || oP(Ue, De))) {
          var ht = _(Ue, De.props);
          return ht.ref = m0(ke, Ue, De), ht.return = ke, ht._debugSource = De._source, ht._debugOwner = De._owner, ht;
        }
        var Rt = vR(De, ke.mode, rt);
        return Rt.ref = m0(ke, Ue, De), Rt.return = ke, Rt;
      }
      function ne(ke, Ue, De, rt) {
        if (Ue === null || Ue.tag !== x || Ue.stateNode.containerInfo !== De.containerInfo || Ue.stateNode.implementation !== De.implementation) {
          var ht = mR(De, ke.mode, rt);
          return ht.return = ke, ht;
        } else {
          var Rt = _(Ue, De.children || []);
          return Rt.return = ke, Rt;
        }
      }
      function ae(ke, Ue, De, rt, ht) {
        if (Ue === null || Ue.tag !== O) {
          var Rt = Ah(De, ke.mode, rt, ht);
          return Rt.return = ke, Rt;
        } else {
          var An = _(Ue, De);
          return An.return = ke, An;
        }
      }
      function Pe(ke, Ue, De) {
        if (typeof Ue == "string" || typeof Ue == "number") {
          var rt = gR("" + Ue, ke.mode, De);
          return rt.return = ke, rt;
        }
        if (typeof Ue == "object" && Ue !== null) {
          switch (Ue.$$typeof) {
            case Cr: {
              var ht = vR(Ue, ke.mode, De);
              return ht.ref = m0(ke, null, Ue), ht.return = ke, ht;
            }
            case Nt: {
              var Rt = mR(Ue, ke.mode, De);
              return Rt.return = ke, Rt;
            }
          }
          if (s_(Ue) || Kn(Ue)) {
            var An = Ah(Ue, ke.mode, De, null);
            return An.return = ke, An;
          }
          u_(ke, Ue);
        }
        return typeof Ue == "function" && l_(ke), null;
      }
      function ye(ke, Ue, De, rt) {
        var ht = Ue !== null ? Ue.key : null;
        if (typeof De == "string" || typeof De == "number")
          return ht !== null ? null : z(ke, Ue, "" + De, rt);
        if (typeof De == "object" && De !== null) {
          switch (De.$$typeof) {
            case Cr:
              return De.key === ht ? De.type === jn ? ae(ke, Ue, De.props.children, rt, ht) : W(ke, Ue, De, rt) : null;
            case Nt:
              return De.key === ht ? ne(ke, Ue, De, rt) : null;
          }
          if (s_(De) || Kn(De))
            return ht !== null ? null : ae(ke, Ue, De, rt, null);
          u_(ke, De);
        }
        return typeof De == "function" && l_(ke), null;
      }
      function Ie(ke, Ue, De, rt, ht) {
        if (typeof rt == "string" || typeof rt == "number") {
          var Rt = ke.get(De) || null;
          return z(Ue, Rt, "" + rt, ht);
        }
        if (typeof rt == "object" && rt !== null) {
          switch (rt.$$typeof) {
            case Cr: {
              var An = ke.get(rt.key === null ? De : rt.key) || null;
              return rt.type === jn ? ae(Ue, An, rt.props.children, ht, rt.key) : W(Ue, An, rt, ht);
            }
            case Nt: {
              var kr = ke.get(rt.key === null ? De : rt.key) || null;
              return ne(Ue, kr, rt, ht);
            }
          }
          if (s_(rt) || Kn(rt)) {
            var Yr = ke.get(De) || null;
            return ae(Ue, Yr, rt, ht, null);
          }
          u_(Ue, rt);
        }
        return typeof rt == "function" && l_(Ue), null;
      }
      function Ke(ke, Ue, De) {
        {
          if (typeof ke != "object" || ke === null)
            return Ue;
          switch (ke.$$typeof) {
            case Cr:
            case Nt:
              CM(ke, De);
              var rt = ke.key;
              if (typeof rt != "string")
                break;
              if (Ue === null) {
                Ue = /* @__PURE__ */ new Set(), Ue.add(rt);
                break;
              }
              if (!Ue.has(rt)) {
                Ue.add(rt);
                break;
              }
              l("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted \u2014 the behavior is unsupported and could change in a future version.", rt);
              break;
          }
        }
        return Ue;
      }
      function lt(ke, Ue, De, rt) {
        for (var ht = null, Rt = 0; Rt < De.length; Rt++) {
          var An = De[Rt];
          ht = Ke(An, ht, ke);
        }
        for (var kr = null, Yr = null, ir = Ue, Ii = 0, qn = 0, qr = null; ir !== null && qn < De.length; qn++) {
          ir.index > qn ? (qr = ir, ir = null) : qr = ir.sibling;
          var ya = ye(ke, ir, De[qn], rt);
          if (ya === null) {
            ir === null && (ir = qr);
            break;
          }
          i && ir && ya.alternate === null && o(ke, ir), Ii = R(ya, Ii, qn), Yr === null ? kr = ya : Yr.sibling = ya, Yr = ya, ir = qr;
        }
        if (qn === De.length)
          return f(ke, ir), kr;
        if (ir === null) {
          for (; qn < De.length; qn++) {
            var Ri = Pe(ke, De[qn], rt);
            Ri !== null && (Ii = R(Ri, Ii, qn), Yr === null ? kr = Ri : Yr.sibling = Ri, Yr = Ri);
          }
          return kr;
        }
        for (var qc = g(ke, ir); qn < De.length; qn++) {
          var Ti = Ie(qc, ke, qn, De[qn], rt);
          Ti !== null && (i && Ti.alternate !== null && qc.delete(Ti.key === null ? qn : Ti.key), Ii = R(Ti, Ii, qn), Yr === null ? kr = Ti : Yr.sibling = Ti, Yr = Ti);
        }
        return i && qc.forEach(function(Xc) {
          return o(ke, Xc);
        }), kr;
      }
      function Ft(ke, Ue, De, rt) {
        var ht = Kn(De);
        if (typeof ht != "function")
          throw Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
        {
          typeof Symbol == "function" && De[Symbol.toStringTag] === "Generator" && (Fw || l("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers."), Fw = !0), De.entries === ht && (zw || l("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), zw = !0);
          var Rt = ht.call(De);
          if (Rt)
            for (var An = null, kr = Rt.next(); !kr.done; kr = Rt.next()) {
              var Yr = kr.value;
              An = Ke(Yr, An, ke);
            }
        }
        var ir = ht.call(De);
        if (ir == null)
          throw Error("An iterable object provided no iterator.");
        for (var Ii = null, qn = null, qr = Ue, ya = 0, Ri = 0, qc = null, Ti = ir.next(); qr !== null && !Ti.done; Ri++, Ti = ir.next()) {
          qr.index > Ri ? (qc = qr, qr = null) : qc = qr.sibling;
          var Xc = ye(ke, qr, Ti.value, rt);
          if (Xc === null) {
            qr === null && (qr = qc);
            break;
          }
          i && qr && Xc.alternate === null && o(ke, qr), ya = R(Xc, ya, Ri), qn === null ? Ii = Xc : qn.sibling = Xc, qn = Xc, qr = qc;
        }
        if (Ti.done)
          return f(ke, qr), Ii;
        if (qr === null) {
          for (; !Ti.done; Ri++, Ti = ir.next()) {
            var Ph = Pe(ke, Ti.value, rt);
            Ph !== null && (ya = R(Ph, ya, Ri), qn === null ? Ii = Ph : qn.sibling = Ph, qn = Ph);
          }
          return Ii;
        }
        for (var wR = g(ke, qr); !Ti.done; Ri++, Ti = ir.next()) {
          var zp = Ie(wR, ke, Ri, Ti.value, rt);
          zp !== null && (i && zp.alternate !== null && wR.delete(zp.key === null ? Ri : zp.key), ya = R(zp, ya, Ri), qn === null ? Ii = zp : qn.sibling = zp, qn = zp);
        }
        return i && wR.forEach(function(DU) {
          return o(ke, DU);
        }), Ii;
      }
      function vn(ke, Ue, De, rt) {
        if (Ue !== null && Ue.tag === T) {
          f(ke, Ue.sibling);
          var ht = _(Ue, De);
          return ht.return = ke, ht;
        }
        f(ke, Ue);
        var Rt = gR(De, ke.mode, rt);
        return Rt.return = ke, Rt;
      }
      function Jt(ke, Ue, De, rt) {
        for (var ht = De.key, Rt = Ue; Rt !== null; ) {
          if (Rt.key === ht) {
            switch (Rt.tag) {
              case O: {
                if (De.type === jn) {
                  f(ke, Rt.sibling);
                  var An = _(Rt, De.props.children);
                  return An.return = ke, An._debugSource = De._source, An._debugOwner = De._owner, An;
                }
                break;
              }
              case se:
              default: {
                if (Rt.elementType === De.type || oP(Rt, De)) {
                  f(ke, Rt.sibling);
                  var kr = _(Rt, De.props);
                  return kr.ref = m0(ke, Rt, De), kr.return = ke, kr._debugSource = De._source, kr._debugOwner = De._owner, kr;
                }
                break;
              }
            }
            f(ke, Rt);
            break;
          } else
            o(ke, Rt);
          Rt = Rt.sibling;
        }
        if (De.type === jn) {
          var Yr = Ah(De.props.children, ke.mode, rt, De.key);
          return Yr.return = ke, Yr;
        } else {
          var ir = vR(De, ke.mode, rt);
          return ir.ref = m0(ke, Ue, De), ir.return = ke, ir;
        }
      }
      function zn(ke, Ue, De, rt) {
        for (var ht = De.key, Rt = Ue; Rt !== null; ) {
          if (Rt.key === ht)
            if (Rt.tag === x && Rt.stateNode.containerInfo === De.containerInfo && Rt.stateNode.implementation === De.implementation) {
              f(ke, Rt.sibling);
              var An = _(Rt, De.children || []);
              return An.return = ke, An;
            } else {
              f(ke, Rt);
              break;
            }
          else
            o(ke, Rt);
          Rt = Rt.sibling;
        }
        var kr = mR(De, ke.mode, rt);
        return kr.return = ke, kr;
      }
      function hr(ke, Ue, De, rt) {
        var ht = typeof De == "object" && De !== null && De.type === jn && De.key === null;
        ht && (De = De.props.children);
        var Rt = typeof De == "object" && De !== null;
        if (Rt)
          switch (De.$$typeof) {
            case Cr:
              return N(Jt(ke, Ue, De, rt));
            case Nt:
              return N(zn(ke, Ue, De, rt));
          }
        if (typeof De == "string" || typeof De == "number")
          return N(vn(ke, Ue, "" + De, rt));
        if (s_(De))
          return lt(ke, Ue, De, rt);
        if (Kn(De))
          return Ft(ke, Ue, De, rt);
        if (Rt && u_(ke, De), typeof De == "function" && l_(ke), typeof De > "u" && !ht)
          switch (ke.tag) {
            case y: {
              var An = ke.stateNode;
              if (An.render._isMockFunction)
                break;
            }
            case se:
            case h:
            case I:
            case U:
              throw Error((dt(ke.type) || "Component") + "(...): Nothing was returned from render. This usually means a return statement is missing. Or, to render nothing, return null.");
          }
        return f(ke, Ue);
      }
      return hr;
    }
    var c_ = RM(!0), TM = RM(!1);
    function A3(i, o) {
      if (!(i === null || o.child === i.child))
        throw Error("Resuming work not yet implemented.");
      if (o.child !== null) {
        var f = o.child, g = Mh(f, f.pendingProps);
        for (o.child = g, g.return = o; f.sibling !== null; )
          f = f.sibling, g = g.sibling = Mh(f, f.pendingProps), g.return = o;
        g.sibling = null;
      }
    }
    function P3(i, o) {
      for (var f = i.child; f !== null; )
        G$(f, o), f = f.sibling;
    }
    var y0 = {}, Pp = $c(y0), b0 = $c(y0), f_ = $c(y0);
    function d_(i) {
      if (i === y0)
        throw Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
      return i;
    }
    function OM() {
      var i = d_(f_.current);
      return i;
    }
    function jw(i, o) {
      da(f_, o, i), da(b0, i, i), da(Pp, y0, i);
      var f = zS(o);
      fa(Pp, i), da(Pp, f, i);
    }
    function gm(i) {
      fa(Pp, i), fa(b0, i), fa(f_, i);
    }
    function Ww() {
      var i = d_(Pp.current);
      return i;
    }
    function DM(i) {
      d_(f_.current);
      var o = d_(Pp.current), f = FS(o, i.type);
      o !== f && (da(b0, i, i), da(Pp, f, i));
    }
    function Gw(i) {
      b0.current === i && (fa(Pp, i), fa(b0, i));
    }
    var N3 = 0, MM = 1, Hw = 1, _0 = 2, Wl = $c(N3);
    function p_(i, o) {
      return (i & o) !== 0;
    }
    function E0(i) {
      return i & MM;
    }
    function Yw(i, o) {
      return i & MM | o;
    }
    function k3(i, o) {
      return i | o;
    }
    function _h(i, o) {
      da(Wl, o, i);
    }
    function mm(i) {
      fa(Wl, i);
    }
    function I3(i, o) {
      var f = i.memoizedState;
      if (f !== null)
        return f.dehydrated !== null;
      var g = i.memoizedProps;
      return g.fallback === void 0 ? !1 : g.unstable_avoidThisFallback !== !0 ? !0 : !o;
    }
    function v_(i) {
      for (var o = i; o !== null; ) {
        if (o.tag === k) {
          var f = o.memoizedState;
          if (f !== null) {
            var g = f.dehydrated;
            if (g === null || KS(g) || QS(g))
              return o;
          }
        } else if (o.tag === J && o.memoizedProps.revealOrder !== void 0) {
          var _ = (o.flags & G) !== Hn;
          if (_)
            return o;
        } else if (o.child !== null) {
          o.child.return = o, o = o.child;
          continue;
        }
        if (o === i)
          return null;
        for (; o.sibling === null; ) {
          if (o.return === null || o.return === i)
            return null;
          o = o.return;
        }
        o.sibling.return = o.return, o = o.sibling;
      }
      return null;
    }
    var qw = 0, ym = 1, bm = 2, x0 = 4, Vu = null, Eh = null, Np = !1;
    function L3(i) {
      var o = i.stateNode.containerInfo;
      return Eh = O1(o), Vu = i, Np = !0, !0;
    }
    function AM(i, o) {
      switch (i.tag) {
        case E:
          i0(i.stateNode.containerInfo, o);
          break;
        case C:
          iw(i.type, i.memoizedProps, i.stateNode, o);
          break;
      }
      var f = Q$();
      f.stateNode = o, f.return = i, f.flags = er, i.lastEffect !== null ? (i.lastEffect.nextEffect = f, i.lastEffect = f) : i.firstEffect = i.lastEffect = f;
    }
    function PM(i, o) {
      switch (o.flags = o.flags & ~Ya | nn, i.tag) {
        case E: {
          var f = i.stateNode.containerInfo;
          switch (o.tag) {
            case C:
              var g = o.type;
              o.pendingProps, aw(f, g);
              break;
            case T:
              var _ = o.pendingProps;
              ow(f, _);
              break;
          }
          break;
        }
        case C: {
          var R = i.type, N = i.memoizedProps, z = i.stateNode;
          switch (o.tag) {
            case C:
              var W = o.type;
              o.pendingProps, Ni(R, N, z, W);
              break;
            case T:
              var ne = o.pendingProps;
              eo(R, N, z, ne);
              break;
            case k:
              sw(R, N);
              break;
          }
          break;
        }
        default:
          return;
      }
    }
    function NM(i, o) {
      switch (i.tag) {
        case C: {
          var f = i.type;
          i.pendingProps;
          var g = qS(o, f);
          return g !== null ? (i.stateNode = g, !0) : !1;
        }
        case T: {
          var _ = i.pendingProps, R = XS(o, _);
          return R !== null ? (i.stateNode = R, !0) : !1;
        }
        case k:
          return !1;
        default:
          return !1;
      }
    }
    function Xw(i) {
      if (!!Np) {
        var o = Eh;
        if (!o) {
          PM(Vu, i), Np = !1, Vu = i;
          return;
        }
        var f = o;
        if (!NM(i, o)) {
          if (o = rm(f), !o || !NM(i, o)) {
            PM(Vu, i), Np = !1, Vu = i;
            return;
          }
          AM(Vu, f);
        }
        Vu = i, Eh = O1(o);
      }
    }
    function B3(i, o, f) {
      var g = i.stateNode, _ = ZS(g, i.type, i.memoizedProps, o, f, i);
      return i.updateQueue = _, _ !== null;
    }
    function z3(i) {
      var o = i.stateNode, f = i.memoizedProps, g = JS(o, f, i);
      if (g) {
        var _ = Vu;
        if (_ !== null)
          switch (_.tag) {
            case E: {
              var R = _.stateNode.containerInfo;
              r0(R, o, f);
              break;
            }
            case C: {
              var N = _.type, z = _.memoizedProps, W = _.stateNode;
              rw(N, z, W, o, f);
              break;
            }
          }
      }
      return g;
    }
    function F3(i) {
      var o = i.memoizedState, f = o !== null ? o.dehydrated : null;
      if (!f)
        throw Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
      return ew(f);
    }
    function kM(i) {
      for (var o = i.return; o !== null && o.tag !== C && o.tag !== E && o.tag !== k; )
        o = o.return;
      Vu = o;
    }
    function h_(i) {
      if (i !== Vu)
        return !1;
      if (!Np)
        return kM(i), Np = !0, !1;
      var o = i.type;
      if (i.tag !== C || o !== "head" && o !== "body" && !tm(o, i.memoizedProps))
        for (var f = Eh; f; )
          AM(i, f), f = rm(f);
      return kM(i), i.tag === k ? Eh = F3(i) : Eh = Vu ? rm(i.stateNode) : null, !0;
    }
    function Kw() {
      Vu = null, Eh = null, Np = !1;
    }
    function Qw() {
      return Np;
    }
    var S0 = [], Zw;
    Zw = {};
    function $3(i) {
      S0.push(i);
    }
    function Jw() {
      for (var i = 0; i < S0.length; i++) {
        var o = S0[i];
        o._workInProgressVersionPrimary = null;
      }
      S0.length = 0;
    }
    function U3(i) {
      return i._workInProgressVersionPrimary;
    }
    function IM(i, o) {
      i._workInProgressVersionPrimary = o, S0.push(i);
    }
    function V3(i) {
      i._currentPrimaryRenderer == null ? i._currentPrimaryRenderer = Zw : i._currentPrimaryRenderer !== Zw && l("Detected multiple renderers concurrently rendering the same mutable source. This is currently unsupported.");
    }
    var mt = a.ReactCurrentDispatcher, ju = a.ReactCurrentBatchConfig, eC, tC;
    tC = {}, eC = /* @__PURE__ */ new Set();
    var w0 = Ge, Sr = null, ro = null, ma = null, g_ = !1, C0 = !1, j3 = 25, et = null, Wu = null, kp = -1, nC = !1;
    function vr() {
      {
        var i = et;
        Wu === null ? Wu = [i] : Wu.push(i);
      }
    }
    function _t() {
      {
        var i = et;
        Wu !== null && (kp++, Wu[kp] !== i && W3(i));
      }
    }
    function R0(i) {
      i != null && !Array.isArray(i) && l("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", et, typeof i);
    }
    function W3(i) {
      {
        var o = dt(Sr.type);
        if (!eC.has(o) && (eC.add(o), Wu !== null)) {
          for (var f = "", g = 30, _ = 0; _ <= kp; _++) {
            for (var R = Wu[_], N = _ === kp ? i : R, z = _ + 1 + ". " + R; z.length < g; )
              z += " ";
            z += N + `
`, f += z;
          }
          l(`React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks

   Previous render            Next render
   ------------------------------------------------------
%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
`, o, f);
        }
      }
    }
    function Zo() {
      throw Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`);
    }
    function rC(i, o) {
      if (nC)
        return !1;
      if (o === null)
        return l("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", et), !1;
      i.length !== o.length && l(`The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`, et, "[" + o.join(", ") + "]", "[" + i.join(", ") + "]");
      for (var f = 0; f < o.length && f < i.length; f++)
        if (!d(i[f], o[f]))
          return !1;
      return !0;
    }
    function _m(i, o, f, g, _, R) {
      w0 = R, Sr = o, Wu = i !== null ? i._debugHookTypes : null, kp = -1, nC = i !== null && i.type !== o.type, o.memoizedState = null, o.updateQueue = null, o.lanes = Ge, i !== null && i.memoizedState !== null ? mt.current = KM : Wu !== null ? mt.current = XM : mt.current = qM;
      var N = f(g, _);
      if (C0) {
        var z = 0;
        do {
          if (C0 = !1, !(z < j3))
            throw Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
          z += 1, nC = !1, ro = null, ma = null, o.updateQueue = null, kp = -1, mt.current = QM, N = f(g, _);
        } while (C0);
      }
      mt.current = O_, o._debugHookTypes = Wu;
      var W = ro !== null && ro.next !== null;
      if (w0 = Ge, Sr = null, ro = null, ma = null, et = null, Wu = null, kp = -1, g_ = !1, W)
        throw Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
      return N;
    }
    function LM(i, o, f) {
      o.updateQueue = i.updateQueue, o.flags &= ~(xi | Ht), i.lanes = Ac(i.lanes, f);
    }
    function BM() {
      if (mt.current = O_, g_) {
        for (var i = Sr.memoizedState; i !== null; ) {
          var o = i.queue;
          o !== null && (o.pending = null), i = i.next;
        }
        g_ = !1;
      }
      w0 = Ge, Sr = null, ro = null, ma = null, Wu = null, kp = -1, et = null, T_ = !1, C0 = !1;
    }
    function xh() {
      var i = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
      };
      return ma === null ? Sr.memoizedState = ma = i : ma = ma.next = i, ma;
    }
    function Sh() {
      var i;
      if (ro === null) {
        var o = Sr.alternate;
        o !== null ? i = o.memoizedState : i = null;
      } else
        i = ro.next;
      var f;
      if (ma === null ? f = Sr.memoizedState : f = ma.next, f !== null)
        ma = f, f = ma.next, ro = i;
      else {
        if (i === null)
          throw Error("Rendered more hooks than during the previous render.");
        ro = i;
        var g = {
          memoizedState: ro.memoizedState,
          baseState: ro.baseState,
          baseQueue: ro.baseQueue,
          queue: ro.queue,
          next: null
        };
        ma === null ? Sr.memoizedState = ma = g : ma = ma.next = g;
      }
      return ma;
    }
    function G3() {
      return {
        lastEffect: null
      };
    }
    function m_(i, o) {
      return typeof o == "function" ? o(i) : o;
    }
    function iC(i, o, f) {
      var g = xh(), _;
      f !== void 0 ? _ = f(o) : _ = o, g.memoizedState = g.baseState = _;
      var R = g.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: i,
        lastRenderedState: _
      }, N = R.dispatch = mC.bind(null, Sr, R);
      return [g.memoizedState, N];
    }
    function aC(i, o, f) {
      var g = Sh(), _ = g.queue;
      if (_ === null)
        throw Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      _.lastRenderedReducer = i;
      var R = ro, N = R.baseQueue, z = _.pending;
      if (z !== null) {
        if (N !== null) {
          var W = N.next, ne = z.next;
          N.next = ne, z.next = W;
        }
        R.baseQueue !== N && l("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React."), R.baseQueue = N = z, _.pending = null;
      }
      if (N !== null) {
        var ae = N.next, Pe = R.baseState, ye = null, Ie = null, Ke = null, lt = ae;
        do {
          var Ft = lt.lane;
          if (wi(w0, Ft)) {
            if (Ke !== null) {
              var Jt = {
                lane: Or,
                action: lt.action,
                eagerReducer: lt.eagerReducer,
                eagerState: lt.eagerState,
                next: null
              };
              Ke = Ke.next = Jt;
            }
            if (lt.eagerReducer === i)
              Pe = lt.eagerState;
            else {
              var zn = lt.action;
              Pe = i(Pe, zn);
            }
          } else {
            var vn = {
              lane: Ft,
              action: lt.action,
              eagerReducer: lt.eagerReducer,
              eagerState: lt.eagerState,
              next: null
            };
            Ke === null ? (Ie = Ke = vn, ye = Pe) : Ke = Ke.next = vn, Sr.lanes = Pn(Sr.lanes, Ft), nR(Ft);
          }
          lt = lt.next;
        } while (lt !== null && lt !== ae);
        Ke === null ? ye = Pe : Ke.next = Ie, d(Pe, g.memoizedState) || AC(), g.memoizedState = Pe, g.baseState = ye, g.baseQueue = Ke, _.lastRenderedState = Pe;
      }
      var hr = _.dispatch;
      return [g.memoizedState, hr];
    }
    function oC(i, o, f) {
      var g = Sh(), _ = g.queue;
      if (_ === null)
        throw Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      _.lastRenderedReducer = i;
      var R = _.dispatch, N = _.pending, z = g.memoizedState;
      if (N !== null) {
        _.pending = null;
        var W = N.next, ne = W;
        do {
          var ae = ne.action;
          z = i(z, ae), ne = ne.next;
        } while (ne !== W);
        d(z, g.memoizedState) || AC(), g.memoizedState = z, g.baseQueue === null && (g.baseState = z), _.lastRenderedState = z;
      }
      return [z, R];
    }
    function zM(i, o, f) {
      V3(o);
      var g = o._getVersion, _ = g(o._source), R = !1, N = U3(o);
      if (N !== null ? R = N === _ : (R = wi(w0, i.mutableReadLanes), R && IM(o, _)), R) {
        var z = f(o._source);
        return typeof z == "function" && l("Mutable source should not return a function as the snapshot value. Functions may close over mutable values and cause tearing."), z;
      } else
        throw $3(o), Error("Cannot read from mutable source during the current render without tearing. This is a bug in React. Please file an issue.");
    }
    function FM(i, o, f, g) {
      var _ = XF();
      if (_ === null)
        throw Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
      var R = o._getVersion, N = R(o._source), z = mt.current, W = z.useState(function() {
        return zM(_, o, f);
      }), ne = W[0], ae = W[1], Pe = ne, ye = ma, Ie = i.memoizedState, Ke = Ie.refs, lt = Ke.getSnapshot, Ft = Ie.source, vn = Ie.subscribe, Jt = Sr;
      if (i.memoizedState = {
        refs: Ke,
        source: o,
        subscribe: g
      }, z.useEffect(function() {
        Ke.getSnapshot = f, Ke.setSnapshot = ae;
        var hr = R(o._source);
        if (!d(N, hr)) {
          var ke = f(o._source);
          if (typeof ke == "function" && l("Mutable source should not return a function as the snapshot value. Functions may close over mutable values and cause tearing."), !d(Pe, ke)) {
            ae(ke);
            var Ue = Ip(Jt);
            Lg(_, Ue);
          }
          rp(_, _.mutableReadLanes);
        }
      }, [f, o, g]), z.useEffect(function() {
        var hr = function() {
          var Ue = Ke.getSnapshot, De = Ke.setSnapshot;
          try {
            De(Ue(o._source));
            var rt = Ip(Jt);
            Lg(_, rt);
          } catch (ht) {
            De(function() {
              throw ht;
            });
          }
        }, ke = g(o._source, hr);
        return typeof ke != "function" && l("Mutable source subscribe function must return an unsubscribe function."), ke;
      }, [o, g]), !d(lt, f) || !d(Ft, o) || !d(vn, g)) {
        var zn = {
          pending: null,
          dispatch: null,
          lastRenderedReducer: m_,
          lastRenderedState: Pe
        };
        zn.dispatch = ae = mC.bind(null, Sr, zn), ye.queue = zn, ye.baseQueue = null, Pe = zM(_, o, f), ye.memoizedState = ye.baseState = Pe;
      }
      return Pe;
    }
    function sC(i, o, f) {
      var g = xh();
      return g.memoizedState = {
        refs: {
          getSnapshot: o,
          setSnapshot: null
        },
        source: i,
        subscribe: f
      }, FM(g, i, o, f);
    }
    function y_(i, o, f) {
      var g = Sh();
      return FM(g, i, o, f);
    }
    function wh(i) {
      var o = xh();
      typeof i == "function" && (i = i()), o.memoizedState = o.baseState = i;
      var f = o.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: m_,
        lastRenderedState: i
      }, g = f.dispatch = mC.bind(null, Sr, f);
      return [o.memoizedState, g];
    }
    function T0(i) {
      return aC(m_);
    }
    function O0(i) {
      return oC(m_);
    }
    function b_(i, o, f, g) {
      var _ = {
        tag: i,
        create: o,
        destroy: f,
        deps: g,
        next: null
      }, R = Sr.updateQueue;
      if (R === null)
        R = G3(), Sr.updateQueue = R, R.lastEffect = _.next = _;
      else {
        var N = R.lastEffect;
        if (N === null)
          R.lastEffect = _.next = _;
        else {
          var z = N.next;
          N.next = _, _.next = z, R.lastEffect = _;
        }
      }
      return _;
    }
    function __(i) {
      var o = xh(), f = {
        current: i
      };
      return Object.seal(f), o.memoizedState = f, f;
    }
    function Em(i) {
      var o = Sh();
      return o.memoizedState;
    }
    function uC(i, o, f, g) {
      var _ = xh(), R = g === void 0 ? null : g;
      Sr.flags |= i, _.memoizedState = b_(ym | o, f, void 0, R);
    }
    function lC(i, o, f, g) {
      var _ = Sh(), R = g === void 0 ? null : g, N = void 0;
      if (ro !== null) {
        var z = ro.memoizedState;
        if (N = z.destroy, R !== null) {
          var W = z.deps;
          if (rC(R, W)) {
            b_(o, f, N, R);
            return;
          }
        }
      }
      Sr.flags |= i, _.memoizedState = b_(ym | o, f, N, R);
    }
    function E_(i, o) {
      return typeof jest < "u" && eP(Sr), uC(Ht | xi, x0, i, o);
    }
    function xm(i, o) {
      return typeof jest < "u" && eP(Sr), lC(Ht | xi, x0, i, o);
    }
    function cC(i, o) {
      return uC(Ht, bm, i, o);
    }
    function x_(i, o) {
      return lC(Ht, bm, i, o);
    }
    function $M(i, o) {
      if (typeof o == "function") {
        var f = o, g = i();
        return f(g), function() {
          f(null);
        };
      } else if (o != null) {
        var _ = o;
        _.hasOwnProperty("current") || l("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", "an object with keys {" + Object.keys(_).join(", ") + "}");
        var R = i();
        return _.current = R, function() {
          _.current = null;
        };
      }
    }
    function fC(i, o, f) {
      typeof o != "function" && l("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", o !== null ? typeof o : "null");
      var g = f != null ? f.concat([i]) : null;
      return uC(Ht, bm, $M.bind(null, o, i), g);
    }
    function S_(i, o, f) {
      typeof o != "function" && l("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", o !== null ? typeof o : "null");
      var g = f != null ? f.concat([i]) : null;
      return lC(Ht, bm, $M.bind(null, o, i), g);
    }
    function H3(i, o) {
    }
    var w_ = H3;
    function dC(i, o) {
      var f = xh(), g = o === void 0 ? null : o;
      return f.memoizedState = [i, g], i;
    }
    function C_(i, o) {
      var f = Sh(), g = o === void 0 ? null : o, _ = f.memoizedState;
      if (_ !== null && g !== null) {
        var R = _[1];
        if (rC(g, R))
          return _[0];
      }
      return f.memoizedState = [i, g], i;
    }
    function pC(i, o) {
      var f = xh(), g = o === void 0 ? null : o, _ = i();
      return f.memoizedState = [_, g], _;
    }
    function R_(i, o) {
      var f = Sh(), g = o === void 0 ? null : o, _ = f.memoizedState;
      if (_ !== null && g !== null) {
        var R = _[1];
        if (rC(g, R))
          return _[0];
      }
      var N = i();
      return f.memoizedState = [N, g], N;
    }
    function vC(i) {
      var o = wh(i), f = o[0], g = o[1];
      return E_(function() {
        var _ = ju.transition;
        ju.transition = 1;
        try {
          g(i);
        } finally {
          ju.transition = _;
        }
      }, [i]), f;
    }
    function UM(i) {
      var o = T0(), f = o[0], g = o[1];
      return xm(function() {
        var _ = ju.transition;
        ju.transition = 1;
        try {
          g(i);
        } finally {
          ju.transition = _;
        }
      }, [i]), f;
    }
    function VM(i) {
      var o = O0(), f = o[0], g = o[1];
      return xm(function() {
        var _ = ju.transition;
        ju.transition = 1;
        try {
          g(i);
        } finally {
          ju.transition = _;
        }
      }, [i]), f;
    }
    function Y3(i, o) {
      var f = Dp();
      ad(f < Uc ? Uc : f, function() {
        i(!0);
      }), ad(f > Vl ? Vl : f, function() {
        var g = ju.transition;
        ju.transition = 1;
        try {
          i(!1), o();
        } finally {
          ju.transition = g;
        }
      });
    }
    function hC() {
      var i = wh(!1), o = i[0], f = i[1], g = Y3.bind(null, f);
      return __(g), [g, o];
    }
    function jM() {
      var i = T0(), o = i[0], f = Em(), g = f.current;
      return [g, o];
    }
    function WM() {
      var i = O0(), o = i[0], f = Em(), g = f.current;
      return [g, o];
    }
    var T_ = !1;
    function q3() {
      return T_;
    }
    function GM(i) {
      {
        var o = dt(i.type) || "Unknown";
        sv() && !tC[o] && (l("The object passed back from useOpaqueIdentifier is meant to be passed through to attributes only. Do not read the value directly."), tC[o] = !0);
      }
    }
    function gC() {
      var i = lw.bind(null, GM.bind(null, Sr));
      if (Qw()) {
        var o = !1, f = Sr, g = function() {
          throw o || (o = !0, T_ = !0, R(i()), T_ = !1, GM(f)), Error("The object passed back from useOpaqueIdentifier is meant to be passed through to attributes only. Do not read the value directly.");
        }, _ = cw(g), R = wh(_)[1];
        return (Sr.mode & to) === Pr && (Sr.flags |= Ht | xi, b_(ym | x0, function() {
          R(i());
        }, void 0, null)), _;
      } else {
        var N = i();
        return wh(N), N;
      }
    }
    function HM() {
      var i = T0()[0];
      return i;
    }
    function YM() {
      var i = O0()[0];
      return i;
    }
    function mC(i, o, f) {
      typeof arguments[3] == "function" && l("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var g = Vs(), _ = Ip(i), R = {
        lane: _,
        action: f,
        eagerReducer: null,
        eagerState: null,
        next: null
      }, N = o.pending;
      N === null ? R.next = R : (R.next = N.next, N.next = R), o.pending = R;
      var z = i.alternate;
      if (i === Sr || z !== null && z === Sr)
        C0 = g_ = !0;
      else {
        if (i.lanes === Ge && (z === null || z.lanes === Ge)) {
          var W = o.lastRenderedReducer;
          if (W !== null) {
            var ne;
            ne = mt.current, mt.current = Gl;
            try {
              var ae = o.lastRenderedState, Pe = W(ae, f);
              if (R.eagerReducer = W, R.eagerState = Pe, d(Pe, ae))
                return;
            } catch {
            } finally {
              mt.current = ne;
            }
          }
        }
        typeof jest < "u" && (JA(i), A$(i)), io(i, _, g);
      }
    }
    var O_ = {
      readContext: ki,
      useCallback: Zo,
      useContext: Zo,
      useEffect: Zo,
      useImperativeHandle: Zo,
      useLayoutEffect: Zo,
      useMemo: Zo,
      useReducer: Zo,
      useRef: Zo,
      useState: Zo,
      useDebugValue: Zo,
      useDeferredValue: Zo,
      useTransition: Zo,
      useMutableSource: Zo,
      useOpaqueIdentifier: Zo,
      unstable_isNewReconciler: Oe
    }, qM = null, XM = null, KM = null, QM = null, jc = null, Gl = null, D_ = null;
    {
      var yC = function() {
        l("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
      }, _n = function() {
        l("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
      };
      qM = {
        readContext: function(i, o) {
          return ki(i, o);
        },
        useCallback: function(i, o) {
          return et = "useCallback", vr(), R0(o), dC(i, o);
        },
        useContext: function(i, o) {
          return et = "useContext", vr(), ki(i, o);
        },
        useEffect: function(i, o) {
          return et = "useEffect", vr(), R0(o), E_(i, o);
        },
        useImperativeHandle: function(i, o, f) {
          return et = "useImperativeHandle", vr(), R0(f), fC(i, o, f);
        },
        useLayoutEffect: function(i, o) {
          return et = "useLayoutEffect", vr(), R0(o), cC(i, o);
        },
        useMemo: function(i, o) {
          et = "useMemo", vr(), R0(o);
          var f = mt.current;
          mt.current = jc;
          try {
            return pC(i, o);
          } finally {
            mt.current = f;
          }
        },
        useReducer: function(i, o, f) {
          et = "useReducer", vr();
          var g = mt.current;
          mt.current = jc;
          try {
            return iC(i, o, f);
          } finally {
            mt.current = g;
          }
        },
        useRef: function(i) {
          return et = "useRef", vr(), __(i);
        },
        useState: function(i) {
          et = "useState", vr();
          var o = mt.current;
          mt.current = jc;
          try {
            return wh(i);
          } finally {
            mt.current = o;
          }
        },
        useDebugValue: function(i, o) {
          return et = "useDebugValue", vr(), void 0;
        },
        useDeferredValue: function(i) {
          return et = "useDeferredValue", vr(), vC(i);
        },
        useTransition: function() {
          return et = "useTransition", vr(), hC();
        },
        useMutableSource: function(i, o, f) {
          return et = "useMutableSource", vr(), sC(i, o, f);
        },
        useOpaqueIdentifier: function() {
          return et = "useOpaqueIdentifier", vr(), gC();
        },
        unstable_isNewReconciler: Oe
      }, XM = {
        readContext: function(i, o) {
          return ki(i, o);
        },
        useCallback: function(i, o) {
          return et = "useCallback", _t(), dC(i, o);
        },
        useContext: function(i, o) {
          return et = "useContext", _t(), ki(i, o);
        },
        useEffect: function(i, o) {
          return et = "useEffect", _t(), E_(i, o);
        },
        useImperativeHandle: function(i, o, f) {
          return et = "useImperativeHandle", _t(), fC(i, o, f);
        },
        useLayoutEffect: function(i, o) {
          return et = "useLayoutEffect", _t(), cC(i, o);
        },
        useMemo: function(i, o) {
          et = "useMemo", _t();
          var f = mt.current;
          mt.current = jc;
          try {
            return pC(i, o);
          } finally {
            mt.current = f;
          }
        },
        useReducer: function(i, o, f) {
          et = "useReducer", _t();
          var g = mt.current;
          mt.current = jc;
          try {
            return iC(i, o, f);
          } finally {
            mt.current = g;
          }
        },
        useRef: function(i) {
          return et = "useRef", _t(), __(i);
        },
        useState: function(i) {
          et = "useState", _t();
          var o = mt.current;
          mt.current = jc;
          try {
            return wh(i);
          } finally {
            mt.current = o;
          }
        },
        useDebugValue: function(i, o) {
          return et = "useDebugValue", _t(), void 0;
        },
        useDeferredValue: function(i) {
          return et = "useDeferredValue", _t(), vC(i);
        },
        useTransition: function() {
          return et = "useTransition", _t(), hC();
        },
        useMutableSource: function(i, o, f) {
          return et = "useMutableSource", _t(), sC(i, o, f);
        },
        useOpaqueIdentifier: function() {
          return et = "useOpaqueIdentifier", _t(), gC();
        },
        unstable_isNewReconciler: Oe
      }, KM = {
        readContext: function(i, o) {
          return ki(i, o);
        },
        useCallback: function(i, o) {
          return et = "useCallback", _t(), C_(i, o);
        },
        useContext: function(i, o) {
          return et = "useContext", _t(), ki(i, o);
        },
        useEffect: function(i, o) {
          return et = "useEffect", _t(), xm(i, o);
        },
        useImperativeHandle: function(i, o, f) {
          return et = "useImperativeHandle", _t(), S_(i, o, f);
        },
        useLayoutEffect: function(i, o) {
          return et = "useLayoutEffect", _t(), x_(i, o);
        },
        useMemo: function(i, o) {
          et = "useMemo", _t();
          var f = mt.current;
          mt.current = Gl;
          try {
            return R_(i, o);
          } finally {
            mt.current = f;
          }
        },
        useReducer: function(i, o, f) {
          et = "useReducer", _t();
          var g = mt.current;
          mt.current = Gl;
          try {
            return aC(i, o, f);
          } finally {
            mt.current = g;
          }
        },
        useRef: function(i) {
          return et = "useRef", _t(), Em();
        },
        useState: function(i) {
          et = "useState", _t();
          var o = mt.current;
          mt.current = Gl;
          try {
            return T0(i);
          } finally {
            mt.current = o;
          }
        },
        useDebugValue: function(i, o) {
          return et = "useDebugValue", _t(), w_();
        },
        useDeferredValue: function(i) {
          return et = "useDeferredValue", _t(), UM(i);
        },
        useTransition: function() {
          return et = "useTransition", _t(), jM();
        },
        useMutableSource: function(i, o, f) {
          return et = "useMutableSource", _t(), y_(i, o, f);
        },
        useOpaqueIdentifier: function() {
          return et = "useOpaqueIdentifier", _t(), HM();
        },
        unstable_isNewReconciler: Oe
      }, QM = {
        readContext: function(i, o) {
          return ki(i, o);
        },
        useCallback: function(i, o) {
          return et = "useCallback", _t(), C_(i, o);
        },
        useContext: function(i, o) {
          return et = "useContext", _t(), ki(i, o);
        },
        useEffect: function(i, o) {
          return et = "useEffect", _t(), xm(i, o);
        },
        useImperativeHandle: function(i, o, f) {
          return et = "useImperativeHandle", _t(), S_(i, o, f);
        },
        useLayoutEffect: function(i, o) {
          return et = "useLayoutEffect", _t(), x_(i, o);
        },
        useMemo: function(i, o) {
          et = "useMemo", _t();
          var f = mt.current;
          mt.current = D_;
          try {
            return R_(i, o);
          } finally {
            mt.current = f;
          }
        },
        useReducer: function(i, o, f) {
          et = "useReducer", _t();
          var g = mt.current;
          mt.current = D_;
          try {
            return oC(i, o, f);
          } finally {
            mt.current = g;
          }
        },
        useRef: function(i) {
          return et = "useRef", _t(), Em();
        },
        useState: function(i) {
          et = "useState", _t();
          var o = mt.current;
          mt.current = D_;
          try {
            return O0(i);
          } finally {
            mt.current = o;
          }
        },
        useDebugValue: function(i, o) {
          return et = "useDebugValue", _t(), w_();
        },
        useDeferredValue: function(i) {
          return et = "useDeferredValue", _t(), VM(i);
        },
        useTransition: function() {
          return et = "useTransition", _t(), WM();
        },
        useMutableSource: function(i, o, f) {
          return et = "useMutableSource", _t(), y_(i, o, f);
        },
        useOpaqueIdentifier: function() {
          return et = "useOpaqueIdentifier", _t(), YM();
        },
        unstable_isNewReconciler: Oe
      }, jc = {
        readContext: function(i, o) {
          return yC(), ki(i, o);
        },
        useCallback: function(i, o) {
          return et = "useCallback", _n(), vr(), dC(i, o);
        },
        useContext: function(i, o) {
          return et = "useContext", _n(), vr(), ki(i, o);
        },
        useEffect: function(i, o) {
          return et = "useEffect", _n(), vr(), E_(i, o);
        },
        useImperativeHandle: function(i, o, f) {
          return et = "useImperativeHandle", _n(), vr(), fC(i, o, f);
        },
        useLayoutEffect: function(i, o) {
          return et = "useLayoutEffect", _n(), vr(), cC(i, o);
        },
        useMemo: function(i, o) {
          et = "useMemo", _n(), vr();
          var f = mt.current;
          mt.current = jc;
          try {
            return pC(i, o);
          } finally {
            mt.current = f;
          }
        },
        useReducer: function(i, o, f) {
          et = "useReducer", _n(), vr();
          var g = mt.current;
          mt.current = jc;
          try {
            return iC(i, o, f);
          } finally {
            mt.current = g;
          }
        },
        useRef: function(i) {
          return et = "useRef", _n(), vr(), __(i);
        },
        useState: function(i) {
          et = "useState", _n(), vr();
          var o = mt.current;
          mt.current = jc;
          try {
            return wh(i);
          } finally {
            mt.current = o;
          }
        },
        useDebugValue: function(i, o) {
          return et = "useDebugValue", _n(), vr(), void 0;
        },
        useDeferredValue: function(i) {
          return et = "useDeferredValue", _n(), vr(), vC(i);
        },
        useTransition: function() {
          return et = "useTransition", _n(), vr(), hC();
        },
        useMutableSource: function(i, o, f) {
          return et = "useMutableSource", _n(), vr(), sC(i, o, f);
        },
        useOpaqueIdentifier: function() {
          return et = "useOpaqueIdentifier", _n(), vr(), gC();
        },
        unstable_isNewReconciler: Oe
      }, Gl = {
        readContext: function(i, o) {
          return yC(), ki(i, o);
        },
        useCallback: function(i, o) {
          return et = "useCallback", _n(), _t(), C_(i, o);
        },
        useContext: function(i, o) {
          return et = "useContext", _n(), _t(), ki(i, o);
        },
        useEffect: function(i, o) {
          return et = "useEffect", _n(), _t(), xm(i, o);
        },
        useImperativeHandle: function(i, o, f) {
          return et = "useImperativeHandle", _n(), _t(), S_(i, o, f);
        },
        useLayoutEffect: function(i, o) {
          return et = "useLayoutEffect", _n(), _t(), x_(i, o);
        },
        useMemo: function(i, o) {
          et = "useMemo", _n(), _t();
          var f = mt.current;
          mt.current = Gl;
          try {
            return R_(i, o);
          } finally {
            mt.current = f;
          }
        },
        useReducer: function(i, o, f) {
          et = "useReducer", _n(), _t();
          var g = mt.current;
          mt.current = Gl;
          try {
            return aC(i, o, f);
          } finally {
            mt.current = g;
          }
        },
        useRef: function(i) {
          return et = "useRef", _n(), _t(), Em();
        },
        useState: function(i) {
          et = "useState", _n(), _t();
          var o = mt.current;
          mt.current = Gl;
          try {
            return T0(i);
          } finally {
            mt.current = o;
          }
        },
        useDebugValue: function(i, o) {
          return et = "useDebugValue", _n(), _t(), w_();
        },
        useDeferredValue: function(i) {
          return et = "useDeferredValue", _n(), _t(), UM(i);
        },
        useTransition: function() {
          return et = "useTransition", _n(), _t(), jM();
        },
        useMutableSource: function(i, o, f) {
          return et = "useMutableSource", _n(), _t(), y_(i, o, f);
        },
        useOpaqueIdentifier: function() {
          return et = "useOpaqueIdentifier", _n(), _t(), HM();
        },
        unstable_isNewReconciler: Oe
      }, D_ = {
        readContext: function(i, o) {
          return yC(), ki(i, o);
        },
        useCallback: function(i, o) {
          return et = "useCallback", _n(), _t(), C_(i, o);
        },
        useContext: function(i, o) {
          return et = "useContext", _n(), _t(), ki(i, o);
        },
        useEffect: function(i, o) {
          return et = "useEffect", _n(), _t(), xm(i, o);
        },
        useImperativeHandle: function(i, o, f) {
          return et = "useImperativeHandle", _n(), _t(), S_(i, o, f);
        },
        useLayoutEffect: function(i, o) {
          return et = "useLayoutEffect", _n(), _t(), x_(i, o);
        },
        useMemo: function(i, o) {
          et = "useMemo", _n(), _t();
          var f = mt.current;
          mt.current = Gl;
          try {
            return R_(i, o);
          } finally {
            mt.current = f;
          }
        },
        useReducer: function(i, o, f) {
          et = "useReducer", _n(), _t();
          var g = mt.current;
          mt.current = Gl;
          try {
            return oC(i, o, f);
          } finally {
            mt.current = g;
          }
        },
        useRef: function(i) {
          return et = "useRef", _n(), _t(), Em();
        },
        useState: function(i) {
          et = "useState", _n(), _t();
          var o = mt.current;
          mt.current = Gl;
          try {
            return O0(i);
          } finally {
            mt.current = o;
          }
        },
        useDebugValue: function(i, o) {
          return et = "useDebugValue", _n(), _t(), w_();
        },
        useDeferredValue: function(i) {
          return et = "useDeferredValue", _n(), _t(), VM(i);
        },
        useTransition: function() {
          return et = "useTransition", _n(), _t(), WM();
        },
        useMutableSource: function(i, o, f) {
          return et = "useMutableSource", _n(), _t(), y_(i, o, f);
        },
        useOpaqueIdentifier: function() {
          return et = "useOpaqueIdentifier", _n(), _t(), YM();
        },
        unstable_isNewReconciler: Oe
      };
    }
    var M_ = n.unstable_now, ZM = 0, D0 = -1;
    function X3() {
      return ZM;
    }
    function JM() {
      ZM = M_();
    }
    function bC(i) {
      D0 = M_(), i.actualStartTime < 0 && (i.actualStartTime = M_());
    }
    function eA(i) {
      D0 = -1;
    }
    function A_(i, o) {
      if (D0 >= 0) {
        var f = M_() - D0;
        i.actualDuration += f, o && (i.selfBaseDuration = f), D0 = -1;
      }
    }
    function _C(i) {
      for (var o = i.child; o; )
        i.actualDuration += o.actualDuration, o = o.sibling;
    }
    var M0 = a.ReactCurrentOwner, Wc = !1, EC, A0, xC, SC, wC, Ch, CC, P_;
    EC = {}, A0 = {}, xC = {}, SC = {}, wC = {}, Ch = !1, CC = {}, P_ = {};
    function Jo(i, o, f, g) {
      i === null ? o.child = TM(o, null, f, g) : o.child = c_(o, i.child, f, g);
    }
    function K3(i, o, f, g) {
      o.child = c_(o, i.child, null, g), o.child = c_(o, null, f, g);
    }
    function tA(i, o, f, g, _) {
      if (o.type !== o.elementType) {
        var R = f.propTypes;
        R && Ko(
          R,
          g,
          "prop",
          dt(f)
        );
      }
      var N = f.render, z = o.ref, W;
      hm(o, _);
      {
        if (M0.current = o, wa(!0), W = _m(i, o, N, g, z, _), o.mode & Hr) {
          Sa();
          try {
            W = _m(i, o, N, g, z, _);
          } finally {
            Di();
          }
        }
        wa(!1);
      }
      return i !== null && !Wc ? (LM(i, o, _), sd(i, o, _)) : (o.flags |= Hi, Jo(i, o, W, _), o.child);
    }
    function nA(i, o, f, g, _, R) {
      if (i === null) {
        var N = f.type;
        if (j$(N) && f.compare === null && f.defaultProps === void 0) {
          var z = N;
          return z = Mm(N), o.tag = U, o.type = z, DC(o, N), rA(i, o, z, g, _, R);
        }
        {
          var W = N.propTypes;
          W && Ko(
            W,
            g,
            "prop",
            dt(N)
          );
        }
        var ne = pR(f.type, null, g, o, o.mode, R);
        return ne.ref = o.ref, ne.return = o, o.child = ne, ne;
      }
      {
        var ae = f.type, Pe = ae.propTypes;
        Pe && Ko(
          Pe,
          g,
          "prop",
          dt(ae)
        );
      }
      var ye = i.child;
      if (!Bn(_, R)) {
        var Ie = ye.memoizedProps, Ke = f.compare;
        if (Ke = Ke !== null ? Ke : w, Ke(Ie, g) && i.ref === o.ref)
          return sd(i, o, R);
      }
      o.flags |= Hi;
      var lt = Mh(ye, g);
      return lt.ref = o.ref, lt.return = o, o.child = lt, lt;
    }
    function rA(i, o, f, g, _, R) {
      if (o.type !== o.elementType) {
        var N = o.elementType;
        if (N.$$typeof === Va) {
          var z = N, W = z._payload, ne = z._init;
          try {
            N = ne(W);
          } catch {
            N = null;
          }
          var ae = N && N.propTypes;
          ae && Ko(
            ae,
            g,
            "prop",
            dt(N)
          );
        }
      }
      if (i !== null) {
        var Pe = i.memoizedProps;
        if (w(Pe, g) && i.ref === o.ref && o.type === i.type)
          if (Wc = !1, Bn(R, _))
            (i.flags & Ef) !== Hn && (Wc = !0);
          else
            return o.lanes = i.lanes, sd(i, o, R);
      }
      return TC(i, o, f, g, R);
    }
    function RC(i, o, f) {
      var g = o.pendingProps, _ = g.children, R = i !== null ? i.memoizedState : null;
      if (g.mode === "hidden" || g.mode === "unstable-defer-without-hiding")
        if ((o.mode & od) === Pr) {
          var N = {
            baseLanes: Ge
          };
          o.memoizedState = N, q_(o, f);
        } else if (Bn(f, Xa)) {
          var ae = {
            baseLanes: Ge
          };
          o.memoizedState = ae;
          var Pe = R !== null ? R.baseLanes : f;
          q_(o, Pe);
        } else {
          var z;
          if (R !== null) {
            var W = R.baseLanes;
            z = Pn(W, f);
          } else
            z = f;
          eE(Xa), o.lanes = o.childLanes = Xa;
          var ne = {
            baseLanes: z
          };
          return o.memoizedState = ne, q_(o, z), null;
        }
      else {
        var ye;
        R !== null ? (ye = Pn(R.baseLanes, f), o.memoizedState = null) : ye = f, q_(o, ye);
      }
      return Jo(i, o, _, f), o.child;
    }
    var Q3 = RC;
    function Z3(i, o, f) {
      var g = o.pendingProps;
      return Jo(i, o, g, f), o.child;
    }
    function J3(i, o, f) {
      var g = o.pendingProps.children;
      return Jo(i, o, g, f), o.child;
    }
    function eF(i, o, f) {
      {
        o.flags |= Ht;
        var g = o.stateNode;
        g.effectDuration = 0, g.passiveEffectDuration = 0;
      }
      var _ = o.pendingProps, R = _.children;
      return Jo(i, o, R, f), o.child;
    }
    function iA(i, o) {
      var f = o.ref;
      (i === null && f !== null || i !== null && i.ref !== f) && (o.flags |= Rr);
    }
    function TC(i, o, f, g, _) {
      if (o.type !== o.elementType) {
        var R = f.propTypes;
        R && Ko(
          R,
          g,
          "prop",
          dt(f)
        );
      }
      var N;
      {
        var z = Cp(o, f, !0);
        N = Rp(o, z);
      }
      var W;
      hm(o, _);
      {
        if (M0.current = o, wa(!0), W = _m(i, o, f, g, N, _), o.mode & Hr) {
          Sa();
          try {
            W = _m(i, o, f, g, N, _);
          } finally {
            Di();
          }
        }
        wa(!1);
      }
      return i !== null && !Wc ? (LM(i, o, _), sd(i, o, _)) : (o.flags |= Hi, Jo(i, o, W, _), o.child);
    }
    function aA(i, o, f, g, _) {
      if (o.type !== o.elementType) {
        var R = f.propTypes;
        R && Ko(
          R,
          g,
          "prop",
          dt(f)
        );
      }
      var N;
      Fu(f) ? (N = !0, cm(o)) : N = !1, hm(o, _);
      var z = o.stateNode, W;
      z === null ? (i !== null && (i.alternate = null, o.alternate = null, o.flags |= nn), SM(o, f, g), Bw(o, f, g, _), W = !0) : i === null ? W = D3(o, f, g, _) : W = M3(i, o, f, g, _);
      var ne = OC(i, o, f, W, N, _);
      {
        var ae = o.stateNode;
        W && ae.props !== g && (Ch || l("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", dt(o.type) || "a component"), Ch = !0);
      }
      return ne;
    }
    function OC(i, o, f, g, _, R) {
      iA(i, o);
      var N = (o.flags & G) !== Hn;
      if (!g && !N)
        return _ && U1(o, f, !1), sd(i, o, R);
      var z = o.stateNode;
      M0.current = o;
      var W;
      if (N && typeof f.getDerivedStateFromError != "function")
        W = null, eA();
      else {
        if (wa(!0), W = z.render(), o.mode & Hr) {
          Sa();
          try {
            z.render();
          } finally {
            Di();
          }
        }
        wa(!1);
      }
      return o.flags |= Hi, i !== null && N ? K3(i, o, W, R) : Jo(i, o, W, R), o.memoizedState = z.state, _ && U1(o, f, !0), o.child;
    }
    function oA(i) {
      var o = i.stateNode;
      o.pendingContext ? F1(i, o.pendingContext, o.pendingContext !== o.context) : o.context && F1(i, o.context, !1), jw(i, o.containerInfo);
    }
    function tF(i, o, f) {
      oA(o);
      var g = o.updateQueue;
      if (!(i !== null && g !== null))
        throw Error("If the root does not have an updateQueue, we should have already bailed out. This error is likely caused by a bug in React. Please file an issue.");
      var _ = o.pendingProps, R = o.memoizedState, N = R !== null ? R.element : null;
      vM(i, o), g0(o, _, null, f);
      var z = o.memoizedState, W = z.element;
      if (W === N)
        return Kw(), sd(i, o, f);
      var ne = o.stateNode;
      if (ne.hydrate && L3(o)) {
        {
          var ae = ne.mutableSourceEagerHydrationData;
          if (ae != null)
            for (var Pe = 0; Pe < ae.length; Pe += 2) {
              var ye = ae[Pe], Ie = ae[Pe + 1];
              IM(ye, Ie);
            }
        }
        var Ke = TM(o, null, W, f);
        o.child = Ke;
        for (var lt = Ke; lt; )
          lt.flags = lt.flags & ~nn | Ya, lt = lt.sibling;
      } else
        Jo(i, o, W, f), Kw();
      return o.child;
    }
    function nF(i, o, f) {
      DM(o), i === null && Xw(o);
      var g = o.type, _ = o.pendingProps, R = i !== null ? i.memoizedProps : null, N = _.children, z = tm(g, _);
      return z ? N = null : R !== null && tm(g, R) && (o.flags |= Lr), iA(i, o), Jo(i, o, N, f), o.child;
    }
    function rF(i, o) {
      return i === null && Xw(o), null;
    }
    function iF(i, o, f, g, _) {
      i !== null && (i.alternate = null, o.alternate = null, o.flags |= nn);
      var R = o.pendingProps, N = f, z = N._payload, W = N._init, ne = W(z);
      o.type = ne;
      var ae = o.tag = W$(ne), Pe = Xt(ne, R), ye;
      switch (ae) {
        case h:
          return DC(o, ne), o.type = ne = Mm(ne), ye = TC(null, o, ne, Pe, _), ye;
        case y:
          return o.type = ne = sR(ne), ye = aA(null, o, ne, Pe, _), ye;
        case I:
          return o.type = ne = uR(ne), ye = tA(null, o, ne, Pe, _), ye;
        case $: {
          if (o.type !== o.elementType) {
            var Ie = ne.propTypes;
            Ie && Ko(
              Ie,
              Pe,
              "prop",
              dt(ne)
            );
          }
          return ye = nA(
            null,
            o,
            ne,
            Xt(ne.type, Pe),
            g,
            _
          ), ye;
        }
      }
      var Ke = "";
      throw ne !== null && typeof ne == "object" && ne.$$typeof === Va && (Ke = " Did you wrap a component in React.lazy() more than once?"), Error("Element type is invalid. Received a promise that resolves to: " + ne + ". Lazy element type must resolve to a class or function." + Ke);
    }
    function aF(i, o, f, g, _) {
      i !== null && (i.alternate = null, o.alternate = null, o.flags |= nn), o.tag = y;
      var R;
      return Fu(f) ? (R = !0, cm(o)) : R = !1, hm(o, _), SM(o, f, g), Bw(o, f, g, _), OC(null, o, f, !0, R, _);
    }
    function oF(i, o, f, g) {
      i !== null && (i.alternate = null, o.alternate = null, o.flags |= nn);
      var _ = o.pendingProps, R;
      {
        var N = Cp(o, f, !1);
        R = Rp(o, N);
      }
      hm(o, g);
      var z;
      {
        if (f.prototype && typeof f.prototype.render == "function") {
          var W = dt(f) || "Unknown";
          EC[W] || (l("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", W, W), EC[W] = !0);
        }
        o.mode & Hr && P.recordLegacyContextWarning(o, null), wa(!0), M0.current = o, z = _m(null, o, f, _, R, g), wa(!1);
      }
      if (o.flags |= Hi, typeof z == "object" && z !== null && typeof z.render == "function" && z.$$typeof === void 0) {
        var ne = dt(f) || "Unknown";
        A0[ne] || (l("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", ne, ne, ne), A0[ne] = !0);
      }
      if (typeof z == "object" && z !== null && typeof z.render == "function" && z.$$typeof === void 0) {
        {
          var ae = dt(f) || "Unknown";
          A0[ae] || (l("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", ae, ae, ae), A0[ae] = !0);
        }
        o.tag = y, o.memoizedState = null, o.updateQueue = null;
        var Pe = !1;
        Fu(f) ? (Pe = !0, cm(o)) : Pe = !1, o.memoizedState = z.state !== null && z.state !== void 0 ? z.state : null, Rw(o);
        var ye = f.getDerivedStateFromProps;
        return typeof ye == "function" && o_(o, f, ye, _), xM(o, z), Bw(o, f, _, g), OC(null, o, f, !0, Pe, g);
      } else {
        if (o.tag = h, o.mode & Hr) {
          Sa();
          try {
            z = _m(null, o, f, _, R, g);
          } finally {
            Di();
          }
        }
        return Jo(null, o, z, g), DC(o, f), o.child;
      }
    }
    function DC(i, o) {
      {
        if (o && o.childContextTypes && l("%s(...): childContextTypes cannot be defined on a function component.", o.displayName || o.name || "Component"), i.ref !== null) {
          var f = "", g = lc();
          g && (f += `

Check the render method of \`` + g + "`.");
          var _ = g || i._debugID || "", R = i._debugSource;
          R && (_ = R.fileName + ":" + R.lineNumber), wC[_] || (wC[_] = !0, l("Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s", f));
        }
        if (typeof o.getDerivedStateFromProps == "function") {
          var N = dt(o) || "Unknown";
          SC[N] || (l("%s: Function components do not support getDerivedStateFromProps.", N), SC[N] = !0);
        }
        if (typeof o.contextType == "object" && o.contextType !== null) {
          var z = dt(o) || "Unknown";
          xC[z] || (l("%s: Function components do not support contextType.", z), xC[z] = !0);
        }
      }
    }
    var N_ = {
      dehydrated: null,
      retryLane: Or
    };
    function k_(i) {
      return {
        baseLanes: i
      };
    }
    function sA(i, o) {
      return {
        baseLanes: Pn(i.baseLanes, o)
      };
    }
    function sF(i, o, f, g) {
      if (o !== null) {
        var _ = o.memoizedState;
        if (_ === null)
          return !1;
      }
      return p_(i, _0);
    }
    function uA(i, o) {
      return Ac(i.childLanes, o);
    }
    function lA(i, o, f) {
      var g = o.pendingProps;
      lU(o) && (o.flags |= G);
      var _ = Wl.current, R = !1, N = (o.flags & G) !== Hn;
      if (N || sF(_, i) ? (R = !0, o.flags &= ~G) : (i === null || i.memoizedState !== null) && g.fallback !== void 0 && g.unstable_avoidThisFallback !== !0 && (_ = k3(_, Hw)), _ = E0(_), _h(o, _), i === null) {
        g.fallback !== void 0 && Xw(o);
        var z = g.children, W = g.fallback;
        if (R) {
          var ne = cA(o, z, W, f), ae = o.child;
          return ae.memoizedState = k_(f), o.memoizedState = N_, ne;
        } else if (typeof g.unstable_expectedLoadTime == "number") {
          var Pe = cA(o, z, W, f), ye = o.child;
          return ye.memoizedState = k_(f), o.memoizedState = N_, o.lanes = ei, eE(ei), Pe;
        } else
          return uF(o, z, f);
      } else {
        var Ie = i.memoizedState;
        if (Ie !== null)
          if (R) {
            var Ke = g.fallback, lt = g.children, Ft = pA(i, o, lt, Ke, f), vn = o.child, Jt = i.child.memoizedState;
            return vn.memoizedState = Jt === null ? k_(f) : sA(Jt, f), vn.childLanes = uA(i, f), o.memoizedState = N_, Ft;
          } else {
            var zn = g.children, hr = dA(i, o, zn, f);
            return o.memoizedState = null, hr;
          }
        else if (R) {
          var ke = g.fallback, Ue = g.children, De = pA(i, o, Ue, ke, f), rt = o.child, ht = i.child.memoizedState;
          return rt.memoizedState = ht === null ? k_(f) : sA(ht, f), rt.childLanes = uA(i, f), o.memoizedState = N_, De;
        } else {
          var Rt = g.children, An = dA(i, o, Rt, f);
          return o.memoizedState = null, An;
        }
      }
    }
    function uF(i, o, f) {
      var g = i.mode, _ = {
        mode: "visible",
        children: o
      }, R = hR(_, g, f, null);
      return R.return = i, i.child = R, R;
    }
    function cA(i, o, f, g) {
      var _ = i.mode, R = i.child, N = {
        mode: "hidden",
        children: o
      }, z, W;
      return (_ & to) === Pr && R !== null ? (z = R, z.childLanes = Ge, z.pendingProps = N, i.mode & Eo && (z.actualDuration = 0, z.actualStartTime = -1, z.selfBaseDuration = 0, z.treeBaseDuration = 0), W = Ah(f, _, g, null)) : (z = hR(N, _, Ge, null), W = Ah(f, _, g, null)), z.return = i, W.return = i, z.sibling = W, i.child = z, W;
    }
    function fA(i, o) {
      return Mh(i, o);
    }
    function dA(i, o, f, g) {
      var _ = i.child, R = _.sibling, N = fA(_, {
        mode: "visible",
        children: f
      });
      return (o.mode & to) === Pr && (N.lanes = g), N.return = o, N.sibling = null, R !== null && (R.nextEffect = null, R.flags = er, o.firstEffect = o.lastEffect = R), o.child = N, N;
    }
    function pA(i, o, f, g, _) {
      var R = o.mode, N = i.child, z = N.sibling, W = {
        mode: "hidden",
        children: f
      }, ne;
      if ((R & to) === Pr && o.child !== N) {
        var ae = o.child;
        ne = ae, ne.childLanes = Ge, ne.pendingProps = W, o.mode & Eo && (ne.actualDuration = 0, ne.actualStartTime = -1, ne.selfBaseDuration = N.selfBaseDuration, ne.treeBaseDuration = N.treeBaseDuration);
        var Pe = ne.lastEffect;
        Pe !== null ? (o.firstEffect = ne.firstEffect, o.lastEffect = Pe, Pe.nextEffect = null) : o.firstEffect = o.lastEffect = null;
      } else
        ne = fA(N, W);
      var ye;
      return z !== null ? ye = Mh(z, g) : (ye = Ah(g, R, _, null), ye.flags |= nn), ye.return = o, ne.return = o, ne.sibling = ye, o.child = ne, ye;
    }
    function vA(i, o) {
      i.lanes = Pn(i.lanes, o);
      var f = i.alternate;
      f !== null && (f.lanes = Pn(f.lanes, o)), fM(i.return, o);
    }
    function lF(i, o, f) {
      for (var g = o; g !== null; ) {
        if (g.tag === k) {
          var _ = g.memoizedState;
          _ !== null && vA(g, f);
        } else if (g.tag === J)
          vA(g, f);
        else if (g.child !== null) {
          g.child.return = g, g = g.child;
          continue;
        }
        if (g === i)
          return;
        for (; g.sibling === null; ) {
          if (g.return === null || g.return === i)
            return;
          g = g.return;
        }
        g.sibling.return = g.return, g = g.sibling;
      }
    }
    function cF(i) {
      for (var o = i, f = null; o !== null; ) {
        var g = o.alternate;
        g !== null && v_(g) === null && (f = o), o = o.sibling;
      }
      return f;
    }
    function fF(i) {
      if (i !== void 0 && i !== "forwards" && i !== "backwards" && i !== "together" && !CC[i])
        if (CC[i] = !0, typeof i == "string")
          switch (i.toLowerCase()) {
            case "together":
            case "forwards":
            case "backwards": {
              l('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', i, i.toLowerCase());
              break;
            }
            case "forward":
            case "backward": {
              l('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', i, i.toLowerCase());
              break;
            }
            default:
              l('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', i);
              break;
          }
        else
          l('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', i);
    }
    function dF(i, o) {
      i !== void 0 && !P_[i] && (i !== "collapsed" && i !== "hidden" ? (P_[i] = !0, l('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?', i)) : o !== "forwards" && o !== "backwards" && (P_[i] = !0, l('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', i)));
    }
    function hA(i, o) {
      {
        var f = Array.isArray(i), g = !f && typeof Kn(i) == "function";
        if (f || g) {
          var _ = f ? "array" : "iterable";
          return l("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", _, o, _), !1;
        }
      }
      return !0;
    }
    function pF(i, o) {
      if ((o === "forwards" || o === "backwards") && i !== void 0 && i !== null && i !== !1)
        if (Array.isArray(i)) {
          for (var f = 0; f < i.length; f++)
            if (!hA(i[f], f))
              return;
        } else {
          var g = Kn(i);
          if (typeof g == "function") {
            var _ = g.call(i);
            if (_)
              for (var R = _.next(), N = 0; !R.done; R = _.next()) {
                if (!hA(R.value, N))
                  return;
                N++;
              }
          } else
            l('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', o);
        }
    }
    function MC(i, o, f, g, _, R) {
      var N = i.memoizedState;
      N === null ? i.memoizedState = {
        isBackwards: o,
        rendering: null,
        renderingStartTime: 0,
        last: g,
        tail: f,
        tailMode: _,
        lastEffect: R
      } : (N.isBackwards = o, N.rendering = null, N.renderingStartTime = 0, N.last = g, N.tail = f, N.tailMode = _, N.lastEffect = R);
    }
    function gA(i, o, f) {
      var g = o.pendingProps, _ = g.revealOrder, R = g.tail, N = g.children;
      fF(_), dF(R, _), pF(N, _), Jo(i, o, N, f);
      var z = Wl.current, W = p_(z, _0);
      if (W)
        z = Yw(z, _0), o.flags |= G;
      else {
        var ne = i !== null && (i.flags & G) !== Hn;
        ne && lF(o, o.child, f), z = E0(z);
      }
      if (_h(o, z), (o.mode & to) === Pr)
        o.memoizedState = null;
      else
        switch (_) {
          case "forwards": {
            var ae = cF(o.child), Pe;
            ae === null ? (Pe = o.child, o.child = null) : (Pe = ae.sibling, ae.sibling = null), MC(
              o,
              !1,
              Pe,
              ae,
              R,
              o.lastEffect
            );
            break;
          }
          case "backwards": {
            var ye = null, Ie = o.child;
            for (o.child = null; Ie !== null; ) {
              var Ke = Ie.alternate;
              if (Ke !== null && v_(Ke) === null) {
                o.child = Ie;
                break;
              }
              var lt = Ie.sibling;
              Ie.sibling = ye, ye = Ie, Ie = lt;
            }
            MC(
              o,
              !0,
              ye,
              null,
              R,
              o.lastEffect
            );
            break;
          }
          case "together": {
            MC(
              o,
              !1,
              null,
              null,
              void 0,
              o.lastEffect
            );
            break;
          }
          default:
            o.memoizedState = null;
        }
      return o.child;
    }
    function vF(i, o, f) {
      jw(o, o.stateNode.containerInfo);
      var g = o.pendingProps;
      return i === null ? o.child = c_(o, null, g, f) : Jo(i, o, g, f), o.child;
    }
    var mA = !1;
    function hF(i, o, f) {
      var g = o.type, _ = g._context, R = o.pendingProps, N = o.memoizedProps, z = R.value;
      {
        "value" in R || mA || (mA = !0, l("The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?"));
        var W = o.type.propTypes;
        W && Ko(W, R, "prop", "Context.Provider");
      }
      if (cM(o, z), N !== null) {
        var ne = N.value, ae = x3(_, z, ne);
        if (ae === 0) {
          if (N.children === R.children && !um())
            return sd(i, o, f);
        } else
          S3(o, _, ae, f);
      }
      var Pe = R.children;
      return Jo(i, o, Pe, f), o.child;
    }
    var yA = !1;
    function gF(i, o, f) {
      var g = o.type;
      g._context === void 0 ? g !== g.Consumer && (yA || (yA = !0, l("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?"))) : g = g._context;
      var _ = o.pendingProps, R = _.children;
      typeof R != "function" && l("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it."), hm(o, f);
      var N = ki(g, _.unstable_observedBits), z;
      return M0.current = o, wa(!0), z = R(N), wa(!1), o.flags |= Hi, Jo(i, o, z, f), o.child;
    }
    function AC() {
      Wc = !0;
    }
    function sd(i, o, f) {
      return i !== null && (o.dependencies = i.dependencies), eA(), nR(o.lanes), Bn(f, o.childLanes) ? (A3(i, o), o.child) : null;
    }
    function mF(i, o, f) {
      {
        var g = o.return;
        if (g === null)
          throw new Error("Cannot swap the root fiber.");
        if (i.alternate = null, o.alternate = null, f.index = o.index, f.sibling = o.sibling, f.return = o.return, f.ref = o.ref, o === g.child)
          g.child = f;
        else {
          var _ = g.child;
          if (_ === null)
            throw new Error("Expected parent to have a child.");
          for (; _.sibling !== o; )
            if (_ = _.sibling, _ === null)
              throw new Error("Expected to find the previous sibling.");
          _.sibling = f;
        }
        var R = g.lastEffect;
        return R !== null ? (R.nextEffect = i, g.lastEffect = i) : g.firstEffect = g.lastEffect = i, i.nextEffect = null, i.flags = er, f.flags |= nn, f;
      }
    }
    function bA(i, o, f) {
      var g = o.lanes;
      if (o._debugNeedsRemount && i !== null)
        return mF(i, o, pR(o.type, o.key, o.pendingProps, o._debugOwner || null, o.mode, o.lanes));
      if (i !== null) {
        var _ = i.memoizedProps, R = o.pendingProps;
        if (_ !== R || um() || o.type !== i.type)
          Wc = !0;
        else if (Bn(f, g))
          (i.flags & Ef) !== Hn ? Wc = !0 : Wc = !1;
        else {
          switch (Wc = !1, o.tag) {
            case E:
              oA(o), Kw();
              break;
            case C:
              DM(o);
              break;
            case y: {
              var N = o.type;
              Fu(N) && cm(o);
              break;
            }
            case x:
              jw(o, o.stateNode.containerInfo);
              break;
            case B: {
              var z = o.memoizedProps.value;
              cM(o, z);
              break;
            }
            case L:
              {
                var W = Bn(f, o.childLanes);
                W && (o.flags |= Ht);
                var ne = o.stateNode;
                ne.effectDuration = 0, ne.passiveEffectDuration = 0;
              }
              break;
            case k: {
              var ae = o.memoizedState;
              if (ae !== null) {
                var Pe = o.child, ye = Pe.childLanes;
                if (Bn(f, ye))
                  return lA(i, o, f);
                _h(o, E0(Wl.current));
                var Ie = sd(i, o, f);
                return Ie !== null ? Ie.sibling : null;
              } else
                _h(o, E0(Wl.current));
              break;
            }
            case J: {
              var Ke = (i.flags & G) !== Hn, lt = Bn(f, o.childLanes);
              if (Ke) {
                if (lt)
                  return gA(i, o, f);
                o.flags |= G;
              }
              var Ft = o.memoizedState;
              if (Ft !== null && (Ft.rendering = null, Ft.tail = null, Ft.lastEffect = null), _h(o, Wl.current), lt)
                break;
              return null;
            }
            case pe:
            case be:
              return o.lanes = Ge, RC(i, o, f);
          }
          return sd(i, o, f);
        }
      } else
        Wc = !1;
      switch (o.lanes = Ge, o.tag) {
        case b:
          return oF(i, o, o.type, f);
        case K: {
          var vn = o.elementType;
          return iF(i, o, vn, g, f);
        }
        case h: {
          var Jt = o.type, zn = o.pendingProps, hr = o.elementType === Jt ? zn : Xt(Jt, zn);
          return TC(i, o, Jt, hr, f);
        }
        case y: {
          var ke = o.type, Ue = o.pendingProps, De = o.elementType === ke ? Ue : Xt(ke, Ue);
          return aA(i, o, ke, De, f);
        }
        case E:
          return tF(i, o, f);
        case C:
          return nF(i, o, f);
        case T:
          return rF(i, o);
        case k:
          return lA(i, o, f);
        case x:
          return vF(i, o, f);
        case I: {
          var rt = o.type, ht = o.pendingProps, Rt = o.elementType === rt ? ht : Xt(rt, ht);
          return tA(i, o, rt, Rt, f);
        }
        case O:
          return Z3(i, o, f);
        case D:
          return J3(i, o, f);
        case L:
          return eF(i, o, f);
        case B:
          return hF(i, o, f);
        case A:
          return gF(i, o, f);
        case $: {
          var An = o.type, kr = o.pendingProps, Yr = Xt(An, kr);
          if (o.type !== o.elementType) {
            var ir = An.propTypes;
            ir && Ko(
              ir,
              Yr,
              "prop",
              dt(An)
            );
          }
          return Yr = Xt(An.type, Yr), nA(i, o, An, Yr, g, f);
        }
        case U:
          return rA(i, o, o.type, o.pendingProps, g, f);
        case X: {
          var Ii = o.type, qn = o.pendingProps, qr = o.elementType === Ii ? qn : Xt(Ii, qn);
          return aF(i, o, Ii, qr, f);
        }
        case J:
          return gA(i, o, f);
        case Q:
          break;
        case Z:
          break;
        case se:
          break;
        case pe:
          return RC(i, o, f);
        case be:
          return Q3(i, o, f);
      }
      throw Error("Unknown unit of work tag (" + o.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function Sm(i) {
      i.flags |= Ht;
    }
    function _A(i) {
      i.flags |= Rr;
    }
    var EA, PC, xA, SA;
    EA = function(i, o, f, g) {
      for (var _ = o.child; _ !== null; ) {
        if (_.tag === C || _.tag === T)
          vh(i, _.stateNode);
        else if (_.tag !== x) {
          if (_.child !== null) {
            _.child.return = _, _ = _.child;
            continue;
          }
        }
        if (_ === o)
          return;
        for (; _.sibling === null; ) {
          if (_.return === null || _.return === o)
            return;
          _ = _.return;
        }
        _.sibling.return = _.return, _ = _.sibling;
      }
    }, PC = function(i) {
    }, xA = function(i, o, f, g, _) {
      var R = i.memoizedProps;
      if (R !== g) {
        var N = o.stateNode, z = Ww(), W = VS(N, f, R, g, _, z);
        o.updateQueue = W, W && Sm(o);
      }
    }, SA = function(i, o, f, g) {
      f !== g && Sm(o);
    };
    function P0(i, o) {
      if (!Qw())
        switch (i.tailMode) {
          case "hidden": {
            for (var f = i.tail, g = null; f !== null; )
              f.alternate !== null && (g = f), f = f.sibling;
            g === null ? i.tail = null : g.sibling = null;
            break;
          }
          case "collapsed": {
            for (var _ = i.tail, R = null; _ !== null; )
              _.alternate !== null && (R = _), _ = _.sibling;
            R === null ? !o && i.tail !== null ? i.tail.sibling = null : i.tail = null : R.sibling = null;
            break;
          }
        }
    }
    function wA(i, o, f) {
      var g = o.pendingProps;
      switch (o.tag) {
        case b:
        case K:
        case U:
        case h:
        case I:
        case O:
        case D:
        case L:
        case A:
        case $:
          return null;
        case y: {
          var _ = o.type;
          return Fu(_) && lm(o), null;
        }
        case E: {
          gm(o), l0(o), Jw();
          var R = o.stateNode;
          if (R.pendingContext && (R.context = R.pendingContext, R.pendingContext = null), i === null || i.child === null) {
            var N = h_(o);
            N ? Sm(o) : R.hydrate || (o.flags |= Oa);
          }
          return PC(o), null;
        }
        case C: {
          Gw(o);
          var z = OM(), W = o.type;
          if (i !== null && o.stateNode != null)
            xA(i, o, W, g, z), i.ref !== o.ref && _A(o);
          else {
            if (!g) {
              if (o.stateNode === null)
                throw Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
              return null;
            }
            var ne = Ww(), ae = h_(o);
            if (ae)
              B3(o, z, ne) && Sm(o);
            else {
              var Pe = E1(W, g, z, ne, o);
              EA(Pe, o, !1, !1), o.stateNode = Pe, t0(Pe, W, g, z) && Sm(o);
            }
            o.ref !== null && _A(o);
          }
          return null;
        }
        case T: {
          var ye = g;
          if (i && o.stateNode != null) {
            var Ie = i.memoizedProps;
            SA(i, o, Ie, ye);
          } else {
            if (typeof ye != "string" && o.stateNode === null)
              throw Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
            var Ke = OM(), lt = Ww(), Ft = h_(o);
            Ft ? z3(o) && Sm(o) : o.stateNode = nm(ye, Ke, lt, o);
          }
          return null;
        }
        case k: {
          mm(o);
          var vn = o.memoizedState;
          if ((o.flags & G) !== Hn)
            return o.lanes = f, (o.mode & Eo) !== Pr && _C(o), o;
          var Jt = vn !== null, zn = !1;
          if (i === null)
            o.memoizedProps.fallback !== void 0 && h_(o);
          else {
            var hr = i.memoizedState;
            zn = hr !== null;
          }
          if (Jt && !zn && (o.mode & to) !== Pr) {
            var ke = i === null && o.memoizedProps.unstable_avoidThisFallback !== !0;
            ke || p_(Wl.current, Hw) ? r$() : i$();
          }
          return (Jt || zn) && (o.flags |= Ht), null;
        }
        case x:
          return gm(o), PC(o), i === null && fw(o.stateNode.containerInfo), null;
        case B:
          return Sw(o), null;
        case X: {
          var Ue = o.type;
          return Fu(Ue) && lm(o), null;
        }
        case J: {
          mm(o);
          var De = o.memoizedState;
          if (De === null)
            return null;
          var rt = (o.flags & G) !== Hn, ht = De.rendering;
          if (ht === null)
            if (rt)
              P0(De, !1);
            else {
              var Rt = o$() && (i === null || (i.flags & G) === Hn);
              if (!Rt)
                for (var An = o.child; An !== null; ) {
                  var kr = v_(An);
                  if (kr !== null) {
                    rt = !0, o.flags |= G, P0(De, !1);
                    var Yr = kr.updateQueue;
                    return Yr !== null && (o.updateQueue = Yr, o.flags |= Ht), De.lastEffect === null && (o.firstEffect = null), o.lastEffect = De.lastEffect, P3(o, f), _h(o, Yw(Wl.current, _0)), o.child;
                  }
                  An = An.sibling;
                }
              De.tail !== null && va() > $A() && (o.flags |= G, rt = !0, P0(De, !1), o.lanes = ei, eE(ei));
            }
          else {
            if (!rt) {
              var ir = v_(ht);
              if (ir !== null) {
                o.flags |= G, rt = !0;
                var Ii = ir.updateQueue;
                if (Ii !== null && (o.updateQueue = Ii, o.flags |= Ht), P0(De, !0), De.tail === null && De.tailMode === "hidden" && !ht.alternate && !Qw()) {
                  var qn = o.lastEffect = De.lastEffect;
                  return qn !== null && (qn.nextEffect = null), null;
                }
              } else
                va() * 2 - De.renderingStartTime > $A() && f !== Xa && (o.flags |= G, rt = !0, P0(De, !1), o.lanes = ei, eE(ei));
            }
            if (De.isBackwards)
              ht.sibling = o.child, o.child = ht;
            else {
              var qr = De.last;
              qr !== null ? qr.sibling = ht : o.child = ht, De.last = ht;
            }
          }
          if (De.tail !== null) {
            var ya = De.tail;
            De.rendering = ya, De.tail = ya.sibling, De.lastEffect = o.lastEffect, De.renderingStartTime = va(), ya.sibling = null;
            var Ri = Wl.current;
            return rt ? Ri = Yw(Ri, _0) : Ri = E0(Ri), _h(o, Ri), ya;
          }
          return null;
        }
        case Q:
          break;
        case Z:
          break;
        case se:
          break;
        case pe:
        case be: {
          if (tR(o), i !== null) {
            var qc = o.memoizedState, Ti = i.memoizedState, Xc = Ti !== null, Ph = qc !== null;
            Xc !== Ph && g.mode !== "unstable-defer-without-hiding" && (o.flags |= Ht);
          }
          return null;
        }
      }
      throw Error("Unknown unit of work tag (" + o.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function yF(i, o) {
      switch (i.tag) {
        case y: {
          var f = i.type;
          Fu(f) && lm(i);
          var g = i.flags;
          return g & po ? (i.flags = g & ~po | G, (i.mode & Eo) !== Pr && _C(i), i) : null;
        }
        case E: {
          gm(i), l0(i), Jw();
          var _ = i.flags;
          if ((_ & G) !== Hn)
            throw Error("The root failed to unmount after an error. This is likely a bug in React. Please file an issue.");
          return i.flags = _ & ~po | G, i;
        }
        case C:
          return Gw(i), null;
        case k: {
          mm(i);
          var R = i.flags;
          return R & po ? (i.flags = R & ~po | G, (i.mode & Eo) !== Pr && _C(i), i) : null;
        }
        case J:
          return mm(i), null;
        case x:
          return gm(i), null;
        case B:
          return Sw(i), null;
        case pe:
        case be:
          return tR(i), null;
        default:
          return null;
      }
    }
    function CA(i) {
      switch (i.tag) {
        case y: {
          var o = i.type.childContextTypes;
          o != null && lm(i);
          break;
        }
        case E: {
          gm(i), l0(i), Jw();
          break;
        }
        case C: {
          Gw(i);
          break;
        }
        case x:
          gm(i);
          break;
        case k:
          mm(i);
          break;
        case J:
          mm(i);
          break;
        case B:
          Sw(i);
          break;
        case pe:
        case be:
          tR(i);
          break;
      }
    }
    function NC(i, o) {
      return {
        value: i,
        source: o,
        stack: To(o)
      };
    }
    function bF(i, o) {
      return !0;
    }
    function kC(i, o) {
      try {
        var f = bF(i, o);
        if (f === !1)
          return;
        var g = o.value, _ = o.source, R = o.stack, N = R !== null ? R : "";
        if (g != null && g._suppressLogging) {
          if (i.tag === y)
            return;
          console.error(g);
        }
        var z = _ ? dt(_.type) : null, W = z ? "The above error occurred in the <" + z + "> component:" : "The above error occurred in one of your React components:", ne, ae = dt(i.type);
        ae ? ne = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + ae + ".") : ne = `Consider adding an error boundary to your tree to customize error handling behavior.
Visit https://reactjs.org/link/error-boundaries to learn more about error boundaries.`;
        var Pe = W + `
` + N + `

` + ("" + ne);
        console.error(Pe);
      } catch (ye) {
        setTimeout(function() {
          throw ye;
        });
      }
    }
    var _F = typeof WeakMap == "function" ? WeakMap : Map;
    function RA(i, o, f) {
      var g = Mp(Cn, f);
      g.tag = ww, g.payload = {
        element: null
      };
      var _ = o.value;
      return g.callback = function() {
        _$(_), kC(i, o);
      }, g;
    }
    function TA(i, o, f) {
      var g = Mp(Cn, f);
      g.tag = ww;
      var _ = i.type.getDerivedStateFromError;
      if (typeof _ == "function") {
        var R = o.value;
        g.payload = function() {
          return kC(i, o), _(R);
        };
      }
      var N = i.stateNode;
      return N !== null && typeof N.componentDidCatch == "function" ? g.callback = function() {
        sP(i), typeof _ != "function" && (y$(this), kC(i, o));
        var W = o.value, ne = o.stack;
        this.componentDidCatch(W, {
          componentStack: ne !== null ? ne : ""
        }), typeof _ != "function" && (Bn(i.lanes, bn) || l("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", dt(i.type) || "Unknown"));
      } : g.callback = function() {
        sP(i);
      }, g;
    }
    function EF(i, o, f) {
      var g = i.pingCache, _;
      if (g === null ? (g = i.pingCache = new _F(), _ = /* @__PURE__ */ new Set(), g.set(o, _)) : (_ = g.get(o), _ === void 0 && (_ = /* @__PURE__ */ new Set(), g.set(o, _))), !_.has(f)) {
        _.add(f);
        var R = E$.bind(null, i, o, f);
        o.then(R, R);
      }
    }
    function xF(i, o, f, g, _) {
      if (f.flags |= _f, f.firstEffect = f.lastEffect = null, g !== null && typeof g == "object" && typeof g.then == "function") {
        var R = g;
        if ((f.mode & to) === Pr) {
          var N = f.alternate;
          N ? (f.updateQueue = N.updateQueue, f.memoizedState = N.memoizedState, f.lanes = N.lanes) : (f.updateQueue = null, f.memoizedState = null);
        }
        var z = p_(Wl.current, Hw), W = o;
        do {
          if (W.tag === k && I3(W, z)) {
            var ne = W.updateQueue;
            if (ne === null) {
              var ae = /* @__PURE__ */ new Set();
              ae.add(R), W.updateQueue = ae;
            } else
              ne.add(R);
            if ((W.mode & to) === Pr) {
              if (W.flags |= G, f.flags |= Ef, f.flags &= ~(Ov | _f), f.tag === y) {
                var Pe = f.alternate;
                if (Pe === null)
                  f.tag = X;
                else {
                  var ye = Mp(Cn, bn);
                  ye.tag = t_, Ap(f, ye);
                }
              }
              f.lanes = Pn(f.lanes, bn);
              return;
            }
            EF(i, R, _), W.flags |= po, W.lanes = _;
            return;
          }
          W = W.return;
        } while (W !== null);
        g = new Error((dt(f.type) || "A React component") + ` suspended while rendering, but no fallback UI was specified.

Add a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.`);
      }
      a$(), g = NC(g, f);
      var Ie = o;
      do {
        switch (Ie.tag) {
          case E: {
            var Ke = g;
            Ie.flags |= po;
            var lt = si(_);
            Ie.lanes = Pn(Ie.lanes, lt);
            var Ft = RA(Ie, Ke, lt);
            hM(Ie, Ft);
            return;
          }
          case y:
            var vn = g, Jt = Ie.type, zn = Ie.stateNode;
            if ((Ie.flags & G) === Hn && (typeof Jt.getDerivedStateFromError == "function" || zn !== null && typeof zn.componentDidCatch == "function" && !rR(zn))) {
              Ie.flags |= po;
              var hr = si(_);
              Ie.lanes = Pn(Ie.lanes, hr);
              var ke = TA(Ie, vn, hr);
              hM(Ie, ke);
              return;
            }
            break;
        }
        Ie = Ie.return;
      } while (Ie !== null);
    }
    var OA = null;
    OA = /* @__PURE__ */ new Set();
    var SF = typeof WeakSet == "function" ? WeakSet : Set, wF = function(i, o) {
      o.props = i.memoizedProps, o.state = i.memoizedState, o.componentWillUnmount();
    };
    function CF(i, o) {
      if (Ei(null, wF, null, i, o), ai()) {
        var f = Qr();
        Lp(i, f);
      }
    }
    function DA(i) {
      var o = i.ref;
      if (o !== null)
        if (typeof o == "function") {
          if (Ei(null, o, null, null), ai()) {
            var f = Qr();
            Lp(i, f);
          }
        } else
          o.current = null;
    }
    function RF(i, o) {
      if (Ei(null, o, null), ai()) {
        var f = Qr();
        Lp(i, f);
      }
    }
    function TF(i, o) {
      switch (o.tag) {
        case h:
        case I:
        case U:
        case se:
          return;
        case y: {
          if (o.flags & Oa && i !== null) {
            var f = i.memoizedProps, g = i.memoizedState, _ = o.stateNode;
            o.type === o.elementType && !Ch && (_.props !== o.memoizedProps && l("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", dt(o.type) || "instance"), _.state !== o.memoizedState && l("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", dt(o.type) || "instance"));
            var R = _.getSnapshotBeforeUpdate(o.elementType === o.type ? f : Xt(o.type, f), g);
            {
              var N = OA;
              R === void 0 && !N.has(o.type) && (N.add(o.type), l("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", dt(o.type)));
            }
            _.__reactInternalSnapshotBeforeUpdate = R;
          }
          return;
        }
        case E: {
          if (o.flags & Oa) {
            var z = o.stateNode;
            Sp(z.containerInfo);
          }
          return;
        }
        case C:
        case T:
        case x:
        case X:
          return;
      }
      throw Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
    }
    function OF(i, o) {
      var f = o.updateQueue, g = f !== null ? f.lastEffect : null;
      if (g !== null) {
        var _ = g.next, R = _;
        do {
          if ((R.tag & i) === i) {
            var N = R.destroy;
            R.destroy = void 0, N !== void 0 && N();
          }
          R = R.next;
        } while (R !== _);
      }
    }
    function DF(i, o) {
      var f = o.updateQueue, g = f !== null ? f.lastEffect : null;
      if (g !== null) {
        var _ = g.next, R = _;
        do {
          if ((R.tag & i) === i) {
            var N = R.create;
            R.destroy = N();
            {
              var z = R.destroy;
              if (z !== void 0 && typeof z != "function") {
                var W = void 0;
                z === null ? W = " You returned null. If your effect does not require clean up, return undefined (or nothing)." : typeof z.then == "function" ? W = `

It looks like you wrote useEffect(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:

useEffect(() => {
  async function fetchData() {
    // You can await here
    const response = await MyAPI.getData(someId);
    // ...
  }
  fetchData();
}, [someId]); // Or [] if effect doesn't need props or state

Learn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching` : W = " You returned: " + z, l("An effect function must not return anything besides a function, which is used for clean-up.%s", W);
              }
            }
          }
          R = R.next;
        } while (R !== _);
      }
    }
    function MF(i) {
      var o = i.updateQueue, f = o !== null ? o.lastEffect : null;
      if (f !== null) {
        var g = f.next, _ = g;
        do {
          var R = _, N = R.next, z = R.tag;
          (z & x0) !== qw && (z & ym) !== qw && (XA(i, _), h$(i, _)), _ = N;
        } while (_ !== g);
      }
    }
    function AF(i, o, f, g) {
      switch (f.tag) {
        case h:
        case I:
        case U:
        case se: {
          DF(bm | ym, f), MF(f);
          return;
        }
        case y: {
          var _ = f.stateNode;
          if (f.flags & Ht)
            if (o === null)
              f.type === f.elementType && !Ch && (_.props !== f.memoizedProps && l("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", dt(f.type) || "instance"), _.state !== f.memoizedState && l("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", dt(f.type) || "instance")), _.componentDidMount();
            else {
              var R = f.elementType === f.type ? o.memoizedProps : Xt(f.type, o.memoizedProps), N = o.memoizedState;
              f.type === f.elementType && !Ch && (_.props !== f.memoizedProps && l("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", dt(f.type) || "instance"), _.state !== f.memoizedState && l("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", dt(f.type) || "instance")), _.componentDidUpdate(R, N, _.__reactInternalSnapshotBeforeUpdate);
            }
          var z = f.updateQueue;
          z !== null && (f.type === f.elementType && !Ch && (_.props !== f.memoizedProps && l("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", dt(f.type) || "instance"), _.state !== f.memoizedState && l("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", dt(f.type) || "instance")), mM(f, z, _));
          return;
        }
        case E: {
          var W = f.updateQueue;
          if (W !== null) {
            var ne = null;
            if (f.child !== null)
              switch (f.child.tag) {
                case C:
                  ne = f.child.stateNode;
                  break;
                case y:
                  ne = f.child.stateNode;
                  break;
              }
            mM(f, W, ne);
          }
          return;
        }
        case C: {
          var ae = f.stateNode;
          if (o === null && f.flags & Ht) {
            var Pe = f.type, ye = f.memoizedProps;
            jS(ae, Pe, ye);
          }
          return;
        }
        case T:
          return;
        case x:
          return;
        case L: {
          {
            var Ie = f.memoizedProps;
            Ie.onCommit;
            var Ke = Ie.onRender;
            f.stateNode.effectDuration;
            var lt = X3();
            typeof Ke == "function" && Ke(f.memoizedProps.id, o === null ? "mount" : "update", f.actualDuration, f.treeBaseDuration, f.actualStartTime, lt, i.memoizedInteractions);
          }
          return;
        }
        case k: {
          FF(i, f);
          return;
        }
        case J:
        case X:
        case Q:
        case Z:
        case pe:
        case be:
          return;
      }
      throw Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
    }
    function MA(i, o) {
      for (var f = i; ; ) {
        if (f.tag === C) {
          var g = f.stateNode;
          o ? HS(g) : YS(f.stateNode, f.memoizedProps);
        } else if (f.tag === T) {
          var _ = f.stateNode;
          o ? Yn(_) : R1(_, f.memoizedProps);
        } else if (!((f.tag === pe || f.tag === be) && f.memoizedState !== null && f !== i)) {
          if (f.child !== null) {
            f.child.return = f, f = f.child;
            continue;
          }
        }
        if (f === i)
          return;
        for (; f.sibling === null; ) {
          if (f.return === null || f.return === i)
            return;
          f = f.return;
        }
        f.sibling.return = f.return, f = f.sibling;
      }
    }
    function PF(i) {
      var o = i.ref;
      if (o !== null) {
        var f = i.stateNode, g;
        switch (i.tag) {
          case C:
            g = f;
            break;
          default:
            g = f;
        }
        typeof o == "function" ? o(g) : (o.hasOwnProperty("current") || l("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", dt(i.type)), o.current = g);
      }
    }
    function NF(i) {
      var o = i.ref;
      o !== null && (typeof o == "function" ? o(null) : o.current = null);
    }
    function AA(i, o, f) {
      switch (gw(o), o.tag) {
        case h:
        case I:
        case $:
        case U:
        case se: {
          var g = o.updateQueue;
          if (g !== null) {
            var _ = g.lastEffect;
            if (_ !== null) {
              var R = _.next, N = R;
              do {
                var z = N, W = z.destroy, ne = z.tag;
                W !== void 0 && ((ne & x0) !== qw ? XA(o, N) : RF(o, W)), N = N.next;
              } while (N !== R);
            }
          }
          return;
        }
        case y: {
          DA(o);
          var ae = o.stateNode;
          typeof ae.componentWillUnmount == "function" && CF(o, ae);
          return;
        }
        case C: {
          DA(o);
          return;
        }
        case x: {
          IA(i, o);
          return;
        }
        case Q:
          return;
        case Y:
          return;
        case Z:
          return;
      }
    }
    function kF(i, o, f) {
      for (var g = o; ; ) {
        if (AA(i, g), g.child !== null && g.tag !== x) {
          g.child.return = g, g = g.child;
          continue;
        }
        if (g === o)
          return;
        for (; g.sibling === null; ) {
          if (g.return === null || g.return === o)
            return;
          g = g.return;
        }
        g.sibling.return = g.return, g = g.sibling;
      }
    }
    function PA(i) {
      i.alternate = null, i.child = null, i.dependencies = null, i.firstEffect = null, i.lastEffect = null, i.memoizedProps = null, i.memoizedState = null, i.pendingProps = null, i.return = null, i.updateQueue = null, i._debugOwner = null;
    }
    function IF(i) {
      for (var o = i.return; o !== null; ) {
        if (NA(o))
          return o;
        o = o.return;
      }
      throw Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    function NA(i) {
      return i.tag === C || i.tag === E || i.tag === x;
    }
    function LF(i) {
      var o = i;
      e:
        for (; ; ) {
          for (; o.sibling === null; ) {
            if (o.return === null || NA(o.return))
              return null;
            o = o.return;
          }
          for (o.sibling.return = o.return, o = o.sibling; o.tag !== C && o.tag !== T && o.tag !== Y; ) {
            if (o.flags & nn || o.child === null || o.tag === x)
              continue e;
            o.child.return = o, o = o.child;
          }
          if (!(o.flags & nn))
            return o.stateNode;
        }
    }
    function kA(i) {
      var o = IF(i), f, g, _ = o.stateNode;
      switch (o.tag) {
        case C:
          f = _, g = !1;
          break;
        case E:
          f = _.containerInfo, g = !0;
          break;
        case x:
          f = _.containerInfo, g = !0;
          break;
        case Q:
        default:
          throw Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
      }
      o.flags & Lr && (x1(f), o.flags &= ~Lr);
      var R = LF(i);
      g ? IC(i, R, f) : LC(i, R, f);
    }
    function IC(i, o, f) {
      var g = i.tag, _ = g === C || g === T;
      if (_ || Se) {
        var R = _ ? i.stateNode : i.stateNode.instance;
        o ? w1(f, R, o) : Fl(f, R);
      } else if (g !== x) {
        var N = i.child;
        if (N !== null) {
          IC(N, o, f);
          for (var z = N.sibling; z !== null; )
            IC(z, o, f), z = z.sibling;
        }
      }
    }
    function LC(i, o, f) {
      var g = i.tag, _ = g === C || g === T;
      if (_ || Se) {
        var R = _ ? i.stateNode : i.stateNode.instance;
        o ? pn(f, R, o) : S1(f, R);
      } else if (g !== x) {
        var N = i.child;
        if (N !== null) {
          LC(N, o, f);
          for (var z = N.sibling; z !== null; )
            LC(z, o, f), z = z.sibling;
        }
      }
    }
    function IA(i, o, f) {
      for (var g = o, _ = !1, R, N; ; ) {
        if (!_) {
          var z = g.return;
          e:
            for (; ; ) {
              if (z === null)
                throw Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
              var W = z.stateNode;
              switch (z.tag) {
                case C:
                  R = W, N = !1;
                  break e;
                case E:
                  R = W.containerInfo, N = !0;
                  break e;
                case x:
                  R = W.containerInfo, N = !0;
                  break e;
              }
              z = z.return;
            }
          _ = !0;
        }
        if (g.tag === C || g.tag === T)
          kF(i, g), N ? C1(R, g.stateNode) : Xo(R, g.stateNode);
        else if (g.tag === x) {
          if (g.child !== null) {
            R = g.stateNode.containerInfo, N = !0, g.child.return = g, g = g.child;
            continue;
          }
        } else if (AA(i, g), g.child !== null) {
          g.child.return = g, g = g.child;
          continue;
        }
        if (g === o)
          return;
        for (; g.sibling === null; ) {
          if (g.return === null || g.return === o)
            return;
          g = g.return, g.tag === x && (_ = !1);
        }
        g.sibling.return = g.return, g = g.sibling;
      }
    }
    function BF(i, o, f) {
      IA(i, o);
      var g = o.alternate;
      PA(o), g !== null && PA(g);
    }
    function BC(i, o) {
      switch (o.tag) {
        case h:
        case I:
        case $:
        case U:
        case se: {
          OF(bm | ym, o);
          return;
        }
        case y:
          return;
        case C: {
          var f = o.stateNode;
          if (f != null) {
            var g = o.memoizedProps, _ = i !== null ? i.memoizedProps : g, R = o.type, N = o.updateQueue;
            o.updateQueue = null, N !== null && WS(f, N, R, _, g);
          }
          return;
        }
        case T: {
          if (o.stateNode === null)
            throw Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
          var z = o.stateNode, W = o.memoizedProps, ne = i !== null ? i.memoizedProps : W;
          GS(z, ne, W);
          return;
        }
        case E: {
          {
            var ae = o.stateNode;
            ae.hydrate && (ae.hydrate = !1, tw(ae.containerInfo));
          }
          return;
        }
        case L:
          return;
        case k: {
          zF(o), LA(o);
          return;
        }
        case J: {
          LA(o);
          return;
        }
        case X:
          return;
        case Q:
          break;
        case Z:
          break;
        case pe:
        case be: {
          var Pe = o.memoizedState, ye = Pe !== null;
          MA(o, ye);
          return;
        }
      }
      throw Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
    }
    function zF(i) {
      var o = i.memoizedState;
      if (o !== null) {
        n$();
        {
          var f = i.child;
          MA(f, !0);
        }
      }
    }
    function FF(i, o) {
      var f = o.memoizedState;
      if (f === null) {
        var g = o.alternate;
        if (g !== null) {
          var _ = g.memoizedState;
          if (_ !== null) {
            var R = _.dehydrated;
            R !== null && nw(R);
          }
        }
      }
    }
    function LA(i) {
      var o = i.updateQueue;
      if (o !== null) {
        i.updateQueue = null;
        var f = i.stateNode;
        f === null && (f = i.stateNode = new SF()), o.forEach(function(g) {
          var _ = S$.bind(null, i, g);
          f.has(g) || (g.__reactDoNotTraceInteractions !== !0 && (_ = r.unstable_wrap(_)), f.add(g), g.then(_, _));
        });
      }
    }
    function $F(i, o) {
      if (i !== null) {
        var f = i.memoizedState;
        if (f === null || f.dehydrated !== null) {
          var g = o.memoizedState;
          return g !== null && g.dehydrated === null;
        }
      }
      return !1;
    }
    function UF(i) {
      x1(i.stateNode);
    }
    if (typeof Symbol == "function" && Symbol.for) {
      var N0 = Symbol.for;
      N0("selector.component"), N0("selector.has_pseudo_class"), N0("selector.role"), N0("selector.test_id"), N0("selector.text");
    }
    var VF = [];
    function jF() {
      VF.forEach(function(i) {
        return i();
      });
    }
    var WF = Math.ceil, zC = a.ReactCurrentDispatcher, FC = a.ReactCurrentOwner, $C = a.IsSomeRendererActing, fi = 0, I_ = 1, GF = 2, UC = 4, VC = 8, Us = 16, Gc = 32, BA = 64, ud = 0, L_ = 1, B_ = 2, z_ = 3, F_ = 4, jC = 5, Zt = fi, xo = null, di = null, So = Ge, Hc = Ge, WC = $c(Ge), La = ud, $_ = null, Rh = Ge, U_ = Ge, Th = Ge, V_ = Ge, GC = null, HC = 0, zA = 500, FA = 1 / 0, HF = 500;
    function wm() {
      FA = va() + HF;
    }
    function $A() {
      return FA;
    }
    var Ct = null, j_ = !1, YC = null, Cm = null, ld = !1, Rm = null, k0 = bh, qC = Ge, XC = [], KC = [], cd = null, YF = 50, I0 = 0, QC = null, qF = 50, W_ = 0, Oh = null, L0 = Cn, fd = Ge, G_ = Ge, ZC = !1, B0 = null, H_ = !1;
    function XF() {
      return xo;
    }
    function Vs() {
      return (Zt & (Us | Gc)) !== fi ? va() : (L0 !== Cn || (L0 = va()), L0);
    }
    function Ip(i) {
      var o = i.mode;
      if ((o & to) === Pr)
        return bn;
      if ((o & od) === Pr)
        return Dp() === Qo ? bn : go;
      fd === Ge && (fd = Rh);
      var f = S() !== v;
      if (f)
        return G_ !== Ge && (G_ = GC !== null ? GC.pendingLanes : Ge), Ng(fd, G_);
      var g = Dp(), _;
      if ((Zt & UC) !== fi && g === Uc)
        _ = Ou(Rc, fd);
      else {
        var R = Mc(g);
        _ = Ou(R, fd);
      }
      return _;
    }
    function KF(i) {
      var o = i.mode;
      return (o & to) === Pr ? bn : (o & od) === Pr ? Dp() === Qo ? bn : go : (fd === Ge && (fd = Rh), Fv(fd));
    }
    function io(i, o, f) {
      C$(), D$(i);
      var g = Y_(i, o);
      if (g === null)
        return T$(i), null;
      Ll(g, o, f), g === xo && (Th = Pn(Th, o), La === F_ && Tm(g, So));
      var _ = Dp();
      o === bn ? (Zt & VC) !== fi && (Zt & (Us | Gc)) === fi ? (Bp(g, o), JC(g)) : (Gu(g, f), Bp(g, o), Zt === fi && (wm(), $u())) : ((Zt & UC) !== fi && (_ === Uc || _ === Qo) && (cd === null ? cd = /* @__PURE__ */ new Set([g]) : cd.add(g)), Gu(g, f), Bp(g, o)), GC = g;
    }
    function Y_(i, o) {
      i.lanes = Pn(i.lanes, o);
      var f = i.alternate;
      f !== null && (f.lanes = Pn(f.lanes, o)), f === null && (i.flags & (nn | Ya)) !== Hn && QA(i);
      for (var g = i, _ = i.return; _ !== null; )
        _.childLanes = Pn(_.childLanes, o), f = _.alternate, f !== null ? f.childLanes = Pn(f.childLanes, o) : (_.flags & (nn | Ya)) !== Hn && QA(i), g = _, _ = _.return;
      if (g.tag === E) {
        var R = g.stateNode;
        return R;
      } else
        return null;
    }
    function Gu(i, o) {
      var f = i.callbackNode;
      Bv(i, o);
      var g = Il(i, i === xo ? So : Ge), _ = sa();
      if (g === Ge) {
        f !== null && (Z1(f), i.callbackNode = null, i.callbackPriority = Ms);
        return;
      }
      if (f !== null) {
        var R = i.callbackPriority;
        if (R === _)
          return;
        Z1(f);
      }
      var N;
      if (_ === Os)
        N = Ew(JC.bind(null, i));
      else if (_ === Df)
        N = Vc(Qo, JC.bind(null, i));
      else {
        var z = kf(_);
        N = Vc(z, UA.bind(null, i));
      }
      i.callbackPriority = _, i.callbackNode = N;
    }
    function UA(i) {
      if (L0 = Cn, fd = Ge, G_ = Ge, (Zt & (Us | Gc)) !== fi)
        throw Error("Should not already be working.");
      var o = i.callbackNode, f = Yc();
      if (f && i.callbackNode !== o)
        return null;
      var g = Il(i, i === xo ? So : Ge);
      if (g === Ge)
        return null;
      var _ = u$(i, g);
      if (Bn(Rh, Th))
        Om(i, Ge);
      else if (_ !== ud) {
        if (_ === B_ && (Zt |= BA, i.hydrate && (i.hydrate = !1, Sp(i.containerInfo)), g = ti(i), g !== Ge && (_ = z0(i, g))), _ === L_) {
          var R = $_;
          throw Om(i, Ge), Tm(i, g), Gu(i, va()), R;
        }
        var N = i.current.alternate;
        i.finishedWork = N, i.finishedLanes = g, QF(i, _, g);
      }
      return Gu(i, va()), i.callbackNode === o ? UA.bind(null, i) : null;
    }
    function QF(i, o, f) {
      switch (o) {
        case ud:
        case L_:
          throw Error("Root did not complete. This is a bug in React.");
        case B_: {
          Dh(i);
          break;
        }
        case z_: {
          if (Tm(i, f), Zd(f) && !N$()) {
            var g = HC + zA - va();
            if (g > 10) {
              var _ = Il(i, Ge);
              if (_ !== Ge)
                break;
              var R = i.suspendedLanes;
              if (!wi(R, f)) {
                Vs(), tp(i, R);
                break;
              }
              i.timeoutHandle = Ja(Dh.bind(null, i), g);
              break;
            }
          }
          Dh(i);
          break;
        }
        case F_: {
          if (Tm(i, f), zv(f))
            break;
          {
            var N = Pg(i, f), z = N, W = va() - z, ne = w$(W) - W;
            if (ne > 10) {
              i.timeoutHandle = Ja(Dh.bind(null, i), ne);
              break;
            }
          }
          Dh(i);
          break;
        }
        case jC: {
          Dh(i);
          break;
        }
        default:
          throw Error("Unknown root exit status.");
      }
    }
    function Tm(i, o) {
      o = Ac(o, V_), o = Ac(o, Th), Ig(i, o);
    }
    function JC(i) {
      if ((Zt & (Us | Gc)) !== fi)
        throw Error("Should not already be working.");
      Yc();
      var o, f;
      if (i === xo && Bn(i.expiredLanes, So) ? (o = So, f = z0(i, o), Bn(Rh, Th) && (o = Il(i, o), f = z0(i, o))) : (o = Il(i, Ge), f = z0(i, o)), i.tag !== c0 && f === B_ && (Zt |= BA, i.hydrate && (i.hydrate = !1, Sp(i.containerInfo)), o = ti(i), o !== Ge && (f = z0(i, o))), f === L_) {
        var g = $_;
        throw Om(i, Ge), Tm(i, o), Gu(i, va()), g;
      }
      var _ = i.current.alternate;
      return i.finishedWork = _, i.finishedLanes = o, Dh(i), Gu(i, va()), null;
    }
    function ZF() {
      if ((Zt & (I_ | Us | Gc)) !== fi) {
        (Zt & Us) !== fi && l("unstable_flushDiscreteUpdates: Cannot flush updates when React is already rendering.");
        return;
      }
      JF(), Yc();
    }
    function JF() {
      if (cd !== null) {
        var i = cd;
        cd = null, i.forEach(function(o) {
          jo(o), Gu(o, va());
        });
      }
      $u();
    }
    function VA(i, o) {
      var f = Zt;
      Zt |= I_;
      try {
        return i(o);
      } finally {
        Zt = f, Zt === fi && (wm(), $u());
      }
    }
    function e$(i, o) {
      var f = Zt;
      Zt |= GF;
      try {
        return i(o);
      } finally {
        Zt = f, Zt === fi && (wm(), $u());
      }
    }
    function t$(i, o, f, g, _) {
      var R = Zt;
      Zt |= UC;
      try {
        return ad(Uc, i.bind(null, o, f, g, _));
      } finally {
        Zt = R, Zt === fi && (wm(), $u());
      }
    }
    function jA(i, o) {
      var f = Zt;
      Zt &= ~I_, Zt |= VC;
      try {
        return i(o);
      } finally {
        Zt = f, Zt === fi && (wm(), $u());
      }
    }
    function eR(i, o) {
      var f = Zt;
      if ((f & (Us | Gc)) !== fi)
        return l("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task."), i(o);
      Zt |= I_;
      try {
        return i ? ad(Qo, i.bind(null, o)) : void 0;
      } finally {
        Zt = f, $u();
      }
    }
    function q_(i, o) {
      da(WC, Hc, i), Hc = Pn(Hc, o), Rh = Pn(Rh, o);
    }
    function tR(i) {
      Hc = WC.current, fa(WC, i);
    }
    function Om(i, o) {
      i.finishedWork = null, i.finishedLanes = Ge;
      var f = i.timeoutHandle;
      if (f !== n0 && (i.timeoutHandle = n0, xp(f)), di !== null)
        for (var g = di.return; g !== null; )
          CA(g), g = g.return;
      xo = i, di = Mh(i.current, null), So = Hc = Rh = o, La = ud, $_ = null, U_ = Ge, Th = Ge, V_ = Ge, Oh = null, P.discardPendingWarnings();
    }
    function WA(i, o) {
      do {
        var f = di;
        try {
          if (no(), BM(), ji(), FC.current = null, f === null || f.return === null) {
            La = L_, $_ = o, di = null;
            return;
          }
          _e && f.mode & Eo && A_(f, !0), xF(i, f.return, f, o, So), qA(f);
        } catch (g) {
          o = g, di === f && f !== null ? (f = f.return, di = f) : f = di;
          continue;
        }
        return;
      } while (!0);
    }
    function GA() {
      var i = zC.current;
      return zC.current = O_, i === null ? O_ : i;
    }
    function HA(i) {
      zC.current = i;
    }
    function X_(i) {
      {
        var o = r.__interactionsRef.current;
        return r.__interactionsRef.current = i.memoizedInteractions, o;
      }
    }
    function K_(i) {
      r.__interactionsRef.current = i;
    }
    function n$() {
      HC = va();
    }
    function nR(i) {
      U_ = Pn(i, U_);
    }
    function r$() {
      La === ud && (La = z_);
    }
    function i$() {
      (La === ud || La === z_) && (La = F_), xo !== null && (Vo(U_) || Vo(Th)) && Tm(xo, So);
    }
    function a$() {
      La !== jC && (La = B_);
    }
    function o$() {
      return La === ud;
    }
    function z0(i, o) {
      var f = Zt;
      Zt |= Us;
      var g = GA();
      (xo !== i || So !== o) && (Om(i, o), rP(i, o));
      var _ = X_(i);
      do
        try {
          s$();
          break;
        } catch (R) {
          WA(i, R);
        }
      while (!0);
      if (no(), K_(_), Zt = f, HA(g), di !== null)
        throw Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
      return xo = null, So = Ge, La;
    }
    function s$() {
      for (; di !== null; )
        YA(di);
    }
    function u$(i, o) {
      var f = Zt;
      Zt |= Us;
      var g = GA();
      (xo !== i || So !== o) && (wm(), Om(i, o), rP(i, o));
      var _ = X_(i);
      do
        try {
          l$();
          break;
        } catch (R) {
          WA(i, R);
        }
      while (!0);
      return no(), K_(_), HA(g), Zt = f, di !== null ? ud : (xo = null, So = Ge, La);
    }
    function l$() {
      for (; di !== null && !p0(); )
        YA(di);
    }
    function YA(i) {
      var o = i.alternate;
      $r(i);
      var f;
      (i.mode & Eo) !== Pr ? (bC(i), f = iR(o, i, Hc), A_(i, !0)) : f = iR(o, i, Hc), ji(), i.memoizedProps = i.pendingProps, f === null ? qA(i) : di = f, FC.current = null;
    }
    function qA(i) {
      var o = i;
      do {
        var f = o.alternate, g = o.return;
        if ((o.flags & _f) === Hn) {
          $r(o);
          var _ = void 0;
          if ((o.mode & Eo) === Pr ? _ = wA(f, o, Hc) : (bC(o), _ = wA(f, o, Hc), A_(o, !1)), ji(), _ !== null) {
            di = _;
            return;
          }
          if (c$(o), g !== null && (g.flags & _f) === Hn) {
            g.firstEffect === null && (g.firstEffect = o.firstEffect), o.lastEffect !== null && (g.lastEffect !== null && (g.lastEffect.nextEffect = o.firstEffect), g.lastEffect = o.lastEffect);
            var R = o.flags;
            R > Hi && (g.lastEffect !== null ? g.lastEffect.nextEffect = o : g.firstEffect = o, g.lastEffect = o);
          }
        } else {
          var N = yF(o);
          if (N !== null) {
            N.flags &= Da, di = N;
            return;
          }
          if ((o.mode & Eo) !== Pr) {
            A_(o, !1);
            for (var z = o.actualDuration, W = o.child; W !== null; )
              z += W.actualDuration, W = W.sibling;
            o.actualDuration = z;
          }
          g !== null && (g.firstEffect = g.lastEffect = null, g.flags |= _f);
        }
        var ne = o.sibling;
        if (ne !== null) {
          di = ne;
          return;
        }
        o = g, di = o;
      } while (o !== null);
      La === ud && (La = jC);
    }
    function c$(i) {
      if (!((i.tag === be || i.tag === pe) && i.memoizedState !== null && !Bn(Hc, Xa) && (i.mode & od) !== Ge)) {
        var o = Ge;
        if ((i.mode & Eo) !== Pr) {
          for (var f = i.actualDuration, g = i.selfBaseDuration, _ = i.alternate === null || i.child !== i.alternate.child, R = i.child; R !== null; )
            o = Pn(o, Pn(R.lanes, R.childLanes)), _ && (f += R.actualDuration), g += R.treeBaseDuration, R = R.sibling;
          var N = i.tag === k && i.memoizedState !== null;
          if (N) {
            var z = i.child;
            z !== null && (g -= z.treeBaseDuration);
          }
          i.actualDuration = f, i.treeBaseDuration = g;
        } else
          for (var W = i.child; W !== null; )
            o = Pn(o, Pn(W.lanes, W.childLanes)), W = W.sibling;
        i.childLanes = o;
      }
    }
    function Dh(i) {
      var o = Dp();
      return ad(Qo, f$.bind(null, i, o)), null;
    }
    function f$(i, o) {
      do
        Yc();
      while (Rm !== null);
      if (R$(), (Zt & (Us | Gc)) !== fi)
        throw Error("Should not already be working.");
      var f = i.finishedWork, g = i.finishedLanes;
      if (f === null)
        return null;
      if (i.finishedWork = null, i.finishedLanes = Ge, f === i.current)
        throw Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
      i.callbackNode = null;
      var _ = Pn(f.lanes, f.childLanes);
      np(i, _), cd !== null && !Lf(_) && cd.has(i) && cd.delete(i), i === xo && (xo = null, di = null, So = Ge);
      var R;
      if (f.flags > Hi ? f.lastEffect !== null ? (f.lastEffect.nextEffect = f, R = f.firstEffect) : R = f : R = f.firstEffect, R !== null) {
        var N = Zt;
        Zt |= Gc;
        var z = X_(i);
        FC.current = null, B0 = $S(i.containerInfo), H_ = !1, Ct = R;
        do
          if (Ei(null, d$, null), ai()) {
            if (Ct === null)
              throw Error("Should be working on an effect.");
            var W = Qr();
            Lp(Ct, W), Ct = Ct.nextEffect;
          }
        while (Ct !== null);
        B0 = null, JM(), Ct = R;
        do
          if (Ei(null, p$, null, i, o), ai()) {
            if (Ct === null)
              throw Error("Should be working on an effect.");
            var ne = Qr();
            Lp(Ct, ne), Ct = Ct.nextEffect;
          }
        while (Ct !== null);
        US(i.containerInfo), i.current = f, Ct = R;
        do
          if (Ei(null, v$, null, i, g), ai()) {
            if (Ct === null)
              throw Error("Should be working on an effect.");
            var ae = Qr();
            Lp(Ct, ae), Ct = Ct.nextEffect;
          }
        while (Ct !== null);
        Ct = null, _w(), K_(z), Zt = N;
      } else
        i.current = f, JM();
      var Pe = ld;
      if (ld)
        ld = !1, Rm = i, qC = g, k0 = o;
      else
        for (Ct = R; Ct !== null; ) {
          var ye = Ct.nextEffect;
          Ct.nextEffect = null, Ct.flags & er && aP(Ct), Ct = ye;
        }
      if (_ = i.pendingLanes, _ !== Ge) {
        if (Oh !== null) {
          var Ie = Oh;
          Oh = null;
          for (var Ke = 0; Ke < Ie.length; Ke++)
            nP(i, Ie[Ke], i.memoizedInteractions);
        }
        Bp(i, _);
      } else
        Cm = null;
      if (Pe || iP(i, g), _ === bn ? i === QC ? I0++ : (I0 = 0, QC = i) : I0 = 0, hw(f.stateNode, o), jF(), Gu(i, va()), j_) {
        j_ = !1;
        var lt = YC;
        throw YC = null, lt;
      }
      return (Zt & VC) !== fi || $u(), null;
    }
    function d$() {
      for (; Ct !== null; ) {
        var i = Ct.alternate;
        !H_ && B0 !== null && ((Ct.flags & er) !== Hn ? Mg(Ct, B0) && (H_ = !0) : Ct.tag === k && $F(i, Ct) && Mg(Ct, B0) && (H_ = !0));
        var o = Ct.flags;
        (o & Oa) !== Hn && ($r(Ct), TF(i, Ct), ji()), (o & xi) !== Hn && (ld || (ld = !0, Vc(Vl, function() {
          return Yc(), null;
        }))), Ct = Ct.nextEffect;
      }
    }
    function p$(i, o) {
      for (; Ct !== null; ) {
        $r(Ct);
        var f = Ct.flags;
        if (f & Lr && UF(Ct), f & Rr) {
          var g = Ct.alternate;
          g !== null && NF(g);
        }
        var _ = f & (nn | Ht | er | Ya);
        switch (_) {
          case nn: {
            kA(Ct), Ct.flags &= ~nn;
            break;
          }
          case vu: {
            kA(Ct), Ct.flags &= ~nn;
            var R = Ct.alternate;
            BC(R, Ct);
            break;
          }
          case Ya: {
            Ct.flags &= ~Ya;
            break;
          }
          case Tg: {
            Ct.flags &= ~Ya;
            var N = Ct.alternate;
            BC(N, Ct);
            break;
          }
          case Ht: {
            var z = Ct.alternate;
            BC(z, Ct);
            break;
          }
          case er: {
            BF(i, Ct);
            break;
          }
        }
        ji(), Ct = Ct.nextEffect;
      }
    }
    function v$(i, o) {
      for (; Ct !== null; ) {
        $r(Ct);
        var f = Ct.flags;
        if (f & (Ht | xs)) {
          var g = Ct.alternate;
          AF(i, g, Ct);
        }
        f & Rr && PF(Ct), ji(), Ct = Ct.nextEffect;
      }
    }
    function Yc() {
      if (k0 !== bh) {
        var i = k0 > Vl ? Vl : k0;
        return k0 = bh, ad(i, m$);
      }
      return !1;
    }
    function h$(i, o) {
      XC.push(o, i), ld || (ld = !0, Vc(Vl, function() {
        return Yc(), null;
      }));
    }
    function XA(i, o) {
      KC.push(o, i);
      {
        i.flags |= un;
        var f = i.alternate;
        f !== null && (f.flags |= un);
      }
      ld || (ld = !0, Vc(Vl, function() {
        return Yc(), null;
      }));
    }
    function g$(i) {
      var o = i.create;
      i.destroy = o();
    }
    function m$() {
      if (Rm === null)
        return !1;
      var i = Rm, o = qC;
      if (Rm = null, qC = Ge, (Zt & (Us | Gc)) !== fi)
        throw Error("Cannot flush passive effects while already rendering.");
      ZC = !0;
      var f = Zt;
      Zt |= Gc;
      var g = X_(i), _ = KC;
      KC = [];
      for (var R = 0; R < _.length; R += 2) {
        var N = _[R], z = _[R + 1], W = N.destroy;
        N.destroy = void 0;
        {
          z.flags &= ~un;
          var ne = z.alternate;
          ne !== null && (ne.flags &= ~un);
        }
        if (typeof W == "function") {
          if ($r(z), Ei(null, W, null), ai()) {
            if (z === null)
              throw Error("Should be working on an effect.");
            var ae = Qr();
            Lp(z, ae);
          }
          ji();
        }
      }
      var Pe = XC;
      XC = [];
      for (var ye = 0; ye < Pe.length; ye += 2) {
        var Ie = Pe[ye], Ke = Pe[ye + 1];
        {
          if ($r(Ke), Ei(null, g$, null, Ie), ai()) {
            if (Ke === null)
              throw Error("Should be working on an effect.");
            var lt = Qr();
            Lp(Ke, lt);
          }
          ji();
        }
      }
      for (var Ft = i.current.firstEffect; Ft !== null; ) {
        var vn = Ft.nextEffect;
        Ft.nextEffect = null, Ft.flags & er && aP(Ft), Ft = vn;
      }
      return K_(g), iP(i, o), ZC = !1, Zt = f, $u(), W_ = Rm === null ? 0 : W_ + 1, !0;
    }
    function rR(i) {
      return Cm !== null && Cm.has(i);
    }
    function y$(i) {
      Cm === null ? Cm = /* @__PURE__ */ new Set([i]) : Cm.add(i);
    }
    function b$(i) {
      j_ || (j_ = !0, YC = i);
    }
    var _$ = b$;
    function KA(i, o, f) {
      var g = NC(f, o), _ = RA(i, g, bn);
      Ap(i, _);
      var R = Vs(), N = Y_(i, bn);
      N !== null && (Ll(N, bn, R), Gu(N, R), Bp(N, bn));
    }
    function Lp(i, o) {
      if (i.tag === E) {
        KA(i, i, o);
        return;
      }
      for (var f = i.return; f !== null; ) {
        if (f.tag === E) {
          KA(f, i, o);
          return;
        } else if (f.tag === y) {
          var g = f.type, _ = f.stateNode;
          if (typeof g.getDerivedStateFromError == "function" || typeof _.componentDidCatch == "function" && !rR(_)) {
            var R = NC(o, i), N = TA(f, R, bn);
            Ap(f, N);
            var z = Vs(), W = Y_(f, bn);
            if (W !== null)
              Ll(W, bn, z), Gu(W, z), Bp(W, bn);
            else if (typeof _.componentDidCatch == "function" && !rR(_))
              try {
                _.componentDidCatch(o, R);
              } catch {
              }
            return;
          }
        }
        f = f.return;
      }
    }
    function E$(i, o, f) {
      var g = i.pingCache;
      g !== null && g.delete(o);
      var _ = Vs();
      tp(i, f), xo === i && wi(So, f) && (La === F_ || La === z_ && Zd(So) && va() - HC < zA ? Om(i, Ge) : V_ = Pn(V_, f)), Gu(i, _), Bp(i, f);
    }
    function x$(i, o) {
      o === Or && (o = KF(i));
      var f = Vs(), g = Y_(i, o);
      g !== null && (Ll(g, o, f), Gu(g, f), Bp(g, o));
    }
    function S$(i, o) {
      var f = Or, g;
      g = i.stateNode, g !== null && g.delete(o), x$(i, f);
    }
    function w$(i) {
      return i < 120 ? 120 : i < 480 ? 480 : i < 1080 ? 1080 : i < 1920 ? 1920 : i < 3e3 ? 3e3 : i < 4320 ? 4320 : WF(i / 1960) * 1960;
    }
    function C$() {
      if (I0 > YF)
        throw I0 = 0, QC = null, Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
      W_ > qF && (W_ = 0, l("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render."));
    }
    function R$() {
      P.flushLegacyContextWarning(), P.flushPendingUnsafeLifecycleWarnings();
    }
    var Q_ = null;
    function QA(i) {
      {
        if ((Zt & Us) !== fi || !(i.mode & (to | od)))
          return;
        var o = i.tag;
        if (o !== b && o !== E && o !== y && o !== h && o !== I && o !== $ && o !== U && o !== se)
          return;
        var f = dt(i.type) || "ReactComponent";
        if (Q_ !== null) {
          if (Q_.has(f))
            return;
          Q_.add(f);
        } else
          Q_ = /* @__PURE__ */ new Set([f]);
        var g = ri;
        try {
          $r(i), l("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead.");
        } finally {
          g ? $r(i) : ji();
        }
      }
    }
    var Z_ = null;
    function T$(i) {
      {
        var o = i.tag;
        if (o !== E && o !== y && o !== h && o !== I && o !== $ && o !== U && o !== se || (i.flags & un) !== Hn)
          return;
        var f = dt(i.type) || "ReactComponent";
        if (Z_ !== null) {
          if (Z_.has(f))
            return;
          Z_.add(f);
        } else
          Z_ = /* @__PURE__ */ new Set([f]);
        if (!ZC) {
          var g = ri;
          try {
            $r(i), l("Can't perform a React state update on an unmounted component. This is a no-op, but it indicates a memory leak in your application. To fix, cancel all subscriptions and asynchronous tasks in %s.", o === y ? "the componentWillUnmount method" : "a useEffect cleanup function");
          } finally {
            g ? $r(i) : ji();
          }
        }
      }
    }
    var iR;
    {
      var O$ = null;
      iR = function(i, o, f) {
        var g = lP(O$, o);
        try {
          return bA(i, o, f);
        } catch (R) {
          if (R !== null && typeof R == "object" && typeof R.then == "function")
            throw R;
          if (no(), BM(), CA(o), lP(o, g), o.mode & Eo && bC(o), Ei(null, bA, null, i, o, f), ai()) {
            var _ = Qr();
            throw _;
          } else
            throw R;
        }
      };
    }
    var ZA = !1, aR;
    aR = /* @__PURE__ */ new Set();
    function D$(i) {
      if (fs && (Zt & Us) !== fi && !q3())
        switch (i.tag) {
          case h:
          case I:
          case U: {
            var o = di && dt(di.type) || "Unknown", f = o;
            if (!aR.has(f)) {
              aR.add(f);
              var g = dt(i.type) || "Unknown";
              l("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://reactjs.org/link/setstate-in-render", g, o, o);
            }
            break;
          }
          case y: {
            ZA || (l("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state."), ZA = !0);
            break;
          }
        }
    }
    var J_ = {
      current: !1
    };
    function JA(i) {
      if ($C.current === !0 && J_.current !== !0) {
        var o = ri;
        try {
          $r(i), l(`It looks like you're using the wrong act() around your test interactions.
Be sure to use the matching version of act() corresponding to your renderer:

// for react-dom:
import {act} from 'react-dom/test-utils';
// ...
act(() => ...);

// for react-test-renderer:
import TestRenderer from react-test-renderer';
const {act} = TestRenderer;
// ...
act(() => ...);`);
        } finally {
          o ? $r(i) : ji();
        }
      }
    }
    function eP(i) {
      (i.mode & Hr) !== Pr && $C.current === !1 && J_.current === !1 && l(`An update to %s ran an effect, but was not wrapped in act(...).

When testing, code that causes React state updates should be wrapped into act(...):

act(() => {
  /* fire events that update state */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`, dt(i.type));
    }
    function M$(i) {
      if (Zt === fi && $C.current === !1 && J_.current === !1) {
        var o = ri;
        try {
          $r(i), l(`An update to %s inside a test was not wrapped in act(...).

When testing, code that causes React state updates should be wrapped into act(...):

act(() => {
  /* fire events that update state */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`, dt(i.type));
        } finally {
          o ? $r(i) : ji();
        }
      }
    }
    var A$ = M$, tP = !1;
    function P$(i) {
      tP === !1 && n.unstable_flushAllWithoutAsserting === void 0 && (i.mode & to || i.mode & od) && (tP = !0, l(`In Concurrent or Sync modes, the "scheduler" module needs to be mocked to guarantee consistent behaviour across tests and browsers. For example, with jest: 
jest.mock('scheduler', () => require('scheduler/unstable_mock'));

For more info, visit https://reactjs.org/link/mock-scheduler`));
    }
    function oR(i, o) {
      return o * 1e3 + i.interactionThreadID;
    }
    function eE(i) {
      Oh === null ? Oh = [i] : Oh.push(i);
    }
    function nP(i, o, f) {
      if (f.size > 0) {
        var g = i.pendingInteractionMap, _ = g.get(o);
        _ != null ? f.forEach(function(z) {
          _.has(z) || z.__count++, _.add(z);
        }) : (g.set(o, new Set(f)), f.forEach(function(z) {
          z.__count++;
        }));
        var R = r.__subscriberRef.current;
        if (R !== null) {
          var N = oR(i, o);
          R.onWorkScheduled(f, N);
        }
      }
    }
    function Bp(i, o) {
      nP(i, o, r.__interactionsRef.current);
    }
    function rP(i, o) {
      var f = /* @__PURE__ */ new Set();
      if (i.pendingInteractionMap.forEach(function(R, N) {
        Bn(o, N) && R.forEach(function(z) {
          return f.add(z);
        });
      }), i.memoizedInteractions = f, f.size > 0) {
        var g = r.__subscriberRef.current;
        if (g !== null) {
          var _ = oR(i, o);
          try {
            g.onWorkStarted(f, _);
          } catch (R) {
            Vc(Qo, function() {
              throw R;
            });
          }
        }
      }
    }
    function iP(i, o) {
      var f = i.pendingLanes, g;
      try {
        if (g = r.__subscriberRef.current, g !== null && i.memoizedInteractions.size > 0) {
          var _ = oR(i, o);
          g.onWorkStopped(i.memoizedInteractions, _);
        }
      } catch (N) {
        Vc(Qo, function() {
          throw N;
        });
      } finally {
        var R = i.pendingInteractionMap;
        R.forEach(function(N, z) {
          Bn(f, z) || (R.delete(z), N.forEach(function(W) {
            if (W.__count--, g !== null && W.__count === 0)
              try {
                g.onInteractionScheduledWorkCompleted(W);
              } catch (ne) {
                Vc(Qo, function() {
                  throw ne;
                });
              }
          }));
        });
      }
    }
    function N$() {
      return k$ > 0;
    }
    var k$ = 0;
    function aP(i) {
      i.sibling = null, i.stateNode = null;
    }
    var Hu = null, Dm = null, I$ = function(i) {
      Hu = i;
    };
    function Mm(i) {
      {
        if (Hu === null)
          return i;
        var o = Hu(i);
        return o === void 0 ? i : o.current;
      }
    }
    function sR(i) {
      return Mm(i);
    }
    function uR(i) {
      {
        if (Hu === null)
          return i;
        var o = Hu(i);
        if (o === void 0) {
          if (i != null && typeof i.render == "function") {
            var f = Mm(i.render);
            if (i.render !== f) {
              var g = {
                $$typeof: uo,
                render: f
              };
              return i.displayName !== void 0 && (g.displayName = i.displayName), g;
            }
          }
          return i;
        }
        return o.current;
      }
    }
    function oP(i, o) {
      {
        if (Hu === null)
          return !1;
        var f = i.elementType, g = o.type, _ = !1, R = typeof g == "object" && g !== null ? g.$$typeof : null;
        switch (i.tag) {
          case y: {
            typeof g == "function" && (_ = !0);
            break;
          }
          case h: {
            (typeof g == "function" || R === Va) && (_ = !0);
            break;
          }
          case I: {
            (R === uo || R === Va) && (_ = !0);
            break;
          }
          case $:
          case U: {
            (R === us || R === Va) && (_ = !0);
            break;
          }
          default:
            return !1;
        }
        if (_) {
          var N = Hu(f);
          if (N !== void 0 && N === Hu(g))
            return !0;
        }
        return !1;
      }
    }
    function sP(i) {
      {
        if (Hu === null || typeof WeakSet != "function")
          return;
        Dm === null && (Dm = /* @__PURE__ */ new WeakSet()), Dm.add(i);
      }
    }
    var L$ = function(i, o) {
      {
        if (Hu === null)
          return;
        var f = o.staleFamilies, g = o.updatedFamilies;
        Yc(), eR(function() {
          lR(i.current, g, f);
        });
      }
    }, B$ = function(i, o) {
      {
        if (i.context !== _o)
          return;
        Yc(), eR(function() {
          F0(o, i, null, null);
        });
      }
    };
    function lR(i, o, f) {
      {
        var g = i.alternate, _ = i.child, R = i.sibling, N = i.tag, z = i.type, W = null;
        switch (N) {
          case h:
          case U:
          case y:
            W = z;
            break;
          case I:
            W = z.render;
            break;
        }
        if (Hu === null)
          throw new Error("Expected resolveFamily to be set during hot reload.");
        var ne = !1, ae = !1;
        if (W !== null) {
          var Pe = Hu(W);
          Pe !== void 0 && (f.has(Pe) ? ae = !0 : o.has(Pe) && (N === y ? ae = !0 : ne = !0));
        }
        Dm !== null && (Dm.has(i) || g !== null && Dm.has(g)) && (ae = !0), ae && (i._debugNeedsRemount = !0), (ae || ne) && io(i, bn, Cn), _ !== null && !ae && lR(_, o, f), R !== null && lR(R, o, f);
      }
    }
    var z$ = function(i, o) {
      {
        var f = /* @__PURE__ */ new Set(), g = new Set(o.map(function(_) {
          return _.current;
        }));
        return cR(i.current, g, f), f;
      }
    };
    function cR(i, o, f) {
      {
        var g = i.child, _ = i.sibling, R = i.tag, N = i.type, z = null;
        switch (R) {
          case h:
          case U:
          case y:
            z = N;
            break;
          case I:
            z = N.render;
            break;
        }
        var W = !1;
        z !== null && o.has(z) && (W = !0), W ? F$(i, f) : g !== null && cR(g, o, f), _ !== null && cR(_, o, f);
      }
    }
    function F$(i, o) {
      {
        var f = $$(i, o);
        if (f)
          return;
        for (var g = i; ; ) {
          switch (g.tag) {
            case C:
              o.add(g.stateNode);
              return;
            case x:
              o.add(g.stateNode.containerInfo);
              return;
            case E:
              o.add(g.stateNode.containerInfo);
              return;
          }
          if (g.return === null)
            throw new Error("Expected to reach root first.");
          g = g.return;
        }
      }
    }
    function $$(i, o) {
      for (var f = i, g = !1; ; ) {
        if (f.tag === C)
          g = !0, o.add(f.stateNode);
        else if (f.child !== null) {
          f.child.return = f, f = f.child;
          continue;
        }
        if (f === i)
          return g;
        for (; f.sibling === null; ) {
          if (f.return === null || f.return === i)
            return g;
          f = f.return;
        }
        f.sibling.return = f.return, f = f.sibling;
      }
      return !1;
    }
    var fR;
    {
      fR = !1;
      try {
        var uP = Object.preventExtensions({});
      } catch {
        fR = !0;
      }
    }
    var U$ = 1;
    function V$(i, o, f, g) {
      this.tag = i, this.key = f, this.elementType = null, this.type = null, this.stateNode = null, this.return = null, this.child = null, this.sibling = null, this.index = 0, this.ref = null, this.pendingProps = o, this.memoizedProps = null, this.updateQueue = null, this.memoizedState = null, this.dependencies = null, this.mode = g, this.flags = Hn, this.nextEffect = null, this.firstEffect = null, this.lastEffect = null, this.lanes = Ge, this.childLanes = Ge, this.alternate = null, this.actualDuration = Number.NaN, this.actualStartTime = Number.NaN, this.selfBaseDuration = Number.NaN, this.treeBaseDuration = Number.NaN, this.actualDuration = 0, this.actualStartTime = -1, this.selfBaseDuration = 0, this.treeBaseDuration = 0, this._debugID = U$++, this._debugSource = null, this._debugOwner = null, this._debugNeedsRemount = !1, this._debugHookTypes = null, !fR && typeof Object.preventExtensions == "function" && Object.preventExtensions(this);
    }
    var js = function(i, o, f, g) {
      return new V$(i, o, f, g);
    };
    function dR(i) {
      var o = i.prototype;
      return !!(o && o.isReactComponent);
    }
    function j$(i) {
      return typeof i == "function" && !dR(i) && i.defaultProps === void 0;
    }
    function W$(i) {
      if (typeof i == "function")
        return dR(i) ? y : h;
      if (i != null) {
        var o = i.$$typeof;
        if (o === uo)
          return I;
        if (o === us)
          return $;
      }
      return b;
    }
    function Mh(i, o) {
      var f = i.alternate;
      f === null ? (f = js(i.tag, o, i.key, i.mode), f.elementType = i.elementType, f.type = i.type, f.stateNode = i.stateNode, f._debugID = i._debugID, f._debugSource = i._debugSource, f._debugOwner = i._debugOwner, f._debugHookTypes = i._debugHookTypes, f.alternate = i, i.alternate = f) : (f.pendingProps = o, f.type = i.type, f.flags = Hn, f.nextEffect = null, f.firstEffect = null, f.lastEffect = null, f.actualDuration = 0, f.actualStartTime = -1), f.childLanes = i.childLanes, f.lanes = i.lanes, f.child = i.child, f.memoizedProps = i.memoizedProps, f.memoizedState = i.memoizedState, f.updateQueue = i.updateQueue;
      var g = i.dependencies;
      switch (f.dependencies = g === null ? null : {
        lanes: g.lanes,
        firstContext: g.firstContext
      }, f.sibling = i.sibling, f.index = i.index, f.ref = i.ref, f.selfBaseDuration = i.selfBaseDuration, f.treeBaseDuration = i.treeBaseDuration, f._debugNeedsRemount = i._debugNeedsRemount, f.tag) {
        case b:
        case h:
        case U:
          f.type = Mm(i.type);
          break;
        case y:
          f.type = sR(i.type);
          break;
        case I:
          f.type = uR(i.type);
          break;
      }
      return f;
    }
    function G$(i, o) {
      i.flags &= nn, i.nextEffect = null, i.firstEffect = null, i.lastEffect = null;
      var f = i.alternate;
      if (f === null)
        i.childLanes = Ge, i.lanes = o, i.child = null, i.memoizedProps = null, i.memoizedState = null, i.updateQueue = null, i.dependencies = null, i.stateNode = null, i.selfBaseDuration = 0, i.treeBaseDuration = 0;
      else {
        i.childLanes = f.childLanes, i.lanes = f.lanes, i.child = f.child, i.memoizedProps = f.memoizedProps, i.memoizedState = f.memoizedState, i.updateQueue = f.updateQueue, i.type = f.type;
        var g = f.dependencies;
        i.dependencies = g === null ? null : {
          lanes: g.lanes,
          firstContext: g.firstContext
        }, i.selfBaseDuration = f.selfBaseDuration, i.treeBaseDuration = f.treeBaseDuration;
      }
      return i;
    }
    function H$(i) {
      var o;
      return i === fm ? o = od | to | Hr : i === V1 ? o = to | Hr : o = Pr, pw && (o |= Eo), js(E, null, null, o);
    }
    function pR(i, o, f, g, _, R) {
      var N = b, z = i;
      if (typeof i == "function")
        dR(i) ? (N = y, z = sR(z)) : z = Mm(z);
      else if (typeof i == "string")
        N = C;
      else {
        e:
          switch (i) {
            case jn:
              return Ah(f.children, _, R, o);
            case ct:
              N = D, _ |= xw;
              break;
            case ss:
              N = D, _ |= Hr;
              break;
            case Ji:
              return Y$(f, _, R, o);
            case ea:
              return q$(f, _, R, o);
            case ta:
              return X$(f, _, R, o);
            case kt:
              return hR(f, _, R, o);
            case mn:
              return K$(f, _, R, o);
            case de:
            default: {
              if (typeof i == "object" && i !== null)
                switch (i.$$typeof) {
                  case so:
                    N = B;
                    break e;
                  case Ua:
                    N = A;
                    break e;
                  case uo:
                    N = I, z = uR(z);
                    break e;
                  case us:
                    N = $;
                    break e;
                  case Va:
                    N = K, z = null;
                    break e;
                  case il:
                    N = se;
                    break e;
                }
              var W = "";
              {
                (i === void 0 || typeof i == "object" && i !== null && Object.keys(i).length === 0) && (W += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
                var ne = g ? dt(g.type) : null;
                ne && (W += `

Check the render method of \`` + ne + "`.");
              }
              throw Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: " + (i == null ? i : typeof i) + "." + W);
            }
          }
      }
      var ae = js(N, f, o, _);
      return ae.elementType = i, ae.type = z, ae.lanes = R, ae._debugOwner = g, ae;
    }
    function vR(i, o, f) {
      var g = null;
      g = i._owner;
      var _ = i.type, R = i.key, N = i.props, z = pR(_, R, N, g, o, f);
      return z._debugSource = i._source, z._debugOwner = i._owner, z;
    }
    function Ah(i, o, f, g) {
      var _ = js(O, i, g, o);
      return _.lanes = f, _;
    }
    function Y$(i, o, f, g) {
      typeof i.id != "string" && l('Profiler must specify an "id" as a prop');
      var _ = js(L, i, g, o | Eo);
      return _.elementType = Ji, _.type = Ji, _.lanes = f, _.stateNode = {
        effectDuration: 0,
        passiveEffectDuration: 0
      }, _;
    }
    function q$(i, o, f, g) {
      var _ = js(k, i, g, o);
      return _.type = ea, _.elementType = ea, _.lanes = f, _;
    }
    function X$(i, o, f, g) {
      var _ = js(J, i, g, o);
      return _.type = ta, _.elementType = ta, _.lanes = f, _;
    }
    function hR(i, o, f, g) {
      var _ = js(pe, i, g, o);
      return _.type = kt, _.elementType = kt, _.lanes = f, _;
    }
    function K$(i, o, f, g) {
      var _ = js(be, i, g, o);
      return _.type = mn, _.elementType = mn, _.lanes = f, _;
    }
    function gR(i, o, f) {
      var g = js(T, i, null, o);
      return g.lanes = f, g;
    }
    function Q$() {
      var i = js(C, null, null, Pr);
      return i.elementType = "DELETED", i.type = "DELETED", i;
    }
    function mR(i, o, f) {
      var g = i.children !== null ? i.children : [], _ = js(x, g, i.key, o);
      return _.lanes = f, _.stateNode = {
        containerInfo: i.containerInfo,
        pendingChildren: null,
        implementation: i.implementation
      }, _;
    }
    function lP(i, o) {
      return i === null && (i = js(b, null, null, Pr)), i.tag = o.tag, i.key = o.key, i.elementType = o.elementType, i.type = o.type, i.stateNode = o.stateNode, i.return = o.return, i.child = o.child, i.sibling = o.sibling, i.index = o.index, i.ref = o.ref, i.pendingProps = o.pendingProps, i.memoizedProps = o.memoizedProps, i.updateQueue = o.updateQueue, i.memoizedState = o.memoizedState, i.dependencies = o.dependencies, i.mode = o.mode, i.flags = o.flags, i.nextEffect = o.nextEffect, i.firstEffect = o.firstEffect, i.lastEffect = o.lastEffect, i.lanes = o.lanes, i.childLanes = o.childLanes, i.alternate = o.alternate, i.actualDuration = o.actualDuration, i.actualStartTime = o.actualStartTime, i.selfBaseDuration = o.selfBaseDuration, i.treeBaseDuration = o.treeBaseDuration, i._debugID = o._debugID, i._debugSource = o._debugSource, i._debugOwner = o._debugOwner, i._debugNeedsRemount = o._debugNeedsRemount, i._debugHookTypes = o._debugHookTypes, i;
    }
    function Z$(i, o, f) {
      switch (this.tag = o, this.containerInfo = i, this.pendingChildren = null, this.current = null, this.pingCache = null, this.finishedWork = null, this.timeoutHandle = n0, this.context = null, this.pendingContext = null, this.hydrate = f, this.callbackNode = null, this.callbackPriority = Ms, this.eventTimes = If(Ge), this.expirationTimes = If(Cn), this.pendingLanes = Ge, this.suspendedLanes = Ge, this.pingedLanes = Ge, this.expiredLanes = Ge, this.mutableReadLanes = Ge, this.finishedLanes = Ge, this.entangledLanes = Ge, this.entanglements = If(Ge), this.mutableSourceEagerHydrationData = null, this.interactionThreadID = r.unstable_getThreadID(), this.memoizedInteractions = /* @__PURE__ */ new Set(), this.pendingInteractionMap = /* @__PURE__ */ new Map(), o) {
        case V1:
          this._debugRootType = "createBlockingRoot()";
          break;
        case fm:
          this._debugRootType = "createRoot()";
          break;
        case c0:
          this._debugRootType = "createLegacyRoot()";
          break;
      }
    }
    function J$(i, o, f, g) {
      var _ = new Z$(i, o, f), R = H$(o);
      return _.current = R, R.stateNode = _, Rw(R), _;
    }
    function eU(i, o) {
      var f = o._getVersion, g = f(o._source);
      i.mutableSourceEagerHydrationData == null ? i.mutableSourceEagerHydrationData = [o, g] : i.mutableSourceEagerHydrationData.push(o, g);
    }
    function tU(i, o, f) {
      var g = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
      return {
        $$typeof: Nt,
        key: g == null ? null : "" + g,
        children: i,
        containerInfo: o,
        implementation: f
      };
    }
    var yR, bR;
    yR = !1, bR = {};
    function nU(i) {
      if (!i)
        return _o;
      var o = Ta(i), f = dw(o);
      if (o.tag === y) {
        var g = o.type;
        if (Fu(g))
          return $1(o, g, f);
      }
      return f;
    }
    function rU(i, o) {
      {
        var f = Ta(i);
        if (f === void 0)
          throw typeof i.render == "function" ? Error("Unable to find node on an unmounted component.") : Error("Argument appears to not be a ReactComponent. Keys: " + Object.keys(i));
        var g = vo(f);
        if (g === null)
          return null;
        if (g.mode & Hr) {
          var _ = dt(f.type) || "Component";
          if (!bR[_]) {
            bR[_] = !0;
            var R = ri;
            try {
              $r(g), f.mode & Hr ? l("%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", o, o, _) : l("%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", o, o, _);
            } finally {
              R ? $r(R) : ji();
            }
          }
        }
        return g.stateNode;
      }
    }
    function iU(i, o, f, g) {
      return J$(i, o, f);
    }
    function F0(i, o, f, g) {
      f0(o, i);
      var _ = o.current, R = Vs();
      typeof jest < "u" && (P$(_), JA(_));
      var N = Ip(_), z = nU(f);
      o.context === null ? o.context = z : o.pendingContext = z, fs && ri !== null && !yR && (yR = !0, l(`Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.

Check the render method of %s.`, dt(ri.type) || "Unknown"));
      var W = Mp(R, N);
      return W.payload = {
        element: i
      }, g = g === void 0 ? null : g, g !== null && (typeof g != "function" && l("render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", g), W.callback = g), Ap(_, W), io(_, N, R), N;
    }
    function _R(i) {
      var o = i.current;
      if (!o.child)
        return null;
      switch (o.child.tag) {
        case C:
          return o.child.stateNode;
        default:
          return o.child.stateNode;
      }
    }
    function cP(i, o) {
      var f = i.memoizedState;
      f !== null && f.dehydrated !== null && (f.retryLane = ua(f.retryLane, o));
    }
    function ER(i, o) {
      cP(i, o);
      var f = i.alternate;
      f && cP(f, o);
    }
    function aU(i) {
      if (i.tag === k) {
        var o = Vs(), f = Pl;
        io(i, f, o), ER(i, f);
      }
    }
    function oU(i) {
      if (i.tag === k) {
        var o = Vs(), f = Qd;
        io(i, f, o), ER(i, f);
      }
    }
    function sU(i) {
      if (i.tag === k) {
        var o = Vs(), f = Ip(i);
        io(i, f, o), ER(i, f);
      }
    }
    function uU(i, o) {
      try {
        return o();
      } finally {
      }
    }
    function fP(i) {
      var o = Av(i);
      return o === null ? null : o.tag === Q ? o.stateNode.instance : o.stateNode;
    }
    var dP = function(i) {
      return !1;
    };
    function lU(i) {
      return dP(i);
    }
    var pP = null, vP = null, hP = null, gP = null, mP = null, yP = null, bP = null, _P = null;
    {
      var EP = function(i, o, f) {
        var g = o[f], _ = Array.isArray(i) ? i.slice() : t({}, i);
        return f + 1 === o.length ? (Array.isArray(_) ? _.splice(g, 1) : delete _[g], _) : (_[g] = EP(i[g], o, f + 1), _);
      }, xP = function(i, o) {
        return EP(i, o, 0);
      }, SP = function(i, o, f, g) {
        var _ = o[g], R = Array.isArray(i) ? i.slice() : t({}, i);
        if (g + 1 === o.length) {
          var N = f[g];
          R[N] = R[_], Array.isArray(R) ? R.splice(_, 1) : delete R[_];
        } else
          R[_] = SP(
            i[_],
            o,
            f,
            g + 1
          );
        return R;
      }, wP = function(i, o, f) {
        if (o.length !== f.length) {
          s("copyWithRename() expects paths of the same length");
          return;
        } else
          for (var g = 0; g < f.length - 1; g++)
            if (o[g] !== f[g]) {
              s("copyWithRename() expects paths to be the same except for the deepest key");
              return;
            }
        return SP(i, o, f, 0);
      }, CP = function(i, o, f, g) {
        if (f >= o.length)
          return g;
        var _ = o[f], R = Array.isArray(i) ? i.slice() : t({}, i);
        return R[_] = CP(i[_], o, f + 1, g), R;
      }, RP = function(i, o, f) {
        return CP(i, o, 0, f);
      }, xR = function(i, o) {
        for (var f = i.memoizedState; f !== null && o > 0; )
          f = f.next, o--;
        return f;
      };
      pP = function(i, o, f, g) {
        var _ = xR(i, o);
        if (_ !== null) {
          var R = RP(_.memoizedState, f, g);
          _.memoizedState = R, _.baseState = R, i.memoizedProps = t({}, i.memoizedProps), io(i, bn, Cn);
        }
      }, vP = function(i, o, f) {
        var g = xR(i, o);
        if (g !== null) {
          var _ = xP(g.memoizedState, f);
          g.memoizedState = _, g.baseState = _, i.memoizedProps = t({}, i.memoizedProps), io(i, bn, Cn);
        }
      }, hP = function(i, o, f, g) {
        var _ = xR(i, o);
        if (_ !== null) {
          var R = wP(_.memoizedState, f, g);
          _.memoizedState = R, _.baseState = R, i.memoizedProps = t({}, i.memoizedProps), io(i, bn, Cn);
        }
      }, gP = function(i, o, f) {
        i.pendingProps = RP(i.memoizedProps, o, f), i.alternate && (i.alternate.pendingProps = i.pendingProps), io(i, bn, Cn);
      }, mP = function(i, o) {
        i.pendingProps = xP(i.memoizedProps, o), i.alternate && (i.alternate.pendingProps = i.pendingProps), io(i, bn, Cn);
      }, yP = function(i, o, f) {
        i.pendingProps = wP(i.memoizedProps, o, f), i.alternate && (i.alternate.pendingProps = i.pendingProps), io(i, bn, Cn);
      }, bP = function(i) {
        io(i, bn, Cn);
      }, _P = function(i) {
        dP = i;
      };
    }
    function cU(i) {
      var o = vo(i);
      return o === null ? null : o.stateNode;
    }
    function fU(i) {
      return null;
    }
    function dU() {
      return ri;
    }
    function pU(i) {
      var o = i.findFiberByHostInstance, f = a.ReactCurrentDispatcher;
      return vw({
        bundleType: i.bundleType,
        version: i.version,
        rendererPackageName: i.rendererPackageName,
        rendererConfig: i.rendererConfig,
        overrideHookState: pP,
        overrideHookStateDeletePath: vP,
        overrideHookStateRenamePath: hP,
        overrideProps: gP,
        overridePropsDeletePath: mP,
        overridePropsRenamePath: yP,
        setSuspenseHandler: _P,
        scheduleUpdate: bP,
        currentDispatcherRef: f,
        findHostInstanceByFiber: cU,
        findFiberByHostInstance: o || fU,
        findHostInstancesForRefresh: z$,
        scheduleRefresh: L$,
        scheduleRoot: B$,
        setRefreshHandler: I$,
        getCurrentFiber: dU
      });
    }
    function SR(i, o, f) {
      this._internalRoot = vU(i, o, f);
    }
    SR.prototype.render = function(i) {
      var o = this._internalRoot;
      {
        typeof arguments[1] == "function" && l("render(...): does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
        var f = o.containerInfo;
        if (f.nodeType !== _i) {
          var g = fP(o.current);
          g && g.parentNode !== f && l("render(...): It looks like the React-rendered content of the root container was removed without using React. This is not supported and will cause errors. Instead, call root.unmount() to empty a root's container.");
        }
      }
      F0(i, o, null, null);
    }, SR.prototype.unmount = function() {
      typeof arguments[0] == "function" && l("unmount(...): does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
      var i = this._internalRoot, o = i.containerInfo;
      F0(null, i, null, function() {
        k1(o);
      });
    };
    function vU(i, o, f) {
      var g = f != null && f.hydrate === !0;
      f != null && f.hydrationOptions;
      var _ = f != null && f.hydrationOptions != null && f.hydrationOptions.mutableSources || null, R = iU(i, o, g);
      N1(R.current, i), i.nodeType;
      {
        var N = i.nodeType === _i ? i.parentNode : i;
        Jy(N);
      }
      if (_)
        for (var z = 0; z < _.length; z++) {
          var W = _[z];
          eU(R, W);
        }
      return R;
    }
    function hU(i, o) {
      return new SR(i, c0, o);
    }
    function Am(i) {
      return !!(i && (i.nodeType === aa || i.nodeType === lu || i.nodeType === dg || i.nodeType === _i && i.nodeValue === " react-mount-point-unstable "));
    }
    var gU = a.ReactCurrentOwner, TP, OP = !1;
    TP = function(i) {
      if (i._reactRootContainer && i.nodeType !== _i) {
        var o = fP(i._reactRootContainer._internalRoot.current);
        o && o.parentNode !== i && l("render(...): It looks like the React-rendered content of this container was removed without using React. This is not supported and will cause errors. Instead, call ReactDOM.unmountComponentAtNode to empty a container.");
      }
      var f = !!i._reactRootContainer, g = tE(i), _ = !!(g && Fc(g));
      _ && !f && l("render(...): Replacing React-rendered children with a new root component. If you intended to update the children of this node, you should instead have the existing children update their state and render the new components instead of calling ReactDOM.render."), i.nodeType === aa && i.tagName && i.tagName.toUpperCase() === "BODY" && l("render(): Rendering components directly into document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try rendering into a container element created for your app.");
    };
    function tE(i) {
      return i ? i.nodeType === lu ? i.documentElement : i.firstChild : null;
    }
    function mU(i) {
      var o = tE(i);
      return !!(o && o.nodeType === aa && o.hasAttribute(Tt));
    }
    function yU(i, o) {
      var f = o || mU(i);
      if (!f)
        for (var g = !1, _; _ = i.lastChild; )
          !g && _.nodeType === aa && _.hasAttribute(Tt) && (g = !0, l("render(): Target node has markup rendered by React, but there are unrelated nodes as well. This is most commonly caused by white-space inserted around server-rendered markup.")), i.removeChild(_);
      return f && !o && !OP && (OP = !0, s("render(): Calling ReactDOM.render() to hydrate server-rendered markup will stop working in React v18. Replace the ReactDOM.render() call with ReactDOM.hydrate() if you want React to attach to the server HTML.")), hU(i, f ? {
        hydrate: !0
      } : void 0);
    }
    function bU(i, o) {
      i !== null && typeof i != "function" && l("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", o, i);
    }
    function nE(i, o, f, g, _) {
      TP(f), bU(_ === void 0 ? null : _, "render");
      var R = f._reactRootContainer, N;
      if (R) {
        if (N = R._internalRoot, typeof _ == "function") {
          var W = _;
          _ = function() {
            var ne = _R(N);
            W.call(ne);
          };
        }
        F0(o, N, i, _);
      } else {
        if (R = f._reactRootContainer = yU(f, g), N = R._internalRoot, typeof _ == "function") {
          var z = _;
          _ = function() {
            var ne = _R(N);
            z.call(ne);
          };
        }
        jA(function() {
          F0(o, N, i, _);
        });
      }
      return _R(N);
    }
    function _U(i) {
      {
        var o = gU.current;
        if (o !== null && o.stateNode !== null) {
          var f = o.stateNode._warnedAboutRefsInRender;
          f || l("%s is accessing findDOMNode inside its render(). render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", dt(o.type) || "A component"), o.stateNode._warnedAboutRefsInRender = !0;
        }
      }
      return i == null ? null : i.nodeType === aa ? i : rU(i, "findDOMNode");
    }
    function EU(i, o, f) {
      if (!Am(o))
        throw Error("Target container is not a DOM element.");
      {
        var g = am(o) && o._reactRootContainer === void 0;
        g && l("You are calling ReactDOM.hydrate() on a container that was previously passed to ReactDOM.createRoot(). This is not supported. Did you mean to call createRoot(container, {hydrate: true}).render(element)?");
      }
      return nE(null, i, o, !0, f);
    }
    function xU(i, o, f) {
      if (!Am(o))
        throw Error("Target container is not a DOM element.");
      {
        var g = am(o) && o._reactRootContainer === void 0;
        g && l("You are calling ReactDOM.render() on a container that was previously passed to ReactDOM.createRoot(). This is not supported. Did you mean to call root.render(element)?");
      }
      return nE(null, i, o, !1, f);
    }
    function SU(i, o, f, g) {
      if (!Am(f))
        throw Error("Target container is not a DOM element.");
      if (!(i != null && bf(i)))
        throw Error("parentComponent must be a valid React Component");
      return nE(i, o, f, !1, g);
    }
    function wU(i) {
      if (!Am(i))
        throw Error("unmountComponentAtNode(...): Target container is not a DOM element.");
      {
        var o = am(i) && i._reactRootContainer === void 0;
        o && l("You are calling ReactDOM.unmountComponentAtNode() on a container that was previously passed to ReactDOM.createRoot(). This is not supported. Did you mean to call root.unmount()?");
      }
      if (i._reactRootContainer) {
        {
          var f = tE(i), g = f && !Fc(f);
          g && l("unmountComponentAtNode(): The node you're attempting to unmount was rendered by another copy of React.");
        }
        return jA(function() {
          nE(null, null, i, !1, function() {
            i._reactRootContainer = null, k1(i);
          });
        }), !0;
      } else {
        {
          var _ = tE(i), R = !!(_ && Fc(_)), N = i.nodeType === aa && Am(i.parentNode) && !!i.parentNode._reactRootContainer;
          R && l("unmountComponentAtNode(): The node you're attempting to unmount was rendered by React and is not a top-level container. %s", N ? "You may have accidentally passed in a React root node instead of its container." : "Instead, have the parent component update its state and rerender in order to remove this component.");
        }
        return !1;
      }
    }
    Yd(aU), gu(oU), xc(sU), El(uU);
    var DP = !1;
    (typeof Map != "function" || Map.prototype == null || typeof Map.prototype.forEach != "function" || typeof Set != "function" || Set.prototype == null || typeof Set.prototype.clear != "function" || typeof Set.prototype.forEach != "function") && l("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"), Cv(cn), Vd(VA, t$, ZF, e$);
    function MP(i, o) {
      var f = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
      if (!Am(o))
        throw Error("Target container is not a DOM element.");
      return tU(i, o, null, f);
    }
    function CU(i, o, f, g) {
      return SU(i, o, f, g);
    }
    function RU(i, o) {
      var f = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
      return DP || (DP = !0, s('The ReactDOM.unstable_createPortal() alias has been deprecated, and will be removed in React 18+. Update your code to use ReactDOM.createPortal() instead. It has the exact same API, but without the "unstable_" prefix.')), MP(i, o, f);
    }
    var TU = {
      Events: [
        Fc,
        Fs,
        om,
        yc,
        Po,
        Yc,
        J_
      ]
    }, OU = pU({
      findFiberByHostInstance: id,
      bundleType: 1,
      version: e_,
      rendererPackageName: "react-dom"
    });
    if (!OU && ee && window.top === window.self && (navigator.userAgent.indexOf("Chrome") > -1 && navigator.userAgent.indexOf("Edge") === -1 || navigator.userAgent.indexOf("Firefox") > -1)) {
      var AP = window.location.protocol;
      /^(https?|file):$/.test(AP) && console.info("%cDownload the React DevTools for a better development experience: https://reactjs.org/link/react-devtools" + (AP === "file:" ? `
You might need to use a local HTTP server (instead of file://): https://reactjs.org/link/react-devtools-faq` : ""), "font-weight:bold");
    }
    Gs.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = TU, Gs.createPortal = MP, Gs.findDOMNode = _U, Gs.flushSync = eR, Gs.hydrate = EU, Gs.render = xU, Gs.unmountComponentAtNode = wU, Gs.unstable_batchedUpdates = VA, Gs.unstable_createPortal = RU, Gs.unstable_renderSubtreeIntoContainer = CU, Gs.version = e_;
  }()), Gs;
}
(function(e) {
  function t() {
    if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) {
      if (process.env.NODE_ENV !== "production")
        throw new Error("^_^");
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(t);
      } catch (n) {
        console.error(n);
      }
    }
  }
  process.env.NODE_ENV === "production" ? (t(), e.exports = L4()) : e.exports = $4();
})(Bx);
const lE = /* @__PURE__ */ kU(Bx.exports);
function U4(e) {
  e();
}
function V4(e) {
  e || (e = U4, process.env.NODE_ENV !== "production" && console.warn("[MobX] Failed to get unstable_batched updates from react-dom / react-native")), f4({ reactionScheduler: e });
}
function j4(e) {
  return WI(e);
}
var W4 = 1e4, G4 = 1e4, H4 = function() {
  function e(t) {
    var n = this;
    Object.defineProperty(this, "finalize", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }), Object.defineProperty(this, "registrations", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: /* @__PURE__ */ new Map()
    }), Object.defineProperty(this, "sweepTimeout", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "sweep", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: function(r) {
        r === void 0 && (r = W4), clearTimeout(n.sweepTimeout), n.sweepTimeout = void 0;
        var a = Date.now();
        n.registrations.forEach(function(s, l) {
          a - s.registeredAt >= r && (n.finalize(s.value), n.registrations.delete(l));
        }), n.registrations.size > 0 && n.scheduleSweep();
      }
    }), Object.defineProperty(this, "finalizeAllImmediately", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: function() {
        n.sweep(0);
      }
    });
  }
  return Object.defineProperty(e.prototype, "register", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function(t, n, r) {
      this.registrations.set(r, {
        value: n,
        registeredAt: Date.now()
      }), this.scheduleSweep();
    }
  }), Object.defineProperty(e.prototype, "unregister", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function(t) {
      this.registrations.delete(t);
    }
  }), Object.defineProperty(e.prototype, "scheduleSweep", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function() {
      this.sweepTimeout === void 0 && (this.sweepTimeout = setTimeout(this.sweep, G4));
    }
  }), e;
}(), Y4 = typeof FinalizationRegistry < "u" ? FinalizationRegistry : H4, RT = new Y4(function(e) {
  var t;
  (t = e.reaction) === null || t === void 0 || t.dispose(), e.reaction = null;
}), CN = globalThis && globalThis.__read || function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n)
    return e;
  var r = n.call(e), a, s = [], l;
  try {
    for (; (t === void 0 || t-- > 0) && !(a = r.next()).done; )
      s.push(a.value);
  } catch (p) {
    l = { error: p };
  } finally {
    try {
      a && !a.done && (n = r.return) && n.call(r);
    } finally {
      if (l)
        throw l.error;
    }
  }
  return s;
};
function RN(e) {
  return "observer".concat(e);
}
var q4 = function() {
  function e() {
  }
  return e;
}();
function X4() {
  return new q4();
}
function aL(e, t) {
  t === void 0 && (t = "observed");
  var n = CN(Wt.useState(X4), 1), r = n[0], a = CN(Wt.useState(), 2), s = a[1], l = function() {
    return s([]);
  }, p = Wt.useRef(null);
  p.current || (p.current = {
    reaction: null,
    mounted: !1,
    changedBeforeMount: !1
  });
  var h = p.current;
  h.reaction || (h.reaction = new hy(RN(t), function() {
    h.mounted ? l() : h.changedBeforeMount = !0;
  }), RT.register(r, h, h)), Wt.useDebugValue(h.reaction, j4), Wt.useEffect(function() {
    return RT.unregister(h), h.mounted = !0, h.reaction ? h.changedBeforeMount && (h.changedBeforeMount = !1, l()) : (h.reaction = new hy(RN(t), function() {
      l();
    }), l()), function() {
      h.reaction.dispose(), h.reaction = null, h.mounted = !1, h.changedBeforeMount = !1;
    };
  }, []);
  var y, b;
  if (h.reaction.track(function() {
    try {
      y = e();
    } catch (E) {
      b = E;
    }
  }), b)
    throw b;
  return y;
}
var TN = !0, oL = typeof Symbol == "function" && Symbol.for, ON = oL ? Symbol.for("react.forward_ref") : typeof HE == "function" && HE(function(e) {
  return null;
}).$$typeof, DN = oL ? Symbol.for("react.memo") : typeof fT == "function" && fT(function(e) {
  return null;
}).$$typeof;
function K4(e, t) {
  var n;
  if (process.env.NODE_ENV !== "production" && TN && t && (TN = !1, console.warn("[mobx-react-lite] `observer(fn, { forwardRef: true })` is deprecated, use `observer(React.forwardRef(fn))`")), DN && e.$$typeof === DN)
    throw new Error("[mobx-react-lite] You are trying to use `observer` on a function component wrapped in either another `observer` or `React.memo`. The observer already applies 'React.memo' for you.");
  var r = (n = t == null ? void 0 : t.forwardRef) !== null && n !== void 0 ? n : !1, a = e, s = e.displayName || e.name;
  if (ON && e.$$typeof === ON && (r = !0, a = e.render, typeof a != "function"))
    throw new Error("[mobx-react-lite] `render` property of ForwardRef was not a function");
  var l = function(p, h) {
    return aL(function() {
      return a(p, h);
    }, s);
  };
  return s !== "" && (l.displayName = s), e.contextTypes && (l.contextTypes = e.contextTypes), r && (l = HE(l)), l = fT(l), Z4(e, l), process.env.NODE_ENV !== "production" && Object.defineProperty(l, "contextTypes", {
    set: function() {
      var p;
      throw new Error("[mobx-react-lite] `".concat(this.displayName || ((p = this.type) === null || p === void 0 ? void 0 : p.displayName) || "Component", ".contextTypes` must be set before applying `observer`."));
    }
  }), l;
}
var Q4 = {
  $$typeof: !0,
  render: !0,
  compare: !0,
  type: !0,
  displayName: !0
};
function Z4(e, t) {
  Object.keys(e).forEach(function(n) {
    Q4[n] || Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(e, n));
  });
}
function ac(e) {
  var t = e.children, n = e.render, r = t || n;
  return typeof r != "function" ? null : aL(r);
}
process.env.NODE_ENV !== "production" && (ac.propTypes = {
  children: MN,
  render: MN
});
ac.displayName = "Observer";
function MN(e, t, n, r, a) {
  var s = t === "children" ? "render" : "children", l = typeof e[t] == "function", p = typeof e[s] == "function";
  return l && p ? new Error("MobX Observer: Do not use children and render in the same time in`" + n) : l || p ? null : new Error("Invalid prop `" + a + "` of type `" + typeof e[t] + "` supplied to `" + n + "`, expected `function`.");
}
globalThis && globalThis.__read;
var UR;
V4(Bx.exports.unstable_batchedUpdates);
UR = RT.finalizeAllImmediately;
var QO = { exports: {} }, Pm = {};
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var AN;
function J4() {
  if (AN)
    return Pm;
  AN = 1, Tb();
  var e = Wt, t = 60103;
  if (Pm.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var n = Symbol.for;
    t = n("react.element"), Pm.Fragment = n("react.fragment");
  }
  var r = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = Object.prototype.hasOwnProperty, s = { key: !0, ref: !0, __self: !0, __source: !0 };
  function l(p, h, y) {
    var b, E = {}, x = null, C = null;
    y !== void 0 && (x = "" + y), h.key !== void 0 && (x = "" + h.key), h.ref !== void 0 && (C = h.ref);
    for (b in h)
      a.call(h, b) && !s.hasOwnProperty(b) && (E[b] = h[b]);
    if (p && p.defaultProps)
      for (b in h = p.defaultProps, h)
        E[b] === void 0 && (E[b] = h[b]);
    return { $$typeof: t, type: p, key: x, ref: C, props: E, _owner: r.current };
  }
  return Pm.jsx = l, Pm.jsxs = l, Pm;
}
var VR = {};
/** @license React v17.0.2
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var PN;
function e5() {
  return PN || (PN = 1, function(e) {
    process.env.NODE_ENV !== "production" && function() {
      var t = Wt, n = Tb(), r = 60103, a = 60106;
      e.Fragment = 60107;
      var s = 60108, l = 60114, p = 60109, h = 60110, y = 60112, b = 60113, E = 60120, x = 60115, C = 60116, T = 60121, O = 60122, D = 60117, A = 60129, B = 60131;
      if (typeof Symbol == "function" && Symbol.for) {
        var I = Symbol.for;
        r = I("react.element"), a = I("react.portal"), e.Fragment = I("react.fragment"), s = I("react.strict_mode"), l = I("react.profiler"), p = I("react.provider"), h = I("react.context"), y = I("react.forward_ref"), b = I("react.suspense"), E = I("react.suspense_list"), x = I("react.memo"), C = I("react.lazy"), T = I("react.block"), O = I("react.server.block"), D = I("react.fundamental"), I("react.scope"), I("react.opaque.id"), A = I("react.debug_trace_mode"), I("react.offscreen"), B = I("react.legacy_hidden");
      }
      var L = typeof Symbol == "function" && Symbol.iterator, k = "@@iterator";
      function $(de) {
        if (de === null || typeof de != "object")
          return null;
        var tt = L && de[L] || de[k];
        return typeof tt == "function" ? tt : null;
      }
      var U = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function K(de) {
        {
          for (var tt = arguments.length, ct = new Array(tt > 1 ? tt - 1 : 0), kt = 1; kt < tt; kt++)
            ct[kt - 1] = arguments[kt];
          X("error", de, ct);
        }
      }
      function X(de, tt, ct) {
        {
          var kt = U.ReactDebugCurrentFrame, mn = kt.getStackAddendum();
          mn !== "" && (tt += "%s", ct = ct.concat([mn]));
          var zt = ct.map(function(yn) {
            return "" + yn;
          });
          zt.unshift("Warning: " + tt), Function.prototype.apply.call(console[de], console, zt);
        }
      }
      var Y = !1;
      function J(de) {
        return !!(typeof de == "string" || typeof de == "function" || de === e.Fragment || de === l || de === A || de === s || de === b || de === E || de === B || Y || typeof de == "object" && de !== null && (de.$$typeof === C || de.$$typeof === x || de.$$typeof === p || de.$$typeof === h || de.$$typeof === y || de.$$typeof === D || de.$$typeof === T || de[0] === O));
      }
      function Q(de, tt, ct) {
        var kt = tt.displayName || tt.name || "";
        return de.displayName || (kt !== "" ? ct + "(" + kt + ")" : ct);
      }
      function Z(de) {
        return de.displayName || "Context";
      }
      function se(de) {
        if (de == null)
          return null;
        if (typeof de.tag == "number" && K("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof de == "function")
          return de.displayName || de.name || null;
        if (typeof de == "string")
          return de;
        switch (de) {
          case e.Fragment:
            return "Fragment";
          case a:
            return "Portal";
          case l:
            return "Profiler";
          case s:
            return "StrictMode";
          case b:
            return "Suspense";
          case E:
            return "SuspenseList";
        }
        if (typeof de == "object")
          switch (de.$$typeof) {
            case h:
              var tt = de;
              return Z(tt) + ".Consumer";
            case p:
              var ct = de;
              return Z(ct._context) + ".Provider";
            case y:
              return Q(de, de.render, "ForwardRef");
            case x:
              return se(de.type);
            case T:
              return se(de._render);
            case C: {
              var kt = de, mn = kt._payload, zt = kt._init;
              try {
                return se(zt(mn));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var pe = 0, be, _e, Se, Oe, re, ie, ce;
      function le() {
      }
      le.__reactDisabledLog = !0;
      function fe() {
        {
          if (pe === 0) {
            be = console.log, _e = console.info, Se = console.warn, Oe = console.error, re = console.group, ie = console.groupCollapsed, ce = console.groupEnd;
            var de = {
              configurable: !0,
              enumerable: !0,
              value: le,
              writable: !0
            };
            Object.defineProperties(console, {
              info: de,
              log: de,
              warn: de,
              error: de,
              group: de,
              groupCollapsed: de,
              groupEnd: de
            });
          }
          pe++;
        }
      }
      function ve() {
        {
          if (pe--, pe === 0) {
            var de = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: n({}, de, {
                value: be
              }),
              info: n({}, de, {
                value: _e
              }),
              warn: n({}, de, {
                value: Se
              }),
              error: n({}, de, {
                value: Oe
              }),
              group: n({}, de, {
                value: re
              }),
              groupCollapsed: n({}, de, {
                value: ie
              }),
              groupEnd: n({}, de, {
                value: ce
              })
            });
          }
          pe < 0 && K("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var ee = U.ReactCurrentDispatcher, Ae;
      function he(de, tt, ct) {
        {
          if (Ae === void 0)
            try {
              throw Error();
            } catch (mn) {
              var kt = mn.stack.trim().match(/\n( *(at )?)/);
              Ae = kt && kt[1] || "";
            }
          return `
` + Ae + de;
        }
      }
      var Fe = !1, Ne;
      {
        var xe = typeof WeakMap == "function" ? WeakMap : Map;
        Ne = new xe();
      }
      function oe(de, tt) {
        if (!de || Fe)
          return "";
        {
          var ct = Ne.get(de);
          if (ct !== void 0)
            return ct;
        }
        var kt;
        Fe = !0;
        var mn = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var zt;
        zt = ee.current, ee.current = null, fe();
        try {
          if (tt) {
            var yn = function() {
              throw Error();
            };
            if (Object.defineProperty(yn.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(yn, []);
              } catch (Vi) {
                kt = Vi;
              }
              Reflect.construct(de, [], yn);
            } else {
              try {
                yn.call();
              } catch (Vi) {
                kt = Vi;
              }
              de.call(yn.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (Vi) {
              kt = Vi;
            }
            de();
          }
        } catch (Vi) {
          if (Vi && kt && typeof Vi.stack == "string") {
            for (var Sn = Vi.stack.split(`
`), Kn = kt.stack.split(`
`), Fn = Sn.length - 1, Qn = Kn.length - 1; Fn >= 1 && Qn >= 0 && Sn[Fn] !== Kn[Qn]; )
              Qn--;
            for (; Fn >= 1 && Qn >= 0; Fn--, Qn--)
              if (Sn[Fn] !== Kn[Qn]) {
                if (Fn !== 1 || Qn !== 1)
                  do
                    if (Fn--, Qn--, Qn < 0 || Sn[Fn] !== Kn[Qn]) {
                      var Ea = `
` + Sn[Fn].replace(" at new ", " at ");
                      return typeof de == "function" && Ne.set(de, Ea), Ea;
                    }
                  while (Fn >= 1 && Qn >= 0);
                break;
              }
          }
        } finally {
          Fe = !1, ee.current = zt, ve(), Error.prepareStackTrace = mn;
        }
        var xa = de ? de.displayName || de.name : "", ru = xa ? he(xa) : "";
        return typeof de == "function" && Ne.set(de, ru), ru;
      }
      function it(de, tt, ct) {
        return oe(de, !1);
      }
      function Le(de) {
        var tt = de.prototype;
        return !!(tt && tt.isReactComponent);
      }
      function qe(de, tt, ct) {
        if (de == null)
          return "";
        if (typeof de == "function")
          return oe(de, Le(de));
        if (typeof de == "string")
          return he(de);
        switch (de) {
          case b:
            return he("Suspense");
          case E:
            return he("SuspenseList");
        }
        if (typeof de == "object")
          switch (de.$$typeof) {
            case y:
              return it(de.render);
            case x:
              return qe(de.type, tt, ct);
            case T:
              return it(de._render);
            case C: {
              var kt = de, mn = kt._payload, zt = kt._init;
              try {
                return qe(zt(mn), tt, ct);
              } catch {
              }
            }
          }
        return "";
      }
      var Tt = {}, Qe = U.ReactDebugCurrentFrame;
      function pt(de) {
        if (de) {
          var tt = de._owner, ct = qe(de.type, de._source, tt ? tt.type : null);
          Qe.setExtraStackFrame(ct);
        } else
          Qe.setExtraStackFrame(null);
      }
      function en(de, tt, ct, kt, mn) {
        {
          var zt = Function.call.bind(Object.prototype.hasOwnProperty);
          for (var yn in de)
            if (zt(de, yn)) {
              var Sn = void 0;
              try {
                if (typeof de[yn] != "function") {
                  var Kn = Error((kt || "React class") + ": " + ct + " type `" + yn + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof de[yn] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw Kn.name = "Invariant Violation", Kn;
                }
                Sn = de[yn](tt, yn, kt, ct, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (Fn) {
                Sn = Fn;
              }
              Sn && !(Sn instanceof Error) && (pt(mn), K("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", kt || "React class", ct, yn, typeof Sn), pt(null)), Sn instanceof Error && !(Sn.message in Tt) && (Tt[Sn.message] = !0, pt(mn), K("Failed %s type: %s", ct, Sn.message), pt(null));
            }
        }
      }
      var wt = U.ReactCurrentOwner, tn = Object.prototype.hasOwnProperty, Vn = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, Kt, ft, Gt;
      Gt = {};
      function xn(de) {
        if (tn.call(de, "ref")) {
          var tt = Object.getOwnPropertyDescriptor(de, "ref").get;
          if (tt && tt.isReactWarning)
            return !1;
        }
        return de.ref !== void 0;
      }
      function gn(de) {
        if (tn.call(de, "key")) {
          var tt = Object.getOwnPropertyDescriptor(de, "key").get;
          if (tt && tt.isReactWarning)
            return !1;
        }
        return de.key !== void 0;
      }
      function rr(de, tt) {
        if (typeof de.ref == "string" && wt.current && tt && wt.current.stateNode !== tt) {
          var ct = se(wt.current.type);
          Gt[ct] || (K('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', se(wt.current.type), de.ref), Gt[ct] = !0);
        }
      }
      function Zi(de, tt) {
        {
          var ct = function() {
            Kt || (Kt = !0, K("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", tt));
          };
          ct.isReactWarning = !0, Object.defineProperty(de, "key", {
            get: ct,
            configurable: !0
          });
        }
      }
      function At(de, tt) {
        {
          var ct = function() {
            ft || (ft = !0, K("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", tt));
          };
          ct.isReactWarning = !0, Object.defineProperty(de, "ref", {
            get: ct,
            configurable: !0
          });
        }
      }
      var at = function(de, tt, ct, kt, mn, zt, yn) {
        var Sn = {
          $$typeof: r,
          type: de,
          key: tt,
          ref: ct,
          props: yn,
          _owner: zt
        };
        return Sn._store = {}, Object.defineProperty(Sn._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(Sn, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: kt
        }), Object.defineProperty(Sn, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: mn
        }), Object.freeze && (Object.freeze(Sn.props), Object.freeze(Sn)), Sn;
      };
      function bt(de, tt, ct, kt, mn) {
        {
          var zt, yn = {}, Sn = null, Kn = null;
          ct !== void 0 && (Sn = "" + ct), gn(tt) && (Sn = "" + tt.key), xn(tt) && (Kn = tt.ref, rr(tt, mn));
          for (zt in tt)
            tn.call(tt, zt) && !Vn.hasOwnProperty(zt) && (yn[zt] = tt[zt]);
          if (de && de.defaultProps) {
            var Fn = de.defaultProps;
            for (zt in Fn)
              yn[zt] === void 0 && (yn[zt] = Fn[zt]);
          }
          if (Sn || Kn) {
            var Qn = typeof de == "function" ? de.displayName || de.name || "Unknown" : de;
            Sn && Zi(yn, Qn), Kn && At(yn, Qn);
          }
          return at(de, Sn, Kn, mn, kt, wt.current, yn);
        }
      }
      var Pt = U.ReactCurrentOwner, dn = U.ReactDebugCurrentFrame;
      function Nn(de) {
        if (de) {
          var tt = de._owner, ct = qe(de.type, de._source, tt ? tt.type : null);
          dn.setExtraStackFrame(ct);
        } else
          dn.setExtraStackFrame(null);
      }
      var kn;
      kn = !1;
      function In(de) {
        return typeof de == "object" && de !== null && de.$$typeof === r;
      }
      function Cr() {
        {
          if (Pt.current) {
            var de = se(Pt.current.type);
            if (de)
              return `

Check the render method of \`` + de + "`.";
          }
          return "";
        }
      }
      function Nt(de) {
        {
          if (de !== void 0) {
            var tt = de.fileName.replace(/^.*[\\\/]/, ""), ct = de.lineNumber;
            return `

Check your code at ` + tt + ":" + ct + ".";
          }
          return "";
        }
      }
      var jn = {};
      function ss(de) {
        {
          var tt = Cr();
          if (!tt) {
            var ct = typeof de == "string" ? de : de.displayName || de.name;
            ct && (tt = `

Check the top-level render call using <` + ct + ">.");
          }
          return tt;
        }
      }
      function Ji(de, tt) {
        {
          if (!de._store || de._store.validated || de.key != null)
            return;
          de._store.validated = !0;
          var ct = ss(tt);
          if (jn[ct])
            return;
          jn[ct] = !0;
          var kt = "";
          de && de._owner && de._owner !== Pt.current && (kt = " It was passed a child from " + se(de._owner.type) + "."), Nn(de), K('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', ct, kt), Nn(null);
        }
      }
      function so(de, tt) {
        {
          if (typeof de != "object")
            return;
          if (Array.isArray(de))
            for (var ct = 0; ct < de.length; ct++) {
              var kt = de[ct];
              In(kt) && Ji(kt, tt);
            }
          else if (In(de))
            de._store && (de._store.validated = !0);
          else if (de) {
            var mn = $(de);
            if (typeof mn == "function" && mn !== de.entries)
              for (var zt = mn.call(de), yn; !(yn = zt.next()).done; )
                In(yn.value) && Ji(yn.value, tt);
          }
        }
      }
      function Ua(de) {
        {
          var tt = de.type;
          if (tt == null || typeof tt == "string")
            return;
          var ct;
          if (typeof tt == "function")
            ct = tt.propTypes;
          else if (typeof tt == "object" && (tt.$$typeof === y || tt.$$typeof === x))
            ct = tt.propTypes;
          else
            return;
          if (ct) {
            var kt = se(tt);
            en(ct, de.props, "prop", kt, de);
          } else if (tt.PropTypes !== void 0 && !kn) {
            kn = !0;
            var mn = se(tt);
            K("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", mn || "Unknown");
          }
          typeof tt.getDefaultProps == "function" && !tt.getDefaultProps.isReactClassApproved && K("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function uo(de) {
        {
          for (var tt = Object.keys(de.props), ct = 0; ct < tt.length; ct++) {
            var kt = tt[ct];
            if (kt !== "children" && kt !== "key") {
              Nn(de), K("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", kt), Nn(null);
              break;
            }
          }
          de.ref !== null && (Nn(de), K("Invalid attribute `ref` supplied to `React.Fragment`."), Nn(null));
        }
      }
      function ea(de, tt, ct, kt, mn, zt) {
        {
          var yn = J(de);
          if (!yn) {
            var Sn = "";
            (de === void 0 || typeof de == "object" && de !== null && Object.keys(de).length === 0) && (Sn += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var Kn = Nt(mn);
            Kn ? Sn += Kn : Sn += Cr();
            var Fn;
            de === null ? Fn = "null" : Array.isArray(de) ? Fn = "array" : de !== void 0 && de.$$typeof === r ? (Fn = "<" + (se(de.type) || "Unknown") + " />", Sn = " Did you accidentally export a JSX literal instead of a component?") : Fn = typeof de, K("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Fn, Sn);
          }
          var Qn = bt(de, tt, ct, mn, zt);
          if (Qn == null)
            return Qn;
          if (yn) {
            var Ea = tt.children;
            if (Ea !== void 0)
              if (kt)
                if (Array.isArray(Ea)) {
                  for (var xa = 0; xa < Ea.length; xa++)
                    so(Ea[xa], de);
                  Object.freeze && Object.freeze(Ea);
                } else
                  K("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
              else
                so(Ea, de);
          }
          return de === e.Fragment ? uo(Qn) : Ua(Qn), Qn;
        }
      }
      function ta(de, tt, ct) {
        return ea(de, tt, ct, !0);
      }
      function us(de, tt, ct) {
        return ea(de, tt, ct, !1);
      }
      var Va = us, il = ta;
      e.jsx = Va, e.jsxs = il;
    }();
  }(VR)), VR;
}
(function(e) {
  process.env.NODE_ENV === "production" ? e.exports = J4() : e.exports = e5();
})(QO);
const He = QO.exports.jsx, qi = QO.exports.jsxs;
var NN = 0;
function t5(e) {
  if (typeof Symbol == "function")
    return Symbol(e);
  var t = "__$mobx-react " + e + " (" + NN + ")";
  return NN++, t;
}
var jR = {};
function Kp(e) {
  return jR[e] || (jR[e] = t5(e)), jR[e];
}
function sL(e, t) {
  if (kN(e, t))
    return !0;
  if (typeof e != "object" || e === null || typeof t != "object" || t === null)
    return !1;
  var n = Object.keys(e), r = Object.keys(t);
  if (n.length !== r.length)
    return !1;
  for (var a = 0; a < n.length; a++)
    if (!Object.hasOwnProperty.call(t, n[a]) || !kN(e[n[a]], t[n[a]]))
      return !1;
  return !0;
}
function kN(e, t) {
  return e === t ? e !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
function vd(e, t, n) {
  Object.hasOwnProperty.call(e, t) ? e[t] = n : Object.defineProperty(e, t, {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: n
  });
}
var IN = /* @__PURE__ */ Kp("patchMixins"), uL = /* @__PURE__ */ Kp("patchedDefinition");
function n5(e, t) {
  var n = e[IN] = e[IN] || {}, r = n[t] = n[t] || {};
  return r.locks = r.locks || 0, r.methods = r.methods || [], r;
}
function LN(e, t) {
  for (var n = this, r = arguments.length, a = new Array(r > 2 ? r - 2 : 0), s = 2; s < r; s++)
    a[s - 2] = arguments[s];
  t.locks++;
  try {
    var l;
    return e != null && (l = e.apply(this, a)), l;
  } finally {
    t.locks--, t.locks === 0 && t.methods.forEach(function(p) {
      p.apply(n, a);
    });
  }
}
function BN(e, t) {
  var n = function() {
    for (var a = arguments.length, s = new Array(a), l = 0; l < a; l++)
      s[l] = arguments[l];
    LN.call.apply(LN, [this, e, t].concat(s));
  };
  return n;
}
function zN(e, t, n) {
  var r = n5(e, t);
  r.methods.indexOf(n) < 0 && r.methods.push(n);
  var a = Object.getOwnPropertyDescriptor(e, t);
  if (!(a && a[uL])) {
    var s = e[t], l = lL(e, t, a ? a.enumerable : void 0, r, s);
    Object.defineProperty(e, t, l);
  }
}
function lL(e, t, n, r, a) {
  var s, l = BN(a, r);
  return s = {}, s[uL] = !0, s.get = function() {
    return l;
  }, s.set = function(h) {
    if (this === e)
      l = BN(h, r);
    else {
      var y = lL(this, t, n, r, h);
      Object.defineProperty(this, t, y);
    }
  }, s.configurable = !0, s.enumerable = n, s;
}
var ny = fn || "$mobx", FN = /* @__PURE__ */ Kp("isMobXReactObserver"), TT = /* @__PURE__ */ Kp("isUnmounted"), ox = /* @__PURE__ */ Kp("skipRender"), IE = /* @__PURE__ */ Kp("isForcingUpdate");
function r5(e) {
  var t = e.prototype;
  if (e[FN]) {
    var n = LE(t);
    console.warn("The provided component class (" + n + `)
                has already been declared as an observer component.`);
  } else
    e[FN] = !0;
  if (t.componentWillReact)
    throw new Error("The componentWillReact life-cycle event is no longer supported");
  if (e.__proto__ !== DO) {
    if (!t.shouldComponentUpdate)
      t.shouldComponentUpdate = $N;
    else if (t.shouldComponentUpdate !== $N)
      throw new Error("It is not allowed to use shouldComponentUpdate in observer based components.");
  }
  WR(t, "props"), WR(t, "state"), e.contextType && WR(t, "context");
  var r = t.render;
  if (typeof r != "function") {
    var a = LE(t);
    throw new Error("[mobx-react] class component (" + a + ") is missing `render` method.\n`observer` requires `render` being a function defined on prototype.\n`render = () => {}` or `render = function() {}` is not supported.");
  }
  return t.render = function() {
    return this.render = i5.call(this, r), this.render();
  }, zN(t, "componentDidMount", function() {
    this[TT] = !1, this.render[ny] || Rb.prototype.forceUpdate.call(this);
  }), zN(t, "componentWillUnmount", function() {
    var s = this.render[ny];
    if (s)
      s.dispose(), this.render[ny] = null;
    else {
      var l = LE(this);
      console.warn("The reactive render of an observer class component (" + l + `)
                was overridden after MobX attached. This may result in a memory leak if the
                overridden reactive render was not properly disposed.`);
    }
    this[TT] = !0;
  }), e;
}
function LE(e) {
  return e.displayName || e.name || e.constructor && (e.constructor.displayName || e.constructor.name) || "<component>";
}
function i5(e) {
  var t = this;
  vd(this, ox, !1), vd(this, IE, !1);
  var n = LE(this), r = e.bind(this), a = !1, s = function() {
    var h = new hy(n + ".render()", function() {
      if (!a && (a = !0, t[TT] !== !0)) {
        var y = !0;
        try {
          vd(t, IE, !0), t[ox] || Rb.prototype.forceUpdate.call(t), y = !1;
        } finally {
          vd(t, IE, !1), y && (h.dispose(), t.render[ny] = null);
        }
      }
    });
    return h.reactComponent = t, h;
  };
  function l() {
    var p;
    a = !1;
    var h = (p = l[ny]) != null ? p : l[ny] = s(), y = void 0, b = void 0;
    if (h.track(function() {
      try {
        b = xI(!1, r);
      } catch (E) {
        y = E;
      }
    }), y)
      throw y;
    return b;
  }
  return l;
}
function $N(e, t) {
  return this.state !== t ? !0 : !sL(this.props, e);
}
function WR(e, t) {
  var n = Kp("reactProp_" + t + "_valueHolder"), r = Kp("reactProp_" + t + "_atomHolder");
  function a() {
    return this[r] || vd(this, r, WO("reactive " + t)), this[r];
  }
  Object.defineProperty(e, t, {
    configurable: !0,
    enumerable: !0,
    get: function() {
      var l = !1;
      return ty && Wp && (l = ty(!0)), a.call(this).reportObserved(), ty && Wp && Wp(l), this[n];
    },
    set: function(l) {
      !this[IE] && !sL(this[n], l) ? (vd(this, n, l), vd(this, ox, !0), a.call(this).reportChanged(), vd(this, ox, !1)) : vd(this, n, l);
    }
  });
}
function zx(e) {
  return e.isMobxInjector === !0 && console.warn("Mobx observer: You are trying to use `observer` on a component that already has `inject`. Please apply `observer` before applying `inject`"), Object.prototype.isPrototypeOf.call(Rb, e) || Object.prototype.isPrototypeOf.call(DO, e) ? r5(e) : K4(e);
}
if (!Rb)
  throw new Error("mobx-react requires React to be available");
if (!_a)
  throw new Error("mobx-react requires mobx to be available");
function ZO(e, t) {
  for (var n = e.length, r = 0; r < n; ++r)
    if (t(e[r], r))
      return !0;
  return !1;
}
function cL(e, t) {
  for (var n = e.length, r = 0; r < n; ++r)
    if (t(e[r], r))
      return e[r];
  return null;
}
function fL(e) {
  var t = e;
  if (typeof t > "u") {
    if (typeof navigator > "u" || !navigator)
      return "";
    t = navigator.userAgent || "";
  }
  return t.toLowerCase();
}
function JO(e, t) {
  try {
    return new RegExp(e, "g").exec(t);
  } catch {
    return null;
  }
}
function a5() {
  if (typeof navigator > "u" || !navigator || !navigator.userAgentData)
    return !1;
  var e = navigator.userAgentData, t = e.brands || e.uaList;
  return !!(t && t.length);
}
function o5(e, t) {
  var n = JO("(" + e + ")((?:\\/|\\s|:)([0-9|\\.|_]+))", t);
  return n ? n[3] : "";
}
function OT(e) {
  return e.replace(/_/g, ".");
}
function X0(e, t) {
  var n = null, r = "-1";
  return ZO(e, function(a) {
    var s = JO("(" + a.test + ")((?:\\/|\\s|:)([0-9|\\.|_]+))?", t);
    return !s || a.brand ? !1 : (n = a, r = s[3] || "-1", a.versionAlias ? r = a.versionAlias : a.versionTest && (r = o5(a.versionTest.toLowerCase(), t) || r), r = OT(r), !0);
  }), {
    preset: n,
    version: r
  };
}
function V0(e, t) {
  var n = {
    brand: "",
    version: "-1"
  };
  return ZO(e, function(r) {
    var a = dL(t, r);
    return a ? (n.brand = r.id, n.version = r.versionAlias || a.version, n.version !== "-1") : !1;
  }), n;
}
function dL(e, t) {
  return cL(e, function(n) {
    var r = n.brand;
    return JO("" + t.test, r.toLowerCase());
  });
}
var DT = [{
  test: "phantomjs",
  id: "phantomjs"
}, {
  test: "whale",
  id: "whale"
}, {
  test: "edgios|edge|edg",
  id: "edge"
}, {
  test: "msie|trident|windows phone",
  id: "ie",
  versionTest: "iemobile|msie|rv"
}, {
  test: "miuibrowser",
  id: "miui browser"
}, {
  test: "samsungbrowser",
  id: "samsung internet"
}, {
  test: "samsung",
  id: "samsung internet",
  versionTest: "version"
}, {
  test: "chrome|crios",
  id: "chrome"
}, {
  test: "firefox|fxios",
  id: "firefox"
}, {
  test: "android",
  id: "android browser",
  versionTest: "version"
}, {
  test: "safari|iphone|ipad|ipod",
  id: "safari",
  versionTest: "version"
}], pL = [{
  test: "(?=.*applewebkit/(53[0-7]|5[0-2]|[0-4]))(?=.*\\schrome)",
  id: "chrome",
  versionTest: "chrome"
}, {
  test: "chromium",
  id: "chrome"
}, {
  test: "whale",
  id: "chrome",
  versionAlias: "-1",
  brand: !0
}], MT = [{
  test: "applewebkit",
  id: "webkit",
  versionTest: "applewebkit|safari"
}], vL = [{
  test: "(?=(iphone|ipad))(?!(.*version))",
  id: "webview"
}, {
  test: "(?=(android|iphone|ipad))(?=.*(naver|daum|; wv))",
  id: "webview"
}, {
  test: "webview",
  id: "webview"
}], hL = [{
  test: "windows phone",
  id: "windows phone"
}, {
  test: "windows 2000",
  id: "window",
  versionAlias: "5.0"
}, {
  test: "windows nt",
  id: "window"
}, {
  test: "win32|windows",
  id: "window"
}, {
  test: "iphone|ipad|ipod",
  id: "ios",
  versionTest: "iphone os|cpu os"
}, {
  test: "macos|macintel|mac os x",
  id: "mac"
}, {
  test: "android|linux armv81",
  id: "android"
}, {
  test: "tizen",
  id: "tizen"
}, {
  test: "webos|web0s",
  id: "webos"
}];
function gL(e) {
  return !!X0(vL, e).preset;
}
function s5(e) {
  var t = fL(e), n = !!/mobi/g.exec(t), r = {
    name: "unknown",
    version: "-1",
    majorVersion: -1,
    webview: gL(t),
    chromium: !1,
    chromiumVersion: "-1",
    webkit: !1,
    webkitVersion: "-1"
  }, a = {
    name: "unknown",
    version: "-1",
    majorVersion: -1
  }, s = X0(DT, t), l = s.preset, p = s.version, h = X0(hL, t), y = h.preset, b = h.version, E = X0(pL, t);
  if (r.chromium = !!E.preset, r.chromiumVersion = E.version, !r.chromium) {
    var x = X0(MT, t);
    r.webkit = !!x.preset, r.webkitVersion = x.version;
  }
  return y && (a.name = y.id, a.version = b, a.majorVersion = parseInt(b, 10)), l && (r.name = l.id, r.version = p, r.webview && a.name === "ios" && r.name !== "safari" && (r.webview = !1)), r.majorVersion = parseInt(r.version, 10), {
    browser: r,
    os: a,
    isMobile: n,
    isHints: !1
  };
}
function u5(e) {
  var t = navigator.userAgentData, n = (t.uaList || t.brands).slice(), r = e && e.fullVersionList, a = t.mobile || !1, s = n[0], l = (e && e.platform || t.platform || navigator.platform).toLowerCase(), p = {
    name: s.brand,
    version: s.version,
    majorVersion: -1,
    webkit: !1,
    webkitVersion: "-1",
    chromium: !1,
    chromiumVersion: "-1",
    webview: !!V0(vL, n).brand || gL(fL())
  }, h = {
    name: "unknown",
    version: "-1",
    majorVersion: -1
  };
  p.webkit = !p.chromium && ZO(MT, function(T) {
    return dL(n, T);
  });
  var y = V0(pL, n);
  if (p.chromium = !!y.brand, p.chromiumVersion = y.version, !p.chromium) {
    var b = V0(MT, n);
    p.webkit = !!b.brand, p.webkitVersion = b.version;
  }
  var E = cL(hL, function(T) {
    return new RegExp("" + T.test, "g").exec(l);
  });
  if (h.name = E ? E.id : "", e && (h.version = e.platformVersion), r && r.length) {
    var x = V0(DT, r);
    p.name = x.brand || p.name, p.version = x.version || p.version;
  } else {
    var C = V0(DT, n);
    p.name = C.brand || p.name, p.version = C.brand && e ? e.uaFullVersion : C.version;
  }
  return p.webkit && (h.name = a ? "ios" : "mac"), h.name === "ios" && p.webview && (p.version = "-1"), h.version = OT(h.version), p.version = OT(p.version), h.majorVersion = parseInt(h.version, 10), p.majorVersion = parseInt(p.version, 10), {
    browser: p,
    os: h,
    isMobile: a,
    isHints: !0
  };
}
function l5(e) {
  return typeof e > "u" && a5() ? u5() : s5(e);
}
function c5(e) {
  for (var t = [], n = 1; n < arguments.length; n++)
    t[n - 1] = arguments[n];
  return t.map(function(r) {
    return r.split(" ").map(function(a) {
      return a ? "" + e + a : "";
    }).join(" ");
  }).join(" ");
}
function f5(e, t) {
  return t.replace(/([^}{]*){/gm, function(n, r) {
    return r.replace(/\.([^{,\s\d.]+)/g, "." + e + "$1") + "{";
  });
}
function hd(e, t) {
  return function(n) {
    n && (e[t] = n);
  };
}
function mL(e, t, n) {
  return function(r) {
    r && (e[t][n] = r);
  };
}
function d5(e, t) {
  return function(n) {
    var r = n.prototype;
    e.forEach(function(a) {
      t(r, a);
    });
  };
}
function yL(e, t) {
  return t === void 0 && (t = {}), function(n, r) {
    e.forEach(function(a) {
      var s = t[a] || a;
      s in n || (n[s] = function() {
        for (var l, p = [], h = 0; h < arguments.length; h++)
          p[h] = arguments[h];
        var y = (l = this[r])[a].apply(l, p);
        return y === this[r] ? this : y;
      });
    });
  };
}
var p5 = "function", v5 = "object", h5 = "string", g5 = "number", eD = "undefined", bL = typeof window !== eD, m5 = typeof document !== eD && document, y5 = [{
  open: "(",
  close: ")"
}, {
  open: '"',
  close: '"'
}, {
  open: "'",
  close: "'"
}, {
  open: '\\"',
  close: '\\"'
}, {
  open: "\\'",
  close: "\\'"
}], $i = 1e-7, cE = {
  cm: function(e) {
    return e * 96 / 2.54;
  },
  mm: function(e) {
    return e * 96 / 254;
  },
  in: function(e) {
    return e * 96;
  },
  pt: function(e) {
    return e * 96 / 72;
  },
  pc: function(e) {
    return e * 96 / 6;
  },
  "%": function(e, t) {
    return e * t / 100;
  },
  vw: function(e, t) {
    return t === void 0 && (t = window.innerWidth), e / 100 * t;
  },
  vh: function(e, t) {
    return t === void 0 && (t = window.innerHeight), e / 100 * t;
  },
  vmax: function(e, t) {
    return t === void 0 && (t = Math.max(window.innerWidth, window.innerHeight)), e / 100 * t;
  },
  vmin: function(e, t) {
    return t === void 0 && (t = Math.min(window.innerWidth, window.innerHeight)), e / 100 * t;
  }
};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function b5() {
  for (var e = 0, t = 0, n = arguments.length; t < n; t++)
    e += arguments[t].length;
  for (var r = Array(e), a = 0, t = 0; t < n; t++)
    for (var s = arguments[t], l = 0, p = s.length; l < p; l++, a++)
      r[a] = s[l];
  return r;
}
function kh(e, t, n, r) {
  return (e * r + t * n) / (n + r);
}
function tD(e) {
  return typeof e === eD;
}
function rs(e) {
  return e && typeof e === v5;
}
function Ki(e) {
  return Array.isArray(e);
}
function tc(e) {
  return typeof e === h5;
}
function UN(e) {
  return typeof e === g5;
}
function Fx(e) {
  return typeof e === p5;
}
function _5(e, t) {
  var n = e === "" || e == " ", r = t === "" || t == " ";
  return r && n || e === t;
}
function _L(e, t, n, r, a) {
  var s = nD(e, t, n);
  return s ? n : E5(e, t, n + 1, r, a);
}
function nD(e, t, n) {
  if (!e.ignore)
    return null;
  var r = t.slice(Math.max(n - 3, 0), n + 3).join("");
  return new RegExp(e.ignore).exec(r);
}
function E5(e, t, n, r, a) {
  for (var s = function(y) {
    var b = t[y].trim();
    if (b === e.close && !nD(e, t, y))
      return {
        value: y
      };
    var E = y, x = bd(a, function(C) {
      var T = C.open;
      return T === b;
    });
    if (x && (E = _L(x, t, y, r, a)), E === -1)
      return l = y, "break";
    y = E, l = y;
  }, l, p = n; p < r; ++p) {
    var h = s(p);
    if (p = l, typeof h == "object")
      return h.value;
    if (h === "break")
      break;
  }
  return -1;
}
function rD(e, t) {
  var n = tc(t) ? {
    separator: t
  } : t, r = n.separator, a = r === void 0 ? "," : r, s = n.isSeparateFirst, l = n.isSeparateOnlyOpenClose, p = n.isSeparateOpenClose, h = p === void 0 ? l : p, y = n.openCloseCharacters, b = y === void 0 ? y5 : y, E = b.map(function(U) {
    var K = U.open, X = U.close;
    return K === X ? K : K + "|" + X;
  }).join("|"), x = "(\\s*" + a + "\\s*|" + E + "|\\s+)", C = new RegExp(x, "g"), T = e.split(C).filter(function(U) {
    return U && U !== "undefined";
  }), O = T.length, D = [], A = [];
  function B() {
    return A.length ? (D.push(A.join("")), A = [], !0) : !1;
  }
  for (var I = function(U) {
    var K = T[U].trim(), X = U, Y = bd(b, function(Z) {
      var se = Z.open;
      return se === K;
    }), J = bd(b, function(Z) {
      var se = Z.close;
      return se === K;
    });
    if (Y) {
      if (X = _L(Y, T, U, O, b), X !== -1 && h)
        return B() && s || (D.push(T.slice(U, X + 1).join("")), U = X, s) ? (L = U, "break") : (L = U, "continue");
    } else if (J && !nD(J, T, U)) {
      var Q = b5(b);
      return Q.splice(b.indexOf(J), 1), {
        value: rD(e, {
          separator: a,
          isSeparateFirst: s,
          isSeparateOnlyOpenClose: l,
          isSeparateOpenClose: h,
          openCloseCharacters: Q
        })
      };
    } else if (_5(K, a) && !l)
      return B(), s ? (L = U, "break") : (L = U, "continue");
    X === -1 && (X = O - 1), A.push(T.slice(U, X + 1).join("")), U = X, L = U;
  }, L, k = 0; k < O; ++k) {
    var $ = I(k);
    if (k = L, typeof $ == "object")
      return $.value;
    if ($ === "break")
      break;
  }
  return A.length && D.push(A.join("")), D;
}
function Qp(e) {
  return rD(e, "");
}
function Vh(e) {
  return rD(e, ",");
}
function EL(e) {
  var t = /([^(]*)\(([\s\S]*)\)([\s\S]*)/g.exec(e);
  return !t || t.length < 4 ? {} : {
    prefix: t[1],
    value: t[2],
    suffix: t[3]
  };
}
function Kh(e) {
  var t = /^([^\d|e|\-|\+]*)((?:\d|\.|-|e-|e\+)+)(\S*)$/g.exec(e);
  if (!t)
    return {
      prefix: "",
      unit: "",
      value: NaN
    };
  var n = t[1], r = t[2], a = t[3];
  return {
    prefix: n,
    unit: a,
    value: parseFloat(r)
  };
}
function AT(e) {
  return e.replace(/[\s-_]+([^\s-_])/g, function(t, n) {
    return n.toUpperCase();
  });
}
function x5(e, t) {
  return t === void 0 && (t = "-"), e.replace(/([a-z])([A-Z])/g, function(n, r, a) {
    return "" + r + t + a.toLowerCase();
  });
}
function vb() {
  return Date.now ? Date.now() : new Date().getTime();
}
function yd(e, t, n) {
  n === void 0 && (n = -1);
  for (var r = e.length, a = 0; a < r; ++a)
    if (t(e[a], a, e))
      return a;
  return n;
}
function bd(e, t, n) {
  var r = yd(e, t);
  return r > -1 ? e[r] : n;
}
var xL = /* @__PURE__ */ function() {
  var e = vb(), t = bL && (window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.msRequestAnimationFrame);
  return t ? t.bind(window) : function(n) {
    var r = vb(), a = setTimeout(function() {
      n(r - e);
    }, 1e3 / 60);
    return a;
  };
}(), S5 = /* @__PURE__ */ function() {
  var e = bL && (window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || window.msCancelAnimationFrame);
  return e ? e.bind(window) : function(t) {
    clearTimeout(t);
  };
}();
function Oy(e) {
  return Object.keys(e);
}
function wr(e, t) {
  var n = Kh(e), r = n.value, a = n.unit;
  if (rs(t)) {
    var s = t[a];
    if (s) {
      if (Fx(s))
        return s(r);
      if (cE[a])
        return cE[a](r, s);
    }
  } else if (a === "%")
    return r * t / 100;
  return cE[a] ? cE[a](r) : r;
}
function sx(e, t, n) {
  return Math.max(t, Math.min(e, n));
}
function VN(e, t, n, r) {
  return r === void 0 && (r = e[0] / e[1]), [[hn(t[0], $i), hn(t[0] / r, $i)], [hn(t[1] * r, $i), hn(t[1], $i)]].filter(function(a) {
    return a.every(function(s, l) {
      var p = t[l], h = hn(p, $i);
      return n ? s <= p || s <= h : s >= p || s >= h;
    });
  })[0] || e;
}
function SL(e, t, n, r) {
  if (!r)
    return e.map(function(C, T) {
      return sx(C, t[T], n[T]);
    });
  var a = e[0], s = e[1], l = r === !0 ? a / s : r, p = VN(e, t, !1, l), h = p[0], y = p[1], b = VN(e, n, !0, l), E = b[0], x = b[1];
  return a < h || s < y ? (a = h, s = y) : (a > E || s > x) && (a = E, s = x), [a, s];
}
function w5(e) {
  for (var t = e.length, n = 0, r = t - 1; r >= 0; --r)
    n += e[r];
  return n;
}
function PT(e) {
  for (var t = e.length, n = 0, r = t - 1; r >= 0; --r)
    n += e[r];
  return t ? n / t : 0;
}
function mi(e, t) {
  var n = t[0] - e[0], r = t[1] - e[1], a = Math.atan2(r, n);
  return a >= 0 ? a : a + Math.PI * 2;
}
function C5(e) {
  return [0, 1].map(function(t) {
    return PT(e.map(function(n) {
      return n[t];
    }));
  });
}
function NT(e) {
  var t = C5(e), n = mi(t, e[0]), r = mi(t, e[1]);
  return n < r && r - n < Math.PI || n > r && r - n < -Math.PI ? 1 : -1;
}
function Qu(e, t) {
  return Math.sqrt(Math.pow((t ? t[0] : 0) - e[0], 2) + Math.pow((t ? t[1] : 0) - e[1], 2));
}
function hn(e, t) {
  if (!t)
    return e;
  var n = 1 / t;
  return Math.round(e / t) / n;
}
function jN(e, t) {
  return e.forEach(function(n, r) {
    e[r] = hn(e[r], t);
  }), e;
}
function Ui(e, t) {
  return e.classList ? e.classList.contains(t) : !!e.className.match(new RegExp("(\\s|^)" + t + "(\\s|$)"));
}
function iD(e, t) {
  e.classList ? e.classList.add(t) : e.className += " " + t;
}
function wL(e, t) {
  if (e.classList)
    e.classList.remove(t);
  else {
    var n = new RegExp("(\\s|^)" + t + "(\\s|$)");
    e.className = e.className.replace(n, " ");
  }
}
function zi(e, t, n, r) {
  e.addEventListener(t, n, r);
}
function Oi(e, t, n, r) {
  e.removeEventListener(t, n, r);
}
function dd(e) {
  return (e == null ? void 0 : e.ownerDocument) || m5;
}
function jh(e) {
  var t;
  return ((t = e == null ? void 0 : e.ownerDocument) === null || t === void 0 ? void 0 : t.defaultView) || window;
}
function R5(e) {
  return e && "postMessage" in e && "blur" in e && "self" in e;
}
function WN(e) {
  return rs(e) && e.nodeName && e.nodeType && "ownerDocument" in e;
}
function T5(e, t, n, r, a, s) {
  for (var l = 0; l < a; ++l) {
    var p = n + l * a, h = r + l * a;
    e[p] += e[h] * s, t[p] += t[h] * s;
  }
}
function O5(e, t, n, r, a) {
  for (var s = 0; s < a; ++s) {
    var l = n + s * a, p = r + s * a, h = e[l], y = t[l];
    e[l] = e[p], e[p] = h, t[l] = t[p], t[p] = y;
  }
}
function D5(e, t, n, r, a) {
  for (var s = 0; s < r; ++s) {
    var l = n + s * r;
    e[l] /= a, t[l] /= a;
  }
}
function CL(e, t, n) {
  n === void 0 && (n = Math.sqrt(e.length));
  for (var r = e.slice(), a = 0; a < n; ++a)
    r[a * n + t - 1] = 0, r[(t - 1) * n + a] = 0;
  return r[(t - 1) * (n + 1)] = 1, r;
}
function nc(e, t) {
  t === void 0 && (t = Math.sqrt(e.length));
  for (var n = e.slice(), r = Kr(t), a = 0; a < t; ++a) {
    var s = t * a + a;
    if (!hn(n[s], $i)) {
      for (var l = a + 1; l < t; ++l)
        if (n[t * a + l]) {
          O5(n, r, a, l, t);
          break;
        }
    }
    if (!hn(n[s], $i))
      return [];
    D5(n, r, a, t, n[s]);
    for (var l = 0; l < t; ++l) {
      var p = l, h = l + a * t, y = n[h];
      !hn(y, $i) || a === l || T5(n, r, p, a, t, -y);
    }
  }
  return r;
}
function M5(e, t) {
  t === void 0 && (t = Math.sqrt(e.length));
  for (var n = [], r = 0; r < t; ++r)
    for (var a = 0; a < t; ++a)
      n[a * t + r] = e[t * r + a];
  return n;
}
function RL(e, t) {
  t === void 0 && (t = Math.sqrt(e.length));
  for (var n = [], r = e[t * t - 1], a = 0; a < t - 1; ++a)
    n[a] = e[t * (t - 1) + a] / r;
  return n[t - 1] = 0, n;
}
function A5(e, t) {
  for (var n = Kr(t), r = 0; r < t - 1; ++r)
    n[t * (t - 1) + r] = e[r] || 0;
  return n;
}
function Qh(e, t) {
  for (var n = e.slice(), r = e.length; r < t - 1; ++r)
    n[r] = 0;
  return n[t - 1] = 1, n;
}
function tf(e, t, n) {
  if (t === void 0 && (t = Math.sqrt(e.length)), t === n)
    return e;
  for (var r = Kr(n), a = Math.min(t, n), s = 0; s < a - 1; ++s) {
    for (var l = 0; l < a - 1; ++l)
      r[s * n + l] = e[s * t + l];
    r[(s + 1) * n - 1] = e[(s + 1) * t - 1], r[(n - 1) * n + s] = e[(t - 1) * t + s];
  }
  return r[n * n - 1] = e[t * t - 1], r;
}
function kT(e) {
  for (var t = [], n = 1; n < arguments.length; n++)
    t[n - 1] = arguments[n];
  var r = Kr(e);
  return t.forEach(function(a) {
    r = yr(r, a, e);
  }), r;
}
function yr(e, t, n) {
  n === void 0 && (n = Math.sqrt(e.length));
  var r = [], a = e.length / n, s = t.length / a;
  if (a) {
    if (!s)
      return e;
  } else
    return t;
  for (var l = 0; l < n; ++l)
    for (var p = 0; p < s; ++p) {
      r[p * n + l] = 0;
      for (var h = 0; h < a; ++h)
        r[p * n + l] += e[h * n + l] * t[p * a + h];
    }
  return r;
}
function On(e, t) {
  for (var n = Math.min(e.length, t.length), r = e.slice(), a = 0; a < n; ++a)
    r[a] = r[a] + t[a];
  return r;
}
function Bt(e, t) {
  for (var n = Math.min(e.length, t.length), r = e.slice(), a = 0; a < n; ++a)
    r[a] = r[a] - t[a];
  return r;
}
function P5(e, t) {
  return t === void 0 && (t = e.length === 6), t ? [e[0], e[1], 0, e[2], e[3], 0, e[4], e[5], 1] : e;
}
function TL(e, t) {
  return t === void 0 && (t = e.length === 9), t ? [e[0], e[1], e[3], e[4], e[6], e[7]] : e;
}
function $a(e, t, n) {
  n === void 0 && (n = t.length);
  var r = yr(e, t, n), a = r[n - 1];
  return r.map(function(s) {
    return s / a;
  });
}
function N5(e, t) {
  return yr(e, [1, 0, 0, 0, 0, Math.cos(t), Math.sin(t), 0, 0, -Math.sin(t), Math.cos(t), 0, 0, 0, 0, 1], 4);
}
function k5(e, t) {
  return yr(e, [Math.cos(t), 0, -Math.sin(t), 0, 0, 1, 0, 0, Math.sin(t), 0, Math.cos(t), 0, 0, 0, 0, 1], 4);
}
function I5(e, t) {
  return yr(e, gy(t, 4));
}
function fE(e, t) {
  var n = t[0], r = n === void 0 ? 1 : n, a = t[1], s = a === void 0 ? 1 : a, l = t[2], p = l === void 0 ? 1 : l;
  return yr(e, [r, 0, 0, 0, 0, s, 0, 0, 0, 0, p, 0, 0, 0, 0, 1], 4);
}
function Fb(e, t) {
  return $a(gy(t, 3), Qh(e, 3));
}
function GR(e, t) {
  var n = t[0], r = n === void 0 ? 0 : n, a = t[1], s = a === void 0 ? 0 : a, l = t[2], p = l === void 0 ? 0 : l;
  return yr(e, [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, r, s, p, 1], 4);
}
function IT(e, t) {
  return yr(e, t, 4);
}
function gy(e, t) {
  var n = Math.cos(e), r = Math.sin(e), a = Kr(t);
  return a[0] = n, a[1] = r, a[t] = -r, a[t + 1] = n, a;
}
function Kr(e) {
  for (var t = e * e, n = [], r = 0; r < t; ++r)
    n[r] = r % (e + 1) ? 0 : 1;
  return n;
}
function aD(e, t) {
  for (var n = Kr(t), r = Math.min(e.length, t - 1), a = 0; a < r; ++a)
    n[(t + 1) * a] = e[a];
  return n;
}
function hb(e, t) {
  for (var n = Kr(t), r = Math.min(e.length, t - 1), a = 0; a < r; ++a)
    n[t * (t - 1) + a] = e[a];
  return n;
}
function oD(e, t, n, r, a, s, l, p) {
  var h = e[0], y = e[1], b = t[0], E = t[1], x = n[0], C = n[1], T = r[0], O = r[1], D = a[0], A = a[1], B = s[0], I = s[1], L = l[0], k = l[1], $ = p[0], U = p[1], K = [h, 0, b, 0, x, 0, T, 0, y, 0, E, 0, C, 0, O, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, h, 0, b, 0, x, 0, T, 0, y, 0, E, 0, C, 0, O, 0, 1, 0, 1, 0, 1, 0, 1, -D * h, -A * h, -B * b, -I * b, -L * x, -k * x, -$ * T, -U * T, -D * y, -A * y, -B * E, -I * E, -L * C, -k * C, -$ * O, -U * O], X = nc(K, 8);
  if (!X.length)
    return [];
  var Y = yr(X, [D, A, B, I, L, k, $, U], 8);
  return Y[8] = 1, tf(M5(Y), 3, 4);
}
var tb = function() {
  return tb = Object.assign || function(t) {
    for (var n, r = 1, a = arguments.length; r < a; r++) {
      n = arguments[r];
      for (var s in n)
        Object.prototype.hasOwnProperty.call(n, s) && (t[s] = n[s]);
    }
    return t;
  }, tb.apply(this, arguments);
};
function sD() {
  return [
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    1
  ];
}
function $x(e, t) {
  return t === void 0 && (t = 0), Vm(Fh(e, t));
}
function BE(e, t) {
  var n = $a(e, [t[0], t[1] || 0, t[2] || 0, 1], 4), r = n[3] || 1;
  return [
    n[0] / r,
    n[1] / r,
    n[2] / r
  ];
}
function L5(e, t) {
  t === void 0 && (t = document.body);
  for (var n = e, r = sD(); n; ) {
    var a = getComputedStyle(n).transform;
    if (r = IT($x(a), r), n === t)
      break;
    n = n.parentElement;
  }
  return r = nc(r, 4), r[12] = 0, r[13] = 0, r[14] = 0, r;
}
function Vm(e) {
  var t = sD();
  return e.forEach(function(n) {
    var r = n.matrixFunction, a = n.functionValue;
    !r || (t = r(t, a));
  }), t;
}
function Fh(e, t) {
  t === void 0 && (t = 0);
  var n = Ki(e) ? e : Qp(e);
  return n.map(function(r) {
    var a = EL(r), s = a.prefix, l = a.value, p = null, h = s, y = "";
    if (s === "translate" || s === "translateX" || s === "translate3d") {
      var b = rs(t) ? tb(tb({}, t), { "o%": t["%"] }) : {
        "%": t,
        "o%": t
      }, E = Vh(l).map(function(Z, se) {
        return se === 0 && "x%" in b ? b["%"] = t["x%"] : se === 1 && "y%" in b ? b["%"] = t["y%"] : b["%"] = t["o%"], wr(Z, b);
      }), x = E[0], C = E[1], T = C === void 0 ? 0 : C, O = E[2], D = O === void 0 ? 0 : O;
      p = GR, y = [x, T, D];
    } else if (s === "translateY") {
      var A = rs(t) ? tb({ "%": t["y%"] }, t) : {
        "%": t
      }, T = wr(l, A);
      p = GR, y = [0, T, 0];
    } else if (s === "translateZ") {
      var D = parseFloat(l);
      p = GR, y = [0, 0, D];
    } else if (s === "scale" || s === "scale3d") {
      var B = Vh(l).map(function(Z) {
        return parseFloat(Z);
      }), I = B[0], L = B[1], k = L === void 0 ? I : L, $ = B[2], U = $ === void 0 ? 1 : $;
      p = fE, y = [I, k, U];
    } else if (s === "scaleX") {
      var I = parseFloat(l);
      p = fE, y = [I, 1, 1];
    } else if (s === "scaleY") {
      var k = parseFloat(l);
      p = fE, y = [1, k, 1];
    } else if (s === "scaleZ") {
      var U = parseFloat(l);
      p = fE, y = [1, 1, U];
    } else if (s === "rotate" || s === "rotateZ" || s === "rotateX" || s === "rotateY") {
      var K = Kh(l), X = K.unit, Y = K.value, J = X === "rad" ? Y : Y * Math.PI / 180;
      s === "rotate" || s === "rotateZ" ? (h = "rotateZ", p = I5) : s === "rotateX" ? p = N5 : s === "rotateY" && (p = k5), y = J;
    } else if (s === "matrix3d")
      p = IT, y = Vh(l).map(function(Z) {
        return parseFloat(Z);
      });
    else if (s === "matrix") {
      var Q = Vh(l).map(function(Z) {
        return parseFloat(Z);
      });
      p = IT, y = [
        Q[0],
        Q[1],
        0,
        0,
        Q[2],
        Q[3],
        0,
        0,
        0,
        0,
        1,
        0,
        Q[4],
        Q[5],
        0,
        1
      ];
    } else
      h = "";
    return {
      name: s,
      functionName: h,
      value: l,
      matrixFunction: p,
      functionValue: y
    };
  });
}
var B5 = /* @__PURE__ */ function() {
  function e() {
    this.keys = [], this.values = [];
  }
  var t = e.prototype;
  return t.get = function(n) {
    return this.values[this.keys.indexOf(n)];
  }, t.set = function(n, r) {
    var a = this.keys, s = this.values, l = a.indexOf(n), p = l === -1 ? a.length : l;
    a[p] = n, s[p] = r;
  }, e;
}(), z5 = /* @__PURE__ */ function() {
  function e() {
    this.object = {};
  }
  var t = e.prototype;
  return t.get = function(n) {
    return this.object[n];
  }, t.set = function(n, r) {
    this.object[n] = r;
  }, e;
}(), F5 = typeof Map == "function", $5 = /* @__PURE__ */ function() {
  function e() {
  }
  var t = e.prototype;
  return t.connect = function(n, r) {
    this.prev = n, this.next = r, n && (n.next = this), r && (r.prev = this);
  }, t.disconnect = function() {
    var n = this.prev, r = this.next;
    n && (n.next = r), r && (r.prev = n);
  }, t.getIndex = function() {
    for (var n = this, r = -1; n; )
      n = n.prev, ++r;
    return r;
  }, e;
}();
function U5(e, t) {
  var n = [], r = [];
  return e.forEach(function(a) {
    var s = a[0], l = a[1], p = new $5();
    n[s] = p, r[l] = p;
  }), n.forEach(function(a, s) {
    a.connect(n[s - 1]);
  }), e.filter(function(a, s) {
    return !t[s];
  }).map(function(a, s) {
    var l = a[0], p = a[1];
    if (l === p)
      return [0, 0];
    var h = n[l], y = r[p - 1], b = h.getIndex();
    h.disconnect(), y ? h.connect(y, y.next) : h.connect(void 0, n[0]);
    var E = h.getIndex();
    return [b, E];
  });
}
var V5 = /* @__PURE__ */ function() {
  function e(n, r, a, s, l, p, h, y) {
    this.prevList = n, this.list = r, this.added = a, this.removed = s, this.changed = l, this.maintained = p, this.changedBeforeAdded = h, this.fixed = y;
  }
  var t = e.prototype;
  return Object.defineProperty(t, "ordered", {
    get: function() {
      return this.cacheOrdered || this.caculateOrdered(), this.cacheOrdered;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(t, "pureChanged", {
    get: function() {
      return this.cachePureChanged || this.caculateOrdered(), this.cachePureChanged;
    },
    enumerable: !0,
    configurable: !0
  }), t.caculateOrdered = function() {
    var n = U5(this.changedBeforeAdded, this.fixed), r = this.changed, a = [];
    this.cacheOrdered = n.filter(function(s, l) {
      var p = s[0], h = s[1], y = r[l], b = y[0], E = y[1];
      if (p !== h)
        return a.push([b, E]), !0;
    }), this.cachePureChanged = a;
  }, e;
}();
function uD(e, t, n) {
  var r = F5 ? Map : n ? z5 : B5, a = n || function(B) {
    return B;
  }, s = [], l = [], p = [], h = e.map(a), y = t.map(a), b = new r(), E = new r(), x = [], C = [], T = {}, O = [], D = 0, A = 0;
  return h.forEach(function(B, I) {
    b.set(B, I);
  }), y.forEach(function(B, I) {
    E.set(B, I);
  }), h.forEach(function(B, I) {
    var L = E.get(B);
    typeof L > "u" ? (++A, l.push(I)) : T[L] = A;
  }), y.forEach(function(B, I) {
    var L = b.get(B);
    typeof L > "u" ? (s.push(I), ++D) : (p.push([L, I]), A = T[I] || 0, x.push([L - A, I - D]), C.push(I === L), L !== I && O.push([L, I]));
  }), l.reverse(), new V5(e, t, s, l, O, p, x, C);
}
var j5 = /* @__PURE__ */ function() {
  function e(n, r) {
    n === void 0 && (n = []), this.findKeyCallback = r, this.list = [].slice.call(n);
  }
  var t = e.prototype;
  return t.update = function(n) {
    var r = [].slice.call(n), a = uD(this.list, r, this.findKeyCallback);
    return this.list = r, a;
  }, e;
}();
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var LT = function(e, t) {
  return LT = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var a in r)
      r.hasOwnProperty(a) && (n[a] = r[a]);
  }, LT(e, t);
};
function W5(e, t) {
  LT(e, t);
  function n() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
}
var OL = typeof Map == "function" ? void 0 : function() {
  var e = 0;
  return function(t) {
    return t.__DIFF_KEY__ || (t.__DIFF_KEY__ = ++e);
  };
}(), G5 = /* @__PURE__ */ function(e) {
  W5(t, e);
  function t(n) {
    return n === void 0 && (n = []), e.call(this, n, OL) || this;
  }
  return t;
}(j5);
function Xm(e, t) {
  return uD(e, t, OL);
}
const DL = G5;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function H5() {
  for (var e = 0, t = 0, n = arguments.length; t < n; t++)
    e += arguments[t].length;
  for (var r = Array(e), a = 0, t = 0; t < n; t++)
    for (var s = arguments[t], l = 0, p = s.length; l < p; l++, a++)
      r[a] = s[l];
  return r;
}
function es(e) {
  return hn(e, $i);
}
function Y5(e, t) {
  return e.every(function(n, r) {
    return es(n - t[r]) === 0;
  });
}
function q5(e, t) {
  return !es(e[0] - t[0]) && !es(e[1] - t[1]);
}
function nb(e) {
  return e.length < 3 ? 0 : Math.abs(w5(e.map(function(t, n) {
    var r = e[n + 1] || e[0];
    return t[0] * r[1] - r[0] * t[1];
  }))) / 2;
}
function BT(e, t) {
  var n = t.width, r = t.height, a = t.left, s = t.top, l = Zp(e), p = l.minX, h = l.minY, y = l.maxX, b = l.maxY, E = n / (y - p), x = r / (b - h);
  return e.map(function(C) {
    return [a + (C[0] - p) * E, s + (C[1] - h) * x];
  });
}
function Zp(e) {
  var t = e.map(function(r) {
    return r[0];
  }), n = e.map(function(r) {
    return r[1];
  });
  return {
    minX: Math.min.apply(Math, t),
    minY: Math.min.apply(Math, n),
    maxX: Math.max.apply(Math, t),
    maxY: Math.max.apply(Math, n)
  };
}
function ux(e, t, n) {
  var r = e[0], a = e[1], s = Zp(t), l = s.minX, p = s.maxX, h = [[l, a], [p, a]], y = lx(h[0], h[1]), b = zT(t), E = [];
  if (b.forEach(function(T) {
    var O = lx(T[0], T[1]), D = T[0];
    if (Y5(y, O))
      E.push({
        pos: e,
        line: T,
        type: "line"
      });
    else {
      var A = ML(lD(y, O), [h, T]);
      A.forEach(function(B) {
        T.some(function(I) {
          return q5(I, B);
        }) ? E.push({
          pos: B,
          line: T,
          type: "point"
        }) : es(D[1] - a) !== 0 && E.push({
          pos: B,
          line: T,
          type: "intersection"
        });
      });
    }
  }), !n && bd(E, function(T) {
    return T[0] === r;
  }))
    return !0;
  var x = 0, C = {};
  return E.forEach(function(T) {
    var O = T.pos, D = T.type, A = T.line;
    if (!(O[0] > r))
      if (D === "intersection")
        ++x;
      else {
        if (D === "line")
          return;
        if (D === "point") {
          var B = bd(A, function(k) {
            return k[1] !== a;
          }), I = C[O[0]], L = B[1] > a ? 1 : -1;
          I ? I !== L && ++x : C[O[0]] = L;
        }
      }
  }), x % 2 === 1;
}
function lx(e, t) {
  var n = e[0], r = e[1], a = t[0], s = t[1], l = a - n, p = s - r;
  Math.abs(l) < $i && (l = 0), Math.abs(p) < $i && (p = 0);
  var h = 0, y = 0, b = 0;
  return l ? p ? (h = -p / l, y = 1, b = -h * n - r) : (y = 1, b = -r) : p && (h = -1, b = n), [h, y, b];
}
function lD(e, t) {
  var n = e[0], r = e[1], a = e[2], s = t[0], l = t[1], p = t[2], h = n === 0 && s === 0, y = r === 0 && l === 0, b = [];
  if (h && y)
    return [];
  if (h) {
    var E = -a / r, x = -p / l;
    return E !== x ? [] : [[-1 / 0, E], [1 / 0, E]];
  } else if (y) {
    var C = -a / n, T = -p / s;
    return C !== T ? [] : [[C, -1 / 0], [C, 1 / 0]];
  } else if (n === 0) {
    var O = -a / r, D = -(l * O + p) / s;
    b = [[D, O]];
  } else if (s === 0) {
    var O = -p / l, D = -(r * O + a) / n;
    b = [[D, O]];
  } else if (r === 0) {
    var D = -a / n, O = -(s * D + p) / l;
    b = [[D, O]];
  } else if (l === 0) {
    var D = -p / s, O = -(n * D + a) / r;
    b = [[D, O]];
  } else {
    var D = (r * p - l * a) / (l * n - r * s), O = -(n * D + a) / r;
    b = [[D, O]];
  }
  return b.map(function(A) {
    return [A[0], A[1]];
  });
}
function ML(e, t) {
  var n = t.map(function(E) {
    return [0, 1].map(function(x) {
      return [Math.min(E[0][x], E[1][x]), Math.max(E[0][x], E[1][x])];
    });
  }), r = [];
  if (e.length === 2) {
    var a = e[0], s = a[0], l = a[1];
    if (es(s - e[1][0])) {
      if (!es(l - e[1][1])) {
        var y = Math.max.apply(Math, n.map(function(E) {
          return E[0][0];
        })), b = Math.min.apply(Math, n.map(function(E) {
          return E[0][1];
        }));
        if (es(y - b) > 0)
          return [];
        r = [[y, l], [b, l]];
      }
    } else {
      var p = Math.max.apply(Math, n.map(function(E) {
        return E[1][0];
      })), h = Math.min.apply(Math, n.map(function(E) {
        return E[1][1];
      }));
      if (es(p - h) > 0)
        return [];
      r = [[s, p], [s, h]];
    }
  }
  return r.length || (r = e.filter(function(E) {
    var x = E[0], C = E[1];
    return n.every(function(T) {
      return 0 <= es(x - T[0][0]) && 0 <= es(T[0][1] - x) && 0 <= es(C - T[1][0]) && 0 <= es(T[1][1] - C);
    });
  })), r.map(function(E) {
    return [es(E[0]), es(E[1])];
  });
}
function zT(e) {
  return H5(e.slice(1), [e[0]]).map(function(t, n) {
    return [e[n], t];
  });
}
function X5(e, t) {
  var n = e.slice(), r = t.slice();
  NT(n) === -1 && n.reverse(), NT(r) === -1 && r.reverse();
  var a = zT(n), s = zT(r), l = a.map(function(b) {
    return lx(b[0], b[1]);
  }), p = s.map(function(b) {
    return lx(b[0], b[1]);
  }), h = [];
  l.forEach(function(b, E) {
    var x = a[E], C = [];
    p.forEach(function(T, O) {
      var D = lD(b, T), A = ML(D, [x, s[O]]);
      C.push.apply(C, A.map(function(B) {
        return {
          index1: E,
          index2: O,
          pos: B,
          type: "intersection"
        };
      }));
    }), C.sort(function(T, O) {
      return Qu(x[0], T.pos) - Qu(x[0], O.pos);
    }), h.push.apply(h, C), ux(x[1], r) && h.push({
      index1: E,
      index2: -1,
      pos: x[1],
      type: "inside"
    });
  }), s.forEach(function(b, E) {
    if (!!ux(b[1], n)) {
      var x = !1, C = yd(h, function(T) {
        var O = T.index2;
        return O === E ? (x = !0, !1) : !!x;
      });
      C === -1 && (x = !1, C = yd(h, function(T) {
        var O = T.index1, D = T.index2;
        return O === -1 && D + 1 === E ? (x = !0, !1) : !!x;
      })), C === -1 ? h.push({
        index1: -1,
        index2: E,
        pos: b[1],
        type: "inside"
      }) : h.splice(C, 0, {
        index1: -1,
        index2: E,
        pos: b[1],
        type: "inside"
      });
    }
  });
  var y = {};
  return h.filter(function(b) {
    var E = b.pos, x = E[0] + "x" + E[1];
    return y[x] ? !1 : (y[x] = !0, !0);
  });
}
function FT(e, t) {
  var n = X5(e, t);
  return n.map(function(r) {
    var a = r.pos;
    return a;
  });
}
function K5(e, t) {
  var n = FT(e, t);
  return nb(n);
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var $T = function() {
  return $T = Object.assign || function(t) {
    for (var n, r = 1, a = arguments.length; r < a; r++) {
      n = arguments[r];
      for (var s in n)
        Object.prototype.hasOwnProperty.call(n, s) && (t[s] = n[s]);
    }
    return t;
  }, $T.apply(this, arguments);
};
function Q5() {
  for (var e = 0, t = 0, n = arguments.length; t < n; t++)
    e += arguments[t].length;
  for (var r = Array(e), a = 0, t = 0; t < n; t++)
    for (var s = arguments[t], l = 0, p = s.length; l < p; l++, a++)
      r[a] = s[l];
  return r;
}
var Z5 = /* @__PURE__ */ function() {
  function e() {
    this._events = {};
  }
  var t = e.prototype;
  return t.on = function(n, r) {
    if (rs(n))
      for (var a in n)
        this.on(a, n[a]);
    else
      this._addEvent(n, r, {});
    return this;
  }, t.off = function(n, r) {
    if (!n)
      this._events = {};
    else if (rs(n))
      for (var a in n)
        this.off(a);
    else if (!r)
      this._events[n] = [];
    else {
      var s = this._events[n];
      if (s) {
        var l = yd(s, function(p) {
          return p.listener === r;
        });
        l > -1 && s.splice(l, 1);
      }
    }
    return this;
  }, t.once = function(n, r) {
    var a = this;
    return r && this._addEvent(n, r, {
      once: !0
    }), new Promise(function(s) {
      a._addEvent(n, s, {
        once: !0
      });
    });
  }, t.emit = function(n, r) {
    var a = this;
    r === void 0 && (r = {});
    var s = this._events[n];
    if (!n || !s)
      return !0;
    var l = !1;
    return r.eventType = n, r.stop = function() {
      l = !0;
    }, r.currentTarget = this, Q5(s).forEach(function(p) {
      p.listener(r), p.once && a.off(n, p.listener);
    }), !l;
  }, t.trigger = function(n, r) {
    return r === void 0 && (r = {}), this.emit(n, r);
  }, t._addEvent = function(n, r, a) {
    var s = this._events;
    s[n] = s[n] || [];
    var l = s[n];
    l.push($T({
      listener: r
    }, a));
  }, e;
}();
const $b = Z5;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var UT = function(e, t) {
  return UT = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var a in r)
      r.hasOwnProperty(a) && (n[a] = r[a]);
  }, UT(e, t);
};
function J5(e, t) {
  UT(e, t);
  function n() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
}
var Km = function() {
  return Km = Object.assign || function(t) {
    for (var n, r = 1, a = arguments.length; r < a; r++) {
      n = arguments[r];
      for (var s in n)
        Object.prototype.hasOwnProperty.call(n, s) && (t[s] = n[s]);
    }
    return t;
  }, Km.apply(this, arguments);
};
function eW(e) {
  var t = e.container;
  return t === document.body ? [t.scrollLeft || document.documentElement.scrollLeft, t.scrollTop || document.documentElement.scrollTop] : [t.scrollLeft, t.scrollTop];
}
function GN(e, t) {
  return e.addEventListener("scroll", t), function() {
    e.removeEventListener("scroll", t);
  };
}
function dE(e) {
  if (e) {
    if (tc(e))
      return document.querySelector(e);
  } else
    return null;
  if (Fx(e))
    return e();
  if (e instanceof Element)
    return e;
  if ("current" in e)
    return e.current;
  if ("value" in e)
    return e.value;
}
var tW = /* @__PURE__ */ function(e) {
  J5(t, e);
  function t() {
    var r = e !== null && e.apply(this, arguments) || this;
    return r._startRect = null, r._startPos = [], r._prevTime = 0, r._timer = 0, r._prevScrollPos = [0, 0], r._isWait = !1, r._flag = !1, r._currentOptions = null, r._lock = !1, r._unregister = null, r._onScroll = function() {
      var a = r._currentOptions;
      r._lock || !a || r.emit("scrollDrag", {
        next: function(s) {
          r.checkScroll({
            container: a.container,
            inputEvent: s
          });
        }
      });
    }, r;
  }
  var n = t.prototype;
  return n.dragStart = function(r, a) {
    var s = dE(a.container);
    if (!s) {
      this._flag = !1;
      return;
    }
    var l = 0, p = 0, h = 0, y = 0;
    if (s === document.body)
      h = window.innerWidth, y = window.innerHeight;
    else {
      var b = s.getBoundingClientRect();
      l = b.top, p = b.left, h = b.width, y = b.height;
    }
    this._flag = !0, this._startPos = [r.clientX, r.clientY], this._startRect = {
      top: l,
      left: p,
      width: h,
      height: y
    }, this._prevScrollPos = this._getScrollPosition([0, 0], a), this._currentOptions = a, this._registerScrollEvent(a);
  }, n.drag = function(r, a) {
    if (clearTimeout(this._timer), !!this._flag) {
      var s = r.clientX, l = r.clientY, p = a.threshold, h = p === void 0 ? 0 : p, y = this, b = y._startRect, E = y._startPos;
      this._currentOptions = a;
      var x = [0, 0];
      return b.top > l - h ? (E[1] > b.top || l < E[1]) && (x[1] = -1) : b.top + b.height < l + h && (E[1] < b.top + b.height || l > E[1]) && (x[1] = 1), b.left > s - h ? (E[0] > b.left || s < E[0]) && (x[0] = -1) : b.left + b.width < s + h && (E[0] < b.left + b.width || s > E[0]) && (x[0] = 1), !x[0] && !x[1] ? !1 : this._continueDrag(Km(Km({}, a), {
        direction: x,
        inputEvent: r,
        isDrag: !0
      }));
    }
  }, n.checkScroll = function(r) {
    var a = this;
    if (this._isWait)
      return !1;
    var s = r.prevScrollPos, l = s === void 0 ? this._prevScrollPos : s, p = r.direction, h = r.throttleTime, y = h === void 0 ? 0 : h, b = r.inputEvent, E = r.isDrag, x = this._getScrollPosition(p || [0, 0], r), C = x[0] - l[0], T = x[1] - l[1], O = p || [C ? Math.abs(C) / C : 0, T ? Math.abs(T) / T : 0];
    return this._prevScrollPos = x, this._lock = !1, !C && !T ? !1 : (this.emit("move", {
      offsetX: O[0] ? C : 0,
      offsetY: O[1] ? T : 0,
      inputEvent: b
    }), y && E && (clearTimeout(this._timer), this._timer = window.setTimeout(function() {
      a._continueDrag(r);
    }, y)), !0);
  }, n.dragEnd = function() {
    this._flag = !1, this._lock = !1, clearTimeout(this._timer), this._unregisterScrollEvent();
  }, n._getScrollPosition = function(r, a) {
    var s = a.container, l = a.getScrollPosition, p = l === void 0 ? eW : l;
    return p({
      container: dE(s),
      direction: r
    });
  }, n._continueDrag = function(r) {
    var a = this, s, l = r.container, p = r.direction, h = r.throttleTime, y = r.useScroll, b = r.isDrag, E = r.inputEvent;
    if (!(!this._flag || b && this._isWait)) {
      var x = vb(), C = Math.max(h + this._prevTime - x, 0);
      if (C > 0)
        return clearTimeout(this._timer), this._timer = window.setTimeout(function() {
          a._continueDrag(r);
        }, C), !1;
      this._prevTime = x;
      var T = this._getScrollPosition(p, r);
      this._prevScrollPos = T, b && (this._isWait = !0), y || (this._lock = !0);
      var O = {
        container: dE(l),
        direction: p,
        inputEvent: E
      };
      return (s = r.requestScroll) === null || s === void 0 || s.call(r, O), this.emit("scroll", O), this._isWait = !1, y || this.checkScroll(Km(Km({}, r), {
        prevScrollPos: T,
        direction: p,
        inputEvent: E
      }));
    }
  }, n._registerScrollEvent = function(r) {
    this._unregisterScrollEvent();
    var a = r.checkScrollEvent;
    if (!!a) {
      var s = a === !0 ? GN : a, l = dE(r.container);
      a === !0 && (l === document.body || l === document.documentElement) ? this._unregister = GN(window, this._onScroll) : this._unregister = s(l, this._onScroll);
    }
  }, n._unregisterScrollEvent = function() {
    var r;
    (r = this._unregister) === null || r === void 0 || r.call(this), this._unregister = null;
  }, t;
}($b);
const AL = tW;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var VT = function(e, t) {
  return VT = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var a in r)
      r.hasOwnProperty(a) && (n[a] = r[a]);
  }, VT(e, t);
};
function nW(e, t) {
  VT(e, t);
  function n() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
}
var Li = function() {
  return Li = Object.assign || function(t) {
    for (var n, r = 1, a = arguments.length; r < a; r++) {
      n = arguments[r];
      for (var s in n)
        Object.prototype.hasOwnProperty.call(n, s) && (t[s] = n[s]);
    }
    return t;
  }, Li.apply(this, arguments);
};
function rW(e, t) {
  var n = t[0] - e[0], r = t[1] - e[1], a = Math.atan2(r, n);
  return a >= 0 ? a : a + Math.PI * 2;
}
function HR(e) {
  return rW([
    e[0].clientX,
    e[0].clientY
  ], [
    e[1].clientX,
    e[1].clientY
  ]) / Math.PI * 180;
}
function iW(e) {
  return e.touches && e.touches.length >= 2;
}
function pE(e) {
  return e ? e.touches ? oW(e.touches) : [PL(e)] : [];
}
function aW(e) {
  return e && (e.type.indexOf("mouse") > -1 || "button" in e);
}
function HN(e, t, n) {
  var r = n.length, a = rb(e, r), s = a.clientX, l = a.clientY, p = a.originalClientX, h = a.originalClientY, y = rb(t, r), b = y.clientX, E = y.clientY, x = rb(n, r), C = x.clientX, T = x.clientY, O = s - b, D = l - E, A = s - C, B = l - T;
  return {
    clientX: p,
    clientY: h,
    deltaX: O,
    deltaY: D,
    distX: A,
    distY: B
  };
}
function YR(e) {
  return Math.sqrt(Math.pow(e[0].clientX - e[1].clientX, 2) + Math.pow(e[0].clientY - e[1].clientY, 2));
}
function oW(e) {
  for (var t = Math.min(e.length, 2), n = [], r = 0; r < t; ++r)
    n.push(PL(e[r]));
  return n;
}
function PL(e) {
  return {
    clientX: e.clientX,
    clientY: e.clientY
  };
}
function rb(e, t) {
  t === void 0 && (t = e.length);
  for (var n = {
    clientX: 0,
    clientY: 0,
    originalClientX: 0,
    originalClientY: 0
  }, r = 0; r < t; ++r) {
    var a = e[r];
    n.originalClientX += "originalClientX" in a ? a.originalClientX : a.clientX, n.originalClientY += "originalClientY" in a ? a.originalClientY : a.clientY, n.clientX += a.clientX, n.clientY += a.clientY;
  }
  return t ? {
    clientX: n.clientX / t,
    clientY: n.clientY / t,
    originalClientX: n.originalClientX / t,
    originalClientY: n.originalClientY / t
  } : n;
}
var qR = /* @__PURE__ */ function() {
  function e(t) {
    this.prevClients = [], this.startClients = [], this.movement = 0, this.length = 0, this.startClients = t, this.prevClients = t, this.length = t.length;
  }
  return e.prototype.getAngle = function(t) {
    return t === void 0 && (t = this.prevClients), HR(t);
  }, e.prototype.getRotation = function(t) {
    return t === void 0 && (t = this.prevClients), HR(t) - HR(this.startClients);
  }, e.prototype.getPosition = function(t, n) {
    t === void 0 && (t = this.prevClients);
    var r = HN(t || this.prevClients, this.prevClients, this.startClients), a = r.deltaX, s = r.deltaY;
    return this.movement += Math.sqrt(a * a + s * s), this.prevClients = t, r;
  }, e.prototype.getPositions = function(t) {
    t === void 0 && (t = this.prevClients);
    var n = this.prevClients;
    return this.startClients.map(function(r, a) {
      return HN([t[a]], [n[a]], [r]);
    });
  }, e.prototype.getMovement = function(t) {
    var n = this.movement;
    if (!t)
      return n;
    var r = rb(t, this.length), a = rb(this.prevClients, this.length), s = r.clientX - a.clientX, l = r.clientY - a.clientY;
    return Math.sqrt(s * s + l * l) + n;
  }, e.prototype.getDistance = function(t) {
    return t === void 0 && (t = this.prevClients), YR(t);
  }, e.prototype.getScale = function(t) {
    return t === void 0 && (t = this.prevClients), YR(t) / YR(this.startClients);
  }, e.prototype.move = function(t, n) {
    this.startClients.forEach(function(r) {
      r.clientX -= t, r.clientY -= n;
    }), this.prevClients.forEach(function(r) {
      r.clientX -= t, r.clientY -= n;
    });
  }, e;
}(), YN = ["textarea", "input"], NL = /* @__PURE__ */ function(e) {
  nW(t, e);
  function t(n, r) {
    r === void 0 && (r = {});
    var a = e.call(this) || this;
    a.options = {}, a.flag = !1, a.pinchFlag = !1, a.data = {}, a.isDrag = !1, a.isPinch = !1, a.clientStores = [], a.targets = [], a.prevTime = 0, a.doubleFlag = !1, a._useMouse = !1, a._useTouch = !1, a._useDrag = !1, a._dragFlag = !1, a._isTrusted = !1, a._isMouseEvent = !1, a._isSecondaryButton = !1, a._preventMouseEvent = !1, a._prevInputEvent = null, a._isDragAPI = !1, a._isIdle = !0, a._window = window, a.onDragStart = function(x, C) {
      if (C === void 0 && (C = !0), !(!a.flag && x.cancelable === !1)) {
        var T = x.type.indexOf("drag") >= -1;
        if (!(a.flag && T)) {
          a._isDragAPI = !0;
          var O = a.options, D = O.container, A = O.pinchOutside, B = O.preventWheelClick, I = O.preventRightClick, L = O.preventDefault, k = O.checkInput, $ = O.dragFocusedInput, U = O.preventClickEventOnDragStart, K = O.preventClickEventOnDrag, X = O.preventClickEventByCondition, Y = a._useTouch, J = !a.flag;
          if (a._isSecondaryButton = x.which === 3 || x.button === 2, B && (x.which === 2 || x.button === 1) || I && (x.which === 3 || x.button === 2))
            return a.stop(), !1;
          if (J) {
            var Q = a._window.document.activeElement, Z = x.target;
            if (Z) {
              var se = Z.tagName.toLowerCase(), pe = YN.indexOf(se) > -1, be = Z.isContentEditable;
              if (pe || be) {
                if (k || !$ && Q === Z)
                  return !1;
                if (Q && (Q === Z || be && Q.isContentEditable && Q.contains(Z)))
                  if ($)
                    Z.blur();
                  else
                    return !1;
              } else if ((L || x.type === "touchstart") && Q) {
                var _e = Q.tagName.toLowerCase();
                (Q.isContentEditable || YN.indexOf(_e) > -1) && Q.blur();
              }
              (U || K || X) && zi(a._window, "click", a._onClick, !0);
            }
            a.clientStores = [new qR(pE(x))], a._isIdle = !1, a.flag = !0, a.isDrag = !1, a._isTrusted = C, a._dragFlag = !0, a._prevInputEvent = x, a.data = {}, a.doubleFlag = vb() - a.prevTime < 200, a._isMouseEvent = aW(x), !a._isMouseEvent && a._preventMouseEvent && (a._preventMouseEvent = !1);
            var Se = a._preventMouseEvent || a.emit("dragStart", Li(Li({ data: a.data, datas: a.data, inputEvent: x, isMouseEvent: a._isMouseEvent, isSecondaryButton: a._isSecondaryButton, isTrusted: C, isDouble: a.doubleFlag }, a.getCurrentStore().getPosition()), { preventDefault: function() {
              x.preventDefault();
            }, preventDrag: function() {
              a._dragFlag = !1;
            } }));
            Se === !1 && a.stop(), a._isMouseEvent && a.flag && L && x.preventDefault();
          }
          if (!a.flag)
            return !1;
          var Oe = 0;
          if (J ? (a._attchDragEvent(), Y && A && (Oe = setTimeout(function() {
            zi(D, "touchstart", a.onDragStart, {
              passive: !1
            });
          }))) : Y && A && Oi(D, "touchstart", a.onDragStart), a.flag && iW(x)) {
            if (clearTimeout(Oe), J && x.touches.length !== x.changedTouches.length)
              return;
            a.pinchFlag || a.onPinchStart(x);
          }
        }
      }
    }, a.onDrag = function(x, C) {
      if (!!a.flag) {
        var T = a.options.preventDefault;
        !a._isMouseEvent && T && x.preventDefault(), a._prevInputEvent = x;
        var O = pE(x), D = a.moveClients(O, x, !1);
        if (a._dragFlag) {
          if (a.pinchFlag || D.deltaX || D.deltaY) {
            var A = a._preventMouseEvent || a.emit("drag", Li(Li({}, D), { isScroll: !!C, inputEvent: x }));
            if (A === !1) {
              a.stop();
              return;
            }
          }
          a.pinchFlag && a.onPinch(x, O);
        }
        a.getCurrentStore().getPosition(O, !0);
      }
    }, a.onDragEnd = function(x) {
      if (!!a.flag) {
        var C = a.options, T = C.pinchOutside, O = C.container, D = C.preventClickEventOnDrag, A = C.preventClickEventOnDragStart, B = C.preventClickEventByCondition, I = a.isDrag;
        (D || A || B) && requestAnimationFrame(function() {
          a._allowClickEvent();
        }), !B && !A && D && !I && a._allowClickEvent(), a._useTouch && T && Oi(O, "touchstart", a.onDragStart), a.pinchFlag && a.onPinchEnd(x);
        var L = x != null && x.touches ? pE(x) : [], k = L.length;
        k === 0 || !a.options.keepDragging ? a.flag = !1 : a._addStore(new qR(L));
        var $ = a._getPosition(), U = vb(), K = !I && a.doubleFlag;
        a._prevInputEvent = null, a.prevTime = I || K ? 0 : U, a.flag || (a._dettachDragEvent(), a._preventMouseEvent || a.emit("dragEnd", Li({ data: a.data, datas: a.data, isDouble: K, isDrag: I, isClick: !I, isMouseEvent: a._isMouseEvent, isSecondaryButton: a._isSecondaryButton, inputEvent: x, isTrusted: a._isTrusted }, $)), a.clientStores = [], a._isMouseEvent || (a._preventMouseEvent = !0, requestAnimationFrame(function() {
          requestAnimationFrame(function() {
            a._preventMouseEvent = !1;
          });
        })), a._isIdle = !0);
      }
    }, a.onBlur = function() {
      a.onDragEnd();
    }, a._allowClickEvent = function() {
      Oi(a._window, "click", a._onClick, !0);
    }, a._onClick = function(x) {
      a._allowClickEvent(), a._preventMouseEvent = !1;
      var C = a.options.preventClickEventByCondition;
      C != null && C(x) || (x.stopPropagation(), x.preventDefault());
    }, a._onContextMenu = function(x) {
      var C = a.options;
      C.preventRightClick ? a.onDragEnd(x) : x.preventDefault();
    }, a._passCallback = function() {
    };
    var s = [].concat(n), l = s[0];
    a._window = R5(l) ? l : jh(l), a.options = Li({ checkInput: !1, container: l && !("document" in l) ? jh(l) : l, preventRightClick: !0, preventWheelClick: !0, preventClickEventOnDragStart: !1, preventClickEventOnDrag: !1, preventClickEventByCondition: null, preventDefault: !0, checkWindowBlur: !1, keepDragging: !1, pinchThreshold: 0, events: ["touch", "mouse"] }, r);
    var p = a.options, h = p.container, y = p.events, b = p.checkWindowBlur;
    if (a._useDrag = y.indexOf("drag") > -1, a._useTouch = y.indexOf("touch") > -1, a._useMouse = y.indexOf("mouse") > -1, a.targets = s, a._useDrag && s.forEach(function(x) {
      zi(x, "dragstart", a.onDragStart);
    }), a._useMouse && (s.forEach(function(x) {
      zi(x, "mousedown", a.onDragStart), zi(x, "mousemove", a._passCallback);
    }), zi(h, "contextmenu", a._onContextMenu)), b && zi(jh(), "blur", a.onBlur), a._useTouch) {
      var E = {
        passive: !1
      };
      s.forEach(function(x) {
        zi(x, "touchstart", a.onDragStart, E), zi(x, "touchmove", a._passCallback, E);
      });
    }
    return a;
  }
  return t.prototype.stop = function() {
    this.isDrag = !1, this.data = {}, this.clientStores = [], this.pinchFlag = !1, this.doubleFlag = !1, this.prevTime = 0, this.flag = !1, this._isIdle = !0, this._allowClickEvent(), this._dettachDragEvent(), this._isDragAPI = !1;
  }, t.prototype.getMovement = function(n) {
    return this.getCurrentStore().getMovement(n) + this.clientStores.slice(1).reduce(function(r, a) {
      return r + a.movement;
    }, 0);
  }, t.prototype.isDragging = function() {
    return this.isDrag;
  }, t.prototype.isIdle = function() {
    return this._isIdle;
  }, t.prototype.isFlag = function() {
    return this.flag;
  }, t.prototype.isPinchFlag = function() {
    return this.pinchFlag;
  }, t.prototype.isDoubleFlag = function() {
    return this.doubleFlag;
  }, t.prototype.isPinching = function() {
    return this.isPinch;
  }, t.prototype.scrollBy = function(n, r, a, s) {
    s === void 0 && (s = !0), this.flag && (this.clientStores[0].move(n, r), s && this.onDrag(a, !0));
  }, t.prototype.move = function(n, r) {
    var a = n[0], s = n[1], l = this.getCurrentStore(), p = l.prevClients;
    return this.moveClients(p.map(function(h) {
      var y = h.clientX, b = h.clientY;
      return {
        clientX: y + a,
        clientY: b + s,
        originalClientX: y,
        originalClientY: b
      };
    }), r, !0);
  }, t.prototype.triggerDragStart = function(n) {
    this.onDragStart(n, !1);
  }, t.prototype.setEventData = function(n) {
    var r = this.data;
    for (var a in n)
      r[a] = n[a];
    return this;
  }, t.prototype.setEventDatas = function(n) {
    return this.setEventData(n);
  }, t.prototype.getCurrentEvent = function(n) {
    return n === void 0 && (n = this._prevInputEvent), Li(Li({ data: this.data, datas: this.data }, this._getPosition()), { movement: this.getMovement(), isDrag: this.isDrag, isPinch: this.isPinch, isScroll: !1, inputEvent: n });
  }, t.prototype.getEventData = function() {
    return this.data;
  }, t.prototype.getEventDatas = function() {
    return this.data;
  }, t.prototype.unset = function() {
    var n = this, r = this.targets, a = this.options.container;
    this.off(), Oi(this._window, "blur", this.onBlur), this._useDrag && r.forEach(function(s) {
      Oi(s, "dragstart", n.onDragStart);
    }), this._useMouse && (r.forEach(function(s) {
      Oi(s, "mousedown", n.onDragStart);
    }), Oi(a, "contextmenu", this._onContextMenu)), this._useTouch && (r.forEach(function(s) {
      Oi(s, "touchstart", n.onDragStart);
    }), Oi(a, "touchstart", this.onDragStart)), this._prevInputEvent = null, this._allowClickEvent(), this._dettachDragEvent();
  }, t.prototype.onPinchStart = function(n) {
    var r = this, a = this.options.pinchThreshold;
    if (!(this.isDrag && this.getMovement() > a)) {
      var s = new qR(pE(n));
      this.pinchFlag = !0, this._addStore(s);
      var l = this.emit("pinchStart", Li(Li({ data: this.data, datas: this.data, angle: s.getAngle(), touches: this.getCurrentStore().getPositions() }, s.getPosition()), { inputEvent: n, isTrusted: this._isTrusted, preventDefault: function() {
        n.preventDefault();
      }, preventDrag: function() {
        r._dragFlag = !1;
      } }));
      l === !1 && (this.pinchFlag = !1);
    }
  }, t.prototype.onPinch = function(n, r) {
    if (!(!this.flag || !this.pinchFlag || r.length < 2)) {
      var a = this.getCurrentStore();
      this.isPinch = !0, this.emit("pinch", Li(Li({ data: this.data, datas: this.data, movement: this.getMovement(r), angle: a.getAngle(r), rotation: a.getRotation(r), touches: a.getPositions(r), scale: a.getScale(r), distance: a.getDistance(r) }, a.getPosition(r)), { inputEvent: n, isTrusted: this._isTrusted }));
    }
  }, t.prototype.onPinchEnd = function(n) {
    if (!!this.pinchFlag) {
      var r = this.isPinch;
      this.isPinch = !1, this.pinchFlag = !1;
      var a = this.getCurrentStore();
      this.emit("pinchEnd", Li(Li({ data: this.data, datas: this.data, isPinch: r, touches: a.getPositions() }, a.getPosition()), { inputEvent: n }));
    }
  }, t.prototype.getCurrentStore = function() {
    return this.clientStores[0];
  }, t.prototype.moveClients = function(n, r, a) {
    var s = this._getPosition(n, a), l = this.isDrag;
    (s.deltaX || s.deltaY) && (this.isDrag = !0);
    var p = !1;
    return !l && this.isDrag && (p = !0), Li(Li({ data: this.data, datas: this.data }, s), { movement: this.getMovement(n), isDrag: this.isDrag, isPinch: this.isPinch, isScroll: !1, isMouseEvent: this._isMouseEvent, isSecondaryButton: this._isSecondaryButton, inputEvent: r, isTrusted: this._isTrusted, isFirstDrag: p });
  }, t.prototype._addStore = function(n) {
    this.clientStores.splice(0, 0, n);
  }, t.prototype._getPosition = function(n, r) {
    var a = this.getCurrentStore(), s = a.getPosition(n, r), l = this.clientStores.slice(1).reduce(function(y, b) {
      var E = b.getPosition();
      return y.distX += E.distX, y.distY += E.distY, y;
    }, s), p = l.distX, h = l.distY;
    return Li(Li({}, s), { distX: p, distY: h });
  }, t.prototype._attchDragEvent = function() {
    var n = this._window, r = this.options.container, a = {
      passive: !1
    };
    this._isDragAPI && (zi(r, "dragover", this.onDrag, a), zi(n, "dragend", this.onDragEnd)), this._useMouse && (zi(r, "mousemove", this.onDrag), zi(n, "mouseup", this.onDragEnd)), this._useTouch && (zi(r, "touchmove", this.onDrag, a), zi(n, "touchend", this.onDragEnd, a), zi(n, "touchcancel", this.onDragEnd, a));
  }, t.prototype._dettachDragEvent = function() {
    var n = this._window, r = this.options.container;
    this._isDragAPI && (Oi(r, "dragover", this.onDrag), Oi(n, "dragend", this.onDragEnd)), this._useMouse && (Oi(r, "mousemove", this.onDrag), Oi(n, "mouseup", this.onDragEnd)), this._useTouch && (Oi(r, "touchstart", this.onDragStart), Oi(r, "touchmove", this.onDrag), Oi(n, "touchend", this.onDragEnd), Oi(n, "touchcancel", this.onDragEnd));
  }, t;
}($b);
function sW(e) {
  for (var t = 5381, n = e.length; n; )
    t = t * 33 ^ e.charCodeAt(--n);
  return t >>> 0;
}
var uW = sW;
function lW(e) {
  return uW(e).toString(36);
}
function cW(e) {
  if (e && e.getRootNode) {
    var t = e.getRootNode();
    if (t.nodeType === 11)
      return t;
  }
}
function fW(e, t, n) {
  return n.original ? t : t.replace(/([^};{\s}][^};{]*|^\s*){/mg, function(r, a) {
    var s = a.trim();
    return (s ? Vh(s) : [""]).map(function(l) {
      var p = l.trim();
      return p.indexOf("@") === 0 ? p : p.indexOf(":global") > -1 ? p.replace(/\:global/g, "") : p.indexOf(":host") > -1 ? "".concat(p.replace(/\:host/g, ".".concat(e))) : p ? ".".concat(e, " ").concat(p) : ".".concat(e);
    }).join(", ") + " {";
  });
}
function dW(e, t, n, r, a) {
  var s = dd(r), l = s.createElement("style");
  return l.setAttribute("type", "text/css"), l.setAttribute("data-styled-id", e), l.setAttribute("data-styled-count", "1"), n.nonce && l.setAttribute("nonce", n.nonce), l.innerHTML = fW(e, t, n), (a || s.head || s.body).appendChild(l), l;
}
function kL(e) {
  var t = "rCS" + lW(e);
  return {
    className: t,
    inject: function(n, r) {
      r === void 0 && (r = {});
      var a = cW(n), s = (a || n.ownerDocument || document).querySelector('style[data-styled-id="'.concat(t, '"]'));
      if (!s)
        s = dW(t, e, r, n, a);
      else {
        var l = parseFloat(s.getAttribute("data-styled-count")) || 0;
        s.setAttribute("data-styled-count", "".concat(l + 1));
      }
      return {
        destroy: function() {
          var p, h = parseFloat(s.getAttribute("data-styled-count")) || 0;
          h <= 1 ? (s.remove ? s.remove() : (p = s.parentNode) === null || p === void 0 || p.removeChild(s), s = null) : s.setAttribute("data-styled-count", "".concat(h - 1));
        }
      };
    }
  };
}
var jT = function(e, t) {
  return jT = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var a in r)
      Object.prototype.hasOwnProperty.call(r, a) && (n[a] = r[a]);
  }, jT(e, t);
};
function IL(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  jT(e, t);
  function n() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
}
var cx = function() {
  return cx = Object.assign || function(t) {
    for (var n, r = 1, a = arguments.length; r < a; r++) {
      n = arguments[r];
      for (var s in n)
        Object.prototype.hasOwnProperty.call(n, s) && (t[s] = n[s]);
    }
    return t;
  }, cx.apply(this, arguments);
};
function pW(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
      t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
}
var vW = /* @__PURE__ */ function(e) {
  IL(t, e);
  function t() {
    var r = e !== null && e.apply(this, arguments) || this;
    return r.injectResult = null, r.tag = "div", r;
  }
  var n = t.prototype;
  return n.render = function() {
    var r = this.props, a = r.className, s = a === void 0 ? "" : a;
    r.cspNonce;
    var l = r.portalContainer, p = pW(r, ["className", "cspNonce", "portalContainer"]), h = this.injector.className, y = this.tag, b = {};
    return (PU || "").indexOf("simple") > -1 && l && (b = {
      portalContainer: l
    }), Ks(y, cx(cx({
      ref: hd(this, "element"),
      "data-styled-id": h,
      className: "".concat(s, " ").concat(h)
    }, b), p));
  }, n.componentDidMount = function() {
    this.injectResult = this.injector.inject(this.element, {
      nonce: this.props.cspNonce
    });
  }, n.componentWillUnmount = function() {
    this.injectResult.destroy(), this.injectResult = null;
  }, n.getElement = function() {
    return this.element;
  }, t;
}(Rb);
function LL(e, t) {
  var n = kL(t);
  return /* @__PURE__ */ function(r) {
    IL(a, r);
    function a() {
      var s = r !== null && r.apply(this, arguments) || this;
      return s.injector = n, s.tag = e, s;
    }
    return a;
  }(vW);
}
var WT = function(e, t) {
  return WT = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var a in r)
      Object.prototype.hasOwnProperty.call(r, a) && (n[a] = r[a]);
  }, WT(e, t);
};
function Ub(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  WT(e, t);
  function n() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
}
var we = function() {
  return we = Object.assign || function(t) {
    for (var n, r = 1, a = arguments.length; r < a; r++) {
      n = arguments[r];
      for (var s in n)
        Object.prototype.hasOwnProperty.call(n, s) && (t[s] = n[s]);
    }
    return t;
  }, we.apply(this, arguments);
};
function hW(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
      t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
}
function gW(e, t, n, r) {
  var a = arguments.length, s = a < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, n) : r, l;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    s = Reflect.decorate(e, t, n, r);
  else
    for (var p = e.length - 1; p >= 0; p--)
      (l = e[p]) && (s = (a < 3 ? l(s) : a > 3 ? l(t, n, s) : l(t, n)) || s);
  return a > 3 && s && Object.defineProperty(t, n, s), s;
}
function jt(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, a = t.length, s; r < a; r++)
      (s || !(r in t)) && (s || (s = Array.prototype.slice.call(t, 0, r)), s[r] = t[r]);
  return e.concat(s || Array.prototype.slice.call(t));
}
function Vb(e, t) {
  var n;
  return we({
    events: {},
    props: (n = {}, n[e] = Boolean, n),
    name: e
  }, t);
}
function mW(e, t) {
  return 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="'.concat(32 * e, 'px" height="').concat(32 * e, 'px" viewBox="0 0 32 32" ><path d="M 16,5 L 12,10 L 14.5,10 L 14.5,22 L 12,22 L 16,27 L 20,22 L 17.5,22 L 17.5,10 L 20, 10 L 16,5 Z" stroke-linejoin="round" stroke-width="1.2" fill="black" stroke="white" style="transform:rotate(').concat(t, 'deg);transform-origin: 16px 16px"></path></svg>');
}
function yW(e) {
  var t = mW(1, e), n = Math.round(e / 45) * 45 % 180, r = "ns-resize";
  return n === 135 ? r = "nwse-resize" : n === 45 ? r = "nesw-resize" : n === 90 && (r = "ew-resize"), "cursor:".concat(r, ";cursor: url('").concat(t, "') 16 16, ").concat(r, ";");
}
var fx = l5(), BL = fx.browser.webkit, zL = BL && function() {
  var e = typeof window > "u" ? {
    userAgent: ""
  } : window.navigator, t = /applewebkit\/([^\s]+)/g.exec(e.userAgent.toLowerCase());
  return t ? parseFloat(t[1]) < 605 : !1;
}(), bW = fx.browser.name === "firefox", _W = parseInt(fx.browser.webkitVersion, 10) >= 612 || parseInt(fx.browser.version, 10) >= 15, cD = "moveable-", EW = `
{
	position: absolute;
	width: 1px;
	height: 1px;
	left: 0;
	top: 0;
    z-index: 3000;
    --moveable-color: #4af;
    --zoom: 1;
    --zoompx: 1px;
    will-change: transform;
    outline: 1px solid transparent;
}
.control-box {
    z-index: 0;
}
.line, .control {
    position: absolute;
	left: 0;
    top: 0;
    will-change: transform;
}
.control {
	width: 14px;
	height: 14px;
	border-radius: 50%;
	border: 2px solid #fff;
	box-sizing: border-box;
    background: #4af;
    background: var(--moveable-color);
	margin-top: -7px;
    margin-left: -7px;
    border: 2px solid #fff;
    z-index: 10;
}
.padding {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100px;
    height: 100px;
    transform-origin: 0 0;
}
.line {
	width: 1px;
    height: 1px;
    background: #4af;
    background: var(--moveable-color);
	transform-origin: 0px 50%;
}
.line.edge {
    z-index: 1;
    background: transparent;
}
.line.dashed {
    box-sizing: border-box;
    background: transparent;
}
.line.dashed.horizontal {
    border-top: 1px dashed #4af;
    border-top-color: #4af;
    border-top-color: var(--moveable-color);
}
.line.dashed.vertical {
    border-left: 1px dashed #4af;
    border-left-color: #4af;
    border-left-color: var(--moveable-color);
}
.line.vertical {
    transform: translateX(-50%);
}
.line.horizontal {
    transform: translateY(-50%);
}
.line.vertical.bold {
    width: 2px;
}
.line.horizontal.bold {
    height: 2px;
}

.control.origin {
	border-color: #f55;
	background: #fff;
	width: 12px;
	height: 12px;
	margin-top: -6px;
    margin-left: -6px;
	pointer-events: none;
}
`.concat([0, 15, 30, 45, 60, 75, 90, 105, 120, 135, 150, 165].map(function(e) {
  return `
.direction[data-rotation="`.concat(e, '"], :global .view-control-rotation').concat(e, ` {
	`).concat(yW(e), `
}
`);
}).join(`
`), `
.group {
    z-index: -1;
}
.area {
    position: absolute;
}
.area-pieces {
    position: absolute;
    top: 0;
    left: 0;
    display: none;
}
.area.avoid, .area.pass {
    pointer-events: none;
}
.area.avoid+.area-pieces {
    display: block;
}
.area-piece {
    position: absolute;
}

`).concat(zL ? `:global svg *:before {
	content:"";
	transform-origin: inherit;
}` : "", `
`), xW = [[0, 1, 2], [1, 0, 3], [2, 0, 3], [3, 1, 2]], GT = 1e-4, Ro = 1e-7, vE = 1e-9, HT = Math.pow(10, 10), qN = -HT, SW = ["n", "w", "s", "e"], fD = ["n", "w", "s", "e", "nw", "ne", "sw", "se"], wW = {
  n: [0, -1],
  e: [1, 0],
  s: [0, 1],
  w: [-1, 0],
  nw: [-1, -1],
  ne: [1, -1],
  sw: [-1, 1],
  se: [1, 1]
}, dD = {
  n: [0, 1],
  e: [1, 3],
  s: [3, 2],
  w: [2, 0],
  nw: [0],
  ne: [1],
  sw: [2],
  se: [3]
}, FL = {
  n: 0,
  s: 180,
  w: 270,
  e: 90,
  nw: 315,
  ne: 45,
  sw: 225,
  se: 135
}, CW = ["isMoveableElement", "updateRect", "updateTarget", "destroy", "dragStart", "isInside", "hitTest", "setState", "getRect", "request", "isDragging", "getManager", "forceUpdate", "waitToChangeTarget", "updateSelectors", "getTargets", "stopDrag"];
function jb(e, t, n, r, a, s) {
  var l, p;
  s === void 0 && (s = "draggable");
  var h = (p = (l = t.gestos[s]) === null || l === void 0 ? void 0 : l.move(n, e.inputEvent)) !== null && p !== void 0 ? p : {}, y = h.originalDatas || h.datas, b = y[s] || (y[s] = {});
  return we(we({}, a ? uB(t, h) : h), {
    isPinch: !!r,
    parentEvent: !0,
    datas: b,
    originalDatas: e.originalDatas
  });
}
var my = /* @__PURE__ */ function() {
  function e(n) {
    var r;
    n === void 0 && (n = "draggable"), this.ableName = n, this.prevX = 0, this.prevY = 0, this.startX = 0, this.startY = 0, this.isDrag = !1, this.isFlag = !1, this.datas = {
      draggable: {}
    }, this.datas = (r = {}, r[n] = {}, r);
  }
  var t = e.prototype;
  return t.dragStart = function(n, r) {
    this.isDrag = !1, this.isFlag = !1;
    var a = r.originalDatas;
    return this.datas = a, a[this.ableName] || (a[this.ableName] = {}), we(we({}, this.move(n, r.inputEvent)), {
      type: "dragstart"
    });
  }, t.drag = function(n, r) {
    return this.move([n[0] - this.prevX, n[1] - this.prevY], r);
  }, t.move = function(n, r) {
    var a, s, l = !1;
    if (!this.isFlag)
      this.prevX = n[0], this.prevY = n[1], this.startX = n[0], this.startY = n[1], a = n[0], s = n[1], this.isFlag = !0;
    else {
      var p = this.isDrag;
      a = this.prevX + n[0], s = this.prevY + n[1], (n[0] || n[1]) && (this.isDrag = !0), !p && this.isDrag && (l = !0);
    }
    return this.prevX = a, this.prevY = s, {
      type: "drag",
      clientX: a,
      clientY: s,
      inputEvent: r,
      isFirstDrag: l,
      isDrag: this.isDrag,
      distX: a - this.startX,
      distY: s - this.startY,
      deltaX: n[0],
      deltaY: n[1],
      datas: this.datas[this.ableName],
      originalDatas: this.datas,
      parentEvent: !0,
      parentGesto: this
    };
  }, e;
}();
function $L(e, t) {
  var n = t.clientX, r = t.clientY, a = t.datas, s = e.state, l = s.moveableClientRect, p = s.rootMatrix, h = s.is3d, y = s.pos1, b = l.left, E = l.top, x = h ? 4 : 3, C = Bt(iy(p, [n - b, r - E], x), y), T = C[0], O = C[1], D = nf({
    datas: a,
    distX: T,
    distY: O
  }), A = D[0], B = D[1];
  return [A, B];
}
function rg(e, t) {
  var n = t.datas, r = e.state, a = r.allMatrix, s = r.beforeMatrix, l = r.is3d, p = r.left, h = r.top, y = r.origin, b = r.offsetMatrix, E = r.targetMatrix, x = r.transformOrigin, C = l ? 4 : 3;
  n.is3d = l, n.matrix = a, n.targetMatrix = E, n.beforeMatrix = s, n.offsetMatrix = b, n.transformOrigin = x, n.inverseMatrix = nc(a, C), n.inverseBeforeMatrix = nc(s, C), n.absoluteOrigin = Qh(On([p, h], y), C), n.startDragBeforeDist = $a(n.inverseBeforeMatrix, n.absoluteOrigin, C), n.startDragDist = $a(n.inverseMatrix, n.absoluteOrigin, C);
}
function RW(e) {
  return ry(e.datas.beforeTransform, [50, 50], 100, 100).direction;
}
function Ux(e, t) {
  var n = e.datas, r = e.originalDatas.beforeRenderable, a = n.transformIndex, s = r.nextTransforms, l = s.length, p = r.nextTransformAppendedIndexes, h = 0;
  a === -1 ? (t === "translate" ? h = 0 : t === "rotate" && (h = yd(s, function(x) {
    return x.match(/scale\(/g);
  })), h === -1 && (h = s.length), n.transformIndex = h) : bd(p, function(x) {
    return x.index === a && x.functionName === t;
  }) ? h = a : h = a + p.filter(function(x) {
    return x.index < a;
  }).length;
  var y = QW(s, h), b = y.targetFunction, E = t === "rotate" ? "rotateZ" : t;
  n.beforeFunctionTexts = y.beforeFunctionTexts, n.afterFunctionTexts = y.afterFunctionTexts, n.beforeTransform = y.beforeFunctionMatrix, n.beforeTransform2 = y.beforeFunctionMatrix2, n.targetTansform = y.targetFunctionMatrix, n.afterTransform = y.afterFunctionMatrix, n.afterTransform2 = y.afterFunctionMatrix2, n.targetAllTransform = y.allFunctionMatrix, b.functionName === E ? (n.afterFunctionTexts.splice(0, 1), n.isAppendTransform = !1) : l > h && (n.isAppendTransform = !0, r.nextTransformAppendedIndexes = jt(jt([], p, !0), [{
    functionName: t,
    index: h,
    isAppend: !0
  }], !1));
}
function Vx(e, t, n) {
  return "".concat(e.beforeFunctionTexts.join(" "), " ").concat(e.isAppendTransform ? n : t, " ").concat(e.afterFunctionTexts.join(" "));
}
function TW(e) {
  var t = e.datas, n = e.distX, r = e.distY, a = VL({
    datas: t,
    distX: n,
    distY: r
  }), s = a[0], l = a[1], p = UL(t, A5([s, l], 4));
  return $a(p, Qh([0, 0, 0], 4), 4);
}
function UL(e, t, n) {
  var r = e.beforeTransform, a = e.afterTransform, s = e.beforeTransform2, l = e.afterTransform2, p = e.targetAllTransform, h = n ? yr(p, t, 4) : yr(t, p, 4), y = yr(nc(n ? s : r, 4), h, 4), b = yr(y, nc(n ? l : a, 4), 4);
  return b;
}
function VL(e) {
  var t = e.datas, n = e.distX, r = e.distY, a = t.inverseBeforeMatrix, s = t.is3d, l = t.startDragBeforeDist, p = t.absoluteOrigin, h = s ? 4 : 3;
  return Bt($a(a, On(p, [n, r]), h), l);
}
function nf(e, t) {
  var n = e.datas, r = e.distX, a = e.distY, s = n.inverseBeforeMatrix, l = n.inverseMatrix, p = n.is3d, h = n.startDragBeforeDist, y = n.startDragDist, b = n.absoluteOrigin, E = p ? 4 : 3;
  return Bt($a(t ? s : l, On(b, [r, a]), E), t ? h : y);
}
function OW(e, t) {
  var n = e.datas, r = e.distX, a = e.distY, s = n.beforeMatrix, l = n.matrix, p = n.is3d, h = n.startDragBeforeDist, y = n.startDragDist, b = n.absoluteOrigin, E = p ? 4 : 3;
  return Bt($a(t ? s : l, On(t ? h : y, [r, a]), E), b);
}
function DW(e, t, n, r, a, s) {
  return r === void 0 && (r = t), a === void 0 && (a = n), s === void 0 && (s = [0, 0]), e ? e.map(function(l, p) {
    var h = Kh(l), y = h.value, b = h.unit, E = p ? a : r, x = p ? n : t;
    if (l === "%" || isNaN(y)) {
      var C = E ? s[p] / E : 0;
      return x * C;
    } else if (b !== "%")
      return y;
    return x * y / 100;
  }) : s;
}
function jL(e) {
  var t = [];
  return e[1] >= 0 && (e[0] >= 0 && t.push(3), e[0] <= 0 && t.push(2)), e[1] <= 0 && (e[0] >= 0 && t.push(1), e[0] <= 0 && t.push(0)), t;
}
function MW(e, t) {
  return jL(t).map(function(n) {
    return e[n];
  });
}
function gi(e, t) {
  var n = (t[0] + 1) / 2, r = (t[1] + 1) / 2, a = [kh(e[0][0], e[1][0], n, 1 - n), kh(e[0][1], e[1][1], n, 1 - n)], s = [kh(e[2][0], e[3][0], n, 1 - n), kh(e[2][1], e[3][1], n, 1 - n)];
  return [kh(a[0], s[0], r, 1 - r), kh(a[1], s[1], r, 1 - r)];
}
function AW(e, t, n, r, a, s) {
  var l = Jp(t, n, r, a), p = gi(l, s), h = e[0] - p[0], y = e[1] - p[1];
  return [h, y];
}
function Wb(e, t, n, r) {
  return yr(e, dx(t, r, n), r);
}
function PW(e, t, n) {
  var r = e.transformOrigin, a = e.offsetMatrix, s = e.is3d, l = t.beforeTransform, p = t.afterTransform, h = s ? 4 : 3, y = $x([n]);
  return Wb(a, tf(yr(yr(l, y, 4), p, 4), 4, h), r, h);
}
function NW(e, t) {
  var n = e.transformOrigin, r = e.offsetMatrix, a = e.is3d, s = e.targetMatrix, l = a ? 4 : 3;
  return Wb(r, yr(s, aD(t, l), l), n, l);
}
function jx(e) {
  var t = Dy(e);
  return {
    setTransform: function(n, r) {
      r === void 0 && (r = -1), t.startTransforms = Ki(n) ? n : Qp(n), YT(e, r);
    },
    setTransformIndex: function(n) {
      YT(e, n);
    }
  };
}
function Wx(e, t) {
  var n = Dy(e), r = n.startTransforms;
  YT(e, yd(r, function(a) {
    return a.indexOf("".concat(t, "(")) === 0;
  }));
}
function YT(e, t) {
  var n = Dy(e), r = e.datas;
  if (r.transformIndex = t, t !== -1) {
    var a = n.startTransforms[t];
    if (!!a) {
      var s = Fh([a]);
      r.startValue = s[0].functionValue;
    }
  }
}
function pD(e, t) {
  var n = Dy(e);
  n.nextTransforms = Qp(t);
}
function Dy(e) {
  return e.originalDatas.beforeRenderable;
}
function WL(e) {
  var t = e.originalDatas.beforeRenderable;
  return t.nextTransforms;
}
function hE(e) {
  return WL(e).join(" ");
}
function gE(e) {
  return Dy(e).nextStyle;
}
function GL(e, t, n, r, a) {
  pD(a, t);
  var s = wo.drag(e, jb(a, e.state, n, r, !1)), l = s ? s.transform : t;
  return we(we({
    transform: t,
    drag: s
  }, Xs({
    transform: l
  }, a)), {
    afterTransform: l
  });
}
function HL(e, t, n, r, a) {
  var s = e.state, l = s.left, p = s.top, h = e.props.groupable, y = PW(e.state, a, t), b = h ? l : 0, E = h ? p : 0, x = qL(e, n, y), C = Bt(r, x);
  return Bt(C, [b, E]);
}
function kW(e, t, n, r, a) {
  var s = HL(e, "scale(".concat(t.join(", "), ")"), n, r, a);
  return s;
}
function YL(e, t, n) {
  return [-1 + e[0] / (t / 2), -1 + e[1] / (n / 2)];
}
function qL(e, t, n) {
  n === void 0 && (n = e.state.allMatrix);
  var r = e.state, a = r.width, s = r.height, l = r.is3d, p = l ? 4 : 3, h = [a / 2 * (1 + t[0]), s / 2 * (1 + t[1])];
  return Yi(n, h, p);
}
function IW(e, t, n) {
  var r = n.fixedDirection, a = n.fixedPosition;
  return HL(e, "rotate(".concat(t, "deg)"), r, a, n);
}
function LW(e, t, n, r, a, s) {
  var l = e.props.groupable, p = e.state, h = p.transformOrigin, y = p.offsetMatrix, b = p.is3d, E = p.width, x = p.height, C = p.left, T = p.top, O = s.fixedDirection, D = s.nextTargetMatrix || p.targetMatrix, A = b ? 4 : 3, B = DW(a, t, n, E, x, h), I = l ? C : 0, L = l ? T : 0, k = Wb(y, D, B, A), $ = AW(r, k, t, n, A, O);
  return Bt($, [I, L]);
}
function XL(e, t) {
  return gi(is(e.state), t);
}
function BW(e, t) {
  var n = e.targetGesto, r = e.controlGesto, a;
  return n != null && n.isFlag() && (a = n.getEventData()[t]), !a && (r == null ? void 0 : r.isFlag()) && (a = r.getEventData()[t]), a || {};
}
function zW(e, t) {
  return [e[0] * t[0], e[1] * t[1]];
}
function $t() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return c5.apply(void 0, jt([cD], e, !1));
}
function KL(e) {
  e();
}
function FW(e) {
  return !e || e === "none" ? [1, 0, 0, 1, 0, 0] : rs(e) ? e : $x(e);
}
function dx(e, t, n) {
  return kT(t, hb(n, t), e, hb(n.map(function(r) {
    return -r;
  }), t));
}
function $W(e, t, n) {
  if (t === "%") {
    var r = vD(e.ownerSVGElement);
    return r[n ? "width" : "height"] / 100;
  }
  return 1;
}
function UW(e) {
  var t = px(_d(e, ":before"));
  return t.map(function(n, r) {
    var a = Kh(n), s = a.value, l = a.unit;
    return s * $W(e, l, r === 0);
  });
}
function px(e) {
  var t = e.transformOrigin;
  return t ? t.split(" ") : ["0", "0"];
}
function QL(e, t) {
  t === void 0 && (t = _d(e));
  var n = t.transform;
  if (n && n !== "none")
    return t.transform;
  if ("transform" in e) {
    var r = e.transform, a = r.baseVal;
    if (!a)
      return "";
    var s = a.length;
    if (!s)
      return "";
    for (var l = [], p = function(y) {
      var b = a[y].matrix;
      l.push("matrix(".concat(["a", "b", "c", "d", "e", "f"].map(function(E) {
        return b[E];
      }).join(", "), ")"));
    }, h = 0; h < s; ++h)
      p(h);
    return l.join(" ");
  }
  return "";
}
function gb(e, t, n, r, a) {
  var s, l, p, h = document.documentElement || document.body, y = !1, b, E;
  if (!e || n)
    b = e;
  else {
    var x = (s = e == null ? void 0 : e.assignedSlot) === null || s === void 0 ? void 0 : s.parentElement, C = e.parentElement;
    x ? (y = !0, E = C, b = x) : b = C;
  }
  for (var T = !1, O = e === t || b === t, D = "relative", A = 1, B = parseFloat((l = a) === null || l === void 0 ? void 0 : l.zoom) || 1, I = a == null ? void 0 : a.position; b && b !== h; ) {
    t === b && (O = !0);
    var L = _d(b), k = b.tagName.toLowerCase(), $ = QL(b, L), U = L.willChange, K = parseFloat(L.zoom) || 1;
    if (D = L.position, r && K !== 1) {
      A = K;
      break;
    }
    if (!n && r && B !== 1 && I && I !== "absolute" || k === "svg" || D !== "static" || $ && $ !== "none" || U === "transform")
      break;
    var X = (p = e == null ? void 0 : e.assignedSlot) === null || p === void 0 ? void 0 : p.parentNode, Y = b.parentNode;
    X && (y = !0, E = Y);
    var J = X || Y;
    if (J && J.nodeType === 11) {
      b = J.host, T = !0;
      break;
    }
    b = J, D = "relative";
  }
  return {
    offsetZoom: A,
    hasSlot: y,
    parentSlotElement: E,
    isCustomElement: T,
    isStatic: D === "static",
    isEnd: O || !b || b === h,
    offsetParent: b || h
  };
}
function VW(e, t, n) {
  var r, a = e.tagName.toLowerCase(), s = e.offsetLeft, l = e.offsetTop, p = tD(s), h = !p, y, b;
  return !h && a !== "svg" ? (y = zL ? UW(e) : px(n).map(function(E) {
    return parseFloat(E);
  }), b = y.slice(), h = !0, r = GW(e, y, e === t && t.tagName.toLowerCase() === "g"), s = r[0], l = r[1], y[0] = r[2], y[1] = r[3]) : (y = px(n).map(function(E) {
    return parseFloat(E);
  }), b = y.slice()), {
    tagName: a,
    isSVG: p,
    hasOffset: h,
    offset: [s || 0, l || 0],
    origin: y,
    targetOrigin: b
  };
}
function ZL(e, t, n) {
  n === void 0 && (n = _d(e));
  var r = _d(document.body), a = r.position;
  if (!t && (!a || a === "static"))
    return [0, 0];
  var s = parseInt(r.marginLeft, 10), l = parseInt(r.marginTop, 10);
  return n.position === "absolute" && ((n.top !== "auto" || n.bottom !== "auto") && (l = 0), (n.left !== "auto" || n.right !== "auto") && (s = 0)), [s, l];
}
function qT(e) {
  e.forEach(function(t) {
    var n = t.matrix;
    n && (t.matrix = tf(n, 3, 4));
  });
}
function jW(e) {
  for (var t = e.parentElement, n = !1; t; ) {
    var r = _d(t).transform;
    if (r && r !== "none") {
      n = !0;
      break;
    }
    if (t === document.body)
      break;
    t = t.parentElement;
  }
  return {
    fixedContainer: t || document.body,
    hasTransform: n
  };
}
function Gx(e, t) {
  return t === void 0 && (t = e.length > 9), "".concat(t ? "matrix3d" : "matrix", "(").concat(TL(e, !t).join(","), ")");
}
function vD(e) {
  var t = e.clientWidth, n = e.clientHeight;
  if (!e)
    return {
      x: 0,
      y: 0,
      width: 0,
      height: 0,
      clientWidth: t,
      clientHeight: n
    };
  var r = e.viewBox, a = r && r.baseVal || {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  };
  return {
    x: a.x,
    y: a.y,
    width: a.width || t,
    height: a.height || n,
    clientWidth: t,
    clientHeight: n
  };
}
function WW(e, t) {
  var n = vD(e), r = n.width, a = n.height, s = n.clientWidth, l = n.clientHeight, p = s / r, h = l / a, y = e.preserveAspectRatio.baseVal, b = y.align, E = y.meetOrSlice, x = [0, 0], C = [p, h], T = [0, 0];
  if (b !== 1) {
    var O = (b - 2) % 3, D = Math.floor((b - 2) / 3);
    x[0] = r * O / 2, x[1] = a * D / 2;
    var A = E === 2 ? Math.max(h, p) : Math.min(p, h);
    C[0] = A, C[1] = A, T[0] = (s - r) / 2 * O, T[1] = (l - a) / 2 * D;
  }
  var B = aD(C, t);
  return B[t * (t - 1)] = T[0], B[t * (t - 1) + 1] = T[1], dx(B, t, x);
}
function GW(e, t, n) {
  if (!e.getBBox || !n && e.tagName.toLowerCase() === "g")
    return [0, 0, 0, 0];
  var r = e.getBBox(), a = vD(e.ownerSVGElement), s = r.x - a.x, l = r.y - a.y;
  return [s, l, t[0] - s, t[1] - l];
}
function Yi(e, t, n) {
  return $a(e, Qh(t, n), n);
}
function Jp(e, t, n, r) {
  return [[0, 0], [t, 0], [0, n], [t, n]].map(function(a) {
    return Yi(e, a, r);
  });
}
function el(e) {
  var t = e.map(function(y) {
    return y[0];
  }), n = e.map(function(y) {
    return y[1];
  }), r = Math.min.apply(Math, t), a = Math.min.apply(Math, n), s = Math.max.apply(Math, t), l = Math.max.apply(Math, n), p = s - r, h = l - a;
  return {
    left: r,
    top: a,
    right: s,
    bottom: l,
    width: p,
    height: h
  };
}
function XN(e, t, n, r) {
  var a = Jp(e, t, n, r);
  return el(a);
}
function HW(e, t, n, r, a) {
  var s, l = e.target, p = e.origin, h = t.matrix, y = eB(l), b = y.offsetWidth, E = y.offsetHeight, x = n.getBoundingClientRect(), C = [0, 0];
  n === document.body && (C = ZL(l, !0));
  for (var T = l.getBoundingClientRect(), O = T.left - x.left + n.scrollLeft - (n.clientLeft || 0) + C[0], D = T.top - x.top + n.scrollTop - (n.clientTop || 0) + C[1], A = T.width, B = T.height, I = kT(r, a, h), L = XN(I, b, E, r), k = L.left, $ = L.top, U = L.width, K = L.height, X = Yi(I, p, r), Y = Bt(X, [k, $]), J = [O + Y[0] * A / U, D + Y[1] * B / K], Q = [0, 0], Z = 0; ++Z < 10; ) {
    var se = nc(a, r);
    s = Bt(Yi(se, J, r), Yi(se, X, r)), Q[0] = s[0], Q[1] = s[1];
    var pe = kT(r, a, hb(Q, r), h), be = XN(pe, b, E, r), _e = be.left, Se = be.top, Oe = _e - O, re = Se - D;
    if (Math.abs(Oe) < 2 && Math.abs(re) < 2)
      break;
    J[0] -= Oe, J[1] -= re;
  }
  return Q.map(function(ie) {
    return Math.round(ie);
  });
}
function YW(e, t, n) {
  var r = e.length === 16, a = r ? 4 : 3, s = t.map(function(h) {
    return Yi(e, h, a);
  }), l = n.left, p = n.top;
  return s.map(function(h) {
    return [h[0] + l, h[1] + p];
  });
}
function ry(e, t, n, r) {
  var a = e.length === 16, s = a ? 4 : 3, l = Jp(e, n, r, s), p = l[0], h = p[0], y = p[1], b = l[1], E = b[0], x = b[1], C = l[2], T = C[0], O = C[1], D = l[3], A = D[0], B = D[1], I = Yi(e, t, s), L = I[0], k = I[1], $ = Math.min(h, E, T, A), U = Math.min(y, x, O, B), K = Math.max(h, E, T, A), X = Math.max(y, x, O, B);
  h = h - $ || 0, E = E - $ || 0, T = T - $ || 0, A = A - $ || 0, y = y - U || 0, x = x - U || 0, O = O - U || 0, B = B - U || 0, L = L - $ || 0, k = k - U || 0;
  var Y = NT(Jp(e, 100, 100, s));
  return {
    left: $,
    top: U,
    right: K,
    bottom: X,
    origin: [L, k],
    pos1: [h, y],
    pos2: [E, x],
    pos3: [T, O],
    pos4: [A, B],
    direction: Y
  };
}
function Jl(e) {
  return Math.sqrt(e[0] * e[0] + e[1] * e[1]);
}
function JL(e, t) {
  return Jl([t[0] - e[0], t[1] - e[1]]);
}
function K0(e, t, n, r) {
  n === void 0 && (n = 1), r === void 0 && (r = mi(e, t));
  var a = JL(e, t);
  return {
    transform: "translateY(-50%) translate(".concat(e[0], "px, ").concat(e[1], "px) rotate(").concat(r, "rad) scaleY(").concat(n, ")"),
    width: "".concat(a, "px")
  };
}
function hD(e, t) {
  for (var n = [], r = 2; r < arguments.length; r++)
    n[r - 2] = arguments[r];
  var a = n.length, s = n.reduce(function(p, h) {
    return p + h[0];
  }, 0) / a, l = n.reduce(function(p, h) {
    return p + h[1];
  }, 0) / a;
  return {
    transform: "translateZ(0px) translate(".concat(s, "px, ").concat(l, "px) rotate(").concat(e, "rad) scale(").concat(t, ")")
  };
}
function Zh(e, t) {
  var n = e[t];
  return rs(n) ? we(we({}, e), n) : e;
}
function eB(e, t) {
  t === void 0 && (t = e ? _d(e) : null);
  var n = e && !tD(e.offsetWidth), r = 0, a = 0, s = 0, l = 0, p = 0, h = 0, y = 0, b = 0, E = 0, x = 0, C = 0, T = 0, O = 1 / 0, D = 1 / 0, A = 1 / 0, B = 1 / 0, I = !1;
  if (e)
    if (!n && e.tagName.toLowerCase() !== "svg") {
      var L = e.getBBox();
      I = !0, r = L.width, a = L.height, p = r, h = a, y = r, b = a, s = r, l = a;
    } else {
      var k = e.style, $ = t.boxSizing === "border-box", U = parseFloat(t.borderLeftWidth) || 0, K = parseFloat(t.borderRightWidth) || 0, X = parseFloat(t.borderTopWidth) || 0, Y = parseFloat(t.borderBottomWidth) || 0, J = parseFloat(t.paddingLeft) || 0, Q = parseFloat(t.paddingRight) || 0, Z = parseFloat(t.paddingTop) || 0, se = parseFloat(t.paddingBottom) || 0, pe = J + Q, be = Z + se, _e = U + K, Se = X + Y, Oe = pe + _e, re = be + Se, ie = t.position, ce = 0, le = 0;
      if ("clientLeft" in e) {
        var fe = null;
        if (ie === "absolute") {
          var ve = gb(e, document.body);
          fe = ve.offsetParent;
        } else
          fe = e.parentElement;
        if (fe) {
          var ee = _d(fe);
          ce = parseFloat(ee.width), le = parseFloat(ee.height);
        }
      }
      E = Math.max(pe, wr(t.minWidth, ce) || 0), x = Math.max(be, wr(t.minHeight, le) || 0), O = wr(t.maxWidth, ce), D = wr(t.maxHeight, le), isNaN(O) && (O = 1 / 0), isNaN(D) && (D = 1 / 0);
      var Ae = wr(k.width, 0) || 0, he = wr(k.height, 0) || 0, Fe = parseFloat(t.width) || 0, Ne = parseFloat(t.height) || 0;
      p = parseFloat(t.width), h = parseFloat(t.height), y = Math.abs(Fe - Ae) < 1 ? sx(E, Ae || p, O) : Fe, b = Math.abs(Ne - he) < 1 ? sx(x, he || h, D) : Ne, r = y, a = b, s = y, l = b, $ ? (A = O, B = D, C = E, T = x, y = r - Oe, b = a - re) : (A = O + Oe, B = D + re, C = E + Oe, T = x + re, r = y + Oe, a = b + re), s = y + pe, l = b + be;
    }
  return {
    svg: I,
    offsetWidth: r,
    offsetHeight: a,
    clientWidth: s,
    clientHeight: l,
    contentWidth: y,
    contentHeight: b,
    cssWidth: p,
    cssHeight: h,
    minWidth: E,
    minHeight: x,
    maxWidth: O,
    maxHeight: D,
    minOffsetWidth: C,
    minOffsetHeight: T,
    maxOffsetWidth: A,
    maxOffsetHeight: B
  };
}
function tB(e, t) {
  return mi(t > 0 ? e[0] : e[1], t > 0 ? e[1] : e[0]);
}
function mE() {
  return {
    left: 0,
    top: 0,
    width: 0,
    height: 0,
    right: 0,
    bottom: 0,
    clientLeft: 0,
    clientTop: 0,
    clientWidth: 0,
    clientHeight: 0,
    scrollWidth: 0,
    scrollHeight: 0
  };
}
function nB(e, t) {
  var n = e === document.body || e === document.documentElement, r = {
    clientLeft: e.clientLeft,
    clientTop: e.clientTop,
    clientWidth: e.clientWidth,
    clientHeight: e.clientHeight,
    scrollWidth: e.scrollWidth,
    scrollHeight: e.scrollHeight,
    overflow: !1
  };
  return n && (r.clientHeight = Math.max(t.height, r.clientHeight), r.scrollHeight = Math.max(t.height, r.scrollHeight)), r.overflow = _d(e).overflow !== "visible", we(we({}, t), r);
}
function XR(e, t, n, r) {
  var a = e.left, s = e.right, l = e.top, p = e.bottom, h = t.top, y = t.left, b = {
    left: y + a,
    top: h + l,
    right: y + s,
    bottom: h + p,
    width: s - a,
    height: p - l
  };
  return n && r ? nB(n, b) : b;
}
function Q0(e, t) {
  var n = 0, r = 0, a = 0, s = 0;
  if (e) {
    var l = e.getBoundingClientRect();
    n = l.left, r = l.top, a = l.width, s = l.height;
  }
  var p = {
    left: n,
    top: r,
    width: a,
    height: s,
    right: n + a,
    bottom: r + s
  };
  return e && t ? nB(e, p) : p;
}
function rB(e, t, n, r) {
  var a;
  if (e)
    a = e;
  else if (t)
    a = [0, 0];
  else {
    var s = n.target;
    a = iB(s, r);
  }
  return a;
}
function iB(e, t) {
  if (!!e) {
    var n = e.getAttribute("data-rotation") || "", r = e.getAttribute("data-direction");
    if (t.deg = n, !!r) {
      var a = [0, 0];
      return r.indexOf("w") > -1 && (a[0] = -1), r.indexOf("e") > -1 && (a[0] = 1), r.indexOf("n") > -1 && (a[1] = -1), r.indexOf("s") > -1 && (a[1] = 1), a;
    }
  }
}
function gD(e, t) {
  return [On(t, e[0]), On(t, e[1]), On(t, e[2]), On(t, e[3])];
}
function is(e) {
  var t = e.left, n = e.top, r = e.pos1, a = e.pos2, s = e.pos3, l = e.pos4;
  return gD([r, a, s, l], [t, n]);
}
function qW(e) {
  return Math.round(e % 1 === -0.5 ? e - 1 : e);
}
function Qm(e, t) {
  var n;
  (n = e[t]) === null || n === void 0 || n.unset(), e[t] = null;
}
function Xs(e, t) {
  if (t) {
    var n = Dy(t);
    n.nextStyle = we(we({}, n.nextStyle), e);
  }
  return {
    style: e,
    cssText: Oy(e).map(function(r) {
      return "".concat(x5(r, "-"), ": ").concat(e[r], ";");
    }).join("")
  };
}
function aB(e, t, n) {
  var r = t.afterTransform || t.transform;
  return we(we({}, Xs(we(we(we({}, e.style), t.style), {
    transform: r
  }), n)), {
    afterTransform: r,
    transform: e.transform
  });
}
function En(e, t, n, r) {
  var a = t.datas;
  a.datas || (a.datas = {});
  var s = we(we({}, n), {
    target: e.state.target,
    clientX: t.clientX,
    clientY: t.clientY,
    inputEvent: t.inputEvent,
    currentTarget: e,
    moveable: e,
    datas: a.datas,
    isFirstDrag: !!t.isFirstDrag,
    stopDrag: function() {
      var l;
      (l = t.stop) === null || l === void 0 || l.call(t);
    }
  });
  return a.isStartEvent ? r || (a.lastEvent = s) : a.isStartEvent = !0, s;
}
function nu(e, t, n) {
  var r = t.datas, a = "isDrag" in n ? n.isDrag : t.isDrag;
  return r.datas || (r.datas = {}), we(we({
    isDrag: a
  }, n), {
    moveable: e,
    target: e.state.target,
    clientX: t.clientX,
    clientY: t.clientY,
    inputEvent: t.inputEvent,
    currentTarget: e,
    lastEvent: r.lastEvent,
    isDouble: t.isDouble,
    datas: r.datas,
    isFirstDrag: !!t.isFirstDrag
  });
}
function Hx(e, t, n) {
  e._emitter.on(t, n);
}
function St(e, t, n, r) {
  return e.triggerEvent(t, n, r);
}
function _d(e, t) {
  return window.getComputedStyle(e, t);
}
function yE(e, t, n) {
  var r = {}, a = {};
  return e.filter(function(s) {
    var l = s.name;
    if (r[l] || !t.some(function(p) {
      return s[p];
    }))
      return !1;
    if (!n && s.ableGroup) {
      if (a[s.ableGroup])
        return !1;
      a[s.ableGroup] = !0;
    }
    return r[l] = !0, !0;
  });
}
function XT(e, t) {
  return e === t || e == null && t == null;
}
function XW() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  for (var n = e.length - 1, r = 0; r < n; ++r) {
    var a = e[r];
    if (!tD(a))
      return a;
  }
  return e[n];
}
function oB(e, t) {
  var n = [], r = [];
  return e.forEach(function(a, s) {
    var l = t(a, s, e), p = r.indexOf(l), h = n[p] || [];
    p === -1 && (r.push(l), n.push(h)), h.push(a);
  }), n;
}
function KW(e, t) {
  var n = [], r = {};
  return e.forEach(function(a, s) {
    var l = t(a, s, e), p = r[l];
    p || (p = [], r[l] = p, n.push(p)), p.push(a);
  }), n;
}
function sB(e) {
  return e.reduce(function(t, n) {
    return t.concat(n);
  }, []);
}
function yy() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return e.sort(function(n, r) {
    return Math.abs(r) - Math.abs(n);
  }), e[0];
}
function iy(e, t, n) {
  return $a(nc(e, n), Qh(t, n), n);
}
function uB(e, t) {
  var n, r = e.is3d, a = e.rootMatrix, s = r ? 4 : 3;
  return n = iy(a, [t.distX, t.distY], s), t.distX = n[0], t.distY = n[1], t;
}
function bE(e, t, n, r, a) {
  return Bt(Yi(e, On(n, t), a), r);
}
function Yl(e, t, n) {
  return n ? "".concat(e / t * 100, "%") : "".concat(e, "px");
}
function vx(e) {
  return Math.abs(e) <= Ro ? 0 : e;
}
function mD(e) {
  return function(t) {
    if (!t.isDragging(e))
      return "";
    var n = BW(t, e), r = n.deg;
    return r ? $t("view-control-rotation".concat(r)) : "";
  };
}
function yD(e, t) {
  return t === void 0 && (t = [e]), function(n, r) {
    if (r.isRequest)
      return t.some(function(s) {
        return r.requestAble === s;
      }) ? r.parentDirection : !1;
    var a = r.inputEvent.target;
    return Ui(a, $t("direction")) && (!e || Ui(a, $t(e)));
  };
}
function QW(e, t) {
  var n = e.slice(0, t < 0 ? void 0 : t), r = e.slice(0, t < 0 ? void 0 : t + 1), a = e[t] || "", s = t < 0 ? [] : e.slice(t), l = t < 0 ? [] : e.slice(t + 1), p = Fh(n), h = Fh(r), y = Fh([a]), b = Fh(s), E = Fh(l), x = Vm(p), C = Vm(h), T = Vm(b), O = Vm(E), D = yr(x, T, 4);
  return {
    transforms: e,
    beforeFunctionMatrix: x,
    beforeFunctionMatrix2: C,
    targetFunctionMatrix: Vm(y),
    afterFunctionMatrix: T,
    afterFunctionMatrix2: O,
    allFunctionMatrix: D,
    beforeFunctions: p,
    beforeFunctions2: h,
    targetFunction: y[0],
    afterFunctions: b,
    afterFunctions2: E,
    beforeFunctionTexts: n,
    beforeFunctionTexts2: r,
    targetFunctionText: a,
    afterFunctionTexts: s,
    afterFunctionTexts2: l
  };
}
function ZW(e) {
  return !e || !rs(e) || e instanceof Element ? !1 : Ki(e) || "length" in e;
}
function Jh(e, t) {
  return e ? e instanceof Element ? e : tc(e) ? t ? document.querySelector(e) : e : Fx(e) ? e() : "current" in e ? e.current : e : null;
}
function bD(e, t) {
  if (!e)
    return [];
  var n = ZW(e) ? [].slice.call(e) : [e];
  return n.reduce(function(r, a) {
    return tc(a) && t ? jt(jt([], r, !0), [].slice.call(document.querySelectorAll(a)), !0) : (Ki(a) ? r.push(bD(a, t)) : r.push(Jh(a, t)), r);
  }, []);
}
function JW(e, t, n) {
  var r = mi(e, t) / Math.PI * 180;
  return r = n >= 0 ? r : 180 - r, r = r >= 0 ? r : 360 + r, r;
}
function KN(e, t) {
  var n = e.rootMatrix, r = e.is3d, a = r ? 4 : 3, s = nc(n, a);
  return r || (s = tf(s, 3, 4)), s[12] = 0, s[13] = 0, s[14] = 0, BE(s, t);
}
function lB(e, t, n, r, a) {
  var s = e[0], l = e[1], p = 0, h = 0;
  if (a && s && l) {
    var y = mi([0, 0], t), b = mi([0, 0], r), E = Jl(t), x = Math.cos(y - b) * E;
    if (!r[0])
      h = x, p = h * n;
    else if (!r[1])
      p = x, h = p / n;
    else {
      var C = r[0] * 2 * s, T = r[1] * 2 * l, O = Jl([C + t[0], T + t[1]]) - Jl([C, T]), D = mi([0, 0], [n, 1]);
      p = Math.cos(D) * O, h = Math.sin(D) * O;
    }
  } else
    p = r[0] * t[0], h = r[1] * t[1];
  return [p, h];
}
function cB(e, t, n, r) {
  var a, s = n.ratio, l = n.startOffsetWidth, p = n.startOffsetHeight, h = 0, y = 0, b = r.distX, E = r.distY, x = r.parentDistance, C = r.parentDist, T = r.parentScale, O = n.fixedDirection, D = [0, 1].map(function($) {
    return Math.abs(e[$] - O[$]);
  }), A = [0, 1].map(function($) {
    var U = D[$];
    return U !== 0 && (U = 2 / U), U;
  });
  if (C)
    h = C[0], y = C[1], t && (h ? y || (y = h / s) : h = y * s);
  else if (T)
    h = (T[0] - 1) * l, y = (T[1] - 1) * p;
  else if (x) {
    var B = l * D[0], I = p * D[1], L = Jl([B, I]);
    h = x / L * B * A[0], y = x / L * I * A[1];
  } else {
    var k = nf({
      datas: n,
      distX: b,
      distY: E
    });
    k = A.map(function($, U) {
      return k[U] * $;
    }), a = lB([l, p], k, s, e, t), h = a[0], y = a[1];
  }
  return {
    distWidth: h,
    distHeight: y
  };
}
function KT(e, t) {
  if (t) {
    if (e === "left")
      return {
        x: "0%",
        y: "50%"
      };
    if (e === "top")
      return {
        x: "50%",
        y: "50%"
      };
    if (e === "center")
      return {
        x: "50%",
        y: "50%"
      };
    if (e === "right")
      return {
        x: "100%",
        y: "50%"
      };
    if (e === "bottom")
      return {
        x: "50%",
        y: "100%"
      };
    var n = e.split(" "), r = n[0], a = n[1], s = KT(r || ""), l = KT(a || ""), p = we(we({}, s), l), h = {
      x: "50%",
      y: "50%"
    };
    return p.x && (h.x = p.x), p.y && (h.y = p.y), p.value && (p.x && !p.y && (h.y = p.value), !p.x && p.y && (h.x = p.value)), h;
  }
  return e === "left" ? {
    x: "0%"
  } : e === "right" ? {
    x: "100%"
  } : e === "top" ? {
    y: "0%"
  } : e === "bottom" ? {
    y: "100%"
  } : e ? e === "center" ? {
    value: "50%"
  } : {
    value: e
  } : {};
}
function eG(e, t, n) {
  var r = KT(e, !0), a = r.x, s = r.y;
  return [wr(a, t) || 0, wr(s, n) || 0];
}
function tG(e, t, n) {
  var r = e.map(function(s) {
    return Bt(s, t);
  }), a = r.map(function(s) {
    return Fb(s, n);
  });
  return {
    prev: r,
    next: a,
    result: a.map(function(s) {
      return On(s, t);
    })
  };
}
var nG = Vb("pinchable", {
  events: {
    onPinchStart: "pinchStart",
    onPinch: "pinch",
    onPinchEnd: "pinchEnd",
    onPinchGroupStart: "pinchGroupStart",
    onPinchGroup: "pinchGroup",
    onPinchGroupEnd: "pinchGroupEnd"
  },
  dragStart: function() {
    return !0;
  },
  pinchStart: function(e, t) {
    var n = t.datas, r = t.targets, a = t.angle, s = t.originalDatas, l = e.props, p = l.pinchable, h = l.ables;
    if (!p)
      return !1;
    var y = "onPinch".concat(r ? "Group" : "", "Start"), b = "drag".concat(r ? "Group" : "", "ControlStart"), E = (p === !0 ? e.controlAbles : h.filter(function(O) {
      return p.indexOf(O.name) > -1;
    })).filter(function(O) {
      return O.canPinch && O[b];
    }), x = En(e, t, {});
    r && (x.targets = r);
    var C = St(e, y, x);
    n.isPinch = C !== !1, n.ables = E;
    var T = n.isPinch;
    return T ? (E.forEach(function(O) {
      if (s[O.name] = s[O.name] || {}, !!O[b]) {
        var D = we(we({}, t), {
          datas: s[O.name],
          parentRotate: a,
          isPinch: !0
        });
        O[b](e, D);
      }
    }), e.state.snapRenderInfo = {
      request: t.isRequest,
      direction: [0, 0]
    }, T) : !1;
  },
  pinch: function(e, t) {
    var n = t.datas, r = t.scale, a = t.distance, s = t.originalDatas, l = t.inputEvent, p = t.targets, h = t.angle;
    if (!!n.isPinch) {
      var y = a * (1 - 1 / r), b = En(e, t, {});
      p && (b.targets = p);
      var E = "onPinch".concat(p ? "Group" : "");
      St(e, E, b);
      var x = n.ables, C = "drag".concat(p ? "Group" : "", "Control");
      return x.forEach(function(T) {
        !T[C] || T[C](e, we(we({}, t), {
          datas: s[T.name],
          inputEvent: l,
          parentDistance: y,
          parentRotate: h,
          isPinch: !0
        }));
      }), b;
    }
  },
  pinchEnd: function(e, t) {
    var n = t.datas, r = t.isPinch, a = t.inputEvent, s = t.targets, l = t.originalDatas;
    if (!!n.isPinch) {
      var p = "onPinch".concat(s ? "Group" : "", "End"), h = nu(e, t, {
        isDrag: r
      });
      s && (h.targets = s), St(e, p, h);
      var y = n.ables, b = "drag".concat(s ? "Group" : "", "ControlEnd");
      return y.forEach(function(E) {
        !E[b] || E[b](e, we(we({}, t), {
          isDrag: r,
          datas: l[E.name],
          inputEvent: a,
          isPinch: !0
        }));
      }), r;
    }
  },
  pinchGroupStart: function(e, t) {
    return this.pinchStart(e, we(we({}, t), {
      targets: e.props.targets
    }));
  },
  pinchGroup: function(e, t) {
    return this.pinch(e, we(we({}, t), {
      targets: e.props.targets
    }));
  },
  pinchGroupEnd: function(e, t) {
    return this.pinchEnd(e, we(we({}, t), {
      targets: e.props.targets
    }));
  }
});
function ec(e, t, n) {
  var r = n.originalDatas;
  r.groupable = r.groupable || {};
  var a = r.groupable;
  a.childDatas = a.childDatas || [];
  var s = a.childDatas;
  return e.moveables.map(function(l, p) {
    return s[p] = s[p] || {}, s[p][t] = s[p][t] || {}, we(we({}, n), {
      datas: s[p][t],
      originalDatas: s[p]
    });
  });
}
function KR(e, t, n, r, a, s, l) {
  var p = !!n.match(/Start$/g), h = !!n.match(/End$/g), y = a.isPinch, b = a.datas, E = ec(e, t.name, a), x = e.moveables, C = E.map(function(T, O) {
    var D = x[O], A = D.state, B = A.gestos, I = T;
    if (p)
      I = new my(l).dragStart(r, T);
    else {
      if (B[l] || (B[l] = b.childGestos[O]), !B[l])
        return;
      I = jb(T, A, r, y, s, l);
    }
    var L = t[n](D, we(we({}, I), {
      parentFlag: !0
    }));
    return h && (B[l] = null), L;
  });
  return p && (b.childGestos = x.map(function(T) {
    return T.state.gestos[l];
  })), C;
}
function gd(e, t, n, r, a, s) {
  a === void 0 && (a = function(b, E) {
    return E;
  });
  var l = !!n.match(/End$/g), p = ec(e, t.name, r), h = e.moveables, y = p.map(function(b, E) {
    var x = h[E], C = b;
    C = a(x, b);
    var T = t[n](x, we(we({}, C), {
      parentFlag: !0
    }));
    return T && s && s(x, b, T, E), l && (x.state.gestos = {}), T;
  });
  return y;
}
var rG = ["left", "right", "center"], iG = ["top", "bottom", "middle"], ev = {
  start: "left",
  end: "right",
  center: "center"
}, tv = {
  start: "top",
  end: "bottom",
  center: "middle"
};
function My(e, t) {
  var n = e.props, r = n.snappable, a = n.bounds, s = n.innerBounds, l = n.verticalGuidelines, p = n.horizontalGuidelines, h = n.snapGridWidth, y = n.snapGridHeight, b = e.state, E = b.guidelines, x = b.enableSnap;
  return !r || !x || t && r !== !0 && r.indexOf(t) < 0 ? !1 : !!(h || y || a || s || E && E.length || l && l.length || p && p.length);
}
function _D(e) {
  return e === !1 ? {} : e === !0 || !e ? {
    left: !0,
    right: !0,
    top: !0,
    bottom: !0
  } : e;
}
function aG(e, t) {
  var n = _D(e), r = {};
  for (var a in n)
    a in t && n[a] && (r[a] = t[a]);
  return r;
}
function ED(e, t) {
  var n = aG(e, t), r = iG.filter(function(s) {
    return s in n;
  }), a = rG.filter(function(s) {
    return s in n;
  });
  return {
    horizontal: r.map(function(s) {
      return n[s];
    }),
    vertical: a.map(function(s) {
      return n[s];
    })
  };
}
function oG(e, t, n) {
  var r = Yi(e, [t.clientLeft, t.clientTop], n);
  return [t.left + r[0], t.top + r[1]];
}
function sG(e) {
  var t = e[0], n = e[1], r = n[0] - t[0], a = n[1] - t[1];
  Math.abs(r) < $i && (r = 0), Math.abs(a) < $i && (a = 0);
  var s = 0, l = 0, p = 0;
  return r ? a ? (s = -a / r, l = 1, p = s * t[0] - t[1]) : (l = 1, p = -t[1]) : (s = -1, p = t[0]), [s, l, p].map(function(h) {
    return hn(h, $i);
  });
}
function Yx(e, t, n, r) {
  var a = e.props, s = XW(r, a.snapThreshold, 5);
  return fB(e.state.guidelines, t, n, s);
}
function fB(e, t, n, r) {
  return {
    vertical: ZN(e, "vertical", t, r),
    horizontal: ZN(e, "horizontal", n, r)
  };
}
function uG(e, t, n) {
  var r = n[0], a = n[1], s = t[0], l = t[1], p = Bt(n, t), h = p[0], y = p[1], b = y > 0, E = h > 0;
  h = vx(h), y = vx(y);
  var x = {
    isSnap: !1,
    offset: 0,
    pos: 0
  }, C = {
    isSnap: !1,
    offset: 0,
    pos: 0
  };
  if (h === 0 && y === 0)
    return {
      vertical: x,
      horizontal: C
    };
  var T = Yx(e, h ? [r] : [], y ? [a] : []), O = T.vertical, D = T.horizontal;
  O.posInfos.filter(function(se) {
    var pe = se.pos;
    return E ? pe >= s : pe <= s;
  }), D.posInfos.filter(function(se) {
    var pe = se.pos;
    return b ? pe >= l : pe <= l;
  }), O.isSnap = O.posInfos.length > 0, D.isSnap = D.posInfos.length > 0;
  var A = QT(O), B = A.isSnap, I = A.guideline, L = QT(D), k = L.isSnap, $ = L.guideline, U = k ? $.pos[1] : 0, K = B ? I.pos[0] : 0;
  if (h === 0)
    k && (C.isSnap = !0, C.pos = $.pos[1], C.offset = a - C.pos);
  else if (y === 0)
    B && (x.isSnap = !0, x.pos = K, x.offset = r - K);
  else {
    var X = y / h, Y = n[1] - X * r, J = 0, Q = 0, Z = !1;
    B ? (Q = K, J = X * Q + Y, Z = !0) : k && (J = U, Q = (J - Y) / X, Z = !0), Z && (x.isSnap = !0, x.pos = Q, x.offset = r - Q, C.isSnap = !0, C.pos = J, C.offset = a - J);
  }
  return {
    vertical: x,
    horizontal: C
  };
}
function QN(e, t, n) {
  var r = ED(e.props.snapDirections, t);
  return Yx(e, r.vertical, r.horizontal, n);
}
function QT(e) {
  var t = e.isSnap;
  if (!t)
    return {
      isSnap: !1,
      offset: 0,
      dist: -1,
      pos: 0,
      guideline: null
    };
  var n = e.posInfos[0], r = n.guidelineInfos[0], a = r.offset, s = r.dist, l = r.guideline;
  return {
    isSnap: t,
    offset: a,
    dist: s,
    pos: n.pos,
    guideline: l
  };
}
function ZN(e, t, n, r) {
  if (!e || !e.length)
    return {
      isSnap: !1,
      index: -1,
      posInfos: []
    };
  var a = t === "vertical", s = a ? 0 : 1, l = n.map(function(h, y) {
    var b = e.map(function(E) {
      var x = E.pos, C = h - x[s];
      return {
        offset: C,
        dist: Math.abs(C),
        guideline: E
      };
    }).filter(function(E) {
      var x = E.guideline, C = E.dist, T = x.type;
      return !(T !== t || C > r);
    }).sort(function(E, x) {
      return E.dist - x.dist;
    });
    return {
      pos: h,
      index: y,
      guidelineInfos: b
    };
  }).filter(function(h) {
    return h.guidelineInfos.length > 0;
  }).sort(function(h, y) {
    return h.guidelineInfos[0].dist - y.guidelineInfos[0].dist;
  }), p = l.length > 0;
  return {
    isSnap: p,
    index: p ? l[0].index : -1,
    posInfos: l
  };
}
function lG(e, t, n, r) {
  r === void 0 && (r = 1);
  var a = [];
  if (n[0] && n[1])
    a = [n, [-n[0], n[1]], [n[0], -n[1]]].map(function(p) {
      return gi(t, p);
    });
  else if (!n[0] && !n[1])
    for (var s = [t[0], t[1], t[3], t[2], t[0]], l = 0; l < 4; ++l)
      a.push(s[l]), a.push([(s[l][0] + s[l + 1][0]) / 2, (s[l][1] + s[l + 1][1]) / 2]);
  else
    e.props.keepRatio ? a = [[-1, -1], [-1, 1], [1, -1], [1, 1], n].map(function(p) {
      return gi(t, p);
    }) : (a = MW(t, n), a.length > 1 && a.push([(a[0][0] + a[1][0]) / 2, (a[0][1] + a[1][1]) / 2]));
  return Yx(e, a.map(function(p) {
    return p[0];
  }), a.map(function(p) {
    return p[1];
  }), r);
}
function dB(e, t) {
  var n = Math.abs(e.offset), r = Math.abs(t.offset);
  return e.isBound && t.isBound ? r - n : e.isBound ? -1 : t.isBound ? 1 : e.isSnap && t.isSnap ? r - n : e.isSnap ? -1 : t.isSnap || n < Ro ? 1 : r < Ro ? -1 : n - r;
}
function hx(e, t) {
  return e.slice().sort(function(n, r) {
    var a = n.sign[t], s = r.sign[t], l = n.offset[t], p = r.offset[t];
    if (a) {
      if (!s)
        return -1;
    } else
      return 1;
    return dB({
      isBound: n.isBound,
      isSnap: n.isSnap,
      offset: l
    }, {
      isBound: r.isBound,
      isSnap: r.isSnap,
      offset: p
    });
  })[0];
}
function cG(e, t, n) {
  var r = [];
  if (n)
    Math.abs(t[0]) !== 1 || Math.abs(t[1]) !== 1 ? r.push([t, [-1, -1]], [t, [-1, 1]], [t, [1, -1]], [t, [1, 1]]) : r.push([t, [e[0], -e[1]]], [t, [-e[0], e[1]]]), r.push([t, e]);
  else if (e[0] && e[1] || !e[0] && !e[1]) {
    var a = e[0] ? e : [1, 1];
    [1, -1].forEach(function(l) {
      [1, -1].forEach(function(p) {
        var h = [l * a[0], p * a[1]];
        t[0] === h[0] && t[1] === h[1] || r.push([t, h]);
      });
    });
  } else if (e[0]) {
    var s = Math.abs(t[0]) === 1 ? [1] : [1, -1];
    s.forEach(function(l) {
      r.push([[t[0], -1], [l * e[0], -1]], [[t[0], 0], [l * e[0], 0]], [[t[0], 1], [l * e[0], 1]]);
    });
  } else if (e[1]) {
    var s = Math.abs(t[1]) === 1 ? [1] : [1, -1];
    s.forEach(function(p) {
      r.push([[-1, t[1]], [-1, p * e[1]]], [[0, t[1]], [0, p * e[1]]], [[1, t[1]], [1, p * e[1]]]);
    });
  }
  return r;
}
function pB(e, t) {
  var n = PT([t[0][0], t[1][0]]), r = PT([t[0][1], t[1][1]]);
  return {
    vertical: n <= e[0],
    horizontal: r <= e[1]
  };
}
function xD(e, t) {
  var n = t[0], r = t[1], a = r[0] - n[0], s = r[1] - n[1];
  Math.abs(a) < Ro && (a = 0), Math.abs(s) < Ro && (s = 0);
  var l, p;
  if (!a)
    l = n[0], p = e[0];
  else if (!s)
    l = n[1], p = e[1];
  else {
    var h = s / a;
    l = h * (e[0] - n[0]) + n[1], p = e[1];
  }
  return l - p;
}
function vB(e, t, n, r) {
  return r === void 0 && (r = Ro), e.every(function(a) {
    var s = xD(a, t), l = s <= 0;
    return l === n || Math.abs(s) <= r;
  });
}
function JN(e, t, n, r, a) {
  return a === void 0 && (a = 0), r && t - a <= e || !r && e <= n + a ? {
    isBound: !0,
    offset: r ? t - e : n - e
  } : {
    isBound: !1,
    offset: 0
  };
}
function fG(e, t) {
  var n = t.line, r = t.centerSign, a = t.verticalSign, s = t.horizontalSign, l = t.lineConstants, p = e.props.innerBounds;
  if (!p)
    return {
      isAllBound: !1,
      isBound: !1,
      isVerticalBound: !1,
      isHorizontalBound: !1,
      offset: [0, 0]
    };
  var h = p.left, y = p.top, b = p.width, E = p.height, x = [[h, y], [h, y + E]], C = [[h, y], [h + b, y]], T = [[h + b, y], [h + b, y + E]], O = [[h, y + E], [h + b, y + E]];
  if (vB([[h, y], [h + b, y], [h, y + E], [h + b, y + E]], n, r))
    return {
      isAllBound: !1,
      isBound: !1,
      isVerticalBound: !1,
      isHorizontalBound: !1,
      offset: [0, 0]
    };
  var D = Up(n, l, C, a), A = Up(n, l, O, a), B = Up(n, l, x, s), I = Up(n, l, T, s), L = D.isBound && A.isBound, k = D.isBound || A.isBound, $ = B.isBound && I.isBound, U = B.isBound || I.isBound, K = yy(D.offset, A.offset), X = yy(B.offset, I.offset), Y = [0, 0], J = !1, Q = !1;
  return Math.abs(X) < Math.abs(K) ? (Y = [K, 0], J = k, Q = L) : (Y = [0, X], J = U, Q = $), {
    isAllBound: Q,
    isVerticalBound: k,
    isHorizontalBound: U,
    isBound: J,
    offset: Y
  };
}
function Up(e, t, n, r, a, s) {
  var l = t[0], p = t[1], h = e[0], y = n[0], b = n[1], E = vx(b[1] - y[1]), x = vx(b[0] - y[0]), C = p, T = l, O = -l / p;
  if (x) {
    if (!E) {
      if (s && !C)
        return {
          isBound: !1,
          offset: 0
        };
      if (T) {
        var I = (y[1] - h[1]) / O + h[0];
        return JN(I, y[0], b[0], r, a);
      } else {
        var A = y[1] - h[1], B = Math.abs(A) <= (a || 0);
        return {
          isBound: B,
          offset: B ? A : 0
        };
      }
    }
  } else {
    if (s && !T)
      return {
        isBound: !1,
        offset: 0
      };
    if (C) {
      var D = O * (y[0] - h[0]) + h[1];
      return JN(D, y[1], b[1], r, a);
    } else {
      var A = y[0] - h[0], B = Math.abs(A) <= (a || 0);
      return {
        isBound: B,
        offset: B ? A : 0
      };
    }
  }
  return {
    isBound: !1,
    offset: 0
  };
}
function hB(e, t, n) {
  return t.map(function(r) {
    var a = fG(e, r), s = a.isBound, l = a.offset, p = a.isVerticalBound, h = a.isHorizontalBound, y = r.multiple, b = nf({
      datas: n,
      distX: l[0],
      distY: l[1]
    }).map(function(E, x) {
      return E * (y[x] ? 2 / y[x] : 0);
    });
    return {
      sign: y,
      isBound: s,
      isVerticalBound: p,
      isHorizontalBound: h,
      isSnap: !1,
      offset: b
    };
  });
}
function dG(e, t, n) {
  var r, a = SD(e, t, [0, 0], !1).map(function(x) {
    return we(we({}, x), {
      multiple: x.multiple.map(function(C) {
        return Math.abs(C) * 2;
      })
    });
  }), s = hB(e, a, n), l = hx(s, 0), p = hx(s, 1), h = 0, y = 0, b = l.isVerticalBound || p.isVerticalBound, E = l.isHorizontalBound || p.isHorizontalBound;
  return (b || E) && (r = OW({
    datas: n,
    distX: -l.offset[0],
    distY: -p.offset[1]
  }), h = r[0], y = r[1]), {
    vertical: {
      isBound: b,
      offset: h
    },
    horizontal: {
      isBound: E,
      offset: y
    }
  };
}
function pG(e, t) {
  var n = [], r = e[0], a = e[1];
  return r && a ? n.push([[0, a * 2], e, [-r, a]], [[r * 2, 0], e, [r, -a]]) : r ? (n.push([[r * 2, 0], [r, 1], [r, -1]]), t && n.push([[0, -1], [r, -1], [-r, -1]], [[0, 1], [r, 1], [-r, 1]])) : a ? (n.push([[0, a * 2], [1, a], [-1, a]]), t && n.push([[-1, 0], [-1, a], [-1, -a]], [[1, 0], [1, a], [1, -a]])) : n.push([[-1, 0], [-1, -1], [-1, 1]], [[1, 0], [1, -1], [1, 1]], [[0, -1], [-1, -1], [1, -1]], [[0, 1], [-1, 1], [1, 1]]), n;
}
function SD(e, t, n, r) {
  var a = e.state, s = a.allMatrix, l = a.is3d, p = Jp(s, 100, 100, l ? 4 : 3), h = gi(p, [0, 0]);
  return pG(n, r).map(function(y) {
    var b = y[0], E = y[1], x = y[2], C = [gi(p, E), gi(p, x)], T = sG(C), O = pB(h, C), D = O.vertical, A = O.horizontal, B = xD(h, C) <= 0;
    return {
      multiple: b,
      centerSign: B,
      verticalSign: D,
      horizontalSign: A,
      lineConstants: T,
      line: [gi(t, E), gi(t, x)]
    };
  });
}
function ek(e, t, n, r) {
  var a = r ? e.map(function(s) {
    return Fb(s, r);
  }) : e;
  return [[a[0], a[1]], [a[1], a[3]], [a[3], a[2]], [a[2], a[0]]].some(function(s) {
    var l = xD(n, s) <= 0;
    return !vB(t, s, l);
  });
}
function vG(e) {
  var t = e[0], n = e[1], r = n[0] - t[0], a = n[1] - t[1];
  if (!r)
    return Math.abs(t[0]);
  if (!a)
    return Math.abs(t[1]);
  var s = a / r;
  return Math.abs((-s * t[0] + t[1]) / Math.sqrt(Math.pow(s, 2) + 1));
}
function hG(e) {
  var t = e[0], n = e[1], r = n[0] - t[0], a = n[1] - t[1];
  if (!r)
    return [t[0], 0];
  if (!a)
    return [0, t[1]];
  var s = a / r, l = -s * t[0] + t[1];
  return [-l / (s + 1 / s), l / (s * s + 1)];
}
function gG(e, t, n, r, a) {
  var s = e.props.innerBounds, l = a * Math.PI / 180;
  if (!s)
    return [];
  var p = s.left, h = s.top, y = s.width, b = s.height, E = p - r[0], x = p + y - r[0], C = h - r[1], T = h + b - r[1], O = [[E, C], [x, C], [E, T], [x, T]], D = gi(n, [0, 0]);
  if (!ek(n, O, D, 0))
    return [];
  var A = [], B = O.map(function(I) {
    return [Jl(I), mi([0, 0], I)];
  });
  return [[n[0], n[1]], [n[1], n[3]], [n[3], n[2]], [n[2], n[0]]].forEach(function(I) {
    var L = mi([0, 0], hG(I)), k = vG(I);
    A.push.apply(A, B.filter(function($) {
      var U = $[0];
      return U && k <= U;
    }).map(function($) {
      var U = $[0], K = $[1], X = Math.acos(U ? k / U : 0), Y = K + X, J = K - X;
      return [l + Y - L, l + J - L];
    }).reduce(function($, U) {
      return $.push.apply($, U), $;
    }, []).filter(function($) {
      return !ek(t, O, D, $);
    }).map(function($) {
      return hn($ * 180 / Math.PI, Ro);
    }));
  }), A;
}
function mG(e) {
  var t = e.props.innerBounds;
  if (!t)
    return {
      vertical: [],
      horizontal: []
    };
  var n = e.getRect(), r = n.pos1, a = n.pos2, s = n.pos3, l = n.pos4, p = [r, a, s, l], h = gi(p, [0, 0]), y = t.left, b = t.top, E = t.width, x = t.height, C = [[y, b], [y, b + x]], T = [[y, b], [y + E, b]], O = [[y + E, b], [y + E, b + x]], D = [[y, b + x], [y + E, b + x]], A = SD(e, p, [0, 0], !1), B = [], I = [], L = {
    top: !1,
    bottom: !1,
    left: !1,
    right: !1
  };
  return A.forEach(function(k) {
    var $ = k.line, U = k.lineConstants, K = pB(h, $), X = K.horizontal, Y = K.vertical, J = Up($, U, T, Y, 1, !0), Q = Up($, U, D, Y, 1, !0), Z = Up($, U, C, X, 1, !0), se = Up($, U, O, X, 1, !0);
    J.isBound && !L.top && (B.push(b), L.top = !0), Q.isBound && !L.bottom && (B.push(b + x), L.bottom = !0), Z.isBound && !L.left && (I.push(y), L.left = !0), se.isBound && !L.right && (I.push(y + E), L.right = !0);
  }), {
    horizontal: B,
    vertical: I
  };
}
function wD(e, t, n) {
  var r = e || {}, a = r.position, s = a === void 0 ? "client" : a, l = r.left, p = l === void 0 ? -1 / 0 : l, h = r.top, y = h === void 0 ? -1 / 0 : h, b = r.right, E = b === void 0 ? 1 / 0 : b, x = r.bottom, C = x === void 0 ? 1 / 0 : x, T = {
    position: s,
    left: p,
    top: y,
    right: E,
    bottom: C
  };
  return {
    vertical: tk(T, t, !0),
    horizontal: tk(T, n, !1)
  };
}
function qx(e, t) {
  var n = e.state, r = n.containerClientRect, a = r.clientHeight, s = r.clientWidth, l = r.clientLeft, p = r.clientTop, h = n.snapOffset, y = h.left, b = h.top, E = h.right, x = h.bottom, C = t || e.props.bounds || {}, T = C.position || "client", O = T === "css", D = C.left, A = D === void 0 ? -1 / 0 : D, B = C.top, I = B === void 0 ? -1 / 0 : B, L = C.right, k = L === void 0 ? O ? -1 / 0 : 1 / 0 : L, $ = C.bottom, U = $ === void 0 ? O ? -1 / 0 : 1 / 0 : $;
  return O && (k = s + E - y - k, U = a + x - b - U), {
    left: A + y - l,
    right: k + y - l,
    top: I + b - p,
    bottom: U + b - p
  };
}
function yG(e, t, n) {
  var r = qx(e), a = r.left, s = r.top, l = r.right, p = r.bottom, h = n[0], y = n[1], b = Bt(n, t), E = b[0], x = b[1];
  Math.abs(E) < Ro && (E = 0), Math.abs(x) < Ro && (x = 0);
  var C = x > 0, T = E > 0, O = {
    isBound: !1,
    offset: 0,
    pos: 0
  }, D = {
    isBound: !1,
    offset: 0,
    pos: 0
  };
  if (E === 0 && x === 0)
    return {
      vertical: O,
      horizontal: D
    };
  if (E === 0)
    C ? p < y && (D.pos = p, D.offset = y - p) : s > y && (D.pos = s, D.offset = y - s);
  else if (x === 0)
    T ? l < h && (O.pos = l, O.offset = h - l) : a > h && (O.pos = a, O.offset = h - a);
  else {
    var A = x / E, B = n[1] - A * h, I = 0, L = 0, k = !1;
    T && l <= h ? (I = A * l + B, L = l, k = !0) : !T && h <= a && (I = A * a + B, L = a, k = !0), k && (I < s || I > p) && (k = !1), k || (C && p <= y ? (I = p, L = (I - B) / A, k = !0) : !C && y <= s && (I = s, L = (I - B) / A, k = !0)), k && (O.isBound = !0, O.pos = L, O.offset = h - L, D.isBound = !0, D.pos = I, D.offset = y - I);
  }
  return {
    vertical: O,
    horizontal: D
  };
}
function tk(e, t, n) {
  var r = e[n ? "left" : "top"], a = e[n ? "right" : "bottom"], s = Math.min.apply(Math, t), l = Math.max.apply(Math, t), p = [];
  return r + 1 > s && p.push({
    isBound: !0,
    offset: s - r,
    pos: r
  }), a - 1 < l && p.push({
    isBound: !0,
    offset: l - a,
    pos: a
  }), p.length || p.push({
    isBound: !1,
    offset: 0,
    pos: 0
  }), p.sort(function(h, y) {
    return Math.abs(y.offset) - Math.abs(h.offset);
  });
}
function nk(e, t, n) {
  var r = n ? e.map(function(a) {
    return Fb(a, n);
  }) : e;
  return r.some(function(a) {
    return a[0] < t.left && Math.abs(a[0] - t.left) > 0.1 || a[0] > t.right && Math.abs(a[0] - t.right) > 0.1 || a[1] < t.top && Math.abs(a[1] - t.top) > 0.1 || a[1] > t.bottom && Math.abs(a[1] - t.bottom) > 0.1;
  });
}
function bG(e, t, n) {
  var r = Jl(e), a = Math.sqrt(r * r - t * t) || 0;
  return [a, -a].sort(function(s, l) {
    return Math.abs(s - e[n ? 0 : 1]) - Math.abs(l - e[n ? 0 : 1]);
  }).map(function(s) {
    return mi([0, 0], n ? [s, t] : [t, s]);
  });
}
function _G(e, t, n, r, a) {
  if (!e.props.bounds)
    return [];
  var s = a * Math.PI / 180, l = qx(e), p = l.left, h = l.top, y = l.right, b = l.bottom, E = p - r[0], x = y - r[0], C = h - r[1], T = b - r[1], O = {
    left: E,
    top: C,
    right: x,
    bottom: T
  };
  if (!nk(n, O, 0))
    return [];
  var D = [];
  return [[E, 0], [x, 0], [C, 1], [T, 1]].forEach(function(A) {
    var B = A[0], I = A[1];
    n.forEach(function(L) {
      var k = mi([0, 0], L);
      D.push.apply(D, bG(L, B, I).map(function($) {
        return s + $ - k;
      }).filter(function($) {
        return !nk(t, O, $);
      }).map(function($) {
        return hn($ * 180 / Math.PI, Ro);
      }));
    });
  }), D;
}
function EG(e, t) {
  var n, r = e.direction, a = e.classNames, s = e.size, l = e.pos, p = e.zoom, h = e.key, y = r === "horizontal", b = y ? "Y" : "X";
  return /* @__PURE__ */ He("div", {
    className: a.join(" "),
    style: (n = {}, n[y ? "width" : "height"] = "".concat(s), n.transform = "translate(".concat(l[0], ", ").concat(l[1], ") translate").concat(b, "(-50%) scale").concat(b, "(").concat(p, ")"), n)
  }, h);
}
function CD(e, t) {
  return EG(we(we({}, e), {
    classNames: jt([$t("line", "guideline", e.direction)], e.classNames, !0).filter(function(n) {
      return n;
    }),
    size: e.size || "".concat(e.sizeValue, "px"),
    pos: e.pos || e.posValue.map(function(n) {
      return "".concat(hn(n, 0.1), "px");
    })
  }));
}
function rk(e, t, n, r, a, s, l, p) {
  var h = e.props.zoom;
  return n.map(function(y, b) {
    var E = y.type, x = y.pos, C = [0, 0];
    return C[l] = r, C[l ? 0 : 1] = -a + x, CD({
      key: "".concat(t, "TargetGuideline").concat(b),
      classNames: [$t("target", "bold", E)],
      posValue: C,
      sizeValue: s,
      zoom: h,
      direction: t
    });
  });
}
function ik(e, t, n, r, a, s) {
  var l = e.props, p = l.zoom, h = l.isDisplayInnerSnapDigit, y = t === "horizontal" ? ev : tv, b = a[y.start], E = a[y.end];
  return n.filter(function(x) {
    var C = x.hide, T = x.elementRect;
    if (C)
      return !1;
    if (h && T) {
      var O = T.rect;
      if (O[y.start] <= b && E <= O[y.end])
        return !1;
    }
    return !0;
  }).map(function(x, C) {
    var T = x.pos, O = x.size, D = x.element, A = x.className, B = [-r[0] + T[0], -r[1] + T[1]];
    return CD({
      key: "".concat(t, "-default-guideline-").concat(C),
      classNames: D ? [$t("bold"), A] : [$t("normal"), A],
      direction: t,
      posValue: B,
      sizeValue: O,
      zoom: p
    });
  });
}
function Z0(e, t, n, r, a, s, l, p) {
  var h, y = e.props, b = y.snapDigit, E = b === void 0 ? 0 : b, x = y.isDisplaySnapDigit, C = x === void 0 ? !0 : x, T = y.snapDistFormat, O = T === void 0 ? function(k, $) {
    return k;
  } : T, D = y.zoom, A = t === "horizontal" ? "X" : "Y", B = t === "vertical" ? "height" : "width", I = Math.abs(a), L = C ? parseFloat(I.toFixed(E)) : 0;
  return /* @__PURE__ */ qi("div", {
    className: $t("guideline-group", t),
    style: (h = {
      left: "".concat(s[0], "px"),
      top: "".concat(s[1], "px")
    }, h[B] = "".concat(I, "px"), h),
    children: [CD({
      direction: t,
      classNames: [$t(n), l],
      size: "100%",
      posValue: [0, 0],
      sizeValue: I,
      zoom: D
    }), /* @__PURE__ */ He("div", {
      className: $t("size-value", "gap"),
      style: {
        transform: "translate".concat(A, "(-50%) scale(").concat(D, ")")
      },
      children: L > 0 ? O(L, t) : ""
    })]
  }, "".concat(t, "-").concat(n, "-guideline-").concat(r));
}
function xG(e, t, n, r) {
  var a = e === "vertical" ? 0 : 1, s = e === "vertical" ? 1 : 0, l = a ? ev : tv, p = n[l.start], h = n[l.end];
  return oB(t, function(y) {
    return y.pos[a];
  }).map(function(y) {
    var b = [], E = [], x = [];
    return y.forEach(function(C) {
      var T, O, D = C.element, A = C.elementRect.rect;
      if (A[l.end] < p)
        b.push(C);
      else if (h < A[l.start])
        E.push(C);
      else if (A[l.start] <= p && h <= A[l.end] && r) {
        var B = C.pos, I = {
          element: D,
          rect: we(we({}, A), (T = {}, T[l.end] = A[l.start], T))
        }, L = {
          element: D,
          rect: we(we({}, A), (O = {}, O[l.start] = A[l.end], O))
        }, k = [0, 0], $ = [0, 0];
        k[a] = B[a], k[s] = B[s], $[a] = B[a], $[s] = B[s] + C.size, b.push({
          type: e,
          pos: k,
          size: 0,
          elementRect: I
        }), E.push({
          type: e,
          pos: $,
          size: 0,
          elementRect: L
        });
      }
    }), b.sort(function(C, T) {
      return T.pos[s] - C.pos[s];
    }), E.sort(function(C, T) {
      return C.pos[s] - T.pos[s];
    }), {
      total: y,
      start: b,
      end: E,
      inner: x
    };
  });
}
function SG(e, t, n, r, a) {
  var s = e.props.isDisplayInnerSnapDigit, l = [];
  return ["vertical", "horizontal"].forEach(function(p) {
    var h = t.filter(function(D) {
      return D.type === p;
    }), y = p === "vertical" ? 1 : 0, b = y ? 0 : 1, E = xG(p, h, r, s), x = y ? tv : ev, C = y ? ev : tv, T = r[x.start], O = r[x.end];
    E.forEach(function(D) {
      var A = D.total, B = D.start, I = D.end, L = D.inner, k = n[b] + A[0].pos[b] - r[C.start], $ = r;
      B.forEach(function(U) {
        var K = U.elementRect.rect, X = $[x.start] - K[x.end];
        if (X > 0) {
          var Y = [0, 0];
          Y[y] = n[y] + $[x.start] - T - X, Y[b] = k, l.push(Z0(e, p, "dashed", l.length, X, Y, U.className));
        }
        $ = K;
      }), $ = r, I.forEach(function(U) {
        var K = U.elementRect.rect, X = K[x.start] - $[x.end];
        if (X > 0) {
          var Y = [0, 0];
          Y[y] = n[y] + $[x.end] - T, Y[b] = k, l.push(Z0(e, p, "dashed", l.length, X, Y, U.className));
        }
        $ = K;
      }), L.forEach(function(U) {
        var K = U.elementRect.rect, X = T - K[x.start], Y = K[x.end] - O, J = [0, 0], Q = [0, 0];
        J[y] = n[y] - X, J[b] = k, Q[y] = n[y] + O - T, Q[b] = k, l.push(Z0(e, p, "dashed", l.length, X, J, U.className)), l.push(Z0(e, p, "dashed", l.length, Y, Q, U.className));
      });
    });
  }), l;
}
function wG(e, t, n, r, a) {
  var s = [];
  return ["horizontal", "vertical"].forEach(function(l) {
    var p = t.filter(function(D) {
      return D.type === l;
    }).slice(0, 1), h = l === "vertical" ? 0 : 1, y = h ? 0 : 1, b = h ? tv : ev, E = h ? ev : tv, x = r[b.start], C = r[b.end], T = r[E.start], O = r[E.end];
    p.forEach(function(D) {
      var A = D.gap, B = D.gapRects, I = Math.max.apply(Math, jt([T], B.map(function($) {
        var U = $.rect;
        return U[E.start];
      }), !1)), L = Math.min.apply(Math, jt([O], B.map(function($) {
        var U = $.rect;
        return U[E.end];
      }), !1)), k = (I + L) / 2;
      I === L || k === (T + O) / 2 || B.forEach(function($) {
        var U = $.rect, K = $.className, X = [n[0], n[1]];
        if (U[b.end] < x)
          X[h] += U[b.end] - x;
        else if (C < U[b.start])
          X[h] += U[b.start] - x - A;
        else
          return;
        X[y] += k - T, s.push(Z0(e, h ? "vertical" : "horizontal", "gap", s.length, A, X, K));
      });
    });
  }), s;
}
function CG(e, t, n, r) {
  var a = t[0] - e[0], s = t[1] - e[1];
  if (Math.abs(a) < $i && (a = 0), Math.abs(s) < $i && (s = 0), !a)
    return r ? [0, 0] : [0, n];
  if (!s)
    return r ? [n, 0] : [0, 0];
  var l = s / a, p = e[1] - l * e[0];
  if (r) {
    var h = l * (t[0] + n) + p;
    return [n, h - t[1]];
  } else {
    var y = (t[1] + n - p) / l;
    return [y - t[0], n];
  }
}
function ZT(e, t, n, r, a) {
  var s = CG(e, t, n, r);
  if (!s)
    return {
      isOutside: !1,
      offset: [0, 0]
    };
  var l = Qu(e, t), p = Qu(s, e), h = Qu(s, t), y = p > l || h > l, b = nf({
    datas: a,
    distX: s[0],
    distY: s[1]
  }), E = b[0], x = b[1];
  return {
    offset: [E, x],
    isOutside: y
  };
}
function gx(e, t) {
  return e.isBound ? e.offset : t.isSnap ? QT(t).offset : 0;
}
function RG(e, t, n, r, a) {
  var s = t[0], l = t[1], p = n[0], h = n[1], y = r[0], b = r[1], E = a[0], x = a[1], C = -E, T = -x;
  if (e && s && l) {
    C = 0, T = 0;
    var O = [];
    if (p && h ? O.push([0, x], [E, 0]) : p ? O.push([E, 0]) : h ? O.push([0, x]) : y && b ? O.push([0, x], [E, 0]) : y ? O.push([E, 0]) : b && O.push([0, x]), O.length) {
      O.sort(function(I, L) {
        return Jl(Bt([s, l], I)) - Jl(Bt([s, l], L));
      });
      var D = O[0];
      if (D[0] && Math.abs(s) > $i)
        C = -D[0], T = l * Math.abs(s + C) / Math.abs(s) - l;
      else if (D[1] && Math.abs(l) > $i) {
        var A = l;
        T = -D[1], C = s * Math.abs(l + T) / Math.abs(A) - s;
      }
      if (e && h && p)
        if (Math.abs(C) > $i && Math.abs(C) < Math.abs(E)) {
          var B = Math.abs(E) / Math.abs(C);
          C *= B, T *= B;
        } else if (Math.abs(T) > $i && Math.abs(T) < Math.abs(x)) {
          var B = Math.abs(x) / Math.abs(T);
          C *= B, T *= B;
        } else
          C = yy(-E, C), T = yy(-x, T);
    }
  } else
    C = s || p ? -E : 0, T = l || h ? -x : 0;
  return [C, T];
}
function TG(e, t, n, r, a, s) {
  if (!My(e, "draggable"))
    return [{
      isSnap: !1,
      isBound: !1,
      offset: 0
    }, {
      isSnap: !1,
      isBound: !1,
      offset: 0
    }];
  var l = gD(s.absolutePoses, [t, n]), p = el(l), h = p.left, y = p.right, b = p.top, E = p.bottom, x = {
    horizontal: l.map(function(se) {
      return se[1];
    }),
    vertical: l.map(function(se) {
      return se[0];
    })
  }, C = _D(e.props.snapDirections), T = ED(C, {
    left: h,
    right: y,
    top: b,
    bottom: E,
    center: (h + y) / 2,
    middle: (b + E) / 2
  }), O = Xx(e, a, T, x), D = O.vertical, A = O.horizontal, B = dG(e, l, s), I = B.vertical, L = B.horizontal, k = D.isSnap, $ = A.isSnap, U = D.isBound || I.isBound, K = A.isBound || L.isBound, X = yy(D.offset, I.offset), Y = yy(A.offset, L.offset), J = RG(r, [t, n], [U, K], [k, $], [X, Y]), Q = J[0], Z = J[1];
  return [{
    isBound: U,
    isSnap: k,
    offset: Q
  }, {
    isBound: K,
    isSnap: $,
    offset: Z
  }];
}
function Xx(e, t, n, r) {
  r === void 0 && (r = n);
  var a = wD(qx(e), r.vertical, r.horizontal), s = a.horizontal, l = a.vertical, p = t ? {
    horizontal: {
      isSnap: !1,
      index: -1
    },
    vertical: {
      isSnap: !1,
      index: -1
    }
  } : Yx(e, n.vertical, n.horizontal), h = p.horizontal, y = p.vertical, b = gx(s[0], h), E = gx(l[0], y), x = Math.abs(b), C = Math.abs(E);
  return {
    horizontal: {
      isBound: s[0].isBound,
      isSnap: h.isSnap,
      snapIndex: h.index,
      offset: b,
      dist: x,
      bounds: s,
      snap: h
    },
    vertical: {
      isBound: l[0].isBound,
      isSnap: y.isSnap,
      snapIndex: y.index,
      offset: E,
      dist: C,
      bounds: l,
      snap: y
    }
  };
}
function ak(e, t, n, r, a) {
  var s = wD(t, n, r), l = s.horizontal, p = s.vertical, h = fB(e, n, r, a), y = h.horizontal, b = h.vertical, E = gx(l[0], y), x = gx(p[0], b), C = Math.abs(E), T = Math.abs(x);
  return {
    horizontal: {
      isBound: l[0].isBound,
      isSnap: y.isSnap,
      snapIndex: y.index,
      offset: E,
      dist: C,
      bounds: l,
      snap: y
    },
    vertical: {
      isBound: p[0].isBound,
      isSnap: b.isSnap,
      snapIndex: b.index,
      offset: x,
      dist: T,
      bounds: p,
      snap: b
    }
  };
}
function OG(e, t, n, r) {
  var a = mi(e, t) / Math.PI * 180, s = n.vertical, l = s.isBound, p = s.isSnap, h = s.dist, y = n.horizontal, b = y.isBound, E = y.isSnap, x = y.dist, C = a % 180, T = C < 3 || C > 177, O = C > 87 && C < 93;
  return x < h && (l || p && !O && (!r || !T)) ? "vertical" : b || E && !T && (!r || !O) ? "horizontal" : "";
}
function DG(e, t, n, r, a, s) {
  return n.map(function(l) {
    var p = l[0], h = l[1], y = gi(t, p), b = gi(t, h), E = r ? MG(e, y, b, a) : Xx(e, a, {
      vertical: [b[0]],
      horizontal: [b[1]]
    }), x = E.horizontal, C = x.offset, T = x.isBound, O = x.isSnap, D = E.vertical, A = D.offset, B = D.isBound, I = D.isSnap, L = Bt(h, p);
    if (!A && !C)
      return {
        isBound: B || T,
        isSnap: I || O,
        sign: L,
        offset: [0, 0]
      };
    var k = OG(y, b, E, r);
    if (!k)
      return {
        sign: L,
        isBound: !1,
        isSnap: !1,
        offset: [0, 0]
      };
    var $ = k === "vertical", U = [0, 0];
    return !r && Math.abs(h[0]) === 1 && Math.abs(h[1]) === 1 && p[0] !== h[0] && p[1] !== h[1] ? U = nf({
      datas: s,
      distX: -A,
      distY: -C
    }) : U = ZT(y, b, -($ ? A : C), $, s).offset, U = U.map(function(K, X) {
      return K * (L[X] ? 2 / L[X] : 0);
    }), {
      sign: L,
      isBound: $ ? B : T,
      isSnap: $ ? I : O,
      offset: U
    };
  });
}
function ok(e, t) {
  return e.isBound ? e.offset : t.isSnap ? t.offset : 0;
}
function MG(e, t, n, r) {
  var a = yG(e, t, n), s = a.horizontal, l = a.vertical, p = r ? {
    horizontal: {
      isSnap: !1
    },
    vertical: {
      isSnap: !1
    }
  } : uG(e, t, n), h = p.horizontal, y = p.vertical, b = ok(s, h), E = ok(l, y), x = Math.abs(b), C = Math.abs(E);
  return {
    horizontal: {
      isBound: s.isBound,
      isSnap: h.isSnap,
      offset: b,
      dist: x
    },
    vertical: {
      isBound: l.isBound,
      isSnap: y.isSnap,
      offset: E,
      dist: C
    }
  };
}
function AG(e, t, n, r, a) {
  var s = [-n[0], -n[1]], l = e.state, p = l.width, h = l.height, y = e.props.bounds, b = 1 / 0, E = 1 / 0;
  if (y) {
    var x = [[n[0], -n[1]], [-n[0], n[1]]], C = y.left, T = C === void 0 ? -1 / 0 : C, O = y.top, D = O === void 0 ? -1 / 0 : O, A = y.right, B = A === void 0 ? 1 / 0 : A, I = y.bottom, L = I === void 0 ? 1 / 0 : I;
    x.forEach(function(k) {
      var $ = k[0] !== s[0], U = k[1] !== s[1], K = gi(t, k), X = mi(r, K) * 360 / Math.PI;
      if (U) {
        var Y = K.slice();
        (Math.abs(X - 360) < 2 || Math.abs(X - 180) < 2) && (Y[1] = r[1]);
        var J = ZT(r, Y, (r[1] < K[1] ? L : D) - K[1], !1, a), Q = J.offset, Z = Q[1], se = J.isOutside;
        isNaN(Z) || (E = h + (se ? 1 : -1) * Math.abs(Z));
      }
      if ($) {
        var Y = K.slice();
        (Math.abs(X - 90) < 2 || Math.abs(X - 270) < 2) && (Y[0] = r[0]);
        var pe = ZT(r, Y, (r[0] < K[0] ? B : T) - K[0], !0, a), be = pe.offset[0], _e = pe.isOutside;
        isNaN(be) || (b = p + (_e ? 1 : -1) * Math.abs(be));
      }
    });
  }
  return {
    maxWidth: b,
    maxHeight: E
  };
}
function JT(e) {
  var t = e.state, n = t.containerClientRect, r = t.hasFixed, a = n.overflow, s = n.scrollHeight, l = n.scrollWidth, p = n.clientHeight, h = n.clientWidth, y = n.clientLeft, b = n.clientTop, E = e.props, x = E.snapGap, C = x === void 0 ? !0 : x, T = E.verticalGuidelines, O = E.horizontalGuidelines, D = E.snapThreshold, A = D === void 0 ? 5 : D, B = E.snapGridWidth, I = B === void 0 ? 0 : B, L = E.snapGridHeight, k = L === void 0 ? 0 : L, $ = E.maxSnapElementGuidelineDistance, U = $ === void 0 ? 1 / 0 : $, K = el(is(e.state)), X = K.top, Y = K.left, J = K.bottom, Q = K.right, Z = {
    top: X,
    left: Y,
    bottom: J,
    right: Q,
    center: (Y + Q) / 2,
    middle: (X + J) / 2
  }, se = kG(e), pe = jt([], se, !0);
  C && pe.push.apply(pe, PG(e, Z, A)), pe.push.apply(pe, NG(I, k, a ? l : h, a ? s : p, y, b));
  var be = we({}, t.snapOffset || {
    left: 0,
    top: 0,
    bottom: 0,
    right: 0
  });
  if (r) {
    var _e = n.left, Se = n.top;
    be.left += _e, be.top += Se, be.right += _e, be.bottom += Se;
  }
  return pe.push.apply(pe, mB(O || !1, T || !1, a ? l : h, a ? s : p, y, b, be)), pe = pe.filter(function(Oe) {
    var re = Oe.element, ie = Oe.elementRect, ce = Oe.type;
    if (!re || !ie)
      return !0;
    var le = ie.rect;
    return gB(Z, le, ce, U);
  }), pe;
}
function PG(e, t, n) {
  var r = e.props, a = r.maxSnapElementGuidelineDistance, s = a === void 0 ? 1 / 0 : a, l = r.maxSnapElementGapDistance, p = l === void 0 ? 1 / 0 : l, h = e.state.elementRects, y = [];
  return [["vertical", ev, tv], ["horizontal", tv, ev]].forEach(function(b) {
    var E = b[0], x = b[1], C = b[2], T = t[x.start], O = t[x.end], D = t[x.center], A = t[C.start], B = t[C.end];
    function I($) {
      var U = $.rect;
      return U[x.end] < T + n ? T - U[x.end] : O - n < U[x.start] ? U[x.start] - O : -1;
    }
    var L = h.filter(function($) {
      var U = $.rect;
      return U[C.start] > B || U[C.end] < A ? !1 : I($) > 0;
    }).sort(function($, U) {
      return I($) - I(U);
    }), k = [];
    L.forEach(function($) {
      L.forEach(function(U) {
        if ($ !== U) {
          var K = $.rect, X = U.rect, Y = K[C.start], J = K[C.end], Q = X[C.start], Z = X[C.end];
          Y > Z || Q > J || k.push([$, U]);
        }
      });
    }), k.forEach(function($) {
      var U = $[0], K = $[1], X = U.rect, Y = K.rect, J = X[x.start], Q = X[x.end], Z = Y[x.start], se = Y[x.end], pe = 0, be = 0, _e = !1, Se = !1, Oe = !1;
      if (Q <= T && O <= Z) {
        if (Se = !0, pe = (Z - Q - (O - T)) / 2, be = Q + pe + (O - T) / 2, Math.abs(be - D) > n)
          return;
      } else if (Q < Z && se < T + n) {
        if (_e = !0, pe = Z - Q, be = se + pe, Math.abs(be - T) > n)
          return;
      } else if (Q < Z && O - n < J) {
        if (Oe = !0, pe = Z - Q, be = J - pe, Math.abs(be - O) > n)
          return;
      } else
        return;
      !pe || !gB(t, Y, E, s) || pe > p || y.push({
        type: E,
        pos: E === "vertical" ? [be, 0] : [0, be],
        element: K.element,
        size: 0,
        className: K.className,
        isStart: _e,
        isCenter: Se,
        isEnd: Oe,
        gap: pe,
        hide: !0,
        gapRects: [U, K]
      });
    });
  }), y;
}
function NG(e, t, n, r, a, s) {
  a === void 0 && (a = 0), s === void 0 && (s = 0);
  var l = [];
  if (t)
    for (var p = 0; p <= r; p += t)
      l.push({
        type: "horizontal",
        pos: [0, hn(p - s, 0.1)],
        size: n,
        hide: !0
      });
  if (e)
    for (var p = 0; p <= n; p += e)
      l.push({
        type: "vertical",
        pos: [hn(p - a, 0.1), 0],
        size: r,
        hide: !0
      });
  return l;
}
function gB(e, t, n, r) {
  return n === "horizontal" ? Math.abs(e.right - t.left) <= r || Math.abs(e.left - t.right) <= r || e.left <= t.right && t.left <= e.right : n === "vertical" ? Math.abs(e.bottom - t.top) <= r || Math.abs(e.top - t.bottom) <= r || e.top <= t.bottom && t.top <= e.bottom : !0;
}
function kG(e) {
  var t = e.state, n = e.props.elementGuidelines, r = n === void 0 ? [] : n;
  if (!r.length)
    return t.elementRects = [], [];
  var a = (t.elementRects || []).filter(function(x) {
    return !x.refresh;
  }), s = r.map(function(x) {
    return rs(x) && "element" in x ? we(we({}, x), {
      element: Jh(x.element, !0)
    }) : {
      element: Jh(x, !0)
    };
  }).filter(function(x) {
    return x.element;
  }), l = Xm(a.map(function(x) {
    return x.element;
  }), s.map(function(x) {
    return x.element;
  })), p = l.maintained, h = l.added, y = [];
  p.forEach(function(x) {
    var C = x[0], T = x[1];
    y[T] = a[C];
  }), IG(e, h.map(function(x) {
    return s[x];
  })).map(function(x, C) {
    y[h[C]] = x;
  }), t.elementRects = y;
  var b = _D(e.props.elementSnapDirections), E = [];
  return y.forEach(function(x) {
    var C = x.element, T = x.top, O = T === void 0 ? b.top : T, D = x.left, A = D === void 0 ? b.left : D, B = x.right, I = B === void 0 ? b.right : B, L = x.bottom, k = L === void 0 ? b.bottom : L, $ = x.center, U = $ === void 0 ? b.center : $, K = x.middle, X = K === void 0 ? b.middle : K, Y = x.className, J = x.rect, Q = ED({
      top: O,
      right: I,
      left: A,
      bottom: k,
      center: U,
      middle: X
    }, J), Z = Q.horizontal, se = Q.vertical, pe = J.top, be = J.left, _e = J.right - be, Se = J.bottom - pe, Oe = [_e, Se];
    se.forEach(function(re) {
      E.push({
        type: "vertical",
        element: C,
        pos: [hn(re, 0.1), pe],
        size: Se,
        sizes: Oe,
        className: Y,
        elementRect: x
      });
    }), Z.forEach(function(re) {
      E.push({
        type: "horizontal",
        element: C,
        pos: [be, hn(re, 0.1)],
        size: _e,
        sizes: Oe,
        className: Y,
        elementRect: x
      });
    });
  }), E;
}
function mB(e, t, n, r, a, s, l) {
  a === void 0 && (a = 0), s === void 0 && (s = 0), l === void 0 && (l = {
    left: 0,
    top: 0,
    right: 0,
    bottom: 0
  });
  var p = [], h = l.left, y = l.top, b = l.bottom, E = l.right, x = n + E - h, C = r + b - y;
  return e && e.forEach(function(T) {
    var O = rs(T) ? T : {
      pos: T
    };
    p.push({
      type: "horizontal",
      pos: [h, hn(O.pos - s + y, 0.1)],
      size: x,
      className: O.className
    });
  }), t && t.forEach(function(T) {
    var O = rs(T) ? T : {
      pos: T
    };
    p.push({
      type: "vertical",
      pos: [hn(O.pos - a + h, 0.1), y],
      size: C,
      className: O.className
    });
  }), p;
}
function IG(e, t) {
  if (!t.length)
    return [];
  var n = e.state, r = n.containerClientRect, a = n.targetClientRect, s = a.top, l = a.left, p = n.rootMatrix, h = n.is3d, y = h ? 4 : 3, b = oG(p, r, y), E = b[0], x = b[1], C = is(n), T = Zp(C), O = T.minX, D = T.minY, A = Bt([O, D], iy(p, [l - E, s - x], y)).map(function(L) {
    return qW(L);
  }), B = A[0], I = A[1];
  return t.map(function(L) {
    var k = L.element.getBoundingClientRect(), $ = k.left - E, U = k.top - x, K = U + k.height, X = $ + k.width, Y = iy(p, [$, U], y), J = Y[0], Q = Y[1], Z = iy(p, [X, K], y), se = Z[0], pe = Z[1];
    return we(we({}, L), {
      rect: {
        left: J + B,
        right: se + B,
        top: Q + I,
        bottom: pe + I,
        center: (J + se) / 2 + B,
        middle: (Q + pe) / 2 + I
      }
    });
  });
}
function _E(e) {
  var t = e.state, n = t.container, r = e.props.snapContainer || n;
  if (t.snapContainer === r && t.guidelines && t.guidelines.length)
    return !1;
  var a = t.containerClientRect, s = {
    left: 0,
    top: 0,
    bottom: 0,
    right: 0
  };
  if (n !== r) {
    var l = Jh(r, !0);
    if (l) {
      var p = Q0(l), h = KN(t, [p.left - a.left, p.top - a.top]), y = KN(t, [p.right - a.right, p.bottom - a.bottom]);
      s.left = hn(h[0], 1e-5), s.top = hn(h[1], 1e-5), s.right = hn(y[0], 1e-5), s.bottom = hn(y[1], 1e-5);
    }
  }
  return t.snapContainer = r, t.snapOffset = s, t.guidelines = JT(e), t.enableSnap = !0, !0;
}
function yB(e, t, n, r, a, s) {
  var l = Jp(e, t, n, s ? 4 : 3), p = gi(l, r);
  return gD(l, Bt(a, p));
}
function LG(e, t, n, r, a, s) {
  var l = s.fixedDirection, p = cG(n, l, r), h = SD(e, t, n, r), y = jt(jt([], DG(e, t, p, r, a, s), !0), hB(e, h, s), !0), b = hx(y, 0), E = hx(y, 1);
  return {
    width: {
      isBound: b.isBound,
      offset: b.offset[0]
    },
    height: {
      isBound: E.isBound,
      offset: E.offset[1]
    }
  };
}
function BG(e, t, n, r, a, s, l, p, h) {
  var y = gi(t, l), b = Xx(e, p, {
    vertical: [y[0]],
    horizontal: [y[1]]
  }), E = b.horizontal.offset, x = b.vertical.offset;
  if (hn(x, GT) || hn(E, GT)) {
    var C = nf({
      datas: h,
      distX: -x,
      distY: -E
    }), T = C[0], O = C[1], D = Math.min(a || 1 / 0, n + l[0] * T), A = Math.min(s || 1 / 0, r + l[1] * O);
    return [D - n, A - r];
  }
  return [0, 0];
}
function bB(e, t, n, r, a, s, l, p) {
  for (var h = is(e.state), y = e.props.keepRatio, b = 0, E = 0, x = 0; x < 2; ++x) {
    var C = t(b, E), T = LG(e, C, a, y, l, p), O = T.width, D = T.height, A = O.isBound, B = D.isBound, I = O.offset, L = D.offset;
    if (x === 1 && (A || (I = 0), B || (L = 0)), x === 0 && l && !A && !B)
      return [0, 0];
    if (y) {
      var k = Math.abs(I) * (n ? 1 / n : 1), $ = Math.abs(L) * (r ? 1 / r : 1), U = A && B ? k < $ : B || !A && k < $;
      U ? I = n * L / r : L = r * I / n;
    }
    b += I, E += L;
  }
  if (a[0] && a[1]) {
    var K = AG(e, h, a, s, p), X = K.maxWidth, Y = K.maxHeight, J = BG(e, t(b, E).map(function(se) {
      return se.map(function(pe) {
        return hn(pe, GT);
      });
    }), n + b, r + E, X, Y, a, l, p), I = J[0], L = J[1];
    b += I, E += L;
  }
  return [b, E];
}
function zG(e, t, n) {
  if (!My(e, "rotatable"))
    return {
      isSnap: !1,
      rotation: n
    };
  var r = t.pos1, a = t.pos2, s = t.pos3, l = t.pos4, p = t.origin, h = n * Math.PI / 180, y = [r, a, s, l].map(function(C) {
    return Bt(C, p);
  }), b = y.map(function(C) {
    return Fb(C, h);
  }), E = jt(jt([], _G(e, y, b, p, n), !0), gG(e, y, b, p, n), !0);
  E.sort(function(C, T) {
    return Math.abs(C - n) - Math.abs(T - n);
  });
  var x = E.length > 0;
  return {
    isSnap: x,
    rotation: x ? E[0] : n
  };
}
function FG(e, t, n, r, a, s, l) {
  if (!My(e, "resizable"))
    return [0, 0];
  var p = l.fixedDirection, h = l.nextAllMatrix, y = e.state, b = y.allMatrix, E = y.is3d;
  return bB(e, function(x, C) {
    return yB(h || b, t + x, n + C, p, a, E);
  }, t, n, r, a, s, l);
}
function $G(e, t, n, r, a) {
  if (!My(e, "scalable"))
    return [0, 0];
  var s = a.startOffsetWidth, l = a.startOffsetHeight, p = a.fixedPosition, h = a.fixedDirection, y = a.is3d, b = bB(e, function(E, x) {
    return yB(NW(a, On(t, [E / s, x / l])), s, l, h, p, y);
  }, s, l, n, p, r, a);
  return [b[0] / s, b[1] / l];
}
function UG(e, t) {
  t.absolutePoses = is(e.state);
}
function sk(e) {
  var t = [];
  return e.forEach(function(n) {
    n.guidelineInfos.forEach(function(r) {
      var a = r.guideline;
      t.indexOf(a) > -1 || t.push(a);
    });
  }), t;
}
function uk(e, t, n, r, a, s) {
  var l = wD(qx(e, s), t, n), p = l.vertical, h = l.horizontal;
  p.forEach(function(x) {
    x.isBound && r.push({
      type: "bounds",
      pos: x.pos
    });
  }), h.forEach(function(x) {
    x.isBound && a.push({
      type: "bounds",
      pos: x.pos
    });
  });
  var y = mG(e), b = y.vertical, E = y.horizontal;
  b.forEach(function(x) {
    yd(r, function(C) {
      var T = C.type, O = C.pos;
      return T === "bounds" && O === x;
    }) >= 0 || r.push({
      type: "bounds",
      pos: x
    });
  }), E.forEach(function(x) {
    yd(a, function(C) {
      var T = C.type, O = C.pos;
      return T === "bounds" && O === x;
    }) >= 0 || a.push({
      type: "bounds",
      pos: x
    });
  });
}
var VG = yD("", ["resizable", "scalable"]), jG = {
  name: "snappable",
  dragRelation: "strong",
  props: {
    snappable: [Boolean, Array],
    snapContainer: Object,
    snapDirections: [Boolean, Object],
    elementSnapDirections: [Boolean, Object],
    snapGap: Boolean,
    snapGridWidth: Number,
    snapGridHeight: Number,
    isDisplaySnapDigit: Boolean,
    isDisplayInnerSnapDigit: Boolean,
    snapDigit: Number,
    snapThreshold: Number,
    snapRenderThreshold: Number,
    horizontalGuidelines: Array,
    verticalGuidelines: Array,
    elementGuidelines: Array,
    bounds: Object,
    innerBounds: Object,
    snapDistFormat: Function,
    maxSnapElementGuidelineDistance: Number,
    maxSnapElementGapDistance: Number
  },
  events: {
    onSnap: "snap"
  },
  css: [`:host {
    --bounds-color: #d66;
}
.guideline {
    pointer-events: none;
    z-index: 2;
}
.guideline.bounds {
    background: #d66;
    background: var(--bounds-color);
}
.guideline-group {
    position: absolute;
    top: 0;
    left: 0;
}
.guideline-group .size-value {
    position: absolute;
    color: #f55;
    font-size: 12px;
    font-weight: bold;
}
.guideline-group.horizontal .size-value {
    transform-origin: 50% 100%;
    transform: translateX(-50%);
    left: 50%;
    bottom: 5px;
}
.guideline-group.vertical .size-value {
    transform-origin: 0% 50%;
    top: 50%;
    transform: translateY(-50%);
    left: 5px;
}
.guideline.gap {
    background: #f55;
}
.size-value.gap {
    color: #f55;
}
`],
  render: function(e, t) {
    var n = e.state, r = n.top, a = n.left, s = n.pos1, l = n.pos2, p = n.pos3, h = n.pos4, y = n.snapRenderInfo, b = e.props.snapRenderThreshold, E = b === void 0 ? 1 : b;
    if (!y || !My(e, ""))
      return [];
    n.guidelines = JT(e);
    var x = Math.min(s[0], l[0], p[0], h[0]), C = Math.min(s[1], l[1], p[1], h[1]), T = y.externalPoses || [], O = is(e.state), D = [], A = [], B = [], I = [], L = [], k = el(O), $ = k.width, U = k.height, K = k.top, X = k.left, Y = k.bottom, J = k.right, Q = {
      left: X,
      right: J,
      top: K,
      bottom: Y,
      center: (X + J) / 2,
      middle: (K + Y) / 2
    }, Z = T.length > 0, se = Z ? el(T) : {};
    if (!y.request) {
      if (y.direction && L.push(lG(e, O, y.direction, E)), y.snap) {
        var pe = el(O);
        y.center && (pe.middle = (pe.top + pe.bottom) / 2, pe.center = (pe.left + pe.right) / 2), L.push(QN(e, pe, E));
      }
      Z && (y.center && (se.middle = (se.top + se.bottom) / 2, se.center = (se.left + se.right) / 2), L.push(QN(e, se, E))), L.forEach(function(Oe) {
        var re = Oe.vertical.posInfos, ie = Oe.horizontal.posInfos;
        D.push.apply(D, re.filter(function(ce) {
          var le = ce.guidelineInfos;
          return le.some(function(fe) {
            var ve = fe.guideline;
            return !ve.hide;
          });
        }).map(function(ce) {
          return {
            type: "snap",
            pos: ce.pos
          };
        })), A.push.apply(A, ie.filter(function(ce) {
          var le = ce.guidelineInfos;
          return le.some(function(fe) {
            var ve = fe.guideline;
            return !ve.hide;
          });
        }).map(function(ce) {
          return {
            type: "snap",
            pos: ce.pos
          };
        })), B.push.apply(B, sk(re)), I.push.apply(I, sk(ie));
      });
    }
    uk(e, [X, J], [K, Y], D, A), Z && uk(e, [se.left, se.right], [se.top, se.bottom], D, A, y.externalBounds);
    var be = jt(jt([], B, !0), I, !0), _e = be.filter(function(Oe) {
      return Oe.element && !Oe.gapRects;
    }), Se = be.filter(function(Oe) {
      return Oe.gapRects;
    }).sort(function(Oe, re) {
      return Oe.gap - re.gap;
    });
    return St(e, "onSnap", {
      guidelines: be.filter(function(Oe) {
        var re = Oe.element;
        return !re;
      }),
      elements: _e,
      gaps: Se
    }, !0), jt(jt(jt(jt(jt(jt([], SG(e, _e, [x, C], Q), !0), wG(e, Se, [x, C], Q), !0), ik(e, "horizontal", I, [a, r], Q), !0), ik(e, "vertical", B, [a, r], Q), !0), rk(e, "horizontal", A, x, r, $, 0), !0), rk(e, "vertical", D, C, a, U, 1), !0);
  },
  dragStart: function(e, t) {
    e.state.snapRenderInfo = {
      request: t.isRequest,
      snap: !0,
      center: !0
    }, _E(e);
  },
  drag: function(e) {
    var t = e.state;
    _E(e) || (t.guidelines = JT(e));
  },
  pinchStart: function(e) {
    this.unset(e);
  },
  dragEnd: function(e) {
    this.unset(e);
  },
  dragControlCondition: function(e, t) {
    if (VG(e, t) || tO(e, t))
      return !0;
    if (!t.isRequest && t.inputEvent)
      return Ui(t.inputEvent.target, $t("snap-control"));
  },
  dragControlStart: function(e) {
    e.state.snapRenderInfo = null, _E(e);
  },
  dragControl: function(e) {
    this.drag(e);
  },
  dragControlEnd: function(e) {
    this.unset(e);
  },
  dragGroupStart: function(e, t) {
    this.dragStart(e, t);
  },
  dragGroup: function(e) {
    this.drag(e);
  },
  dragGroupEnd: function(e) {
    this.unset(e);
  },
  dragGroupControlStart: function(e) {
    e.state.snapRenderInfo = null, _E(e);
  },
  dragGroupControl: function(e) {
    this.drag(e);
  },
  dragGroupControlEnd: function(e) {
    this.unset(e);
  },
  unset: function(e) {
    var t = e.state;
    t.enableSnap = !1, t.guidelines = [], t.snapRenderInfo = null, t.elementRects = [];
  }
};
function _B(e, t, n, r) {
  var a = e.getState(), s = a.renderPoses, l = a.rotation, p = a.direction, h = Zh(e.props, t).zoom, y = p > 0 ? 1 : -1, b = l / Math.PI * 180, E = {}, x = e.renderState;
  x.renderDirectionMap || (x.renderDirectionMap = {});
  var C = x.renderDirectionMap;
  return n.forEach(function(T) {
    var O = T.dir;
    E[O] = !0;
  }), n.map(function(T) {
    var O = T.data, D = T.classNames, A = T.dir, B = dD[A];
    if (!B || !E[A])
      return null;
    C[A] = !0;
    var I = (hn(b, 15) + y * FL[A] + 720) % 180, L = {};
    return Oy(O).forEach(function(k) {
      L["data-".concat(k)] = O[k];
    }), /* @__PURE__ */ He("div", {
      ...we({
        className: $t.apply(void 0, jt(["control", "direction", A, t], D, !1)),
        "data-rotation": I,
        "data-direction": A
      }, L, {
        key: "direction-".concat(A),
        style: hD.apply(void 0, jt([l, h], B.map(function(k) {
          return s[k];
        }), !1))
      })
    });
  });
}
function EB(e, t, n, r) {
  var a = Zh(e.props, n).renderDirections, s = a === void 0 ? t : a;
  if (!s)
    return [];
  var l = s === !0 ? fD : s;
  return _B(e, n, l.map(function(p) {
    return {
      data: {},
      classNames: [],
      dir: p
    };
  }));
}
function WG(e, t) {
  var n = e.renderState;
  n.renderDirectionMap || (n.renderDirectionMap = {});
  var r = e.getState(), a = r.renderPoses, s = r.rotation, l = r.direction, p = n.renderDirectionMap, h = e.props.zoom, y = l > 0 ? 1 : -1, b = s / Math.PI * 180;
  return Oy(p).map(function(E) {
    var x = dD[E];
    if (!x)
      return null;
    var C = (hn(b, 15) + y * FL[E] + 720) % 180;
    return /* @__PURE__ */ He("div", {
      className: $t("around-control"),
      "data-rotation": C,
      "data-direction": E,
      style: hD.apply(void 0, jt([s, h], x.map(function(T) {
        return a[T];
      }), !1))
    }, "direction-around-".concat(E));
  });
}
function mb(e, t, n, r, a, s) {
  for (var l = [], p = 6; p < arguments.length; p++)
    l[p - 6] = arguments[p];
  var h = mi(n, r), y = t ? hn(h / Math.PI * 180, 15) % 180 : -1;
  return /* @__PURE__ */ He("div", {
    className: $t.apply(void 0, jt(["line", "direction", t ? "edge" : "", t], l, !1)),
    "data-rotation": y,
    "data-line-key": s,
    "data-direction": t,
    style: K0(n, r, a, h)
  }, "line-".concat(s));
}
function xB(e, t, n, r, a) {
  var s = n === !0 ? SW : n;
  return s.map(function(l, p) {
    var h = dD[l], y = h[0], b = h[1];
    if (b != null)
      return mb(e, l, r[y], r[b], a, "".concat(t, "Edge").concat(p), t);
  }).filter(Boolean);
}
function SB(e) {
  return function(t, n) {
    var r = Zh(t.props, e).edge;
    return r && (r === !0 || r.length) ? jt(jt([], xB(n, e, r, t.getState().renderPoses, t.props.zoom), !0), GG(t, e), !0) : wB(t, e);
  };
}
function wB(e, t, n) {
  return EB(e, fD, t);
}
function GG(e, t, n) {
  return EB(e, ["nw", "ne", "sw", "se"], t);
}
var wo = {
  name: "draggable",
  props: {
    draggable: Boolean,
    throttleDrag: Number,
    throttleDragRotate: Number,
    startDragRotate: Number,
    edgeDraggable: Boolean
  },
  events: {
    onDragStart: "dragStart",
    onDrag: "drag",
    onDragEnd: "dragEnd",
    onDragGroupStart: "dragGroupStart",
    onDragGroup: "dragGroup",
    onDragGroupEnd: "dragGroupEnd"
  },
  requestStyle: function() {
    return ["left", "top", "right", "bottom"];
  },
  render: function(e, t) {
    var n = e.props, r = n.throttleDragRotate, a = n.zoom, s = e.getState(), l = s.dragInfo, p = s.beforeOrigin;
    if (!r || !l)
      return [];
    var h = l.dist;
    if (!h[0] && !h[1])
      return [];
    var y = Jl(h), b = mi(h, [0, 0]);
    return [/* @__PURE__ */ He("div", {
      className: $t("line", "horizontal", "dragline", "dashed"),
      style: {
        width: "".concat(y, "px"),
        transform: "translate(".concat(p[0], "px, ").concat(p[1], "px) rotate(").concat(b, "rad) scaleY(").concat(a, ")")
      }
    }, "dragRotateGuideline")];
  },
  dragStart: function(e, t) {
    var n = t.datas, r = t.parentEvent, a = t.parentGesto, s = e.state, l = s.gestos, p = s.style;
    if (l.draggable)
      return !1;
    l.draggable = a || e.targetGesto, n.datas = {}, n.left = parseFloat(p.left || "") || 0, n.top = parseFloat(p.top || "") || 0, n.bottom = parseFloat(p.bottom || "") || 0, n.right = parseFloat(p.right || "") || 0, n.startValue = [0, 0], rg(e, t), Wx(t, "translate"), UG(e, n), n.prevDist = [0, 0], n.prevBeforeDist = [0, 0], n.isDrag = !1, n.deltaOffset = [0, 0];
    var h = En(e, t, we({
      set: function(b) {
        n.startValue = b;
      }
    }, jx(t))), y = r || St(e, "onDragStart", h);
    return y !== !1 ? (n.isDrag = !0, e.state.dragInfo = {
      startRect: e.getRect(),
      dist: [0, 0]
    }) : (l.draggable = null, n.isPinch = !1), n.isDrag ? h : !1;
  },
  drag: function(e, t) {
    if (!!t) {
      Ux(t, "translate");
      var n = t.datas, r = t.parentEvent, a = t.parentFlag, s = t.isPinch, l = t.isRequest, p = t.deltaOffset, h = t.distX, y = t.distY, b = n.isDrag, E = n.prevDist, x = n.prevBeforeDist, C = n.startValue;
      if (!!b) {
        p && (h += p[0], y += p[1]);
        var T = e.props, O = T.parentMoveable, D = r ? 0 : T.throttleDrag || 0, A = r ? 0 : T.throttleDragRotate || 0, B = 0, I = !1, L = !1, k = !1, $ = !1;
        if (!r && A > 0 && (h || y)) {
          var U = T.startDragRotate || 0, K = hn(U + mi([0, 0], [h, y]) * 180 / Math.PI, A) - U, X = y * Math.abs(Math.cos((K - 90) / 180 * Math.PI)), Y = h * Math.abs(Math.cos(K / 180 * Math.PI)), J = Jl([Y, X]);
          B = K * Math.PI / 180, h = J * Math.cos(B), y = J * Math.sin(B);
        }
        if (!s && !r && !a && (!A || h || y)) {
          var Q = TG(e, h, y, A, l || p, n), Z = Q[0], se = Q[1];
          I = Z.isSnap, L = Z.isBound, k = se.isSnap, $ = se.isBound;
          var pe = Z.offset, be = se.offset;
          h += pe, y += be;
        }
        var _e = On(VL({
          datas: n,
          distX: h,
          distY: y
        }), C), Se = On(TW({
          datas: n,
          distX: h,
          distY: y
        }), C);
        jN(Se, Ro), jN(_e, Ro), A || (!I && !L && (Se[0] = hn(Se[0], D), _e[0] = hn(_e[0], D)), !k && !$ && (Se[1] = hn(Se[1], D), _e[1] = hn(_e[1], D)));
        var Oe = Bt(_e, C), re = Bt(Se, C), ie = Bt(re, E), ce = Bt(Oe, x);
        n.prevDist = re, n.prevBeforeDist = Oe, n.passDelta = ie, n.passDist = re;
        var le = n.left + Oe[0], fe = n.top + Oe[1], ve = n.right - Oe[0], ee = n.bottom - Oe[1], Ae = Vx(n, "translate(".concat(Se[0], "px, ").concat(Se[1], "px)"), "translate(".concat(re[0], "px, ").concat(re[1], "px)"));
        if (pD(t, Ae), e.state.dragInfo.dist = r ? [0, 0] : re, !(!r && !O && ie.every(function(oe) {
          return !oe;
        }) && ce.some(function(oe) {
          return !oe;
        }))) {
          var he = e.state, Fe = he.width, Ne = he.height, xe = En(e, t, we({
            transform: Ae,
            dist: re,
            delta: ie,
            translate: Se,
            beforeDist: Oe,
            beforeDelta: ce,
            beforeTranslate: _e,
            left: le,
            top: fe,
            right: ve,
            bottom: ee,
            width: Fe,
            height: Ne,
            isPinch: s
          }, Xs({
            transform: Ae
          }, t)));
          return !r && St(e, "onDrag", xe), xe;
        }
      }
    }
  },
  dragAfter: function(e, t) {
    var n = t.datas, r = n.deltaOffset;
    return r[0] || r[1] ? (n.deltaOffset = [0, 0], this.drag(e, we(we({}, t), {
      deltaOffset: r
    }))) : !1;
  },
  dragEnd: function(e, t) {
    var n = t.parentEvent, r = t.datas;
    if (e.state.dragInfo = null, !!r.isDrag) {
      r.isDrag = !1;
      var a = nu(e, t, {});
      return !n && St(e, "onDragEnd", a), a;
    }
  },
  dragGroupStart: function(e, t) {
    var n = t.datas, r = t.clientX, a = t.clientY, s = this.dragStart(e, t);
    if (!s)
      return !1;
    var l = KR(e, this, "dragStart", [r || 0, a || 0], t, !1, "draggable"), p = we(we({}, s), {
      targets: e.props.targets,
      events: l
    }), h = St(e, "onDragGroupStart", p);
    return n.isDrag = h !== !1, n.isDrag ? s : !1;
  },
  dragGroup: function(e, t) {
    var n = t.datas;
    if (!!n.isDrag) {
      var r = this.drag(e, t), a = t.datas.passDelta, s = KR(e, this, "drag", a, t, !1, "draggable");
      if (!!r) {
        var l = we({
          targets: e.props.targets,
          events: s
        }, r);
        return St(e, "onDragGroup", l), l;
      }
    }
  },
  dragGroupEnd: function(e, t) {
    var n = t.isDrag, r = t.datas;
    if (!!r.isDrag) {
      this.dragEnd(e, t);
      var a = KR(e, this, "dragEnd", [0, 0], t, !1, "draggable");
      return St(e, "onDragGroupEnd", nu(e, t, {
        targets: e.props.targets,
        events: a
      })), n;
    }
  },
  request: function(e) {
    var t = {}, n = e.getRect(), r = 0, a = 0;
    return {
      isControl: !1,
      requestStart: function() {
        return {
          datas: t
        };
      },
      request: function(s) {
        return "x" in s ? r = s.x - n.left : "deltaX" in s && (r += s.deltaX), "y" in s ? a = s.y - n.top : "deltaY" in s && (a += s.deltaY), {
          datas: t,
          distX: r,
          distY: a
        };
      },
      requestEnd: function() {
        return {
          datas: t,
          isDrag: !0
        };
      }
    };
  },
  unset: function(e) {
    e.state.gestos.draggable = null, e.state.dragInfo = null;
  }
}, lk = yD("resizable"), eO = {
  name: "resizable",
  ableGroup: "size",
  canPinch: !0,
  props: {
    resizable: Boolean,
    throttleResize: Number,
    renderDirections: Array,
    keepRatio: Boolean,
    resizeFormat: Function,
    keepRatioFinally: Boolean,
    edge: Boolean
  },
  events: {
    onResizeStart: "resizeStart",
    onBeforeResize: "beforeResize",
    onResize: "resize",
    onResizeEnd: "resizeEnd",
    onResizeGroupStart: "resizeGroupStart",
    onBeforeResizeGroup: "beforeResizeGroup",
    onResizeGroup: "resizeGroup",
    onResizeGroupEnd: "resizeGroupEnd"
  },
  render: SB("resizable"),
  dragControlCondition: lk,
  viewClassName: mD("resizable"),
  dragControlStart: function(e, t) {
    var n, r = t.inputEvent, a = t.isPinch, s = t.isGroup, l = t.parentDirection, p = t.parentGesto, h = t.datas, y = t.parentFixedDirection, b = t.parentEvent, E = rB(l, a, r, h), x = e.state, C = x.target, T = x.width, O = x.height, D = x.gestos;
    if (!E || !C || D.resizable)
      return !1;
    D.resizable = p || e.controlGesto, !a && rg(e, t), h.datas = {}, h.direction = E, h.startOffsetWidth = T, h.startOffsetHeight = O, h.prevWidth = 0, h.prevHeight = 0, h.minSize = [0, 0], h.startWidth = x.cssWidth, h.startHeight = x.cssHeight, h.maxSize = [1 / 0, 1 / 0], s || (h.minSize = [x.minOffsetWidth, x.minOffsetHeight], h.maxSize = [x.maxOffsetWidth, x.maxOffsetHeight]);
    var A = e.props.transformOrigin || "% %";
    h.transformOrigin = A && tc(A) ? A.split(" ") : A, h.startOffsetMatrix = x.offsetMatrix, h.startTransformOrigin = x.transformOrigin, h.isWidth = (n = t == null ? void 0 : t.parentIsWidth) !== null && n !== void 0 ? n : !E[0] && !E[1] || E[0] || !E[1];
    function B(X) {
      h.ratio = X && isFinite(X) ? X : 0;
    }
    h.startPositions = is(e.state);
    function I(X) {
      h.fixedDirection = X, h.fixedPosition = gi(h.startPositions, X);
    }
    function L(X) {
      var Y = e.state, J = Y.width, Q = Y.height;
      h.fixedPosition = X, h.fixedDirection = YL(X, J, Q);
    }
    function k(X) {
      h.minSize = [wr("".concat(X[0]), 0) || 0, wr("".concat(X[1]), 0) || 0];
    }
    function $(X) {
      var Y = [X[0] || 1 / 0, X[1] || 1 / 0];
      (!UN(Y[0]) || isFinite(Y[0])) && (Y[0] = wr("".concat(Y[0]), 0) || 1 / 0), (!UN(Y[1]) || isFinite(Y[1])) && (Y[1] = wr("".concat(Y[1]), 0) || 1 / 0), h.maxSize = Y;
    }
    B(T / O), I(y || [-E[0], -E[1]]), h.setFixedDirection = I, h.setFixedPosition = L, h.setMin = k, h.setMax = $;
    var U = En(e, t, {
      direction: E,
      startRatio: h.ratio,
      set: function(X) {
        var Y = X[0], J = X[1];
        h.startWidth = Y, h.startHeight = J;
      },
      setMin: k,
      setMax: $,
      setRatio: B,
      setFixedDirection: I,
      setFixedPosition: L,
      setOrigin: function(X) {
        h.transformOrigin = X;
      },
      dragStart: wo.dragStart(e, new my().dragStart([0, 0], t))
    }), K = b || St(e, "onResizeStart", U);
    return h.startFixedDirection = h.fixedDirection, h.startFixedPosition = h.fixedPosition, K !== !1 && (h.isResize = !0, e.state.snapRenderInfo = {
      request: t.isRequest,
      direction: E
    }), h.isResize ? U : !1;
  },
  dragControl: function(e, t) {
    var n, r = t.datas, a = t.parentFlag, s = t.isPinch, l = t.parentKeepRatio, p = t.dragClient, h = t.parentDist, y = t.isRequest, b = t.isGroup, E = t.parentEvent, x = t.resolveMatrix, C = r.isResize, T = r.transformOrigin, O = r.startWidth, D = r.startHeight, A = r.prevWidth, B = r.prevHeight, I = r.minSize, L = r.maxSize, k = r.ratio, $ = r.startOffsetWidth, U = r.startOffsetHeight, K = r.isWidth;
    if (!C)
      return;
    if (x) {
      var X = e.state.is3d, Y = r.startOffsetMatrix, J = r.startTransformOrigin, Q = X ? 4 : 3, Z = $x(WL(t)), se = Math.sqrt(Z.length);
      Q !== se && (Z = tf(Z, se, Q));
      var pe = Wb(Y, Z, J, Q), be = Jp(pe, $, U, Q);
      r.startPositions = be, r.nextTargetMatrix = Z, r.nextAllMatrix = pe;
    }
    var _e = Zh(e.props, "resizable"), Se = _e.resizeFormat, Oe = _e.throttleResize, re = Oe === void 0 ? a ? 0 : 1 : Oe, ie = _e.parentMoveable, ce = _e.keepRatioFinally, le = r.direction, fe = le, ve = 0, ee = 0;
    !le[0] && !le[1] && (fe = [1, 1]);
    var Ae = k && (l != null ? l : _e.keepRatio) || !1;
    function he() {
      var Kt = r.fixedDirection, ft = cB(fe, Ae, r, t);
      ve = ft.distWidth, ee = ft.distHeight;
      var Gt = fe[0] - Kt[0] || Ae ? Math.max($ + ve, Ro) : $, xn = fe[1] - Kt[1] || Ae ? Math.max(U + ee, Ro) : U;
      return Ae && $ && U && (K ? xn = Gt / k : Gt = xn * k), [Gt, xn];
    }
    var Fe = he(), Ne = Fe[0], xe = Fe[1];
    E || (r.setFixedDirection(r.fixedDirection), St(e, "onBeforeResize", En(e, t, {
      startFixedDirection: r.startFixedDirection,
      startFixedPosition: r.startFixedPosition,
      setFixedDirection: function(Kt) {
        var ft;
        return r.setFixedDirection(Kt), ft = he(), Ne = ft[0], xe = ft[1], [Ne, xe];
      },
      setFixedPosition: function(Kt) {
        var ft;
        return r.setFixedPosition(Kt), ft = he(), Ne = ft[0], xe = ft[1], [Ne, xe];
      },
      boundingWidth: Ne,
      boundingHeight: xe,
      setSize: function(Kt) {
        Ne = Kt[0], xe = Kt[1];
      }
    }, !0)));
    var oe = p;
    p || (!a && s ? oe = XL(e, [0, 0]) : oe = r.fixedPosition);
    var it = [0, 0];
    s || (it = FG(e, Ne, xe, le, oe, y, r)), h && (!h[0] && (it[0] = 0), !h[1] && (it[1] = 0));
    function Le() {
      var Kt;
      Se && (Kt = Se([Ne, xe]), Ne = Kt[0], xe = Kt[1]), Ne = hn(Ne, re), xe = hn(xe, re);
    }
    if (Ae) {
      fe[0] && fe[1] && it[0] && it[1] && (Math.abs(it[0]) > Math.abs(it[1]) ? it[1] = 0 : it[0] = 0);
      var qe = !it[0] && !it[1];
      qe && Le(), fe[0] && !fe[1] || it[0] && !it[1] || qe && K ? (Ne += it[0], xe = Ne / k) : (!fe[0] && fe[1] || !it[0] && it[1] || qe && !K) && (xe += it[1], Ne = xe * k);
    } else
      Ne += it[0], xe += it[1], Ne = Math.max(0, Ne), xe = Math.max(0, xe);
    n = SL([Ne, xe], I, L, Ae ? k : !1), Ne = n[0], xe = n[1], Le(), Ae && (b || ce) && (K ? xe = Ne / k : Ne = xe * k), ve = Ne - $, ee = xe - U;
    var Tt = [ve - A, ee - B];
    r.prevWidth = ve, r.prevHeight = ee;
    var Qe = LW(e, Ne, xe, oe, T, r);
    if (!(!ie && Tt.every(function(Kt) {
      return !Kt;
    }) && Qe.every(function(Kt) {
      return !Kt;
    }))) {
      var pt = wo.drag(e, jb(t, e.state, Qe, !!s, !1, "draggable")), en = pt.transform, wt = O + ve, tn = D + ee, Vn = En(e, t, we({
        width: wt,
        height: tn,
        offsetWidth: Math.round(Ne),
        offsetHeight: Math.round(xe),
        startRatio: k,
        boundingWidth: Ne,
        boundingHeight: xe,
        direction: le,
        dist: [ve, ee],
        delta: Tt,
        isPinch: !!s,
        drag: pt
      }, aB({
        style: {
          width: "".concat(wt, "px"),
          height: "".concat(tn, "px")
        },
        transform: en
      }, pt, t)));
      return !E && St(e, "onResize", Vn), Vn;
    }
  },
  dragControlAfter: function(e, t) {
    var n = t.datas, r = n.isResize, a = n.startOffsetWidth, s = n.startOffsetHeight, l = n.prevWidth, p = n.prevHeight;
    if (!!r) {
      var h = e.state, y = h.width, b = h.height, E = y - (a + l), x = b - (s + p), C = Math.abs(E) > 3, T = Math.abs(x) > 3;
      if (C && (n.startWidth += E, n.startOffsetWidth += E, n.prevWidth += E), T && (n.startHeight += x, n.startOffsetHeight += x, n.prevHeight += x), C || T)
        return this.dragControl(e, t);
    }
  },
  dragControlEnd: function(e, t) {
    var n = t.datas, r = t.parentEvent;
    if (!!n.isResize) {
      n.isResize = !1;
      var a = nu(e, t, {});
      return !r && St(e, "onResizeEnd", a), a;
    }
  },
  dragGroupControlCondition: lk,
  dragGroupControlStart: function(e, t) {
    var n = t.datas, r = this.dragControlStart(e, we(we({}, t), {
      isGroup: !0
    }));
    if (!r)
      return !1;
    var a = ec(e, "resizable", t);
    function s(T, O) {
      var D = n.fixedDirection, A = n.fixedPosition, B = O.datas.startPositions || is(T.state), I = gi(B, D), L = $a(gy(-e.rotation / 180 * Math.PI, 3), [I[0] - A[0], I[1] - A[1], 1], 3), k = L[0], $ = L[1];
      return O.datas.originalX = k, O.datas.originalY = $, O;
    }
    var l = n.startOffsetWidth, p = n.startOffsetHeight;
    function h() {
      var T = n.minSize;
      a.forEach(function(O) {
        var D = O.datas, A = D.minSize, B = D.startOffsetWidth, I = D.startOffsetHeight, L = l * (B ? A[0] / B : 0), k = p * (I ? A[1] / I : 0);
        T[0] = Math.max(T[0], L), T[1] = Math.max(T[1], k);
      });
    }
    function y() {
      var T = n.maxSize;
      a.forEach(function(O) {
        var D = O.datas, A = D.maxSize, B = D.startOffsetWidth, I = D.startOffsetHeight, L = l * (B ? A[0] / B : 0), k = p * (I ? A[1] / I : 0);
        T[0] = Math.min(T[0], L), T[1] = Math.min(T[1], k);
      });
    }
    var b = gd(e, this, "dragControlStart", t, function(T, O) {
      return s(T, O);
    });
    h(), y();
    var E = function(T) {
      r.setFixedDirection(T), b.forEach(function(O, D) {
        O.setFixedDirection(T), s(O.moveable, a[D]);
      });
    };
    n.setFixedDirection = E;
    var x = we(we({}, r), {
      targets: e.props.targets,
      events: b.map(function(T) {
        return we(we({}, T), {
          setMin: function(O) {
            T.setMin(O), h();
          },
          setMax: function(O) {
            T.setMax(O), y();
          }
        });
      }),
      setFixedDirection: E,
      setMin: function(T) {
        r.setMin(T), h();
      },
      setMax: function(T) {
        r.setMax(T), y();
      }
    }), C = St(e, "onResizeGroupStart", x);
    return n.isResize = C !== !1, n.isResize ? r : !1;
  },
  dragGroupControl: function(e, t) {
    var n = t.datas;
    if (!!n.isResize) {
      var r = Zh(e.props, "resizable");
      Hx(e, "onBeforeResize", function(C) {
        St(e, "onBeforeResizeGroup", En(e, t, we(we({}, C), {
          targets: r.targets
        }), !0));
      });
      var a = this.dragControl(e, we(we({}, t), {
        isGroup: !0
      }));
      if (!!a) {
        var s = a.boundingWidth, l = a.boundingHeight, p = a.dist, h = r.keepRatio, y = [s / (s - p[0]), l / (l - p[1])], b = n.fixedPosition, E = gd(e, this, "dragControl", t, function(C, T) {
          var O = $a(gy(e.rotation / 180 * Math.PI, 3), [T.datas.originalX * y[0], T.datas.originalY * y[1], 1], 3), D = O[0], A = O[1];
          return we(we({}, T), {
            parentDist: null,
            parentScale: y,
            dragClient: On(b, [D, A]),
            parentKeepRatio: h
          });
        }), x = we({
          targets: r.targets,
          events: E
        }, a);
        return St(e, "onResizeGroup", x), x;
      }
    }
  },
  dragGroupControlEnd: function(e, t) {
    var n = t.isDrag, r = t.datas;
    if (!!r.isResize) {
      this.dragControlEnd(e, t);
      var a = gd(e, this, "dragControlEnd", t), s = nu(e, t, {
        targets: e.props.targets,
        events: a
      });
      return St(e, "onResizeGroupEnd", s), n;
    }
  },
  request: function(e) {
    var t = {}, n = 0, r = 0, a = e.getRect();
    return {
      isControl: !0,
      requestStart: function(s) {
        var l;
        return {
          datas: t,
          parentDirection: s.direction || [1, 1],
          parentIsWidth: (l = s == null ? void 0 : s.horizontal) !== null && l !== void 0 ? l : !0
        };
      },
      request: function(s) {
        return "offsetWidth" in s ? n = s.offsetWidth - a.offsetWidth : "deltaWidth" in s && (n += s.deltaWidth), "offsetHeight" in s ? r = s.offsetHeight - a.offsetHeight : "deltaHeight" in s && (r += s.deltaHeight), {
          datas: t,
          parentDist: [n, r],
          parentKeepRatio: s.keepRatio
        };
      },
      requestEnd: function() {
        return {
          datas: t,
          isDrag: !0
        };
      }
    };
  },
  unset: function(e) {
    e.state.gestos.resizable = null;
  }
};
function QR(e, t, n, r, a) {
  var s = e.props.groupable, l = e.state, p = l.is3d ? 4 : 3, h = t.origin, y = Yi(
    e.state.rootMatrix,
    Bt([h[0], h[1]], s ? [0, 0] : [l.left, l.top]),
    p
  ), b = On([a.left, a.top], y);
  t.startAbsoluteOrigin = b, t.prevDeg = mi(b, [n, r]) / Math.PI * 180, t.defaultDeg = t.prevDeg, t.prevSnapDeg = 0, t.loop = 0, t.startDist = Qu(b, [n, r]);
}
function zE(e, t, n) {
  var r = n.defaultDeg, a = n.prevDeg, s = a % 360, l = Math.floor(a / 360);
  s < 0 && (s += 360), s > e && s > 270 && e < 90 ? ++l : s < e && s < 90 && e > 270 && --l;
  var p = t * (l * 360 + e - r);
  return n.prevDeg = r + p, p;
}
function ZR(e, t, n, r) {
  return zE(mi(r.startAbsoluteOrigin, [e, t]) / Math.PI * 180, n, r);
}
function JR(e, t, n, r, a, s) {
  var l = e.props.throttleRotate, p = l === void 0 ? 0 : l, h = n.prevSnapDeg, y = 0, b = !1;
  if (s) {
    var E = zG(e, t, r);
    b = E.isSnap, y = a + E.rotation;
  }
  b || (y = hn(a + r, p));
  var x = y - a;
  return n.prevSnapDeg = x, [x - h, x, y];
}
function CB(e, t, n) {
  var r = t[0], a = t[1], s = t[2], l = t[3];
  if (e === "none")
    return [];
  if (Ki(e))
    return e.map(function(O) {
      return CB(O, [r, a, s, l], n)[0];
    });
  var p = (e || "top").split("-"), h = p[0], y = p[1], b = [r, a];
  h === "left" ? b = [s, r] : h === "right" ? b = [a, l] : h === "bottom" && (b = [l, s]);
  var E = [(b[0][0] + b[1][0]) / 2, (b[0][1] + b[1][1]) / 2], x = tB(b, n);
  if (y) {
    var C = y === "top" || y === "left", T = h === "bottom" || h === "left";
    E = b[C && !T || !C && T ? 0 : 1];
  }
  return [[E, x]];
}
function tO(e, t) {
  if (t.isRequest)
    return t.requestAble === "rotatable";
  var n = t.inputEvent.target;
  if (Ui(n, $t("rotation-control")) || Ui(n, $t("around-control")) || Ui(n, $t("control")) && Ui(n, $t("rotatable")))
    return !0;
  var r = e.props.rotationTarget;
  return r ? bD(r, !0).some(function(a) {
    return a ? n === a || n.contains(a) : !1;
  }) : !1;
}
var HG = fD.map(function(e) {
  var t = "", n = "", r = "center", a = "center";
  return e.indexOf("n") > -1 && (t = "top: -20px;", a = "bottom"), e.indexOf("s") > -1 && (t = "top: 0px;", a = "top"), e.indexOf("w") > -1 && (n = "left: -20px;", r = "right"), e.indexOf("e") > -1 && (n = "left: 0px;", r = "left"), '.around-control[data-direction*="'.concat(e, `"] {
        `).concat(n).concat(t, `
        transform-origin: `).concat(r, " ").concat(a, `;
    }`);
}).join(`
`), YG = `.rotation {
    position: absolute;
    height: 40px;
    width: 1px;
    transform-origin: 50% 100%;
    height: calc(40px * var(--zoom));
    top: auto;
    left: 0;
    bottom: 100%;
    will-change: transform;
}
.rotation .rotation-line {
    display: block;
    width: 100%;
    height: 100%;
    transform-origin: 50% 50%;
}
.rotation .rotation-control {
    border-color: #4af;
    border-color: var(--moveable-color);
    background:#fff;
    cursor: alias;
}
:global .view-rotation-dragging, .rotatable.direction.control {
    cursor: alias;
}
.around-control {
    position: absolute;
    will-change: transform;
    width: 20px;
    height: 20px;
    left: -10px;
    top: -10px;
    box-sizing: border-box;
    background: transparent;
    z-index: 8;
    cursor: alias;
    transform-origin: center center;
}
.rotatable.direction.control.move {
    cursor: move;
}
`.concat(HG, `
`), qG = {
  name: "rotatable",
  canPinch: !0,
  props: {
    rotatable: Boolean,
    rotationPosition: String,
    throttleRotate: Number,
    renderDirections: Object,
    rotationTarget: Object,
    rotateAroundControls: Boolean,
    edge: Boolean,
    resolveAblesWithRotatable: Object
  },
  events: {
    onRotateStart: "rotateStart",
    onBeforeRotate: "beforeRotate",
    onRotate: "rotate",
    onRotateEnd: "rotateEnd",
    onRotateGroupStart: "rotateGroupStart",
    onBeforeRotateGroup: "beforeRotateGroup",
    onRotateGroup: "rotateGroup",
    onRotateGroupEnd: "rotateGroupEnd"
  },
  css: [YG],
  viewClassName: function(e) {
    return e.isDragging("rotatable") ? $t("view-rotation-dragging") : "";
  },
  render: function(e, t) {
    var n = Zh(e.props, "rotatable"), r = n.rotatable, a = n.rotationPosition, s = n.zoom, l = n.renderDirections, p = n.rotateAroundControls, h = n.resolveAblesWithRotatable, y = e.getState(), b = y.renderPoses, E = y.direction;
    if (!r)
      return null;
    var x = CB(a, b, E), C = [];
    if (x.forEach(function(A, B) {
      var I = A[0], L = A[1];
      C.push(/* @__PURE__ */ qi("div", {
        className: $t("rotation"),
        style: {
          transform: "translate(-50%) translate(".concat(I[0], "px, ").concat(I[1], "px) rotate(").concat(L, "rad)")
        },
        children: [/* @__PURE__ */ He("div", {
          className: $t("line rotation-line"),
          style: {
            transform: "scaleX(".concat(s, ")")
          }
        }), /* @__PURE__ */ He("div", {
          className: $t("control rotation-control"),
          style: {
            transform: "translate(0.5px) scale(".concat(s, ")")
          }
        })]
      }, "rotation".concat(B)));
    }), l) {
      var T = Oy(h || {}), O = {};
      T.forEach(function(A) {
        h[A].forEach(function(B) {
          O[B] = A;
        });
      });
      var D = [];
      Ki(l) && (D = l.map(function(A) {
        var B = O[A];
        return {
          data: B ? {
            resolve: B
          } : {},
          classNames: B ? ["move"] : [],
          dir: A
        };
      })), C.push.apply(C, _B(e, "rotatable", D));
    }
    return p && C.push.apply(C, WG(e)), C;
  },
  dragControlCondition: tO,
  dragControlStart: function(e, t) {
    var n, r, a = t.datas, s = t.clientX, l = t.clientY, p = t.parentRotate, h = t.parentFlag, y = t.isPinch, b = t.isRequest, E = e.state, x = E.target, C = E.left, T = E.top, O = E.direction, D = E.beforeDirection, A = E.targetTransform, B = E.moveableClientRect, I = E.offsetMatrix, L = E.targetMatrix, k = E.allMatrix, $ = E.width, U = E.height;
    if (!b && !x)
      return !1;
    var K = e.getRect();
    a.rect = K, a.transform = A, a.left = C, a.top = T;
    var X = function(ve) {
      var ee = e.state, Ae = ee.allMatrix, he = ee.is3d, Fe = ee.width, Ne = ee.height, xe = YL(ve, Fe, Ne);
      a.fixedDirection = xe, a.fixedPosition = Yi(Ae, ve, he ? 4 : 3), ie && ie.setFixedPosition(ve);
    }, Y = function(ve) {
      a.fixedDirection = ve, a.fixedPosition = qL(e, ve), ie && ie.setFixedDirection(ve);
    }, J = s, Q = l;
    if (b || y || h) {
      var Z = p || 0;
      a.beforeInfo = {
        origin: K.beforeOrigin,
        prevDeg: Z,
        defaultDeg: Z,
        prevSnapDeg: 0,
        startDist: 0
      }, a.afterInfo = we(we({}, a.beforeInfo), {
        origin: K.origin
      }), a.absoluteInfo = we(we({}, a.beforeInfo), {
        origin: K.origin,
        startValue: Z
      });
    } else {
      var se = (r = t.inputEvent) === null || r === void 0 ? void 0 : r.target;
      if (se) {
        var pe = se.getAttribute("data-direction") || "", be = wW[pe];
        if (be) {
          a.isControl = !0, a.isAroundControl = Ui(se, $t("around-control")), a.controlDirection = be;
          var _e = se.getAttribute("data-resolve");
          _e && (a.resolveAble = _e);
          var Se = YW(E.rootMatrix, E.renderPoses, B);
          n = gi(Se, be), J = n[0], Q = n[1];
        }
      }
      a.beforeInfo = {
        origin: K.beforeOrigin
      }, a.afterInfo = {
        origin: K.origin
      }, a.absoluteInfo = {
        origin: K.origin,
        startValue: K.rotation
      };
      var Oe = X;
      X = function(ve) {
        var ee = E.is3d ? 4 : 3, Ae = On(RL(L, ee), ve), he = Ae[0], Fe = Ae[1], Ne = $a(I, Qh([he, Fe], ee)), xe = $a(k, Qh([ve[0], ve[1]], ee));
        Oe(ve);
        var oe = E.posDelta;
        a.beforeInfo.origin = Bt(Ne, oe), a.afterInfo.origin = Bt(xe, oe), a.absoluteInfo.origin = Bt(xe, oe), QR(e, a.beforeInfo, J, Q, B), QR(e, a.afterInfo, J, Q, B), QR(e, a.absoluteInfo, J, Q, B);
      }, Y = function(ve) {
        var ee = gi([[0, 0], [$, 0], [0, U], [$, U]], ve);
        X(ee);
      };
    }
    a.startClientX = J, a.startClientY = Q, a.direction = O, a.beforeDirection = D, a.startValue = 0, a.datas = {}, Wx(t, "rotate");
    var re = !1, ie = !1;
    if (a.isControl && a.resolveAble) {
      var ce = a.resolveAble;
      ce === "resizable" && (ie = eO.dragControlStart(e, we(we({}, new my("resizable").dragStart([0, 0], t)), {
        parentPosition: a.controlPosition,
        parentFixedPosition: a.fixedPosition
      })));
    }
    ie || (re = wo.dragStart(e, new my().dragStart([0, 0], t))), X(E.transformOrigin);
    var le = En(e, t, we(we({
      set: function(ve) {
        a.startValue = ve * Math.PI / 180;
      },
      setFixedDirection: Y,
      setFixedPosition: X
    }, jx(t)), {
      dragStart: re,
      resizeStart: ie
    })), fe = St(e, "onRotateStart", le);
    return a.isRotate = fe !== !1, E.snapRenderInfo = {
      request: t.isRequest
    }, a.isRotate ? le : !1;
  },
  dragControl: function(e, t) {
    var n, r, a, s = t.datas, l = t.clientDistX, p = t.clientDistY, h = t.parentRotate, y = t.parentFlag, b = t.isPinch, E = t.groupDelta, x = s.beforeDirection, C = s.beforeInfo, T = s.afterInfo, O = s.absoluteInfo, D = s.isRotate, A = s.startValue, B = s.rect, I = s.startClientX, L = s.startClientY;
    if (!!D) {
      Ux(t, "rotate");
      var k = RW(t), $ = x * k, U = e.props.parentMoveable, K = 0, X, Y, J = 0, Q, Z, se = 0, pe, be, _e = 180 / Math.PI * A, Se = O.startValue, Oe = !1, re = I + l, ie = L + p;
      if (!y && "parentDist" in t) {
        var ce = t.parentDist;
        X = ce, Q = ce, pe = ce;
      } else
        b || y ? (X = zE(h, x, C), Q = zE(h, $, T), pe = zE(h, $, O)) : (X = ZR(re, ie, x, C), Q = ZR(re, ie, $, T), pe = ZR(re, ie, $, O), Oe = !0);
      if (Y = _e + X, Z = _e + Q, be = Se + pe, St(e, "onBeforeRotate", En(e, t, {
        beforeRotation: Y,
        rotation: Z,
        absoluteRotation: be,
        setRotation: function(oe) {
          Q = oe - _e, X = Q, pe = Q;
        }
      }, !0)), n = JR(e, B, C, X, _e, Oe), K = n[0], X = n[1], Y = n[2], r = JR(e, B, T, Q, _e, Oe), J = r[0], Q = r[1], Z = r[2], a = JR(e, B, O, pe, Se, Oe), se = a[0], pe = a[1], be = a[2], !(!se && !J && !K && !U)) {
        var le = Vx(s, "rotate(".concat(Z, "deg)"), "rotate(".concat(Q, "deg)")), fe = IW(e, Q, s), ve = Bt(On(E || [0, 0], fe), s.prevInverseDist || [0, 0]);
        s.prevInverseDist = fe, s.requestValue = null;
        var ee = GL(e, le, ve, b, t), Ae = ee, he = Qu([re, ie], O.startAbsoluteOrigin) - O.startDist, Fe = void 0;
        if (s.resolveAble === "resizable") {
          var Ne = eO.dragControl(e, we(we({}, jb(t, e.state, [t.deltaX, t.deltaY], !!b, !1, "resizable")), {
            resolveMatrix: !0,
            parentDistance: he
          }));
          Ne && (Fe = Ne, Ae = aB(Ae, Ne, t));
        }
        var xe = En(e, t, we(we({
          delta: J,
          dist: Q,
          rotate: Z,
          rotation: Z,
          beforeDist: X,
          beforeDelta: K,
          beforeRotate: Y,
          beforeRotation: Y,
          absoluteDist: pe,
          absoluteDelta: se,
          absoluteRotate: be,
          absoluteRotation: be,
          isPinch: !!b,
          resize: Fe
        }, ee), Ae));
        return St(e, "onRotate", xe), xe;
      }
    }
  },
  dragControlAfter: function(e, t) {
    t.datas.requestValue;
  },
  dragControlEnd: function(e, t) {
    var n = t.datas;
    if (!!n.isRotate) {
      n.isRotate = !1;
      var r = nu(e, t, {});
      return St(e, "onRotateEnd", r), r;
    }
  },
  dragGroupControlCondition: tO,
  dragGroupControlStart: function(e, t) {
    var n = t.datas, r = e.state, a = r.left, s = r.top, l = r.beforeOrigin, p = this.dragControlStart(e, t);
    if (!p)
      return !1;
    p.set(n.beforeDirection * e.rotation);
    var h = gd(e, this, "dragControlStart", t, function(E, x) {
      var C = E.state, T = C.left, O = C.top, D = C.beforeOrigin, A = On(Bt([T, O], [a, s]), Bt(D, l));
      return x.datas.startGroupClient = A, x.datas.groupClient = A, we(we({}, x), {
        parentRotate: 0
      });
    }), y = we(we({}, p), {
      targets: e.props.targets,
      events: h
    }), b = St(e, "onRotateGroupStart", y);
    return n.isRotate = b !== !1, n.isRotate ? p : !1;
  },
  dragGroupControl: function(e, t) {
    var n = t.datas;
    if (!!n.isRotate) {
      Hx(e, "onBeforeRotate", function(y) {
        St(e, "onBeforeRotateGroup", En(e, t, we(we({}, y), {
          targets: e.props.targets
        }), !0));
      });
      var r = this.dragControl(e, t);
      if (!!r) {
        var a = n.beforeDirection, s = r.beforeDist, l = s / 180 * Math.PI, p = gd(e, this, "dragControl", t, function(y, b) {
          var E = b.datas.startGroupClient, x = b.datas.groupClient, C = x[0], T = x[1], O = Fb(E, l * a), D = O[0], A = O[1], B = [D - C, A - T];
          return b.datas.groupClient = [D, A], we(we({}, b), {
            parentRotate: s,
            groupDelta: B
          });
        });
        e.rotation = a * r.beforeRotation;
        var h = we({
          targets: e.props.targets,
          events: p,
          set: function(y) {
            e.rotation = y;
          },
          setGroupRotation: function(y) {
            e.rotation = y;
          }
        }, r);
        return St(e, "onRotateGroup", h), h;
      }
    }
  },
  dragGroupControlEnd: function(e, t) {
    var n = t.isDrag, r = t.datas;
    if (!!r.isRotate) {
      this.dragControlEnd(e, t);
      var a = gd(e, this, "dragControlEnd", t), s = nu(e, t, {
        targets: e.props.targets,
        events: a
      });
      return St(e, "onRotateGroupEnd", s), n;
    }
  },
  request: function(e) {
    var t = {}, n = 0, r = e.getRotation();
    return {
      isControl: !0,
      requestStart: function() {
        return {
          datas: t
        };
      },
      request: function(a) {
        return "deltaRotate" in a ? n += a.deltaRotate : "rotate" in a && (n = a.rotate - r), {
          datas: t,
          parentDist: n
        };
      },
      requestEnd: function() {
        return {
          datas: t,
          isDrag: !0
        };
      }
    };
  }
}, ck = yD("scalable"), XG = {
  name: "scalable",
  ableGroup: "size",
  canPinch: !0,
  props: {
    scalable: Boolean,
    throttleScale: Number,
    renderDirections: String,
    keepRatio: Boolean,
    edge: Boolean
  },
  events: {
    onScaleStart: "scaleStart",
    onBeforeScale: "beforeScale",
    onScale: "scale",
    onScaleEnd: "scaleEnd",
    onScaleGroupStart: "scaleGroupStart",
    onBeforeScaleGroup: "beforeScaleGroup",
    onScaleGroup: "scaleGroup",
    onScaleGroupEnd: "scaleGroupEnd"
  },
  render: SB("scalable"),
  dragControlCondition: ck,
  viewClassName: mD("scalable"),
  dragControlStart: function(e, t) {
    var n = t.datas, r = t.isPinch, a = t.inputEvent, s = t.parentDirection, l = rB(s, r, a, n), p = e.state, h = p.width, y = p.height, b = p.targetTransform, E = p.target, x = p.pos1, C = p.pos2, T = p.pos4;
    if (!l || !E)
      return !1;
    r || rg(e, t), n.datas = {}, n.transform = b, n.prevDist = [1, 1], n.direction = l, n.startOffsetWidth = h, n.startOffsetHeight = y, n.startValue = [1, 1];
    var O = Qu(x, C), D = Qu(C, T), A = !l[0] && !l[1] || l[0] || !l[1];
    n.scaleWidth = O, n.scaleHeight = D, n.scaleXRatio = O / h, n.scaleYRatio = D / y, Wx(t, "scale"), n.isWidth = A;
    function B($) {
      n.ratio = $ && isFinite($) ? $ : 0;
    }
    n.startPositions = is(e.state);
    function I($) {
      n.fixedDirection = $, n.fixedPosition = gi(n.startPositions, $);
    }
    n.setFixedDirection = I, B(Qu(x, C) / Qu(C, T)), I([-l[0], -l[1]]);
    var L = En(e, t, we(we({
      direction: l,
      set: function($) {
        n.startValue = $;
      },
      setRatio: B,
      setFixedDirection: I
    }, jx(t)), {
      dragStart: wo.dragStart(e, new my().dragStart([0, 0], t))
    })), k = St(e, "onScaleStart", L);
    return n.startFixedDirection = n.fixedDirection, k !== !1 && (n.isScale = !0, e.state.snapRenderInfo = {
      request: t.isRequest,
      direction: l
    }), n.isScale ? L : !1;
  },
  dragControl: function(e, t) {
    Ux(t, "scale");
    var n = t.datas, r = t.parentKeepRatio, a = t.parentFlag, s = t.isPinch, l = t.dragClient, p = t.isRequest, h = n.prevDist, y = n.direction, b = n.startOffsetWidth, E = n.startOffsetHeight, x = n.isScale, C = n.startValue, T = n.isWidth, O = n.ratio;
    if (!x)
      return !1;
    var D = e.props, A = D.throttleScale, B = D.parentMoveable, I = y;
    !y[0] && !y[1] && (I = [1, 1]);
    var L = O && (r != null ? r : D.keepRatio) || !1, k = e.state;
    function $() {
      var ie = cB(I, L, n, t), ce = ie.distWidth, le = ie.distHeight, fe = b ? (b + ce) / b : 1, ve = E ? (E + le) / E : 1;
      return fe = I[0] || L ? fe * C[0] : C[0], ve = I[1] || L ? ve * C[1] : C[1], fe === 0 && (fe = (h[0] > 0 ? 1 : -1) * vE), ve === 0 && (ve = (h[1] > 0 ? 1 : -1) * vE), [fe, ve];
    }
    var U = $();
    if (!s && e.props.groupable) {
      var K = k.snapRenderInfo || {}, X = K.direction;
      Ki(X) && (X[0] || X[1]) && (k.snapRenderInfo = {
        direction: y,
        request: t.isRequest
      });
    }
    St(e, "onBeforeScale", En(e, t, {
      scale: U,
      setFixedDirection: function(ie) {
        return n.setFixedDirection(ie), U = $(), U;
      },
      startFixedDirection: n.startFixedDirection,
      setScale: function(ie) {
        U = ie;
      }
    }, !0));
    var Y = [U[0] / C[0], U[1] / C[1]], J = l, Q = [0, 0];
    if (l || (!a && s ? J = XL(e, [0, 0]) : J = n.fixedPosition), s || (Q = $G(e, Y, y, p, n)), L) {
      I[0] && I[1] && Q[0] && Q[1] && (Math.abs(Q[0] * b) > Math.abs(Q[1] * E) ? Q[1] = 0 : Q[0] = 0);
      var Z = !Q[0] && !Q[1];
      if (Z && (T ? Y[0] = hn(Y[0] * C[0], A) / C[0] : Y[1] = hn(Y[1] * C[1], A) / C[1]), I[0] && !I[1] || Q[0] && !Q[1] || Z && T) {
        Y[0] += Q[0];
        var se = b * Y[0] * C[0] / O;
        Y[1] = se / E / C[1];
      } else if (!I[0] && I[1] || !Q[0] && Q[1] || Z && !T) {
        Y[1] += Q[1];
        var pe = E * Y[1] * C[1] * O;
        Y[0] = pe / b / C[0];
      }
    } else
      Y[0] += Q[0], Y[1] += Q[1], Q[0] || (Y[0] = hn(Y[0] * C[0], A) / C[0]), Q[1] || (Y[1] = hn(Y[1] * C[1], A) / C[1]);
    Y[0] === 0 && (Y[0] = (h[0] > 0 ? 1 : -1) * vE), Y[1] === 0 && (Y[1] = (h[1] > 0 ? 1 : -1) * vE);
    var be = [Y[0] / h[0], Y[1] / h[1]];
    U = zW(Y, C);
    var _e = kW(e, Y, n.fixedDirection, J, n), Se = Bt(_e, n.prevInverseDist || [0, 0]);
    if (n.prevDist = Y, n.prevInverseDist = _e, U[0] === h[0] && U[1] === h[1] && Se.every(function(ie) {
      return !ie;
    }) && !B)
      return !1;
    var Oe = Vx(n, "scale(".concat(U.join(", "), ")"), "scale(".concat(Y.join(", "), ")")), re = En(e, t, we({
      offsetWidth: b,
      offsetHeight: E,
      direction: y,
      scale: U,
      dist: Y,
      delta: be,
      isPinch: !!s
    }, GL(e, Oe, Se, s, t)));
    return St(e, "onScale", re), re;
  },
  dragControlEnd: function(e, t) {
    var n = t.datas;
    if (!n.isScale)
      return !1;
    n.isScale = !1;
    var r = nu(e, t, {});
    return St(e, "onScaleEnd", r), r;
  },
  dragGroupControlCondition: ck,
  dragGroupControlStart: function(e, t) {
    var n = t.datas, r = this.dragControlStart(e, t);
    if (!r)
      return !1;
    var a = ec(e, "resizable", t);
    function s(b, E) {
      var x = n.fixedDirection, C = n.fixedPosition, T = E.datas.startPositions || is(b.state), O = gi(T, x), D = $a(gy(-e.rotation / 180 * Math.PI, 3), [O[0] - C[0], O[1] - C[1], 1], 3), A = D[0], B = D[1];
      return E.datas.originalX = A, E.datas.originalY = B, E;
    }
    n.moveableScale = e.scale;
    var l = gd(e, this, "dragControlStart", t, function(b, E) {
      return s(b, E);
    }), p = function(b) {
      r.setFixedDirection(b), l.forEach(function(E, x) {
        E.setFixedDirection(b), s(E.moveable, a[x]);
      });
    };
    n.setFixedDirection = p;
    var h = we(we({}, r), {
      targets: e.props.targets,
      events: l,
      setFixedDirection: p
    }), y = St(e, "onScaleGroupStart", h);
    return n.isScale = y !== !1, n.isScale ? h : !1;
  },
  dragGroupControl: function(e, t) {
    var n = t.datas;
    if (!!n.isScale) {
      Hx(e, "onBeforeScale", function(E) {
        St(e, "onBeforeScaleGroup", En(e, t, we(we({}, E), {
          targets: e.props.targets
        }), !0));
      });
      var r = this.dragControl(e, t);
      if (!!r) {
        var a = n.moveableScale;
        e.scale = [r.scale[0] * a[0], r.scale[1] * a[1]];
        var s = e.props.keepRatio, l = r.dist, p = r.scale, h = n.fixedPosition, y = gd(e, this, "dragControl", t, function(E, x) {
          var C = $a(gy(e.rotation / 180 * Math.PI, 3), [x.datas.originalX * l[0], x.datas.originalY * l[1], 1], 3), T = C[0], O = C[1];
          return we(we({}, x), {
            parentDist: null,
            parentScale: p,
            parentKeepRatio: s,
            dragClient: On(h, [T, O])
          });
        }), b = we({
          targets: e.props.targets,
          events: y
        }, r);
        return St(e, "onScaleGroup", b), b;
      }
    }
  },
  dragGroupControlEnd: function(e, t) {
    var n = t.isDrag, r = t.datas;
    if (!!r.isScale) {
      this.dragControlEnd(e, t);
      var a = gd(e, this, "dragControlEnd", t), s = nu(e, t, {
        targets: e.props.targets,
        events: a
      });
      return St(e, "onScaleGroupEnd", s), n;
    }
  },
  request: function() {
    var e = {}, t = 0, n = 0;
    return {
      isControl: !0,
      requestStart: function(r) {
        return {
          datas: e,
          parentDirection: r.direction || [1, 1]
        };
      },
      request: function(r) {
        return t += r.deltaWidth, n += r.deltaHeight, {
          datas: e,
          parentDist: [t, n],
          parentKeepRatio: r.keepRatio
        };
      },
      requestEnd: function() {
        return {
          datas: e,
          isDrag: !0
        };
      }
    };
  }
};
function Fp(e, t) {
  return e.map(function(n, r) {
    return kh(n, t[r], 1, 2);
  });
}
function fk(e, t, n) {
  var r = mi(e, t), a = mi(e, n), s = a - r;
  return s >= 0 ? s : s + 2 * Math.PI;
}
function KG(e, t) {
  var n = fk(e[0], e[1], e[2]), r = fk(t[0], t[1], t[2]), a = Math.PI;
  return !(n >= a && r <= a || n <= a && r >= a);
}
var QG = {
  name: "warpable",
  ableGroup: "size",
  props: {
    warpable: Boolean,
    renderDirections: Array,
    edge: Boolean
  },
  events: {
    onWarpStart: "warpStart",
    onWarp: "warp",
    onWarpEnd: "warpEnd"
  },
  viewClassName: mD("warpable"),
  render: function(e, t) {
    var n = e.props, r = n.resizable, a = n.scalable, s = n.warpable, l = n.zoom;
    if (r || a || !s)
      return [];
    var p = e.state, h = p.pos1, y = p.pos2, b = p.pos3, E = p.pos4, x = Fp(h, y), C = Fp(y, h), T = Fp(h, b), O = Fp(b, h), D = Fp(b, E), A = Fp(E, b), B = Fp(y, E), I = Fp(E, y);
    return jt([/* @__PURE__ */ He("div", {
      className: $t("line"),
      style: K0(x, D, l)
    }, "middeLine1"), /* @__PURE__ */ He("div", {
      className: $t("line"),
      style: K0(C, A, l)
    }, "middeLine2"), /* @__PURE__ */ He("div", {
      className: $t("line"),
      style: K0(T, B, l)
    }, "middeLine3"), /* @__PURE__ */ He("div", {
      className: $t("line"),
      style: K0(O, I, l)
    }, "middeLine4")], wB(e, "warpable"), !0);
  },
  dragControlCondition: function(e, t) {
    if (t.isRequest)
      return !1;
    var n = t.inputEvent.target;
    return Ui(n, $t("direction")) && Ui(n, $t("warpable"));
  },
  dragControlStart: function(e, t) {
    var n = t.datas, r = t.inputEvent, a = e.props.target, s = r.target, l = iB(s, n);
    if (!l || !a)
      return !1;
    var p = e.state, h = p.transformOrigin, y = p.is3d, b = p.targetTransform, E = p.targetMatrix, x = p.width, C = p.height, T = p.left, O = p.top;
    n.datas = {}, n.targetTransform = b, n.warpTargetMatrix = y ? E : tf(E, 3, 4), n.targetInverseMatrix = CL(nc(n.warpTargetMatrix, 4), 3, 4), n.direction = l, n.left = T, n.top = O, n.poses = [[0, 0], [x, 0], [0, C], [x, C]].map(function(B) {
      return Bt(B, h);
    }), n.nextPoses = n.poses.map(function(B) {
      var I = B[0], L = B[1];
      return $a(n.warpTargetMatrix, [I, L, 0, 1], 4);
    }), n.startValue = Kr(4), n.prevMatrix = Kr(4), n.absolutePoses = is(p), n.posIndexes = jL(l), rg(e, t), Wx(t, "matrix3d"), p.snapRenderInfo = {
      request: t.isRequest,
      direction: l
    };
    var D = En(e, t, we({
      set: function(B) {
        n.startValue = B;
      }
    }, jx(t))), A = St(e, "onWarpStart", D);
    return A !== !1 && (n.isWarp = !0), n.isWarp;
  },
  dragControl: function(e, t) {
    var n = t.datas, r = t.isRequest, a = t.distX, s = t.distY, l = n.targetInverseMatrix, p = n.prevMatrix, h = n.isWarp, y = n.startValue, b = n.poses, E = n.posIndexes, x = n.absolutePoses;
    if (!h)
      return !1;
    if (Ux(t, "matrix3d"), My(e, "warpable")) {
      var C = E.map(function(X) {
        return x[X];
      });
      C.length > 1 && C.push([(C[0][0] + C[1][0]) / 2, (C[0][1] + C[1][1]) / 2]);
      var T = Xx(e, r, {
        horizontal: C.map(function(X) {
          return X[1] + s;
        }),
        vertical: C.map(function(X) {
          return X[0] + a;
        })
      }), O = T.horizontal, D = T.vertical;
      s -= O.offset, a -= D.offset;
    }
    var A = nf({
      datas: n,
      distX: a,
      distY: s
    }, !0), B = n.nextPoses.slice();
    if (E.forEach(function(X) {
      B[X] = On(B[X], A);
    }), !xW.every(function(X) {
      return KG(X.map(function(Y) {
        return b[Y];
      }), X.map(function(Y) {
        return B[Y];
      }));
    }))
      return !1;
    var I = oD(b[0], b[2], b[1], b[3], B[0], B[2], B[1], B[3]);
    if (!I.length)
      return !1;
    var L = yr(l, I, 4), k = UL(n, L, !0), $ = yr(nc(p, 4), k, 4);
    n.prevMatrix = k;
    var U = yr(y, k, 4), K = Vx(n, "matrix3d(".concat(U.join(", "), ")"), "matrix3d(".concat(k.join(", "), ")"));
    return pD(t, K), St(e, "onWarp", En(e, t, {
      delta: $,
      matrix: U,
      dist: k,
      multiply: yr,
      transform: K
    })), !0;
  },
  dragControlEnd: function(e, t) {
    var n = t.datas, r = t.isDrag;
    return n.isWarp ? (n.isWarp = !1, St(e, "onWarpEnd", nu(e, t, {})), r) : !1;
  }
}, ZG = /* @__PURE__ */ $t("area-pieces"), EE = /* @__PURE__ */ $t("area-piece"), RB = /* @__PURE__ */ $t("avoid"), JG = $t("view-dragging");
function eT(e) {
  var t = e.areaElement;
  if (!!t) {
    var n = e.state, r = n.width, a = n.height;
    wL(t, RB), t.style.cssText += "left: 0px; top: 0px; width: ".concat(r, "px; height: ").concat(a, "px");
  }
}
function dk(e) {
  return /* @__PURE__ */ qi("div", {
    className: ZG,
    children: [/* @__PURE__ */ He("div", {
      className: EE
    }), /* @__PURE__ */ He("div", {
      className: EE
    }), /* @__PURE__ */ He("div", {
      className: EE
    }), /* @__PURE__ */ He("div", {
      className: EE
    })]
  }, "area_pieces");
}
var TB = {
  name: "dragArea",
  props: {
    dragArea: Boolean,
    passDragArea: Boolean
  },
  events: {
    onClick: "click",
    onClickGroup: "clickGroup"
  },
  render: function(e, t) {
    var n = e.props, r = n.target, a = n.dragArea, s = n.groupable, l = n.passDragArea, p = e.getState(), h = p.width, y = p.height, b = p.renderPoses, E = l ? $t("area", "pass") : $t("area");
    if (s)
      return [/* @__PURE__ */ He("div", {
        ref: hd(e, "areaElement"),
        className: E
      }, "area"), dk()];
    if (!r || !a)
      return [];
    var x = oD([0, 0], [h, 0], [0, y], [h, y], b[0], b[1], b[2], b[3]), C = x.length ? Gx(x, !0) : "none";
    return [/* @__PURE__ */ He("div", {
      ref: hd(e, "areaElement"),
      className: E,
      style: {
        top: "0px",
        left: "0px",
        width: "".concat(h, "px"),
        height: "".concat(y, "px"),
        transformOrigin: "0 0",
        transform: C
      }
    }, "area"), dk()];
  },
  dragStart: function(e, t) {
    var n = t.datas, r = t.clientX, a = t.clientY, s = t.inputEvent;
    if (!s)
      return !1;
    n.isDragArea = !1;
    var l = e.areaElement, p = e.state, h = p.moveableClientRect, y = p.renderPoses, b = p.rootMatrix, E = p.is3d, x = h.left, C = h.top, T = el(y), O = T.left, D = T.top, A = T.width, B = T.height, I = E ? 4 : 3, L = iy(b, [r - x, a - C], I), k = L[0], $ = L[1];
    k -= O, $ -= D;
    var U = [{
      left: O,
      top: D,
      width: A,
      height: $ - 10
    }, {
      left: O,
      top: D,
      width: k - 10,
      height: B
    }, {
      left: O,
      top: D + $ + 10,
      width: A,
      height: B - $ - 10
    }, {
      left: O + k + 10,
      top: D,
      width: A - k - 10,
      height: B
    }], K = [].slice.call(l.nextElementSibling.children);
    U.forEach(function(X, Y) {
      K[Y].style.cssText = "left: ".concat(X.left, "px;top: ").concat(X.top, "px; width: ").concat(X.width, "px; height: ").concat(X.height, "px;");
    }), iD(l, RB), p.disableNativeEvent = !0;
  },
  drag: function(e, t) {
    var n = t.datas, r = t.inputEvent;
    if (this.enableNativeEvent(e), !r)
      return !1;
    n.isDragArea || (n.isDragArea = !0, eT(e));
  },
  dragEnd: function(e, t) {
    this.enableNativeEvent(e);
    var n = t.inputEvent, r = t.datas;
    if (!n)
      return !1;
    r.isDragArea || eT(e);
  },
  dragGroupStart: function(e, t) {
    return this.dragStart(e, t);
  },
  dragGroup: function(e, t) {
    return this.drag(e, t);
  },
  dragGroupEnd: function(e, t) {
    return this.dragEnd(e, t);
  },
  unset: function(e) {
    eT(e), e.state.disableNativeEvent = !1;
  },
  enableNativeEvent: function(e) {
    var t = e.state;
    t.disableNativeEvent && xL(function() {
      t.disableNativeEvent = !1;
    });
  }
}, eH = Vb("origin", {
  render: function(e, t) {
    var n = e.props.zoom, r = e.getState(), a = r.beforeOrigin, s = r.rotation;
    return [/* @__PURE__ */ He("div", {
      className: $t("control", "origin"),
      style: hD(s, n, a)
    }, "beforeOrigin")];
  }
});
function tH(e) {
  var t = e.scrollContainer;
  return [t.scrollLeft, t.scrollTop];
}
var nH = {
  name: "scrollable",
  canPinch: !0,
  props: {
    scrollable: Boolean,
    scrollContainer: Object,
    scrollThreshold: Number,
    scrollThrottleTime: Number,
    getScrollPosition: Function
  },
  events: {
    onScroll: "scroll",
    onScrollGroup: "scrollGroup"
  },
  dragRelation: "strong",
  dragStart: function(e, t) {
    var n = e.props, r = n.scrollContainer, a = r === void 0 ? e.getContainer() : r, s = new AL(), l = Jh(a, !0);
    t.datas.dragScroll = s;
    var p = t.isControl ? "controlGesto" : "targetGesto", h = t.targets;
    s.on("scroll", function(y) {
      var b = y.container, E = y.direction, x = En(e, t, {
        scrollContainer: b,
        direction: E
      }), C = h ? "onScrollGroup" : "onScroll";
      h && (x.targets = h), St(e, C, x);
    }).on("move", function(y) {
      var b = y.offsetX, E = y.offsetY, x = y.inputEvent;
      e[p].scrollBy(b, E, x.inputEvent, !1);
    }), s.dragStart(t, {
      container: l
    });
  },
  checkScroll: function(e, t) {
    var n = t.datas.dragScroll;
    if (!!n) {
      var r = e.props, a = r.scrollContainer, s = a === void 0 ? e.getContainer() : a, l = r.scrollThreshold, p = l === void 0 ? 0 : l, h = r.scrollThrottleTime, y = h === void 0 ? 0 : h, b = r.getScrollPosition, E = b === void 0 ? tH : b;
      return n.drag(t, {
        container: s,
        threshold: p,
        throttleTime: y,
        getScrollPosition: function(x) {
          return E({
            scrollContainer: x.container,
            direction: x.direction
          });
        }
      }), !0;
    }
  },
  drag: function(e, t) {
    return this.checkScroll(e, t);
  },
  dragEnd: function(e, t) {
    t.datas.dragScroll.dragEnd(), t.datas.dragScroll = null;
  },
  dragControlStart: function(e, t) {
    return this.dragStart(e, we(we({}, t), {
      isControl: !0
    }));
  },
  dragControl: function(e, t) {
    return this.drag(e, t);
  },
  dragControlEnd: function(e, t) {
    return this.dragEnd(e, t);
  },
  dragGroupStart: function(e, t) {
    return this.dragStart(e, we(we({}, t), {
      targets: e.props.targets
    }));
  },
  dragGroup: function(e, t) {
    return this.drag(e, we(we({}, t), {
      targets: e.props.targets
    }));
  },
  dragGroupEnd: function(e, t) {
    return this.dragEnd(e, we(we({}, t), {
      targets: e.props.targets
    }));
  },
  dragGroupControlStart: function(e, t) {
    return this.dragStart(e, we(we({}, t), {
      targets: e.props.targets,
      isControl: !0
    }));
  },
  dragGroupContro: function(e, t) {
    return this.drag(e, we(we({}, t), {
      targets: e.props.targets
    }));
  },
  dragGroupControEnd: function(e, t) {
    return this.dragEnd(e, we(we({}, t), {
      targets: e.props.targets
    }));
  }
}, OB = {
  name: "",
  props: {
    target: Object,
    dragTarget: Object,
    container: Object,
    portalContainer: Object,
    rootContainer: Object,
    useResizeObserver: Boolean,
    zoom: Number,
    transformOrigin: Array,
    edge: Object,
    ables: Array,
    className: String,
    pinchThreshold: Number,
    pinchOutside: Boolean,
    triggerAblesSimultaneously: Boolean,
    checkInput: Boolean,
    cspNonce: String,
    translateZ: Number,
    hideDefaultLines: Boolean,
    props: Object,
    flushSync: Function,
    stopPropagation: Boolean,
    preventClickEventOnDrag: Boolean,
    preventClickDefault: Boolean,
    viewContainer: Object,
    persistData: Object,
    firstRenderState: Object
  },
  events: {
    onChangeTargets: "changeTargets"
  }
}, rH = Vb("padding", {
  render: function(e, t) {
    var n = e.props;
    if (n.dragArea)
      return [];
    var r = n.padding || {}, a = r.left, s = a === void 0 ? 0 : a, l = r.top, p = l === void 0 ? 0 : l, h = r.right, y = h === void 0 ? 0 : h, b = r.bottom, E = b === void 0 ? 0 : b, x = e.getState(), C = x.renderPoses, T = x.pos1, O = x.pos2, D = x.pos3, A = x.pos4, B = [T, O, D, A], I = [];
    return s > 0 && I.push([0, 2]), p > 0 && I.push([0, 1]), y > 0 && I.push([1, 3]), E > 0 && I.push([2, 3]), I.map(function(L, k) {
      var $ = L[0], U = L[1], K = B[$], X = B[U], Y = C[$], J = C[U], Q = oD([0, 0], [100, 0], [0, 100], [100, 100], K, X, Y, J);
      if (!!Q.length)
        return /* @__PURE__ */ He("div", {
          className: $t("padding"),
          style: {
            transform: Gx(Q, !0)
          }
        }, "padding".concat(k));
    });
  }
}), pk = ["nw", "ne", "se", "sw"];
function xE(e, t) {
  var n = e[0] + e[1], r = n > t ? t / n : 1;
  return e[0] *= r, e[1] = t - e[1] * r, e;
}
var iH = [1, 2, 5, 6], aH = [0, 3, 4, 7], $h = [1, -1, -1, 1], Uh = [1, 1, -1, -1];
function RD(e, t, n, r, a, s, l, p) {
  a === void 0 && (a = 0), s === void 0 && (s = 0), l === void 0 && (l = n), p === void 0 && (p = r);
  var h = [], y = !1, b = e.filter(function(x) {
    return !x.virtual;
  }), E = b.map(function(x) {
    var C = x.horizontal, T = x.vertical, O = x.pos;
    if (T && !y && (y = !0, h.push("/")), y) {
      var D = Math.max(0, T === 1 ? O[1] - s : p - O[1]);
      return h.push(Yl(D, r, t)), D;
    } else {
      var D = Math.max(0, C === 1 ? O[0] - a : l - O[0]);
      return h.push(Yl(D, n, t)), D;
    }
  });
  return {
    radiusPoses: b,
    styles: h,
    raws: E
  };
}
function DB(e) {
  for (var t = [0, 0], n = [0, 0], r = e.length, a = 0; a < r; ++a) {
    var s = e[a];
    !s.sub || (s.horizontal && (t[1] === 0 && (t[0] = a), t[1] = a - t[0] + 1, n[0] = a + 1), s.vertical && (n[1] === 0 && (n[0] = a), n[1] = a - n[0] + 1));
  }
  return {
    horizontalRange: t,
    verticalRange: n
  };
}
function MB(e, t, n, r, a, s, l) {
  var p, h, y, b;
  s === void 0 && (s = [0, 0]), l === void 0 && (l = !1);
  var E = e.indexOf("/"), x = (E > -1 ? e.slice(0, E) : e).length, C = e.slice(0, x), T = e.slice(x + 1), O = C.length, D = T.length, A = D > 0, B = C[0], I = B === void 0 ? "0px" : B, L = C[1], k = L === void 0 ? I : L, $ = C[2], U = $ === void 0 ? I : $, K = C[3], X = K === void 0 ? k : K, Y = T[0], J = Y === void 0 ? I : Y, Q = T[1], Z = Q === void 0 ? A ? J : k : Q, se = T[2], pe = se === void 0 ? A ? J : U : se, be = T[3], _e = be === void 0 ? A ? Z : X : be, Se = [I, k, U, X].map(function(fe) {
    return wr(fe, t);
  }), Oe = [J, Z, pe, _e].map(function(fe) {
    return wr(fe, n);
  }), re = Se.slice(), ie = Oe.slice();
  p = xE([re[0], re[1]], t), re[0] = p[0], re[1] = p[1], h = xE([re[3], re[2]], t), re[3] = h[0], re[2] = h[1], y = xE([ie[0], ie[3]], n), ie[0] = y[0], ie[3] = y[1], b = xE([ie[1], ie[2]], n), ie[1] = b[0], ie[2] = b[1];
  var ce = l ? re : re.slice(0, Math.max(s[0], O)), le = l ? ie : ie.slice(0, Math.max(s[1], D));
  return jt(jt([], ce.map(function(fe, ve) {
    var ee = pk[ve];
    return {
      virtual: ve >= O,
      horizontal: $h[ve],
      vertical: 0,
      pos: [r + fe, a + (Uh[ve] === -1 ? n : 0)],
      sub: !0,
      raw: Se[ve],
      direction: ee
    };
  }), !0), le.map(function(fe, ve) {
    var ee = pk[ve];
    return {
      virtual: ve >= D,
      horizontal: 0,
      vertical: Uh[ve],
      pos: [r + ($h[ve] === -1 ? t : 0), a + fe],
      sub: !0,
      raw: Oe[ve],
      direction: ee
    };
  }), !0);
}
function oH(e, t, n, r, a) {
  a === void 0 && (a = t.length);
  var s = DB(e.slice(r)), l = s.horizontalRange, p = s.verticalRange, h = n - r, y = 0;
  if (h === 0)
    y = a;
  else if (h > 0 && h < l[1])
    y = l[1] - h;
  else if (h >= p[0])
    y = p[0] + p[1] - h;
  else
    return;
  e.splice(n, y), t.splice(n, y);
}
function sH(e, t, n, r, a, s, l, p, h, y, b) {
  y === void 0 && (y = 0), b === void 0 && (b = 0);
  var E = DB(e.slice(n)), x = E.horizontalRange, C = E.verticalRange;
  if (r > -1)
    for (var T = $h[r] === 1 ? s - y : p - s, O = x[1]; O <= r; ++O) {
      var D = Uh[O] === 1 ? b : h, A = 0;
      if (r === O ? A = s : O === 0 ? A = y + T : $h[O] === -1 && (A = p - (t[n][0] - y)), e.splice(n + O, 0, {
        horizontal: $h[O],
        vertical: 0,
        pos: [A, D]
      }), t.splice(n + O, 0, [A, D]), O === 0)
        break;
    }
  else if (a > -1) {
    var B = Uh[a] === 1 ? l - b : h - l;
    if (x[1] === 0 && C[1] === 0) {
      var I = [y + B, b];
      e.push({
        horizontal: $h[0],
        vertical: 0,
        pos: I
      }), t.push(I);
    }
    for (var L = C[0], O = C[1]; O <= a; ++O) {
      var A = $h[O] === 1 ? y : p, D = 0;
      if (a === O ? D = l : O === 0 ? D = b + B : Uh[O] === 1 ? D = t[n + L][1] : Uh[O] === -1 && (D = h - (t[n + L][1] - b)), e.push({
        horizontal: 0,
        vertical: Uh[O],
        pos: [A, D]
      }), t.push([A, D]), O === 0)
        break;
    }
  }
}
function uH(e, t) {
  t === void 0 && (t = e.map(function(a) {
    return a.raw;
  }));
  var n = e.map(function(a, s) {
    return a.horizontal ? t[s] : null;
  }).filter(function(a) {
    return a != null;
  }), r = e.map(function(a, s) {
    return a.vertical ? t[s] : null;
  }).filter(function(a) {
    return a != null;
  });
  return {
    horizontals: n,
    verticals: r
  };
}
var lH = [[0, -1, "n"], [1, 0, "e"]], cH = [[-1, -1, "nw"], [0, -1, "n"], [1, -1, "ne"], [1, 0, "e"], [1, 1, "se"], [0, 1, "s"], [-1, 1, "sw"], [-1, 0, "w"]];
function TD(e, t, n) {
  var r = e.props.clipRelative, a = e.state, s = a.width, l = a.height, p = t, h = p.type, y = p.poses, b = h === "rect", E = h === "circle";
  if (h === "polygon")
    return n.map(function($) {
      return "".concat(Yl($[0], s, r), " ").concat(Yl($[1], l, r));
    });
  if (b || h === "inset") {
    var x = n[1][1], C = n[3][0], T = n[7][0], O = n[5][1];
    if (b)
      return [x, C, O, T].map(function($) {
        return "".concat($, "px");
      });
    var D = [x, s - C, l - O, T].map(function($, U) {
      return Yl($, U % 2 ? s : l, r);
    });
    if (n.length > 8) {
      var A = Bt(n[4], n[0]), B = A[0], I = A[1];
      D.push.apply(D, jt(["round"], RD(y.slice(8).map(function($, U) {
        return we(we({}, $), {
          pos: n[U]
        });
      }), r, B, I, T, x, C, O).styles, !1));
    }
    return D;
  } else if (E || h === "ellipse") {
    var L = n[0], k = Yl(Math.abs(n[1][1] - L[1]), E ? Math.sqrt((s * s + l * l) / 2) : l, r), D = E ? [k] : [Yl(Math.abs(n[2][0] - L[0]), s, r), k];
    return D.push("at", Yl(L[0], s, r), Yl(L[1], l, r)), D;
  }
}
function mx(e, t, n, r) {
  var a = [r, (r + t) / 2, t], s = [e, (e + n) / 2, n];
  return cH.map(function(l) {
    var p = l[0], h = l[1], y = l[2], b = a[p + 1], E = s[h + 1];
    return {
      vertical: Math.abs(h),
      horizontal: Math.abs(p),
      direction: y,
      pos: [b, E]
    };
  });
}
function AB(e) {
  var t = [1 / 0, -1 / 0], n = [1 / 0, -1 / 0];
  return e.forEach(function(r) {
    var a = r.pos;
    t[0] = Math.min(t[0], a[0]), t[1] = Math.max(t[1], a[0]), n[0] = Math.min(n[0], a[1]), n[1] = Math.max(n[1], a[1]);
  }), [Math.abs(t[1] - t[0]), Math.abs(n[1] - n[0])];
}
function vk(e, t, n, r, a) {
  var s, l, p, h, y, b, E;
  if (!!e) {
    var x = a;
    if (!x) {
      var C = getComputedStyle(e), T = C.clipPath;
      x = T !== "none" ? T : C.clip;
    }
    if (!((!x || x === "none" || x === "auto") && (x = r, !x))) {
      var O = EL(x), D = O.prefix, A = D === void 0 ? x : D, B = O.value, I = B === void 0 ? "" : B, L = A === "circle", k = " ";
      if (A === "polygon") {
        var $ = Vh(I || "0% 0%, 100% 0%, 100% 100%, 0% 100%");
        k = ",";
        var U = $.map(function(pt) {
          var en = pt.split(" "), wt = en[0], tn = en[1];
          return {
            vertical: 1,
            horizontal: 1,
            pos: [wr(wt, t), wr(tn, n)]
          };
        }), K = Zp(U.map(function(pt) {
          return pt.pos;
        }));
        return {
          type: A,
          clipText: x,
          poses: U,
          splitter: k,
          left: K.minX,
          right: K.maxX,
          top: K.minY,
          bottom: K.maxY
        };
      } else if (L || A === "ellipse") {
        var X = "", Y = "", J = 0, Q = 0, $ = Qp(I);
        if (L) {
          var Z = "";
          s = $[0], Z = s === void 0 ? "50%" : s, l = $[2], X = l === void 0 ? "50%" : l, p = $[3], Y = p === void 0 ? "50%" : p, J = wr(Z, Math.sqrt((t * t + n * n) / 2)), Q = J;
        } else {
          var se = "", pe = "";
          h = $[0], se = h === void 0 ? "50%" : h, y = $[1], pe = y === void 0 ? "50%" : y, b = $[3], X = b === void 0 ? "50%" : b, E = $[4], Y = E === void 0 ? "50%" : E, J = wr(se, t), Q = wr(pe, n);
        }
        var be = [wr(X, t), wr(Y, n)], U = jt([{
          vertical: 1,
          horizontal: 1,
          pos: be,
          direction: "nesw"
        }], lH.slice(0, L ? 1 : 2).map(function(wt) {
          return {
            vertical: Math.abs(wt[1]),
            horizontal: wt[0],
            direction: wt[2],
            sub: !0,
            pos: [be[0] + wt[0] * J, be[1] + wt[1] * Q]
          };
        }), !0);
        return {
          type: A,
          clipText: x,
          radiusX: J,
          radiusY: Q,
          left: be[0] - J,
          top: be[1] - Q,
          right: be[0] + J,
          bottom: be[1] + Q,
          poses: U,
          splitter: k
        };
      } else if (A === "inset") {
        var $ = Qp(I || "0 0 0 0"), _e = $.indexOf("round"), Se = (_e > -1 ? $.slice(0, _e) : $).length, Oe = $.slice(Se + 1), re = $.slice(0, Se), ie = re[0], ce = re[1], le = ce === void 0 ? ie : ce, fe = re[2], ve = fe === void 0 ? ie : fe, ee = re[3], Ae = ee === void 0 ? le : ee, he = [ie, ve].map(function(wt) {
          return wr(wt, n);
        }), Fe = he[0], Ne = he[1], xe = [Ae, le].map(function(wt) {
          return wr(wt, t);
        }), oe = xe[0], it = xe[1], Le = t - it, qe = n - Ne, Tt = MB(Oe, Le - oe, qe - Fe, oe, Fe), U = jt(jt([], mx(Fe, Le, qe, oe), !0), Tt, !0);
        return {
          type: "inset",
          clipText: x,
          poses: U,
          top: Fe,
          left: oe,
          right: Le,
          bottom: qe,
          radius: Oe,
          splitter: k
        };
      } else if (A === "rect") {
        var $ = Vh(I || "0px, ".concat(t, "px, ").concat(n, "px, 0px"));
        k = ",";
        var Qe = $.map(function(ft) {
          var Gt = Kh(ft).value;
          return Gt;
        }), Fe = Qe[0], it = Qe[1], Ne = Qe[2], oe = Qe[3], U = mx(Fe, it, Ne, oe);
        return {
          type: "rect",
          clipText: x,
          poses: U,
          top: Fe,
          right: it,
          bottom: Ne,
          left: oe,
          values: $,
          splitter: k
        };
      }
    }
  }
}
function fH(e, t, n, r, a) {
  var s = e[t], l = s.direction, p = s.sub, h = e.map(function() {
    return [0, 0];
  }), y = l ? l.split("") : [];
  if (r && t < 8) {
    var b = y.filter(function(Z) {
      return Z === "w" || Z === "e";
    }), E = y.filter(function(Z) {
      return Z === "n" || Z === "s";
    }), x = b[0], C = E[0];
    h[t] = n;
    var T = AB(e), O = T[0], D = T[1], A = O && D ? O / D : 0;
    if (A && a) {
      var B = (t + 4) % 8, I = e[B].pos, L = [0, 0];
      l.indexOf("w") > -1 ? L[0] = -1 : l.indexOf("e") > -1 && (L[0] = 1), l.indexOf("n") > -1 ? L[1] = -1 : l.indexOf("s") > -1 && (L[1] = 1);
      var k = lB([O, D], n, A, L, !0), $ = O + k[0], U = D + k[1], K = I[1], X = I[1], Y = I[0], J = I[0];
      L[0] === -1 ? Y = J - $ : L[0] === 1 ? J = Y + $ : (Y = Y - $ / 2, J = J + $ / 2), L[1] === -1 ? K = X - U : (L[1] === 1 || (K = X - U / 2), X = K + U);
      var Q = mx(K, J, X, Y);
      e.forEach(function(Z, se) {
        h[se][0] = Q[se].pos[0] - Z.pos[0], h[se][1] = Q[se].pos[1] - Z.pos[1];
      });
    } else
      e.forEach(function(Z, se) {
        var pe = Z.direction;
        !pe || (pe.indexOf(x) > -1 && (h[se][0] = n[0]), pe.indexOf(C) > -1 && (h[se][1] = n[1]));
      }), x && (h[1][0] = n[0] / 2, h[5][0] = n[0] / 2), C && (h[3][1] = n[1] / 2, h[7][1] = n[1] / 2);
  } else
    l && !p ? y.forEach(function(Z) {
      var se = Z === "n" || Z === "s";
      e.forEach(function(pe, be) {
        var _e = pe.direction, Se = pe.horizontal, Oe = pe.vertical;
        !_e || _e.indexOf(Z) === -1 || (h[be] = [se || !Se ? 0 : n[0], !se || !Oe ? 0 : n[1]]);
      });
    }) : h[t] = n;
  return h;
}
function dH(e, t) {
  var n = $L(e, t), r = n[0], a = n[1], s = t.datas, l = s.clipPath, p = s.clipIndex, h = l, y = h.type, b = h.poses, E = h.splitter, x = b.map(function(B) {
    return B.pos;
  });
  if (y === "polygon")
    x.splice(p, 0, [r, a]);
  else if (y === "inset") {
    var C = iH.indexOf(p), T = aH.indexOf(p), O = b.length;
    if (sH(b, x, 8, C, T, r, a, x[4][0], x[4][1], x[0][0], x[0][1]), O === b.length)
      return;
  } else
    return;
  var D = TD(e, l, x), A = "".concat(y, "(").concat(D.join(E), ")");
  St(e, "onClip", En(e, t, we({
    clipEventType: "added",
    clipType: y,
    poses: x,
    clipStyles: D,
    clipStyle: A,
    distX: 0,
    distY: 0
  }, Xs({
    clipPath: A
  }, t))));
}
function pH(e, t) {
  var n = t.datas, r = n.clipPath, a = n.clipIndex, s = r, l = s.type, p = s.poses, h = s.splitter, y = p.map(function(C) {
    return C.pos;
  }), b = y.length;
  if (l === "polygon")
    p.splice(a, 1), y.splice(a, 1);
  else if (l === "inset") {
    if (a < 8 || (oH(p, y, a, 8, b), b === p.length))
      return;
  } else
    return;
  var E = TD(e, r, y), x = "".concat(l, "(").concat(E.join(h), ")");
  St(e, "onClip", En(e, t, we({
    clipEventType: "removed",
    clipType: l,
    poses: y,
    clipStyles: E,
    clipStyle: x,
    distX: 0,
    distY: 0
  }, Xs({
    clipPath: x
  }, t))));
}
var vH = {
  name: "clippable",
  props: {
    clippable: Boolean,
    defaultClipPath: String,
    customClipPath: String,
    keepRatio: Boolean,
    clipRelative: Boolean,
    clipArea: Boolean,
    dragWithClip: Boolean,
    clipTargetBounds: Boolean,
    clipVerticalGuidelines: Array,
    clipHorizontalGuidelines: Array,
    clipSnapThreshold: Boolean
  },
  events: {
    onClipStart: "clipStart",
    onClip: "clip",
    onClipEnd: "clipEnd"
  },
  css: [`.control.clip-control {
    background: #6d6;
    cursor: pointer;
}
.control.clip-control.clip-radius {
    background: #d66;
}
.line.clip-line {
    background: #6e6;
    cursor: move;
    z-index: 1;
}
.clip-area {
    position: absolute;
    top: 0;
    left: 0;
}
.clip-ellipse {
    position: absolute;
    cursor: move;
    border: 1px solid #6d6;
    border: var(--zoompx) solid #6d6;
    border-radius: 50%;
    transform-origin: 0px 0px;
}`, `:host {
    --bounds-color: #d66;
}`, `.guideline {
    pointer-events: none;
    z-index: 2;
}`, `.line.guideline.bounds {
    background: #d66;
    background: var(--bounds-color);
}`],
  render: function(e, t) {
    var n = e.props, r = n.customClipPath, a = n.defaultClipPath, s = n.clipArea, l = n.zoom, p = e.getState(), h = p.target, y = p.width, b = p.height, E = p.allMatrix, x = p.is3d, C = p.left, T = p.top, O = p.pos1, D = p.pos2, A = p.pos3, B = p.pos4, I = p.clipPathState, L = p.snapBoundInfos, k = p.rotation;
    if (!h)
      return [];
    var $ = vk(h, y, b, a || "inset", I || r);
    if (!$)
      return [];
    var U = x ? 4 : 3, K = $.type, X = $.poses, Y = X.map(function(Le) {
      var qe = Yi(E, Le.pos, U);
      return [qe[0] - C, qe[1] - T];
    }), J = [], Q = [], Z = K === "rect", se = K === "inset", pe = K === "polygon";
    if (Z || se || pe) {
      var be = se ? Y.slice(0, 8) : Y;
      Q = be.map(function(Le, qe) {
        var Tt = qe === 0 ? be[be.length - 1] : be[qe - 1], Qe = mi(Tt, Le), pt = JL(Tt, Le);
        return /* @__PURE__ */ He("div", {
          className: $t("line", "clip-line", "snap-control"),
          "data-clip-index": qe,
          style: {
            width: "".concat(pt, "px"),
            transform: "translate(".concat(Tt[0], "px, ").concat(Tt[1], "px) rotate(").concat(Qe, "rad) scaleY(").concat(l, ")")
          }
        }, "clipLine".concat(qe));
      });
    }
    if (J = Y.map(function(Le, qe) {
      return /* @__PURE__ */ He("div", {
        className: $t("control", "clip-control", "snap-control"),
        "data-clip-index": qe,
        style: {
          transform: "translate(".concat(Le[0], "px, ").concat(Le[1], "px) rotate(").concat(k, "rad) scale(").concat(l, ")")
        }
      }, "clipControl".concat(qe));
    }), se && J.push.apply(J, Y.slice(8).map(function(Le, qe) {
      return /* @__PURE__ */ He("div", {
        className: $t("control", "clip-control", "clip-radius", "snap-control"),
        "data-clip-index": 8 + qe,
        style: {
          transform: "translate(".concat(Le[0], "px, ").concat(Le[1], "px) rotate(").concat(k, "rad) scale(").concat(l, ")")
        }
      }, "clipRadiusControl".concat(qe));
    })), K === "circle" || K === "ellipse") {
      var _e = $.left, Se = $.top, Oe = $.radiusX, re = $.radiusY, ie = Bt(Yi(E, [_e, Se], U), Yi(E, [0, 0], U)), ce = ie[0], le = ie[1], fe = "none";
      if (!s) {
        for (var ve = Math.max(10, Oe / 5, re / 5), ee = [], Ae = 0; Ae <= ve; ++Ae) {
          var he = Math.PI * 2 / ve * Ae;
          ee.push([Oe + (Oe - l) * Math.cos(he), re + (re - l) * Math.sin(he)]);
        }
        ee.push([Oe, -2]), ee.push([-2, -2]), ee.push([-2, re * 2 + 2]), ee.push([Oe * 2 + 2, re * 2 + 2]), ee.push([Oe * 2 + 2, -2]), ee.push([Oe, -2]), fe = "polygon(".concat(ee.map(function(Le) {
          return "".concat(Le[0], "px ").concat(Le[1], "px");
        }).join(", "), ")");
      }
      J.push(/* @__PURE__ */ He("div", {
        className: $t("clip-ellipse", "snap-control"),
        style: {
          width: "".concat(Oe * 2, "px"),
          height: "".concat(re * 2, "px"),
          clipPath: fe,
          transform: "translate(".concat(-C + ce, "px, ").concat(-T + le, "px) ").concat(Gx(E))
        }
      }, "clipEllipse"));
    }
    if (s) {
      var Fe = el(jt([O, D, A, B], Y, !0)), Ne = Fe.width, xe = Fe.height, oe = Fe.left, it = Fe.top;
      if (pe || Z || se) {
        var ee = se ? Y.slice(0, 8) : Y;
        J.push(/* @__PURE__ */ He("div", {
          className: $t("clip-area", "snap-control"),
          style: {
            width: "".concat(Ne, "px"),
            height: "".concat(xe, "px"),
            transform: "translate(".concat(oe, "px, ").concat(it, "px)"),
            clipPath: "polygon(".concat(ee.map(function(qe) {
              return "".concat(qe[0] - oe, "px ").concat(qe[1] - it, "px");
            }).join(", "), ")")
          }
        }, "clipArea"));
      }
    }
    return L && ["vertical", "horizontal"].forEach(function(Le) {
      var qe = L[Le], Tt = Le === "horizontal";
      qe.isSnap && Q.push.apply(Q, qe.snap.posInfos.map(function(Qe, pt) {
        var en = Qe.pos, wt = Bt(Yi(E, Tt ? [0, en] : [en, 0], U), [C, T]), tn = Bt(Yi(E, Tt ? [y, en] : [en, b], U), [C, T]);
        return mb(t, "", wt, tn, l, "clip".concat(Le, "snap").concat(pt), "guideline");
      })), qe.isBound && Q.push.apply(Q, qe.bounds.map(function(Qe, pt) {
        var en = Qe.pos, wt = Bt(Yi(E, Tt ? [0, en] : [en, 0], U), [C, T]), tn = Bt(Yi(E, Tt ? [y, en] : [en, b], U), [C, T]);
        return mb(t, "", wt, tn, l, "clip".concat(Le, "bounds").concat(pt), "guideline", "bounds", "bold");
      }));
    }), jt(jt([], J, !0), Q, !0);
  },
  dragControlCondition: function(e, t) {
    return t.inputEvent && (t.inputEvent.target.getAttribute("class") || "").indexOf("clip") > -1;
  },
  dragStart: function(e, t) {
    var n = e.props, r = n.dragWithClip, a = r === void 0 ? !0 : r;
    return a ? !1 : this.dragControlStart(e, t);
  },
  drag: function(e, t) {
    return this.dragControl(e, we(we({}, t), {
      isDragTarget: !0
    }));
  },
  dragEnd: function(e, t) {
    return this.dragControlEnd(e, t);
  },
  dragControlStart: function(e, t) {
    var n = e.state, r = e.props, a = r.defaultClipPath, s = r.customClipPath, l = n.target, p = n.width, h = n.height, y = t.inputEvent ? t.inputEvent.target : null, b = y && y.getAttribute("class") || "", E = t.datas, x = vk(l, p, h, a || "inset", s);
    if (!x)
      return !1;
    var C = x.clipText, T = x.type, O = x.poses, D = St(e, "onClipStart", En(e, t, {
      clipType: T,
      clipStyle: C,
      poses: O.map(function(A) {
        return A.pos;
      })
    }));
    return D === !1 ? (E.isClipStart = !1, !1) : (E.isControl = b && b.indexOf("clip-control") > -1, E.isLine = b.indexOf("clip-line") > -1, E.isArea = b.indexOf("clip-area") > -1 || b.indexOf("clip-ellipse") > -1, E.clipIndex = y ? parseInt(y.getAttribute("data-clip-index"), 10) : -1, E.clipPath = x, E.isClipStart = !0, n.clipPathState = C, rg(e, t), !0);
  },
  dragControl: function(e, t) {
    var n, r, a = t.datas, s = t.originalDatas, l = t.isDragTarget;
    if (!a.isClipStart)
      return !1;
    var p = a, h = p.isControl, y = p.isLine, b = p.isArea, E = p.clipIndex, x = p.clipPath;
    if (!x)
      return !1;
    var C = Zh(e.props, "clippable"), T = C.keepRatio, O = 0, D = 0, A = s.draggable, B = nf(t);
    l && A ? (n = A.prevBeforeDist, O = n[0], D = n[1]) : (O = B[0], D = B[1]);
    var I = [O, D], L = e.state, k = L.width, $ = L.height, U = !b && !h && !y, K = x.type, X = x.poses, Y = x.splitter, J = X.map(function(Nt) {
      return Nt.pos;
    });
    U && (O = -O, D = -D);
    var Q = !h || X[E].direction === "nesw", Z = K === "inset" || K === "rect", se = X.map(function() {
      return [0, 0];
    });
    if (h && !Q) {
      var pe = X[E], be = pe.horizontal, _e = pe.vertical, Se = [O * Math.abs(be), D * Math.abs(_e)];
      se = fH(X, E, Se, Z, T);
    } else
      Q && (se = J.map(function() {
        return [O, D];
      }));
    var Oe = J.map(function(Nt, jn) {
      return On(Nt, se[jn]);
    }), re = jt([], Oe, !0);
    L.snapBoundInfos = null;
    var ie = x.type === "circle", ce = x.type === "ellipse";
    if (ie || ce) {
      var le = el(Oe), fe = Math.abs(le.bottom - le.top), ve = Math.abs(ce ? le.right - le.left : fe), ee = Oe[0][1] + fe, Ae = Oe[0][0] - ve, he = Oe[0][0] + ve;
      ie && (re.push([he, le.bottom]), se.push([1, 0])), re.push([le.left, ee]), se.push([0, 1]), re.push([Ae, le.bottom]), se.push([1, 0]);
    }
    var Fe = mB((C.clipHorizontalGuidelines || []).map(function(Nt) {
      return wr("".concat(Nt), $);
    }), (C.clipVerticalGuidelines || []).map(function(Nt) {
      return wr("".concat(Nt), k);
    }), k, $), Ne = [], xe = [];
    if (ie || ce)
      Ne = [re[4][0], re[2][0]], xe = [re[1][1], re[3][1]];
    else if (Z) {
      var oe = [re[0], re[2], re[4], re[6]], it = [se[0], se[2], se[4], se[6]];
      Ne = oe.filter(function(Nt, jn) {
        return it[jn][0];
      }).map(function(Nt) {
        return Nt[0];
      }), xe = oe.filter(function(Nt, jn) {
        return it[jn][1];
      }).map(function(Nt) {
        return Nt[1];
      });
    } else
      Ne = re.filter(function(Nt, jn) {
        return se[jn][0];
      }).map(function(Nt) {
        return Nt[0];
      }), xe = re.filter(function(Nt, jn) {
        return se[jn][1];
      }).map(function(Nt) {
        return Nt[1];
      });
    var Le = [0, 0], qe = ak(Fe, C.clipTargetBounds && {
      left: 0,
      top: 0,
      right: k,
      bottom: $
    }, Ne, xe, 5), Tt = qe.horizontal, Qe = qe.vertical, pt = Tt.offset, en = Qe.offset;
    if (Tt.isBound && (Le[1] += pt), Qe.isBound && (Le[0] += en), (ce || ie) && se[0][0] === 0 && se[0][1] === 0) {
      var le = el(Oe), wt = le.bottom - le.top, tn = ce ? le.right - le.left : wt, Vn = Qe.isBound ? Math.abs(en) : Qe.snapIndex === 0 ? -en : en, Kt = Tt.isBound ? Math.abs(pt) : Tt.snapIndex === 0 ? -pt : pt;
      tn -= Vn, wt -= Kt, ie && (wt = dB(Qe, Tt) > 0 ? wt : tn, tn = wt);
      var ft = re[0];
      re[1][1] = ft[1] - wt, re[2][0] = ft[0] + tn, re[3][1] = ft[1] + wt, re[4][0] = ft[0] - tn;
    } else if (Z && T && h) {
      var Gt = AB(X), xn = Gt[0], gn = Gt[1], rr = xn && gn ? xn / gn : 0, Zi = X[E], At = Zi.direction || "", at = re[1][1], ee = re[5][1], Ae = re[7][0], he = re[3][0];
      pt <= en ? pt = en / rr : en = pt * rr, At.indexOf("w") > -1 ? Ae -= en : At.indexOf("e") > -1 ? he -= en : (Ae += en / 2, he -= en / 2), At.indexOf("n") > -1 ? at -= pt : At.indexOf("s") > -1 ? ee -= pt : (at += pt / 2, ee -= pt / 2);
      var bt = mx(at, he, ee, Ae);
      re.forEach(function(Ji, so) {
        var Ua;
        Ua = bt[so].pos, Ji[0] = Ua[0], Ji[1] = Ua[1];
      });
    } else
      re.forEach(function(Nt, jn) {
        var ss = se[jn];
        ss[0] && (Nt[0] -= en), ss[1] && (Nt[1] -= pt);
      });
    var Pt = TD(e, x, Oe), dn = "".concat(K, "(").concat(Pt.join(Y), ")");
    if (L.clipPathState = dn, ie || ce)
      Ne = [re[4][0], re[2][0]], xe = [re[1][1], re[3][1]];
    else if (Z) {
      var oe = [re[0], re[2], re[4], re[6]];
      Ne = oe.map(function(jn) {
        return jn[0];
      }), xe = oe.map(function(jn) {
        return jn[1];
      });
    } else
      Ne = re.map(function(Nt) {
        return Nt[0];
      }), xe = re.map(function(Nt) {
        return Nt[1];
      });
    if (L.snapBoundInfos = ak(Fe, C.clipTargetBounds && {
      left: 0,
      top: 0,
      right: k,
      bottom: $
    }, Ne, xe, 1), A) {
      var Nn = L.is3d, kn = L.allMatrix, In = Nn ? 4 : 3, Cr = Le;
      l && (Cr = [I[0] + Le[0] - B[0], I[1] + Le[1] - B[1]]), A.deltaOffset = yr(kn, [Cr[0], Cr[1], 0, 0], In);
    }
    return St(e, "onClip", En(e, t, we({
      clipEventType: "changed",
      clipType: K,
      poses: Oe,
      clipStyle: dn,
      clipStyles: Pt,
      distX: O,
      distY: D
    }, Xs((r = {}, r[K === "rect" ? "clip" : "clipPath"] = dn, r), t)))), !0;
  },
  dragControlEnd: function(e, t) {
    this.unset(e);
    var n = t.isDrag, r = t.datas, a = t.isDouble, s = r.isLine, l = r.isClipStart, p = r.isControl;
    return l ? (St(e, "onClipEnd", nu(e, t, {})), a && (p ? pH(e, t) : s && dH(e, t)), a || n) : !1;
  },
  unset: function(e) {
    e.state.clipPathState = "", e.state.snapBoundInfos = null;
  }
}, hH = {
  name: "originDraggable",
  props: {
    originDraggable: Boolean,
    originRelative: Boolean
  },
  events: {
    onDragOriginStart: "dragOriginStart",
    onDragOrigin: "dragOrigin",
    onDragOriginEnd: "dragOriginEnd"
  },
  css: [`:host[data-able-origindraggable] .control.origin {
    pointer-events: auto;
}`],
  dragControlCondition: function(e, t) {
    return t.isRequest ? t.requestAble === "originDraggable" : Ui(t.inputEvent.target, $t("origin"));
  },
  dragControlStart: function(e, t) {
    var n = t.datas;
    rg(e, t);
    var r = En(e, t, {
      dragStart: wo.dragStart(e, new my().dragStart([0, 0], t))
    }), a = St(e, "onDragOriginStart", r);
    return n.startOrigin = e.state.transformOrigin, n.startTargetOrigin = e.state.targetOrigin, n.prevOrigin = [0, 0], n.isDragOrigin = !0, a === !1 ? (n.isDragOrigin = !1, !1) : r;
  },
  dragControl: function(e, t) {
    var n = t.datas, r = t.isPinch, a = t.isRequest;
    if (!n.isDragOrigin)
      return !1;
    var s = nf(t), l = s[0], p = s[1], h = e.state, y = h.width, b = h.height, E = h.offsetMatrix, x = h.targetMatrix, C = h.is3d, T = e.props.originRelative, O = T === void 0 ? !0 : T, D = C ? 4 : 3, A = [l, p];
    if (a) {
      var B = t.distOrigin;
      (B[0] || B[1]) && (A = B);
    }
    var I = On(n.startOrigin, A), L = On(n.startTargetOrigin, A), k = Bt(A, n.prevOrigin), $ = Wb(E, x, I, D), U = e.getRect(), K = el(Jp($, y, b, D)), X = [U.left - K.left, U.top - K.top];
    n.prevOrigin = A;
    var Y = [Yl(L[0], y, O), Yl(L[1], b, O)].join(" "), J = En(e, t, {
      width: y,
      height: b,
      origin: I,
      dist: A,
      delta: k,
      transformOrigin: Y,
      drag: wo.drag(e, jb(t, e.state, X, !!r, !1))
    });
    return St(e, "onDragOrigin", J), J;
  },
  dragControlEnd: function(e, t) {
    var n = t.datas;
    return n.isDragOrigin ? (St(e, "onDragOriginEnd", nu(e, t, {})), !0) : !1;
  },
  dragGroupControlCondition: function(e, t) {
    return this.dragControlCondition(e, t);
  },
  dragGroupControlStart: function(e, t) {
    var n = this.dragControlStart(e, t);
    return !!n;
  },
  dragGroupControl: function(e, t) {
    var n = this.dragControl(e, t);
    return n ? (e.transformOrigin = n.transformOrigin, !0) : !1;
  },
  request: function(e) {
    var t = {}, n = e.getRect(), r = 0, a = 0, s = n.transformOrigin, l = [0, 0];
    return {
      isControl: !0,
      requestStart: function() {
        return {
          datas: t
        };
      },
      request: function(p) {
        return "deltaOrigin" in p ? (l[0] += p.deltaOrigin[0], l[1] += p.deltaOrigin[1]) : "origin" in p ? (l[0] = p.origin[0] - s[0], l[1] = p.origin[1] - s[1]) : ("x" in p ? r = p.x - n.left : "deltaX" in p && (r += p.deltaX), "y" in p ? a = p.y - n.top : "deltaY" in p && (a += p.deltaY)), {
          datas: t,
          distX: r,
          distY: a,
          distOrigin: l
        };
      },
      requestEnd: function() {
        return {
          datas: t,
          isDrag: !0
        };
      }
    };
  }
};
function gH(e, t, n, r) {
  var a = e.filter(function(h) {
    var y = h.virtual, b = h.horizontal;
    return b && !y;
  }).length, s = e.filter(function(h) {
    var y = h.virtual, b = h.vertical;
    return b && !y;
  }).length, l = -1;
  if (t === 0 && (a === 0 ? l = 0 : a === 1 && (l = 1)), t === 2 && (a <= 2 ? l = 2 : a <= 3 && (l = 3)), t === 3 && (s === 0 ? l = 4 : s < 4 && (l = 7)), t === 1 && (s <= 1 ? l = 5 : s <= 2 && (l = 6)), !(l === -1 || !e[l].virtual)) {
    var p = e[l];
    mH(e, l), l < 4 ? p.pos[0] = n : p.pos[1] = r;
  }
}
function mH(e, t) {
  t < 4 ? e.slice(0, t + 1).forEach(function(n) {
    n.virtual = !1;
  }) : (e[0].virtual && (e[0].virtual = !1), e.slice(4, t + 1).forEach(function(n) {
    n.virtual = !1;
  }));
}
function yH(e, t) {
  t < 4 ? e.slice(t, 4).forEach(function(n) {
    n.virtual = !0;
  }) : e.slice(t).forEach(function(n) {
    n.virtual = !0;
  });
}
function hk(e, t, n, r, a) {
  r === void 0 && (r = [0, 0]);
  var s = [];
  return !e || e === "0px" ? s = [] : s = Qp(e), MB(s, t, n, 0, 0, r, a);
}
function gk(e, t, n, r, a) {
  var s = e.state, l = s.width, p = s.height, h = RD(a, e.props.roundRelative, l, p), y = h.raws, b = h.styles, E = h.radiusPoses, x = uH(E, y), C = x.horizontals, T = x.verticals, O = b.join(" ");
  s.borderRadiusState = O;
  var D = En(e, t, we({
    horizontals: C,
    verticals: T,
    borderRadius: O,
    width: l,
    height: p,
    delta: r,
    dist: n
  }, Xs({
    borderRadius: O
  }, t)));
  return St(e, "onRound", D), D;
}
function mk(e) {
  var t = e.getState().style, n = t.borderRadius || "";
  if (!n && e.props.groupable) {
    var r = e.getTargets()[0];
    r && (n = getComputedStyle(r).borderRadius, t.borderRadius = n);
  }
  return n;
}
var bH = {
  name: "roundable",
  props: {
    roundable: Boolean,
    roundRelative: Boolean,
    minRoundControls: Array,
    maxRoundControls: Array,
    roundClickable: Boolean,
    roundPadding: Number,
    isDisplayShadowRoundControls: Boolean
  },
  events: {
    onRoundStart: "roundStart",
    onRound: "round",
    onRoundEnd: "roundEnd",
    onRoundGroupStart: "roundGroupStart",
    onRoundGroup: "roundGroup",
    onRoundGroupEnd: "roundGroupEnd"
  },
  css: [`.control.border-radius {
    background: #d66;
    cursor: pointer;
    z-index: 3;
}`, `.control.border-radius.vertical {
    background: #d6d;
    z-index: 2;
}`, `.control.border-radius.virtual {
    opacity: 0.5;
    z-index: 1;
}`, `:host.round-line-clickable .line.direction {
    cursor: pointer;
}`],
  className: function(e) {
    var t = e.props.roundClickable;
    return t === !0 || t === "line" ? $t("round-line-clickable") : "";
  },
  requestStyle: function() {
    return ["borderRadius"];
  },
  render: function(e, t) {
    var n = e.getState(), r = n.target, a = n.width, s = n.height, l = n.allMatrix, p = n.is3d, h = n.left, y = n.top, b = n.borderRadiusState, E = e.props, x = E.minRoundControls, C = x === void 0 ? [0, 0] : x, T = E.maxRoundControls, O = T === void 0 ? [4, 4] : T, D = E.zoom, A = E.roundPadding, B = A === void 0 ? 0 : A, I = E.isDisplayShadowRoundControls, L = E.groupable;
    if (!r)
      return null;
    var k = b || mk(e), $ = p ? 4 : 3, U = hk(k, a, s, C, !0);
    if (!U)
      return null;
    var K = 0, X = 0, Y = L ? [0, 0] : [h, y];
    return U.map(function(J, Q) {
      var Z = J.horizontal, se = J.vertical, pe = J.direction || "", be = jt([], J.pos, !0);
      X += Math.abs(Z), K += Math.abs(se), Z && pe.indexOf("n") > -1 && (be[1] -= B), se && pe.indexOf("w") > -1 && (be[0] -= B), Z && pe.indexOf("s") > -1 && (be[1] += B), se && pe.indexOf("e") > -1 && (be[0] += B);
      var _e = Bt(Yi(l, be, $), Y), Se = J.vertical ? K <= O[1] && (I || !J.virtual) : X <= O[0] && (I || !J.virtual);
      return /* @__PURE__ */ He("div", {
        className: $t("control", "border-radius", J.vertical ? "vertical" : "", J.virtual ? "virtual" : ""),
        "data-radius-index": Q,
        style: {
          display: Se ? "block" : "none",
          transform: "translate(".concat(_e[0], "px, ").concat(_e[1], "px) scale(").concat(D, ")")
        }
      }, "borderRadiusControl".concat(Q));
    });
  },
  dragControlCondition: function(e, t) {
    if (!t.inputEvent || t.isRequest)
      return !1;
    var n = t.inputEvent.target.getAttribute("class") || "";
    return n.indexOf("border-radius") > -1 || n.indexOf("moveable-line") > -1 && n.indexOf("moveable-direction") > -1;
  },
  dragGroupControlCondition: function(e, t) {
    return this.dragControlCondition(e, t);
  },
  dragControlStart: function(e, t) {
    var n = t.inputEvent, r = t.datas, a = n.target, s = a.getAttribute("class") || "", l = s.indexOf("border-radius") > -1, p = s.indexOf("moveable-line") > -1 && s.indexOf("moveable-direction") > -1, h = l ? parseInt(a.getAttribute("data-radius-index"), 10) : -1, y = -1;
    if (p) {
      var b = a.getAttribute("data-line-key") || "";
      b && (y = parseInt(b.replace(/render-line-/g, ""), 10), isNaN(y) && (y = -1));
    }
    if (!l && !p)
      return !1;
    var E = En(e, t, {}), x = St(e, "onRoundStart", E);
    if (x === !1)
      return !1;
    r.lineIndex = y, r.controlIndex = h, r.isControl = l, r.isLine = p, rg(e, t);
    var C = e.props, T = C.roundRelative, O = C.minRoundControls, D = O === void 0 ? [0, 0] : O, A = e.state, B = A.width, I = A.height;
    r.isRound = !0, r.prevDist = [0, 0];
    var L = mk(e), k = hk(L || "", B, I, D, !0) || [];
    return r.controlPoses = k, A.borderRadiusState = RD(k, T, B, I).styles.join(" "), E;
  },
  dragControl: function(e, t) {
    var n = t.datas, r = n.controlPoses;
    if (!n.isRound || !n.isControl || !r.length)
      return !1;
    var a = n.controlIndex, s = nf(t), l = s[0], p = s[1], h = [l, p], y = Bt(h, n.prevDist), b = e.props.maxRoundControls, E = b === void 0 ? [4, 4] : b, x = e.state, C = x.width, T = x.height, O = r[a], D = O.vertical, A = O.horizontal, B = r.map(function(L) {
      var k = L.horizontal, $ = L.vertical, U = [k * A * h[0], $ * D * h[1]];
      if (k) {
        if (E[0] === 1)
          return U;
        if (E[0] < 4 && k !== A)
          return U;
      } else {
        if (E[1] === 0)
          return U[1] = $ * A * h[0] / C * T, U;
        if (D) {
          if (E[1] === 1)
            return U;
          if (E[1] < 4 && $ !== D)
            return U;
        }
      }
      return [0, 0];
    });
    B[a] = h;
    var I = r.map(function(L, k) {
      return we(we({}, L), {
        pos: On(L.pos, B[k])
      });
    });
    return a < 4 ? I.slice(0, a + 1).forEach(function(L) {
      L.virtual = !1;
    }) : I.slice(4, a + 1).forEach(function(L) {
      L.virtual = !1;
    }), n.prevDist = [l, p], gk(e, t, h, y, I);
  },
  dragControlEnd: function(e, t) {
    var n = e.state;
    n.borderRadiusState = "";
    var r = t.datas, a = t.isDouble;
    if (!r.isRound)
      return !1;
    var s = r.isControl, l = r.controlIndex, p = r.isLine, h = r.lineIndex, y = r.controlPoses, b = y.filter(function(A) {
      var B = A.virtual;
      return B;
    }).length, E = e.props.roundClickable, x = E === void 0 ? !0 : E;
    if (a && x) {
      if (s && (x === !0 || x === "control"))
        yH(y, l);
      else if (p && (x === !0 || x === "line")) {
        var C = $L(e, t), T = C[0], O = C[1];
        gH(y, h, T, O);
      }
      b !== y.filter(function(A) {
        var B = A.virtual;
        return B;
      }).length && gk(e, t, [0, 0], [0, 0], y);
    }
    var D = nu(e, t, {});
    return St(e, "onRoundEnd", D), n.borderRadiusState = "", D;
  },
  dragGroupControlStart: function(e, t) {
    var n = this.dragControlStart(e, t);
    if (!n)
      return !1;
    var r = e.moveables, a = e.props.targets, s = ec(e, "roundable", t), l = we({
      targets: e.props.targets,
      events: s.map(function(p, h) {
        return we(we({}, p), {
          target: a[h],
          moveable: r[h],
          currentTarget: r[h]
        });
      })
    }, n);
    return St(e, "onRoundGroupStart", l), n;
  },
  dragGroupControl: function(e, t) {
    var n = this.dragControl(e, t);
    if (!n)
      return !1;
    var r = e.moveables, a = e.props.targets, s = ec(e, "roundable", t), l = we({
      targets: e.props.targets,
      events: s.map(function(p, h) {
        return we(we(we({}, p), {
          target: a[h],
          moveable: r[h],
          currentTarget: r[h]
        }), Xs({
          borderRadius: n.borderRadius
        }, p));
      })
    }, n);
    return St(e, "onRoundGroup", l), l;
  },
  dragGroupControlEnd: function(e, t) {
    var n = e.moveables, r = e.props.targets, a = ec(e, "roundable", t);
    Hx(e, "onRound", function(p) {
      var h = we({
        targets: e.props.targets,
        events: a.map(function(y, b) {
          return we(we(we({}, y), {
            target: r[b],
            moveable: n[b],
            currentTarget: n[b]
          }), Xs({
            borderRadius: p.borderRadius
          }, y));
        })
      }, p);
      St(e, "onRoundGroup", h);
    });
    var s = this.dragControlEnd(e, t);
    if (!s)
      return !1;
    var l = we({
      targets: e.props.targets,
      events: a.map(function(p, h) {
        var y;
        return we(we({}, p), {
          target: r[h],
          moveable: n[h],
          currentTarget: n[h],
          lastEvent: (y = p.datas) === null || y === void 0 ? void 0 : y.lastEvent
        });
      })
    }, s);
    return St(e, "onRoundGroupEnd", l), l;
  },
  unset: function(e) {
    e.state.borderRadiusState = "";
  }
};
function _H(e, t) {
  var n = t ? 4 : 3, r = Kr(n), a = "matrix".concat(t ? "3d" : "", "(").concat(r.join(","), ")");
  return e === a || e === "matrix(1,0,0,1,0,0)";
}
var PB = {
  isPinch: !0,
  name: "beforeRenderable",
  props: {},
  events: {
    onBeforeRenderStart: "beforeRenderStart",
    onBeforeRender: "beforeRender",
    onBeforeRenderEnd: "beforeRenderEnd",
    onBeforeRenderGroupStart: "beforeRenderGroupStart",
    onBeforeRenderGroup: "beforeRenderGroup",
    onBeforeRenderGroupEnd: "beforeRenderGroupEnd"
  },
  dragRelation: "weak",
  setTransform: function(e, t) {
    var n = e.state, r = n.is3d, a = n.target, s = n.targetMatrix, l = a == null ? void 0 : a.style.transform, p = r ? "matrix3d(".concat(s.join(","), ")") : "matrix(".concat(TL(s, !0), ")"), h = !l || l === "none" ? p : l;
    t.datas.startTransforms = _H(h, r) ? [] : Qp(h);
  },
  resetStyle: function(e) {
    var t = e.datas;
    t.nextStyle = {}, t.nextTransforms = e.datas.startTransforms, t.nextTransformAppendedIndexes = [];
  },
  fillDragStartParams: function(e, t) {
    return En(e, t, {
      setTransform: function(n) {
        t.datas.startTransforms = Ki(n) ? n : Qp(n);
      },
      isPinch: !!t.isPinch
    });
  },
  fillDragParams: function(e, t) {
    return En(e, t, {
      isPinch: !!t.isPinch
    });
  },
  dragStart: function(e, t) {
    this.setTransform(e, t), this.resetStyle(t), St(e, "onBeforeRenderStart", this.fillDragStartParams(e, t));
  },
  drag: function(e, t) {
    this.resetStyle(t), St(e, "onBeforeRender", En(e, t, {
      isPinch: !!t.isPinch
    }));
  },
  dragEnd: function(e, t) {
    St(e, "onBeforeRenderEnd", En(e, t, {
      isPinch: !!t.isPinch,
      isDrag: t.isDrag
    }));
  },
  dragGroupStart: function(e, t) {
    var n = this;
    this.dragStart(e, t);
    var r = ec(e, "beforeRenderable", t), a = e.moveables, s = r.map(function(l, p) {
      var h = a[p];
      return n.setTransform(h, l), n.resetStyle(l), n.fillDragStartParams(h, l);
    });
    St(e, "onBeforeRenderGroupStart", En(e, t, {
      isPinch: !!t.isPinch,
      targets: e.props.targets,
      setTransform: function() {
      },
      events: s
    }));
  },
  dragGroup: function(e, t) {
    var n = this;
    this.drag(e, t);
    var r = ec(e, "beforeRenderable", t), a = e.moveables, s = r.map(function(l, p) {
      var h = a[p];
      return n.resetStyle(l), n.fillDragParams(h, l);
    });
    St(e, "onBeforeRenderGroup", En(e, t, {
      isPinch: !!t.isPinch,
      targets: e.props.targets,
      events: s
    }));
  },
  dragGroupEnd: function(e, t) {
    this.dragEnd(e, t), St(e, "onBeforeRenderGroupEnd", En(e, t, {
      isPinch: !!t.isPinch,
      isDrag: t.isDrag,
      targets: e.props.targets
    }));
  },
  dragControlStart: function(e, t) {
    return this.dragStart(e, t);
  },
  dragControl: function(e, t) {
    return this.drag(e, t);
  },
  dragControlEnd: function(e, t) {
    return this.dragEnd(e, t);
  },
  dragGroupControlStart: function(e, t) {
    return this.dragGroupStart(e, t);
  },
  dragGroupControl: function(e, t) {
    return this.dragGroup(e, t);
  },
  dragGroupControlEnd: function(e, t) {
    return this.dragGroupEnd(e, t);
  }
}, NB = {
  name: "renderable",
  props: {},
  events: {
    onRenderStart: "renderStart",
    onRender: "render",
    onRenderEnd: "renderEnd",
    onRenderGroupStart: "renderGroupStart",
    onRenderGroup: "renderGroup",
    onRenderGroupEnd: "renderGroupEnd"
  },
  dragRelation: "weak",
  dragStart: function(e, t) {
    St(e, "onRenderStart", En(e, t, {
      isPinch: !!t.isPinch
    }));
  },
  drag: function(e, t) {
    St(e, "onRender", this.fillDragParams(e, t));
  },
  dragAfter: function(e, t) {
    if (t.resultCount)
      return this.drag(e, t);
  },
  dragEnd: function(e, t) {
    St(e, "onRenderEnd", this.fillDragEndParams(e, t));
  },
  dragGroupStart: function(e, t) {
    St(e, "onRenderGroupStart", En(e, t, {
      isPinch: !!t.isPinch,
      targets: e.props.targets
    }));
  },
  dragGroup: function(e, t) {
    var n = this, r = ec(e, "beforeRenderable", t), a = e.moveables, s = r.map(function(l, p) {
      var h = a[p];
      return n.fillDragParams(h, l);
    });
    St(e, "onRenderGroup", En(e, t, we(we({
      isPinch: !!t.isPinch,
      targets: e.props.targets,
      transform: hE(t)
    }, Xs(gE(t))), {
      events: s
    })));
  },
  dragGroupEnd: function(e, t) {
    var n = this, r = ec(e, "beforeRenderable", t), a = e.moveables, s = r.map(function(l, p) {
      var h = a[p];
      return n.fillDragEndParams(h, l);
    });
    St(e, "onRenderGroupEnd", En(e, t, we({
      isPinch: !!t.isPinch,
      isDrag: t.isDrag,
      targets: e.props.targets,
      events: s,
      transform: hE(t)
    }, Xs(gE(t)))));
  },
  dragControlStart: function(e, t) {
    return this.dragStart(e, t);
  },
  dragControl: function(e, t) {
    return this.drag(e, t);
  },
  dragControlAfter: function(e, t) {
    return this.dragAfter(e, t);
  },
  dragControlEnd: function(e, t) {
    return this.dragEnd(e, t);
  },
  dragGroupControlStart: function(e, t) {
    return this.dragGroupStart(e, t);
  },
  dragGroupControl: function(e, t) {
    return this.dragGroup(e, t);
  },
  dragGroupControlEnd: function(e, t) {
    return this.dragGroupEnd(e, t);
  },
  fillDragParams: function(e, t) {
    return En(e, t, we({
      isPinch: !!t.isPinch,
      transform: hE(t)
    }, Xs(gE(t))));
  },
  fillDragEndParams: function(e, t) {
    return En(e, t, we({
      isPinch: !!t.isPinch,
      isDrag: t.isDrag,
      transform: hE(t)
    }, Xs(gE(t))));
  }
};
function ib(e, t, n, r, a, s, l) {
  var p = a === "Start", h = e.state.target, y = s.isRequest;
  if (!h || p && r.indexOf("Control") > -1 && !y && e.areaElement === s.inputEvent.target)
    return !1;
  var b = "".concat(n).concat(r).concat(a), E = "".concat(n).concat(r, "Condition"), x = a === "End", C = a === "After", T = p && (!e.targetGesto || !e.controlGesto || !e.targetGesto.isFlag() || !e.controlGesto.isFlag());
  T && e.updateRect(a, !0, !1), s.clientDistX = s.distX, s.clientDistY = s.distY, a === "" && !y && uB(e.state, s);
  var O = jt([], e[t], !0);
  if (y) {
    var D = s.requestAble;
    O.some(function(Q) {
      return Q.name === D;
    }) || O.push.apply(O, e.props.ables.filter(function(Q) {
      return Q.name === D;
    }));
  }
  if (!O.length || O.every(function(Q) {
    return Q.dragRelation;
  }))
    return !1;
  var A = jt(jt([PB], O, !0), [NB], !1).filter(function(Q) {
    return Q[b];
  }), B = s.datas;
  T && A.forEach(function(Q) {
    Q.unset && Q.unset(e);
  });
  var I = s.inputEvent, L;
  x && I && (L = document.elementFromPoint(s.clientX, s.clientY) || I.target);
  var k = 0, $ = !1, U = function() {
    var Q;
    $ = !0, (Q = s.stop) === null || Q === void 0 || Q.call(s);
  }, K = A.filter(function(Q) {
    var Z = Q.name, se = B[Z] || (B[Z] = {});
    if (p && (se.isEventStart = !Q[E] || Q[E](e, s)), se.isEventStart) {
      var pe = Q[b](e, we(we({}, s), {
        stop: U,
        resultCount: k,
        datas: se,
        originalDatas: B,
        inputTarget: L
      }));
      return e._emitter.off(), p && pe === !1 && (se.isEventStart = !1), k += pe ? 1 : 0, pe;
    }
    return !1;
  }), X = K.length, Y = !1;
  if ($ && (Y = !0), !Y && p && A.length && !X && (Y = A.filter(function(Q) {
    var Z = Q.name, se = B[Z];
    return se.isEventStart ? Q.dragRelation !== "strong" : !1;
  }).length), (x || Y) && (e.state.gestos = {}, e.moveables && e.moveables.forEach(function(Q) {
    Q.state.gestos = {};
  }), A.forEach(function(Q) {
    Q.unset && Q.unset(e);
  })), p && !Y && !y && X && (s == null || s.preventDefault()), e.isUnmounted || Y)
    return !1;
  if (!p && X && !l || x) {
    var J = e.props.flushSync || KL;
    J(function() {
      e.updateRect(x ? a : "", !0, !1), e.forceUpdate();
    });
  }
  return !p && !x && !C && X && !l && ib(e, t, n, r, a + "After", s), !0;
}
function nO(e) {
  return function(t) {
    var n = e.props.dragTarget, r = t.inputEvent.target, a = e.areaElement;
    return n && (r === n || n.contains(r)) || r === a || !e.isMoveableElement(r) && !e.controlBox.getElement().contains(r) || Ui(r, "moveable-area") || Ui(r, "moveable-padding") || Ui(r, "moveable-edgeDraggable");
  };
}
function kB(e, t, n) {
  var r = e.controlBox.getElement(), a = [], s = e.props.dragTarget;
  return a.push(r), (!e.props.dragArea || s) && a.push(t), OD(e, a, "targetAbles", n, {
    dragStart: nO(e),
    pinchStart: nO(e)
  });
}
function OD(e, t, n, r, a) {
  a === void 0 && (a = {});
  var s = n === "targetAbles", l = e.props, p = l.pinchOutside, h = l.pinchThreshold, y = l.preventClickEventOnDrag, b = l.preventClickDefault, E = l.checkInput, x = {
    preventDefault: !0,
    preventRightClick: !0,
    preventWheelClick: !0,
    container: window,
    pinchThreshold: h,
    pinchOutside: p,
    preventClickEventOnDrag: s ? y : !1,
    preventClickEventOnDragStart: s ? b : !1,
    preventClickEventByCondition: s ? null : function(O) {
      return e.controlBox.getElement().contains(O.target);
    },
    checkInput: s ? E : !1
  }, C = new NL(t, x), T = r === "Control";
  return ["drag", "pinch"].forEach(function(O) {
    ["Start", "", "End"].forEach(function(D) {
      C.on("".concat(O).concat(D), function(A) {
        var B, I = A.eventType;
        if (a[I] && !a[I](A)) {
          A.stop();
          return;
        }
        var L = ib(e, n, O, r, D, A);
        L ? (e.props.stopPropagation || D === "Start" && T) && ((B = A == null ? void 0 : A.inputEvent) === null || B === void 0 || B.stopPropagation()) : A.stop();
      });
    });
  }), C;
}
var EH = /* @__PURE__ */ function() {
  function e(n, r, a) {
    var s = this;
    this.target = n, this.moveable = r, this.eventName = a, this.ables = [], this._onEvent = function(l) {
      var p = s.eventName, h = s.moveable;
      h.state.disableNativeEvent || s.ables.forEach(function(y) {
        y[p](h, {
          inputEvent: l
        });
      });
    }, n.addEventListener(a.toLowerCase(), this._onEvent);
  }
  var t = e.prototype;
  return t.setAbles = function(n) {
    this.ables = n;
  }, t.destroy = function() {
    this.target.removeEventListener(this.eventName.toLowerCase(), this._onEvent), this.target = null, this.moveable = null;
  }, e;
}();
function xH(e) {
  if (e && e.getRootNode) {
    var t = e.getRootNode();
    if (t.nodeType === 11)
      return t;
  }
}
function yk(e, t, n) {
  for (var r = e, a = [], s = document.documentElement || document.body, l = !n && e === t || e === s, p = l, h = !1, y = 3, b, E, x, C = !1, T = gb(t, t, !0).offsetParent, O = 1; r && !p; ) {
    p = l;
    var D = getComputedStyle(r), A = D.position, B = QL(r, D), I = P5(FW(B)), L = A === "fixed", k = {
      hasTransform: !1,
      fixedContainer: null
    };
    L && (C = !0, k = jW(r), T = k.fixedContainer);
    var $ = I.length;
    !h && $ === 16 && (h = !0, y = 4, qT(a), x && (x = tf(x, 3, 4))), h && $ === 9 && (I = tf(I, 3, 4));
    var U = VW(r, e, D), K = U.tagName, X = U.hasOffset, Y = U.isSVG, J = U.origin, Q = U.targetOrigin, Z = U.offset, se = Z[0], pe = Z[1];
    K === "svg" && x && (a.push({
      type: "target",
      target: r,
      matrix: WW(r, y)
    }), a.push({
      type: "offset",
      target: r,
      matrix: Kr(y)
    }));
    var be = void 0, _e = !1, Se = !1, Oe = parseFloat(D.zoom) || 1;
    if (L)
      be = k.fixedContainer, _e = !0;
    else {
      var re = gb(r, t, !1, !0, D), ie = re.offsetZoom;
      if (be = re.offsetParent, _e = re.isEnd, Se = re.isStatic, O *= ie, ie !== 1 && Se)
        se -= be.offsetLeft, pe -= be.offsetTop;
      else if (bW) {
        var ce = re.parentSlotElement;
        if (ce) {
          for (var le = be, fe = 0, ve = 0; le && xH(le); )
            fe += le.offsetLeft, ve += le.offsetTop, le = le.offsetParent;
          se -= fe, pe -= ve;
        }
      }
    }
    BL && !_W && X && !Y && Se && (A === "relative" || A === "static") && (se -= be.offsetLeft, pe -= be.offsetTop, l = l || _e);
    var ee = 0, Ae = 0, he = 0, Fe = 0;
    if (L)
      X && k.hasTransform && (he = be.clientLeft, Fe = be.clientTop);
    else if (X && T !== be && (ee = be.clientLeft, Ae = be.clientTop), X && be === s) {
      var Ne = ZL(r, !1, D);
      se += Ne[0], pe += Ne[1];
    }
    if (a.push({
      type: "target",
      target: r,
      matrix: dx(I, y, J)
    }), X) {
      var xe = r === e, oe = xe ? 0 : r.scrollLeft, it = xe ? 0 : r.scrollTop;
      a.push({
        type: "offset",
        target: r,
        matrix: hb([se - oe + ee - he, pe - it + Ae - Fe], y)
      });
    } else
      a.push({
        type: "offset",
        target: r,
        origin: J
      });
    if (Oe !== 1 && a.push({
      type: "zoom",
      target: r,
      matrix: dx(aD([Oe, Oe], y), y, [0, 0])
    }), x || (x = I), b || (b = J), E || (E = Q), p || L)
      break;
    r = be, l = _e, (!n || r === s) && (p = l);
  }
  return x || (x = Kr(y)), b || (b = [0, 0]), E || (E = [0, 0]), {
    zoom: O,
    offsetContainer: T,
    matrixes: a,
    targetMatrix: x,
    transformOrigin: b,
    targetOrigin: E,
    is3d: h,
    hasFixed: C
  };
}
function SH(e, t, n, r) {
  var a;
  n === void 0 && (n = t);
  var s = yk(e, t), l = s.matrixes, p = s.is3d, h = s.targetMatrix, y = s.transformOrigin, b = s.targetOrigin, E = s.offsetContainer, x = s.hasFixed, C = s.zoom, T = yk(E, n, !0), O = T.matrixes, D = T.is3d, A = T.offsetContainer, B = T.zoom, I = r || D || p, L = I ? 4 : 3, k = e.tagName.toLowerCase() !== "svg" && "ownerSVGElement" in e, $ = h, U = Kr(L), K = Kr(L), X = Kr(L), Y = Kr(L), J = l.length;
  O.reverse(), l.reverse(), !p && I && ($ = tf($, 3, 4), qT(l)), !D && I && qT(O), O.forEach(function(Se) {
    K = yr(K, Se.matrix, L);
  });
  var Q = n || document.body, Z = ((a = O[0]) === null || a === void 0 ? void 0 : a.target) || gb(Q, Q, !0).offsetParent, se = O.slice(1).reduce(function(Se, Oe) {
    return yr(Se, Oe.matrix, L);
  }, Kr(L));
  l.forEach(function(Se, Oe) {
    if (J - 2 === Oe && (X = U.slice()), J - 1 === Oe && (Y = U.slice()), !Se.matrix) {
      var re = l[Oe + 1], ie = HW(Se, re, Z, L, yr(se, U, L));
      Se.matrix = hb(ie, L);
    }
    U = yr(U, Se.matrix, L);
  });
  var pe = !k && p;
  $ || ($ = Kr(pe ? 4 : 3));
  var be = Gx(k && $.length === 16 ? tf($, 4, 3) : $, pe), _e = K;
  return K = CL(K, L, L), {
    hasZoom: C !== 1 || B !== 1,
    hasFixed: x,
    rootMatrix: K,
    originalRootMatrix: _e,
    beforeMatrix: X,
    offsetMatrix: Y,
    allMatrix: U,
    targetMatrix: $,
    targetTransform: be,
    transformOrigin: y,
    targetOrigin: b,
    is3d: I,
    offsetContainer: E,
    offsetRootContainer: A
  };
}
function wH(e, t, n, r) {
  n === void 0 && (n = t);
  var a = 0, s = 0, l = 0, p = {}, h = eB(e);
  if (e && (a = h.offsetWidth, s = h.offsetHeight), e) {
    var y = SH(e, t, n, r), b = ry(y.allMatrix, y.transformOrigin, a, s);
    p = we(we({}, y), b);
    var E = ry(y.allMatrix, [50, 50], 100, 100);
    l = tB([E.pos1, E.pos2], E.direction);
  }
  var x = r ? 4 : 3;
  return we(we(we({
    hasZoom: !1,
    width: a,
    height: s,
    rotation: l
  }, h), {
    originalRootMatrix: Kr(x),
    rootMatrix: Kr(x),
    beforeMatrix: Kr(x),
    offsetMatrix: Kr(x),
    allMatrix: Kr(x),
    targetMatrix: Kr(x),
    targetTransform: "",
    transformOrigin: [0, 0],
    targetOrigin: [0, 0],
    is3d: !!r,
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    origin: [0, 0],
    pos1: [0, 0],
    pos2: [0, 0],
    pos3: [0, 0],
    pos4: [0, 0],
    direction: 1,
    hasFixed: !1,
    offsetContainer: null,
    offsetRootContainer: null
  }), p);
}
function rO(e, t, n, r, a, s) {
  s === void 0 && (s = []);
  var l = 1, p = [0, 0], h = mE(), y = mE(), b = mE(), E = mE(), x = {}, C = wH(t, n, a, !0);
  if (t) {
    var T = getComputedStyle(t);
    s.forEach(function($) {
      x[$] = T[$];
    });
    var O = C.is3d ? 4 : 3, D = ry(C.offsetMatrix, On(C.transformOrigin, RL(C.targetMatrix, O)), C.width, C.height);
    l = D.direction, p = On(D.origin, [D.left - C.left, D.top - C.top]), E = Q0(C.offsetRootContainer);
    var A = gb(r, r, !0).offsetParent || C.offsetRootContainer;
    if (C.hasZoom) {
      var B = ry(yr(C.originalRootMatrix, C.allMatrix), C.transformOrigin, C.width, C.height), I = ry(C.originalRootMatrix, px(getComputedStyle(A)).map(function($) {
        return parseFloat($);
      }), A.offsetWidth, A.offsetHeight);
      if (h = XR(B, E), b = XR(I, E, A, !0), e) {
        var L = B.left, k = B.top;
        y = XR({
          left: L,
          top: k,
          bottom: k,
          right: k
        }, E);
      }
    } else
      h = Q0(t), b = Q0(A, !0), e && (y = Q0(e));
  }
  return we({
    targetClientRect: h,
    containerClientRect: b,
    moveableClientRect: y,
    rootContainerClientRect: E,
    beforeDirection: l,
    beforeOrigin: p,
    originalBeforeOrigin: p,
    target: t,
    style: x
  }, C);
}
function bk(e) {
  var t = e.pos1, n = e.pos2, r = e.pos3, a = e.pos4;
  if (!t || !n || !r || !a)
    return null;
  var s = Zp([t, n, r, a]), l = [s.minX, s.minY], p = Bt(e.origin, l);
  return t = Bt(t, l), n = Bt(n, l), r = Bt(r, l), a = Bt(a, l), we(we({}, e), {
    left: e.left,
    top: e.top,
    posDelta: l,
    pos1: t,
    pos2: n,
    pos3: r,
    pos4: a,
    origin: p,
    beforeOrigin: p,
    isPersisted: !0
  });
}
var by = /* @__PURE__ */ function(e) {
  Ub(t, e);
  function t() {
    var r = e !== null && e.apply(this, arguments) || this;
    return r.state = we({
      container: null,
      gestos: {},
      renderPoses: [[0, 0], [0, 0], [0, 0], [0, 0]],
      disableNativeEvent: !1,
      posDelta: [0, 0]
    }, rO(null)), r.renderState = {}, r.enabledAbles = [], r.targetAbles = [], r.controlAbles = [], r.rotation = 0, r.scale = [1, 1], r.isMoveableMounted = !1, r.isUnmounted = !1, r.events = {
      mouseEnter: null,
      mouseLeave: null
    }, r._emitter = new $b(), r._prevTarget = null, r._prevDragArea = !1, r._isPropTargetChanged = !1, r._hasFirstTarget = !1, r._observer = null, r._observerId = 0, r._rootContainer = null, r._viewContainer = null, r._viewClassNames = [], r.checkUpdateRect = function() {
      if (!r.isDragging()) {
        var a = r.props.parentMoveable;
        if (a) {
          a.checkUpdateRect();
          return;
        }
        S5(r._observerId), r._observerId = xL(function() {
          r.isDragging() || r.updateRect();
        });
      }
    }, r._onPreventClick = function(a) {
      a.stopPropagation(), a.preventDefault();
    }, r;
  }
  var n = t.prototype;
  return n.render = function() {
    var r = this.props, a = this.getState(), s = r.parentPosition, l = r.className, p = r.target, h = r.zoom, y = r.cspNonce, b = r.translateZ, E = r.cssStyled, x = r.portalContainer, C = r.groupable;
    this._checkUpdateRootContainer(), this.checkUpdate(), this.updateRenderPoses();
    var T = s || [0, 0], O = T[0], D = T[1], A = a.left, B = a.top, I = a.target, L = a.direction, k = a.hasFixed, $ = r.targets, U = this.isDragging(), K = {};
    this.getEnabledAbles().forEach(function(Q) {
      K["data-able-".concat(Q.name.toLowerCase())] = !0;
    });
    var X = this._getAbleClassName(), Y = $ && $.length && (I || C) || p || !this._hasFirstTarget && this.state.isPersisted, J = this.controlBox || this.props.firstRenderState || this.props.persistData;
    return /* @__PURE__ */ qi(E, {
      ...we({
        cspNonce: y,
        ref: hd(this, "controlBox"),
        className: "".concat($t("control-box", L === -1 ? "reverse" : "", U ? "dragging" : ""), " ").concat(X, " ").concat(l)
      }, K, {
        onClick: this._onPreventClick,
        portalContainer: x,
        style: {
          position: k ? "fixed" : "absolute",
          display: Y ? "block" : "none",
          visibility: J ? "visible" : "hidden",
          transform: "translate3d(".concat(A - O, "px, ").concat(B - D, "px, ").concat(b, ")"),
          "--zoom": h,
          "--zoompx": "".concat(h, "px")
        }
      }),
      children: [this.renderAbles(), this._renderLines()]
    });
  }, n.componentDidMount = function() {
    this.isMoveableMounted = !0, this.isUnmounted = !1, this.controlBox.getElement();
    var r = this.props, a = r.parentMoveable, s = r.container, l = r.wrapperMoveable;
    this._checkUpdateRootContainer(), this._checkUpdateViewContainer(), this._updateTargets(), this._updateNativeEvents(), this._updateEvents(), this.updateCheckInput(), this._updateObserver(this.props), !s && !a && !l && !this.state.isPersisted && (this.updateRect("", !1, !1), this.forceUpdate());
  }, n.componentDidUpdate = function(r) {
    this._checkUpdateRootContainer(), this._checkUpdateViewContainer(), this._updateNativeEvents(), this._updateEvents(), this._updateTargets(), this.updateCheckInput(), this._updateObserver(r);
  }, n.componentWillUnmount = function() {
    this.isMoveableMounted = !1, this.isUnmounted = !0, this._emitter.off();
    var r = this._viewContainer;
    r && this._changeAbleViewClassNames([]), Qm(this, "targetGesto"), Qm(this, "controlGesto");
    var a = this.events;
    for (var s in a) {
      var l = a[s];
      l && l.destroy();
    }
  }, n.getTargets = function() {
    var r = this.props.target;
    return r ? [r] : [];
  }, n.getAble = function(r) {
    var a = this.props.ables || [];
    return bd(a, function(s) {
      return s.name === r;
    });
  }, n.getContainer = function() {
    var r = this.props, a = r.parentMoveable, s = r.wrapperMoveable, l = r.container;
    return l || s && s.getContainer() || a && a.getContainer() || this.controlBox.getElement().parentElement;
  }, n.isMoveableElement = function(r) {
    var a;
    return r && (((a = r.getAttribute) === null || a === void 0 ? void 0 : a.call(r, "class")) || "").indexOf(cD) > -1;
  }, n.dragStart = function(r) {
    var a = this.targetGesto, s = this.controlGesto;
    return a && nO(this)({
      inputEvent: r
    }) ? a.isFlag() || a.triggerDragStart(r) : s && this.isMoveableElement(r.target) && (s.isFlag() || s.triggerDragStart(r)), this;
  }, n.hitTest = function(r) {
    var a = this.state, s = a.target, l = a.pos1, p = a.pos2, h = a.pos3, y = a.pos4, b = a.targetClientRect;
    if (!s)
      return 0;
    var E;
    if (r instanceof Element) {
      var x = r.getBoundingClientRect();
      E = {
        left: x.left,
        top: x.top,
        width: x.width,
        height: x.height
      };
    } else
      E = we({
        width: 0,
        height: 0
      }, r);
    var C = E.left, T = E.top, O = E.width, D = E.height, A = BT([l, p, y, h], b), B = K5(A, [[C, T], [C + O, T], [C + O, T + D], [C, T + D]]), I = nb(A);
    return !B || !I ? 0 : Math.min(100, B / I * 100);
  }, n.isInside = function(r, a) {
    var s = this.state, l = s.target, p = s.pos1, h = s.pos2, y = s.pos3, b = s.pos4, E = s.targetClientRect;
    return l ? ux([r, a], BT([p, h, b, y], E)) : !1;
  }, n.updateRect = function(r, a, s) {
    s === void 0 && (s = !0);
    var l = this.props, p = l.parentMoveable, h = this.state, y = h.target || this.props.target, b = this.getContainer(), E = p ? p._rootContainer : this._rootContainer, x = rO(this.controlBox && this.controlBox.getElement(), y, b, b, E || b, this._getRequestStyles());
    if (!y && this._hasFirstTarget && l.persistData) {
      var C = bk(l.persistData);
      for (var T in C)
        x[T] = C[T];
    }
    this.updateState(x, p ? !1 : s);
  }, n.isDragging = function(r) {
    var a, s, l = this.targetGesto, p = this.controlGesto;
    if (l != null && l.isFlag()) {
      if (!r)
        return !0;
      var h = l.getEventData();
      return !!(!((a = h[r]) === null || a === void 0) && a.isEventStart);
    }
    if (p != null && p.isFlag()) {
      if (!r)
        return !0;
      var h = p.getEventData();
      return !!(!((s = h[r]) === null || s === void 0) && s.isEventStart);
    }
    return !1;
  }, n.updateTarget = function(r) {
    this.updateRect(r, !0);
  }, n.getRect = function() {
    var r = this.state, a = is(this.state), s = a[0], l = a[1], p = a[2], h = a[3], y = el(a), b = r.width, E = r.height, x = y.width, C = y.height, T = y.left, O = y.top, D = [r.left, r.top], A = On(D, r.origin), B = On(D, r.beforeOrigin), I = r.transformOrigin;
    return {
      width: x,
      height: C,
      left: T,
      top: O,
      pos1: s,
      pos2: l,
      pos3: p,
      pos4: h,
      offsetWidth: b,
      offsetHeight: E,
      beforeOrigin: B,
      origin: A,
      transformOrigin: I,
      rotation: this.getRotation()
    };
  }, n.getManager = function() {
    return this;
  }, n.stopDrag = function(r) {
    var a, s;
    (!r || r === "target") && ((a = this.targetGesto) === null || a === void 0 || a.stop()), (!r || r === "control") && ((s = this.controlGesto) === null || s === void 0 || s.stop());
  }, n.getRotation = function() {
    var r = this.state, a = r.pos1, s = r.pos2, l = r.direction;
    return JW(a, s, l);
  }, n.request = function(r, a, s) {
    a === void 0 && (a = {});
    var l = this.props, p = l.ables, h = l.groupable, y = p.filter(function(D) {
      return D.name === r;
    })[0];
    if (this.isDragging() || !y || !y.request)
      return {
        request: function() {
          return this;
        },
        requestEnd: function() {
          return this;
        }
      };
    var b = this, E = y.request(this), x = s || a.isInstant, C = E.isControl ? "controlAbles" : "targetAbles", T = "".concat(h ? "Group" : "").concat(E.isControl ? "Control" : ""), O = {
      request: function(D) {
        return ib(b, C, "drag", T, "", we(we({}, E.request(D)), {
          requestAble: r,
          isRequest: !0
        }), x), this;
      },
      requestEnd: function() {
        return ib(b, C, "drag", T, "End", we(we({}, E.requestEnd()), {
          requestAble: r,
          isRequest: !0
        }), x), this;
      }
    };
    return ib(b, C, "drag", T, "Start", we(we({}, E.requestStart(a)), {
      requestAble: r,
      isRequest: !0
    }), x), x ? O.request(a).requestEnd() : O;
  }, n.destroy = function() {
    this.componentWillUnmount();
  }, n.updateRenderPoses = function() {
    var r = this.getState(), a = this.props, s = r.originalBeforeOrigin, l = r.transformOrigin, p = r.allMatrix, h = r.is3d, y = r.pos1, b = r.pos2, E = r.pos3, x = r.pos4, C = r.left, T = r.top, O = r.isPersisted, D = a.padding || {}, A = D.left, B = A === void 0 ? 0 : A, I = D.top, L = I === void 0 ? 0 : I, k = D.bottom, $ = k === void 0 ? 0 : k, U = D.right, K = U === void 0 ? 0 : U, X = h ? 4 : 3, Y = [];
    O ? Y = l : this.controlBox && a.groupable ? Y = s : Y = On(s, [C, T]), r.renderPoses = [On(y, bE(p, [-B, -L], l, Y, X)), On(b, bE(p, [K, -L], l, Y, X)), On(E, bE(p, [-B, $], l, Y, X)), On(x, bE(p, [K, $], l, Y, X))];
  }, n.checkUpdate = function() {
    this._isPropTargetChanged = !1;
    var r = this.props, a = r.target, s = r.container, l = r.parentMoveable, p = this.state, h = p.target, y = p.container;
    if (!(!h && !a)) {
      this.updateAbles();
      var b = !XT(h, a), E = b || !XT(y, s);
      if (!!E) {
        var x = s || this.controlBox;
        x && this.unsetAbles(), this.updateState({
          target: a,
          container: s
        }), !l && x && this.updateRect("End", !1, !1), this._isPropTargetChanged = b;
      }
    }
  }, n.waitToChangeTarget = function() {
    return new Promise(function() {
    });
  }, n.triggerEvent = function(r, a) {
    this._emitter.trigger(r, a);
    var s = this.props[r];
    return s && s(a);
  }, n.useCSS = function(r, a) {
    var s = this.props.customStyledMap, l = r + a;
    return s[l] || (s[l] = LL(r, a)), s[l];
  }, n.getState = function() {
    var r, a = this.props;
    (a.target || ((r = a.targets) === null || r === void 0 ? void 0 : r.length)) && (this._hasFirstTarget = !0);
    var s = this.controlBox, l = a.persistData, p = a.firstRenderState;
    if (p && !s)
      return p;
    if (!this._hasFirstTarget && l) {
      var h = bk(l);
      if (h)
        return this.updateState(h, !1), this.state;
    }
    return this.state.isPersisted = !1, this.state;
  }, n.updateSelectors = function() {
  }, n.unsetAbles = function() {
    var r = this;
    this.targetAbles.forEach(function(a) {
      a.unset && a.unset(r);
    });
  }, n.updateAbles = function(r, a) {
    r === void 0 && (r = this.props.ables), a === void 0 && (a = "");
    var s = this.props, l = s.triggerAblesSimultaneously, p = this.getEnabledAbles(r), h = "drag".concat(a, "Start"), y = "pinch".concat(a, "Start"), b = "drag".concat(a, "ControlStart"), E = yE(p, [h, y], l), x = yE(p, [b], l);
    this.enabledAbles = p, this.targetAbles = E, this.controlAbles = x;
  }, n.updateState = function(r, a) {
    if (a) {
      if (this.isUnmounted)
        return;
      this.setState(r);
    } else {
      var s = this.state;
      for (var l in r)
        s[l] = r[l];
    }
  }, n.getEnabledAbles = function(r) {
    r === void 0 && (r = this.props.ables);
    var a = this.props;
    return r.filter(function(s) {
      return s && (s.always && a[s.name] !== !1 || a[s.name]);
    });
  }, n.renderAbles = function() {
    var r = this, a = this.props, s = a.triggerAblesSimultaneously, l = {
      createElement: Ks
    };
    return this.renderState = {}, KW(sB(yE(this.getEnabledAbles(), ["render"], s).map(function(p) {
      var h = p.render;
      return h(r, l) || [];
    })).filter(function(p) {
      return p;
    }), function(p) {
      var h = p.key;
      return h;
    }).map(function(p) {
      return p[0];
    });
  }, n.updateCheckInput = function() {
    this.targetGesto && (this.targetGesto.options.checkInput = this.props.checkInput);
  }, n._getRequestStyles = function() {
    var r = this.getEnabledAbles().reduce(function(a, s) {
      var l, p, h = (p = (l = s.requestStyle) === null || l === void 0 ? void 0 : l.call(s)) !== null && p !== void 0 ? p : [];
      return jt(jt([], a, !0), h, !0);
    }, []);
    return r;
  }, n._updateObserver = function(r) {
    var a, s = this.props, l = s.target;
    if (!window.ResizeObserver || !l || !s.useResizeObserver) {
      (a = this._observer) === null || a === void 0 || a.disconnect();
      return;
    }
    if (!(r.target === l && this._observer)) {
      var p = new ResizeObserver(this.checkUpdateRect);
      p.observe(l, {
        box: "border-box"
      }), this._observer = p;
    }
  }, n._updateEvents = function() {
    var r = this.controlBox.getElement(), a = this.targetAbles.length, s = this.controlAbles.length, l = this.props, p = l.dragTarget || l.target, h = !a && this.targetGesto || this._isTargetChanged(!0);
    h && (Qm(this, "targetGesto"), this.updateState({
      gesto: null
    })), s || Qm(this, "controlGesto"), p && a && !this.targetGesto && (this.targetGesto = kB(this, p, "")), !this.controlGesto && s && (this.controlGesto = OD(this, r, "controlAbles", "Control"));
  }, n._updateTargets = function() {
    var r = this.props;
    this._prevTarget = r.dragTarget || r.target, this._prevDragArea = r.dragArea;
  }, n._renderLines = function() {
    var r = this.props, a = r, s = a.zoom, l = a.hideDefaultLines, p = a.hideChildMoveableDefaultLines, h = a.parentMoveable;
    if (l || h && p)
      return [];
    var y = this.getState().renderPoses, b = {
      createElement: Ks
    };
    return [[0, 1], [1, 3], [3, 2], [2, 0]].map(function(E, x) {
      var C = E[0], T = E[1];
      return mb(b, "", y[C], y[T], s, "render-line-".concat(x));
    });
  }, n._isTargetChanged = function(r) {
    var a = this.props, s = a.dragTarget || a.target, l = this._prevTarget, p = this._prevDragArea, h = a.dragArea, y = !h && l !== s, b = (r || h) && p !== h;
    return y || b;
  }, n._updateNativeEvents = function() {
    var r = this, a = this.props, s = a.dragArea ? this.areaElement : this.state.target, l = this.events, p = Oy(l);
    if (this._isTargetChanged())
      for (var h in l) {
        var y = l[h];
        y && y.destroy(), l[h] = null;
      }
    if (!!s) {
      var b = this.enabledAbles;
      p.forEach(function(E) {
        var x = yE(b, [E]), C = x.length > 0, T = l[E];
        if (!C) {
          T && (T.destroy(), l[E] = null);
          return;
        }
        T || (T = new EH(s, r, E), l[E] = T), T.setAbles(x);
      });
    }
  }, n._checkUpdateRootContainer = function() {
    var r = this.props.rootContainer;
    !this._rootContainer && r && (this._rootContainer = Jh(r, !0));
  }, n._checkUpdateViewContainer = function() {
    var r = this.props.viewContainer;
    !this._viewContainer && r && (this._viewContainer = Jh(r, !0));
    var a = this._viewContainer;
    a && this._changeAbleViewClassNames(jt(jt([], this._getAbleViewClassNames(), !0), [this.isDragging() ? JG : ""], !1));
  }, n._changeAbleViewClassNames = function(r) {
    var a = this._viewContainer, s = oB(r.filter(Boolean), function(b) {
      return b;
    }).map(function(b) {
      var E = b[0];
      return E;
    }), l = this._viewClassNames, p = uD(l, s), h = p.removed, y = p.added;
    h.forEach(function(b) {
      wL(a, l[b]);
    }), y.forEach(function(b) {
      iD(a, s[b]);
    }), this._viewClassNames = s;
  }, n._getAbleViewClassNames = function() {
    var r = this;
    return (this.getEnabledAbles().map(function(a) {
      var s;
      return ((s = a.viewClassName) === null || s === void 0 ? void 0 : s.call(a, r)) || "";
    }).join(" ") + " ".concat(this._getAbleClassName("-view"))).split(/\s+/g);
  }, n._getAbleClassName = function(r) {
    var a = this;
    r === void 0 && (r = "");
    var s = this.getEnabledAbles(), l = this.targetGesto, p = this.controlGesto, h = l != null && l.isFlag() ? l.getEventData() : {}, y = p != null && p.isFlag() ? p.getEventData() : {};
    return s.map(function(b) {
      var E, x, C, T = b.name, O = ((E = b.className) === null || E === void 0 ? void 0 : E.call(b, a)) || "";
      return (((x = h[T]) === null || x === void 0 ? void 0 : x.isEventStart) || ((C = y[T]) === null || C === void 0 ? void 0 : C.isEventStart)) && (O += " ".concat($t("".concat(T).concat(r, "-dragging")))), O.trim();
    }).filter(Boolean).join(" ");
  }, t.defaultProps = {
    target: null,
    dragTarget: null,
    container: null,
    rootContainer: null,
    origin: !0,
    parentMoveable: null,
    wrapperMoveable: null,
    isWrapperMounted: !1,
    parentPosition: null,
    portalContainer: null,
    useResizeObserver: !1,
    ables: [],
    pinchThreshold: 20,
    dragArea: !1,
    passDragArea: !1,
    transformOrigin: "",
    className: "",
    zoom: 1,
    triggerAblesSimultaneously: !1,
    padding: {},
    pinchOutside: !0,
    checkInput: !1,
    groupable: !1,
    hideDefaultLines: !1,
    cspNonce: "",
    translateZ: 0,
    cssStyled: null,
    customStyledMap: {},
    props: {},
    stopPropagation: !1,
    preventClickDefault: !1,
    preventClickEventOnDrag: !0,
    flushSync: KL,
    firstRenderState: null,
    persistData: null,
    viewContainer: null
  }, t;
}(Ze.PureComponent), DD = {
  name: "groupable",
  props: {
    defaultGroupRotate: Number,
    defaultGroupOrigin: String,
    groupable: Boolean,
    groupableProps: Object,
    targetGroups: Object,
    hideChildMoveableDefaultLines: Boolean
  },
  events: {},
  render: function(e, t) {
    var n, r = e.props, a = r.targets || [];
    e.moveables = [];
    var s = e.getState(), l = s.left, p = s.top, h = s.isPersisted, y = [l, p], b = r.zoom || 1, E = e.renderGroupRects, x = ((n = r.persistData) === null || n === void 0 ? void 0 : n.children) || [];
    return h ? a = x.map(function() {
      return null;
    }) : x = [], jt(jt([], a.map(function(C, T) {
      return /* @__PURE__ */ He(by, {
        ref: mL(e, "moveables", T),
        target: C,
        origin: !1,
        cssStyled: r.cssStyled,
        customStyledMap: r.customStyledMap,
        useResizeObserver: r.useResizeObserver,
        hideChildMoveableDefaultLines: r.hideChildMoveableDefaultLines,
        parentMoveable: e,
        parentPosition: y,
        persistData: x[T],
        zoom: b
      }, "moveable" + T);
    }), !0), sB(E.map(function(C, T) {
      var O = C.pos1, D = C.pos2, A = C.pos3, B = C.pos4, I = [O, D, A, B];
      return [[0, 1], [1, 3], [3, 2], [2, 0]].map(function(L, k) {
        var $ = L[0], U = L[1];
        return mb(t, "", Bt(I[$], y), Bt(I[U], y), b, "group-rect-".concat(T, "-").concat(k));
      });
    })), !0);
  }
}, CH = Vb("clickable", {
  props: {
    clickable: Boolean
  },
  events: {
    onClick: "click",
    onClickGroup: "clickGroup"
  },
  always: !0,
  dragRelation: "weak",
  dragStart: function() {
  },
  dragControlStart: function() {
  },
  dragGroupStart: function(e, t) {
    t.datas.inputTarget = t.inputEvent && t.inputEvent.target;
  },
  dragEnd: function(e, t) {
    var n = e.props.target, r = t.inputEvent, a = t.inputTarget, s = e.isMoveableElement(a), l = !s && e.controlBox.getElement().contains(a);
    if (!(!r || !a || t.isDrag || e.isMoveableElement(a) || l)) {
      var p = n.contains(a);
      St(e, "onClick", En(e, t, {
        isDouble: t.isDouble,
        inputTarget: a,
        isTarget: n === a,
        moveableTarget: e.props.target,
        containsTarget: p
      }));
    }
  },
  dragGroupEnd: function(e, t) {
    var n = t.inputEvent, r = t.inputTarget;
    if (!(!n || !r || t.isDrag || e.isMoveableElement(r) || t.datas.inputTarget === r)) {
      var a = e.props.targets, s = a.indexOf(r), l = s > -1, p = !1;
      s === -1 && (s = yd(a, function(h) {
        return h.contains(r);
      }), p = s > -1), St(e, "onClickGroup", En(e, t, {
        isDouble: t.isDouble,
        targets: a,
        inputTarget: r,
        targetIndex: s,
        isTarget: l,
        containsTarget: p,
        moveableTarget: a[s]
      }));
    }
  },
  dragControlEnd: function(e, t) {
    this.dragEnd(e, t);
  },
  dragGroupControlEnd: function(e, t) {
    this.dragEnd(e, t);
  }
});
function Nm(e) {
  var t = e.originalDatas.draggable;
  return t || (e.originalDatas.draggable = {}, t = e.originalDatas.draggable), we(we({}, e), {
    datas: t
  });
}
var RH = Vb("edgeDraggable", {
  css: [`.edge.edgeDraggable.line {
    cursor: move;
}`],
  render: function(e, t) {
    var n = e.props, r = n.edgeDraggable;
    return r ? xB(t, "edgeDraggable", r, e.getState().renderPoses, n.zoom) : [];
  },
  dragCondition: function(e, t) {
    var n, r = e.props, a = (n = t.inputEvent) === null || n === void 0 ? void 0 : n.target;
    return !r.edgeDraggable || !a ? !1 : !r.draggable && Ui(a, $t("direction")) && Ui(a, $t("edge")) && Ui(a, $t("edgeDraggable"));
  },
  dragStart: function(e, t) {
    return wo.dragStart(e, Nm(t));
  },
  drag: function(e, t) {
    return wo.drag(e, Nm(t));
  },
  dragEnd: function(e, t) {
    return wo.dragEnd(e, Nm(t));
  },
  dragGroupCondition: function(e, t) {
    var n, r = e.props, a = (n = t.inputEvent) === null || n === void 0 ? void 0 : n.target;
    return !r.edgeDraggable || !a ? !1 : !r.draggable && Ui(a, $t("direction")) && Ui(a, $t("line"));
  },
  dragGroupStart: function(e, t) {
    return wo.dragGroupStart(e, Nm(t));
  },
  dragGroup: function(e, t) {
    return wo.dragGroup(e, Nm(t));
  },
  dragGroupEnd: function(e, t) {
    return wo.dragGroupEnd(e, Nm(t));
  },
  unset: function(e) {
    return wo.unset(e);
  }
}), IB = {
  name: "individualGroupable",
  props: {
    individualGroupable: Boolean
  },
  events: {}
}, TH = [PB, OB, jG, nG, wo, RH, eO, XG, QG, qG, nH, rH, eH, hH, vH, bH, DD, IB, CH, TB, NB];
function _k(e, t) {
  var n = e[0], r = e[1], a = e[2];
  return (n * t[0] + r * t[1] + a) / Math.sqrt(n * n + r * r);
}
function SE(e, t) {
  var n = e[0], r = e[1];
  return -n * t[0] - r * t[1];
}
function Ek(e, t) {
  return Math.max.apply(Math, e.map(function(n) {
    var r = n[0], a = n[1], s = n[2], l = n[3];
    return Math.max(r[t], a[t], s[t], l[t]);
  }));
}
function xk(e, t) {
  return Math.min.apply(Math, e.map(function(n) {
    var r = n[0], a = n[1], s = n[2], l = n[3];
    return Math.min(r[t], a[t], s[t], l[t]);
  }));
}
function OH(e, t) {
  var n, r = [0, 0], a = [0, 0], s = [0, 0], l = [0, 0], p = 0, h = 0;
  if (!e.length)
    return {
      pos1: r,
      pos2: a,
      pos3: s,
      pos4: l,
      minX: 0,
      minY: 0,
      maxX: 0,
      maxY: 0,
      width: p,
      height: h,
      rotation: t
    };
  var y = hn(t, Ro);
  if (y % 90) {
    var b = y / 180 * Math.PI, E = Math.tan(b), x = -1 / E, C = [HT, qN], T = [[0, 0], [0, 0]], O = [HT, qN], D = [[0, 0], [0, 0]];
    e.forEach(function(Oe) {
      Oe.forEach(function(re) {
        var ie = _k([-E, 1, 0], re), ce = _k([-x, 1, 0], re);
        C[0] > ie && (T[0] = re, C[0] = ie), C[1] < ie && (T[1] = re, C[1] = ie), O[0] > ce && (D[0] = re, O[0] = ce), O[1] < ce && (D[1] = re, O[1] = ce);
      });
    });
    var A = T[0], B = T[1], I = D[0], L = D[1], k = [-E, 1, SE([-E, 1], A)], $ = [-E, 1, SE([-E, 1], B)], U = [-x, 1, SE([-x, 1], I)], K = [-x, 1, SE([-x, 1], L)];
    n = [[k, U], [k, K], [$, U], [$, K]].map(function(Oe) {
      var re = Oe[0], ie = Oe[1];
      return lD(re, ie)[0];
    }), r = n[0], a = n[1], s = n[2], l = n[3], p = O[1] - O[0], h = C[1] - C[0];
  } else {
    var X = xk(e, 0), Y = xk(e, 1), J = Ek(e, 0), Q = Ek(e, 1);
    if (r = [X, Y], a = [J, Y], s = [X, Q], l = [J, Q], p = J - X, h = Q - Y, y % 180) {
      var Z = [s, r, l, a];
      r = Z[0], a = Z[1], s = Z[2], l = Z[3], p = Q - Y, h = J - X;
    }
  }
  if (y % 360 > 180) {
    var Z = [l, s, a, r];
    r = Z[0], a = Z[1], s = Z[2], l = Z[3];
  }
  var se = Zp([r, a, s, l]), pe = se.minX, be = se.minY, _e = se.maxX, Se = se.maxY;
  return {
    pos1: r,
    pos2: a,
    pos3: s,
    pos4: l,
    width: p,
    height: h,
    minX: pe,
    minY: be,
    maxX: _e,
    maxY: Se,
    rotation: t
  };
}
function LB(e, t) {
  var n = t.map(function(r) {
    if (Ki(r)) {
      var a = LB(e, r), s = a.length;
      return s > 1 ? a : s === 1 ? a[0] : null;
    } else {
      var l = bd(e, function(p) {
        var h = p.manager;
        return h.props.target === r;
      });
      return l ? (l.finded = !0, l.manager) : null;
    }
  }).filter(Boolean);
  return n.length === 1 && Ki(n[0]) ? n[0] : n;
}
var DH = /* @__PURE__ */ function(e) {
  Ub(t, e);
  function t() {
    var r = e !== null && e.apply(this, arguments) || this;
    return r.differ = new DL(), r.moveables = [], r.transformOrigin = "50% 50%", r.renderGroupRects = [], r._hasFirstTargets = !1, r;
  }
  var n = t.prototype;
  return n.componentDidMount = function() {
    e.prototype.componentDidMount.call(this);
  }, n.checkUpdate = function() {
    this._isPropTargetChanged = !1, this.updateAbles();
  }, n.getTargets = function() {
    return this.props.targets;
  }, n.updateRect = function(r, a, s) {
    var l;
    s === void 0 && (s = !0);
    var p = this.state;
    if (!this.controlBox || p.isPersisted)
      return;
    this.moveables.forEach(function(Ae) {
      Ae.updateRect(r, !1, !1);
    });
    var h = this.props, y = this.moveables, b = p.target || h.target, E = y.map(function(Ae) {
      return {
        finded: !1,
        manager: Ae
      };
    }), x = LB(E, this.props.targetGroups || []);
    x.push.apply(x, E.filter(function(Ae) {
      var he = Ae.finded;
      return !he;
    }).map(function(Ae) {
      var he = Ae.manager;
      return he;
    }));
    var C = [], T = !a || r !== "" && h.updateGroup, O = h.defaultGroupRotate || 0;
    if (!this._hasFirstTargets) {
      var D = (l = this.props.persistData) === null || l === void 0 ? void 0 : l.rotation;
      D != null && (O = D);
    }
    function A(Ae, he, Fe) {
      var Ne = Ae.map(function(Qe) {
        if (Ki(Qe)) {
          var pt = A(Qe, he), en = [pt.pos1, pt.pos2, pt.pos3, pt.pos4];
          return C.push(pt), {
            poses: en,
            rotation: pt.rotation
          };
        } else
          return {
            poses: is(Qe.state),
            rotation: Qe.getRotation()
          };
      }), xe = Ne.map(function(Qe) {
        var pt = Qe.rotation;
        return pt;
      }), oe = 0, it = xe[0], Le = xe.every(function(Qe) {
        return Math.abs(it - Qe) < 0.1;
      });
      T ? oe = Le ? it : O : oe = !Fe && Le ? it : he;
      var qe = Ne.map(function(Qe) {
        var pt = Qe.poses;
        return pt;
      }), Tt = OH(qe, oe);
      return Tt;
    }
    var B = A(x, this.rotation, !0);
    T && (this.rotation = B.rotation, this.transformOrigin = h.defaultGroupOrigin || "50% 50%", this.scale = [1, 1]), this.renderGroupRects = C;
    var I = this.transformOrigin, L = this.rotation, k = this.scale, $ = B.width, U = B.height, K = B.minX, X = B.minY, Y = tG([[0, 0], [$, 0], [0, U], [$, U]], eG(I, $, U), this.rotation / 180 * Math.PI), J = Zp(Y.result), Q = J.minX, Z = J.minY, se = " rotate(".concat(L, "deg)") + " scale(".concat(k[0] >= 0 ? 1 : -1, ", ").concat(k[1] >= 0 ? 1 : -1, ")"), pe = "translate(".concat(-Q, "px, ").concat(-Z, "px)").concat(se);
    this.controlBox.getElement().style.transform = "translate3d(".concat(K, "px, ").concat(X, "px, ").concat(this.props.translateZ || 0, ")"), b.style.cssText += "left:0px;top:0px;" + "transform-origin:".concat(I, ";") + "width:".concat($, "px;height:").concat(U, "px;") + "transform: ".concat(pe), p.width = $, p.height = U;
    var be = this.getContainer(), _e = rO(this.controlBox.getElement(), b, this.controlBox.getElement(), this.getContainer(), this._rootContainer || be, []), Se = [_e.left, _e.top], Oe = is(_e), re = Oe[0], ie = Oe[1], ce = Oe[2], le = Oe[3], fe = Zp([re, ie, ce, le]), ve = [fe.minX, fe.minY], ee = k[0] * k[1] > 0 ? 1 : -1;
    _e.pos1 = Bt(re, ve), _e.pos2 = Bt(ie, ve), _e.pos3 = Bt(ce, ve), _e.pos4 = Bt(le, ve), _e.left = K - _e.left + ve[0], _e.top = X - _e.top + ve[1], _e.origin = Bt(On(Se, _e.origin), ve), _e.beforeOrigin = Bt(On(Se, _e.beforeOrigin), ve), _e.originalBeforeOrigin = On(Se, _e.originalBeforeOrigin), _e.transformOrigin = Bt(On(Se, _e.transformOrigin), ve), b.style.transform = "translate(".concat(-Q - ve[0], "px, ").concat(-Z - ve[1], "px)") + se, this.updateState(we(we({}, _e), {
      posDelta: ve,
      direction: ee,
      beforeDirection: ee
    }), s);
  }, n.getRect = function() {
    return we(we({}, e.prototype.getRect.call(this)), {
      children: this.moveables.map(function(r) {
        return r.getRect();
      })
    });
  }, n.triggerEvent = function(r, a, s) {
    if (s || r.indexOf("Group") > -1)
      return e.prototype.triggerEvent.call(this, r, a);
    this._emitter.trigger(r, a);
  }, n.updateAbles = function() {
    e.prototype.updateAbles.call(this, jt(jt([], this.props.ables, !0), [DD], !1), "Group");
  }, n._updateTargets = function() {
    e.prototype._updateTargets.call(this), this._prevTarget = this.props.dragTarget || this.areaElement;
  }, n._updateEvents = function() {
    var r = this.state, a = this.props, s = this._prevTarget, l = a.dragTarget || this.areaElement;
    s !== l && (Qm(this, "targetGesto"), Qm(this, "controlGesto"), r.target = null), r.target || (r.target = this.areaElement, this.controlBox.getElement().style.display = "block"), r.target && (this.targetGesto || (this.targetGesto = kB(this, l, "Group")), this.controlGesto || (this.controlGesto = OD(this, this.controlBox.getElement(), "controlAbles", "GroupControl")));
    var p = !XT(r.container, a.container);
    p && (r.container = a.container);
    var h = this.differ.update(a.targets), y = h.added, b = h.changed, E = h.removed, x = y.length || E.length;
    (p || x || b.length) && (this.updateRect(), this._hasFirstTargets = !0), this._isPropTargetChanged = !!x;
  }, n._updateObserver = function() {
  }, t.defaultProps = we(we({}, by.defaultProps), {
    transformOrigin: ["50%", "50%"],
    groupable: !0,
    dragArea: !0,
    keepRatio: !0,
    targets: [],
    defaultGroupRotate: 0,
    defaultGroupOrigin: "50% 50%"
  }), t;
}(by), MH = /* @__PURE__ */ function(e) {
  Ub(t, e);
  function t() {
    var r = e !== null && e.apply(this, arguments) || this;
    return r.moveables = [], r;
  }
  var n = t.prototype;
  return n.render = function() {
    var r = this, a, s = this.props, l = s.cspNonce, p = s.cssStyled, h = s.persistData, y = s.targets || [], b = y.length, E = this.isUnmounted || !b, x = (a = h == null ? void 0 : h.children) !== null && a !== void 0 ? a : [];
    return E && !b && x.length ? y = x.map(function() {
      return null;
    }) : E || (x = []), /* @__PURE__ */ He(p, {
      cspNonce: l,
      ref: hd(this, "controlBox"),
      className: $t("control-box"),
      children: y.map(function(C, T) {
        return /* @__PURE__ */ He(by, {
          ...we({
            key: "moveable" + T,
            ref: mL(r, "moveables", T)
          }, r.props, {
            target: C,
            wrapperMoveable: r,
            isWrapperMounted: r.isMoveableMounted,
            persistData: x[T]
          })
        });
      })
    });
  }, n.componentDidUpdate = function() {
  }, n.getTargets = function() {
    return this.props.targets;
  }, n.updateRect = function(r, a, s) {
    s === void 0 && (s = !0), this.moveables.forEach(function(l) {
      l.updateRect(r, a, s);
    });
  }, n.getRect = function() {
    return we(we({}, e.prototype.getRect.call(this)), {
      children: this.moveables.map(function(r) {
        return r.getRect();
      })
    });
  }, n.request = function() {
    return {
      request: function() {
        return this;
      },
      requestEnd: function() {
        return this;
      }
    };
  }, n.dragStart = function() {
    return this;
  }, n.hitTest = function() {
    return 0;
  }, n.isInside = function() {
    return !1;
  }, n.isDragging = function() {
    return !1;
  }, n.updateRenderPoses = function() {
  }, n.checkUpdate = function() {
  }, n.triggerEvent = function() {
  }, n.updateAbles = function() {
  }, n._updateEvents = function() {
  }, n._updateObserver = function() {
  }, t;
}(by);
function BB(e, t) {
  var n = [];
  return e.forEach(function(r) {
    if (!!r) {
      if (tc(r)) {
        t[r] && n.push.apply(n, t[r]);
        return;
      }
      Ki(r) ? n.push.apply(n, BB(r, t)) : n.push(r);
    }
  }), n;
}
function zB(e, t) {
  var n = [];
  return e.forEach(function(r) {
    if (!!r) {
      if (tc(r)) {
        t[r] && n.push.apply(n, t[r]);
        return;
      }
      Ki(r) ? n.push(zB(r, t)) : n.push(r);
    }
  }), n;
}
function FB(e, t) {
  return e.length !== t.length || e.some(function(n, r) {
    var a = t[r];
    return !n && !a ? !1 : n != a ? Ki(n) && Ki(a) ? FB(n, a) : !0 : !1;
  });
}
var AH = /* @__PURE__ */ function(e) {
  Ub(t, e);
  function t() {
    var r = e !== null && e.apply(this, arguments) || this;
    return r.refTargets = [], r.selectorMap = {}, r._differ = new DL(), r._elementTargets = [], r._onChangeTargets = null, r;
  }
  var n = t.prototype;
  return t.makeStyled = function() {
    var r = {}, a = this.getTotalAbles();
    a.forEach(function(l) {
      var p = l.css;
      !p || p.forEach(function(h) {
        r[h] = !0;
      });
    });
    var s = Oy(r).join(`
`);
    this.defaultStyled = LL("div", f5(cD, EW + s));
  }, t.getTotalAbles = function() {
    return jt([OB, DD, IB, TB], this.defaultAbles, !0);
  }, n.render = function() {
    var r, a = this.constructor;
    a.defaultStyled || a.makeStyled();
    var s = this.props, l = s.ables, p = s.props, h = hW(s, ["ables", "props"]), y = this._updateRefs(!0), b = BB(y, this.selectorMap), E = b.length > 1, x = a.getTotalAbles(), C = jt(jt([], x, !0), l || [], !0), T = we(we(we({}, h), p || {}), {
      ables: C,
      cssStyled: a.defaultStyled,
      customStyledMap: a.customStyledMap
    });
    this._elementTargets = b;
    var O = null, D = this.moveable, A = h.persistData;
    if (A != null && A.children && (E = !0), E) {
      if (h.individualGroupable)
        return /* @__PURE__ */ He(MH, {
          ...we({
            key: "individual-group",
            ref: hd(this, "moveable")
          }, T, {
            target: null,
            targets: b
          })
        });
      var B = zB(y, this.selectorMap);
      if (D && !D.props.groupable && !D.props.individualGroupable) {
        var I = D.props.target;
        I && b.indexOf(I) > -1 && (O = we({}, D.state));
      }
      return /* @__PURE__ */ He(DH, {
        ...we({
          key: "group",
          ref: hd(this, "moveable")
        }, T, (r = h.groupableProps) !== null && r !== void 0 ? r : {}, {
          target: null,
          targets: b,
          targetGroups: B,
          firstRenderState: O
        })
      });
    } else {
      var L = b[0];
      if (D && (D.props.groupable || D.props.individualGroupable)) {
        var k = D.moveables || [], $ = bd(k, function(U) {
          return U.props.target === L;
        });
        $ && (O = we({}, $.state));
      }
      return /* @__PURE__ */ He(by, {
        ...we({
          key: "single",
          ref: hd(this, "moveable")
        }, T, {
          target: L,
          firstRenderState: O
        })
      });
    }
  }, n.componentDidMount = function() {
    this._checkChangeTargets(), this._updateRefs();
  }, n.componentDidUpdate = function() {
    this._checkChangeTargets();
  }, n.componentWillUnmount = function() {
    this.selectorMap = {}, this.refTargets = [];
  }, n.getTargets = function() {
    var r, a;
    return (a = (r = this.moveable) === null || r === void 0 ? void 0 : r.getTargets()) !== null && a !== void 0 ? a : [];
  }, n.updateSelectors = function() {
    this.selectorMap = {}, this._updateRefs();
  }, n.waitToChangeTarget = function() {
    var r = this, a;
    return this._onChangeTargets = function() {
      r._onChangeTargets = null, a();
    }, new Promise(function(s) {
      a = s;
    });
  }, n.waitToChangeTargets = function() {
    return this.waitToChangeTarget();
  }, n.getManager = function() {
    return this.moveable;
  }, n._updateRefs = function(r) {
    var a = this.refTargets, s = bD(this.props.target || this.props.targets), l = typeof document < "u", p = FB(a, s), h = this.selectorMap, y = {};
    return this.refTargets.forEach(function b(E) {
      if (tc(E)) {
        var x = h[E];
        x ? y[E] = h[E] : l && (p = !0, y[E] = [].slice.call(document.querySelectorAll(E)));
      } else
        Ki(E) && E.forEach(b);
    }), this.refTargets = s, this.selectorMap = y, !r && p && this.forceUpdate(), s;
  }, n._checkChangeTargets = function() {
    var r, a, s, l = this._differ.update(this._elementTargets), p = l.added, h = l.removed, y = p.length || h.length;
    y && ((a = (r = this.props).onChangeTargets) === null || a === void 0 || a.call(r, {
      moveable: this.moveable,
      targets: this._elementTargets
    }), (s = this._onChangeTargets) === null || s === void 0 || s.call(this)), this._updateRefs();
  }, t.defaultAbles = [], t.customStyledMap = {}, t.defaultStyled = null, gW([yL(CW)], t.prototype, "moveable", void 0), t;
}(Ze.PureComponent), iO = /* @__PURE__ */ function(e) {
  Ub(t, e);
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return t.defaultAbles = TH, t;
}(AH), aO = function(e, t) {
  return aO = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var a in r)
      Object.prototype.hasOwnProperty.call(r, a) && (n[a] = r[a]);
  }, aO(e, t);
};
function PH(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  aO(e, t);
  function n() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
}
function NH(e, t) {
  return t = {
    exports: {}
  }, e(t, t.exports), t.exports;
}
var Gb = NH(function(e, t) {
  function n(h) {
    if (h && typeof h == "object") {
      var y = h.which || h.keyCode || h.charCode;
      y && (h = y);
    }
    if (typeof h == "number")
      return l[h];
    var b = String(h), E = r[b.toLowerCase()];
    if (E)
      return E;
    var E = a[b.toLowerCase()];
    if (E)
      return E;
    if (b.length === 1)
      return b.charCodeAt(0);
  }
  n.isEventKey = function(y, b) {
    if (y && typeof y == "object") {
      var E = y.which || y.keyCode || y.charCode;
      if (E == null)
        return !1;
      if (typeof b == "string") {
        var x = r[b.toLowerCase()];
        if (x)
          return x === E;
        var x = a[b.toLowerCase()];
        if (x)
          return x === E;
      } else if (typeof b == "number")
        return b === E;
      return !1;
    }
  }, t = e.exports = n;
  var r = t.code = t.codes = {
    backspace: 8,
    tab: 9,
    enter: 13,
    shift: 16,
    ctrl: 17,
    alt: 18,
    "pause/break": 19,
    "caps lock": 20,
    esc: 27,
    space: 32,
    "page up": 33,
    "page down": 34,
    end: 35,
    home: 36,
    left: 37,
    up: 38,
    right: 39,
    down: 40,
    insert: 45,
    delete: 46,
    command: 91,
    "left command": 91,
    "right command": 93,
    "numpad *": 106,
    "numpad +": 107,
    "numpad -": 109,
    "numpad .": 110,
    "numpad /": 111,
    "num lock": 144,
    "scroll lock": 145,
    "my computer": 182,
    "my calculator": 183,
    ";": 186,
    "=": 187,
    ",": 188,
    "-": 189,
    ".": 190,
    "/": 191,
    "`": 192,
    "[": 219,
    "\\": 220,
    "]": 221,
    "'": 222
  }, a = t.aliases = {
    windows: 91,
    "\u21E7": 16,
    "\u2325": 18,
    "\u2303": 17,
    "\u2318": 91,
    ctl: 17,
    control: 17,
    option: 18,
    pause: 19,
    break: 19,
    caps: 20,
    return: 13,
    escape: 27,
    spc: 32,
    spacebar: 32,
    pgup: 33,
    pgdn: 34,
    ins: 45,
    del: 46,
    cmd: 91
  };
  /*!
   * Programatically add the following
   */
  for (s = 97; s < 123; s++)
    r[String.fromCharCode(s)] = s - 32;
  for (var s = 48; s < 58; s++)
    r[s - 48] = s;
  for (s = 1; s < 13; s++)
    r["f" + s] = s + 111;
  for (s = 0; s < 10; s++)
    r["numpad " + s] = s + 96;
  var l = t.names = t.title = {};
  for (s in r)
    l[r[s]] = s;
  for (var p in a)
    r[p] = a[p];
});
Gb.code;
Gb.codes;
Gb.aliases;
var kH = Gb.names;
Gb.title;
var Sk = {
  "+": "plus",
  "left command": "meta",
  "right command": "meta"
}, wk = {
  shift: 1,
  ctrl: 2,
  alt: 3,
  meta: 4
};
function $B(e, t) {
  var n = (kH[e] || t || "").toLowerCase();
  for (var r in Sk)
    n = n.replace(r, Sk[r]);
  return n.replace(/\s/g, "");
}
function UB(e, t) {
  t === void 0 && (t = $B(e.keyCode, e.key));
  var n = IH(e);
  return n.indexOf(t) === -1 && n.push(t), n.filter(Boolean);
}
function IH(e) {
  var t = [e.shiftKey && "shift", e.ctrlKey && "ctrl", e.altKey && "alt", e.metaKey && "meta"];
  return t.filter(Boolean);
}
function Ck(e) {
  var t = e.slice();
  return t.sort(function(n, r) {
    var a = wk[n] || 5, s = wk[r] || 5;
    return a - s;
  }), t;
}
var Rk, LH = /* @__PURE__ */ function(e) {
  PH(t, e);
  function t(r) {
    r === void 0 && (r = window);
    var a = e.call(this) || this;
    return a.container = r, a.ctrlKey = !1, a.altKey = !1, a.shiftKey = !1, a.metaKey = !1, a.clear = function() {
      return a.ctrlKey = !1, a.altKey = !1, a.shiftKey = !1, a.metaKey = !1, a;
    }, a.keydownEvent = function(s) {
      a.triggerEvent("keydown", s);
    }, a.keyupEvent = function(s) {
      a.triggerEvent("keyup", s);
    }, a.blur = function() {
      a.clear(), a.trigger("blur");
    }, zi(r, "blur", a.blur), zi(r, "keydown", a.keydownEvent), zi(r, "keyup", a.keyupEvent), a;
  }
  var n = t.prototype;
  return Object.defineProperty(t, "global", {
    get: function() {
      return Rk || (Rk = new t());
    },
    enumerable: !1,
    configurable: !0
  }), t.setGlobal = function() {
    return this.global;
  }, n.destroy = function() {
    var r = this.container;
    this.clear(), this.off(), Oi(r, "blur", this.blur), Oi(r, "keydown", this.keydownEvent), Oi(r, "keyup", this.keyupEvent);
  }, n.keydown = function(r, a) {
    return this.addEvent("keydown", r, a);
  }, n.offKeydown = function(r, a) {
    return this.removeEvent("keydown", r, a);
  }, n.offKeyup = function(r, a) {
    return this.removeEvent("keyup", r, a);
  }, n.keyup = function(r, a) {
    return this.addEvent("keyup", r, a);
  }, n.addEvent = function(r, a, s) {
    return Ki(a) ? this.on("".concat(r, ".").concat(Ck(a).join(".")), s) : tc(a) ? this.on("".concat(r, ".").concat(a), s) : this.on(r, a), this;
  }, n.removeEvent = function(r, a, s) {
    return Ki(a) ? this.off("".concat(r, ".").concat(Ck(a).join(".")), s) : tc(a) ? this.off("".concat(r, ".").concat(a), s) : this.off(r, a), this;
  }, n.triggerEvent = function(r, a) {
    this.ctrlKey = a.ctrlKey, this.shiftKey = a.shiftKey, this.altKey = a.altKey, this.metaKey = a.metaKey;
    var s = $B(a.keyCode, a.key), l = s === "ctrl" || s === "shift" || s === "meta" || s === "alt", p = {
      key: s,
      isToggle: l,
      inputEvent: a,
      keyCode: a.keyCode,
      ctrlKey: a.ctrlKey,
      altKey: a.altKey,
      shiftKey: a.shiftKey,
      metaKey: a.metaKey
    };
    this.trigger(r, p), this.trigger("".concat(r, ".").concat(s), p);
    var h = UB(a, s);
    h.length > 1 && this.trigger("".concat(r, ".").concat(h.join(".")), p);
  }, t;
}($b);
const BH = LH;
var oO = function(e, t) {
  return oO = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var a in r)
      Object.prototype.hasOwnProperty.call(r, a) && (n[a] = r[a]);
  }, oO(e, t);
};
function VB(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  oO(e, t);
  function n() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
}
var Bi = function() {
  return Bi = Object.assign || function(t) {
    for (var n, r = 1, a = arguments.length; r < a; r++) {
      n = arguments[r];
      for (var s in n)
        Object.prototype.hasOwnProperty.call(n, s) && (t[s] = n[s]);
    }
    return t;
  }, Bi.apply(this, arguments);
};
function zH(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
      t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
}
function FH(e, t, n, r) {
  var a = arguments.length, s = a < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, n) : r, l;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    s = Reflect.decorate(e, t, n, r);
  else
    for (var p = e.length - 1; p >= 0; p--)
      (l = e[p]) && (s = (a < 3 ? l(s) : a > 3 ? l(t, n, s) : l(t, n)) || s);
  return a > 3 && s && Object.defineProperty(t, n, s), s;
}
function ab(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, a = t.length, s; r < a; r++)
      (s || !(r in t)) && (s || (s = Array.prototype.slice.call(t, 0, r)), s[r] = t[r]);
  return e.concat(s || Array.prototype.slice.call(t));
}
function $H(e) {
  if ("touches" in e) {
    var t = e.touches[0] || e.changedTouches[0];
    return {
      clientX: t.clientX,
      clientY: t.clientY
    };
  } else
    return {
      clientX: e.clientX,
      clientY: e.clientY
    };
}
function UH(e) {
  if (typeof Map > "u")
    return e.filter(function(n, r) {
      return e.indexOf(n) === r;
    });
  var t = /* @__PURE__ */ new Map();
  return e.filter(function(n) {
    return t.has(n) ? !1 : (t.set(n, !0), !0);
  });
}
function VH(e, t, n) {
  var r = dd(e);
  return r.elementFromPoint && r.elementFromPoint(t, n) || null;
}
function jB(e, t, n) {
  var r = e.tag, a = e.children, s = e.attributes, l = e.className, p = e.style, h = t || dd(n).createElement(r);
  for (var y in s)
    h.setAttribute(y, s[y]);
  var b = h.children;
  if (a.forEach(function(x, C) {
    jB(x, b[C], h);
  }), l && l.split(" ").forEach(function(x) {
    Ui(h, x) || iD(h, x);
  }), p) {
    var E = h.style;
    for (var y in p)
      E[y] = p[y];
  }
  return !t && n && n.appendChild(h), h;
}
function jH(e, t) {
  for (var n = [], r = 2; r < arguments.length; r++)
    n[r - 2] = arguments[r];
  var a = t || {}, s = a.className, l = s === void 0 ? "" : s, p = a.style, h = p === void 0 ? {} : p, y = zH(a, ["className", "style"]);
  return {
    tag: e,
    className: l,
    style: h,
    attributes: y,
    children: n
  };
}
function tT(e, t, n) {
  e !== t && n(e, t);
}
function Tk(e, t, n) {
  var r;
  n === void 0 && (n = e.data.boundArea);
  var a = e.distX, s = a === void 0 ? 0 : a, l = e.distY, p = l === void 0 ? 0 : l, h = e.data, y = h.startX, b = h.startY;
  if (t > 0) {
    var E = Math.sqrt((s * s + p * p) / (1 + t * t)), x = t * E;
    s = (s >= 0 ? 1 : -1) * x, p = (p >= 0 ? 1 : -1) * E;
  }
  var C = Math.abs(s), T = Math.abs(p), O = s < 0 ? y - n.left : n.right - y, D = p < 0 ? b - n.top : n.bottom - b;
  r = SL([C, T], [0, 0], [O, D], !!t), C = r[0], T = r[1], s = (s >= 0 ? 1 : -1) * C, p = (p >= 0 ? 1 : -1) * T;
  var A = Math.min(0, s), B = Math.min(0, p), I = y + A, L = b + B;
  return {
    left: I,
    top: L,
    right: I + C,
    bottom: L + T,
    width: C,
    height: T
  };
}
function wE(e) {
  var t = e.getBoundingClientRect(), n = t.left, r = t.top, a = t.width, s = t.height;
  return {
    pos1: [n, r],
    pos2: [n + a, r],
    pos3: [n, r + s],
    pos4: [n + a, r + s]
  };
}
function Ok(e, t, n) {
  var r = Xm(e, t), a = r.list, s = r.prevList, l = r.added, p = r.removed, h = r.maintained;
  return ab(ab(ab([], l.map(function(y) {
    return a[y];
  }), !0), p.map(function(y) {
    return s[y];
  }), !0), n ? h.map(function(y) {
    var b = y[1];
    return a[b];
  }) : [], !0);
}
function Dk(e) {
  for (var t = 0, n = e.length, r = 1; r < n; ++r)
    t = Math.max(Qu(e[r], e[r - 1]), t);
  return t;
}
var WB = kL(`
:host {
    position: fixed;
    display: none;
    border: 1px solid #4af;
    background: rgba(68, 170, 255, 0.5);
    pointer-events: none;
    will-change: transform;
    z-index: 100;
}
`), GB = "selecto-selection ".concat(WB.className), MD = ["boundContainer", "selectableTargets", "selectByClick", "selectFromInside", "continueSelect", "continueSelectWithoutDeselect", "toggleContinueSelect", "toggleContinueSelectWithoutDeselect", "keyContainer", "hitRate", "scrollOptions", "checkInput", "preventDefault", "ratio", "getElementRect", "preventDragFromInside", "rootContainer", "dragCondition", "clickBySelectEnd", "checkOverflow", "innerScrollOptions"], WH = ab([
  "dragContainer",
  "cspNonce",
  "preventClickEventOnDrag",
  "preventClickEventOnDragStart",
  "preventRightClick"
], MD, !0), HB = ["dragStart", "drag", "dragEnd", "selectStart", "select", "selectEnd", "keydown", "keyup", "scroll", "innerScroll"], GH = ["clickTarget", "getSelectableElements", "setSelectedTargets", "getElementPoints", "getSelectedTargets", "findSelectableTargets", "triggerDragStart", "checkScroll", "selectTargetsByPoints", "setSelectedTargetsByPoints"], HH = /* @__PURE__ */ function(e) {
  VB(t, e);
  function t(r) {
    r === void 0 && (r = {});
    var a = e.call(this) || this;
    a.selectedTargets = [], a.dragScroll = new AL(), a._onDragStart = function(p, h) {
      var y = p.data, b = p.clientX, E = p.clientY, x = p.inputEvent, C = a.options, T = C.selectFromInside, O = C.selectByClick, D = C.rootContainer, A = C.boundContainer, B = C.preventDragFromInside, I = B === void 0 ? !0 : B, L = C.clickBySelectEnd, k = C.dragCondition;
      if (k && !k(p)) {
        p.stop();
        return;
      }
      y.data = {};
      var $ = jh(a.container);
      y.innerWidth = $.innerWidth, y.innerHeight = $.innerHeight, a.findSelectableTargets(y), y.startSelectedTargets = a.selectedTargets, y.scaleMatrix = sD(), y.containerX = 0, y.containerY = 0;
      var U = a.container, K = {
        left: -1 / 0,
        top: -1 / 0,
        right: 1 / 0,
        bottom: 1 / 0
      };
      if (D) {
        var X = a.container.getBoundingClientRect();
        y.containerX = X.left, y.containerY = X.top, y.scaleMatrix = L5(a.container, D);
      }
      if (A) {
        var Y = rs(A) && "element" in A ? Bi({
          left: !0,
          top: !0,
          bottom: !0,
          right: !0
        }, A) : {
          element: A,
          left: !0,
          top: !0,
          bottom: !0,
          right: !0
        }, J = Y.element, Q = void 0;
        if (J) {
          tc(J) ? Q = dd(U).querySelector(J) : J === !0 ? Q = a.container : Q = J;
          var Z = Q.getBoundingClientRect();
          Y.left && (K.left = Z.left), Y.top && (K.top = Z.top), Y.right && (K.right = Z.right), Y.bottom && (K.bottom = Z.bottom);
        }
      }
      y.boundArea = K;
      var se = {
        left: b,
        top: E,
        right: b,
        bottom: E,
        width: 0,
        height: 0
      }, pe = [];
      if (!T || O && !L) {
        var be = a._findElement(
          h || x.target,
          y.selectableTargets
        );
        pe = be ? [be] : [];
      }
      var _e = pe.length > 0, Se = !T && _e;
      if (Se && !O)
        return p.stop(), !1;
      var Oe = x.type, re = Oe === "mousedown" || Oe === "touchstart", ie = !p.isClick && re ? a.emit("dragStart", Bi(Bi({}, p), {
        data: y.data
      })) : !0;
      if (!ie)
        return p.stop(), !1;
      if (a.continueSelect ? (pe = Ok(a.selectedTargets, pe, a.continueSelectWithoutDeselect), y.startPassedTargets = a.selectedTargets) : y.startPassedTargets = [], a._select(pe, se, p, !0, Se && O && !L && I), y.startX = b, y.startY = E, y.selectFlag = !1, y.preventDragFromInside = !1, x.target) {
        var ce = BE(y.scaleMatrix, [b - y.containerX, E - y.containerY]);
        a.target.style.cssText += "position: ".concat(D ? "absolute" : "fixed", ";") + "left:0px;top:0px;" + "transform: translate(".concat(ce[0], "px, ").concat(ce[1], "px)");
      }
      if (Se && O && !L)
        x.preventDefault(), I && (a._selectEnd(y.startSelectedTargets, y.startPassedTargets, se, p, !0), y.preventDragFromInside = !0);
      else {
        y.selectFlag = !0;
        var le = a.options, fe = le.scrollOptions, ve = le.innerScrollOptions, ee = !1;
        if (ve) {
          for (var Ae = p.inputEvent, he = Ae.target, Fe = null, Ne = he; Ne && Ne !== dd(U).body; ) {
            var xe = getComputedStyle(Ne).overflow !== "visible";
            if (xe) {
              Fe = Ne;
              break;
            }
            Ne = Ne.parentElement;
          }
          Fe && (y.innerScrollOptions = Bi({
            container: Fe,
            checkScrollEvent: !0
          }, ve === !0 ? {} : ve), a.dragScroll.dragStart(p, y.innerScrollOptions), ee = !0);
        }
        !ee && fe && fe.container && a.dragScroll.dragStart(p, fe), L && (y.selectFlag = !1, p.preventDrag());
      }
      return !0;
    }, a._onDrag = function(p) {
      if (p.data.selectFlag) {
        var h = a.scrollOptions, y = p.data.innerScrollOptions, b = y || (h == null ? void 0 : h.container);
        if (b && !p.isScroll && a.dragScroll.drag(p, y || h))
          return;
      }
      a._checkSelected(p);
    }, a._onDragEnd = function(p) {
      var h = p.data, y = p.inputEvent, b = Tk(p, a.options.ratio), E = h.selectFlag, x = a.container;
      if (y && a.emit("dragEnd", Bi(Bi({
        isDouble: !!p.isDouble,
        isClick: !!p.isClick,
        isDrag: !1,
        isSelect: E
      }, p), {
        data: h.data,
        rect: b
      })), a.target.style.cssText += "display: none;", E)
        h.selectFlag = !1, a.dragScroll.dragEnd();
      else if (a.selectByClick && a.clickBySelectEnd) {
        var C = a._findElement((y == null ? void 0 : y.target) || VH(x, p.clientX, p.clientY), h.selectableTargets);
        a._select(C ? [C] : [], b, p);
      }
      h.preventDragFromInside || a._selectEnd(h.startSelectedTargets, h.startPassedTargets, b, p);
    }, a._onKeyDown = function(p) {
      var h = a.options, y = !1;
      if (!a._keydownContinueSelect) {
        var b = a._sameCombiKey(p, h.toggleContinueSelect);
        a._keydownContinueSelect = b, y || (y = b);
      }
      if (!a._keydownContinueSelectWithoutDeselection) {
        var b = a._sameCombiKey(p, h.toggleContinueSelectWithoutDeselect);
        a._keydownContinueSelectWithoutDeselection = b, y || (y = b);
      }
      !y || a.emit("keydown", {
        keydownContinueSelect: a._keydownContinueSelect,
        keydownContinueSelectWithoutDeselection: a._keydownContinueSelectWithoutDeselection
      });
    }, a._onKeyUp = function(p) {
      var h = a.options, y = !1;
      if (a._keydownContinueSelect) {
        var b = a._sameCombiKey(p, h.toggleContinueSelect, !0);
        a._keydownContinueSelect = !b, y || (y = b);
      }
      if (a._keydownContinueSelectWithoutDeselection) {
        var b = a._sameCombiKey(p, h.toggleContinueSelectWithoutDeselect, !0);
        a._keydownContinueSelectWithoutDeselection = !b, y || (y = b);
      }
      !y || a.emit("keyup", {
        keydownContinueSelect: a._keydownContinueSelect,
        keydownContinueSelectWithoutDeselection: a._keydownContinueSelectWithoutDeselection
      });
    }, a._onBlur = function() {
      (a._keydownContinueSelect || a._keydownContinueSelectWithoutDeselection) && (a._keydownContinueSelect = !1, a._keydownContinueSelectWithoutDeselection = !1, a.emit("keyup", {
        keydownContinueSelect: a._keydownContinueSelect,
        keydownContinueSelectWithoutDeselection: a._keydownContinueSelectWithoutDeselection
      }));
    }, a._onDocumentSelectStart = function(p) {
      var h = dd(a.container);
      if (!!a.gesto.isFlag()) {
        var y = a.dragContainer;
        y === jh(a.container) && (y = h.documentElement);
        var b = WN(y) ? [y] : [].slice.call(y), E = p.target;
        b.some(function(x) {
          if (x === E || x.contains(E))
            return p.preventDefault(), !0;
        });
      }
    }, a.target = r.portalContainer;
    var s = r.container;
    a.options = Bi({
      portalContainer: null,
      container: null,
      dragContainer: null,
      selectableTargets: [],
      selectByClick: !0,
      selectFromInside: !0,
      clickBySelectEnd: !1,
      hitRate: 100,
      continueSelect: !1,
      continueSelectWithoutDeselect: !1,
      toggleContinueSelect: null,
      toggleContinueSelectWithoutDeselect: null,
      keyContainer: null,
      scrollOptions: void 0,
      checkInput: !1,
      preventDefault: !1,
      boundContainer: !1,
      preventDragFromInside: !0,
      dragCondition: null,
      rootContainer: null,
      checkOverflow: !1,
      innerScrollOptions: !1,
      getElementRect: wE,
      cspNonce: "",
      ratio: 0
    }, r);
    var l = a.options.portalContainer;
    return l && (s = l.parentElement), a.container = s || document.body, a.initElement(), a.initDragScroll(), a.setKeyController(), a;
  }
  var n = t.prototype;
  return n.setSelectedTargets = function(r) {
    var a = this.selectedTargets, s = Xm(a, r), l = s.added, p = s.removed, h = s.prevList, y = s.list;
    return this.selectedTargets = r, {
      added: l.map(function(b) {
        return y[b];
      }),
      removed: p.map(function(b) {
        return h[b];
      }),
      beforeSelected: a,
      selected: r
    };
  }, n.setSelectedTargetsByPoints = function(r, a) {
    var s = Math.min(r[0], a[0]), l = Math.min(r[1], a[1]), p = Math.max(r[0], a[0]), h = Math.max(r[1], a[1]), y = {
      left: s,
      top: l,
      right: p,
      bottom: h,
      width: p - s,
      height: h - l
    }, b = {
      ignoreClick: !0
    };
    this.findSelectableTargets(b);
    var E = this.hitTest(y, b), x = this.setSelectedTargets(E);
    return Bi(Bi({}, x), {
      rect: y
    });
  }, n.selectTargetsByPoints = function(r, a) {
    var s = new MouseEvent("mousedown", {
      clientX: r[0],
      clientY: r[1],
      cancelable: !0,
      bubbles: !0
    }), l = new MouseEvent("mousemove", {
      clientX: a[0],
      clientY: a[1],
      cancelable: !0,
      bubbles: !0
    }), p = new MouseEvent("mousemove", {
      clientX: a[0],
      clientY: a[1],
      cancelable: !0,
      bubbles: !0
    }), h = this.gesto, y = h.onDragStart(s);
    y !== !1 && (h.onDrag(l), h.onDragEnd(p));
  }, n.getSelectedTargets = function() {
    return this.selectedTargets;
  }, n.triggerDragStart = function(r) {
    return this.gesto.triggerDragStart(r), this;
  }, n.destroy = function() {
    var r;
    this.off(), this.keycon && this.keycon.destroy(), this.gesto.unset(), this.injectResult.destroy(), this.dragScroll.dragEnd(), Oi(document, "selectstart", this._onDocumentSelectStart), this.options.portalContainer || (r = this.target.parentElement) === null || r === void 0 || r.removeChild(this.target), this.keycon = null, this.gesto = null, this.injectResult = null, this.target = null, this.container = null, this.options = null;
  }, n.getElementPoints = function(r) {
    var a = this.getElementRect || wE, s = a(r), l = [s.pos1, s.pos2, s.pos4, s.pos3];
    if (a !== wE) {
      var p = r.getBoundingClientRect();
      return BT(l, p);
    }
    return l;
  }, n.getSelectableElements = function() {
    var r = this.container, a = [];
    return this.options.selectableTargets.forEach(function(s) {
      if (Fx(s)) {
        var l = s();
        l && a.push.apply(a, [].slice.call(l));
      } else if (WN(s))
        a.push(s);
      else if (rs(s))
        a.push(s.value || s.current);
      else {
        var p = [].slice.call(dd(r).querySelectorAll(s));
        a.push.apply(a, p);
      }
    }), a;
  }, n.checkScroll = function() {
    if (!!this.gesto.isFlag()) {
      var r = this.scrollOptions, a = this.gesto.getEventData().innerScrollOptions, s = a || (r == null ? void 0 : r.container);
      s && this.dragScroll.checkScroll(Bi({
        inputEvent: this.gesto.getCurrentEvent()
      }, a || r));
    }
  }, n.findSelectableTargets = function(r) {
    var a = this;
    r === void 0 && (r = this.gesto.getEventData());
    var s = this.getSelectableElements(), l = s.map(function(E) {
      return a.getElementPoints(E);
    });
    r.selectableTargets = s, r.selectablePoints = l, r.selectableParentMap = null;
    var p = this.options, h = p.checkOverflow || p.innerScrollOptions, y = dd(this.container);
    if (h) {
      var b = /* @__PURE__ */ new Map();
      r.selectableInnerScrollParentMap = b, r.selectableInnerScrollPathsList = s.map(function(E, x) {
        for (var C = E.parentElement, T = [], O = [], D = function() {
          var A = b.get(C);
          if (!A) {
            var B = getComputedStyle(C).overflow !== "visible";
            if (B) {
              var I = wE(C);
              A = {
                parentElement: C,
                indexes: [],
                points: [I.pos1, I.pos2, I.pos4, I.pos3],
                paths: ab([], O, !0)
              }, T.push(C), T.forEach(function(L) {
                b.set(L, A);
              }), T = [];
            }
          }
          A ? (C = A.parentElement, b.get(C).indexes.push(x), O.push(C)) : T.push(C), C = C.parentElement;
        }; C && C !== y.body; )
          D();
        return O;
      });
    }
    return p.checkOverflow || (r.selectableInners = s.map(function() {
      return !0;
    })), this._refreshGroups(r), s;
  }, n.clickTarget = function(r, a) {
    var s = $H(r), l = s.clientX, p = s.clientY, h = {
      data: {
        selectFlag: !1
      },
      clientX: l,
      clientY: p,
      inputEvent: r,
      isClick: !0,
      isTrusted: !1,
      stop: function() {
        return !1;
      }
    };
    return this._onDragStart(h, a) && this._onDragEnd(h), this;
  }, n.setKeyController = function() {
    var r = this.options, a = r.keyContainer, s = r.toggleContinueSelect, l = r.toggleContinueSelectWithoutDeselect;
    this.keycon && (this.keycon.destroy(), this.keycon = null), (s || l) && (this.keycon = new BH(a || jh(this.container)), this.keycon.keydown(this._onKeyDown).keyup(this._onKeyUp).on("blur", this._onBlur));
  }, n.setKeyEvent = function() {
    var r = this.options, a = r.toggleContinueSelect, s = r.toggleContinueSelectWithoutDeselect;
    !a && !s || this.keycon || this.setKeyController();
  }, n.setKeyContainer = function(r) {
    var a = this, s = this.options;
    tT(s.keyContainer, r, function() {
      s.keyContainer = r, a.setKeyController();
    });
  }, n.getContinueSelect = function() {
    var r = this.options, a = r.continueSelect, s = r.toggleContinueSelect;
    return !s || !this._keydownContinueSelect ? a : !a;
  }, n.getContinueSelectWithoutDeselect = function() {
    var r = this.options, a = r.continueSelectWithoutDeselect, s = r.toggleContinueSelectWithoutDeselect;
    return !s || !this._keydownContinueSelectWithoutDeselection ? a : !a;
  }, n.setToggleContinueSelect = function(r) {
    var a = this, s = this.options;
    tT(s.toggleContinueSelect, r, function() {
      s.toggleContinueSelect = r, a.setKeyEvent();
    });
  }, n.setToggleContinueSelectWithoutDeselect = function(r) {
    var a = this, s = this.options;
    tT(s.toggleContinueSelectWithoutDeselect, r, function() {
      s.toggleContinueSelectWithoutDeselect = r, a.setKeyEvent();
    });
  }, n.setPreventDefault = function(r) {
    this.gesto.options.preventDefault = r;
  }, n.setCheckInput = function(r) {
    this.gesto.options.checkInput = r;
  }, n.initElement = function() {
    var r = this.container;
    this.target = jB(jH("div", {
      className: GB
    }), this.target, r);
    var a = this.target, s = this.options, l = s.dragContainer, p = s.checkInput, h = s.preventDefault, y = s.preventClickEventOnDragStart, b = s.preventClickEventOnDrag, E = s.preventClickEventByCondition, x = s.preventRightClick, C = x === void 0 ? !0 : x;
    this.dragContainer = typeof l == "string" ? [].slice.call(dd(r).querySelectorAll(l)) : l || this.target.parentNode, this.gesto = new NL(this.dragContainer, {
      checkWindowBlur: !0,
      container: jh(r),
      checkInput: p,
      preventDefault: h,
      preventClickEventOnDragStart: y,
      preventClickEventOnDrag: b,
      preventClickEventByCondition: E,
      preventRightClick: C
    }).on({
      dragStart: this._onDragStart,
      drag: this._onDrag,
      dragEnd: this._onDragEnd
    }), zi(document, "selectstart", this._onDocumentSelectStart), this.injectResult = WB.inject(a, {
      nonce: this.options.cspNonce
    });
  }, n.hitTest = function(r, a, s) {
    var l = this.options, p = l.hitRate, h = l.selectByClick, y = r.left, b = r.top, E = r.right, x = r.bottom, C = a.innerGroups, T = a.innerWidth, O = a.innerHeight, D = s == null ? void 0 : s.clientX, A = s == null ? void 0 : s.clientY, B = a.ignoreClick, I = [[y, b], [E, b], [E, x], [y, x]], L = function(_e, Se) {
      var Oe = Kh(typeof p == "function" ? "".concat(p(Se)) : "".concat(p)), re = B ? !1 : ux([D, A], _e);
      if (h && re)
        return !0;
      var ie = FT(I, _e);
      if (!ie.length)
        return !1;
      var ce = nb(ie), le = 0;
      if (ce === 0 && nb(_e) === 0 ? (le = Dk(_e), ce = Dk(ie)) : le = nb(_e), Oe.unit === "px")
        return ce >= Oe.value;
      var fe = sx(Math.round(ce / le * 100), 0, 100);
      return fe >= Math.min(100, Oe.value);
    }, k = a.selectableTargets, $ = a.selectablePoints, U = a.selectableInners;
    if (!C)
      return k.filter(function(_e, Se) {
        return U[Se] ? L($[Se], k[Se]) : !1;
      });
    for (var K = [], X = Math.floor(y / T), Y = Math.floor(E / T), J = Math.floor(b / O), Q = Math.floor(x / O), Z = X; Z <= Y; ++Z) {
      var se = C[Z];
      if (!!se)
        for (var pe = J; pe <= Q; ++pe) {
          var be = se[pe];
          !be || be.forEach(function(_e) {
            var Se = $[_e], Oe = U[_e], re = k[_e];
            Oe && L(Se, re) && K.push(re);
          });
        }
    }
    return UH(K);
  }, n.initDragScroll = function() {
    var r = this;
    this.dragScroll.on("scrollDrag", function(a) {
      var s = a.next;
      s(r.gesto.getCurrentEvent());
    }).on("scroll", function(a) {
      var s = a.container, l = a.direction, p = r.gesto.getEventData().innerScrollOptions;
      p ? r.emit("innerScroll", {
        container: s,
        direction: l
      }) : r.emit("scroll", {
        container: s,
        direction: l
      });
    }).on("move", function(a) {
      var s = a.offsetX, l = a.offsetY, p = a.inputEvent, h = r.gesto;
      if (!(!h || !h.isFlag())) {
        var y = r.gesto.getEventData(), b = y.boundArea;
        y.startX -= s, y.startY -= l;
        var E = r.gesto.getEventData().innerScrollOptions, x = E == null ? void 0 : E.container, C = !1;
        if (x) {
          var T = y.selectableInnerScrollParentMap, O = T.get(x);
          O && (O.paths.forEach(function(D) {
            var A = T.get(D);
            A.points.forEach(function(B) {
              B[0] -= s, B[1] -= l;
            });
          }), O.indexes.forEach(function(D) {
            y.selectablePoints[D].forEach(function(A) {
              A[0] -= s, A[1] -= l;
            });
          }), C = !0);
        }
        C || y.selectablePoints.forEach(function(D) {
          D.forEach(function(A) {
            A[0] -= s, A[1] -= l;
          });
        }), r._refreshGroups(y), b.left -= s, b.right -= s, b.top -= l, b.bottom -= l, r.gesto.scrollBy(s, l, p.inputEvent), r._checkSelected(r.gesto.getCurrentEvent());
      }
    });
  }, n._select = function(r, a, s, l, p) {
    p === void 0 && (p = !1);
    var h = s.inputEvent, y = s.data, b = this.setSelectedTargets(r), E = Xm(y.startSelectedTargets, r), x = E.added, C = E.removed, T = E.prevList, O = E.list, D = {
      startSelected: T,
      startAdded: x.map(function(A) {
        return O[A];
      }),
      startRemoved: C.map(function(A) {
        return T[A];
      })
    };
    l && this.emit("selectStart", Bi(Bi(Bi({}, b), D), {
      rect: a,
      inputEvent: h,
      data: y.data,
      isTrusted: s.isTrusted,
      isDragStartEnd: p
    })), (b.added.length || b.removed.length) && this.emit("select", Bi(Bi(Bi({}, b), D), {
      rect: a,
      inputEvent: h,
      data: y.data,
      isTrusted: s.isTrusted,
      isDragStartEnd: p
    }));
  }, n._selectEnd = function(r, a, s, l, p) {
    p === void 0 && (p = !1);
    var h = l.inputEvent, y = l.isDouble, b = l.data, E = Xm(r, this.selectedTargets), x = E.added, C = E.removed, T = E.prevList, O = E.list, D = Xm(a, this.selectedTargets), A = D.added, B = D.removed, I = D.prevList, L = D.list;
    this.emit("selectEnd", {
      startSelected: r,
      beforeSelected: a,
      selected: this.selectedTargets,
      added: x.map(function(k) {
        return O[k];
      }),
      removed: C.map(function(k) {
        return T[k];
      }),
      afterAdded: A.map(function(k) {
        return L[k];
      }),
      afterRemoved: B.map(function(k) {
        return I[k];
      }),
      isDragStart: p,
      isDragStartEnd: p,
      isClick: !!l.isClick,
      isDouble: !!y,
      rect: s,
      inputEvent: h,
      data: b.data,
      isTrusted: l.isTrusted
    });
  }, n._checkSelected = function(r, a) {
    a === void 0 && (a = Tk(r, this.options.ratio));
    var s = r.data, l = a.top, p = a.left, h = a.width, y = a.height, b = s.selectFlag, E = s.containerX, x = s.containerY, C = s.scaleMatrix, T = BE(C, [p - E, l - x]), O = BE(C, [h, y]), D = [];
    if (b) {
      this.target.style.cssText += "display: block;left:0px;top:0px;" + "transform: translate(".concat(T[0], "px, ").concat(T[1], "px);") + "width:".concat(O[0], "px;height:").concat(O[1], "px;");
      var A = this.hitTest(a, s, r);
      D = Ok(s.startPassedTargets, A, this.continueSelect && this.continueSelectWithoutDeselect);
    }
    var B = this.emit("drag", Bi(Bi({}, r), {
      data: s.data,
      isSelect: b,
      rect: a
    }));
    if (B === !1) {
      this.target.style.cssText += "display: none;", r.stop();
      return;
    }
    b && this._select(D, a, r);
  }, n._sameCombiKey = function(r, a, s) {
    if (!a)
      return !1;
    var l = UB(r.inputEvent, r.key), p = [].concat(a), h = Ki(p[0]) ? p : [p];
    if (s) {
      var y = r.key;
      return h.some(function(b) {
        return b.some(function(E) {
          return E === y;
        });
      });
    }
    return h.some(function(b) {
      return b.every(function(E) {
        return l.indexOf(E) > -1;
      });
    });
  }, n._findElement = function(r, a) {
    for (var s = r; s && !(a.indexOf(s) > -1); )
      s = s.parentElement;
    return s;
  }, n._refreshGroups = function(r) {
    var a, s = r.innerWidth, l = r.innerHeight, p = r.selectablePoints;
    if (this.options.checkOverflow) {
      var h = (a = this.gesto.getEventData().innerScrollOptions) === null || a === void 0 ? void 0 : a.container, y = r.selectableInnerScrollParentMap, b = r.selectableInnerScrollPathsList;
      r.selectableInners = b.map(function(C, T) {
        var O = !1;
        return C.every(function(D) {
          if (O)
            return !0;
          if (D === h)
            return O = !0, !0;
          var A = y.get(D);
          if (A) {
            var B = p[T], I = A.points, L = FT(B, I);
            if (!L.length)
              return !1;
          }
          return !0;
        });
      });
    }
    if (!s || !l)
      r.innerGroups = null;
    else {
      var E = r.selectablePoints, x = {};
      E.forEach(function(C, T) {
        var O = 1 / 0, D = -1 / 0, A = 1 / 0, B = -1 / 0;
        C.forEach(function(k) {
          var $ = Math.floor(k[0] / s), U = Math.floor(k[1] / l);
          O = Math.min($, O), D = Math.max($, D), A = Math.min(U, A), B = Math.max(U, B);
        });
        for (var I = O; I <= D; ++I)
          for (var L = A; L <= B; ++L)
            x[I] = x[I] || {}, x[I][L] = x[I][L] || [], x[I][L].push(T);
      }), r.innerGroups = x;
    }
  }, t = FH([d5(MD, function(r, a) {
    var s = {
      enumerable: !0,
      configurable: !0,
      get: function() {
        return this.options[a];
      }
    }, l = AT("get ".concat(a));
    r[l] ? s.get = function() {
      return this[l]();
    } : s.get = function() {
      return this.options[a];
    };
    var p = AT("set ".concat(a));
    r[p] ? s.set = function(y) {
      this[p](y);
    } : s.set = function(y) {
      this.options[a] = y;
    }, Object.defineProperty(r, a, s);
  })], t), t;
}($b), YH = /* @__PURE__ */ function(e) {
  VB(t, e);
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return t;
}(HH);
const qH = YH;
var sO = function(e, t) {
  return sO = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var a in r)
      Object.prototype.hasOwnProperty.call(r, a) && (n[a] = r[a]);
  }, sO(e, t);
};
function XH(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  sO(e, t);
  function n() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
}
var yx = function() {
  return yx = Object.assign || function(t) {
    for (var n, r = 1, a = arguments.length; r < a; r++) {
      n = arguments[r];
      for (var s in n)
        Object.prototype.hasOwnProperty.call(n, s) && (t[s] = n[s]);
    }
    return t;
  }, yx.apply(this, arguments);
};
function KH(e, t, n, r) {
  var a = arguments.length, s = a < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, n) : r, l;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    s = Reflect.decorate(e, t, n, r);
  else
    for (var p = e.length - 1; p >= 0; p--)
      (l = e[p]) && (s = (a < 3 ? l(s) : a > 3 ? l(t, n, s) : l(t, n)) || s);
  return a > 3 && s && Object.defineProperty(t, n, s), s;
}
var Mk = HB.map(function(e) {
  return AT("on ".concat(e));
}), QH = /* @__PURE__ */ function(e) {
  XH(t, e);
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  var n = t.prototype;
  return n.render = function() {
    return Ks("div", {
      className: GB,
      ref: hd(this, "selectionElement")
    });
  }, n.componentDidMount = function() {
    var r = this, a = this.props, s = {};
    WH.forEach(function(l) {
      l in a && (s[l] = a[l]);
    }), this.selecto = new qH(yx(yx({}, s), {
      portalContainer: this.selectionElement
    })), HB.forEach(function(l, p) {
      r.selecto.on(l, function(h) {
        var y = r.props, b = y[Mk[p]] && y[Mk[p]](h);
        b === !1 && h.stop();
      });
    });
  }, n.componentDidUpdate = function(r) {
    var a = this.props, s = this.selecto;
    MD.forEach(function(l) {
      r[l] !== a[l] && (s[l] = a[l]);
    });
  }, n.componentWillUnmount = function() {
    this.selecto.destroy();
  }, KH([yL(GH)], t.prototype, "selecto", void 0), t;
}(DO);
const ZH = QH;
class JH {
  constructor({ store: t, width: n = 1920, height: r = 1080, scaleFactor: a = 1 } = {}) {
    Et(this, "width");
    Et(this, "height");
    Et(this, "scaleFactor");
    Et(this, "fit", () => {
      const { height: t } = document.querySelector("#available-space").getBoundingClientRect(), n = t * (this.store.inPreview ? 1 : 0.9);
      this.setDimensions({ height: n });
    });
    Et(this, "setDimensions", ({ height: t }) => {
      this.height = t, this.width = t * (16 / 9), this.scaleFactor = t / 1080;
    });
    Et(this, "setScale", (t) => {
      const n = t / this.scaleFactor;
      this.setDimensions({ height: this.height * n });
    });
    Et(this, "zoomIn", () => {
      this.setScale(Math.min(this.scaleFactor + 0.1, 3));
    });
    Et(this, "zoomOut", () => {
      this.setScale(Math.max(this.scaleFactor - 0.1, 0.1));
    });
    this.store = t, this.width = n, this.height = r, this.aspectRatio = n / r, this.scaleFactor = a, ng(this);
  }
}
class e6 {
  constructor(t) {
    Et(this, "active", !1);
    Et(this, "dragging", !1);
    Et(this, "setActive", (t) => {
      this.active = t;
    });
    Et(this, "onMouseDown", (t) => {
      t.preventDefault(), this.dragging = !0, this.ref = document.getElementById("available-space"), this.initialCoordinates = {
        x: t.clientX,
        y: t.clientY,
        scrollTop: this.ref.scrollTop,
        scrollLeft: this.ref.scrollLeft
      };
    });
    Et(this, "onMouseMove", (t) => {
      this.ref && this.dragging && (this.ref.scrollLeft = this.initialCoordinates.scrollLeft + (this.initialCoordinates.x - t.clientX), this.ref.scrollTop = this.initialCoordinates.scrollTop + (this.initialCoordinates.y - t.clientY));
    });
    Et(this, "onMouseLeave", () => {
      this.dragging = !1;
    });
    Et(this, "onMouseUp", () => {
      this.dragging = !1;
    });
    this.store = t, this.dragging = !1, this.ref = null, ng(this);
  }
  get props() {
    return this.active ? {
      onMouseDown: this.onMouseDown,
      onMouseMove: this.onMouseMove,
      onMouseUp: this.onMouseUp,
      onMouseLeave: this.onMouseLeave,
      style: {
        cursor: this.dragging ? "grabbing" : "grab"
      }
    } : {};
  }
}
class Xl {
  constructor({ id: t, title: n, handler: r, icon: a, category: s = "default" }) {
    Et(this, "id");
    Et(this, "title");
    Et(this, "icon");
    Et(this, "handler");
    Et(this, "category");
    this.id = t || n, this.title = n, this.handler = r, this.icon = a, this.category = s;
  }
}
Et(Xl, "groupedByCategories", function(t) {
  let n = {};
  return t.forEach((r) => {
    r.category in n ? n[r.category].push(r) : n[r.category] = [r];
  }), n;
});
class t6 {
  constructor(t) {
    Et(this, "targets");
    this.store = t, this.targets = [], ng(this);
  }
  setTargets(t) {
    var n;
    (n = this.selectoRef) != null && n.current && this.selectoRef.current.selecto.setSelectedTargets(t), this.targets = Array.from(new Set(t));
  }
  get boxes() {
    return this.store.boxes.filter((t) => t.isSelected);
  }
  get length() {
    return this.boxes.length;
  }
  get actions() {
    return this.store.inCropModeBox ? this.store.inCropModeBox.actions : this.length > 0 ? [
      ...this.length === 1 ? this.boxes[0].actions : [],
      new Xl({
        title: "Forward",
        handler: () => {
          this.store.zUp(), this.store.onZReorder({ undo: !0 });
        },
        icon: "bring-forward",
        category: "arrange"
      }),
      new Xl({
        title: "Backward",
        handler: () => {
          this.store.zDown(), this.store.onZReorder({ undo: !0 });
        },
        icon: "send-backward",
        category: "arrange"
      }),
      new Xl({
        title: "To front",
        handler: () => {
          this.store.toFront(), this.store.onZReorder({ undo: !0 });
        },
        icon: "bring-to-front",
        category: "arrange"
      }),
      new Xl({
        title: "To back",
        handler: () => {
          this.store.toBack(), this.store.onZReorder({ undo: !0 });
        },
        icon: "send-to-back",
        category: "arrange"
      }),
      new Xl({
        title: "Delete",
        handler: () => this.boxes.map((t) => this.store.removeBox(t)),
        icon: "trash"
      })
    ] : [];
  }
  get moveableProps() {
    if (this.boxes.length === 0)
      return {};
    if (this.boxes.length === 1)
      return this.boxes[0].moveableProps;
    {
      const t = {}, n = this.boxes.filter((r) => r.moveableProps.draggable);
      return n.length > 0 && Object.assign(t, {
        draggable: !0,
        onDragGroupStart: (r) => {
          this.store.setGuidelines(), n.forEach((a) => {
            a.onDragGroupStart && a.onDragGroupStart(r);
          });
        },
        onDragGroup: (r) => {
          n.forEach((a) => {
            a.moveableProps.onDragGroup(r);
          });
        },
        onDragGroupEnd: (r) => {
          n.forEach((a) => {
            a.onDragGroupEnd && a.onDragGroupEnd(r), this.store.onBoxUpdate(a);
          });
        }
      }), t;
    }
  }
  deselect() {
    this.boxes.forEach((t) => t.deselect());
  }
}
function Ak(e, t) {
  return e.reduce((n, r, a) => (t(r) ? n[n.length - 1].push(a) : n[n.length - 1].length !== 0 && n.push([]), n), [[]]).filter((n) => n.length > 0);
}
function Pk(e, t, n) {
  return e.splice(n, 0, e.splice(t, 1)[0]), e;
}
function n6(e) {
  return e * (Math.PI / 180);
}
function AD(e) {
  const t = _y(e);
  return t === !1 ? 0 : (t % 360 + 360) % 360;
}
function Nk(e) {
  const t = AD(e), n = n6(t), r = +Math.sin(n).toFixed(15), a = +Math.cos(n).toFixed(15), s = r / a;
  return {
    degrees: t,
    rad: n,
    sin: r,
    cos: a,
    tg: s
  };
}
function _y(e) {
  return isNaN(e) ? !1 : +e;
}
let CE;
const r6 = new Uint8Array(16);
function i6() {
  if (!CE && (CE = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !CE))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return CE(r6);
}
const Ba = [];
for (let e = 0; e < 256; ++e)
  Ba.push((e + 256).toString(16).slice(1));
function a6(e, t = 0) {
  return (Ba[e[t + 0]] + Ba[e[t + 1]] + Ba[e[t + 2]] + Ba[e[t + 3]] + "-" + Ba[e[t + 4]] + Ba[e[t + 5]] + "-" + Ba[e[t + 6]] + Ba[e[t + 7]] + "-" + Ba[e[t + 8]] + Ba[e[t + 9]] + "-" + Ba[e[t + 10]] + Ba[e[t + 11]] + Ba[e[t + 12]] + Ba[e[t + 13]] + Ba[e[t + 14]] + Ba[e[t + 15]]).toLowerCase();
}
const o6 = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), kk = {
  randomUUID: o6
};
function s6(e, t, n) {
  if (kk.randomUUID && !t && !e)
    return kk.randomUUID();
  e = e || {};
  const r = e.random || (e.rng || i6)();
  if (r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, t) {
    n = n || 0;
    for (let a = 0; a < 16; ++a)
      t[n + a] = r[a];
    return t;
  }
  return a6(r);
}
var uO = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
(function(e, t) {
  (function() {
    var n, r = "4.17.21", a = 200, s = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", l = "Expected a function", p = "Invalid `variable` option passed into `_.template`", h = "__lodash_hash_undefined__", y = 500, b = "__lodash_placeholder__", E = 1, x = 2, C = 4, T = 1, O = 2, D = 1, A = 2, B = 4, I = 8, L = 16, k = 32, $ = 64, U = 128, K = 256, X = 512, Y = 30, J = "...", Q = 800, Z = 16, se = 1, pe = 2, be = 3, _e = 1 / 0, Se = 9007199254740991, Oe = 17976931348623157e292, re = 0 / 0, ie = 4294967295, ce = ie - 1, le = ie >>> 1, fe = [
      ["ary", U],
      ["bind", D],
      ["bindKey", A],
      ["curry", I],
      ["curryRight", L],
      ["flip", X],
      ["partial", k],
      ["partialRight", $],
      ["rearg", K]
    ], ve = "[object Arguments]", ee = "[object Array]", Ae = "[object AsyncFunction]", he = "[object Boolean]", Fe = "[object Date]", Ne = "[object DOMException]", xe = "[object Error]", oe = "[object Function]", it = "[object GeneratorFunction]", Le = "[object Map]", qe = "[object Number]", Tt = "[object Null]", Qe = "[object Object]", pt = "[object Promise]", en = "[object Proxy]", wt = "[object RegExp]", tn = "[object Set]", Vn = "[object String]", Kt = "[object Symbol]", ft = "[object Undefined]", Gt = "[object WeakMap]", xn = "[object WeakSet]", gn = "[object ArrayBuffer]", rr = "[object DataView]", Zi = "[object Float32Array]", At = "[object Float64Array]", at = "[object Int8Array]", bt = "[object Int16Array]", Pt = "[object Int32Array]", dn = "[object Uint8Array]", Nn = "[object Uint8ClampedArray]", kn = "[object Uint16Array]", In = "[object Uint32Array]", Cr = /\b__p \+= '';/g, Nt = /\b(__p \+=) '' \+/g, jn = /(__e\(.*?\)|\b__t\)) \+\n'';/g, ss = /&(?:amp|lt|gt|quot|#39);/g, Ji = /[&<>"']/g, so = RegExp(ss.source), Ua = RegExp(Ji.source), uo = /<%-([\s\S]+?)%>/g, ea = /<%([\s\S]+?)%>/g, ta = /<%=([\s\S]+?)%>/g, us = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Va = /^\w*$/, il = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, de = /[\\^$.*+?()[\]{}|]/g, tt = RegExp(de.source), ct = /^\s+/, kt = /\s/, mn = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, zt = /\{\n\/\* \[wrapped with (.+)\] \*/, yn = /,? & /, Sn = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, Kn = /[()=,{}\[\]\/\s]/, Fn = /\\(\\)?/g, Qn = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, Ea = /\w*$/, xa = /^[-+]0x[0-9a-f]+$/i, ru = /^0b[01]+$/i, Vi = /^\[object .+?Constructor\]$/, Td = /^0o[0-7]+$/i, ig = /^(?:0|[1-9]\d*)$/, ag = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Sa = /($^)/, Di = /['\n\r\u2028\u2029\\]/g, al = "\\ud800-\\udfff", Od = "\\u0300-\\u036f", iu = "\\ufe20-\\ufe2f", Dd = "\\u20d0-\\u20ff", oc = Od + iu + Dd, av = "\\u2700-\\u27bf", sc = "a-z\\xdf-\\xf6\\xf8-\\xff", og = "\\xac\\xb1\\xd7\\xf7", uc = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", ov = "\\u2000-\\u206f", ja = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", ls = "A-Z\\xc0-\\xd6\\xd8-\\xde", To = "\\ufe0e\\ufe0f", cs = og + uc + ov + ja, au = "['\u2019]", dt = "[" + al + "]", ol = "[" + cs + "]", ri = "[" + oc + "]", fs = "\\d+", lc = "[" + av + "]", cc = "[" + sc + "]", ji = "[^" + al + cs + fs + av + sc + ls + "]", $r = "\\ud83c[\\udffb-\\udfff]", wa = "(?:" + ri + "|" + $r + ")", sv = "[^" + al + "]", na = "(?:\\ud83c[\\udde6-\\uddff]){2}", ra = "[\\ud800-\\udbff][\\udc00-\\udfff]", sl = "[" + ls + "]", ul = "\\u200d", ou = "(?:" + cc + "|" + ji + ")", Md = "(?:" + sl + "|" + ji + ")", uv = "(?:" + au + "(?:d|ll|m|re|s|t|ve))?", af = "(?:" + au + "(?:D|LL|M|RE|S|T|VE))?", lv = wa + "?", fc = "[" + To + "]?", cv = "(?:" + ul + "(?:" + [sv, na, ra].join("|") + ")" + fc + lv + ")*", of = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", fv = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", sf = fc + lv + cv, sg = "(?:" + [lc, na, ra].join("|") + ")" + sf, Ad = "(?:" + [sv + ri + "?", ri, na, ra, dt].join("|") + ")", ug = RegExp(au, "g"), Wn = RegExp(ri, "g"), ds = RegExp($r + "(?=" + $r + ")|" + Ad + sf, "g"), lg = RegExp([
      sl + "?" + cc + "+" + uv + "(?=" + [ol, sl, "$"].join("|") + ")",
      Md + "+" + af + "(?=" + [ol, sl + ou, "$"].join("|") + ")",
      sl + "?" + ou + "+" + uv,
      sl + "+" + af,
      fv,
      of,
      fs,
      sg
    ].join("|"), "g"), dv = RegExp("[" + ul + al + oc + To + "]"), dc = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, cg = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], Pd = -1, Dn = {};
    Dn[Zi] = Dn[At] = Dn[at] = Dn[bt] = Dn[Pt] = Dn[dn] = Dn[Nn] = Dn[kn] = Dn[In] = !0, Dn[ve] = Dn[ee] = Dn[gn] = Dn[he] = Dn[rr] = Dn[Fe] = Dn[xe] = Dn[oe] = Dn[Le] = Dn[qe] = Dn[Qe] = Dn[wt] = Dn[tn] = Dn[Vn] = Dn[Gt] = !1;
    var $n = {};
    $n[ve] = $n[ee] = $n[gn] = $n[rr] = $n[he] = $n[Fe] = $n[Zi] = $n[At] = $n[at] = $n[bt] = $n[Pt] = $n[Le] = $n[qe] = $n[Qe] = $n[wt] = $n[tn] = $n[Vn] = $n[Kt] = $n[dn] = $n[Nn] = $n[kn] = $n[In] = !0, $n[xe] = $n[oe] = $n[Gt] = !1;
    var uf = {
      \u00C0: "A",
      \u00C1: "A",
      \u00C2: "A",
      \u00C3: "A",
      \u00C4: "A",
      \u00C5: "A",
      \u00E0: "a",
      \u00E1: "a",
      \u00E2: "a",
      \u00E3: "a",
      \u00E4: "a",
      \u00E5: "a",
      \u00C7: "C",
      \u00E7: "c",
      \u00D0: "D",
      \u00F0: "d",
      \u00C8: "E",
      \u00C9: "E",
      \u00CA: "E",
      \u00CB: "E",
      \u00E8: "e",
      \u00E9: "e",
      \u00EA: "e",
      \u00EB: "e",
      \u00CC: "I",
      \u00CD: "I",
      \u00CE: "I",
      \u00CF: "I",
      \u00EC: "i",
      \u00ED: "i",
      \u00EE: "i",
      \u00EF: "i",
      \u00D1: "N",
      \u00F1: "n",
      \u00D2: "O",
      \u00D3: "O",
      \u00D4: "O",
      \u00D5: "O",
      \u00D6: "O",
      \u00D8: "O",
      \u00F2: "o",
      \u00F3: "o",
      \u00F4: "o",
      \u00F5: "o",
      \u00F6: "o",
      \u00F8: "o",
      \u00D9: "U",
      \u00DA: "U",
      \u00DB: "U",
      \u00DC: "U",
      \u00F9: "u",
      \u00FA: "u",
      \u00FB: "u",
      \u00FC: "u",
      \u00DD: "Y",
      \u00FD: "y",
      \u00FF: "y",
      \u00C6: "Ae",
      \u00E6: "ae",
      \u00DE: "Th",
      \u00FE: "th",
      \u00DF: "ss",
      \u0100: "A",
      \u0102: "A",
      \u0104: "A",
      \u0101: "a",
      \u0103: "a",
      \u0105: "a",
      \u0106: "C",
      \u0108: "C",
      \u010A: "C",
      \u010C: "C",
      \u0107: "c",
      \u0109: "c",
      \u010B: "c",
      \u010D: "c",
      \u010E: "D",
      \u0110: "D",
      \u010F: "d",
      \u0111: "d",
      \u0112: "E",
      \u0114: "E",
      \u0116: "E",
      \u0118: "E",
      \u011A: "E",
      \u0113: "e",
      \u0115: "e",
      \u0117: "e",
      \u0119: "e",
      \u011B: "e",
      \u011C: "G",
      \u011E: "G",
      \u0120: "G",
      \u0122: "G",
      \u011D: "g",
      \u011F: "g",
      \u0121: "g",
      \u0123: "g",
      \u0124: "H",
      \u0126: "H",
      \u0125: "h",
      \u0127: "h",
      \u0128: "I",
      \u012A: "I",
      \u012C: "I",
      \u012E: "I",
      \u0130: "I",
      \u0129: "i",
      \u012B: "i",
      \u012D: "i",
      \u012F: "i",
      \u0131: "i",
      \u0134: "J",
      \u0135: "j",
      \u0136: "K",
      \u0137: "k",
      \u0138: "k",
      \u0139: "L",
      \u013B: "L",
      \u013D: "L",
      \u013F: "L",
      \u0141: "L",
      \u013A: "l",
      \u013C: "l",
      \u013E: "l",
      \u0140: "l",
      \u0142: "l",
      \u0143: "N",
      \u0145: "N",
      \u0147: "N",
      \u014A: "N",
      \u0144: "n",
      \u0146: "n",
      \u0148: "n",
      \u014B: "n",
      \u014C: "O",
      \u014E: "O",
      \u0150: "O",
      \u014D: "o",
      \u014F: "o",
      \u0151: "o",
      \u0154: "R",
      \u0156: "R",
      \u0158: "R",
      \u0155: "r",
      \u0157: "r",
      \u0159: "r",
      \u015A: "S",
      \u015C: "S",
      \u015E: "S",
      \u0160: "S",
      \u015B: "s",
      \u015D: "s",
      \u015F: "s",
      \u0161: "s",
      \u0162: "T",
      \u0164: "T",
      \u0166: "T",
      \u0163: "t",
      \u0165: "t",
      \u0167: "t",
      \u0168: "U",
      \u016A: "U",
      \u016C: "U",
      \u016E: "U",
      \u0170: "U",
      \u0172: "U",
      \u0169: "u",
      \u016B: "u",
      \u016D: "u",
      \u016F: "u",
      \u0171: "u",
      \u0173: "u",
      \u0174: "W",
      \u0175: "w",
      \u0176: "Y",
      \u0177: "y",
      \u0178: "Y",
      \u0179: "Z",
      \u017B: "Z",
      \u017D: "Z",
      \u017A: "z",
      \u017C: "z",
      \u017E: "z",
      \u0132: "IJ",
      \u0133: "ij",
      \u0152: "Oe",
      \u0153: "oe",
      \u0149: "'n",
      \u017F: "s"
    }, su = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, fg = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, Iy = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, pv = parseFloat, vv = parseInt, hv = typeof $0 == "object" && $0 && $0.Object === Object && $0, lf = typeof self == "object" && self && self.Object === Object && self, yi = hv || lf || Function("return this")(), uu = t && !t.nodeType && t, lo = uu && !0 && e && !e.nodeType && e, cf = lo && lo.exports === uu, Oo = cf && hv.process, ia = function() {
      try {
        var Ce = lo && lo.require && lo.require("util").types;
        return Ce || Oo && Oo.binding && Oo.binding("util");
      } catch {
      }
    }(), ff = ia && ia.isArrayBuffer, Nd = ia && ia.isDate, ll = ia && ia.isMap, pc = ia && ia.isRegExp, kd = ia && ia.isSet, Wi = ia && ia.isTypedArray;
    function ii(Ce, $e, Be) {
      switch (Be.length) {
        case 0:
          return Ce.call($e);
        case 1:
          return Ce.call($e, Be[0]);
        case 2:
          return Ce.call($e, Be[0], Be[1]);
        case 3:
          return Ce.call($e, Be[0], Be[1], Be[2]);
      }
      return Ce.apply($e, Be);
    }
    function vc(Ce, $e, Be, ot) {
      for (var an = -1, Mn = Ce == null ? 0 : Ce.length; ++an < Mn; ) {
        var Ln = Ce[an];
        $e(ot, Ln, Be(Ln), Ce);
      }
      return ot;
    }
    function bi(Ce, $e) {
      for (var Be = -1, ot = Ce == null ? 0 : Ce.length; ++Be < ot && $e(Ce[Be], Be, Ce) !== !1; )
        ;
      return Ce;
    }
    function gv(Ce, $e) {
      for (var Be = Ce == null ? 0 : Ce.length; Be-- && $e(Ce[Be], Be, Ce) !== !1; )
        ;
      return Ce;
    }
    function df(Ce, $e) {
      for (var Be = -1, ot = Ce == null ? 0 : Ce.length; ++Be < ot; )
        if (!$e(Ce[Be], Be, Ce))
          return !1;
      return !0;
    }
    function Wa(Ce, $e) {
      for (var Be = -1, ot = Ce == null ? 0 : Ce.length, an = 0, Mn = []; ++Be < ot; ) {
        var Ln = Ce[Be];
        $e(Ln, Be, Ce) && (Mn[an++] = Ln);
      }
      return Mn;
    }
    function Do(Ce, $e) {
      var Be = Ce == null ? 0 : Ce.length;
      return !!Be && cl(Ce, $e, 0) > -1;
    }
    function hc(Ce, $e, Be) {
      for (var ot = -1, an = Ce == null ? 0 : Ce.length; ++ot < an; )
        if (Be($e, Ce[ot]))
          return !0;
      return !1;
    }
    function Gn(Ce, $e) {
      for (var Be = -1, ot = Ce == null ? 0 : Ce.length, an = Array(ot); ++Be < ot; )
        an[Be] = $e(Ce[Be], Be, Ce);
      return an;
    }
    function ps(Ce, $e) {
      for (var Be = -1, ot = $e.length, an = Ce.length; ++Be < ot; )
        Ce[an + Be] = $e[Be];
      return Ce;
    }
    function aa(Ce, $e, Be, ot) {
      var an = -1, Mn = Ce == null ? 0 : Ce.length;
      for (ot && Mn && (Be = Ce[++an]); ++an < Mn; )
        Be = $e(Be, Ce[an], an, Ce);
      return Be;
    }
    function vs(Ce, $e, Be, ot) {
      var an = Ce == null ? 0 : Ce.length;
      for (ot && an && (Be = Ce[--an]); an--; )
        Be = $e(Be, Ce[an], an, Ce);
      return Be;
    }
    function _i(Ce, $e) {
      for (var Be = -1, ot = Ce == null ? 0 : Ce.length; ++Be < ot; )
        if ($e(Ce[Be], Be, Ce))
          return !0;
      return !1;
    }
    var lu = mv("length");
    function dg(Ce) {
      return Ce.split("");
    }
    function Id(Ce) {
      return Ce.match(Sn) || [];
    }
    function pg(Ce, $e, Be) {
      var ot;
      return Be(Ce, function(an, Mn, Ln) {
        if ($e(an, Mn, Ln))
          return ot = Mn, !1;
      }), ot;
    }
    function cu(Ce, $e, Be, ot) {
      for (var an = Ce.length, Mn = Be + (ot ? 1 : -1); ot ? Mn-- : ++Mn < an; )
        if ($e(Ce[Mn], Mn, Ce))
          return Mn;
      return -1;
    }
    function cl(Ce, $e, Be) {
      return $e === $e ? $d(Ce, $e, Be) : cu(Ce, Ld, Be);
    }
    function Ly(Ce, $e, Be, ot) {
      for (var an = Be - 1, Mn = Ce.length; ++an < Mn; )
        if (ot(Ce[an], $e))
          return an;
      return -1;
    }
    function Ld(Ce) {
      return Ce !== Ce;
    }
    function vg(Ce, $e) {
      var Be = Ce == null ? 0 : Ce.length;
      return Be ? bv(Ce, $e) / Be : re;
    }
    function mv(Ce) {
      return function($e) {
        return $e == null ? n : $e[Ce];
      };
    }
    function pf(Ce) {
      return function($e) {
        return Ce == null ? n : Ce[$e];
      };
    }
    function yv(Ce, $e, Be, ot, an) {
      return an(Ce, function(Mn, Ln, Zn) {
        Be = ot ? (ot = !1, Mn) : $e(Be, Mn, Ln, Zn);
      }), Be;
    }
    function By(Ce, $e) {
      var Be = Ce.length;
      for (Ce.sort($e); Be--; )
        Ce[Be] = Ce[Be].value;
      return Ce;
    }
    function bv(Ce, $e) {
      for (var Be, ot = -1, an = Ce.length; ++ot < an; ) {
        var Mn = $e(Ce[ot]);
        Mn !== n && (Be = Be === n ? Mn : Be + Mn);
      }
      return Be;
    }
    function Bd(Ce, $e) {
      for (var Be = -1, ot = Array(Ce); ++Be < Ce; )
        ot[Be] = $e(Be);
      return ot;
    }
    function hg(Ce, $e) {
      return Gn($e, function(Be) {
        return [Be, Ce[Be]];
      });
    }
    function fl(Ce) {
      return Ce && Ce.slice(0, Mo(Ce) + 1).replace(ct, "");
    }
    function Gi(Ce) {
      return function($e) {
        return Ce($e);
      };
    }
    function zd(Ce, $e) {
      return Gn($e, function(Be) {
        return Ce[Be];
      });
    }
    function gc(Ce, $e) {
      return Ce.has($e);
    }
    function gg(Ce, $e) {
      for (var Be = -1, ot = Ce.length; ++Be < ot && cl($e, Ce[Be], 0) > -1; )
        ;
      return Be;
    }
    function mg(Ce, $e) {
      for (var Be = Ce.length; Be-- && cl($e, Ce[Be], 0) > -1; )
        ;
      return Be;
    }
    function _v(Ce, $e) {
      for (var Be = Ce.length, ot = 0; Be--; )
        Ce[Be] === $e && ++ot;
      return ot;
    }
    var vf = pf(uf), zy = pf(su);
    function yg(Ce) {
      return "\\" + Iy[Ce];
    }
    function bg(Ce, $e) {
      return Ce == null ? n : Ce[$e];
    }
    function dl(Ce) {
      return dv.test(Ce);
    }
    function Ev(Ce) {
      return dc.test(Ce);
    }
    function _g(Ce) {
      for (var $e, Be = []; !($e = Ce.next()).done; )
        Be.push($e.value);
      return Be;
    }
    function hs(Ce) {
      var $e = -1, Be = Array(Ce.size);
      return Ce.forEach(function(ot, an) {
        Be[++$e] = [an, ot];
      }), Be;
    }
    function Eg(Ce, $e) {
      return function(Be) {
        return Ce($e(Be));
      };
    }
    function fu(Ce, $e) {
      for (var Be = -1, ot = Ce.length, an = 0, Mn = []; ++Be < ot; ) {
        var Ln = Ce[Be];
        (Ln === $e || Ln === b) && (Ce[Be] = b, Mn[an++] = Be);
      }
      return Mn;
    }
    function Fd(Ce) {
      var $e = -1, Be = Array(Ce.size);
      return Ce.forEach(function(ot) {
        Be[++$e] = ot;
      }), Be;
    }
    function xg(Ce) {
      var $e = -1, Be = Array(Ce.size);
      return Ce.forEach(function(ot) {
        Be[++$e] = [ot, ot];
      }), Be;
    }
    function $d(Ce, $e, Be) {
      for (var ot = Be - 1, an = Ce.length; ++ot < an; )
        if (Ce[ot] === $e)
          return ot;
      return -1;
    }
    function co(Ce, $e, Be) {
      for (var ot = Be + 1; ot--; )
        if (Ce[ot] === $e)
          return ot;
      return ot;
    }
    function Ca(Ce) {
      return dl(Ce) ? Sg(Ce) : lu(Ce);
    }
    function Ga(Ce) {
      return dl(Ce) ? xv(Ce) : dg(Ce);
    }
    function Mo(Ce) {
      for (var $e = Ce.length; $e-- && kt.test(Ce.charAt($e)); )
        ;
      return $e;
    }
    var Fy = pf(fg);
    function Sg(Ce) {
      for (var $e = ds.lastIndex = 0; ds.test(Ce); )
        ++$e;
      return $e;
    }
    function xv(Ce) {
      return Ce.match(ds) || [];
    }
    function Sv(Ce) {
      return Ce.match(lg) || [];
    }
    var wg = function Ce($e) {
      $e = $e == null ? yi : pl.defaults(yi.Object(), $e, pl.pick(yi, cg));
      var Be = $e.Array, ot = $e.Date, an = $e.Error, Mn = $e.Function, Ln = $e.Math, Zn = $e.Object, vl = $e.RegExp, Cg = $e.String, Ra = $e.TypeError, mc = Be.prototype, hf = Mn.prototype, Ha = Zn.prototype, gf = $e["__core-js_shared__"], gs = hf.toString, Tn = Ha.hasOwnProperty, hl = 0, ms = function() {
        var c = /[^.]+$/.exec(gf && gf.keys && gf.keys.IE_PROTO || "");
        return c ? "Symbol(src)_1." + c : "";
      }(), Ao = Ha.toString, wv = gs.call(Zn), Cv = yi._, yc = vl(
        "^" + gs.call(Tn).replace(de, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), mf = cf ? $e.Buffer : n, Po = $e.Symbol, gl = $e.Uint8Array, Jn = mf ? mf.allocUnsafe : n, ml = Eg(Zn.getPrototypeOf, Zn), Ud = Zn.create, No = Ha.propertyIsEnumerable, yl = mc.splice, yf = Po ? Po.isConcatSpreadable : n, ys = Po ? Po.iterator : n, ko = Po ? Po.toStringTag : n, bs = function() {
        try {
          var c = Mr(Zn, "defineProperty");
          return c({}, "", {}), c;
        } catch {
        }
      }(), Rg = $e.clearTimeout !== yi.clearTimeout && $e.clearTimeout, Vd = ot && ot.now !== yi.Date.now && ot.now, Rv = $e.setTimeout !== yi.setTimeout && $e.setTimeout, bc = Ln.ceil, _s = Ln.floor, bl = Zn.getOwnPropertySymbols, _c = mf ? mf.isBuffer : n, Tv = $e.isFinite, jd = mc.join, du = Eg(Zn.keys, Zn), Ur = Ln.max, br = Ln.min, Wd = ot.now, _l = $e.parseInt, fo = Ln.random, Gd = mc.reverse, Ei = Mr($e, "DataView"), Ec = Mr($e, "Map"), Es = Mr($e, "Promise"), ai = Mr($e, "Set"), Qr = Mr($e, "WeakMap"), Ta = Mr(Zn, "create"), bf = Qr && new Qr(), pu = {}, Hn = Ia(Ei), Hi = Ia(Ec), nn = Ia(Es), Ht = Ia(ai), vu = Ia(Qr), er = Po ? Po.prototype : n, Lr = er ? er.valueOf : n, xs = er ? er.toString : n;
      function G(c) {
        if (Ar(c) && !cn(c) && !(c instanceof un)) {
          if (c instanceof xi)
            return c;
          if (Tn.call(c, "__wrapped__"))
            return zl(c);
        }
        return new xi(c);
      }
      var Rr = function() {
        function c() {
        }
        return function(v) {
          if (!Fr(v))
            return {};
          if (Ud)
            return Ud(v);
          c.prototype = v;
          var S = new c();
          return c.prototype = n, S;
        };
      }();
      function Oa() {
      }
      function xi(c, v) {
        this.__wrapped__ = c, this.__actions__ = [], this.__chain__ = !!v, this.__index__ = 0, this.__values__ = n;
      }
      G.templateSettings = {
        escape: uo,
        evaluate: ea,
        interpolate: ta,
        variable: "",
        imports: {
          _: G
        }
      }, G.prototype = Oa.prototype, G.prototype.constructor = G, xi.prototype = Rr(Oa.prototype), xi.prototype.constructor = xi;
      function un(c) {
        this.__wrapped__ = c, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = ie, this.__views__ = [];
      }
      function Ya() {
        var c = new un(this.__wrapped__);
        return c.__actions__ = Bn(this.__actions__), c.__dir__ = this.__dir__, c.__filtered__ = this.__filtered__, c.__iteratees__ = Bn(this.__iteratees__), c.__takeCount__ = this.__takeCount__, c.__views__ = Bn(this.__views__), c;
      }
      function Tg() {
        if (this.__filtered__) {
          var c = new un(this);
          c.__dir__ = -1, c.__filtered__ = !0;
        } else
          c = this.clone(), c.__dir__ *= -1;
        return c;
      }
      function Ov() {
        var c = this.__wrapped__.value(), v = this.__dir__, S = cn(c), P = v < 0, j = S ? c.length : 0, q = Uf(0, j, this.__views__), ue = q.start, ge = q.end, Re = ge - ue, Ve = P ? ge : ue - 1, je = this.__iteratees__, Xe = je.length, ut = 0, Ot = br(Re, this.__takeCount__);
        if (!S || !P && j == Re && Ot == Re)
          return kf(c, this.__actions__);
        var Vt = [];
        e:
          for (; Re-- && ut < Ot; ) {
            Ve += v;
            for (var Xt = -1, Lt = c[Ve]; ++Xt < Xe; ) {
              var wn = je[Xt], Rn = wn.iteratee, ha = wn.type, ci = Rn(Lt);
              if (ha == pe)
                Lt = ci;
              else if (!ci) {
                if (ha == se)
                  continue e;
                break e;
              }
            }
            Vt[ut++] = Lt;
          }
        return Vt;
      }
      un.prototype = Rr(Oa.prototype), un.prototype.constructor = un;
      function Da(c) {
        var v = -1, S = c == null ? 0 : c.length;
        for (this.clear(); ++v < S; ) {
          var P = c[v];
          this.set(P[0], P[1]);
        }
      }
      function _f() {
        this.__data__ = Ta ? Ta(null) : {}, this.size = 0;
      }
      function po(c) {
        var v = this.has(c) && delete this.__data__[c];
        return this.size -= v ? 1 : 0, v;
      }
      function Ef(c) {
        var v = this.__data__;
        if (Ta) {
          var S = v[c];
          return S === h ? n : S;
        }
        return Tn.call(v, c) ? v[c] : n;
      }
      function $y(c) {
        var v = this.__data__;
        return Ta ? v[c] !== n : Tn.call(v, c);
      }
      function hu(c, v) {
        var S = this.__data__;
        return this.size += this.has(c) ? 0 : 1, S[c] = Ta && v === n ? h : v, this;
      }
      Da.prototype.clear = _f, Da.prototype.delete = po, Da.prototype.get = Ef, Da.prototype.has = $y, Da.prototype.set = hu;
      function qa(c) {
        var v = -1, S = c == null ? 0 : c.length;
        for (this.clear(); ++v < S; ) {
          var P = c[v];
          this.set(P[0], P[1]);
        }
      }
      function Og() {
        this.__data__ = [], this.size = 0;
      }
      function Hd(c) {
        var v = this.__data__, S = wl(v, c);
        if (S < 0)
          return !1;
        var P = v.length - 1;
        return S == P ? v.pop() : yl.call(v, S, 1), --this.size, !0;
      }
      function Dg(c) {
        var v = this.__data__, S = wl(v, c);
        return S < 0 ? n : v[S][1];
      }
      function Dv(c) {
        return wl(this.__data__, c) > -1;
      }
      function Mv(c, v) {
        var S = this.__data__, P = wl(S, c);
        return P < 0 ? (++this.size, S.push([c, v])) : S[P][1] = v, this;
      }
      qa.prototype.clear = Og, qa.prototype.delete = Hd, qa.prototype.get = Dg, qa.prototype.has = Dv, qa.prototype.set = Mv;
      function vo(c) {
        var v = -1, S = c == null ? 0 : c.length;
        for (this.clear(); ++v < S; ) {
          var P = c[v];
          this.set(P[0], P[1]);
        }
      }
      function Av() {
        this.size = 0, this.__data__ = {
          hash: new Da(),
          map: new (Ec || qa)(),
          string: new Da()
        };
      }
      function Mg(c) {
        var v = ks(this, c).delete(c);
        return this.size -= v ? 1 : 0, v;
      }
      function Io(c) {
        return ks(this, c).get(c);
      }
      function Yd(c) {
        return ks(this, c).has(c);
      }
      function xf(c, v) {
        var S = ks(this, c), P = S.size;
        return S.set(c, v), this.size += S.size == P ? 0 : 1, this;
      }
      vo.prototype.clear = Av, vo.prototype.delete = Mg, vo.prototype.get = Io, vo.prototype.has = Yd, vo.prototype.set = xf;
      function gu(c) {
        var v = -1, S = c == null ? 0 : c.length;
        for (this.__data__ = new vo(); ++v < S; )
          this.add(c[v]);
      }
      function Si(c) {
        return this.__data__.set(c, h), this;
      }
      function xc(c) {
        return this.__data__.has(c);
      }
      gu.prototype.add = gu.prototype.push = Si, gu.prototype.has = xc;
      function Ma(c) {
        var v = this.__data__ = new qa(c);
        this.size = v.size;
      }
      function El() {
        this.__data__ = new qa(), this.size = 0;
      }
      function xl(c) {
        var v = this.__data__, S = v.delete(c);
        return this.size = v.size, S;
      }
      function oi(c) {
        return this.__data__.get(c);
      }
      function Ss(c) {
        return this.__data__.has(c);
      }
      function mu(c, v) {
        var S = this.__data__;
        if (S instanceof qa) {
          var P = S.__data__;
          if (!Ec || P.length < a - 1)
            return P.push([c, v]), this.size = ++S.size, this;
          S = this.__data__ = new vo(P);
        }
        return S.set(c, v), this.size = S.size, this;
      }
      Ma.prototype.clear = El, Ma.prototype.delete = xl, Ma.prototype.get = oi, Ma.prototype.has = Ss, Ma.prototype.set = mu;
      function Zr(c, v) {
        var S = cn(c), P = !S && Lc(c), j = !S && !P && Bc(c), q = !S && !P && !j && xp(c), ue = S || P || j || q, ge = ue ? Bd(c.length, Cg) : [], Re = ge.length;
        for (var Ve in c)
          (v || Tn.call(c, Ve)) && !(ue && (Ve == "length" || j && (Ve == "offset" || Ve == "parent") || q && (Ve == "buffer" || Ve == "byteLength" || Ve == "byteOffset") || Ai(Ve, Re))) && ge.push(Ve);
        return ge;
      }
      function ws(c) {
        var v = c.length;
        return v ? c[go(0, v - 1)] : n;
      }
      function yu(c, v) {
        return Xf(Bn(c), _u(v, 0, c.length));
      }
      function Lo(c) {
        return Xf(Bn(c));
      }
      function Sc(c, v, S) {
        (S !== n && !qo(c[v], S) || S === n && !(v in c)) && Vr(c, v, S);
      }
      function Sl(c, v, S) {
        var P = c[v];
        (!(Tn.call(c, v) && qo(P, S)) || S === n && !(v in c)) && Vr(c, v, S);
      }
      function wl(c, v) {
        for (var S = c.length; S--; )
          if (qo(c[S][0], v))
            return S;
        return -1;
      }
      function Pv(c, v, S, P) {
        return ho(c, function(j, q, ue) {
          v(P, j, S(j), ue);
        }), P;
      }
      function bu(c, v) {
        return c && wi(v, Ni(v), c);
      }
      function Aa(c, v) {
        return c && wi(v, eo(v), c);
      }
      function Vr(c, v, S) {
        v == "__proto__" && bs ? bs(c, v, {
          configurable: !0,
          enumerable: !0,
          value: S,
          writable: !0
        }) : c[v] = S;
      }
      function Sf(c, v) {
        for (var S = -1, P = v.length, j = Be(P), q = c == null; ++S < P; )
          j[S] = q ? n : r0(c, v[S]);
        return j;
      }
      function _u(c, v, S) {
        return c === c && (S !== n && (c = c <= S ? c : S), v !== n && (c = c >= v ? c : v)), c;
      }
      function Tr(c, v, S, P, j, q) {
        var ue, ge = v & E, Re = v & x, Ve = v & C;
        if (S && (ue = j ? S(c, P, j, q) : S(c)), ue !== n)
          return ue;
        if (!Fr(c))
          return c;
        var je = cn(c);
        if (je) {
          if (ue = kc(c), !ge)
            return Bn(c, ue);
        } else {
          var Xe = ui(c), ut = Xe == oe || Xe == it;
          if (Bc(c))
            return zv(c, ge);
          if (Xe == Qe || Xe == ve || ut && !j) {
            if (ue = Re || ut ? {} : gt(c), !ge)
              return Re ? Ac(c, Aa(ue, c)) : Pn(c, bu(ue, c));
          } else {
            if (!$n[Xe])
              return j ? c : {};
            ue = jf(c, Xe, ge);
          }
        }
        q || (q = new Ma());
        var Ot = q.get(c);
        if (Ot)
          return Ot;
        q.set(c, ue), tm(c) ? c.forEach(function(Lt) {
          ue.add(Tr(Lt, v, S, Lt, c, q));
        }) : em(c) && c.forEach(function(Lt, wn) {
          ue.set(wn, Tr(Lt, v, S, wn, c, q));
        });
        var Vt = Ve ? Re ? Yt : Ns : Re ? eo : Ni, Xt = je ? n : Vt(c);
        return bi(Xt || c, function(Lt, wn) {
          Xt && (wn = Lt, Lt = c[wn]), Sl(ue, wn, Tr(Lt, v, S, wn, c, q));
        }), ue;
      }
      function Cs(c) {
        var v = Ni(c);
        return function(S) {
          return Nv(S, c, v);
        };
      }
      function Nv(c, v, S) {
        var P = S.length;
        if (c == null)
          return !P;
        for (c = Zn(c); P--; ) {
          var j = S[P], q = v[j], ue = c[j];
          if (ue === n && !(j in c) || !q(ue))
            return !1;
        }
        return !0;
      }
      function Bo(c, v, S) {
        if (typeof c != "function")
          throw new Ra(l);
        return Ho(function() {
          c.apply(n, S);
        }, v);
      }
      function Cl(c, v, S, P) {
        var j = -1, q = Do, ue = !0, ge = c.length, Re = [], Ve = v.length;
        if (!ge)
          return Re;
        S && (v = Gn(v, Gi(S))), P ? (q = hc, ue = !1) : v.length >= a && (q = gc, ue = !1, v = new gu(v));
        e:
          for (; ++j < ge; ) {
            var je = c[j], Xe = S == null ? je : S(je);
            if (je = P || je !== 0 ? je : 0, ue && Xe === Xe) {
              for (var ut = Ve; ut--; )
                if (v[ut] === Xe)
                  continue e;
              Re.push(je);
            } else
              q(v, Xe, P) || Re.push(je);
          }
        return Re;
      }
      var ho = If(oa), wc = If(Cf, !0);
      function Cc(c, v) {
        var S = !0;
        return ho(c, function(P, j, q) {
          return S = !!v(P, j, q), S;
        }), S;
      }
      function Eu(c, v, S) {
        for (var P = -1, j = c.length; ++P < j; ) {
          var q = c[P], ue = v(q);
          if (ue != null && (ge === n ? ue === ue && !Ja(ue) : S(ue, ge)))
            var ge = ue, Re = q;
        }
        return Re;
      }
      function Rl(c, v, S, P) {
        var j = c.length;
        for (S = pn(S), S < 0 && (S = -S > j ? 0 : j + S), P = P === n || P > j ? j : pn(P), P < 0 && (P += j), P = S > P ? 0 : w1(P); S < P; )
          c[S++] = v;
        return c;
      }
      function wf(c, v) {
        var S = [];
        return ho(c, function(P, j, q) {
          v(P, j, q) && S.push(P);
        }), S;
      }
      function jr(c, v, S, P, j) {
        var q = -1, ue = c.length;
        for (S || (S = Wo), j || (j = []); ++q < ue; ) {
          var ge = c[q];
          v > 0 && S(ge) ? v > 1 ? jr(ge, v - 1, S, P, j) : ps(j, ge) : P || (j[j.length] = ge);
        }
        return j;
      }
      var Rs = Ll(), Tl = Ll(!0);
      function oa(c, v) {
        return c && Rs(c, v, Ni);
      }
      function Cf(c, v) {
        return c && Tl(c, v, Ni);
      }
      function xu(c, v) {
        return Wa(v, function(S) {
          return Bu(c[S]);
        });
      }
      function Ts(c, v) {
        v = ti(v, c);
        for (var S = 0, P = v.length; c != null && S < P; )
          c = c[Ka(v[S++])];
        return S && S == P ? c : n;
      }
      function Su(c, v, S) {
        var P = v(c);
        return cn(c) ? P : ps(P, S(c));
      }
      function pr(c) {
        return c == null ? c === n ? ft : Tt : ko && ko in Zn(c) ? mo(c) : ka(c);
      }
      function Ol(c, v) {
        return c > v;
      }
      function Rf(c, v) {
        return c != null && Tn.call(c, v);
      }
      function Dl(c, v) {
        return c != null && v in Zn(c);
      }
      function Tf(c, v, S) {
        return c >= br(v, S) && c < Ur(v, S);
      }
      function wu(c, v, S) {
        for (var P = S ? hc : Do, j = c[0].length, q = c.length, ue = q, ge = Be(q), Re = 1 / 0, Ve = []; ue--; ) {
          var je = c[ue];
          ue && v && (je = Gn(je, Gi(v))), Re = br(je.length, Re), ge[ue] = !S && (v || j >= 120 && je.length >= 120) ? new gu(ue && je) : n;
        }
        je = c[0];
        var Xe = -1, ut = ge[0];
        e:
          for (; ++Xe < j && Ve.length < Re; ) {
            var Ot = je[Xe], Vt = v ? v(Ot) : Ot;
            if (Ot = S || Ot !== 0 ? Ot : 0, !(ut ? gc(ut, Vt) : P(Ve, Vt, S))) {
              for (ue = q; --ue; ) {
                var Xt = ge[ue];
                if (!(Xt ? gc(Xt, Vt) : P(c[ue], Vt, S)))
                  continue e;
              }
              ut && ut.push(Vt), Ve.push(Ot);
            }
          }
        return Ve;
      }
      function Ag(c, v, S, P) {
        return oa(c, function(j, q, ue) {
          v(P, S(j), q, ue);
        }), P;
      }
      function Ml(c, v, S) {
        v = ti(v, c), c = Bs(c, v);
        var P = c == null ? c : c[Ka(li(v))];
        return P == null ? n : ii(P, c, S);
      }
      function _r(c) {
        return Ar(c) && pr(c) == ve;
      }
      function Of(c) {
        return Ar(c) && pr(c) == gn;
      }
      function zo(c) {
        return Ar(c) && pr(c) == Fe;
      }
      function Pa(c, v, S, P, j) {
        return c === v ? !0 : c == null || v == null || !Ar(c) && !Ar(v) ? c !== c && v !== v : Fo(c, v, S, P, Pa, j);
      }
      function Fo(c, v, S, P, j, q) {
        var ue = cn(c), ge = cn(v), Re = ue ? ee : ui(c), Ve = ge ? ee : ui(v);
        Re = Re == ve ? Qe : Re, Ve = Ve == ve ? Qe : Ve;
        var je = Re == Qe, Xe = Ve == Qe, ut = Re == Ve;
        if (ut && Bc(c)) {
          if (!Bc(v))
            return !1;
          ue = !0, je = !1;
        }
        if (ut && !je)
          return q || (q = new Ma()), ue || xp(c) ? qv(c, v, S, P, j, q) : Vy(c, v, Re, S, P, j, q);
        if (!(S & T)) {
          var Ot = je && Tn.call(c, "__wrapped__"), Vt = Xe && Tn.call(v, "__wrapped__");
          if (Ot || Vt) {
            var Xt = Ot ? c.value() : c, Lt = Vt ? v.value() : v;
            return q || (q = new Ma()), j(Xt, Lt, S, P, q);
          }
        }
        return ut ? (q || (q = new Ma()), $f(c, v, S, P, j, q)) : !1;
      }
      function kv(c) {
        return Ar(c) && ui(c) == Le;
      }
      function qd(c, v, S, P) {
        var j = S.length, q = j, ue = !P;
        if (c == null)
          return !q;
        for (c = Zn(c); j--; ) {
          var ge = S[j];
          if (ue && ge[2] ? ge[1] !== c[ge[0]] : !(ge[0] in c))
            return !1;
        }
        for (; ++j < q; ) {
          ge = S[j];
          var Re = ge[0], Ve = c[Re], je = ge[1];
          if (ue && ge[2]) {
            if (Ve === n && !(Re in c))
              return !1;
          } else {
            var Xe = new Ma();
            if (P)
              var ut = P(Ve, je, Re, c, v, Xe);
            if (!(ut === n ? Pa(je, Ve, T | O, P, Xe) : ut))
              return !1;
          }
        }
        return !0;
      }
      function Os(c) {
        if (!Fr(c) || Ls(c))
          return !1;
        var v = Bu(c) ? yc : Vi;
        return v.test(Ia(c));
      }
      function Df(c) {
        return Ar(c) && pr(c) == wt;
      }
      function Mf(c) {
        return Ar(c) && ui(c) == tn;
      }
      function Rc(c) {
        return Ar(c) && Ep(c.length) && !!Dn[pr(c)];
      }
      function Cu(c) {
        return typeof c == "function" ? c : c == null ? pa : typeof c == "object" ? cn(c) ? Jr(c[0], c[1]) : dr(c) : Uc(c);
      }
      function $o(c) {
        if (!Mu(c))
          return du(c);
        var v = [];
        for (var S in Zn(c))
          Tn.call(c, S) && S != "constructor" && v.push(S);
        return v;
      }
      function Tc(c) {
        if (!Fr(c))
          return sp(c);
        var v = Mu(c), S = [];
        for (var P in c)
          P == "constructor" && (v || !Tn.call(c, P)) || S.push(P);
        return S;
      }
      function Wr(c, v) {
        return c < v;
      }
      function Al(c, v) {
        var S = -1, P = Pi(c) ? Be(c.length) : [];
        return ho(c, function(j, q, ue) {
          P[++S] = v(j, q, ue);
        }), P;
      }
      function dr(c) {
        var v = Gr(c);
        return v.length == 1 && v[0][2] ? Go(v[0][0], v[0][1]) : function(S) {
          return S === c || qd(S, c, v);
        };
      }
      function Jr(c, v) {
        return Bl(c) && Hf(v) ? Go(Ka(c), v) : function(S) {
          var P = r0(S, c);
          return P === n && P === v ? i0(S, c) : Pa(v, P, T | O);
        };
      }
      function Br(c, v, S, P, j) {
        c !== v && Rs(v, function(q, ue) {
          if (j || (j = new Ma()), Fr(q))
            Af(c, v, ue, S, Br, P, j);
          else {
            var ge = P ? P(ca(c, ue), q, ue + "", c, v, j) : n;
            ge === n && (ge = q), Sc(c, ue, ge);
          }
        }, eo);
      }
      function Af(c, v, S, P, j, q, ue) {
        var ge = ca(c, S), Re = ca(v, S), Ve = ue.get(Re);
        if (Ve) {
          Sc(c, S, Ve);
          return;
        }
        var je = q ? q(ge, Re, S + "", c, v, ue) : n, Xe = je === n;
        if (Xe) {
          var ut = cn(Re), Ot = !ut && Bc(Re), Vt = !ut && !Ot && xp(Re);
          je = Re, ut || Ot || Vt ? cn(ge) ? je = ge : ni(ge) ? je = Bn(ge) : Ot ? (Xe = !1, je = zv(Re, !0)) : Vt ? (Xe = !1, je = Jd(Re, !0)) : je = [] : vh(Re) || Lc(Re) ? (je = ge, Lc(ge) ? je = C1(ge) : (!Fr(ge) || Bu(ge)) && (je = gt(Re))) : Xe = !1;
        }
        Xe && (ue.set(Re, je), j(je, Re, P, q, ue), ue.delete(Re)), Sc(c, S, je);
      }
      function Ds(c, v) {
        var S = c.length;
        if (!!S)
          return v += v < 0 ? S : 0, Ai(v, S) ? c[v] : n;
      }
      function Mi(c, v, S) {
        v.length ? v = Gn(v, function(q) {
          return cn(q) ? function(ue) {
            return Ts(ue, q.length === 1 ? q[0] : q);
          } : q;
        }) : v = [pa];
        var P = -1;
        v = Gn(v, Gi(Dt()));
        var j = Al(c, function(q, ue, ge) {
          var Re = Gn(v, function(Ve) {
            return Ve(q);
          });
          return { criteria: Re, index: ++P, value: q };
        });
        return By(j, function(q, ue) {
          return si(q, ue, S);
        });
      }
      function Ms(c, v) {
        return Xd(c, v, function(S, P) {
          return i0(c, P);
        });
      }
      function Xd(c, v, S) {
        for (var P = -1, j = v.length, q = {}; ++P < j; ) {
          var ue = v[P], ge = Ts(c, ue);
          S(ge, ue) && Uo(q, ti(ue, c), ge);
        }
        return q;
      }
      function Ge(c) {
        return function(v) {
          return Ts(v, c);
        };
      }
      function Or(c, v, S, P) {
        var j = P ? Ly : cl, q = -1, ue = v.length, ge = c;
        for (c === v && (v = Bn(v)), S && (ge = Gn(c, Gi(S))); ++q < ue; )
          for (var Re = 0, Ve = v[q], je = S ? S(Ve) : Ve; (Re = j(ge, je, Re, P)) > -1; )
            ge !== c && yl.call(ge, Re, 1), yl.call(c, Re, 1);
        return c;
      }
      function bn(c, v) {
        for (var S = c ? v.length : 0, P = S - 1; S--; ) {
          var j = v[S];
          if (S == P || j !== q) {
            var q = j;
            Ai(j) ? yl.call(c, j, 1) : Un(c, j);
          }
        }
        return c;
      }
      function go(c, v) {
        return c + _s(fo() * (v - c + 1));
      }
      function Pl(c, v, S, P) {
        for (var j = -1, q = Ur(bc((v - c) / (S || 1)), 0), ue = Be(q); q--; )
          ue[P ? q : ++j] = c, c += S;
        return ue;
      }
      function Nl(c, v) {
        var S = "";
        if (!c || v < 1 || v > Se)
          return S;
        do
          v % 2 && (S += c), v = _s(v / 2), v && (c += c);
        while (v);
        return S;
      }
      function ln(c, v) {
        return qf(bo(c, v, pa), c + "");
      }
      function Iv(c) {
        return ws(Fs(c));
      }
      function Oc(c, v) {
        var S = Fs(c);
        return Xf(S, _u(v, 0, S.length));
      }
      function Uo(c, v, S, P) {
        if (!Fr(c))
          return c;
        v = ti(v, c);
        for (var j = -1, q = v.length, ue = q - 1, ge = c; ge != null && ++j < q; ) {
          var Re = Ka(v[j]), Ve = S;
          if (Re === "__proto__" || Re === "constructor" || Re === "prototype")
            return c;
          if (j != ue) {
            var je = ge[Re];
            Ve = P ? P(je, Re, ge) : n, Ve === n && (Ve = Fr(je) ? je : Ai(v[j + 1]) ? [] : {});
          }
          Sl(ge, Re, Ve), ge = ge[Re];
        }
        return c;
      }
      var Kd = bf ? function(c, v) {
        return bf.set(c, v), c;
      } : pa, As = bs ? function(c, v) {
        return bs(c, "toString", {
          configurable: !0,
          enumerable: !1,
          value: f0(v),
          writable: !0
        });
      } : pa;
      function Dc(c) {
        return Xf(Fs(c));
      }
      function ei(c, v, S) {
        var P = -1, j = c.length;
        v < 0 && (v = -v > j ? 0 : j + v), S = S > j ? j : S, S < 0 && (S += j), j = v > S ? 0 : S - v >>> 0, v >>>= 0;
        for (var q = Be(j); ++P < j; )
          q[P] = c[P + v];
        return q;
      }
      function Qd(c, v) {
        var S;
        return ho(c, function(P, j, q) {
          return S = v(P, j, q), !S;
        }), !!S;
      }
      function Ru(c, v, S) {
        var P = 0, j = c == null ? P : c.length;
        if (typeof v == "number" && v === v && j <= le) {
          for (; P < j; ) {
            var q = P + j >>> 1, ue = c[q];
            ue !== null && !Ja(ue) && (S ? ue <= v : ue < v) ? P = q + 1 : j = q;
          }
          return j;
        }
        return Pf(c, v, pa, S);
      }
      function Pf(c, v, S, P) {
        var j = 0, q = c == null ? 0 : c.length;
        if (q === 0)
          return 0;
        v = S(v);
        for (var ue = v !== v, ge = v === null, Re = Ja(v), Ve = v === n; j < q; ) {
          var je = _s((j + q) / 2), Xe = S(c[je]), ut = Xe !== n, Ot = Xe === null, Vt = Xe === Xe, Xt = Ja(Xe);
          if (ue)
            var Lt = P || Vt;
          else
            Ve ? Lt = Vt && (P || ut) : ge ? Lt = Vt && ut && (P || !Ot) : Re ? Lt = Vt && ut && !Ot && (P || !Xt) : Ot || Xt ? Lt = !1 : Lt = P ? Xe <= v : Xe < v;
          Lt ? j = je + 1 : q = je;
        }
        return br(q, ce);
      }
      function Nf(c, v) {
        for (var S = -1, P = c.length, j = 0, q = []; ++S < P; ) {
          var ue = c[S], ge = v ? v(ue) : ue;
          if (!S || !qo(ge, Re)) {
            var Re = ge;
            q[j++] = ue === 0 ? 0 : ue;
          }
        }
        return q;
      }
      function Xa(c) {
        return typeof c == "number" ? c : Ja(c) ? re : +c;
      }
      function Cn(c) {
        if (typeof c == "string")
          return c;
        if (cn(c))
          return Gn(c, Cn) + "";
        if (Ja(c))
          return xs ? xs.call(c) : "";
        var v = c + "";
        return v == "0" && 1 / c == -_e ? "-0" : v;
      }
      function Tu(c, v, S) {
        var P = -1, j = Do, q = c.length, ue = !0, ge = [], Re = ge;
        if (S)
          ue = !1, j = hc;
        else if (q >= a) {
          var Ve = v ? null : Bg(c);
          if (Ve)
            return Fd(Ve);
          ue = !1, j = gc, Re = new gu();
        } else
          Re = v ? [] : ge;
        e:
          for (; ++P < q; ) {
            var je = c[P], Xe = v ? v(je) : je;
            if (je = S || je !== 0 ? je : 0, ue && Xe === Xe) {
              for (var ut = Re.length; ut--; )
                if (Re[ut] === Xe)
                  continue e;
              v && Re.push(Xe), ge.push(je);
            } else
              j(Re, Xe, S) || (Re !== ge && Re.push(Xe), ge.push(je));
          }
        return ge;
      }
      function Un(c, v) {
        return v = ti(v, c), c = Bs(c, v), c == null || delete c[Ka(li(v))];
      }
      function kl(c, v, S, P) {
        return Uo(c, v, S(Ts(c, v)), P);
      }
      function Mc(c, v, S, P) {
        for (var j = c.length, q = P ? j : -1; (P ? q-- : ++q < j) && v(c[q], q, c); )
          ;
        return S ? ei(c, P ? 0 : q, P ? q + 1 : j) : ei(c, P ? q + 1 : 0, P ? j : q);
      }
      function kf(c, v) {
        var S = c;
        return S instanceof un && (S = S.value()), aa(v, function(P, j) {
          return j.func.apply(j.thisArg, ps([P], j.args));
        }, S);
      }
      function Il(c, v, S) {
        var P = c.length;
        if (P < 2)
          return P ? Tu(c[0]) : [];
        for (var j = -1, q = Be(P); ++j < P; )
          for (var ue = c[j], ge = -1; ++ge < P; )
            ge != j && (q[j] = Cl(q[j] || ue, c[ge], v, S));
        return Tu(jr(q, 1), v, S);
      }
      function Pg(c, v, S) {
        for (var P = -1, j = c.length, q = v.length, ue = {}; ++P < j; ) {
          var ge = P < q ? v[P] : n;
          S(ue, c[P], ge);
        }
        return ue;
      }
      function Lv(c) {
        return ni(c) ? c : [];
      }
      function Bv(c) {
        return typeof c == "function" ? c : pa;
      }
      function ti(c, v) {
        return cn(c) ? c : Bl(c, v) ? [c] : Kf(Yn(c));
      }
      var sa = ln;
      function Vo(c, v, S) {
        var P = c.length;
        return S = S === n ? P : S, !v && S >= P ? c : ei(c, v, S);
      }
      var Zd = Rg || function(c) {
        return yi.clearTimeout(c);
      };
      function zv(c, v) {
        if (v)
          return c.slice();
        var S = c.length, P = Jn ? Jn(S) : new c.constructor(S);
        return c.copy(P), P;
      }
      function Ou(c) {
        var v = new c.constructor(c.byteLength);
        return new gl(v).set(new gl(c)), v;
      }
      function Ng(c, v) {
        var S = v ? Ou(c.buffer) : c.buffer;
        return new c.constructor(S, c.byteOffset, c.byteLength);
      }
      function Fv(c) {
        var v = new c.constructor(c.source, Ea.exec(c));
        return v.lastIndex = c.lastIndex, v;
      }
      function kg(c) {
        return Lr ? Zn(Lr.call(c)) : {};
      }
      function Jd(c, v) {
        var S = v ? Ou(c.buffer) : c.buffer;
        return new c.constructor(S, c.byteOffset, c.length);
      }
      function $v(c, v) {
        if (c !== v) {
          var S = c !== n, P = c === null, j = c === c, q = Ja(c), ue = v !== n, ge = v === null, Re = v === v, Ve = Ja(v);
          if (!ge && !Ve && !q && c > v || q && ue && Re && !ge && !Ve || P && ue && Re || !S && Re || !j)
            return 1;
          if (!P && !q && !Ve && c < v || Ve && S && j && !P && !q || ge && S && j || !ue && j || !Re)
            return -1;
        }
        return 0;
      }
      function si(c, v, S) {
        for (var P = -1, j = c.criteria, q = v.criteria, ue = j.length, ge = S.length; ++P < ue; ) {
          var Re = $v(j[P], q[P]);
          if (Re) {
            if (P >= ge)
              return Re;
            var Ve = S[P];
            return Re * (Ve == "desc" ? -1 : 1);
          }
        }
        return c.index - v.index;
      }
      function Ps(c, v, S, P) {
        for (var j = -1, q = c.length, ue = S.length, ge = -1, Re = v.length, Ve = Ur(q - ue, 0), je = Be(Re + Ve), Xe = !P; ++ge < Re; )
          je[ge] = v[ge];
        for (; ++j < ue; )
          (Xe || j < q) && (je[S[j]] = c[j]);
        for (; Ve--; )
          je[ge++] = c[j++];
        return je;
      }
      function Uv(c, v, S, P) {
        for (var j = -1, q = c.length, ue = -1, ge = S.length, Re = -1, Ve = v.length, je = Ur(q - ge, 0), Xe = Be(je + Ve), ut = !P; ++j < je; )
          Xe[j] = c[j];
        for (var Ot = j; ++Re < Ve; )
          Xe[Ot + Re] = v[Re];
        for (; ++ue < ge; )
          (ut || j < q) && (Xe[Ot + S[ue]] = c[j++]);
        return Xe;
      }
      function Bn(c, v) {
        var S = -1, P = c.length;
        for (v || (v = Be(P)); ++S < P; )
          v[S] = c[S];
        return v;
      }
      function wi(c, v, S, P) {
        var j = !S;
        S || (S = {});
        for (var q = -1, ue = v.length; ++q < ue; ) {
          var ge = v[q], Re = P ? P(S[ge], c[ge], ge, S, c) : n;
          Re === n && (Re = c[ge]), j ? Vr(S, ge, Re) : Sl(S, ge, Re);
        }
        return S;
      }
      function Pn(c, v) {
        return wi(c, Is(c), v);
      }
      function Ac(c, v) {
        return wi(c, yo(c), v);
      }
      function ep(c, v) {
        return function(S, P) {
          var j = cn(S) ? vc : Pv, q = v ? v() : {};
          return j(S, c, Dt(P, 2), q);
        };
      }
      function ua(c) {
        return ln(function(v, S) {
          var P = -1, j = S.length, q = j > 1 ? S[j - 1] : n, ue = j > 2 ? S[2] : n;
          for (q = c.length > 3 && typeof q == "function" ? (j--, q) : n, ue && zr(S[0], S[1], ue) && (q = j < 3 ? n : q, j = 1), v = Zn(v); ++P < j; ) {
            var ge = S[P];
            ge && c(v, ge, P, q);
          }
          return v;
        });
      }
      function If(c, v) {
        return function(S, P) {
          if (S == null)
            return S;
          if (!Pi(S))
            return c(S, P);
          for (var j = S.length, q = v ? j : -1, ue = Zn(S); (v ? q-- : ++q < j) && P(ue[q], q, ue) !== !1; )
            ;
          return S;
        };
      }
      function Ll(c) {
        return function(v, S, P) {
          for (var j = -1, q = Zn(v), ue = P(v), ge = ue.length; ge--; ) {
            var Re = ue[c ? ge : ++j];
            if (S(q[Re], Re, q) === !1)
              break;
          }
          return v;
        };
      }
      function Ig(c, v, S) {
        var P = v & D, j = Lf(c);
        function q() {
          var ue = this && this !== yi && this instanceof q ? j : c;
          return ue.apply(P ? S : this, arguments);
        }
        return q;
      }
      function tp(c) {
        return function(v) {
          v = Yn(v);
          var S = dl(v) ? Ga(v) : n, P = S ? S[0] : v.charAt(0), j = S ? Vo(S, 1).join("") : v.slice(1);
          return P[c]() + j;
        };
      }
      function jo(c) {
        return function(v) {
          return aa(yh(Ko(v).replace(ug, "")), c, "");
        };
      }
      function Lf(c) {
        return function() {
          var v = arguments;
          switch (v.length) {
            case 0:
              return new c();
            case 1:
              return new c(v[0]);
            case 2:
              return new c(v[0], v[1]);
            case 3:
              return new c(v[0], v[1], v[2]);
            case 4:
              return new c(v[0], v[1], v[2], v[3]);
            case 5:
              return new c(v[0], v[1], v[2], v[3], v[4]);
            case 6:
              return new c(v[0], v[1], v[2], v[3], v[4], v[5]);
            case 7:
              return new c(v[0], v[1], v[2], v[3], v[4], v[5], v[6]);
          }
          var S = Rr(c.prototype), P = c.apply(S, v);
          return Fr(P) ? P : S;
        };
      }
      function Lg(c, v, S) {
        var P = Lf(c);
        function j() {
          for (var q = arguments.length, ue = Be(q), ge = q, Re = Dr(j); ge--; )
            ue[ge] = arguments[ge];
          var Ve = q < 3 && ue[0] !== Re && ue[q - 1] !== Re ? [] : fu(ue, Re);
          if (q -= Ve.length, q < S)
            return Wv(
              c,
              v,
              Bf,
              j.placeholder,
              n,
              ue,
              Ve,
              n,
              n,
              S - q
            );
          var je = this && this !== yi && this instanceof j ? P : c;
          return ii(je, this, ue);
        }
        return j;
      }
      function np(c) {
        return function(v, S, P) {
          var j = Zn(v);
          if (!Pi(v)) {
            var q = Dt(S, 3);
            v = Ni(v), S = function(ge) {
              return q(j[ge], ge, j);
            };
          }
          var ue = c(v, S, P);
          return ue > -1 ? j[q ? v[ue] : ue] : n;
        };
      }
      function rp(c) {
        return la(function(v) {
          var S = v.length, P = S, j = xi.prototype.thru;
          for (c && v.reverse(); P--; ) {
            var q = v[P];
            if (typeof q != "function")
              throw new Ra(l);
            if (j && !ue && Er(q) == "wrapper")
              var ue = new xi([], !0);
          }
          for (P = ue ? P : S; ++P < S; ) {
            q = v[P];
            var ge = Er(q), Re = ge == "wrapper" ? Ci(q) : n;
            Re && Wf(Re[0]) && Re[1] == (U | I | k | K) && !Re[4].length && Re[9] == 1 ? ue = ue[Er(Re[0])].apply(ue, Re[3]) : ue = q.length == 1 && Wf(q) ? ue[ge]() : ue.thru(q);
          }
          return function() {
            var Ve = arguments, je = Ve[0];
            if (ue && Ve.length == 1 && cn(je))
              return ue.plant(je).value();
            for (var Xe = 0, ut = S ? v[Xe].apply(this, Ve) : je; ++Xe < S; )
              ut = v[Xe].call(this, ut);
            return ut;
          };
        });
      }
      function Bf(c, v, S, P, j, q, ue, ge, Re, Ve) {
        var je = v & U, Xe = v & D, ut = v & A, Ot = v & (I | L), Vt = v & X, Xt = ut ? n : Lf(c);
        function Lt() {
          for (var wn = arguments.length, Rn = Be(wn), ha = wn; ha--; )
            Rn[ha] = arguments[ha];
          if (Ot)
            var ci = Dr(Lt), ga = _v(Rn, ci);
          if (P && (Rn = Ps(Rn, P, j, Ot)), q && (Rn = Uv(Rn, q, ue, Ot)), wn -= ga, Ot && wn < Ve) {
            var Nr = fu(Rn, ci);
            return Wv(
              c,
              v,
              Bf,
              Lt.placeholder,
              S,
              Rn,
              Nr,
              ge,
              Re,
              Ve - wn
            );
          }
          var no = Xe ? S : this, Uu = ut ? no[c] : c;
          return wn = Rn.length, ge ? Rn = up(Rn, ge) : Vt && wn > 1 && Rn.reverse(), je && Re < wn && (Rn.length = Re), this && this !== yi && this instanceof Lt && (Uu = Xt || Lf(Uu)), Uu.apply(no, Rn);
        }
        return Lt;
      }
      function Vv(c, v) {
        return function(S, P) {
          return Ag(S, c, v(P), {});
        };
      }
      function zf(c, v) {
        return function(S, P) {
          var j;
          if (S === n && P === n)
            return v;
          if (S !== n && (j = S), P !== n) {
            if (j === n)
              return P;
            typeof S == "string" || typeof P == "string" ? (S = Cn(S), P = Cn(P)) : (S = Xa(S), P = Xa(P)), j = c(S, P);
          }
          return j;
        };
      }
      function jv(c) {
        return la(function(v) {
          return v = Gn(v, Gi(Dt())), ln(function(S) {
            var P = this;
            return c(v, function(j) {
              return ii(j, P, S);
            });
          });
        });
      }
      function Ff(c, v) {
        v = v === n ? " " : Cn(v);
        var S = v.length;
        if (S < 2)
          return S ? Nl(v, c) : v;
        var P = Nl(v, bc(c / Ca(v)));
        return dl(v) ? Vo(Ga(P), 0, c).join("") : P.slice(0, c);
      }
      function Uy(c, v, S, P) {
        var j = v & D, q = Lf(c);
        function ue() {
          for (var ge = -1, Re = arguments.length, Ve = -1, je = P.length, Xe = Be(je + Re), ut = this && this !== yi && this instanceof ue ? q : c; ++Ve < je; )
            Xe[Ve] = P[Ve];
          for (; Re--; )
            Xe[Ve++] = arguments[++ge];
          return ii(ut, j ? S : this, Xe);
        }
        return ue;
      }
      function ip(c) {
        return function(v, S, P) {
          return P && typeof P != "number" && zr(v, S, P) && (S = P = n), v = Fl(v), S === n ? (S = v, v = 0) : S = Fl(S), P = P === n ? v < S ? 1 : -1 : Fl(P), Pl(v, S, P, c);
        };
      }
      function Pc(c) {
        return function(v, S) {
          return typeof v == "string" && typeof S == "string" || (v = Xo(v), S = Xo(S)), c(v, S);
        };
      }
      function Wv(c, v, S, P, j, q, ue, ge, Re, Ve) {
        var je = v & I, Xe = je ? ue : n, ut = je ? n : ue, Ot = je ? q : n, Vt = je ? n : q;
        v |= je ? k : $, v &= ~(je ? $ : k), v & B || (v &= ~(D | A));
        var Xt = [
          c,
          v,
          j,
          Ot,
          Xe,
          Vt,
          ut,
          ge,
          Re,
          Ve
        ], Lt = S.apply(n, Xt);
        return Wf(c) && lp(Lt, Xt), Lt.placeholder = P, zg(Lt, c, v);
      }
      function ap(c) {
        var v = Ln[c];
        return function(S, P) {
          if (S = Xo(S), P = P == null ? 0 : br(pn(P), 292), P && Tv(S)) {
            var j = (Yn(S) + "e").split("e"), q = v(j[0] + "e" + (+j[1] + P));
            return j = (Yn(q) + "e").split("e"), +(j[0] + "e" + (+j[1] - P));
          }
          return v(S);
        };
      }
      var Bg = ai && 1 / Fd(new ai([, -0]))[1] == _e ? function(c) {
        return new ai(c);
      } : pm;
      function Gv(c) {
        return function(v) {
          var S = ui(v);
          return S == Le ? hs(v) : S == tn ? xg(v) : hg(v, c(v));
        };
      }
      function Na(c, v, S, P, j, q, ue, ge) {
        var Re = v & A;
        if (!Re && typeof c != "function")
          throw new Ra(l);
        var Ve = P ? P.length : 0;
        if (Ve || (v &= ~(k | $), P = j = n), ue = ue === n ? ue : Ur(pn(ue), 0), ge = ge === n ? ge : pn(ge), Ve -= j ? j.length : 0, v & $) {
          var je = P, Xe = j;
          P = j = n;
        }
        var ut = Re ? n : Ci(c), Ot = [
          c,
          v,
          S,
          P,
          j,
          je,
          Xe,
          q,
          ue,
          ge
        ];
        if (ut && Yf(Ot, ut), c = Ot[0], v = Ot[1], S = Ot[2], P = Ot[3], j = Ot[4], ge = Ot[9] = Ot[9] === n ? Re ? 0 : c.length : Ur(Ot[9] - Ve, 0), !ge && v & (I | L) && (v &= ~(I | L)), !v || v == D)
          var Vt = Ig(c, v, S);
        else
          v == I || v == L ? Vt = Lg(c, v, ge) : (v == k || v == (D | k)) && !j.length ? Vt = Uy(c, v, S, P) : Vt = Bf.apply(n, Ot);
        var Xt = ut ? Kd : lp;
        return zg(Xt(Vt, Ot), c, v);
      }
      function Nc(c, v, S, P) {
        return c === n || qo(c, Ha[S]) && !Tn.call(P, S) ? v : c;
      }
      function Hv(c, v, S, P, j, q) {
        return Fr(c) && Fr(v) && (q.set(v, c), Br(c, v, n, Hv, q), q.delete(v)), c;
      }
      function Yv(c) {
        return vh(c) ? n : c;
      }
      function qv(c, v, S, P, j, q) {
        var ue = S & T, ge = c.length, Re = v.length;
        if (ge != Re && !(ue && Re > ge))
          return !1;
        var Ve = q.get(c), je = q.get(v);
        if (Ve && je)
          return Ve == v && je == c;
        var Xe = -1, ut = !0, Ot = S & O ? new gu() : n;
        for (q.set(c, v), q.set(v, c); ++Xe < ge; ) {
          var Vt = c[Xe], Xt = v[Xe];
          if (P)
            var Lt = ue ? P(Xt, Vt, Xe, v, c, q) : P(Vt, Xt, Xe, c, v, q);
          if (Lt !== n) {
            if (Lt)
              continue;
            ut = !1;
            break;
          }
          if (Ot) {
            if (!_i(v, function(wn, Rn) {
              if (!gc(Ot, Rn) && (Vt === wn || j(Vt, wn, S, P, q)))
                return Ot.push(Rn);
            })) {
              ut = !1;
              break;
            }
          } else if (!(Vt === Xt || j(Vt, Xt, S, P, q))) {
            ut = !1;
            break;
          }
        }
        return q.delete(c), q.delete(v), ut;
      }
      function Vy(c, v, S, P, j, q, ue) {
        switch (S) {
          case rr:
            if (c.byteLength != v.byteLength || c.byteOffset != v.byteOffset)
              return !1;
            c = c.buffer, v = v.buffer;
          case gn:
            return !(c.byteLength != v.byteLength || !q(new gl(c), new gl(v)));
          case he:
          case Fe:
          case qe:
            return qo(+c, +v);
          case xe:
            return c.name == v.name && c.message == v.message;
          case wt:
          case Vn:
            return c == v + "";
          case Le:
            var ge = hs;
          case tn:
            var Re = P & T;
            if (ge || (ge = Fd), c.size != v.size && !Re)
              return !1;
            var Ve = ue.get(c);
            if (Ve)
              return Ve == v;
            P |= O, ue.set(c, v);
            var je = qv(ge(c), ge(v), P, j, q, ue);
            return ue.delete(c), je;
          case Kt:
            if (Lr)
              return Lr.call(c) == Lr.call(v);
        }
        return !1;
      }
      function $f(c, v, S, P, j, q) {
        var ue = S & T, ge = Ns(c), Re = ge.length, Ve = Ns(v), je = Ve.length;
        if (Re != je && !ue)
          return !1;
        for (var Xe = Re; Xe--; ) {
          var ut = ge[Xe];
          if (!(ue ? ut in v : Tn.call(v, ut)))
            return !1;
        }
        var Ot = q.get(c), Vt = q.get(v);
        if (Ot && Vt)
          return Ot == v && Vt == c;
        var Xt = !0;
        q.set(c, v), q.set(v, c);
        for (var Lt = ue; ++Xe < Re; ) {
          ut = ge[Xe];
          var wn = c[ut], Rn = v[ut];
          if (P)
            var ha = ue ? P(Rn, wn, ut, v, c, q) : P(wn, Rn, ut, c, v, q);
          if (!(ha === n ? wn === Rn || j(wn, Rn, S, P, q) : ha)) {
            Xt = !1;
            break;
          }
          Lt || (Lt = ut == "constructor");
        }
        if (Xt && !Lt) {
          var ci = c.constructor, ga = v.constructor;
          ci != ga && "constructor" in c && "constructor" in v && !(typeof ci == "function" && ci instanceof ci && typeof ga == "function" && ga instanceof ga) && (Xt = !1);
        }
        return q.delete(c), q.delete(v), Xt;
      }
      function la(c) {
        return qf(bo(c, n, zs), c + "");
      }
      function Ns(c) {
        return Su(c, Ni, Is);
      }
      function Yt(c) {
        return Su(c, eo, yo);
      }
      var Ci = bf ? function(c) {
        return bf.get(c);
      } : pm;
      function Er(c) {
        for (var v = c.name + "", S = pu[v], P = Tn.call(pu, v) ? S.length : 0; P--; ) {
          var j = S[P], q = j.func;
          if (q == null || q == c)
            return j.name;
        }
        return v;
      }
      function Dr(c) {
        var v = Tn.call(G, "placeholder") ? G : c;
        return v.placeholder;
      }
      function Dt() {
        var c = G.iteratee || dm;
        return c = c === dm ? Cu : c, arguments.length ? c(arguments[0], arguments[1]) : c;
      }
      function ks(c, v) {
        var S = c.__data__;
        return Kv(v) ? S[typeof v == "string" ? "string" : "hash"] : S.map;
      }
      function Gr(c) {
        for (var v = Ni(c), S = v.length; S--; ) {
          var P = v[S], j = c[P];
          v[S] = [P, j, Hf(j)];
        }
        return v;
      }
      function Mr(c, v) {
        var S = bg(c, v);
        return Os(S) ? S : n;
      }
      function mo(c) {
        var v = Tn.call(c, ko), S = c[ko];
        try {
          c[ko] = n;
          var P = !0;
        } catch {
        }
        var j = Ao.call(c);
        return P && (v ? c[ko] = S : delete c[ko]), j;
      }
      var Is = bl ? function(c) {
        return c == null ? [] : (c = Zn(c), Wa(bl(c), function(v) {
          return No.call(c, v);
        }));
      } : bh, yo = bl ? function(c) {
        for (var v = []; c; )
          ps(v, Is(c)), c = ml(c);
        return v;
      } : bh, ui = pr;
      (Ei && ui(new Ei(new ArrayBuffer(1))) != rr || Ec && ui(new Ec()) != Le || Es && ui(Es.resolve()) != pt || ai && ui(new ai()) != tn || Qr && ui(new Qr()) != Gt) && (ui = function(c) {
        var v = pr(c), S = v == Qe ? c.constructor : n, P = S ? Ia(S) : "";
        if (P)
          switch (P) {
            case Hn:
              return rr;
            case Hi:
              return Le;
            case nn:
              return pt;
            case Ht:
              return tn;
            case vu:
              return Gt;
          }
        return v;
      });
      function Uf(c, v, S) {
        for (var P = -1, j = S.length; ++P < j; ) {
          var q = S[P], ue = q.size;
          switch (q.type) {
            case "drop":
              c += ue;
              break;
            case "dropRight":
              v -= ue;
              break;
            case "take":
              v = br(v, c + ue);
              break;
            case "takeRight":
              c = Ur(c, v - ue);
              break;
          }
        }
        return { start: c, end: v };
      }
      function Vf(c) {
        var v = c.match(zt);
        return v ? v[1].split(yn) : [];
      }
      function Du(c, v, S) {
        v = ti(v, c);
        for (var P = -1, j = v.length, q = !1; ++P < j; ) {
          var ue = Ka(v[P]);
          if (!(q = c != null && S(c, ue)))
            break;
          c = c[ue];
        }
        return q || ++P != j ? q : (j = c == null ? 0 : c.length, !!j && Ep(j) && Ai(ue, j) && (cn(c) || Lc(c)));
      }
      function kc(c) {
        var v = c.length, S = new c.constructor(v);
        return v && typeof c[0] == "string" && Tn.call(c, "index") && (S.index = c.index, S.input = c.input), S;
      }
      function gt(c) {
        return typeof c.constructor == "function" && !Mu(c) ? Rr(ml(c)) : {};
      }
      function jf(c, v, S) {
        var P = c.constructor;
        switch (v) {
          case gn:
            return Ou(c);
          case he:
          case Fe:
            return new P(+c);
          case rr:
            return Ng(c, S);
          case Zi:
          case At:
          case at:
          case bt:
          case Pt:
          case dn:
          case Nn:
          case kn:
          case In:
            return Jd(c, S);
          case Le:
            return new P();
          case qe:
          case Vn:
            return new P(c);
          case wt:
            return Fv(c);
          case tn:
            return new P();
          case Kt:
            return kg(c);
        }
      }
      function Xv(c, v) {
        var S = v.length;
        if (!S)
          return c;
        var P = S - 1;
        return v[P] = (S > 1 ? "& " : "") + v[P], v = v.join(S > 2 ? ", " : " "), c.replace(mn, `{
/* [wrapped with ` + v + `] */
`);
      }
      function Wo(c) {
        return cn(c) || Lc(c) || !!(yf && c && c[yf]);
      }
      function Ai(c, v) {
        var S = typeof c;
        return v = v == null ? Se : v, !!v && (S == "number" || S != "symbol" && ig.test(c)) && c > -1 && c % 1 == 0 && c < v;
      }
      function zr(c, v, S) {
        if (!Fr(S))
          return !1;
        var P = typeof v;
        return (P == "number" ? Pi(S) && Ai(v, S.length) : P == "string" && v in S) ? qo(S[v], c) : !1;
      }
      function Bl(c, v) {
        if (cn(c))
          return !1;
        var S = typeof c;
        return S == "number" || S == "symbol" || S == "boolean" || c == null || Ja(c) ? !0 : Va.test(c) || !us.test(c) || v != null && c in Zn(v);
      }
      function Kv(c) {
        var v = typeof c;
        return v == "string" || v == "number" || v == "symbol" || v == "boolean" ? c !== "__proto__" : c === null;
      }
      function Wf(c) {
        var v = Er(c), S = G[v];
        if (typeof S != "function" || !(v in un.prototype))
          return !1;
        if (c === S)
          return !0;
        var P = Ci(S);
        return !!P && c === P[0];
      }
      function Ls(c) {
        return !!ms && ms in c;
      }
      var Gf = gf ? Bu : p0;
      function Mu(c) {
        var v = c && c.constructor, S = typeof v == "function" && v.prototype || Ha;
        return c === S;
      }
      function Hf(c) {
        return c === c && !Fr(c);
      }
      function Go(c, v) {
        return function(S) {
          return S == null ? !1 : S[c] === v && (v !== n || c in Zn(S));
        };
      }
      function op(c) {
        var v = Ic(c, function(P) {
          return S.size === y && S.clear(), P;
        }), S = v.cache;
        return v;
      }
      function Yf(c, v) {
        var S = c[1], P = v[1], j = S | P, q = j < (D | A | U), ue = P == U && S == I || P == U && S == K && c[7].length <= v[8] || P == (U | K) && v[7].length <= v[8] && S == I;
        if (!(q || ue))
          return c;
        P & D && (c[2] = v[2], j |= S & D ? 0 : B);
        var ge = v[3];
        if (ge) {
          var Re = c[3];
          c[3] = Re ? Ps(Re, ge, v[4]) : ge, c[4] = Re ? fu(c[3], b) : v[4];
        }
        return ge = v[5], ge && (Re = c[5], c[5] = Re ? Uv(Re, ge, v[6]) : ge, c[6] = Re ? fu(c[5], b) : v[6]), ge = v[7], ge && (c[7] = ge), P & U && (c[8] = c[8] == null ? v[8] : br(c[8], v[8])), c[9] == null && (c[9] = v[9]), c[0] = v[0], c[1] = j, c;
      }
      function sp(c) {
        var v = [];
        if (c != null)
          for (var S in Zn(c))
            v.push(S);
        return v;
      }
      function ka(c) {
        return Ao.call(c);
      }
      function bo(c, v, S) {
        return v = Ur(v === n ? c.length - 1 : v, 0), function() {
          for (var P = arguments, j = -1, q = Ur(P.length - v, 0), ue = Be(q); ++j < q; )
            ue[j] = P[v + j];
          j = -1;
          for (var ge = Be(v + 1); ++j < v; )
            ge[j] = P[j];
          return ge[v] = S(ue), ii(c, this, ge);
        };
      }
      function Bs(c, v) {
        return v.length < 2 ? c : Ts(c, ei(v, 0, -1));
      }
      function up(c, v) {
        for (var S = c.length, P = br(v.length, S), j = Bn(c); P--; ) {
          var q = v[P];
          c[P] = Ai(q, S) ? j[q] : n;
        }
        return c;
      }
      function ca(c, v) {
        if (!(v === "constructor" && typeof c[v] == "function") && v != "__proto__")
          return c[v];
      }
      var lp = Qv(Kd), Ho = Rv || function(c, v) {
        return yi.setTimeout(c, v);
      }, qf = Qv(As);
      function zg(c, v, S) {
        var P = v + "";
        return qf(c, Xv(P, cp(Vf(P), S)));
      }
      function Qv(c) {
        var v = 0, S = 0;
        return function() {
          var P = Wd(), j = Z - (P - S);
          if (S = P, j > 0) {
            if (++v >= Q)
              return arguments[0];
          } else
            v = 0;
          return c.apply(n, arguments);
        };
      }
      function Xf(c, v) {
        var S = -1, P = c.length, j = P - 1;
        for (v = v === n ? P : v; ++S < v; ) {
          var q = go(S, j), ue = c[q];
          c[q] = c[S], c[S] = ue;
        }
        return c.length = v, c;
      }
      var Kf = op(function(c) {
        var v = [];
        return c.charCodeAt(0) === 46 && v.push(""), c.replace(il, function(S, P, j, q) {
          v.push(j ? q.replace(Fn, "$1") : P || S);
        }), v;
      });
      function Ka(c) {
        if (typeof c == "string" || Ja(c))
          return c;
        var v = c + "";
        return v == "0" && 1 / c == -_e ? "-0" : v;
      }
      function Ia(c) {
        if (c != null) {
          try {
            return gs.call(c);
          } catch {
          }
          try {
            return c + "";
          } catch {
          }
        }
        return "";
      }
      function cp(c, v) {
        return bi(fe, function(S) {
          var P = "_." + S[0];
          v & S[1] && !Do(c, P) && c.push(P);
        }), c.sort();
      }
      function zl(c) {
        if (c instanceof un)
          return c.clone();
        var v = new xi(c.__wrapped__, c.__chain__);
        return v.__actions__ = Bn(c.__actions__), v.__index__ = c.__index__, v.__values__ = c.__values__, v;
      }
      function Qf(c, v, S) {
        (S ? zr(c, v, S) : v === n) ? v = 1 : v = Ur(pn(v), 0);
        var P = c == null ? 0 : c.length;
        if (!P || v < 1)
          return [];
        for (var j = 0, q = 0, ue = Be(bc(P / v)); j < P; )
          ue[q++] = ei(c, j, j += v);
        return ue;
      }
      function Fg(c) {
        for (var v = -1, S = c == null ? 0 : c.length, P = 0, j = []; ++v < S; ) {
          var q = c[v];
          q && (j[P++] = q);
        }
        return j;
      }
      function $g() {
        var c = arguments.length;
        if (!c)
          return [];
        for (var v = Be(c - 1), S = arguments[0], P = c; P--; )
          v[P - 1] = arguments[P];
        return ps(cn(S) ? Bn(S) : [S], jr(v, 1));
      }
      var Zv = ln(function(c, v) {
        return ni(c) ? Cl(c, jr(v, 1, ni, !0)) : [];
      }), Ug = ln(function(c, v) {
        var S = li(v);
        return ni(S) && (S = n), ni(c) ? Cl(c, jr(v, 1, ni, !0), Dt(S, 2)) : [];
      }), Au = ln(function(c, v) {
        var S = li(v);
        return ni(S) && (S = n), ni(c) ? Cl(c, jr(v, 1, ni, !0), n, S) : [];
      });
      function jy(c, v, S) {
        var P = c == null ? 0 : c.length;
        return P ? (v = S || v === n ? 1 : pn(v), ei(c, v < 0 ? 0 : v, P)) : [];
      }
      function Wy(c, v, S) {
        var P = c == null ? 0 : c.length;
        return P ? (v = S || v === n ? 1 : pn(v), v = P - v, ei(c, 0, v < 0 ? 0 : v)) : [];
      }
      function Pu(c, v) {
        return c && c.length ? Mc(c, Dt(v, 3), !0, !0) : [];
      }
      function Vg(c, v) {
        return c && c.length ? Mc(c, Dt(v, 3), !0) : [];
      }
      function Jv(c, v, S, P) {
        var j = c == null ? 0 : c.length;
        return j ? (S && typeof S != "number" && zr(c, v, S) && (S = 0, P = j), Rl(c, v, S, P)) : [];
      }
      function eh(c, v, S) {
        var P = c == null ? 0 : c.length;
        if (!P)
          return -1;
        var j = S == null ? 0 : pn(S);
        return j < 0 && (j = Ur(P + j, 0)), cu(c, Dt(v, 3), j);
      }
      function Nu(c, v, S) {
        var P = c == null ? 0 : c.length;
        if (!P)
          return -1;
        var j = P - 1;
        return S !== n && (j = pn(S), j = S < 0 ? Ur(P + j, 0) : br(j, P - 1)), cu(c, Dt(v, 3), j, !0);
      }
      function zs(c) {
        var v = c == null ? 0 : c.length;
        return v ? jr(c, 1) : [];
      }
      function Gy(c) {
        var v = c == null ? 0 : c.length;
        return v ? jr(c, _e) : [];
      }
      function Hy(c, v) {
        var S = c == null ? 0 : c.length;
        return S ? (v = v === n ? 1 : pn(v), jr(c, v)) : [];
      }
      function jg(c) {
        for (var v = -1, S = c == null ? 0 : c.length, P = {}; ++v < S; ) {
          var j = c[v];
          P[j[0]] = j[1];
        }
        return P;
      }
      function Wg(c) {
        return c && c.length ? c[0] : n;
      }
      function Qa(c, v, S) {
        var P = c == null ? 0 : c.length;
        if (!P)
          return -1;
        var j = S == null ? 0 : pn(S);
        return j < 0 && (j = Ur(P + j, 0)), cl(c, v, j);
      }
      function fp(c) {
        var v = c == null ? 0 : c.length;
        return v ? ei(c, 0, -1) : [];
      }
      var Yy = ln(function(c) {
        var v = Gn(c, Lv);
        return v.length && v[0] === c[0] ? wu(v) : [];
      }), ku = ln(function(c) {
        var v = li(c), S = Gn(c, Lv);
        return v === li(S) ? v = n : S.pop(), S.length && S[0] === c[0] ? wu(S, Dt(v, 2)) : [];
      }), Zf = ln(function(c) {
        var v = li(c), S = Gn(c, Lv);
        return v = typeof v == "function" ? v : n, v && S.pop(), S.length && S[0] === c[0] ? wu(S, n, v) : [];
      });
      function Yo(c, v) {
        return c == null ? "" : jd.call(c, v);
      }
      function li(c) {
        var v = c == null ? 0 : c.length;
        return v ? c[v - 1] : n;
      }
      function th(c, v, S) {
        var P = c == null ? 0 : c.length;
        if (!P)
          return -1;
        var j = P;
        return S !== n && (j = pn(S), j = j < 0 ? Ur(P + j, 0) : br(j, P - 1)), v === v ? co(c, v, j) : cu(c, Ld, j, !0);
      }
      function nh(c, v) {
        return c && c.length ? Ds(c, pn(v)) : n;
      }
      var qy = ln(Jf);
      function Jf(c, v) {
        return c && c.length && v && v.length ? Or(c, v) : c;
      }
      function dp(c, v, S) {
        return c && c.length && v && v.length ? Or(c, v, Dt(S, 2)) : c;
      }
      function pp(c, v, S) {
        return c && c.length && v && v.length ? Or(c, v, n, S) : c;
      }
      var Gg = la(function(c, v) {
        var S = c == null ? 0 : c.length, P = Sf(c, v);
        return bn(c, Gn(v, function(j) {
          return Ai(j, S) ? +j : j;
        }).sort($v)), P;
      });
      function vp(c, v) {
        var S = [];
        if (!(c && c.length))
          return S;
        var P = -1, j = [], q = c.length;
        for (v = Dt(v, 3); ++P < q; ) {
          var ue = c[P];
          v(ue, P, c) && (S.push(ue), j.push(P));
        }
        return bn(c, j), S;
      }
      function hp(c) {
        return c == null ? c : Gd.call(c);
      }
      function rh(c, v, S) {
        var P = c == null ? 0 : c.length;
        return P ? (S && typeof S != "number" && zr(c, v, S) ? (v = 0, S = P) : (v = v == null ? 0 : pn(v), S = S === n ? P : pn(S)), ei(c, v, S)) : [];
      }
      function ed(c, v) {
        return Ru(c, v);
      }
      function Xy(c, v, S) {
        return Pf(c, v, Dt(S, 2));
      }
      function gp(c, v) {
        var S = c == null ? 0 : c.length;
        if (S) {
          var P = Ru(c, v);
          if (P < S && qo(c[P], v))
            return P;
        }
        return -1;
      }
      function Hg(c, v) {
        return Ru(c, v, !0);
      }
      function Ky(c, v, S) {
        return Pf(c, v, Dt(S, 2), !0);
      }
      function td(c, v) {
        var S = c == null ? 0 : c.length;
        if (S) {
          var P = Ru(c, v, !0) - 1;
          if (qo(c[P], v))
            return P;
        }
        return -1;
      }
      function Qy(c) {
        return c && c.length ? Nf(c) : [];
      }
      function mp(c, v) {
        return c && c.length ? Nf(c, Dt(v, 2)) : [];
      }
      function u(c) {
        var v = c == null ? 0 : c.length;
        return v ? ei(c, 1, v) : [];
      }
      function d(c, v, S) {
        return c && c.length ? (v = S || v === n ? 1 : pn(v), ei(c, 0, v < 0 ? 0 : v)) : [];
      }
      function m(c, v, S) {
        var P = c == null ? 0 : c.length;
        return P ? (v = S || v === n ? 1 : pn(v), v = P - v, ei(c, v < 0 ? 0 : v, P)) : [];
      }
      function w(c, v) {
        return c && c.length ? Mc(c, Dt(v, 3), !1, !0) : [];
      }
      function M(c, v) {
        return c && c.length ? Mc(c, Dt(v, 3)) : [];
      }
      var F = ln(function(c) {
        return Tu(jr(c, 1, ni, !0));
      }), H = ln(function(c) {
        var v = li(c);
        return ni(v) && (v = n), Tu(jr(c, 1, ni, !0), Dt(v, 2));
      }), te = ln(function(c) {
        var v = li(c);
        return v = typeof v == "function" ? v : n, Tu(jr(c, 1, ni, !0), n, v);
      });
      function me(c) {
        return c && c.length ? Tu(c) : [];
      }
      function ze(c, v) {
        return c && c.length ? Tu(c, Dt(v, 2)) : [];
      }
      function vt(c, v) {
        return v = typeof v == "function" ? v : n, c && c.length ? Tu(c, n, v) : [];
      }
      function qt(c) {
        if (!(c && c.length))
          return [];
        var v = 0;
        return c = Wa(c, function(S) {
          if (ni(S))
            return v = Ur(S.length, v), !0;
        }), Bd(v, function(S) {
          return Gn(c, mv(S));
        });
      }
      function Je(c, v) {
        if (!(c && c.length))
          return [];
        var S = qt(c);
        return v == null ? S : Gn(S, function(P) {
          return ii(v, n, P);
        });
      }
      var Mt = ln(function(c, v) {
        return ni(c) ? Cl(c, v) : [];
      }), Qt = ln(function(c) {
        return Il(Wa(c, ni));
      }), It = ln(function(c) {
        var v = li(c);
        return ni(v) && (v = n), Il(Wa(c, ni), Dt(v, 2));
      }), Me = ln(function(c) {
        var v = li(c);
        return v = typeof v == "function" ? v : n, Il(Wa(c, ni), n, v);
      }), Ee = ln(qt);
      function Te(c, v) {
        return Pg(c || [], v || [], Sl);
      }
      function We(c, v) {
        return Pg(c || [], v || [], Uo);
      }
      var Ye = ln(function(c) {
        var v = c.length, S = v > 1 ? c[v - 1] : n;
        return S = typeof S == "function" ? (c.pop(), S) : n, Je(c, S);
      });
      function rn(c) {
        var v = G(c);
        return v.__chain__ = !0, v;
      }
      function yt(c, v) {
        return v(c), c;
      }
      function Ut(c, v) {
        return v(c);
      }
      var sn = la(function(c) {
        var v = c.length, S = v ? c[0] : 0, P = this.__wrapped__, j = function(q) {
          return Sf(q, c);
        };
        return v > 1 || this.__actions__.length || !(P instanceof un) || !Ai(S) ? this.thru(j) : (P = P.slice(S, +S + (v ? 1 : 0)), P.__actions__.push({
          func: Ut,
          args: [j],
          thisArg: n
        }), new xi(P, this.__chain__).thru(function(q) {
          return v && !q.length && q.push(n), q;
        }));
      });
      function on() {
        return rn(this);
      }
      function Iu() {
        return new xi(this.value(), this.__chain__);
      }
      function Zy() {
        this.__values__ === n && (this.__values__ = S1(this.value()));
        var c = this.__index__ >= this.__values__.length, v = c ? n : this.__values__[this.__index__++];
        return { done: c, value: v };
      }
      function Jb() {
        return this;
      }
      function gS(c) {
        for (var v, S = this; S instanceof Oa; ) {
          var P = zl(S);
          P.__index__ = 0, P.__values__ = n, v ? j.__wrapped__ = P : v = P;
          var j = P;
          S = S.__wrapped__;
        }
        return j.__wrapped__ = c, v;
      }
      function mS() {
        var c = this.__wrapped__;
        if (c instanceof un) {
          var v = c;
          return this.__actions__.length && (v = new un(this)), v = v.reverse(), v.__actions__.push({
            func: Ut,
            args: [hp],
            thisArg: n
          }), new xi(v, this.__chain__);
        }
        return this.thru(hp);
      }
      function yS() {
        return kf(this.__wrapped__, this.__actions__);
      }
      var ih = ep(function(c, v, S) {
        Tn.call(c, S) ? ++c[S] : Vr(c, S, 1);
      });
      function e1(c, v, S) {
        var P = cn(c) ? df : Cc;
        return S && zr(c, v, S) && (v = n), P(c, Dt(v, 3));
      }
      function t1(c, v) {
        var S = cn(c) ? Wa : wf;
        return S(c, Dt(v, 3));
      }
      var bS = np(eh), n1 = np(Nu);
      function _S(c, v) {
        return jr(Yg(c, v), 1);
      }
      function xr(c, v) {
        return jr(Yg(c, v), _e);
      }
      function r1(c, v, S) {
        return S = S === n ? 1 : pn(S), jr(Yg(c, v), S);
      }
      function Jy(c, v) {
        var S = cn(c) ? bi : ho;
        return S(c, Dt(v, 3));
      }
      function e0(c, v) {
        var S = cn(c) ? gv : wc;
        return S(c, Dt(v, 3));
      }
      var i1 = ep(function(c, v, S) {
        Tn.call(c, S) ? c[S].push(v) : Vr(c, S, [v]);
      });
      function a1(c, v, S, P) {
        c = Pi(c) ? c : Fs(c), S = S && !P ? pn(S) : 0;
        var j = c.length;
        return S < 0 && (S = Ur(j + S, 0)), nm(c) ? S <= j && c.indexOf(v, S) > -1 : !!j && cl(c, v, S) > -1;
      }
      var o1 = ln(function(c, v, S) {
        var P = -1, j = typeof v == "function", q = Pi(c) ? Be(c.length) : [];
        return ho(c, function(ue) {
          q[++P] = j ? ii(v, ue, S) : Ml(ue, v, S);
        }), q;
      }), ah = ep(function(c, v, S) {
        Vr(c, S, v);
      });
      function Yg(c, v) {
        var S = cn(c) ? Gn : Al;
        return S(c, Dt(v, 3));
      }
      function qg(c, v, S, P) {
        return c == null ? [] : (cn(v) || (v = v == null ? [] : [v]), S = P ? n : S, cn(S) || (S = S == null ? [] : [S]), Mi(c, v, S));
      }
      var yp = ep(function(c, v, S) {
        c[S ? 0 : 1].push(v);
      }, function() {
        return [[], []];
      });
      function ES(c, v, S) {
        var P = cn(c) ? aa : yv, j = arguments.length < 3;
        return P(c, Dt(v, 4), S, j, ho);
      }
      function s1(c, v, S) {
        var P = cn(c) ? vs : yv, j = arguments.length < 3;
        return P(c, Dt(v, 4), S, j, wc);
      }
      function xS(c, v) {
        var S = cn(c) ? Wa : wf;
        return S(c, dh(Dt(v, 3)));
      }
      function u1(c) {
        var v = cn(c) ? ws : Iv;
        return v(c);
      }
      function Za(c, v, S) {
        (S ? zr(c, v, S) : v === n) ? v = 1 : v = pn(v);
        var P = cn(c) ? yu : Oc;
        return P(c, v);
      }
      function oh(c) {
        var v = cn(c) ? Lo : Dc;
        return v(c);
      }
      function Xg(c) {
        if (c == null)
          return 0;
        if (Pi(c))
          return nm(c) ? Ca(c) : c.length;
        var v = ui(c);
        return v == Le || v == tn ? c.size : $o(c).length;
      }
      function sh(c, v, S) {
        var P = cn(c) ? _i : Qd;
        return S && zr(c, v, S) && (v = n), P(c, Dt(v, 3));
      }
      var l1 = ln(function(c, v) {
        if (c == null)
          return [];
        var S = v.length;
        return S > 1 && zr(c, v[0], v[1]) ? v = [] : S > 2 && zr(v[0], v[1], v[2]) && (v = [v[0]]), Mi(c, jr(v, 1), []);
      }), Lu = Vd || function() {
        return yi.Date.now();
      };
      function nd(c, v) {
        if (typeof v != "function")
          throw new Ra(l);
        return c = pn(c), function() {
          if (--c < 1)
            return v.apply(this, arguments);
        };
      }
      function uh(c, v, S) {
        return v = S ? n : v, v = c && v == null ? c.length : v, Na(c, U, n, n, n, n, v);
      }
      function rd(c, v) {
        var S;
        if (typeof v != "function")
          throw new Ra(l);
        return c = pn(c), function() {
          return --c > 0 && (S = v.apply(this, arguments)), c <= 1 && (v = n), S;
        };
      }
      var lh = ln(function(c, v, S) {
        var P = D;
        if (S.length) {
          var j = fu(S, Dr(lh));
          P |= k;
        }
        return Na(c, P, v, S, j);
      }), bp = ln(function(c, v, S) {
        var P = D | A;
        if (S.length) {
          var j = fu(S, Dr(bp));
          P |= k;
        }
        return Na(v, P, c, S, j);
      });
      function ch(c, v, S) {
        v = S ? n : v;
        var P = Na(c, I, n, n, n, n, n, v);
        return P.placeholder = ch.placeholder, P;
      }
      function fh(c, v, S) {
        v = S ? n : v;
        var P = Na(c, L, n, n, n, n, n, v);
        return P.placeholder = fh.placeholder, P;
      }
      function _p(c, v, S) {
        var P, j, q, ue, ge, Re, Ve = 0, je = !1, Xe = !1, ut = !0;
        if (typeof c != "function")
          throw new Ra(l);
        v = Xo(v) || 0, Fr(S) && (je = !!S.leading, Xe = "maxWait" in S, q = Xe ? Ur(Xo(S.maxWait) || 0, v) : q, ut = "trailing" in S ? !!S.trailing : ut);
        function Ot(Nr) {
          var no = P, Uu = j;
          return P = j = n, Ve = Nr, ue = c.apply(Uu, no), ue;
        }
        function Vt(Nr) {
          return Ve = Nr, ge = Ho(wn, v), je ? Ot(Nr) : ue;
        }
        function Xt(Nr) {
          var no = Nr - Re, Uu = Nr - Ve, h0 = v - no;
          return Xe ? br(h0, q - Uu) : h0;
        }
        function Lt(Nr) {
          var no = Nr - Re, Uu = Nr - Ve;
          return Re === n || no >= v || no < 0 || Xe && Uu >= q;
        }
        function wn() {
          var Nr = Lu();
          if (Lt(Nr))
            return Rn(Nr);
          ge = Ho(wn, Xt(Nr));
        }
        function Rn(Nr) {
          return ge = n, ut && P ? Ot(Nr) : (P = j = n, ue);
        }
        function ha() {
          ge !== n && Zd(ge), Ve = 0, P = Re = j = ge = n;
        }
        function ci() {
          return ge === n ? ue : Rn(Lu());
        }
        function ga() {
          var Nr = Lu(), no = Lt(Nr);
          if (P = arguments, j = this, Re = Nr, no) {
            if (ge === n)
              return Vt(Re);
            if (Xe)
              return Zd(ge), ge = Ho(wn, v), Ot(Re);
          }
          return ge === n && (ge = Ho(wn, v)), ue;
        }
        return ga.cancel = ha, ga.flush = ci, ga;
      }
      var c1 = ln(function(c, v) {
        return Bo(c, 1, v);
      }), Kg = ln(function(c, v, S) {
        return Bo(c, Xo(v) || 0, S);
      });
      function f1(c) {
        return Na(c, X);
      }
      function Ic(c, v) {
        if (typeof c != "function" || v != null && typeof v != "function")
          throw new Ra(l);
        var S = function() {
          var P = arguments, j = v ? v.apply(this, P) : P[0], q = S.cache;
          if (q.has(j))
            return q.get(j);
          var ue = c.apply(this, P);
          return S.cache = q.set(j, ue) || q, ue;
        };
        return S.cache = new (Ic.Cache || vo)(), S;
      }
      Ic.Cache = vo;
      function dh(c) {
        if (typeof c != "function")
          throw new Ra(l);
        return function() {
          var v = arguments;
          switch (v.length) {
            case 0:
              return !c.call(this);
            case 1:
              return !c.call(this, v[0]);
            case 2:
              return !c.call(this, v[0], v[1]);
            case 3:
              return !c.call(this, v[0], v[1], v[2]);
          }
          return !c.apply(this, v);
        };
      }
      function SS(c) {
        return rd(2, c);
      }
      var wS = sa(function(c, v) {
        v = v.length == 1 && cn(v[0]) ? Gn(v[0], Gi(Dt())) : Gn(jr(v, 1), Gi(Dt()));
        var S = v.length;
        return ln(function(P) {
          for (var j = -1, q = br(P.length, S); ++j < q; )
            P[j] = v[j].call(this, P[j]);
          return ii(c, this, P);
        });
      }), Qg = ln(function(c, v) {
        var S = fu(v, Dr(Qg));
        return Na(c, k, n, v, S);
      }), d1 = ln(function(c, v) {
        var S = fu(v, Dr(d1));
        return Na(c, $, n, v, S);
      }), Zg = la(function(c, v) {
        return Na(c, K, n, n, n, v);
      });
      function CS(c, v) {
        if (typeof c != "function")
          throw new Ra(l);
        return v = v === n ? v : pn(v), ln(c, v);
      }
      function RS(c, v) {
        if (typeof c != "function")
          throw new Ra(l);
        return v = v == null ? 0 : Ur(pn(v), 0), ln(function(S) {
          var P = S[v], j = Vo(S, 0, v);
          return P && ps(j, P), ii(c, this, j);
        });
      }
      function TS(c, v, S) {
        var P = !0, j = !0;
        if (typeof c != "function")
          throw new Ra(l);
        return Fr(S) && (P = "leading" in S ? !!S.leading : P, j = "trailing" in S ? !!S.trailing : j), _p(c, v, {
          leading: P,
          maxWait: v,
          trailing: j
        });
      }
      function OS(c) {
        return uh(c, 1);
      }
      function DS(c, v) {
        return Qg(Bv(v), c);
      }
      function MS() {
        if (!arguments.length)
          return [];
        var c = arguments[0];
        return cn(c) ? c : [c];
      }
      function AS(c) {
        return Tr(c, C);
      }
      function PS(c, v) {
        return v = typeof v == "function" ? v : n, Tr(c, C, v);
      }
      function NS(c) {
        return Tr(c, E | C);
      }
      function kS(c, v) {
        return v = typeof v == "function" ? v : n, Tr(c, E | C, v);
      }
      function p1(c, v) {
        return v == null || Nv(c, v, Ni(v));
      }
      function qo(c, v) {
        return c === v || c !== c && v !== v;
      }
      var v1 = Pc(Ol), h1 = Pc(function(c, v) {
        return c >= v;
      }), Lc = _r(function() {
        return arguments;
      }()) ? _r : function(c) {
        return Ar(c) && Tn.call(c, "callee") && !No.call(c, "callee");
      }, cn = Be.isArray, ph = ff ? Gi(ff) : Of;
      function Pi(c) {
        return c != null && Ep(c.length) && !Bu(c);
      }
      function ni(c) {
        return Ar(c) && Pi(c);
      }
      function g1(c) {
        return c === !0 || c === !1 || Ar(c) && pr(c) == he;
      }
      var Bc = _c || p0, IS = Nd ? Gi(Nd) : zo;
      function m1(c) {
        return Ar(c) && c.nodeType === 1 && !vh(c);
      }
      function LS(c) {
        if (c == null)
          return !0;
        if (Pi(c) && (cn(c) || typeof c == "string" || typeof c.splice == "function" || Bc(c) || xp(c) || Lc(c)))
          return !c.length;
        var v = ui(c);
        if (v == Le || v == tn)
          return !c.size;
        if (Mu(c))
          return !$o(c).length;
        for (var S in c)
          if (Tn.call(c, S))
            return !1;
        return !0;
      }
      function BS(c, v) {
        return Pa(c, v);
      }
      function y1(c, v, S) {
        S = typeof S == "function" ? S : n;
        var P = S ? S(c, v) : n;
        return P === n ? Pa(c, v, n, S) : !!P;
      }
      function zc(c) {
        if (!Ar(c))
          return !1;
        var v = pr(c);
        return v == xe || v == Ne || typeof c.message == "string" && typeof c.name == "string" && !vh(c);
      }
      function b1(c) {
        return typeof c == "number" && Tv(c);
      }
      function Bu(c) {
        if (!Fr(c))
          return !1;
        var v = pr(c);
        return v == oe || v == it || v == Ae || v == en;
      }
      function Jg(c) {
        return typeof c == "number" && c == pn(c);
      }
      function Ep(c) {
        return typeof c == "number" && c > -1 && c % 1 == 0 && c <= Se;
      }
      function Fr(c) {
        var v = typeof c;
        return c != null && (v == "object" || v == "function");
      }
      function Ar(c) {
        return c != null && typeof c == "object";
      }
      var em = ll ? Gi(ll) : kv;
      function _1(c, v) {
        return c === v || qd(c, v, Gr(v));
      }
      function zS(c, v, S) {
        return S = typeof S == "function" ? S : n, qd(c, v, Gr(v), S);
      }
      function FS(c) {
        return E1(c) && c != +c;
      }
      function lM(c) {
        if (Gf(c))
          throw new an(s);
        return Os(c);
      }
      function $S(c) {
        return c === null;
      }
      function US(c) {
        return c == null;
      }
      function E1(c) {
        return typeof c == "number" || Ar(c) && pr(c) == qe;
      }
      function vh(c) {
        if (!Ar(c) || pr(c) != Qe)
          return !1;
        var v = ml(c);
        if (v === null)
          return !0;
        var S = Tn.call(v, "constructor") && v.constructor;
        return typeof S == "function" && S instanceof S && gs.call(S) == wv;
      }
      var t0 = pc ? Gi(pc) : Df;
      function VS(c) {
        return Jg(c) && c >= -Se && c <= Se;
      }
      var tm = kd ? Gi(kd) : Mf;
      function nm(c) {
        return typeof c == "string" || !cn(c) && Ar(c) && pr(c) == Vn;
      }
      function Ja(c) {
        return typeof c == "symbol" || Ar(c) && pr(c) == Kt;
      }
      var xp = Wi ? Gi(Wi) : Rc;
      function n0(c) {
        return c === n;
      }
      function jS(c) {
        return Ar(c) && ui(c) == Gt;
      }
      function WS(c) {
        return Ar(c) && pr(c) == xn;
      }
      var x1 = Pc(Wr), GS = Pc(function(c, v) {
        return c <= v;
      });
      function S1(c) {
        if (!c)
          return [];
        if (Pi(c))
          return nm(c) ? Ga(c) : Bn(c);
        if (ys && c[ys])
          return _g(c[ys]());
        var v = ui(c), S = v == Le ? hs : v == tn ? Fd : Fs;
        return S(c);
      }
      function Fl(c) {
        if (!c)
          return c === 0 ? c : 0;
        if (c = Xo(c), c === _e || c === -_e) {
          var v = c < 0 ? -1 : 1;
          return v * Oe;
        }
        return c === c ? c : 0;
      }
      function pn(c) {
        var v = Fl(c), S = v % 1;
        return v === v ? S ? v - S : v : 0;
      }
      function w1(c) {
        return c ? _u(pn(c), 0, ie) : 0;
      }
      function Xo(c) {
        if (typeof c == "number")
          return c;
        if (Ja(c))
          return re;
        if (Fr(c)) {
          var v = typeof c.valueOf == "function" ? c.valueOf() : c;
          c = Fr(v) ? v + "" : v;
        }
        if (typeof c != "string")
          return c === 0 ? c : +c;
        c = fl(c);
        var S = ru.test(c);
        return S || Td.test(c) ? vv(c.slice(2), S ? 2 : 8) : xa.test(c) ? re : +c;
      }
      function C1(c) {
        return wi(c, eo(c));
      }
      function HS(c) {
        return c ? _u(pn(c), -Se, Se) : c === 0 ? c : 0;
      }
      function Yn(c) {
        return c == null ? "" : Cn(c);
      }
      var YS = ua(function(c, v) {
        if (Mu(v) || Pi(v)) {
          wi(v, Ni(v), c);
          return;
        }
        for (var S in v)
          Tn.call(v, S) && Sl(c, S, v[S]);
      }), R1 = ua(function(c, v) {
        wi(v, eo(v), c);
      }), Sp = ua(function(c, v, S, P) {
        wi(v, eo(v), c, P);
      }), qS = ua(function(c, v, S, P) {
        wi(v, Ni(v), c, P);
      }), XS = la(Sf);
      function KS(c, v) {
        var S = Rr(c);
        return v == null ? S : bu(S, v);
      }
      var QS = ln(function(c, v) {
        c = Zn(c);
        var S = -1, P = v.length, j = P > 2 ? v[2] : n;
        for (j && zr(v[0], v[1], j) && (P = 1); ++S < P; )
          for (var q = v[S], ue = eo(q), ge = -1, Re = ue.length; ++ge < Re; ) {
            var Ve = ue[ge], je = c[Ve];
            (je === n || qo(je, Ha[Ve]) && !Tn.call(c, Ve)) && (c[Ve] = q[Ve]);
          }
        return c;
      }), T1 = ln(function(c) {
        return c.push(n, Hv), ii(M1, n, c);
      });
      function rm(c, v) {
        return pg(c, Dt(v, 3), oa);
      }
      function O1(c, v) {
        return pg(c, Dt(v, 3), Cf);
      }
      function ZS(c, v) {
        return c == null ? c : Rs(c, Dt(v, 3), eo);
      }
      function JS(c, v) {
        return c == null ? c : Tl(c, Dt(v, 3), eo);
      }
      function ew(c, v) {
        return c && oa(c, Dt(v, 3));
      }
      function D1(c, v) {
        return c && Cf(c, Dt(v, 3));
      }
      function tw(c) {
        return c == null ? [] : xu(c, Ni(c));
      }
      function nw(c) {
        return c == null ? [] : xu(c, eo(c));
      }
      function r0(c, v, S) {
        var P = c == null ? n : Ts(c, v);
        return P === n ? S : P;
      }
      function rw(c, v) {
        return c != null && Du(c, v, Rf);
      }
      function i0(c, v) {
        return c != null && Du(c, v, Dl);
      }
      var iw = Vv(function(c, v, S) {
        v != null && typeof v.toString != "function" && (v = Ao.call(v)), c[v] = S;
      }, f0(pa)), aw = Vv(function(c, v, S) {
        v != null && typeof v.toString != "function" && (v = Ao.call(v)), Tn.call(c, v) ? c[v].push(S) : c[v] = [S];
      }, Dt), ow = ln(Ml);
      function Ni(c) {
        return Pi(c) ? Zr(c) : $o(c);
      }
      function eo(c) {
        return Pi(c) ? Zr(c, !0) : Tc(c);
      }
      function sw(c, v) {
        var S = {};
        return v = Dt(v, 3), oa(c, function(P, j, q) {
          Vr(S, v(P, j, q), P);
        }), S;
      }
      function uw(c, v) {
        var S = {};
        return v = Dt(v, 3), oa(c, function(P, j, q) {
          Vr(S, j, v(P, j, q));
        }), S;
      }
      var lw = ua(function(c, v, S) {
        Br(c, v, S);
      }), M1 = ua(function(c, v, S, P) {
        Br(c, v, S, P);
      }), cw = la(function(c, v) {
        var S = {};
        if (c == null)
          return S;
        var P = !1;
        v = Gn(v, function(q) {
          return q = ti(q, c), P || (P = q.length > 1), q;
        }), wi(c, Yt(c), S), P && (S = Tr(S, E | x | C, Yv));
        for (var j = v.length; j--; )
          Un(S, v[j]);
        return S;
      });
      function fw(c, v) {
        return wp(c, dh(Dt(v)));
      }
      var im = la(function(c, v) {
        return c == null ? {} : Ms(c, v);
      });
      function wp(c, v) {
        if (c == null)
          return {};
        var S = Gn(Yt(c), function(P) {
          return [P];
        });
        return v = Dt(v), Xd(c, S, function(P, j) {
          return v(P, j[0]);
        });
      }
      function A1(c, v, S) {
        v = ti(v, c);
        var P = -1, j = v.length;
        for (j || (j = 1, c = n); ++P < j; ) {
          var q = c == null ? n : c[Ka(v[P])];
          q === n && (P = j, q = S), c = Bu(q) ? q.call(c) : q;
        }
        return c;
      }
      function hh(c, v, S) {
        return c == null ? c : Uo(c, v, S);
      }
      function P1(c, v, S, P) {
        return P = typeof P == "function" ? P : n, c == null ? c : Uo(c, v, S, P);
      }
      var gh = Gv(Ni), N1 = Gv(eo);
      function k1(c, v, S) {
        var P = cn(c), j = P || Bc(c) || xp(c);
        if (v = Dt(v, 4), S == null) {
          var q = c && c.constructor;
          j ? S = P ? new q() : [] : Fr(c) ? S = Bu(q) ? Rr(ml(c)) : {} : S = {};
        }
        return (j ? bi : oa)(c, function(ue, ge, Re) {
          return v(S, ue, ge, Re);
        }), S;
      }
      function am(c, v) {
        return c == null ? !0 : Un(c, v);
      }
      function id(c, v, S) {
        return c == null ? c : kl(c, v, Bv(S));
      }
      function Fc(c, v, S, P) {
        return P = typeof P == "function" ? P : n, c == null ? c : kl(c, v, Bv(S), P);
      }
      function Fs(c) {
        return c == null ? [] : zd(c, Ni(c));
      }
      function om(c) {
        return c == null ? [] : zd(c, eo(c));
      }
      function a0(c, v, S) {
        return S === n && (S = v, v = n), S !== n && (S = Xo(S), S = S === S ? S : 0), v !== n && (v = Xo(v), v = v === v ? v : 0), _u(Xo(c), v, S);
      }
      function I1(c, v, S) {
        return v = Fl(v), S === n ? (S = v, v = 0) : S = Fl(S), c = Xo(c), Tf(c, v, S);
      }
      function L1(c, v, S) {
        if (S && typeof S != "boolean" && zr(c, v, S) && (v = S = n), S === n && (typeof v == "boolean" ? (S = v, v = n) : typeof c == "boolean" && (S = c, c = n)), c === n && v === n ? (c = 0, v = 1) : (c = Fl(c), v === n ? (v = c, c = 0) : v = Fl(v)), c > v) {
          var P = c;
          c = v, v = P;
        }
        if (S || c % 1 || v % 1) {
          var j = fo();
          return br(c + j * (v - c + pv("1e-" + ((j + "").length - 1))), v);
        }
        return go(c, v);
      }
      var B1 = jo(function(c, v, S) {
        return v = v.toLowerCase(), c + (S ? mh(v) : v);
      });
      function mh(c) {
        return fm(Yn(c).toLowerCase());
      }
      function Ko(c) {
        return c = Yn(c), c && c.replace(ag, vf).replace(Wn, "");
      }
      function o0(c, v, S) {
        c = Yn(c), v = Cn(v);
        var P = c.length;
        S = S === n ? P : _u(pn(S), 0, P);
        var j = S;
        return S -= v.length, S >= 0 && c.slice(S, j) == v;
      }
      function sm(c) {
        return c = Yn(c), c && Ua.test(c) ? c.replace(Ji, zy) : c;
      }
      function $l(c) {
        return c = Yn(c), c && tt.test(c) ? c.replace(de, "\\$&") : c;
      }
      var $c = jo(function(c, v, S) {
        return c + (S ? "-" : "") + v.toLowerCase();
      }), fa = jo(function(c, v, S) {
        return c + (S ? " " : "") + v.toLowerCase();
      }), da = tp("toLowerCase");
      function s0(c, v, S) {
        c = Yn(c), v = pn(v);
        var P = v ? Ca(c) : 0;
        if (!v || P >= v)
          return c;
        var j = (v - P) / 2;
        return Ff(_s(j), S) + c + Ff(bc(j), S);
      }
      function _o(c, v, S) {
        c = Yn(c), v = pn(v);
        var P = v ? Ca(c) : 0;
        return v && P < v ? c + Ff(v - P, S) : c;
      }
      function Ul(c, v, S) {
        c = Yn(c), v = pn(v);
        var P = v ? Ca(c) : 0;
        return v && P < v ? Ff(v - P, S) + c : c;
      }
      function zu(c, v, S) {
        return S || v == null ? v = 0 : v && (v = +v), _l(Yn(c).replace(ct, ""), v || 0);
      }
      function u0(c, v, S) {
        return (S ? zr(c, v, S) : v === n) ? v = 1 : v = pn(v), Nl(Yn(c), v);
      }
      function Cp() {
        var c = arguments, v = Yn(c[0]);
        return c.length < 3 ? v : v.replace(c[1], c[2]);
      }
      var z1 = jo(function(c, v, S) {
        return c + (S ? "_" : "") + v.toLowerCase();
      });
      function Rp(c, v, S) {
        return S && typeof S != "number" && zr(c, v, S) && (v = S = n), S = S === n ? ie : S >>> 0, S ? (c = Yn(c), c && (typeof v == "string" || v != null && !t0(v)) && (v = Cn(v), !v && dl(c)) ? Vo(Ga(c), 0, S) : c.split(v, S)) : [];
      }
      var um = jo(function(c, v, S) {
        return c + (S ? " " : "") + fm(v);
      });
      function Fu(c, v, S) {
        return c = Yn(c), S = S == null ? 0 : _u(pn(S), 0, c.length), v = Cn(v), c.slice(S, S + v.length) == v;
      }
      function lm(c, v, S) {
        var P = G.templateSettings;
        S && zr(c, v, S) && (v = n), c = Yn(c), v = Sp({}, v, P, Nc);
        var j = Sp({}, v.imports, P.imports, Nc), q = Ni(j), ue = zd(j, q), ge, Re, Ve = 0, je = v.interpolate || Sa, Xe = "__p += '", ut = vl(
          (v.escape || Sa).source + "|" + je.source + "|" + (je === ta ? Qn : Sa).source + "|" + (v.evaluate || Sa).source + "|$",
          "g"
        ), Ot = "//# sourceURL=" + (Tn.call(v, "sourceURL") ? (v.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++Pd + "]") + `
`;
        c.replace(ut, function(Lt, wn, Rn, ha, ci, ga) {
          return Rn || (Rn = ha), Xe += c.slice(Ve, ga).replace(Di, yg), wn && (ge = !0, Xe += `' +
__e(` + wn + `) +
'`), ci && (Re = !0, Xe += `';
` + ci + `;
__p += '`), Rn && (Xe += `' +
((__t = (` + Rn + `)) == null ? '' : __t) +
'`), Ve = ga + Lt.length, Lt;
        }), Xe += `';
`;
        var Vt = Tn.call(v, "variable") && v.variable;
        if (!Vt)
          Xe = `with (obj) {
` + Xe + `
}
`;
        else if (Kn.test(Vt))
          throw new an(p);
        Xe = (Re ? Xe.replace(Cr, "") : Xe).replace(Nt, "$1").replace(jn, "$1;"), Xe = "function(" + (Vt || "obj") + `) {
` + (Vt ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (ge ? ", __e = _.escape" : "") + (Re ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + Xe + `return __p
}`;
        var Xt = $s(function() {
          return Mn(q, Ot + "return " + Xe).apply(n, ue);
        });
        if (Xt.source = Xe, zc(Xt))
          throw Xt;
        return Xt;
      }
      function l0(c) {
        return Yn(c).toLowerCase();
      }
      function F1(c) {
        return Yn(c).toUpperCase();
      }
      function $1(c, v, S) {
        if (c = Yn(c), c && (S || v === n))
          return fl(c);
        if (!c || !(v = Cn(v)))
          return c;
        var P = Ga(c), j = Ga(v), q = gg(P, j), ue = mg(P, j) + 1;
        return Vo(P, q, ue).join("");
      }
      function cm(c, v, S) {
        if (c = Yn(c), c && (S || v === n))
          return c.slice(0, Mo(c) + 1);
        if (!c || !(v = Cn(v)))
          return c;
        var P = Ga(c), j = mg(P, Ga(v)) + 1;
        return Vo(P, 0, j).join("");
      }
      function U1(c, v, S) {
        if (c = Yn(c), c && (S || v === n))
          return c.replace(ct, "");
        if (!c || !(v = Cn(v)))
          return c;
        var P = Ga(c), j = gg(P, Ga(v));
        return Vo(P, j).join("");
      }
      function dw(c, v) {
        var S = Y, P = J;
        if (Fr(v)) {
          var j = "separator" in v ? v.separator : j;
          S = "length" in v ? pn(v.length) : S, P = "omission" in v ? Cn(v.omission) : P;
        }
        c = Yn(c);
        var q = c.length;
        if (dl(c)) {
          var ue = Ga(c);
          q = ue.length;
        }
        if (S >= q)
          return c;
        var ge = S - Ca(P);
        if (ge < 1)
          return P;
        var Re = ue ? Vo(ue, 0, ge).join("") : c.slice(0, ge);
        if (j === n)
          return Re + P;
        if (ue && (ge += Re.length - ge), t0(j)) {
          if (c.slice(ge).search(j)) {
            var Ve, je = Re;
            for (j.global || (j = vl(j.source, Yn(Ea.exec(j)) + "g")), j.lastIndex = 0; Ve = j.exec(je); )
              var Xe = Ve.index;
            Re = Re.slice(0, Xe === n ? ge : Xe);
          }
        } else if (c.indexOf(Cn(j), ge) != ge) {
          var ut = Re.lastIndexOf(j);
          ut > -1 && (Re = Re.slice(0, ut));
        }
        return Re + P;
      }
      function c0(c) {
        return c = Yn(c), c && so.test(c) ? c.replace(ss, Fy) : c;
      }
      var V1 = jo(function(c, v, S) {
        return c + (S ? " " : "") + v.toUpperCase();
      }), fm = tp("toUpperCase");
      function yh(c, v, S) {
        return c = Yn(c), v = S ? n : v, v === n ? Ev(c) ? Sv(c) : Id(c) : c.match(v) || [];
      }
      var $s = ln(function(c, v) {
        try {
          return ii(c, n, v);
        } catch (S) {
          return zc(S) ? S : new an(S);
        }
      }), Tp = la(function(c, v) {
        return bi(v, function(S) {
          S = Ka(S), Vr(c, S, lh(c[S], c));
        }), c;
      });
      function pw(c) {
        var v = c == null ? 0 : c.length, S = Dt();
        return c = v ? Gn(c, function(P) {
          if (typeof P[1] != "function")
            throw new Ra(l);
          return [S(P[0]), P[1]];
        }) : [], ln(function(P) {
          for (var j = -1; ++j < v; ) {
            var q = c[j];
            if (ii(q[0], this, P))
              return ii(q[1], this, P);
          }
        });
      }
      function vw(c) {
        return Cs(Tr(c, E));
      }
      function f0(c) {
        return function() {
          return c;
        };
      }
      function hw(c, v) {
        return c == null || c !== c ? v : c;
      }
      var gw = rp(), mw = rp(!0);
      function pa(c) {
        return c;
      }
      function dm(c) {
        return Cu(typeof c == "function" ? c : Tr(c, E));
      }
      function yw(c) {
        return dr(Tr(c, E));
      }
      function j1(c, v) {
        return Jr(c, Tr(v, E));
      }
      var d0 = ln(function(c, v) {
        return function(S) {
          return Ml(S, c, v);
        };
      }), bw = ln(function(c, v) {
        return function(S) {
          return Ml(c, S, v);
        };
      });
      function Op(c, v, S) {
        var P = Ni(v), j = xu(v, P);
        S == null && !(Fr(v) && (j.length || !P.length)) && (S = v, v = c, c = this, j = xu(v, Ni(v)));
        var q = !(Fr(S) && "chain" in S) || !!S.chain, ue = Bu(c);
        return bi(j, function(ge) {
          var Re = v[ge];
          c[ge] = Re, ue && (c.prototype[ge] = function() {
            var Ve = this.__chain__;
            if (q || Ve) {
              var je = c(this.__wrapped__), Xe = je.__actions__ = Bn(this.__actions__);
              return Xe.push({ func: Re, args: arguments, thisArg: c }), je.__chain__ = Ve, je;
            }
            return Re.apply(c, ps([this.value()], arguments));
          });
        }), c;
      }
      function W1() {
        return yi._ === this && (yi._ = Cv), this;
      }
      function pm() {
      }
      function G1(c) {
        return c = pn(c), ln(function(v) {
          return Ds(v, c);
        });
      }
      var H1 = jv(Gn), Y1 = jv(df), Qo = jv(_i);
      function Uc(c) {
        return Bl(c) ? mv(Ka(c)) : Ge(c);
      }
      function Vl(c) {
        return function(v) {
          return c == null ? n : Ts(c, v);
        };
      }
      var q1 = ip(), X1 = ip(!0);
      function bh() {
        return [];
      }
      function p0() {
        return !1;
      }
      function _w() {
        return {};
      }
      function jl() {
        return "";
      }
      function vm() {
        return !0;
      }
      function v0(c, v) {
        if (c = pn(c), c < 1 || c > Se)
          return [];
        var S = ie, P = br(c, ie);
        v = Dt(v), c -= ie;
        for (var j = Bd(P, v); ++S < c; )
          v(S);
        return j;
      }
      function K1(c) {
        return cn(c) ? Gn(c, Ka) : Ja(c) ? [c] : Bn(Kf(Yn(c)));
      }
      function va(c) {
        var v = ++hl;
        return Yn(c) + v;
      }
      var Dp = zf(function(c, v) {
        return c + v;
      }, 0), Q1 = ap("ceil"), ad = zf(function(c, v) {
        return c / v;
      }, 1), Vc = ap("floor");
      function Ew(c) {
        return c && c.length ? Eu(c, pa, Ol) : n;
      }
      function Z1(c, v) {
        return c && c.length ? Eu(c, Dt(v, 2), Ol) : n;
      }
      function $u(c) {
        return vg(c, pa);
      }
      function J1(c, v) {
        return vg(c, Dt(v, 2));
      }
      function e_(c) {
        return c && c.length ? Eu(c, pa, Wr) : n;
      }
      function Pr(c, v) {
        return c && c.length ? Eu(c, Dt(v, 2), Wr) : n;
      }
      var Hr = zf(function(c, v) {
        return c * v;
      }, 1), to = ap("round"), od = zf(function(c, v) {
        return c - v;
      }, 0);
      function Eo(c) {
        return c && c.length ? bv(c, pa) : 0;
      }
      function xw(c, v) {
        return c && c.length ? bv(c, Dt(v, 2)) : 0;
      }
      return G.after = nd, G.ary = uh, G.assign = YS, G.assignIn = R1, G.assignInWith = Sp, G.assignWith = qS, G.at = XS, G.before = rd, G.bind = lh, G.bindAll = Tp, G.bindKey = bp, G.castArray = MS, G.chain = rn, G.chunk = Qf, G.compact = Fg, G.concat = $g, G.cond = pw, G.conforms = vw, G.constant = f0, G.countBy = ih, G.create = KS, G.curry = ch, G.curryRight = fh, G.debounce = _p, G.defaults = QS, G.defaultsDeep = T1, G.defer = c1, G.delay = Kg, G.difference = Zv, G.differenceBy = Ug, G.differenceWith = Au, G.drop = jy, G.dropRight = Wy, G.dropRightWhile = Pu, G.dropWhile = Vg, G.fill = Jv, G.filter = t1, G.flatMap = _S, G.flatMapDeep = xr, G.flatMapDepth = r1, G.flatten = zs, G.flattenDeep = Gy, G.flattenDepth = Hy, G.flip = f1, G.flow = gw, G.flowRight = mw, G.fromPairs = jg, G.functions = tw, G.functionsIn = nw, G.groupBy = i1, G.initial = fp, G.intersection = Yy, G.intersectionBy = ku, G.intersectionWith = Zf, G.invert = iw, G.invertBy = aw, G.invokeMap = o1, G.iteratee = dm, G.keyBy = ah, G.keys = Ni, G.keysIn = eo, G.map = Yg, G.mapKeys = sw, G.mapValues = uw, G.matches = yw, G.matchesProperty = j1, G.memoize = Ic, G.merge = lw, G.mergeWith = M1, G.method = d0, G.methodOf = bw, G.mixin = Op, G.negate = dh, G.nthArg = G1, G.omit = cw, G.omitBy = fw, G.once = SS, G.orderBy = qg, G.over = H1, G.overArgs = wS, G.overEvery = Y1, G.overSome = Qo, G.partial = Qg, G.partialRight = d1, G.partition = yp, G.pick = im, G.pickBy = wp, G.property = Uc, G.propertyOf = Vl, G.pull = qy, G.pullAll = Jf, G.pullAllBy = dp, G.pullAllWith = pp, G.pullAt = Gg, G.range = q1, G.rangeRight = X1, G.rearg = Zg, G.reject = xS, G.remove = vp, G.rest = CS, G.reverse = hp, G.sampleSize = Za, G.set = hh, G.setWith = P1, G.shuffle = oh, G.slice = rh, G.sortBy = l1, G.sortedUniq = Qy, G.sortedUniqBy = mp, G.split = Rp, G.spread = RS, G.tail = u, G.take = d, G.takeRight = m, G.takeRightWhile = w, G.takeWhile = M, G.tap = yt, G.throttle = TS, G.thru = Ut, G.toArray = S1, G.toPairs = gh, G.toPairsIn = N1, G.toPath = K1, G.toPlainObject = C1, G.transform = k1, G.unary = OS, G.union = F, G.unionBy = H, G.unionWith = te, G.uniq = me, G.uniqBy = ze, G.uniqWith = vt, G.unset = am, G.unzip = qt, G.unzipWith = Je, G.update = id, G.updateWith = Fc, G.values = Fs, G.valuesIn = om, G.without = Mt, G.words = yh, G.wrap = DS, G.xor = Qt, G.xorBy = It, G.xorWith = Me, G.zip = Ee, G.zipObject = Te, G.zipObjectDeep = We, G.zipWith = Ye, G.entries = gh, G.entriesIn = N1, G.extend = R1, G.extendWith = Sp, Op(G, G), G.add = Dp, G.attempt = $s, G.camelCase = B1, G.capitalize = mh, G.ceil = Q1, G.clamp = a0, G.clone = AS, G.cloneDeep = NS, G.cloneDeepWith = kS, G.cloneWith = PS, G.conformsTo = p1, G.deburr = Ko, G.defaultTo = hw, G.divide = ad, G.endsWith = o0, G.eq = qo, G.escape = sm, G.escapeRegExp = $l, G.every = e1, G.find = bS, G.findIndex = eh, G.findKey = rm, G.findLast = n1, G.findLastIndex = Nu, G.findLastKey = O1, G.floor = Vc, G.forEach = Jy, G.forEachRight = e0, G.forIn = ZS, G.forInRight = JS, G.forOwn = ew, G.forOwnRight = D1, G.get = r0, G.gt = v1, G.gte = h1, G.has = rw, G.hasIn = i0, G.head = Wg, G.identity = pa, G.includes = a1, G.indexOf = Qa, G.inRange = I1, G.invoke = ow, G.isArguments = Lc, G.isArray = cn, G.isArrayBuffer = ph, G.isArrayLike = Pi, G.isArrayLikeObject = ni, G.isBoolean = g1, G.isBuffer = Bc, G.isDate = IS, G.isElement = m1, G.isEmpty = LS, G.isEqual = BS, G.isEqualWith = y1, G.isError = zc, G.isFinite = b1, G.isFunction = Bu, G.isInteger = Jg, G.isLength = Ep, G.isMap = em, G.isMatch = _1, G.isMatchWith = zS, G.isNaN = FS, G.isNative = lM, G.isNil = US, G.isNull = $S, G.isNumber = E1, G.isObject = Fr, G.isObjectLike = Ar, G.isPlainObject = vh, G.isRegExp = t0, G.isSafeInteger = VS, G.isSet = tm, G.isString = nm, G.isSymbol = Ja, G.isTypedArray = xp, G.isUndefined = n0, G.isWeakMap = jS, G.isWeakSet = WS, G.join = Yo, G.kebabCase = $c, G.last = li, G.lastIndexOf = th, G.lowerCase = fa, G.lowerFirst = da, G.lt = x1, G.lte = GS, G.max = Ew, G.maxBy = Z1, G.mean = $u, G.meanBy = J1, G.min = e_, G.minBy = Pr, G.stubArray = bh, G.stubFalse = p0, G.stubObject = _w, G.stubString = jl, G.stubTrue = vm, G.multiply = Hr, G.nth = nh, G.noConflict = W1, G.noop = pm, G.now = Lu, G.pad = s0, G.padEnd = _o, G.padStart = Ul, G.parseInt = zu, G.random = L1, G.reduce = ES, G.reduceRight = s1, G.repeat = u0, G.replace = Cp, G.result = A1, G.round = to, G.runInContext = Ce, G.sample = u1, G.size = Xg, G.snakeCase = z1, G.some = sh, G.sortedIndex = ed, G.sortedIndexBy = Xy, G.sortedIndexOf = gp, G.sortedLastIndex = Hg, G.sortedLastIndexBy = Ky, G.sortedLastIndexOf = td, G.startCase = um, G.startsWith = Fu, G.subtract = od, G.sum = Eo, G.sumBy = xw, G.template = lm, G.times = v0, G.toFinite = Fl, G.toInteger = pn, G.toLength = w1, G.toLower = l0, G.toNumber = Xo, G.toSafeInteger = HS, G.toString = Yn, G.toUpper = F1, G.trim = $1, G.trimEnd = cm, G.trimStart = U1, G.truncate = dw, G.unescape = c0, G.uniqueId = va, G.upperCase = V1, G.upperFirst = fm, G.each = Jy, G.eachRight = e0, G.first = Wg, Op(G, function() {
        var c = {};
        return oa(G, function(v, S) {
          Tn.call(G.prototype, S) || (c[S] = v);
        }), c;
      }(), { chain: !1 }), G.VERSION = r, bi(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(c) {
        G[c].placeholder = G;
      }), bi(["drop", "take"], function(c, v) {
        un.prototype[c] = function(S) {
          S = S === n ? 1 : Ur(pn(S), 0);
          var P = this.__filtered__ && !v ? new un(this) : this.clone();
          return P.__filtered__ ? P.__takeCount__ = br(S, P.__takeCount__) : P.__views__.push({
            size: br(S, ie),
            type: c + (P.__dir__ < 0 ? "Right" : "")
          }), P;
        }, un.prototype[c + "Right"] = function(S) {
          return this.reverse()[c](S).reverse();
        };
      }), bi(["filter", "map", "takeWhile"], function(c, v) {
        var S = v + 1, P = S == se || S == be;
        un.prototype[c] = function(j) {
          var q = this.clone();
          return q.__iteratees__.push({
            iteratee: Dt(j, 3),
            type: S
          }), q.__filtered__ = q.__filtered__ || P, q;
        };
      }), bi(["head", "last"], function(c, v) {
        var S = "take" + (v ? "Right" : "");
        un.prototype[c] = function() {
          return this[S](1).value()[0];
        };
      }), bi(["initial", "tail"], function(c, v) {
        var S = "drop" + (v ? "" : "Right");
        un.prototype[c] = function() {
          return this.__filtered__ ? new un(this) : this[S](1);
        };
      }), un.prototype.compact = function() {
        return this.filter(pa);
      }, un.prototype.find = function(c) {
        return this.filter(c).head();
      }, un.prototype.findLast = function(c) {
        return this.reverse().find(c);
      }, un.prototype.invokeMap = ln(function(c, v) {
        return typeof c == "function" ? new un(this) : this.map(function(S) {
          return Ml(S, c, v);
        });
      }), un.prototype.reject = function(c) {
        return this.filter(dh(Dt(c)));
      }, un.prototype.slice = function(c, v) {
        c = pn(c);
        var S = this;
        return S.__filtered__ && (c > 0 || v < 0) ? new un(S) : (c < 0 ? S = S.takeRight(-c) : c && (S = S.drop(c)), v !== n && (v = pn(v), S = v < 0 ? S.dropRight(-v) : S.take(v - c)), S);
      }, un.prototype.takeRightWhile = function(c) {
        return this.reverse().takeWhile(c).reverse();
      }, un.prototype.toArray = function() {
        return this.take(ie);
      }, oa(un.prototype, function(c, v) {
        var S = /^(?:filter|find|map|reject)|While$/.test(v), P = /^(?:head|last)$/.test(v), j = G[P ? "take" + (v == "last" ? "Right" : "") : v], q = P || /^find/.test(v);
        !j || (G.prototype[v] = function() {
          var ue = this.__wrapped__, ge = P ? [1] : arguments, Re = ue instanceof un, Ve = ge[0], je = Re || cn(ue), Xe = function(wn) {
            var Rn = j.apply(G, ps([wn], ge));
            return P && ut ? Rn[0] : Rn;
          };
          je && S && typeof Ve == "function" && Ve.length != 1 && (Re = je = !1);
          var ut = this.__chain__, Ot = !!this.__actions__.length, Vt = q && !ut, Xt = Re && !Ot;
          if (!q && je) {
            ue = Xt ? ue : new un(this);
            var Lt = c.apply(ue, ge);
            return Lt.__actions__.push({ func: Ut, args: [Xe], thisArg: n }), new xi(Lt, ut);
          }
          return Vt && Xt ? c.apply(this, ge) : (Lt = this.thru(Xe), Vt ? P ? Lt.value()[0] : Lt.value() : Lt);
        });
      }), bi(["pop", "push", "shift", "sort", "splice", "unshift"], function(c) {
        var v = mc[c], S = /^(?:push|sort|unshift)$/.test(c) ? "tap" : "thru", P = /^(?:pop|shift)$/.test(c);
        G.prototype[c] = function() {
          var j = arguments;
          if (P && !this.__chain__) {
            var q = this.value();
            return v.apply(cn(q) ? q : [], j);
          }
          return this[S](function(ue) {
            return v.apply(cn(ue) ? ue : [], j);
          });
        };
      }), oa(un.prototype, function(c, v) {
        var S = G[v];
        if (S) {
          var P = S.name + "";
          Tn.call(pu, P) || (pu[P] = []), pu[P].push({ name: v, func: S });
        }
      }), pu[Bf(n, A).name] = [{
        name: "wrapper",
        func: n
      }], un.prototype.clone = Ya, un.prototype.reverse = Tg, un.prototype.value = Ov, G.prototype.at = sn, G.prototype.chain = on, G.prototype.commit = Iu, G.prototype.next = Zy, G.prototype.plant = gS, G.prototype.reverse = mS, G.prototype.toJSON = G.prototype.valueOf = G.prototype.value = yS, G.prototype.first = G.prototype.head, ys && (G.prototype[ys] = Jb), G;
    }, pl = wg();
    lo ? ((lo.exports = pl)._ = pl, uu._ = pl) : yi._ = pl;
  }).call($0);
})(uO, uO.exports);
function PD(e) {
  const { id: t, x: n = 0, y: r = 0, z: a = 0, width: s = 0, height: l = 0, rotation: p = 0 } = e;
  return {
    id: t || s6(),
    x: n,
    y: r,
    z: a,
    width: s,
    height: l,
    rotation: AD(p),
    getDOMNode: function() {
      return this.id && document.querySelector(`.vcsBE-box[data-box-id|="${this.id}"]`);
    },
    getBasicProps() {
      const { x: h, y, z: b, width: E, height: x, rotation: C } = this;
      return { x: h, y, z: b, width: E, height: x, rotation: C };
    },
    applyProps(h) {
      return uO.exports.merge(this, h);
    }
  };
}
const u6 = {
  move({ x: e, y: t }) {
    e !== void 0 && (this.x = e), t !== void 0 && (this.y = t);
  }
}, Kx = {
  ...u6,
  drag(e) {
    const t = this.x + e.delta[0], n = this.y + e.delta[1];
    this.move({ x: t, y: n });
  },
  positionAt({ x: e, y: t }) {
    const n = _y(e), r = _y(t), a = n !== !1 ? n - this.x : 0, s = r !== !1 ? r - this.y : 0;
    this.onDrag({ delta: [a, s] }), setTimeout(() => {
      this.store.updateRect();
    }, 0);
  },
  preventOverlap() {
    const t = this.store.boxes.indexOf(this);
    if (t < 1)
      return;
    const { x: n, y: r } = this.store.boxes[t - 1];
    Math.abs(n - this.x) <= 30 && Math.abs(r - this.y) <= 30 && this.positionAt({
      x: n + 30,
      y: r + 30
    });
  },
  moveToCenter() {
    const e = {
      x: 960,
      y: 540
    }, t = {
      x: this.x + this.width / 2,
      y: this.y + this.height / 2
    };
    this.onDrag({
      delta: [
        e.x - t.x,
        e.y - t.y
      ]
    }), this.store.onBoxUpdate(this), setTimeout(() => {
      this.store.updateRect();
    }, 0);
  }
}, ND = {
  ...Kx,
  resize({ width: e, height: t, drag: n }) {
    e !== void 0 && (this.width = e), t !== void 0 && (this.height = t), n && this.drag(n);
  }
}, YB = {
  rotate({ rotation: e }) {
    _y(e) !== !1 && (this.rotation = AD(e));
  }
}, qB = {
  selectable: !0,
  isSelected: !1,
  select() {
    this.selectable && (this.isSelected = !0);
  },
  deselect() {
    this.isSelected = !1;
  },
  selectOnly() {
    this.inCropMode || this.store.inCropModeBox || (this.store.selection.deselect(), this.select(), setTimeout(() => {
      this.store.selection.setTargets([this.getDOMNode()]);
    }, 0));
  }
};
class l6 {
  constructor(t) {
    Object.assign(this, {
      ...PD(t),
      ...Kx,
      ...ND
    }), ng(this);
  }
}
class c6 {
  constructor({
    store: t,
    x: n,
    y: r,
    z: a,
    width: s,
    height: l,
    rotation: p,
    contentBox: h,
    fitToSlide: y = !1
  }) {
    Et(this, "onDragStart", () => {
      this.store.setGuidelines();
    });
    Et(this, "onResizeStart", () => {
      this.store.setGuidelines();
    });
    Et(this, "onDrag", (t) => {
      this.drag(t), this.contentBox.drag(t);
    });
    Et(this, "onResize", ({ width: t, height: n, drag: r = { delta: [0, 0] } }) => {
      const a = [_y(t), _y(n)];
      if (a.every((E) => E === !1))
        return;
      const s = a.indexOf(!1);
      s !== -1 && (s === 0 ? a[0] = a[1] * this.aspectRatio : a[1] = a[0] / this.aspectRatio);
      const [l, p] = a;
      if (l < 32 || p < 32)
        return;
      const h = l / this.width, y = p / this.height;
      this.resize({ width: l, height: p }), this.contentBox.resize({
        width: this.contentBox.width * h,
        height: this.contentBox.height * y
      });
      const b = {
        x: this.x + r.delta[0],
        y: this.y + r.delta[1]
      };
      this.contentBox.move({
        x: b.x - (this.x - this.contentBox.x) * h,
        y: b.y - (this.y - this.contentBox.y) * y
      }), this.move(b);
    });
    Et(this, "toggleCropMode", () => {
      this.inCropMode ? this.leaveCropMode() : this.enterCropMode(), setTimeout(() => {
        this.store.updateRect();
      }, 0);
    });
    Et(this, "enterCropMode", () => {
      this.inCropMode = !0, this.store.setInCropModeBox(this), this.store.selection.deselect();
    });
    Et(this, "leaveCropMode", () => {
      this.store.onBoxUpdate(this), this.inCropMode = !1, this.store.setInCropModeBox(!1), this.selectOnly();
    });
    Et(this, "resetCrop", () => {
      const { x: t, y: n, width: r, height: a } = this.contentBox;
      this.move({ x: t, y: n }), this.resize({ width: r, height: a });
    });
    Et(this, "fillSlide", () => {
      const t = this.rotation % 90, { sin: n, cos: r } = Nk(t), a = (() => {
        const l = this.rotation >= 0 && this.rotation < 90 || this.rotation >= 180 && this.rotation < 270 ? 1920 * n + 1080 * r : 1920 * r + 1080 * n;
        return { width: l * this.aspectRatio, height: l };
      })(), s = (() => {
        const l = this.rotation >= 0 && this.rotation < 90 || this.rotation >= 180 && this.rotation < 270 ? 1080 * n + 1920 * r : 1080 * r + 1920 * n, p = l / this.aspectRatio;
        return { width: l, height: p };
      })();
      this.onResize({
        ...a.width > s.width ? a : s
      }), this.moveToCenter();
    });
    Et(this, "fitSlide", () => {
      const t = this.getDOMNode(this.id).getBoundingClientRect();
      if (!t)
        return;
      const n = t.width / t.height, { sin: r, cos: a } = Nk(this.rotation % 90);
      let s, l;
      if (this.rotation >= 0 && this.rotation < 90 || this.rotation >= 180 && this.rotation < 270)
        l = n > 16 / 9 ? 1920 / (r + this.aspectRatio * a) : 1080 / (a + this.aspectRatio * r);
      else if (this.rotation >= 90 && this.rotation < 180 || this.rotation >= 270 && this.rotation < 360)
        l = n > 16 / 9 ? 1920 / (a + this.aspectRatio * r) : 1080 / (r + this.aspectRatio * a);
      else
        return;
      s = l * this.aspectRatio, this.onResize({ width: s, height: l }), this.moveToCenter();
    });
    Et(this, "cropModeDragCropper", (t) => {
      this.cropModeDragContent(t);
    });
    Et(this, "cropModeResizeCropper", (t) => {
      const { delta: n, direction: r, width: a, height: s, drag: l } = t;
      if (!(a < 32 || s < 32))
        if (r[0] === 0 && r[1] === -1) {
          let p = this.contentBox.x + l.delta[0], h = this.contentBox.y + l.delta[1] + (r[1] < 0 ? n[1] : 0), y = this.x + l.delta[0], b = this.y + l.delta[1];
          const E = h > b ? h - b : 0;
          E || (this.contentBox.move({
            x: p,
            y: h
          }), b = E > 0 ? h : b, this.move({ x: y, y: b }), this.resize({
            height: this.height + n[1] - E
          }));
        } else if (r[0] === -1 && r[1] === 0) {
          let p = this.contentBox.x + l.delta[0] + (r[0] < 0 ? n[0] : 0), h = this.contentBox.y + l.delta[1], y = this.x + l.delta[0], b = this.y + l.delta[1];
          const E = p > y ? p - y : 0;
          E || (this.contentBox.move({
            x: p,
            y: h
          }), y = E > 0 ? p : y, this.move({ x: y, y: b }), this.resize({
            width: this.width + n[0] - E
          }));
        } else {
          this.contentBox.move({
            x: this.contentBox.x + l.delta[0] + (r[0] < 0 ? n[0] : 0),
            y: this.contentBox.y + l.delta[1] + (r[1] < 0 ? n[1] : 0)
          });
          const p = Math.max(this.contentBox.x, this.x + l.delta[0]), h = Math.max(this.contentBox.y, this.y + l.delta[1]);
          this.move({ x: p, y: h }), r[0] === -1 || r[1] === -1 ? this.resize({
            width: Math.min(a, this.x + this.width - this.contentBox.x),
            height: Math.min(s, this.y + this.height - this.contentBox.y)
          }) : this.resize({
            width: Math.min(a, this.contentBox.x + this.contentBox.width - this.x),
            height: Math.min(s, this.contentBox.y + this.contentBox.height - this.y)
          });
        }
    });
    Et(this, "cropModeDragContent", (t) => {
      const n = this.rotation * (Math.PI / 180), r = Math.sin(n), a = Math.cos(n);
      let s = this.contentBox.x + a * t.delta[0] + (t.delta[1] > 0 ? 1 : -1) * Math.abs(t.delta[1]) * r, l = this.contentBox.y + a * t.delta[1] + (t.delta[0] > 0 ? -1 : 1) * Math.abs(t.delta[0]) * r;
      (s > this.x || s + this.contentBox.width < this.x + this.width) && (s = void 0), (l > this.y || l + this.contentBox.height < this.y + this.height) && (l = void 0), this.contentBox.move({
        x: s,
        y: l
      });
    });
    Et(this, "cropModeResizeContent", (t) => {
      console.log(t);
    });
    Et(this, "onRotate", (t) => {
      this.rotate(t), setTimeout(() => {
        this.store.updateRect();
      }, 0);
    });
    this.inCropMode = !1, this.store = t;
    const b = { x: n, y: r, z: a, width: s, height: l, rotation: p };
    if (y)
      for (; b.width > 1920 || b.height > 1080; )
        b.width /= 2, b.height /= 2;
    Object.assign(this, {
      store: t,
      ...PD(b),
      contentBox: new l6(h || b),
      ...Kx,
      ...ND,
      ...YB,
      ...qB
    }), this.actionsOutsideCrop = [
      new Xl({
        title: "Crop",
        handler: this.toggleCropMode,
        icon: "crop"
      }),
      new Xl({
        title: "Fill",
        handler: this.fillSlide,
        icon: "scale-to-fill",
        category: "scale"
      }),
      new Xl({
        title: "Fit",
        handler: this.fitSlide,
        icon: "scale-to-fit",
        category: "scale"
      })
    ], this.actionsInCrop = [
      new Xl({
        id: "Crop_Done",
        title: "Done",
        handler: this.leaveCropMode,
        icon: "crop"
      }),
      new Xl({
        title: "Reset",
        handler: this.resetCrop,
        icon: "reload"
      })
    ], this.moveableProps = {
      draggable: !0,
      onDragStart: this.store.setGuidelines,
      onDrag: this.onDrag,
      onDragGroup: this.onDrag,
      keepRatio: !0,
      resizable: !0,
      onResizeStart: this.store.setGuidelines,
      onResize: this.onResize,
      rotatable: !0,
      onRotate: this.onRotate,
      onDragEnd: () => this.store.onBoxUpdate(this),
      onResizeEnd: () => this.store.onBoxUpdate(this),
      onRotateEnd: () => this.store.onBoxUpdate(this)
    }, ng(this, {
      apiProps: !1
    });
  }
  get apiProps() {
    return {
      ...this.getBasicProps(),
      contentBox: this.contentBox.getBasicProps()
    };
  }
  get actions() {
    return this.inCropMode ? this.actionsInCrop : this.actionsOutsideCrop;
  }
  get aspectRatio() {
    return this.width / this.height;
  }
  get cssTransform() {
    return `translate(${this.x}px, ${this.y}px) rotate(${this.rotation}deg)`;
  }
  get cropperConentTransform() {
    return `translate(${this.contentBox.x - this.x}px, ${this.contentBox.y - this.y}px) rotate(${this.rotation}deg)`;
  }
  get cropperConentTransformNoRotation() {
    return `translate(${this.contentBox.x - this.x}px, ${this.contentBox.y - this.y}px)`;
  }
  get cropModeContentTransformOrigin() {
    const t = (this.x - this.contentBox.x + this.width / 2) * 100 / this.contentBox.width, n = (this.y - this.contentBox.y + this.height / 2) * 100 / this.contentBox.height;
    return `${t}% ${n}%`;
  }
}
class f6 {
  constructor({
    store: t,
    x: n,
    y: r,
    z: a,
    width: s = null,
    height: l = null,
    rotation: p,
    fontSizes: h,
    fontFamilies: y
  }) {
    Et(this, "adjustHeight", () => {
      setTimeout(() => {
        n4(() => {
          this.height = this.getContentSizeRef().offsetHeight;
        }), this.store.updateRect();
      }, 0);
    });
    Et(this, "onFontSizeChange", (t) => {
      this.fontSizes = t, this.adjustHeight();
    });
    Et(this, "onFontFamilyChange", (t) => {
      this.fontFamilies = t, this.adjustHeight();
    });
    Et(this, "onDragStart", () => {
      this.store.setGuidelines();
    });
    Et(this, "onDrag", (t) => {
      this.drag(t);
    });
    Et(this, "onResizeStart", (t) => {
      this.resizeStartFontSizes = { ...this.fontSizes }, this.resizeStartHeight = t.target.offsetHeight, this.resizeStartWidth = t.target.offsetWidth, this.store.setGuidelines(), this.height = "auto";
    });
    Et(this, "onResize", (t) => {
      if (t.direction[1] === 0)
        this.resize({
          width: t.width,
          height: "auto",
          drag: { delta: [t.drag.delta[0], 0] }
        });
      else {
        this.resize(t);
        const n = Math.min(
          t.height / this.resizeStartHeight,
          t.width / this.resizeStartWidth
        ), r = {};
        Object.keys(this.resizeStartFontSizes).forEach((a) => {
          r[a] = this.resizeStartFontSizes[a] * n;
        }), this.fontSizes = r;
      }
    });
    Et(this, "onResizeEnd", (t) => {
      this.height = t.target.offsetHeight, this.store.onBoxUpdate(this);
    });
    Et(this, "onRotate", (t) => {
      this.rotate(t);
    });
    Et(this, "onChange", (t) => {
      const n = {}, r = {};
      t.getCurrentContent().getBlocksAsArray().forEach((a) => {
        n[a.key] = this.fontSizes[a.key] || this.fontSizes.DEFAULT, r[a.key] = this.fontFamilies[a.key] || this.fontFamilies.DEFAULT;
      }), n.DEFAULT = this.fontSizes.DEFAULT || 42, r.DEFAULT = this.fontFamilies.DEFAULT || "Roboto", this.onFontSizeChange(n), this.onFontFamilyChange(r);
    });
    this.store = t, this.actions = [], this.fontFamilies = {
      DEFAULT: "Roboto",
      ...y
    }, this.fontSizes = {
      DEFAULT: 42,
      ...h
    }, Object.assign(this, {
      store: t,
      ...PD({ x: n, y: r, z: a, width: s, height: l, rotation: p }),
      ...Kx,
      ...ND,
      ...YB,
      ...qB
    }), ng(this, {
      apiProps: !1
    }), this.moveableProps = {
      draggable: !0,
      onDragStart: this.store.setGuidelines,
      onDrag: this.onDrag,
      onDragGroup: this.onDrag,
      keepRatio: !0,
      resizable: !0,
      onResizeStart: this.onResizeStart,
      onResize: this.onResize,
      rotatable: !0,
      onRotate: this.onRotate,
      onDragEnd: () => this.store.onBoxUpdate(this),
      onResizeEnd: this.onResizeEnd,
      onRotateEnd: () => this.store.onBoxUpdate(this),
      renderDirections: ["nw", "ne", "sw", "se", "e", "w"]
    };
  }
  get apiProps() {
    return {
      ...this.getBasicProps(),
      fontFamilies: { ...this.fontFamilies },
      fontSizes: { ...this.fontSizes }
    };
  }
  get cssTransform() {
    return `translate(${this.x}px, ${this.y}px) rotate(${this.rotation}deg)`;
  }
}
class bx {
}
Et(bx, "IMAGE", c6), Et(bx, "TEXT", f6);
const Ik = () => {
};
class XB {
  constructor({
    onBoxUpdate: t,
    onBoxDelete: n,
    onZReorder: r
  } = {}) {
    Et(this, "boxes", []);
    Et(this, "inCropModeBox", !1);
    Et(this, "inPreview", !1);
    Et(this, "backgroundColorCSS", "white");
    Et(this, "snappable", !0);
    Et(this, "verticalGuidelines", []);
    Et(this, "horizontalGuidelines", []);
    Et(this, "elementGuidelines", []);
    Et(this, "setSnappable", (t) => {
      this.snappable = t;
    });
    Et(this, "setInCropModeBox", (t) => {
      this.inCropModeBox = t;
    });
    Et(this, "inEditOnly", (t = Ik) => this.inPreview ? Ik : t);
    Et(this, "setBackgroundColorCSS", (t) => {
      this.backgroundColorCSS = t;
    });
    Et(this, "setPreview", (t) => {
      this.inPreview = t, this.selection.deselect(), this.dimensionStore.fit();
    });
    Et(this, "setVerticalGuidelines", () => {
      if (!this.snappable)
        this.verticalGuidelines = [];
      else {
        const t = [0, 1920, 960];
        this.boxes.forEach((n) => {
          n.isSelected || t.push(n.x, n.x + n.width, n.x + n.width / 2);
        }), this.verticalGuidelines = t;
      }
    });
    Et(this, "setHorizontalGuidelines", () => {
      if (!this.snappable)
        this.verticalGuidelines = [];
      else {
        const t = [0, 1080, 540];
        this.boxes.forEach((n) => {
          n.isSelected || t.push(n.y, n.y + n.height, n.y + n.height / 2);
        }), this.horizontalGuidelines = t;
      }
    });
    Et(this, "setElementGuidelines", () => {
      this.snappable ? this.elementGuidelines = Array.from(document.querySelectorAll('[data-box-selected="false"]')) : this.elementGuidelines = [];
    });
    Et(this, "setGuidelines", () => {
      this.setVerticalGuidelines(), this.setHorizontalGuidelines(), this.setElementGuidelines();
    });
    Et(this, "addBox", (t, { updateZOrder: n = !0 } = {}) => {
      t.store = this, this.boxes.push(t), n && this.onZReorder();
    });
    Et(this, "removeBox", (t, { updateZOrder: n = !0 } = {}) => {
      t.deselect(), this.boxes.remove(t), this.onBoxDelete(t), n && this.onZReorder(), setTimeout(() => {
        this.updateRect();
      }, 0);
    });
    Et(this, "clear", () => {
      this.selection.deselect(), this.boxes.forEach((t) => this.removeBox(t, { updateZOrder: !1 })), this.onZReorder();
    });
    this.onBoxUpdate = this.inEditOnly(t), this.onBoxDelete = this.inEditOnly(n), this.onZReorder = this.inEditOnly((a = {}) => {
      r(this.zOrder, a);
    }), this.selection = new t6(this), this.pan = new e6(this), this.dimensionStore = new JH({ store: this }), ng(this, {
      zOrder: !1
    });
  }
  get zOrder() {
    const t = {};
    return this.boxes.forEach((n, r) => {
      t[n.id] = r;
    }), t;
  }
  get scaleFactor() {
    return this.dimensionStore.scaleFactor;
  }
  boxFromDOMNode(t) {
    return this.boxes.find((n) => n.id === t.getAttribute("data-box-id"));
  }
  get zOrderIds() {
    return this.boxes.map(({ id: t }) => t);
  }
  zUp() {
    const t = Ak(this.boxes, (n) => n.isSelected);
    t.length !== 0 && (t.slice(-1).pop().slice(-1).pop() === this.boxes.length - 1 && t.pop(), t.forEach((n) => {
      Pk(this.boxes, n[n.length - 1] + 1, n[0]);
    }));
  }
  zDown() {
    const t = Ak(this.boxes, (n) => n.isSelected);
    t.length !== 0 && (t[0][0] === 0 && t.shift(), t.forEach((n) => {
      Pk(this.boxes, n[0] - 1, n.slice(-1).pop());
    }));
  }
  toFront() {
    let t = 30;
    for (; t > 0; ) {
      const n = this.zOrderIds;
      this.zUp();
      const r = this.zOrderIds;
      if (n.every((a, s) => r[s] === a))
        break;
      t--;
    }
  }
  toBack() {
    let t = 30;
    for (; t > 0; ) {
      const n = this.zOrderIds;
      this.zDown();
      const r = this.zOrderIds;
      if (n.every((a, s) => r[s] === a))
        break;
      t--;
    }
  }
  applyZOrder(t) {
    this.boxes.sort((n, r) => t[n.id] - t[r.id]);
  }
}
const d6 = wy`
    /* Rotation */
    .moveable-rotation {
        height: calc(24px * var(--zoom)) !important;
        
        .moveable-rotation-line {
            width: 200% !important;
        }
    }

    /* Generic line */
    .moveable-line,
    .moveable-control {
        background: var(--selectionColor) !important;
    }
    
    .moveable-guideline {
        background: rgb(255, 74, 225) !important;
        border-color: rgb(255, 74, 225) !important;
    }

    .moveable-guideline.moveable-dashed {
        background: transparent !important;
    }

    .moveable-size-value {
        background-color: rgb(255,74,225) !important;
        color: white !important;
        padding: 2px 6px !important;
        border-radius: 16px !important;
    }

    .moveable-line.moveable-direction {
        border-bottom: 1px solid white !important;
        height: 3px !important;
    }
    
    .moveable-direction.moveable-resizable,
    .moveable-rotation-control {
        border: 1px solid white !important;
    }

    .moveable-cropper-box {
        .moveable-n,
        .moveable-s {
            height: 6px;
            width: 24px;
            margin-left: -12px;
            margin-top: -3px;
            border-radius: 0;
        }

        .moveable-e,
        .moveable-w {
            height: 24px;
            width: 6px;
            margin-left: -3px;
            margin-top: -12px;
            border-radius: 0;
        }

        .moveable-se {
            border-radius: 0;
            width: 32px;
            height: 32px;
            margin-top: -16px;
            margin-left: -16px;
            border: none !important;
            background-color: white !important;
            clip-path: polygon(13px 0, 19px 0, 19px 19px, 0 19px, 0 13px, 13px 13px);

            position: relative;
            
            ::before {
                content: '';
                position: absolute;
                width: 32px;
                height: 32px;
                background-color: var(--selectionColor) !important;
                clip-path: polygon(14px 1px, 18px 1px, 18px 18px, 1px 18px, 1px 14px, 14px 14px);
            }
        }
    }
`, Hb = ({
  box: e,
  className: t = "",
  style: n = {},
  ...r
}) => {
  const a = ["vcsBE-box", e.selectable ? "vcsBE-box-selecto" : "", t].join(" ");
  return /* @__PURE__ */ He(ac, {
    children: () => /* @__PURE__ */ He("div", {
      className: a,
      "data-box-id": e.id,
      "data-box-selected": e.isSelected,
      style: {
        userSelect: "none",
        position: "absolute",
        width: e.width,
        height: e.height,
        transform: e.cssTransform,
        ...n
      },
      ...r
    })
  });
};
Hb.propTypes = {
  box: V.exports.any,
  onMouseOver: V.exports.func,
  onMouseLeave: V.exports.func,
  onClick: V.exports.func,
  style: V.exports.object,
  className: V.exports.string
};
const KB = ({
  store: e
}) => {
  Wt.useEffect(() => {
    const n = (r) => {
      ["Enter", "Escape"].includes(r.key) && t(r);
    };
    return document.addEventListener("keyup", n), () => document.removeEventListener("keyup", n);
  }, []);
  const t = (n) => {
    n.preventDefault(), n.stopPropagation(), e.inCropModeBox && e.inCropModeBox.leaveCropMode();
  };
  return e.inCropModeBox && /* @__PURE__ */ He("div", {
    onClick: t,
    onContextMenu: t,
    style: {
      position: "fixed",
      inset: 0,
      backgroundColor: "rgba(0,0,0,0.5)"
    }
  });
};
KB.propTypes = {
  store: V.exports.object
};
const QB = zx(KB), j0 = {
  CropGrid: qu.div`
        position: absolute;
        top: 0; bottom: 0; left: 0; right: 0;
        z-index: 1;
   `,
  CropGridHorizontal: qu.div`
        position: absolute;
        height: 1px;
        width: 100%;
        background-color: var(--border-color);
        `,
  CropGridVertical: qu.div`
        position: absolute;
        height: 100%;
        width: 1px;
        background-color: var(--border-color);
   `
}, Qx = ({
  box: e,
  children: t,
  ...n
}) => /* @__PURE__ */ He(ac, {
  children: () => /* @__PURE__ */ He(Hb, {
    id: `CropModeContent-${e.id}`,
    box: e.contentBox,
    style: {
      transform: e.cropperConentTransform
    },
    ...n,
    children: /* @__PURE__ */ He("div", {
      style: {
        width: "100%",
        height: "100%"
      },
      children: t
    })
  })
});
Qx.propTypes = {
  box: V.exports.any
};
const ZB = ({
  box: e,
  children: t,
  ...n
}) => /* @__PURE__ */ He(ac, {
  children: () => /* @__PURE__ */ He(Hb, {
    box: e,
    style: {
      overflow: "hidden"
    },
    ...n,
    children: /* @__PURE__ */ He(Qx, {
      box: e,
      children: t,
      style: {
        transform: e.cropperConentTransformNoRotation
      }
    })
  })
});
ZB.propTypes = {
  box: V.exports.any,
  renderBoxContent: V.exports.func
};
const JB = ({
  box: e,
  children: t,
  ...n
}) => {
  const [r, a] = Wt.useState(), [s, l] = Wt.useState(), p = Wt.createRef();
  return Wt.useEffect(() => {
    a(document.querySelector(`#crop-${e.id}`)), l(document.querySelector(`#CropModeContent-${e.id}`));
  }, [e.id]), Wt.useEffect(() => {
    var h, y;
    (y = (h = p.current) == null ? void 0 : h.moveable) == null || y.updateRect();
  }, [p]), /* @__PURE__ */ He(ac, {
    children: () => /* @__PURE__ */ qi(Wt.Fragment, {
      children: [/* @__PURE__ */ qi(Hb, {
        id: `crop-${e.id}`,
        box: e,
        style: {
          position: "fixed",
          overflow: "hidden"
        },
        ...n,
        children: [/* @__PURE__ */ qi(j0.CropGrid, {
          children: [/* @__PURE__ */ He(j0.CropGridHorizontal, {
            style: {
              top: "33%"
            }
          }), /* @__PURE__ */ He(j0.CropGridHorizontal, {
            style: {
              top: "66%"
            }
          }), /* @__PURE__ */ He(j0.CropGridVertical, {
            style: {
              left: "33%"
            }
          }), /* @__PURE__ */ He(j0.CropGridVertical, {
            style: {
              left: "66%"
            }
          })]
        }), /* @__PURE__ */ He(Qx, {
          box: e,
          children: t,
          style: {
            opacity: 1,
            transform: e.cropperConentTransformNoRotation
          }
        })]
      }), /* @__PURE__ */ He(iO, {
        ref: p,
        target: r,
        rootContainer: document.getElementById("canvas"),
        zoom: 1 / e.store.scaleFactor,
        resizable: !0,
        onResize: (h) => {
          e.cropModeResizeCropper(h);
        },
        snappable: !0,
        draggable: !0,
        origin: !1,
        onDrag: (h) => {
          e.cropModeDragCropper(h);
        },
        renderDirections: ["e", "n", "s", "w", "se"],
        className: "moveable-cropper-box"
      }), /* @__PURE__ */ He(iO, {
        target: s,
        rootContainer: document.getElementById("canvas"),
        zoom: 1 / e.store.scaleFactor,
        draggable: !0,
        origin: !1,
        hideDefaultLines: !0,
        onDrag: (h) => {
          e.cropModeDragCropper(h);
        }
      })]
    })
  });
};
JB.propTypes = {
  box: V.exports.any,
  renderBoxContent: V.exports.func
};
const ez = ({
  box: e,
  children: t,
  ...n
}) => /* @__PURE__ */ He(ac, {
  children: () => /* @__PURE__ */ qi(Wt.Fragment, {
    children: [/* @__PURE__ */ He(QB, {
      store: e.store
    }), /* @__PURE__ */ He(Qx, {
      box: e,
      children: t,
      style: {
        position: "fixed",
        opacity: 0.6,
        outline: "2px solid var(--vcs-color--orange)",
        transform: `translate(${e.contentBox.x}px, ${e.contentBox.y}px) rotate(${e.rotation}deg)`,
        transformOrigin: e.cropModeContentTransformOrigin
      },
      ...n
    }), /* @__PURE__ */ He(JB, {
      box: e,
      children: t,
      ...n
    })]
  })
});
ez.propTypes = {
  box: V.exports.any
};
const tz = (e) => /* @__PURE__ */ He(ac, {
  children: () => e.box.inCropMode ? /* @__PURE__ */ He(ez, {
    ...e
  }) : /* @__PURE__ */ He(ZB, {
    ...e
  })
});
tz.propTypes = {
  box: V.exports.any,
  renderBoxContent: V.exports.func,
  onMouseOver: V.exports.func,
  onMouseLeave: V.exports.func,
  onClick: V.exports.func
};
const nz = ({
  box: e,
  children: t,
  ...n
}) => {
  const r = Wt.createRef();
  return e.getContentSizeRef = () => r.current, /* @__PURE__ */ He(ac, {
    children: () => /* @__PURE__ */ He(Hb, {
      box: e,
      ...n,
      style: {
        fontSize: e.fontSize,
        fontFamily: e.fontFamily
      },
      children: /* @__PURE__ */ He("div", {
        ref: r,
        children: t
      })
    })
  });
};
nz.propTypes = {
  box: V.exports.any,
  renderBoxContent: V.exports.func
};
const lO = ({
  box: e,
  ...t
}) => {
  let n = null;
  return e instanceof bx.IMAGE && (n = tz), e instanceof bx.TEXT && (n = nz), /* @__PURE__ */ He(ac, {
    children: () => /* @__PURE__ */ He(n, {
      box: e,
      ...t
    })
  });
};
lO.propTypes = {
  box: V.exports.any,
  onMouseOver: V.exports.func,
  onMouseLeave: V.exports.func,
  onClick: V.exports.func
};
const rz = ({
  store: e,
  renderBoxContent: t
}) => (Wt.useEffect(() => {
  e.updateRect();
}, [e.inCropModeBox]), /* @__PURE__ */ qi(Wt.Fragment, {
  children: [e.boxes.map((n) => n.inCropMode ? null : /* @__PURE__ */ He(lO, {
    box: n,
    children: t(n)
  }, n.id)), e.inCropModeBox && /* @__PURE__ */ He(lO, {
    box: e.inCropModeBox,
    children: t(e.inCropModeBox)
  }, e.inCropModeBox.id)]
}));
rz.propTypes = {
  store: V.exports.object,
  renderBoxContent: V.exports.func
};
const p6 = zx(rz);
function iz({
  store: e
}) {
  return Wt.useEffect(() => {
    const t = ({
      key: r
    }) => ["Control", "`"].includes(r) && e.setSnappable(!1), n = ({
      key: r
    }) => ["Control", "`"].includes(r) && e.setSnappable(!0);
    return window.addEventListener("keydown", t), window.addEventListener("keyup", n), () => {
      window.removeEventListener("keydown", t), window.removeEventListener("keyup", n);
    };
  }, []), Wt.useEffect(() => {
    const t = (r) => {
      r.code === "Space" && r.target == document.body && (r.preventDefault(), e.pan.setActive(!0));
    }, n = (r) => {
      r.code === "Space" && r.target == document.body && (r.preventDefault(), e.pan.setActive(!1));
    };
    return window.addEventListener("keydown", t), window.addEventListener("keyup", n), () => {
      window.removeEventListener("keydown", t), window.removeEventListener("keyup", n);
    };
  }, []), null;
}
iz.propTypes = {
  store: V.exports.object
};
const v6 = zx(iz), km = {
  AvailableSpace: qu.div`
        max-width: 100%;
        max-height: 100%;
        display: flex;
        overflow: hidden;
        ${(e) => {
    if (!e.inPreview)
      return wy`
                    overflow: scroll;
                    margin: 16px;
                    margin-right: 0;
                `;
  }}
    `,
  PanBlockingOverlay: qu.div`
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 9999;
    `,
  Wrapper: qu.div`
        margin: auto;
        /* The actual container with the absolute dimensions on the screen */
        box-shadow: var(--evelation-shadow-2);

        ${d6};
    `,
  Rescaled: qu.div.attrs((e) => ({
    style: {
      transform: `scale(${e.store.scaleFactor})`,
      backgroundColor: `${e.backgroundColor}`
    }
  }))`
        /* 16:9, but rescaled, relative to the absolute dimensions */
        width: 1920px;
        height: 1080px;
        position: relative;
        transform-origin: 0 0;
        direction: ltr;
        background-color: white;
    `,
  Inner: qu.div`
        width: 1920px;
        height: 1080px;
        position: relative;
    `,
  Absolute: qu.div`
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        outline: none;
        overflow: hidden;
    `
};
let nT = null;
const h6 = ({
  store: e,
  renderBoxContent: t,
  children: n,
  style: r = {},
  ...a
}) => {
  const s = Wt.createRef(), l = Wt.useRef(null), p = Wt.useRef(null);
  e.selection.selectoRef = p, e.updateRect = () => {
    var T;
    (T = l == null ? void 0 : l.current) == null || T.updateRect();
  }, B2(() => (e.dimensionStore.fit(), window.addEventListener("resize", e.dimensionStore.fit), () => window.removeEventListener("resize", e.dimensionStore.fit)), []);
  const h = (T, O) => {
    e.inCropModeBox || (e.selection.setTargets(T), e.boxes.forEach((D) => {
      O.includes(D.id) ? D.select() : D.deselect();
    }));
  }, y = (T) => {
    T.inputEvent.preventDefault(), l.current.dragStart(T.inputEvent);
  }, b = (T) => {
    var O, D, A;
    (D = (O = e.pan.props).onMouseDown) == null || D.call(O, T), (A = a.onMouseDown) == null || A.call(a, T);
  }, E = (T) => {
    var O, D, A;
    (D = (O = e.pan.props).onMouseMove) == null || D.call(O, T), (A = a.onMouseMove) == null || A.call(a, T);
  }, x = (T) => {
    var O, D, A;
    (D = (O = e.pan.props).onMouseUp) == null || D.call(O, T), (A = a.onMouseUp) == null || A.call(a, T);
  }, C = (T) => {
    var O, D, A;
    (D = (O = e.pan.props).onMouseLeave) == null || D.call(O, T), (A = a.onMouseLeave) == null || A.call(a, T);
  };
  return /* @__PURE__ */ He(ac, {
    children: () => {
      var T;
      return /* @__PURE__ */ qi(km.AvailableSpace, {
        id: "available-space",
        ref: s,
        inPreview: e.inPreview,
        style: {
          ...(T = e.pan.props.style) != null ? T : {},
          ...r
        },
        ...a,
        onMouseDown: b,
        onMouseMove: E,
        onMouseUp: x,
        onMouseLeave: C,
        children: [/* @__PURE__ */ He(v6, {
          store: e
        }), !e.inPreview && !e.pan.active && /* @__PURE__ */ He(ZH, {
          ref: p,
          selectableTargets: [".vcsBE-selecto-area .vcsBE-box-selecto"],
          hitRate: 1,
          selectByClick: !0,
          selectFromInside: !0,
          toggleContinueSelect: ["ctrl"],
          ratio: 0,
          onDragStart: (O) => {
            const D = O.inputEvent.target;
            nT = O.datas.selectableTargets.find((A) => A.contains(D)), (e.inCropModeBox || l.current.isMoveableElement(D) || e.selection.targets.some((A) => A === D || A.contains(D))) && O.stop();
          },
          onDrag: (O) => {
            nT && (p.current.selecto.trigger("select", {
              selected: [nT]
            }), y(O), O.stop());
          },
          onSelect: ({
            selected: O
          }) => {
            h(O, O.map((D) => D.getAttribute("data-box-id")));
          }
        }), /* @__PURE__ */ He(QB, {
          store: e
        }), /* @__PURE__ */ He(km.Wrapper, {
          id: "canvas",
          style: {
            width: e.dimensionStore.width,
            height: e.dimensionStore.height,
            "--selectionColor": e.inCropModeBox ? "var(--vcs-color--orange)" : "var(--vcs-color--primary)"
          },
          children: /* @__PURE__ */ qi(km.Rescaled, {
            store: e,
            backgroundColor: e.backgroundColorCSS,
            children: [!e.inPreview && !e.pan.active && /* @__PURE__ */ He(iO, {
              ref: l,
              target: e.selection.targets,
              zoom: 1 / e.scaleFactor,
              rootContainer: document.getElementById("canvas"),
              snappable: e.snappable,
              verticalGuidelines: e.verticalGuidelines,
              horizontalGuidelines: e.horizontalGuidelines,
              snapDirections: {
                left: !0,
                top: !0,
                right: !0,
                bottom: !0,
                center: !0,
                middle: !0
              },
              elementSnapDirections: {
                left: !0,
                top: !0,
                right: !0,
                bottom: !0,
                center: !0,
                middle: !0
              },
              snapThreshold: 15 * e.scaleFactor,
              elementGuidelines: e.elementGuidelines,
              origin: !1,
              onClickGroup: (O) => {
                p.current.clickTarget(O.inputEvent, O.inputTarget);
              },
              ...e.selection.moveableProps
            }), /* @__PURE__ */ He(km.Inner, {
              children: /* @__PURE__ */ qi(km.Absolute, {
                className: "vcsBE-selecto-area",
                children: [/* @__PURE__ */ He(p6, {
                  store: e,
                  renderBoxContent: t
                }), n, e.pan.active && /* @__PURE__ */ He(km.PanBlockingOverlay, {})]
              })
            })]
          })
        })]
      });
    }
  });
};
h6.propTypes = {
  store: V.exports.instanceOf(XB),
  renderBoxContent: V.exports.func
};
var Ih = {}, oo = {};
Object.defineProperty(oo, "__esModule", {
  value: !0
});
oo.anchorRef = _6;
oo.bindContextMenu = x6;
oo.bindDialog = M6;
oo.bindDoubleClick = R6;
oo.bindFocus = C6;
oo.bindHover = w6;
oo.bindMenu = O6;
oo.bindPopover = T6;
oo.bindPopper = D6;
oo.bindToggle = S6;
oo.bindTrigger = E6;
oo.createPopupState = b6;
oo.initCoreState = void 0;
g6(Wt);
function az(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap();
  return (az = function(r) {
    return r ? n : t;
  })(e);
}
function g6(e, t) {
  if (!t && e && e.__esModule)
    return e;
  if (e === null || typeof e != "object" && typeof e != "function")
    return { default: e };
  var n = az(t);
  if (n && n.has(e))
    return n.get(e);
  var r = {}, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var s in e)
    if (s !== "default" && Object.prototype.hasOwnProperty.call(e, s)) {
      var l = a ? Object.getOwnPropertyDescriptor(e, s) : null;
      l && (l.get || l.set) ? Object.defineProperty(r, s, l) : r[s] = e[s];
    }
  return r.default = e, n && n.set(e, r), r;
}
const Lk = {};
function m6(e, t) {
  Lk[e] || (Lk[e] = !0, console.error("[material-ui-popup-state] WARNING", t));
}
const y6 = {
  isOpen: !1,
  setAnchorElUsed: !1,
  anchorEl: null,
  anchorPosition: void 0,
  hovered: !1,
  focused: !1,
  _openEventType: null,
  _childPopupState: null,
  _deferNextOpen: !1,
  _deferNextClose: !1
};
oo.initCoreState = y6;
function b6({
  state: e,
  setState: t,
  parentPopupState: n,
  popupId: r,
  variant: a,
  disableAutoFocus: s
}) {
  const {
    isOpen: l,
    setAnchorElUsed: p,
    anchorEl: h,
    anchorPosition: y,
    hovered: b,
    focused: E,
    _openEventType: x,
    _childPopupState: C,
    _deferNextOpen: T,
    _deferNextClose: O
  } = e;
  let D = e;
  const A = (J) => {
    P6(D, J) && t(D = {
      ...D,
      ...J
    });
  }, B = (J) => {
    A({
      setAnchorElUsed: !0,
      anchorEl: J
    });
  }, I = (J) => {
    l ? k(J) : L(J);
  }, L = (J) => {
    const Q = J && J.type, Z = J && J.currentTarget, se = J && J.clientX, pe = J && J.clientY, be = typeof se == "number" && typeof pe == "number" ? {
      left: se,
      top: pe
    } : void 0;
    if (Q === "touchstart") {
      A({
        _deferNextOpen: !0
      });
      return;
    }
    const _e = () => {
      if (!J && !p && m6("missingEventOrAnchorEl", "eventOrAnchorEl should be defined if setAnchorEl is not used"), n) {
        if (!n.isOpen)
          return;
        n._setChildPopupState(Y);
      }
      const Se = {
        isOpen: !0,
        anchorPosition: be,
        hovered: Q === "mouseover" || b,
        focused: Q === "focus" || E,
        _openEventType: Q
      };
      Z ? p || (Se.anchorEl = Z) : J && (Se.anchorEl = J), A(Se);
    };
    T ? (A({
      _deferNextOpen: !1
    }), setTimeout(_e, 0)) : _e();
  }, k = (J) => {
    switch (J && J.type) {
      case "touchstart":
        A({
          _deferNextClose: !0
        });
        return;
    }
    const Z = () => {
      C && C.close(), n && n._setChildPopupState(null), A({
        isOpen: !1,
        hovered: !1,
        focused: !1
      });
    };
    O ? (A({
      _deferNextClose: !1
    }), setTimeout(Z, 0)) : Z();
  }, $ = (J, Q) => {
    J ? L(Q) : k(Q);
  }, U = (J) => {
    const Q = J.relatedTarget;
    b && !cO(Q, Y) && (E ? A({
      hovered: !1
    }) : k(J));
  }, K = (J) => {
    const Q = J.relatedTarget;
    E && !cO(Q, Y) && (b ? A({
      focused: !1
    }) : k(J));
  }, X = (J) => A({
    _childPopupState: J
  }), Y = {
    anchorEl: h,
    anchorPosition: y,
    setAnchorEl: B,
    setAnchorElUsed: p,
    popupId: r,
    variant: a,
    isOpen: l,
    open: L,
    close: k,
    toggle: I,
    setOpen: $,
    onBlur: K,
    onMouseLeave: U,
    disableAutoFocus: s != null ? s : Boolean(b || E),
    _openEventType: x,
    _childPopupState: C,
    _setChildPopupState: X
  };
  return Y;
}
function _6({
  setAnchorEl: e
}) {
  return (t) => {
    t && e(t);
  };
}
function Yb({
  isOpen: e,
  open: t,
  popupId: n,
  variant: r
}) {
  return {
    ...r === "popover" ? {
      "aria-haspopup": !0,
      "aria-controls": e && n != null ? n : void 0
    } : r === "popper" ? {
      "aria-describedby": e && n != null ? n : void 0
    } : void 0
  };
}
function E6(e) {
  return {
    ...Yb(e),
    onClick: e.open,
    onTouchStart: e.open
  };
}
function x6(e) {
  return {
    ...Yb(e),
    onContextMenu: (t) => {
      t.preventDefault(), e.open(t);
    }
  };
}
function S6(e) {
  return {
    ...Yb(e),
    onClick: e.toggle,
    onTouchStart: e.toggle
  };
}
function w6(e) {
  const {
    open: t,
    onMouseLeave: n
  } = e;
  return {
    ...Yb(e),
    onTouchStart: t,
    onMouseOver: t,
    onMouseLeave: n
  };
}
function C6(e) {
  const {
    open: t,
    onBlur: n
  } = e;
  return {
    ...Yb(e),
    onFocus: t,
    onBlur: n
  };
}
function R6({
  isOpen: e,
  open: t,
  popupId: n,
  variant: r
}) {
  return {
    [r === "popover" ? "aria-controls" : "aria-describedby"]: e ? n : null,
    "aria-haspopup": r === "popover" ? !0 : void 0,
    onDoubleClick: t
  };
}
function T6({
  isOpen: e,
  anchorEl: t,
  anchorPosition: n,
  close: r,
  popupId: a,
  onMouseLeave: s,
  disableAutoFocus: l,
  _openEventType: p
}) {
  return {
    id: a,
    anchorEl: t,
    anchorPosition: n,
    anchorReference: p === "contextmenu" ? "anchorPosition" : "anchorEl",
    open: e,
    onClose: r,
    onMouseLeave: s,
    ...l && {
      disableAutoFocus: !0,
      disableEnforceFocus: !0,
      disableRestoreFocus: !0
    }
  };
}
function O6({
  isOpen: e,
  anchorEl: t,
  anchorPosition: n,
  close: r,
  popupId: a,
  onMouseLeave: s,
  disableAutoFocus: l,
  _openEventType: p
}) {
  return {
    id: a,
    anchorEl: t,
    anchorPosition: n,
    anchorReference: p === "contextmenu" ? "anchorPosition" : "anchorEl",
    open: e,
    onClose: r,
    onMouseLeave: s,
    ...l && {
      autoFocus: !1,
      disableAutoFocusItem: !0,
      disableAutoFocus: !0,
      disableEnforceFocus: !0,
      disableRestoreFocus: !0
    }
  };
}
function D6({
  isOpen: e,
  anchorEl: t,
  popupId: n,
  onMouseLeave: r
}) {
  return {
    id: n,
    anchorEl: t,
    open: e,
    onMouseLeave: r
  };
}
function M6({
  isOpen: e,
  close: t
}) {
  return {
    open: e,
    onClose: t
  };
}
function A6({
  popupId: e
}) {
  return e && typeof document < "u" ? document.getElementById(e) : null;
}
function cO(e, t) {
  const {
    anchorEl: n,
    _childPopupState: r
  } = t;
  return Bk(n, e) || Bk(A6(t), e) || r != null && cO(e, r);
}
function Bk(e, t) {
  if (!e)
    return !1;
  for (; t; ) {
    if (t === e)
      return !0;
    t = t.parentElement;
  }
  return !1;
}
function P6(e, t) {
  for (let n in t)
    if (Object.prototype.hasOwnProperty.call(e, n) && e[n] !== t[n])
      return !0;
  return !1;
}
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "anchorRef", {
    enumerable: !0,
    get: function() {
      return n.anchorRef;
    }
  }), Object.defineProperty(e, "bindContextMenu", {
    enumerable: !0,
    get: function() {
      return n.bindContextMenu;
    }
  }), Object.defineProperty(e, "bindDialog", {
    enumerable: !0,
    get: function() {
      return n.bindDialog;
    }
  }), Object.defineProperty(e, "bindDoubleClick", {
    enumerable: !0,
    get: function() {
      return n.bindDoubleClick;
    }
  }), Object.defineProperty(e, "bindFocus", {
    enumerable: !0,
    get: function() {
      return n.bindFocus;
    }
  }), Object.defineProperty(e, "bindHover", {
    enumerable: !0,
    get: function() {
      return n.bindHover;
    }
  }), Object.defineProperty(e, "bindMenu", {
    enumerable: !0,
    get: function() {
      return n.bindMenu;
    }
  }), Object.defineProperty(e, "bindPopover", {
    enumerable: !0,
    get: function() {
      return n.bindPopover;
    }
  }), Object.defineProperty(e, "bindPopper", {
    enumerable: !0,
    get: function() {
      return n.bindPopper;
    }
  }), Object.defineProperty(e, "bindToggle", {
    enumerable: !0,
    get: function() {
      return n.bindToggle;
    }
  }), Object.defineProperty(e, "bindTrigger", {
    enumerable: !0,
    get: function() {
      return n.bindTrigger;
    }
  }), e.usePopupState = r;
  var t = Wt, n = oo;
  if (!t.useState)
    throw new Error("React.useState (added in 16.8.0) must be defined to use the hooks API");
  function r({
    parentPopupState: a,
    popupId: s,
    variant: l,
    disableAutoFocus: p
  }) {
    const [h, y] = (0, t.useState)(n.initCoreState);
    return (0, t.useEffect)(() => {
      if (!p && s && typeof document == "object") {
        const b = document.getElementById(s);
        b && b.focus();
      }
    }, [s, h.anchorEl]), (0, t.useMemo)(() => (0, n.createPopupState)({
      state: h,
      setState: y,
      parentPopupState: a,
      popupId: s,
      variant: l,
      disableAutoFocus: p
    }), [h, y, a, s, l, p]);
  }
})(Ih);
var oz = {};
const Ay = /* @__PURE__ */ AO(VV);
var hi = {};
Object.defineProperty(hi, "__esModule", {
  value: !0
});
hi.textSecondary = hi.textOverflow = hi.selectedListItem = hi.linkNoDecoration = hi.hoverListItem = hi.hoverAnimation = hi.disabled = hi.TextSecondary = hi.TextOverflow = void 0;
var wd = N6(Ay);
function sz(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap();
  return (sz = function(r) {
    return r ? n : t;
  })(e);
}
function N6(e, t) {
  if (!t && e && e.__esModule)
    return e;
  if (e === null || typeof e != "object" && typeof e != "function")
    return { default: e };
  var n = sz(t);
  if (n && n.has(e))
    return n.get(e);
  var r = {}, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var s in e)
    if (s !== "default" && Object.prototype.hasOwnProperty.call(e, s)) {
      var l = a ? Object.getOwnPropertyDescriptor(e, s) : null;
      l && (l.get || l.set) ? Object.defineProperty(r, s, l) : r[s] = e[s];
    }
  return r.default = e, n && n.set(e, r), r;
}
const uz = (0, wd.css)`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;
hi.textOverflow = uz;
const k6 = (0, wd.css)`
    opacity: 0.5 !important;
    cursor: not-allowed !important;
    pointer-events: none !important;
`;
hi.disabled = k6;
const I6 = (0, wd.css)`
    color: var(--vcs-color--primary);
    background-color: rgba(var(--vcs-color--primary-rgb), 0.1);
    box-shadow: 0 -1px 0 var(--vcs-color--primary);
    border-bottom: 1px solid var(--vcs-color--primary);
`;
hi.selectedListItem = I6;
const L6 = (0, wd.css)`
    transition: all 0.25s ease-in;

    &:hover {
        cursor: pointer;
        color: var(--vcs-color--primary);
        background-color: rgba(var(--vcs-color--primary-rgb), 0.05);
    }
`;
hi.hoverListItem = L6;
const B6 = (e = "var(--text-primary-color)") => (0, wd.css)`
    color: ${e};
    text-decoration: none;

    &:hover,
    &:visited,
    &:active,
    &:focus {
        color: ${e};
        text-decoration: none;
        cursor: pointer;
    }
`;
hi.linkNoDecoration = B6;
const z6 = (e = "var(--text-primary-color)", t = "var(--vcs-color--primary)") => (0, wd.css)`
    transition: color 0.4s ease, fill 0.4s ease;
    color: ${e};
    fill: ${e};

    &:hover {
        color: ${t};
        fill: ${t};
    }
`;
hi.hoverAnimation = z6;
const lz = (0, wd.css)`
    color: var(--text-secondary-color);
    font-size: 13px;
`;
hi.textSecondary = lz;
const F6 = wd.default.div`${uz}`;
hi.TextOverflow = F6;
const $6 = wd.default.div`${lz}`;
hi.TextSecondary = $6;
Object.defineProperty(oz, "__esModule", {
  value: !0
});
var rT = oz.IconButton = dz, zk = fz(Wt), Im = fz(V.exports), FE = V6(Ay), Fk = hi;
const U6 = ["children", "disabled", "toggled", "onClick", "toggleIndicatorProps"];
function cz(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap();
  return (cz = function(r) {
    return r ? n : t;
  })(e);
}
function V6(e, t) {
  if (!t && e && e.__esModule)
    return e;
  if (e === null || typeof e != "object" && typeof e != "function")
    return { default: e };
  var n = cz(t);
  if (n && n.has(e))
    return n.get(e);
  var r = {}, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var s in e)
    if (s !== "default" && Object.prototype.hasOwnProperty.call(e, s)) {
      var l = a ? Object.getOwnPropertyDescriptor(e, s) : null;
      l && (l.get || l.set) ? Object.defineProperty(r, s, l) : r[s] = e[s];
    }
  return r.default = e, n && n.set(e, r), r;
}
function fz(e) {
  return e && e.__esModule ? e : { default: e };
}
function _x() {
  return _x = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, _x.apply(this, arguments);
}
function j6(e, t) {
  if (e == null)
    return {};
  var n = W6(e, t), r, a;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (a = 0; a < s.length; a++)
      r = s[a], !(t.indexOf(r) >= 0) && (!Object.prototype.propertyIsEnumerable.call(e, r) || (n[r] = e[r]));
  }
  return n;
}
function W6(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), a, s;
  for (s = 0; s < r.length; s++)
    a = r[s], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
const G6 = FE.default.button`
    position: relative;

    display: inline-flex;
    vertical-align: top;
    align-items: center;
    justify-content: center;
    padding: 0;

    transition: color 0.25s ease-in;
    color: inherit;
    background: transparent;

    border: 0;
    border-radius: 50%;
    cursor: pointer;

    ${(e) => !e.disableHoverAnimation && (0, Fk.hoverAnimation)()}
    ${(e) => e.disabled && Fk.disabled}
    ${(e) => e.toggled && (0, FE.css)`
        color: white;
    `};

    &:hover {
        ${(e) => e.toggled && (0, FE.css)`
            color: white;
        `};
    }
`, H6 = FE.default.div`
    position: absolute;
    width: 42px;
    height: 42px;
    top: -5px;
    left: -5px;

    transition: opacity 0.4s ease;
    opacity: ${(e) => e.toggled ? 1 : 0};

    background-color: var(--vcs-color--primary);
    border-radius: 50%;
`;
function dz(e) {
  let {
    children: t,
    disabled: n = !1,
    toggled: r = void 0,
    onClick: a = console.log,
    toggleIndicatorProps: s = {}
  } = e, l = j6(e, U6);
  const p = () => !n && a();
  return /* @__PURE__ */ zk.default.createElement(G6, _x({
    disabled: n,
    "aria-disabled": n,
    toggled: r,
    onClick: a,
    onKeyDown: ({
      code: h
    }) => h === "Enter" && p()
  }, l), [!0, !1].includes(r) && /* @__PURE__ */ zk.default.createElement(H6, _x({
    toggled: r
  }, s)), t);
}
dz.propTypes = {
  toggled: Im.default.bool,
  disabled: Im.default.bool,
  onClick: Im.default.func,
  title: Im.default.string,
  toggleIndicatorProps: Im.default.object,
  disableHoverAnimation: Im.default.bool
};
var kD = {};
Object.defineProperty(kD, "__esModule", {
  value: !0
});
var $E = kD.Icon = void 0, Y6 = vz(Wt), W0 = vz(V.exports), ID = X6(Ay);
const q6 = ["className"];
function pz(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap();
  return (pz = function(r) {
    return r ? n : t;
  })(e);
}
function X6(e, t) {
  if (!t && e && e.__esModule)
    return e;
  if (e === null || typeof e != "object" && typeof e != "function")
    return { default: e };
  var n = pz(t);
  if (n && n.has(e))
    return n.get(e);
  var r = {}, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var s in e)
    if (s !== "default" && Object.prototype.hasOwnProperty.call(e, s)) {
      var l = a ? Object.getOwnPropertyDescriptor(e, s) : null;
      l && (l.get || l.set) ? Object.defineProperty(r, s, l) : r[s] = e[s];
    }
  return r.default = e, n && n.set(e, r), r;
}
function vz(e) {
  return e && e.__esModule ? e : { default: e };
}
function fO() {
  return fO = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, fO.apply(this, arguments);
}
function K6(e, t) {
  if (e == null)
    return {};
  var n = Q6(e, t), r, a;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (a = 0; a < s.length; a++)
      r = s[a], !(t.indexOf(r) >= 0) && (!Object.prototype.propertyIsEnumerable.call(e, r) || (n[r] = e[r]));
  }
  return n;
}
function Q6(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), a, s;
  for (s = 0; s < r.length; s++)
    a = r[s], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
const Z6 = (0, ID.css)`
    position: relative;
    display: inline-block;
    border: 0;
    font-size: ${({
  size: e
}) => {
  switch (e) {
    case "md":
      return "32px;";
    case "sm":
      return "16px;";
    default:
      return e;
  }
}};
    color: ${({
  color: e
}) => e};
    fill: ${({
  color: e
}) => e};
`, J6 = (0, ID.css)`
    position: absolute;
    top: 0;
    right: -8px;

    padding: 1px;
    color: var(--bg-color);
    background-color: ${({
  color: e
}) => e || "var(--text-primary-color)"};
    
    border-radius: 50%;
    border: 2px solid var(--bg-color);
`, eY = ID.default.i`
    ${Z6};
    ${({
  badge: e
}) => e && J6};
`, LD = (e) => {
  let {
    className: t = ""
  } = e, n = K6(e, q6);
  const r = "icon-" + n.icon, a = `${r} ${t}`;
  return /* @__PURE__ */ Y6.default.createElement(eY, fO({
    className: a,
    role: "img",
    "aria-label": r
  }, n), n.children);
};
$E = kD.Icon = LD;
LD.defaultProps = {
  size: "md",
  badge: !1,
  className: ""
};
LD.propTypes = {
  icon: W0.default.string.isRequired,
  size: W0.default.string,
  className: W0.default.string,
  color: W0.default.string,
  badge: W0.default.bool
};
var BD = {};
Object.defineProperty(BD, "__esModule", {
  value: !0
});
var zD = BD.Button = void 0, RE = gz(V.exports), tY = gz(Wt), yb = iY(Ay), nY = hi;
const rY = ["disabled", "onClick", "children"];
function hz(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap();
  return (hz = function(r) {
    return r ? n : t;
  })(e);
}
function iY(e, t) {
  if (!t && e && e.__esModule)
    return e;
  if (e === null || typeof e != "object" && typeof e != "function")
    return { default: e };
  var n = hz(t);
  if (n && n.has(e))
    return n.get(e);
  var r = {}, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var s in e)
    if (s !== "default" && Object.prototype.hasOwnProperty.call(e, s)) {
      var l = a ? Object.getOwnPropertyDescriptor(e, s) : null;
      l && (l.get || l.set) ? Object.defineProperty(r, s, l) : r[s] = e[s];
    }
  return r.default = e, n && n.set(e, r), r;
}
function gz(e) {
  return e && e.__esModule ? e : { default: e };
}
function dO() {
  return dO = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, dO.apply(this, arguments);
}
function aY(e, t) {
  if (e == null)
    return {};
  var n = oY(e, t), r, a;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (a = 0; a < s.length; a++)
      r = s[a], !(t.indexOf(r) >= 0) && (!Object.prototype.propertyIsEnumerable.call(e, r) || (n[r] = e[r]));
  }
  return n;
}
function oY(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), a, s;
  for (s = 0; s < r.length; s++)
    a = r[s], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
var FD = /* @__PURE__ */ function(e) {
  return e.primary = "primary", e.secondary = "secondary", e;
}(FD || {});
const mz = (0, yb.css)`
    ${(e) => !e.disabled && (0, yb.css)`
        &.hover,
        &:hover {
            filter: brightness(90%);
        }

        &.active,
        &:active {
            filter: brightness(80%);
        }
    `}
`, sY = (0, yb.css)`
    color: white;
    background-color: var(--vcs-color--primary);
    border: 1px solid var(--vcs-color--primary-border);
    ${mz}
`, uY = (0, yb.css)`
    color: var(--btn-text-color);
    background-color: var(--btn-bg-color);
    border: 1px solid var(--btn-border-color);
    ${mz}
`, lY = yb.default.button.attrs((e) => ({
  type: e.type || "button"
}))`
    display: inline-flex;
    align-items: center;
    justify-content: center;

    position: relative;
    background: transparent;
    transition: all 0.4s ease;

    padding: 0 16px;
    line-height: 32px;
    /* min-width: 140px; // Dialog only. 100 on secondary buttons */

    border-radius: 2px;
    font-size: 14px;
    text-align: center;
    text-transform: uppercase;

    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;

    ${(e) => e.variant === FD.primary ? sY : uY}
    ${(e) => e.disabled && nY.disabled}

    :hover {
        cursor: pointer;
    }
`, $D = (e) => {
  let {
    disabled: t,
    onClick: n,
    children: r
  } = e, a = aY(e, rY);
  const s = () => !t && n();
  return /* @__PURE__ */ tY.default.createElement(lY, dO({
    disabled: t,
    "aria-disabled": t,
    onClick: n,
    onKeyDown: ({
      code: l
    }) => l === "Enter" && s()
  }, a), r);
};
zD = BD.Button = $D;
$D.propTypes = {
  children: RE.default.node,
  disabled: RE.default.bool,
  onClick: RE.default.func,
  variant: RE.default.oneOf(["primary", "secondary"])
};
$D.defaultProps = {
  disabled: !1,
  variant: FD.primary,
  onClick: console.log
};
var UD = {};
function st() {
  return st = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, st.apply(this, arguments);
}
function Ir(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), a, s;
  for (s = 0; s < r.length; s++)
    a = r[s], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
var VD = { exports: {} }, gr = {};
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var $k;
function cY() {
  if ($k)
    return gr;
  $k = 1;
  var e = 60103, t = 60106, n = 60107, r = 60108, a = 60114, s = 60109, l = 60110, p = 60112, h = 60113, y = 60120, b = 60115, E = 60116, x = 60121, C = 60122, T = 60117, O = 60129, D = 60131;
  if (typeof Symbol == "function" && Symbol.for) {
    var A = Symbol.for;
    e = A("react.element"), t = A("react.portal"), n = A("react.fragment"), r = A("react.strict_mode"), a = A("react.profiler"), s = A("react.provider"), l = A("react.context"), p = A("react.forward_ref"), h = A("react.suspense"), y = A("react.suspense_list"), b = A("react.memo"), E = A("react.lazy"), x = A("react.block"), C = A("react.server.block"), T = A("react.fundamental"), O = A("react.debug_trace_mode"), D = A("react.legacy_hidden");
  }
  function B(Z) {
    if (typeof Z == "object" && Z !== null) {
      var se = Z.$$typeof;
      switch (se) {
        case e:
          switch (Z = Z.type, Z) {
            case n:
            case a:
            case r:
            case h:
            case y:
              return Z;
            default:
              switch (Z = Z && Z.$$typeof, Z) {
                case l:
                case p:
                case E:
                case b:
                case s:
                  return Z;
                default:
                  return se;
              }
          }
        case t:
          return se;
      }
    }
  }
  var I = s, L = e, k = p, $ = n, U = E, K = b, X = t, Y = a, J = r, Q = h;
  return gr.ContextConsumer = l, gr.ContextProvider = I, gr.Element = L, gr.ForwardRef = k, gr.Fragment = $, gr.Lazy = U, gr.Memo = K, gr.Portal = X, gr.Profiler = Y, gr.StrictMode = J, gr.Suspense = Q, gr.isAsyncMode = function() {
    return !1;
  }, gr.isConcurrentMode = function() {
    return !1;
  }, gr.isContextConsumer = function(Z) {
    return B(Z) === l;
  }, gr.isContextProvider = function(Z) {
    return B(Z) === s;
  }, gr.isElement = function(Z) {
    return typeof Z == "object" && Z !== null && Z.$$typeof === e;
  }, gr.isForwardRef = function(Z) {
    return B(Z) === p;
  }, gr.isFragment = function(Z) {
    return B(Z) === n;
  }, gr.isLazy = function(Z) {
    return B(Z) === E;
  }, gr.isMemo = function(Z) {
    return B(Z) === b;
  }, gr.isPortal = function(Z) {
    return B(Z) === t;
  }, gr.isProfiler = function(Z) {
    return B(Z) === a;
  }, gr.isStrictMode = function(Z) {
    return B(Z) === r;
  }, gr.isSuspense = function(Z) {
    return B(Z) === h;
  }, gr.isValidElementType = function(Z) {
    return typeof Z == "string" || typeof Z == "function" || Z === n || Z === a || Z === O || Z === r || Z === h || Z === y || Z === D || typeof Z == "object" && Z !== null && (Z.$$typeof === E || Z.$$typeof === b || Z.$$typeof === s || Z.$$typeof === l || Z.$$typeof === p || Z.$$typeof === T || Z.$$typeof === x || Z[0] === C);
  }, gr.typeOf = B, gr;
}
var mr = {};
/** @license React v17.0.2
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Uk;
function fY() {
  return Uk || (Uk = 1, process.env.NODE_ENV !== "production" && function() {
    var e = 60103, t = 60106, n = 60107, r = 60108, a = 60114, s = 60109, l = 60110, p = 60112, h = 60113, y = 60120, b = 60115, E = 60116, x = 60121, C = 60122, T = 60117, O = 60129, D = 60131;
    if (typeof Symbol == "function" && Symbol.for) {
      var A = Symbol.for;
      e = A("react.element"), t = A("react.portal"), n = A("react.fragment"), r = A("react.strict_mode"), a = A("react.profiler"), s = A("react.provider"), l = A("react.context"), p = A("react.forward_ref"), h = A("react.suspense"), y = A("react.suspense_list"), b = A("react.memo"), E = A("react.lazy"), x = A("react.block"), C = A("react.server.block"), T = A("react.fundamental"), A("react.scope"), A("react.opaque.id"), O = A("react.debug_trace_mode"), A("react.offscreen"), D = A("react.legacy_hidden");
    }
    var B = !1;
    function I(xe) {
      return !!(typeof xe == "string" || typeof xe == "function" || xe === n || xe === a || xe === O || xe === r || xe === h || xe === y || xe === D || B || typeof xe == "object" && xe !== null && (xe.$$typeof === E || xe.$$typeof === b || xe.$$typeof === s || xe.$$typeof === l || xe.$$typeof === p || xe.$$typeof === T || xe.$$typeof === x || xe[0] === C));
    }
    function L(xe) {
      if (typeof xe == "object" && xe !== null) {
        var oe = xe.$$typeof;
        switch (oe) {
          case e:
            var it = xe.type;
            switch (it) {
              case n:
              case a:
              case r:
              case h:
              case y:
                return it;
              default:
                var Le = it && it.$$typeof;
                switch (Le) {
                  case l:
                  case p:
                  case E:
                  case b:
                  case s:
                    return Le;
                  default:
                    return oe;
                }
            }
          case t:
            return oe;
        }
      }
    }
    var k = l, $ = s, U = e, K = p, X = n, Y = E, J = b, Q = t, Z = a, se = r, pe = h, be = !1, _e = !1;
    function Se(xe) {
      return be || (be = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function Oe(xe) {
      return _e || (_e = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function re(xe) {
      return L(xe) === l;
    }
    function ie(xe) {
      return L(xe) === s;
    }
    function ce(xe) {
      return typeof xe == "object" && xe !== null && xe.$$typeof === e;
    }
    function le(xe) {
      return L(xe) === p;
    }
    function fe(xe) {
      return L(xe) === n;
    }
    function ve(xe) {
      return L(xe) === E;
    }
    function ee(xe) {
      return L(xe) === b;
    }
    function Ae(xe) {
      return L(xe) === t;
    }
    function he(xe) {
      return L(xe) === a;
    }
    function Fe(xe) {
      return L(xe) === r;
    }
    function Ne(xe) {
      return L(xe) === h;
    }
    mr.ContextConsumer = k, mr.ContextProvider = $, mr.Element = U, mr.ForwardRef = K, mr.Fragment = X, mr.Lazy = Y, mr.Memo = J, mr.Portal = Q, mr.Profiler = Z, mr.StrictMode = se, mr.Suspense = pe, mr.isAsyncMode = Se, mr.isConcurrentMode = Oe, mr.isContextConsumer = re, mr.isContextProvider = ie, mr.isElement = ce, mr.isForwardRef = le, mr.isFragment = fe, mr.isLazy = ve, mr.isMemo = ee, mr.isPortal = Ae, mr.isProfiler = he, mr.isStrictMode = Fe, mr.isSuspense = Ne, mr.isValidElementType = I, mr.typeOf = L;
  }()), mr;
}
(function(e) {
  process.env.NODE_ENV === "production" ? e.exports = cY() : e.exports = fY();
})(VD);
function yz(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number")
    r += e;
  else if (typeof e == "object")
    if (Array.isArray(e))
      for (t = 0; t < e.length; t++)
        e[t] && (n = yz(e[t])) && (r && (r += " "), r += n);
    else
      for (t in e)
        e[t] && (r && (r += " "), r += t);
  return r;
}
function ba() {
  for (var e, t, n = 0, r = ""; n < arguments.length; )
    (e = arguments[n++]) && (t = yz(e)) && (r && (r += " "), r += t);
  return r;
}
function Zx(e) {
  return typeof e == "string";
}
function qb(e, t) {
  return process.env.NODE_ENV === "production" ? () => null : function(...r) {
    return e(...r) || t(...r);
  };
}
function jm(e) {
  return e !== null && typeof e == "object" && e.constructor === Object;
}
function bz(e) {
  if (!jm(e))
    return e;
  const t = {};
  return Object.keys(e).forEach((n) => {
    t[n] = bz(e[n]);
  }), t;
}
function md(e, t, n = {
  clone: !0
}) {
  const r = n.clone ? st({}, e) : e;
  return jm(e) && jm(t) && Object.keys(t).forEach((a) => {
    a !== "__proto__" && (jm(t[a]) && a in e && jm(e[a]) ? r[a] = md(e[a], t[a], n) : n.clone ? r[a] = jm(t[a]) ? bz(t[a]) : t[a] : r[a] = t[a]);
  }), r;
}
function dY(e) {
  const {
    prototype: t = {}
  } = e;
  return Boolean(t.isReactComponent);
}
function _z(e, t, n, r, a) {
  const s = e[t], l = a || t;
  if (s == null || typeof window > "u")
    return null;
  let p;
  const h = s.type;
  return typeof h == "function" && !dY(h) && (p = "Did you accidentally use a plain function component for an element instead?"), p !== void 0 ? new Error(`Invalid ${r} \`${l}\` supplied to \`${n}\`. Expected an element that can hold a ref. ${p} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const Ez = qb(V.exports.element, _z);
Ez.isRequired = qb(V.exports.element.isRequired, _z);
const Xb = Ez;
function pY(e) {
  const {
    prototype: t = {}
  } = e;
  return Boolean(t.isReactComponent);
}
function vY(e, t, n, r, a) {
  const s = e[t], l = a || t;
  if (s == null || typeof window > "u")
    return null;
  let p;
  return typeof s == "function" && !pY(s) && (p = "Did you accidentally provide a plain function component instead?"), p !== void 0 ? new Error(`Invalid ${r} \`${l}\` supplied to \`${n}\`. Expected an element type that can hold a ref. ${p} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const xz = qb(V.exports.elementType, vY), hY = "exact-prop: \u200B";
function Sz(e) {
  return process.env.NODE_ENV === "production" ? e : st({}, e, {
    [hY]: (t) => {
      const n = Object.keys(t).filter((r) => !e.hasOwnProperty(r));
      return n.length > 0 ? new Error(`The following props are not supported: ${n.map((r) => `\`${r}\``).join(", ")}. Please remove them.`) : null;
    }
  });
}
function bb(e) {
  let t = "https://mui.com/production-error/?code=" + e;
  for (let n = 1; n < arguments.length; n += 1)
    t += "&args[]=" + encodeURIComponent(arguments[n]);
  return "Minified MUI error #" + e + "; visit " + t + " for the full message.";
}
const gY = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function mY(e) {
  const t = `${e}`.match(gY);
  return t && t[1] || "";
}
function wz(e, t = "") {
  return e.displayName || e.name || mY(e) || t;
}
function Vk(e, t, n) {
  const r = wz(t);
  return e.displayName || (r !== "" ? `${n}(${r})` : n);
}
function yY(e) {
  if (e != null) {
    if (typeof e == "string")
      return e;
    if (typeof e == "function")
      return wz(e, "Component");
    if (typeof e == "object")
      switch (e.$$typeof) {
        case sy.exports.ForwardRef:
          return Vk(e, e.render, "ForwardRef");
        case sy.exports.Memo:
          return Vk(e, e.type, "memo");
        default:
          return;
      }
  }
}
function Ey(e, t, n, r, a) {
  if (process.env.NODE_ENV === "production")
    return null;
  const s = e[t], l = a || t;
  return s == null ? null : s && s.nodeType !== 1 ? new Error(`Invalid ${r} \`${l}\` supplied to \`${n}\`. Expected an HTMLElement.`) : null;
}
const bY = V.exports.oneOfType([V.exports.func, V.exports.object]), Cz = bY;
function ob(e) {
  if (typeof e != "string")
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `capitalize(string)` expects a string argument." : bb(7));
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function jk(...e) {
  return e.reduce((t, n) => n == null ? t : function(...a) {
    t.apply(this, a), n.apply(this, a);
  }, () => {
  });
}
function _Y(e, t = 166) {
  let n;
  function r(...a) {
    const s = () => {
      e.apply(this, a);
    };
    clearTimeout(n), n = setTimeout(s, t);
  }
  return r.clear = () => {
    clearTimeout(n);
  }, r;
}
function rc(e) {
  return e && e.ownerDocument || document;
}
function _b(e) {
  return rc(e).defaultView || window;
}
function pO(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
const EY = typeof window < "u" ? Ze.useLayoutEffect : Ze.useEffect, Eb = EY;
function Zm(e) {
  const t = Ze.useRef(e);
  return Eb(() => {
    t.current = e;
  }), Ze.useCallback((...n) => (0, t.current)(...n), []);
}
function eu(...e) {
  return Ze.useMemo(() => e.every((t) => t == null) ? null : (t) => {
    e.forEach((n) => {
      pO(n, t);
    });
  }, e);
}
let Jx = !0, vO = !1, Wk;
const xY = {
  text: !0,
  search: !0,
  url: !0,
  tel: !0,
  email: !0,
  password: !0,
  number: !0,
  date: !0,
  month: !0,
  week: !0,
  time: !0,
  datetime: !0,
  "datetime-local": !0
};
function SY(e) {
  const {
    type: t,
    tagName: n
  } = e;
  return !!(n === "INPUT" && xY[t] && !e.readOnly || n === "TEXTAREA" && !e.readOnly || e.isContentEditable);
}
function wY(e) {
  e.metaKey || e.altKey || e.ctrlKey || (Jx = !0);
}
function iT() {
  Jx = !1;
}
function CY() {
  this.visibilityState === "hidden" && vO && (Jx = !0);
}
function RY(e) {
  e.addEventListener("keydown", wY, !0), e.addEventListener("mousedown", iT, !0), e.addEventListener("pointerdown", iT, !0), e.addEventListener("touchstart", iT, !0), e.addEventListener("visibilitychange", CY, !0);
}
function TY(e) {
  const {
    target: t
  } = e;
  try {
    return t.matches(":focus-visible");
  } catch {
  }
  return Jx || SY(t);
}
function OY() {
  const e = Ze.useCallback((a) => {
    a != null && RY(a.ownerDocument);
  }, []), t = Ze.useRef(!1);
  function n() {
    return t.current ? (vO = !0, window.clearTimeout(Wk), Wk = window.setTimeout(() => {
      vO = !1;
    }, 100), t.current = !1, !0) : !1;
  }
  function r(a) {
    return TY(a) ? (t.current = !0, !0) : !1;
  }
  return {
    isFocusVisibleRef: t,
    onFocus: r,
    onBlur: n,
    ref: e
  };
}
function Rz(e) {
  const t = e.documentElement.clientWidth;
  return Math.abs(window.innerWidth - t);
}
function DY(e) {
  const t = typeof e;
  switch (t) {
    case "number":
      return Number.isNaN(e) ? "NaN" : Number.isFinite(e) ? e !== Math.floor(e) ? "float" : "number" : "Infinity";
    case "object":
      return e === null ? "null" : e.constructor.name;
    default:
      return t;
  }
}
function MY(e) {
  return typeof e == "number" && isFinite(e) && Math.floor(e) === e;
}
const AY = Number.isInteger || MY;
function Tz(e, t, n, r) {
  const a = e[t];
  if (a == null || !AY(a)) {
    const s = DY(a);
    return new RangeError(`Invalid ${r} \`${t}\` of type \`${s}\` supplied to \`${n}\`, expected \`integer\`.`);
  }
  return null;
}
function Oz(e, t, ...n) {
  return e[t] === void 0 ? null : Tz(e, t, ...n);
}
function hO() {
  return null;
}
Oz.isRequired = Tz;
hO.isRequired = hO;
const Dz = process.env.NODE_ENV === "production" ? hO : Oz;
function Mz(e, t) {
  const n = st({}, t);
  return Object.keys(e).forEach((r) => {
    if (r.toString().match(/^(components|slots)$/))
      n[r] = st({}, e[r], n[r]);
    else if (r.toString().match(/^(componentsProps|slotProps)$/)) {
      const a = e[r] || {}, s = t[r];
      n[r] = {}, !s || !Object.keys(s) ? n[r] = a : !a || !Object.keys(a) ? n[r] = s : (n[r] = st({}, s), Object.keys(a).forEach((l) => {
        n[r][l] = Mz(a[l], s[l]);
      }));
    } else
      n[r] === void 0 && (n[r] = e[r]);
  }), n;
}
function rv(e, t, n) {
  const r = {};
  return Object.keys(e).forEach(
    (a) => {
      r[a] = e[a].reduce((s, l) => (l && (n && n[l] && s.push(n[l]), s.push(t(l))), s), []).join(" ");
    }
  ), r;
}
const Gk = (e) => e, PY = () => {
  let e = Gk;
  return {
    configure(t) {
      e = t;
    },
    generate(t) {
      return e(t);
    },
    reset() {
      e = Gk;
    }
  };
}, NY = PY(), kY = NY, IY = {
  active: "Mui-active",
  checked: "Mui-checked",
  completed: "Mui-completed",
  disabled: "Mui-disabled",
  error: "Mui-error",
  expanded: "Mui-expanded",
  focused: "Mui-focused",
  focusVisible: "Mui-focusVisible",
  required: "Mui-required",
  selected: "Mui-selected"
};
function rf(e, t) {
  return IY[t] || `${kY.generate(e)}-${t}`;
}
function rl(e, t) {
  const n = {};
  return t.forEach((r) => {
    n[r] = rf(e, r);
  }), n;
}
function LY(e) {
  return rf("MuiBackdrop", e);
}
rl("MuiBackdrop", ["root", "invisible"]);
const BY = ["classes", "className", "invisible", "component", "components", "componentsProps", "theme"], zY = (e) => {
  const {
    classes: t,
    invisible: n
  } = e;
  return rv({
    root: ["root", n && "invisible"]
  }, LY, t);
}, Az = /* @__PURE__ */ Ze.forwardRef(function(t, n) {
  const {
    classes: r,
    className: a,
    invisible: s = !1,
    component: l = "div",
    components: p = {},
    componentsProps: h = {},
    theme: y
  } = t, b = Ir(t, BY), E = st({}, t, {
    classes: r,
    invisible: s
  }), x = zY(E), C = p.Root || l, T = h.root || {};
  return /* @__PURE__ */ He(C, st({
    "aria-hidden": !0
  }, T, !Zx(C) && {
    as: l,
    ownerState: st({}, E, T.ownerState),
    theme: y
  }, {
    ref: n
  }, b, {
    className: ba(x.root, T.className, a)
  }));
});
process.env.NODE_ENV !== "production" && (Az.propTypes = {
  children: V.exports.node,
  classes: V.exports.object,
  className: V.exports.string,
  component: V.exports.elementType,
  components: V.exports.shape({
    Root: V.exports.elementType
  }),
  componentsProps: V.exports.shape({
    root: V.exports.object
  }),
  invisible: V.exports.bool
});
const FY = Az;
function $Y(e) {
  return typeof e == "function" ? e() : e;
}
const Ex = /* @__PURE__ */ Ze.forwardRef(function(t, n) {
  const {
    children: r,
    container: a,
    disablePortal: s = !1
  } = t, [l, p] = Ze.useState(null), h = eu(/* @__PURE__ */ Ze.isValidElement(r) ? r.ref : null, n);
  return Eb(() => {
    s || p($Y(a) || document.body);
  }, [a, s]), Eb(() => {
    if (l && !s)
      return pO(n, l), () => {
        pO(n, null);
      };
  }, [n, l, s]), s ? /* @__PURE__ */ Ze.isValidElement(r) ? /* @__PURE__ */ Ze.cloneElement(r, {
    ref: h
  }) : r : l && /* @__PURE__ */ Bx.exports.createPortal(r, l);
});
process.env.NODE_ENV !== "production" && (Ex.propTypes = {
  children: V.exports.node,
  container: V.exports.oneOfType([Ey, V.exports.func]),
  disablePortal: V.exports.bool
});
process.env.NODE_ENV !== "production" && (Ex["propTypes"] = Sz(Ex.propTypes));
const UY = Ex;
function VY(e) {
  const t = rc(e);
  return t.body === e ? _b(e).innerWidth > t.documentElement.clientWidth : e.scrollHeight > e.clientHeight;
}
function sb(e, t) {
  t ? e.setAttribute("aria-hidden", "true") : e.removeAttribute("aria-hidden");
}
function Hk(e) {
  return parseInt(_b(e).getComputedStyle(e).paddingRight, 10) || 0;
}
function Yk(e, t, n, r = [], a) {
  const s = [t, n, ...r], l = ["TEMPLATE", "SCRIPT", "STYLE"];
  [].forEach.call(e.children, (p) => {
    s.indexOf(p) === -1 && l.indexOf(p.tagName) === -1 && sb(p, a);
  });
}
function aT(e, t) {
  let n = -1;
  return e.some((r, a) => t(r) ? (n = a, !0) : !1), n;
}
function jY(e, t) {
  const n = [], r = e.container;
  if (!t.disableScrollLock) {
    if (VY(r)) {
      const h = Rz(rc(r));
      n.push({
        value: r.style.paddingRight,
        property: "padding-right",
        el: r
      }), r.style.paddingRight = `${Hk(r) + h}px`;
      const y = rc(r).querySelectorAll(".mui-fixed");
      [].forEach.call(y, (b) => {
        n.push({
          value: b.style.paddingRight,
          property: "padding-right",
          el: b
        }), b.style.paddingRight = `${Hk(b) + h}px`;
      });
    }
    const s = r.parentElement, l = _b(r), p = (s == null ? void 0 : s.nodeName) === "HTML" && l.getComputedStyle(s).overflowY === "scroll" ? s : r;
    n.push({
      value: p.style.overflow,
      property: "overflow",
      el: p
    }, {
      value: p.style.overflowX,
      property: "overflow-x",
      el: p
    }, {
      value: p.style.overflowY,
      property: "overflow-y",
      el: p
    }), p.style.overflow = "hidden";
  }
  return () => {
    n.forEach(({
      value: s,
      el: l,
      property: p
    }) => {
      s ? l.style.setProperty(p, s) : l.style.removeProperty(p);
    });
  };
}
function WY(e) {
  const t = [];
  return [].forEach.call(e.children, (n) => {
    n.getAttribute("aria-hidden") === "true" && t.push(n);
  }), t;
}
class GY {
  constructor() {
    this.containers = void 0, this.modals = void 0, this.modals = [], this.containers = [];
  }
  add(t, n) {
    let r = this.modals.indexOf(t);
    if (r !== -1)
      return r;
    r = this.modals.length, this.modals.push(t), t.modalRef && sb(t.modalRef, !1);
    const a = WY(n);
    Yk(n, t.mount, t.modalRef, a, !0);
    const s = aT(this.containers, (l) => l.container === n);
    return s !== -1 ? (this.containers[s].modals.push(t), r) : (this.containers.push({
      modals: [t],
      container: n,
      restore: null,
      hiddenSiblings: a
    }), r);
  }
  mount(t, n) {
    const r = aT(this.containers, (s) => s.modals.indexOf(t) !== -1), a = this.containers[r];
    a.restore || (a.restore = jY(a, n));
  }
  remove(t) {
    const n = this.modals.indexOf(t);
    if (n === -1)
      return n;
    const r = aT(this.containers, (s) => s.modals.indexOf(t) !== -1), a = this.containers[r];
    if (a.modals.splice(a.modals.indexOf(t), 1), this.modals.splice(n, 1), a.modals.length === 0)
      a.restore && a.restore(), t.modalRef && sb(t.modalRef, !0), Yk(a.container, t.mount, t.modalRef, a.hiddenSiblings, !1), this.containers.splice(r, 1);
    else {
      const s = a.modals[a.modals.length - 1];
      s.modalRef && sb(s.modalRef, !1);
    }
    return n;
  }
  isTopModal(t) {
    return this.modals.length > 0 && this.modals[this.modals.length - 1] === t;
  }
}
const HY = ["input", "select", "textarea", "a[href]", "button", "[tabindex]", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])'].join(",");
function YY(e) {
  const t = parseInt(e.getAttribute("tabindex"), 10);
  return Number.isNaN(t) ? e.contentEditable === "true" || (e.nodeName === "AUDIO" || e.nodeName === "VIDEO" || e.nodeName === "DETAILS") && e.getAttribute("tabindex") === null ? 0 : e.tabIndex : t;
}
function qY(e) {
  if (e.tagName !== "INPUT" || e.type !== "radio" || !e.name)
    return !1;
  const t = (r) => e.ownerDocument.querySelector(`input[type="radio"]${r}`);
  let n = t(`[name="${e.name}"]:checked`);
  return n || (n = t(`[name="${e.name}"]`)), n !== e;
}
function XY(e) {
  return !(e.disabled || e.tagName === "INPUT" && e.type === "hidden" || qY(e));
}
function KY(e) {
  const t = [], n = [];
  return Array.from(e.querySelectorAll(HY)).forEach((r, a) => {
    const s = YY(r);
    s === -1 || !XY(r) || (s === 0 ? t.push(r) : n.push({
      documentOrder: a,
      tabIndex: s,
      node: r
    }));
  }), n.sort((r, a) => r.tabIndex === a.tabIndex ? r.documentOrder - a.documentOrder : r.tabIndex - a.tabIndex).map((r) => r.node).concat(t);
}
function QY() {
  return !0;
}
function xx(e) {
  const {
    children: t,
    disableAutoFocus: n = !1,
    disableEnforceFocus: r = !1,
    disableRestoreFocus: a = !1,
    getTabbable: s = KY,
    isEnabled: l = QY,
    open: p
  } = e, h = Ze.useRef(), y = Ze.useRef(null), b = Ze.useRef(null), E = Ze.useRef(null), x = Ze.useRef(null), C = Ze.useRef(!1), T = Ze.useRef(null), O = eu(t.ref, T), D = Ze.useRef(null);
  Ze.useEffect(() => {
    !p || !T.current || (C.current = !n);
  }, [n, p]), Ze.useEffect(() => {
    if (!p || !T.current)
      return;
    const I = rc(T.current);
    return T.current.contains(I.activeElement) || (T.current.hasAttribute("tabIndex") || (process.env.NODE_ENV !== "production" && console.error(["MUI: The modal content node does not accept focus.", 'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".'].join(`
`)), T.current.setAttribute("tabIndex", -1)), C.current && T.current.focus()), () => {
      a || (E.current && E.current.focus && (h.current = !0, E.current.focus()), E.current = null);
    };
  }, [p]), Ze.useEffect(() => {
    if (!p || !T.current)
      return;
    const I = rc(T.current), L = (U) => {
      const {
        current: K
      } = T;
      if (K !== null) {
        if (!I.hasFocus() || r || !l() || h.current) {
          h.current = !1;
          return;
        }
        if (!K.contains(I.activeElement)) {
          if (U && x.current !== U.target || I.activeElement !== x.current)
            x.current = null;
          else if (x.current !== null)
            return;
          if (!C.current)
            return;
          let J = [];
          if ((I.activeElement === y.current || I.activeElement === b.current) && (J = s(T.current)), J.length > 0) {
            var X, Y;
            const Q = Boolean(((X = D.current) == null ? void 0 : X.shiftKey) && ((Y = D.current) == null ? void 0 : Y.key) === "Tab"), Z = J[0], se = J[J.length - 1];
            Q ? se.focus() : Z.focus();
          } else
            K.focus();
        }
      }
    }, k = (U) => {
      D.current = U, !(r || !l() || U.key !== "Tab") && I.activeElement === T.current && U.shiftKey && (h.current = !0, b.current.focus());
    };
    I.addEventListener("focusin", L), I.addEventListener("keydown", k, !0);
    const $ = setInterval(() => {
      I.activeElement.tagName === "BODY" && L();
    }, 50);
    return () => {
      clearInterval($), I.removeEventListener("focusin", L), I.removeEventListener("keydown", k, !0);
    };
  }, [n, r, a, l, p, s]);
  const A = (I) => {
    E.current === null && (E.current = I.relatedTarget), C.current = !0, x.current = I.target;
    const L = t.props.onFocus;
    L && L(I);
  }, B = (I) => {
    E.current === null && (E.current = I.relatedTarget), C.current = !0;
  };
  return /* @__PURE__ */ qi(Ze.Fragment, {
    children: [/* @__PURE__ */ He("div", {
      tabIndex: 0,
      onFocus: B,
      ref: y,
      "data-test": "sentinelStart"
    }), /* @__PURE__ */ Ze.cloneElement(t, {
      ref: O,
      onFocus: A
    }), /* @__PURE__ */ He("div", {
      tabIndex: 0,
      onFocus: B,
      ref: b,
      "data-test": "sentinelEnd"
    })]
  });
}
process.env.NODE_ENV !== "production" && (xx.propTypes = {
  children: Xb,
  disableAutoFocus: V.exports.bool,
  disableEnforceFocus: V.exports.bool,
  disableRestoreFocus: V.exports.bool,
  getTabbable: V.exports.func,
  isEnabled: V.exports.func,
  open: V.exports.bool.isRequired
});
process.env.NODE_ENV !== "production" && (xx["propTypes"] = Sz(xx.propTypes));
function ZY(e) {
  return rf("MuiModal", e);
}
rl("MuiModal", ["root", "hidden"]);
const JY = ["BackdropComponent", "BackdropProps", "children", "classes", "className", "closeAfterTransition", "component", "components", "componentsProps", "container", "disableAutoFocus", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "manager", "onBackdropClick", "onClose", "onKeyDown", "open", "theme", "onTransitionEnter", "onTransitionExited"], e8 = (e) => {
  const {
    open: t,
    exited: n,
    classes: r
  } = e;
  return rv({
    root: ["root", !t && n && "hidden"]
  }, ZY, r);
};
function t8(e) {
  return typeof e == "function" ? e() : e;
}
function n8(e) {
  return e.children ? e.children.props.hasOwnProperty("in") : !1;
}
const r8 = new GY(), Pz = /* @__PURE__ */ Ze.forwardRef(function(t, n) {
  const {
    BackdropComponent: r,
    BackdropProps: a,
    children: s,
    classes: l,
    className: p,
    closeAfterTransition: h = !1,
    component: y = "div",
    components: b = {},
    componentsProps: E = {},
    container: x,
    disableAutoFocus: C = !1,
    disableEnforceFocus: T = !1,
    disableEscapeKeyDown: O = !1,
    disablePortal: D = !1,
    disableRestoreFocus: A = !1,
    disableScrollLock: B = !1,
    hideBackdrop: I = !1,
    keepMounted: L = !1,
    manager: k = r8,
    onBackdropClick: $,
    onClose: U,
    onKeyDown: K,
    open: X,
    theme: Y,
    onTransitionEnter: J,
    onTransitionExited: Q
  } = t, Z = Ir(t, JY), [se, pe] = Ze.useState(!0), be = Ze.useRef({}), _e = Ze.useRef(null), Se = Ze.useRef(null), Oe = eu(Se, n), re = n8(t), ie = () => rc(_e.current), ce = () => (be.current.modalRef = Se.current, be.current.mountNode = _e.current, be.current), le = () => {
    k.mount(ce(), {
      disableScrollLock: B
    }), Se.current.scrollTop = 0;
  }, fe = Zm(() => {
    const Qe = t8(x) || ie().body;
    k.add(ce(), Qe), Se.current && le();
  }), ve = Ze.useCallback(() => k.isTopModal(ce()), [k]), ee = Zm((Qe) => {
    _e.current = Qe, Qe && (X && ve() ? le() : sb(Se.current, !0));
  }), Ae = Ze.useCallback(() => {
    k.remove(ce());
  }, [k]);
  Ze.useEffect(() => () => {
    Ae();
  }, [Ae]), Ze.useEffect(() => {
    X ? fe() : (!re || !h) && Ae();
  }, [X, Ae, re, h, fe]);
  const he = st({}, t, {
    classes: l,
    closeAfterTransition: h,
    disableAutoFocus: C,
    disableEnforceFocus: T,
    disableEscapeKeyDown: O,
    disablePortal: D,
    disableRestoreFocus: A,
    disableScrollLock: B,
    exited: se,
    hideBackdrop: I,
    keepMounted: L
  }), Fe = e8(he);
  if (!L && !X && (!re || se))
    return null;
  const Ne = () => {
    pe(!1), J && J();
  }, xe = () => {
    pe(!0), Q && Q(), h && Ae();
  }, oe = (Qe) => {
    Qe.target === Qe.currentTarget && ($ && $(Qe), U && U(Qe, "backdropClick"));
  }, it = (Qe) => {
    K && K(Qe), !(Qe.key !== "Escape" || !ve()) && (O || (Qe.stopPropagation(), U && U(Qe, "escapeKeyDown")));
  }, Le = {};
  s.props.tabIndex === void 0 && (Le.tabIndex = "-1"), re && (Le.onEnter = jk(Ne, s.props.onEnter), Le.onExited = jk(xe, s.props.onExited));
  const qe = b.Root || y, Tt = E.root || {};
  return /* @__PURE__ */ He(UY, {
    ref: ee,
    container: x,
    disablePortal: D,
    children: /* @__PURE__ */ qi(qe, st({
      role: "presentation"
    }, Tt, !Zx(qe) && {
      as: y,
      ownerState: st({}, he, Tt.ownerState),
      theme: Y
    }, Z, {
      ref: Oe,
      onKeyDown: it,
      className: ba(Fe.root, Tt.className, p),
      children: [!I && r ? /* @__PURE__ */ He(r, st({
        open: X,
        onClick: oe
      }, a)) : null, /* @__PURE__ */ He(xx, {
        disableEnforceFocus: T,
        disableAutoFocus: C,
        disableRestoreFocus: A,
        isEnabled: ve,
        open: X,
        children: /* @__PURE__ */ Ze.cloneElement(s, Le)
      })]
    }))
  });
});
process.env.NODE_ENV !== "production" && (Pz.propTypes = {
  BackdropComponent: V.exports.elementType,
  BackdropProps: V.exports.object,
  children: Xb.isRequired,
  classes: V.exports.object,
  className: V.exports.string,
  closeAfterTransition: V.exports.bool,
  component: V.exports.elementType,
  components: V.exports.shape({
    Root: V.exports.elementType
  }),
  componentsProps: V.exports.shape({
    root: V.exports.object
  }),
  container: V.exports.oneOfType([Ey, V.exports.func]),
  disableAutoFocus: V.exports.bool,
  disableEnforceFocus: V.exports.bool,
  disableEscapeKeyDown: V.exports.bool,
  disablePortal: V.exports.bool,
  disableRestoreFocus: V.exports.bool,
  disableScrollLock: V.exports.bool,
  hideBackdrop: V.exports.bool,
  keepMounted: V.exports.bool,
  onBackdropClick: V.exports.func,
  onClose: V.exports.func,
  onKeyDown: V.exports.func,
  open: V.exports.bool.isRequired
});
const i8 = Pz;
function a8(e) {
  if (e.sheet)
    return e.sheet;
  for (var t = 0; t < document.styleSheets.length; t++)
    if (document.styleSheets[t].ownerNode === e)
      return document.styleSheets[t];
}
function o8(e) {
  var t = document.createElement("style");
  return t.setAttribute("data-emotion", e.key), e.nonce !== void 0 && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
}
var Nz = /* @__PURE__ */ function() {
  function e(n) {
    var r = this;
    this._insertTag = function(a) {
      var s;
      r.tags.length === 0 ? r.insertionPoint ? s = r.insertionPoint.nextSibling : r.prepend ? s = r.container.firstChild : s = r.before : s = r.tags[r.tags.length - 1].nextSibling, r.container.insertBefore(a, s), r.tags.push(a);
    }, this.isSpeedy = n.speedy === void 0 ? process.env.NODE_ENV === "production" : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var t = e.prototype;
  return t.hydrate = function(r) {
    r.forEach(this._insertTag);
  }, t.insert = function(r) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(o8(this));
    var a = this.tags[this.tags.length - 1];
    if (process.env.NODE_ENV !== "production") {
      var s = r.charCodeAt(0) === 64 && r.charCodeAt(1) === 105;
      s && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + r + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !s;
    }
    if (this.isSpeedy) {
      var l = a8(a);
      try {
        l.insertRule(r, l.cssRules.length);
      } catch (p) {
        process.env.NODE_ENV !== "production" && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(r) && console.error('There was a problem inserting the following rule: "' + r + '"', p);
      }
    } else
      a.appendChild(document.createTextNode(r));
    this.ctr++;
  }, t.flush = function() {
    this.tags.forEach(function(r) {
      return r.parentNode && r.parentNode.removeChild(r);
    }), this.tags = [], this.ctr = 0, process.env.NODE_ENV !== "production" && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, e;
}(), ao = "-ms-", Sx = "-moz-", tr = "-webkit-", jD = "comm", WD = "rule", GD = "decl", s8 = "@import", kz = "@keyframes", u8 = "@layer", l8 = Math.abs, eS = String.fromCharCode, c8 = Object.assign;
function f8(e, t) {
  return za(e, 0) ^ 45 ? (((t << 2 ^ za(e, 0)) << 2 ^ za(e, 1)) << 2 ^ za(e, 2)) << 2 ^ za(e, 3) : 0;
}
function Iz(e) {
  return e.trim();
}
function d8(e, t) {
  return (e = t.exec(e)) ? e[0] : e;
}
function nr(e, t, n) {
  return e.replace(t, n);
}
function gO(e, t) {
  return e.indexOf(t);
}
function za(e, t) {
  return e.charCodeAt(t) | 0;
}
function xb(e, t, n) {
  return e.slice(t, n);
}
function Kc(e) {
  return e.length;
}
function HD(e) {
  return e.length;
}
function TE(e, t) {
  return t.push(e), e;
}
function p8(e, t) {
  return e.map(t).join("");
}
var tS = 1, xy = 1, Lz = 0, as = 0, Fi = 0, Py = "";
function nS(e, t, n, r, a, s, l) {
  return { value: e, root: t, parent: n, type: r, props: a, children: s, line: tS, column: xy, length: l, return: "" };
}
function G0(e, t) {
  return c8(nS("", null, null, "", null, null, 0), e, { length: -e.length }, t);
}
function v8() {
  return Fi;
}
function h8() {
  return Fi = as > 0 ? za(Py, --as) : 0, xy--, Fi === 10 && (xy = 1, tS--), Fi;
}
function tu() {
  return Fi = as < Lz ? za(Py, as++) : 0, xy++, Fi === 10 && (xy = 1, tS++), Fi;
}
function ef() {
  return za(Py, as);
}
function UE() {
  return as;
}
function Kb(e, t) {
  return xb(Py, e, t);
}
function Sb(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function Bz(e) {
  return tS = xy = 1, Lz = Kc(Py = e), as = 0, [];
}
function zz(e) {
  return Py = "", e;
}
function VE(e) {
  return Iz(Kb(as - 1, mO(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function g8(e) {
  for (; (Fi = ef()) && Fi < 33; )
    tu();
  return Sb(e) > 2 || Sb(Fi) > 3 ? "" : " ";
}
function m8(e, t) {
  for (; --t && tu() && !(Fi < 48 || Fi > 102 || Fi > 57 && Fi < 65 || Fi > 70 && Fi < 97); )
    ;
  return Kb(e, UE() + (t < 6 && ef() == 32 && tu() == 32));
}
function mO(e) {
  for (; tu(); )
    switch (Fi) {
      case e:
        return as;
      case 34:
      case 39:
        e !== 34 && e !== 39 && mO(Fi);
        break;
      case 40:
        e === 41 && mO(e);
        break;
      case 92:
        tu();
        break;
    }
  return as;
}
function y8(e, t) {
  for (; tu() && e + Fi !== 47 + 10; )
    if (e + Fi === 42 + 42 && ef() === 47)
      break;
  return "/*" + Kb(t, as - 1) + "*" + eS(e === 47 ? e : tu());
}
function b8(e) {
  for (; !Sb(ef()); )
    tu();
  return Kb(e, as);
}
function _8(e) {
  return zz(jE("", null, null, null, [""], e = Bz(e), 0, [0], e));
}
function jE(e, t, n, r, a, s, l, p, h) {
  for (var y = 0, b = 0, E = l, x = 0, C = 0, T = 0, O = 1, D = 1, A = 1, B = 0, I = "", L = a, k = s, $ = r, U = I; D; )
    switch (T = B, B = tu()) {
      case 40:
        if (T != 108 && za(U, E - 1) == 58) {
          gO(U += nr(VE(B), "&", "&\f"), "&\f") != -1 && (A = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        U += VE(B);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        U += g8(T);
        break;
      case 92:
        U += m8(UE() - 1, 7);
        continue;
      case 47:
        switch (ef()) {
          case 42:
          case 47:
            TE(E8(y8(tu(), UE()), t, n), h);
            break;
          default:
            U += "/";
        }
        break;
      case 123 * O:
        p[y++] = Kc(U) * A;
      case 125 * O:
      case 59:
      case 0:
        switch (B) {
          case 0:
          case 125:
            D = 0;
          case 59 + b:
            A == -1 && (U = nr(U, /\f/g, "")), C > 0 && Kc(U) - E && TE(C > 32 ? Xk(U + ";", r, n, E - 1) : Xk(nr(U, " ", "") + ";", r, n, E - 2), h);
            break;
          case 59:
            U += ";";
          default:
            if (TE($ = qk(U, t, n, y, b, a, p, I, L = [], k = [], E), s), B === 123)
              if (b === 0)
                jE(U, t, $, $, L, s, E, p, k);
              else
                switch (x === 99 && za(U, 3) === 110 ? 100 : x) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    jE(e, $, $, r && TE(qk(e, $, $, 0, 0, a, p, I, a, L = [], E), k), a, k, E, p, r ? L : k);
                    break;
                  default:
                    jE(U, $, $, $, [""], k, 0, p, k);
                }
        }
        y = b = C = 0, O = A = 1, I = U = "", E = l;
        break;
      case 58:
        E = 1 + Kc(U), C = T;
      default:
        if (O < 1) {
          if (B == 123)
            --O;
          else if (B == 125 && O++ == 0 && h8() == 125)
            continue;
        }
        switch (U += eS(B), B * O) {
          case 38:
            A = b > 0 ? 1 : (U += "\f", -1);
            break;
          case 44:
            p[y++] = (Kc(U) - 1) * A, A = 1;
            break;
          case 64:
            ef() === 45 && (U += VE(tu())), x = ef(), b = E = Kc(I = U += b8(UE())), B++;
            break;
          case 45:
            T === 45 && Kc(U) == 2 && (O = 0);
        }
    }
  return s;
}
function qk(e, t, n, r, a, s, l, p, h, y, b) {
  for (var E = a - 1, x = a === 0 ? s : [""], C = HD(x), T = 0, O = 0, D = 0; T < r; ++T)
    for (var A = 0, B = xb(e, E + 1, E = l8(O = l[T])), I = e; A < C; ++A)
      (I = Iz(O > 0 ? x[A] + " " + B : nr(B, /&\f/g, x[A]))) && (h[D++] = I);
  return nS(e, t, n, a === 0 ? WD : p, h, y, b);
}
function E8(e, t, n) {
  return nS(e, t, n, jD, eS(v8()), xb(e, 2, -2), 0);
}
function Xk(e, t, n, r) {
  return nS(e, t, n, GD, xb(e, 0, r), xb(e, r + 1, -1), r);
}
function ay(e, t) {
  for (var n = "", r = HD(e), a = 0; a < r; a++)
    n += t(e[a], a, e, t) || "";
  return n;
}
function x8(e, t, n, r) {
  switch (e.type) {
    case u8:
      if (e.children.length)
        break;
    case s8:
    case GD:
      return e.return = e.return || e.value;
    case jD:
      return "";
    case kz:
      return e.return = e.value + "{" + ay(e.children, r) + "}";
    case WD:
      e.value = e.props.join(",");
  }
  return Kc(n = ay(e.children, r)) ? e.return = e.value + "{" + n + "}" : "";
}
function S8(e) {
  var t = HD(e);
  return function(n, r, a, s) {
    for (var l = "", p = 0; p < t; p++)
      l += e[p](n, r, a, s) || "";
    return l;
  };
}
function w8(e) {
  return function(t) {
    t.root || (t = t.return) && e(t);
  };
}
var C8 = function(t, n, r) {
  for (var a = 0, s = 0; a = s, s = ef(), a === 38 && s === 12 && (n[r] = 1), !Sb(s); )
    tu();
  return Kb(t, as);
}, R8 = function(t, n) {
  var r = -1, a = 44;
  do
    switch (Sb(a)) {
      case 0:
        a === 38 && ef() === 12 && (n[r] = 1), t[r] += C8(as - 1, n, r);
        break;
      case 2:
        t[r] += VE(a);
        break;
      case 4:
        if (a === 44) {
          t[++r] = ef() === 58 ? "&\f" : "", n[r] = t[r].length;
          break;
        }
      default:
        t[r] += eS(a);
    }
  while (a = tu());
  return t;
}, T8 = function(t, n) {
  return zz(R8(Bz(t), n));
}, Kk = /* @__PURE__ */ new WeakMap(), O8 = function(t) {
  if (!(t.type !== "rule" || !t.parent || t.length < 1)) {
    for (var n = t.value, r = t.parent, a = t.column === r.column && t.line === r.line; r.type !== "rule"; )
      if (r = r.parent, !r)
        return;
    if (!(t.props.length === 1 && n.charCodeAt(0) !== 58 && !Kk.get(r)) && !a) {
      Kk.set(t, !0);
      for (var s = [], l = T8(n, s), p = r.props, h = 0, y = 0; h < l.length; h++)
        for (var b = 0; b < p.length; b++, y++)
          t.props[y] = s[h] ? l[h].replace(/&\f/g, p[b]) : p[b] + " " + l[h];
    }
  }
}, D8 = function(t) {
  if (t.type === "decl") {
    var n = t.value;
    n.charCodeAt(0) === 108 && n.charCodeAt(2) === 98 && (t.return = "", t.value = "");
  }
}, M8 = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason", A8 = function(t) {
  return t.type === "comm" && t.children.indexOf(M8) > -1;
}, P8 = function(t) {
  return function(n, r, a) {
    if (!(n.type !== "rule" || t.compat)) {
      var s = n.value.match(/(:first|:nth|:nth-last)-child/g);
      if (s) {
        for (var l = !!n.parent, p = l ? n.parent.children : a, h = p.length - 1; h >= 0; h--) {
          var y = p[h];
          if (y.line < n.line)
            break;
          if (y.column < n.column) {
            if (A8(y))
              return;
            break;
          }
        }
        s.forEach(function(b) {
          console.error('The pseudo class "' + b + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + b.split("-child")[0] + '-of-type".');
        });
      }
    }
  };
}, Fz = function(t) {
  return t.type.charCodeAt(1) === 105 && t.type.charCodeAt(0) === 64;
}, N8 = function(t, n) {
  for (var r = t - 1; r >= 0; r--)
    if (!Fz(n[r]))
      return !0;
  return !1;
}, Qk = function(t) {
  t.type = "", t.value = "", t.return = "", t.children = "", t.props = "";
}, k8 = function(t, n, r) {
  !Fz(t) || (t.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), Qk(t)) : N8(n, r) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), Qk(t)));
};
function $z(e, t) {
  switch (f8(e, t)) {
    case 5103:
      return tr + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return tr + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return tr + e + Sx + e + ao + e + e;
    case 6828:
    case 4268:
      return tr + e + ao + e + e;
    case 6165:
      return tr + e + ao + "flex-" + e + e;
    case 5187:
      return tr + e + nr(e, /(\w+).+(:[^]+)/, tr + "box-$1$2" + ao + "flex-$1$2") + e;
    case 5443:
      return tr + e + ao + "flex-item-" + nr(e, /flex-|-self/, "") + e;
    case 4675:
      return tr + e + ao + "flex-line-pack" + nr(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return tr + e + ao + nr(e, "shrink", "negative") + e;
    case 5292:
      return tr + e + ao + nr(e, "basis", "preferred-size") + e;
    case 6060:
      return tr + "box-" + nr(e, "-grow", "") + tr + e + ao + nr(e, "grow", "positive") + e;
    case 4554:
      return tr + nr(e, /([^-])(transform)/g, "$1" + tr + "$2") + e;
    case 6187:
      return nr(nr(nr(e, /(zoom-|grab)/, tr + "$1"), /(image-set)/, tr + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return nr(e, /(image-set\([^]*)/, tr + "$1$`$1");
    case 4968:
      return nr(nr(e, /(.+:)(flex-)?(.*)/, tr + "box-pack:$3" + ao + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + tr + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return nr(e, /(.+)-inline(.+)/, tr + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (Kc(e) - 1 - t > 6)
        switch (za(e, t + 1)) {
          case 109:
            if (za(e, t + 4) !== 45)
              break;
          case 102:
            return nr(e, /(.+:)(.+)-([^]+)/, "$1" + tr + "$2-$3$1" + Sx + (za(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~gO(e, "stretch") ? $z(nr(e, "stretch", "fill-available"), t) + e : e;
        }
      break;
    case 4949:
      if (za(e, t + 1) !== 115)
        break;
    case 6444:
      switch (za(e, Kc(e) - 3 - (~gO(e, "!important") && 10))) {
        case 107:
          return nr(e, ":", ":" + tr) + e;
        case 101:
          return nr(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + tr + (za(e, 14) === 45 ? "inline-" : "") + "box$3$1" + tr + "$2$3$1" + ao + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (za(e, t + 11)) {
        case 114:
          return tr + e + ao + nr(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return tr + e + ao + nr(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return tr + e + ao + nr(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return tr + e + ao + e + e;
  }
  return e;
}
var I8 = function(t, n, r, a) {
  if (t.length > -1 && !t.return)
    switch (t.type) {
      case GD:
        t.return = $z(t.value, t.length);
        break;
      case kz:
        return ay([G0(t, {
          value: nr(t.value, "@", "@" + tr)
        })], a);
      case WD:
        if (t.length)
          return p8(t.props, function(s) {
            switch (d8(s, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return ay([G0(t, {
                  props: [nr(s, /:(read-\w+)/, ":" + Sx + "$1")]
                })], a);
              case "::placeholder":
                return ay([G0(t, {
                  props: [nr(s, /:(plac\w+)/, ":" + tr + "input-$1")]
                }), G0(t, {
                  props: [nr(s, /:(plac\w+)/, ":" + Sx + "$1")]
                }), G0(t, {
                  props: [nr(s, /:(plac\w+)/, ao + "input-$1")]
                })], a);
            }
            return "";
          });
    }
}, L8 = [I8], B8 = function(t) {
  var n = t.key;
  if (process.env.NODE_ENV !== "production" && !n)
    throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
  if (n === "css") {
    var r = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(r, function(O) {
      var D = O.getAttribute("data-emotion");
      D.indexOf(" ") !== -1 && (document.head.appendChild(O), O.setAttribute("data-s", ""));
    });
  }
  var a = t.stylisPlugins || L8;
  if (process.env.NODE_ENV !== "production" && /[^a-z-]/.test(n))
    throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + n + '" was passed');
  var s = {}, l, p = [];
  l = t.container || document.head, Array.prototype.forEach.call(
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(O) {
      for (var D = O.getAttribute("data-emotion").split(" "), A = 1; A < D.length; A++)
        s[D[A]] = !0;
      p.push(O);
    }
  );
  var h, y = [O8, D8];
  process.env.NODE_ENV !== "production" && y.push(P8({
    get compat() {
      return T.compat;
    }
  }), k8);
  {
    var b, E = [x8, process.env.NODE_ENV !== "production" ? function(O) {
      O.root || (O.return ? b.insert(O.return) : O.value && O.type !== jD && b.insert(O.value + "{}"));
    } : w8(function(O) {
      b.insert(O);
    })], x = S8(y.concat(a, E)), C = function(D) {
      return ay(_8(D), x);
    };
    h = function(D, A, B, I) {
      b = B, process.env.NODE_ENV !== "production" && A.map !== void 0 && (b = {
        insert: function(k) {
          B.insert(k + A.map);
        }
      }), C(D ? D + "{" + A.styles + "}" : A.styles), I && (T.inserted[A.name] = !0);
    };
  }
  var T = {
    key: n,
    sheet: new Nz({
      key: n,
      container: l,
      nonce: t.nonce,
      speedy: t.speedy,
      prepend: t.prepend,
      insertionPoint: t.insertionPoint
    }),
    nonce: t.nonce,
    inserted: s,
    registered: {},
    insert: h
  };
  return T.sheet.hydrate(p), T;
}, z8 = !0;
function YD(e, t, n) {
  var r = "";
  return n.split(" ").forEach(function(a) {
    e[a] !== void 0 ? t.push(e[a] + ";") : r += a + " ";
  }), r;
}
var F8 = function(t, n, r) {
  var a = t.key + "-" + n.name;
  (r === !1 || z8 === !1) && t.registered[a] === void 0 && (t.registered[a] = n.styles);
}, rS = function(t, n, r) {
  F8(t, n, r);
  var a = t.key + "-" + n.name;
  if (t.inserted[n.name] === void 0) {
    var s = n;
    do
      t.insert(n === s ? "." + a : "", s, t.sheet, !0), s = s.next;
    while (s !== void 0);
  }
};
function $8(e) {
  for (var t = 0, n, r = 0, a = e.length; a >= 4; ++r, a -= 4)
    n = e.charCodeAt(r) & 255 | (e.charCodeAt(++r) & 255) << 8 | (e.charCodeAt(++r) & 255) << 16 | (e.charCodeAt(++r) & 255) << 24, n = (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= n >>> 24, t = (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (a) {
    case 3:
      t ^= (e.charCodeAt(r + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(r + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(r) & 255, t = (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
var U8 = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, Zk = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, V8 = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).", j8 = /[A-Z]|^ms/g, Uz = /_EMO_([^_]+?)_([^]*?)_EMO_/g, qD = function(t) {
  return t.charCodeAt(1) === 45;
}, Jk = function(t) {
  return t != null && typeof t != "boolean";
}, oT = /* @__PURE__ */ U2(function(e) {
  return qD(e) ? e : e.replace(j8, "-$&").toLowerCase();
}), wx = function(t, n) {
  switch (t) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(Uz, function(r, a, s) {
          return ql = {
            name: a,
            styles: s,
            next: ql
          }, a;
        });
  }
  return U8[t] !== 1 && !qD(t) && typeof n == "number" && n !== 0 ? n + "px" : n;
};
if (process.env.NODE_ENV !== "production") {
  var W8 = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, G8 = ["normal", "none", "initial", "inherit", "unset"], H8 = wx, Y8 = /^-ms-/, q8 = /-(.)/g, e2 = {};
  wx = function(t, n) {
    if (t === "content" && (typeof n != "string" || G8.indexOf(n) === -1 && !W8.test(n) && (n.charAt(0) !== n.charAt(n.length - 1) || n.charAt(0) !== '"' && n.charAt(0) !== "'")))
      throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + n + "\"'`");
    var r = H8(t, n);
    return r !== "" && !qD(t) && t.indexOf("-") !== -1 && e2[t] === void 0 && (e2[t] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + t.replace(Y8, "ms-").replace(q8, function(a, s) {
      return s.toUpperCase();
    }) + "?")), r;
  };
}
var Vz = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function wb(e, t, n) {
  if (n == null)
    return "";
  if (n.__emotion_styles !== void 0) {
    if (process.env.NODE_ENV !== "production" && n.toString() === "NO_COMPONENT_SELECTOR")
      throw new Error(Vz);
    return n;
  }
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      if (n.anim === 1)
        return ql = {
          name: n.name,
          styles: n.styles,
          next: ql
        }, n.name;
      if (n.styles !== void 0) {
        var r = n.next;
        if (r !== void 0)
          for (; r !== void 0; )
            ql = {
              name: r.name,
              styles: r.styles,
              next: ql
            }, r = r.next;
        var a = n.styles + ";";
        return process.env.NODE_ENV !== "production" && n.map !== void 0 && (a += n.map), a;
      }
      return X8(e, t, n);
    }
    case "function": {
      if (e !== void 0) {
        var s = ql, l = n(e);
        return ql = s, wb(e, t, l);
      } else
        process.env.NODE_ENV !== "production" && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;
    }
    case "string":
      if (process.env.NODE_ENV !== "production") {
        var p = [], h = n.replace(Uz, function(b, E, x) {
          var C = "animation" + p.length;
          return p.push("const " + C + " = keyframes`" + x.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + C + "}";
        });
        p.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(p, ["`" + h + "`"]).join(`
`) + `

You should wrap it with \`css\` like this:

` + ("css`" + h + "`"));
      }
      break;
  }
  if (t == null)
    return n;
  var y = t[n];
  return y !== void 0 ? y : n;
}
function X8(e, t, n) {
  var r = "";
  if (Array.isArray(n))
    for (var a = 0; a < n.length; a++)
      r += wb(e, t, n[a]) + ";";
  else
    for (var s in n) {
      var l = n[s];
      if (typeof l != "object")
        t != null && t[l] !== void 0 ? r += s + "{" + t[l] + "}" : Jk(l) && (r += oT(s) + ":" + wx(s, l) + ";");
      else {
        if (s === "NO_COMPONENT_SELECTOR" && process.env.NODE_ENV !== "production")
          throw new Error(Vz);
        if (Array.isArray(l) && typeof l[0] == "string" && (t == null || t[l[0]] === void 0))
          for (var p = 0; p < l.length; p++)
            Jk(l[p]) && (r += oT(s) + ":" + wx(s, l[p]) + ";");
        else {
          var h = wb(e, t, l);
          switch (s) {
            case "animation":
            case "animationName": {
              r += oT(s) + ":" + h + ";";
              break;
            }
            default:
              process.env.NODE_ENV !== "production" && s === "undefined" && console.error(V8), r += s + "{" + h + "}";
          }
        }
      }
    }
  return r;
}
var t2 = /label:\s*([^\s;\n{]+)\s*(;|$)/g, jz;
process.env.NODE_ENV !== "production" && (jz = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g);
var ql, Sy = function(t, n, r) {
  if (t.length === 1 && typeof t[0] == "object" && t[0] !== null && t[0].styles !== void 0)
    return t[0];
  var a = !0, s = "";
  ql = void 0;
  var l = t[0];
  l == null || l.raw === void 0 ? (a = !1, s += wb(r, n, l)) : (process.env.NODE_ENV !== "production" && l[0] === void 0 && console.error(Zk), s += l[0]);
  for (var p = 1; p < t.length; p++)
    s += wb(r, n, t[p]), a && (process.env.NODE_ENV !== "production" && l[p] === void 0 && console.error(Zk), s += l[p]);
  var h;
  process.env.NODE_ENV !== "production" && (s = s.replace(jz, function(x) {
    return h = x, "";
  })), t2.lastIndex = 0;
  for (var y = "", b; (b = t2.exec(s)) !== null; )
    y += "-" + b[1];
  var E = $8(s) + y;
  return process.env.NODE_ENV !== "production" ? {
    name: E,
    styles: s,
    map: h,
    next: ql,
    toString: function() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  } : {
    name: E,
    styles: s,
    next: ql
  };
}, K8 = {}.hasOwnProperty, XD = /* @__PURE__ */ z2(
  typeof HTMLElement < "u" ? /* @__PURE__ */ B8({
    key: "css"
  }) : null
);
process.env.NODE_ENV !== "production" && (XD.displayName = "EmotionCacheContext");
XD.Provider;
var iS = function(t) {
  return /* @__PURE__ */ HE(function(n, r) {
    var a = nl(XD);
    return t(n, a, r);
  });
}, Ny = /* @__PURE__ */ z2({});
process.env.NODE_ENV !== "production" && (Ny.displayName = "EmotionThemeContext");
var n2 = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", r2 = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__", Q8 = function() {
  return null;
}, Z8 = /* @__PURE__ */ iS(function(e, t, n) {
  var r = e.css;
  typeof r == "string" && t.registered[r] !== void 0 && (r = t.registered[r]);
  var a = e[n2], s = [r], l = "";
  typeof e.className == "string" ? l = YD(t.registered, s, e.className) : e.className != null && (l = e.className + " ");
  var p = Sy(s, void 0, nl(Ny));
  if (process.env.NODE_ENV !== "production" && p.name.indexOf("-") === -1) {
    var h = e[r2];
    h && (p = Sy([p, "label:" + h + ";"]));
  }
  rS(t, p, typeof a == "string"), l += t.key + "-" + p.name;
  var y = {};
  for (var b in e)
    K8.call(e, b) && b !== "css" && b !== n2 && (process.env.NODE_ENV === "production" || b !== r2) && (y[b] = e[b]);
  y.ref = n, y.className = l;
  var E = /* @__PURE__ */ Ks(a, y), x = /* @__PURE__ */ Ks(Q8, null);
  return /* @__PURE__ */ Ks(MO, null, x, E);
});
process.env.NODE_ENV !== "production" && (Z8.displayName = "EmotionCssPropInternal");
var J8 = {
  name: "@emotion/react",
  version: "11.7.1",
  main: "dist/emotion-react.cjs.js",
  module: "dist/emotion-react.esm.js",
  browser: {
    "./dist/emotion-react.cjs.js": "./dist/emotion-react.browser.cjs.js",
    "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
  },
  types: "types/index.d.ts",
  files: [
    "src",
    "dist",
    "jsx-runtime",
    "jsx-dev-runtime",
    "_isolated-hnrs",
    "types/*.d.ts",
    "macro.js",
    "macro.d.ts",
    "macro.js.flow"
  ],
  sideEffects: !1,
  author: "mitchellhamilton <mitchell@mitchellhamilton.me>",
  license: "MIT",
  scripts: {
    "test:typescript": "dtslint types"
  },
  dependencies: {
    "@babel/runtime": "^7.13.10",
    "@emotion/cache": "^11.7.1",
    "@emotion/serialize": "^1.0.2",
    "@emotion/sheet": "^1.1.0",
    "@emotion/utils": "^1.0.0",
    "@emotion/weak-memoize": "^0.2.5",
    "hoist-non-react-statics": "^3.3.1"
  },
  peerDependencies: {
    "@babel/core": "^7.0.0",
    react: ">=16.8.0"
  },
  peerDependenciesMeta: {
    "@babel/core": {
      optional: !0
    },
    "@types/react": {
      optional: !0
    }
  },
  devDependencies: {
    "@babel/core": "^7.13.10",
    "@emotion/css": "11.7.1",
    "@emotion/css-prettifier": "1.0.1",
    "@emotion/server": "11.4.0",
    "@emotion/styled": "11.6.0",
    "@types/react": "^16.9.11",
    dtslint: "^0.3.0",
    "html-tag-names": "^1.1.2",
    react: "16.14.0",
    "svg-tag-names": "^1.1.1"
  },
  repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
  publishConfig: {
    access: "public"
  },
  "umd:main": "dist/emotion-react.umd.min.js",
  preconstruct: {
    entrypoints: [
      "./index.js",
      "./jsx-runtime.js",
      "./jsx-dev-runtime.js",
      "./_isolated-hnrs.js"
    ],
    umdName: "emotionReact"
  }
}, i2 = !1, e9 = /* @__PURE__ */ iS(function(e, t) {
  process.env.NODE_ENV !== "production" && !i2 && (e.className || e.css) && (console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?"), i2 = !0);
  var n = e.styles, r = Sy([n], void 0, nl(Ny)), a = OO();
  return cT(function() {
    var s = t.key + "-global", l = new Nz({
      key: s,
      nonce: t.sheet.nonce,
      container: t.sheet.container,
      speedy: t.sheet.isSpeedy
    }), p = !1, h = document.querySelector('style[data-emotion="' + s + " " + r.name + '"]');
    return t.sheet.tags.length && (l.before = t.sheet.tags[0]), h !== null && (p = !0, h.setAttribute("data-emotion", s), l.hydrate([h])), a.current = [l, p], function() {
      l.flush();
    };
  }, [t]), cT(function() {
    var s = a.current, l = s[0], p = s[1];
    if (p) {
      s[1] = !1;
      return;
    }
    if (r.next !== void 0 && rS(t, r.next, !0), l.tags.length) {
      var h = l.tags[l.tags.length - 1].nextElementSibling;
      l.before = h, l.flush();
    }
    t.insert("", r, l, !1);
  }, [t, r.name]), null;
});
process.env.NODE_ENV !== "production" && (e9.displayName = "EmotionGlobal");
function t9() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return Sy(t);
}
var KD = function() {
  var t = t9.apply(void 0, arguments), n = "animation-" + t.name;
  return {
    name: n,
    styles: "@keyframes " + n + "{" + t.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}, n9 = function e(t) {
  for (var n = t.length, r = 0, a = ""; r < n; r++) {
    var s = t[r];
    if (s != null) {
      var l = void 0;
      switch (typeof s) {
        case "boolean":
          break;
        case "object": {
          if (Array.isArray(s))
            l = e(s);
          else {
            process.env.NODE_ENV !== "production" && s.styles !== void 0 && s.name !== void 0 && console.error("You have passed styles created with `css` from `@emotion/react` package to the `cx`.\n`cx` is meant to compose class names (strings) so you should convert those styles to a class name by passing them to the `css` received from <ClassNames/> component."), l = "";
            for (var p in s)
              s[p] && p && (l && (l += " "), l += p);
          }
          break;
        }
        default:
          l = s;
      }
      l && (a && (a += " "), a += l);
    }
  }
  return a;
};
function r9(e, t, n) {
  var r = [], a = YD(e, r, n);
  return r.length < 2 ? n : a + t(r);
}
var i9 = function() {
  return null;
}, a9 = /* @__PURE__ */ iS(function(e, t) {
  var n = !1, r = function() {
    if (n && process.env.NODE_ENV !== "production")
      throw new Error("css can only be used during render");
    for (var y = arguments.length, b = new Array(y), E = 0; E < y; E++)
      b[E] = arguments[E];
    var x = Sy(b, t.registered);
    return rS(t, x, !1), t.key + "-" + x.name;
  }, a = function() {
    if (n && process.env.NODE_ENV !== "production")
      throw new Error("cx can only be used during render");
    for (var y = arguments.length, b = new Array(y), E = 0; E < y; E++)
      b[E] = arguments[E];
    return r9(t.registered, r, n9(b));
  }, s = {
    css: r,
    cx: a,
    theme: nl(Ny)
  }, l = e.children(s);
  n = !0;
  var p = /* @__PURE__ */ Ks(i9, null);
  return /* @__PURE__ */ Ks(MO, null, p, l);
});
process.env.NODE_ENV !== "production" && (a9.displayName = "EmotionClassNames");
if (process.env.NODE_ENV !== "production") {
  var a2 = !0, o9 = typeof jest < "u";
  if (a2 && !o9) {
    var o2 = typeof globalThis < "u" ? globalThis : a2 ? window : global, s2 = "__EMOTION_REACT_" + J8.version.split(".")[0] + "__";
    o2[s2] && console.warn("You are loading @emotion/react when it is already loaded. Running multiple instances may cause problems. This can happen if multiple versions are used, or if multiple builds of the same version are used."), o2[s2] = !0;
  }
}
var s9 = dT, u9 = function(t) {
  return t !== "theme";
}, u2 = function(t) {
  return typeof t == "string" && t.charCodeAt(0) > 96 ? s9 : u9;
}, l2 = function(t, n, r) {
  var a;
  if (n) {
    var s = n.shouldForwardProp;
    a = t.__emotion_forwardProp && s ? function(l) {
      return t.__emotion_forwardProp(l) && s(l);
    } : s;
  }
  return typeof a != "function" && r && (a = t.__emotion_forwardProp), a;
}, c2 = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, l9 = function() {
  return null;
}, c9 = function e(t, n) {
  if (process.env.NODE_ENV !== "production" && t === void 0)
    throw new Error(`You are trying to create a styled element with an undefined component.
You may have forgotten to import it.`);
  var r = t.__emotion_real === t, a = r && t.__emotion_base || t, s, l;
  n !== void 0 && (s = n.label, l = n.target);
  var p = l2(t, n, r), h = p || u2(a), y = !h("as");
  return function() {
    var b = arguments, E = r && t.__emotion_styles !== void 0 ? t.__emotion_styles.slice(0) : [];
    if (s !== void 0 && E.push("label:" + s + ";"), b[0] == null || b[0].raw === void 0)
      E.push.apply(E, b);
    else {
      process.env.NODE_ENV !== "production" && b[0][0] === void 0 && console.error(c2), E.push(b[0][0]);
      for (var x = b.length, C = 1; C < x; C++)
        process.env.NODE_ENV !== "production" && b[0][C] === void 0 && console.error(c2), E.push(b[C], b[0][C]);
    }
    var T = iS(function(O, D, A) {
      var B = y && O.as || a, I = "", L = [], k = O;
      if (O.theme == null) {
        k = {};
        for (var $ in O)
          k[$] = O[$];
        k.theme = nl(Ny);
      }
      typeof O.className == "string" ? I = YD(D.registered, L, O.className) : O.className != null && (I = O.className + " ");
      var U = Sy(E.concat(L), D.registered, k);
      rS(D, U, typeof B == "string"), I += D.key + "-" + U.name, l !== void 0 && (I += " " + l);
      var K = y && p === void 0 ? u2(B) : h, X = {};
      for (var Y in O)
        y && Y === "as" || K(Y) && (X[Y] = O[Y]);
      X.className = I, X.ref = A;
      var J = /* @__PURE__ */ Ks(B, X), Q = /* @__PURE__ */ Ks(l9, null);
      return /* @__PURE__ */ Ks(MO, null, Q, J);
    });
    return T.displayName = s !== void 0 ? s : "Styled(" + (typeof a == "string" ? a : a.displayName || a.name || "Component") + ")", T.defaultProps = t.defaultProps, T.__emotion_real = T, T.__emotion_base = a, T.__emotion_styles = E, T.__emotion_forwardProp = p, Object.defineProperty(T, "toString", {
      value: function() {
        return l === void 0 && process.env.NODE_ENV !== "production" ? "NO_COMPONENT_SELECTOR" : "." + l;
      }
    }), T.withComponent = function(O, D) {
      return e(O, st({}, n, D, {
        shouldForwardProp: l2(T, D, !0)
      })).apply(void 0, E);
    }, T;
  };
}, f9 = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "marquee",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
], yO = c9.bind();
f9.forEach(function(e) {
  yO[e] = yO(e);
});
const d9 = yO;
/**
 * @mui/styled-engine v5.13.2
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function p9(e, t) {
  const n = d9(e, t);
  return process.env.NODE_ENV !== "production" ? (...r) => {
    const a = typeof e == "string" ? `"${e}"` : "component";
    return r.length === 0 ? console.error([`MUI: Seems like you called \`styled(${a})()\` without a \`style\` argument.`, 'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join(`
`)) : r.some((s) => s === void 0) && console.error(`MUI: the styled(${a})(...args) API requires all its args to be defined.`), n(...r);
  } : n;
}
const v9 = (e, t) => {
  Array.isArray(e.__emotion_styles) && (e.__emotion_styles = t(e.__emotion_styles));
}, h9 = ["values", "unit", "step"], g9 = (e) => {
  const t = Object.keys(e).map((n) => ({
    key: n,
    val: e[n]
  })) || [];
  return t.sort((n, r) => n.val - r.val), t.reduce((n, r) => st({}, n, {
    [r.key]: r.val
  }), {});
};
function m9(e) {
  const {
    values: t = {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536
    },
    unit: n = "px",
    step: r = 5
  } = e, a = Ir(e, h9), s = g9(t), l = Object.keys(s);
  function p(x) {
    return `@media (min-width:${typeof t[x] == "number" ? t[x] : x}${n})`;
  }
  function h(x) {
    return `@media (max-width:${(typeof t[x] == "number" ? t[x] : x) - r / 100}${n})`;
  }
  function y(x, C) {
    const T = l.indexOf(C);
    return `@media (min-width:${typeof t[x] == "number" ? t[x] : x}${n}) and (max-width:${(T !== -1 && typeof t[l[T]] == "number" ? t[l[T]] : C) - r / 100}${n})`;
  }
  function b(x) {
    return l.indexOf(x) + 1 < l.length ? y(x, l[l.indexOf(x) + 1]) : p(x);
  }
  function E(x) {
    const C = l.indexOf(x);
    return C === 0 ? p(l[1]) : C === l.length - 1 ? h(l[C]) : y(x, l[l.indexOf(x) + 1]).replace("@media", "@media not all and");
  }
  return st({
    keys: l,
    values: s,
    up: p,
    down: h,
    between: y,
    only: b,
    not: E,
    unit: n
  }, a);
}
const y9 = {
  borderRadius: 4
}, b9 = y9, _9 = process.env.NODE_ENV !== "production" ? V.exports.oneOfType([V.exports.number, V.exports.string, V.exports.object, V.exports.array]) : {}, iv = _9;
function ub(e, t) {
  return t ? md(e, t, {
    clone: !1
  }) : e;
}
const QD = {
  xs: 0,
  sm: 600,
  md: 900,
  lg: 1200,
  xl: 1536
}, f2 = {
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (e) => `@media (min-width:${QD[e]}px)`
};
function Ed(e, t, n) {
  const r = e.theme || {};
  if (Array.isArray(t)) {
    const s = r.breakpoints || f2;
    return t.reduce((l, p, h) => (l[s.up(s.keys[h])] = n(t[h]), l), {});
  }
  if (typeof t == "object") {
    const s = r.breakpoints || f2;
    return Object.keys(t).reduce((l, p) => {
      if (Object.keys(s.values || QD).indexOf(p) !== -1) {
        const h = s.up(p);
        l[h] = n(t[p], p);
      } else {
        const h = p;
        l[h] = t[h];
      }
      return l;
    }, {});
  }
  return n(t);
}
function E9(e = {}) {
  var t;
  return ((t = e.keys) == null ? void 0 : t.reduce((r, a) => {
    const s = e.up(a);
    return r[s] = {}, r;
  }, {})) || {};
}
function x9(e, t) {
  return e.reduce((n, r) => {
    const a = n[r];
    return (!a || Object.keys(a).length === 0) && delete n[r], n;
  }, t);
}
function aS(e, t, n = !0) {
  if (!t || typeof t != "string")
    return null;
  if (e && e.vars && n) {
    const r = `vars.${t}`.split(".").reduce((a, s) => a && a[s] ? a[s] : null, e);
    if (r != null)
      return r;
  }
  return t.split(".").reduce((r, a) => r && r[a] != null ? r[a] : null, e);
}
function Cx(e, t, n, r = n) {
  let a;
  return typeof e == "function" ? a = e(n) : Array.isArray(e) ? a = e[n] || r : a = aS(e, n) || r, t && (a = t(a, r, e)), a;
}
function fr(e) {
  const {
    prop: t,
    cssProperty: n = e.prop,
    themeKey: r,
    transform: a
  } = e, s = (l) => {
    if (l[t] == null)
      return null;
    const p = l[t], h = l.theme, y = aS(h, r) || {};
    return Ed(l, p, (E) => {
      let x = Cx(y, a, E);
      return E === x && typeof E == "string" && (x = Cx(y, a, `${t}${E === "default" ? "" : ob(E)}`, E)), n === !1 ? x : {
        [n]: x
      };
    });
  };
  return s.propTypes = process.env.NODE_ENV !== "production" ? {
    [t]: iv
  } : {}, s.filterProps = [t], s;
}
function S9(e) {
  const t = {};
  return (n) => (t[n] === void 0 && (t[n] = e(n)), t[n]);
}
const w9 = {
  m: "margin",
  p: "padding"
}, C9 = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
}, d2 = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
}, R9 = S9((e) => {
  if (e.length > 2)
    if (d2[e])
      e = d2[e];
    else
      return [e];
  const [t, n] = e.split(""), r = w9[t], a = C9[n] || "";
  return Array.isArray(a) ? a.map((s) => r + s) : [r + a];
}), oS = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"], sS = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"], T9 = [...oS, ...sS];
function Qb(e, t, n, r) {
  var a;
  const s = (a = aS(e, t, !1)) != null ? a : n;
  return typeof s == "number" ? (l) => typeof l == "string" ? l : (process.env.NODE_ENV !== "production" && typeof l != "number" && console.error(`MUI: Expected ${r} argument to be a number or a string, got ${l}.`), s * l) : Array.isArray(s) ? (l) => typeof l == "string" ? l : (process.env.NODE_ENV !== "production" && (Number.isInteger(l) ? l > s.length - 1 && console.error([`MUI: The value provided (${l}) overflows.`, `The supported values are: ${JSON.stringify(s)}.`, `${l} > ${s.length - 1}, you need to add the missing values.`].join(`
`)) : console.error([`MUI: The \`theme.${t}\` array type cannot be combined with non integer values.You should either use an integer value that can be used as index, or define the \`theme.${t}\` as a number.`].join(`
`))), s[l]) : typeof s == "function" ? s : (process.env.NODE_ENV !== "production" && console.error([`MUI: The \`theme.${t}\` value (${s}) is invalid.`, "It should be a number, an array or a function."].join(`
`)), () => {
  });
}
function Wz(e) {
  return Qb(e, "spacing", 8, "spacing");
}
function Zb(e, t) {
  if (typeof t == "string" || t == null)
    return t;
  const n = Math.abs(t), r = e(n);
  return t >= 0 ? r : typeof r == "number" ? -r : `-${r}`;
}
function O9(e, t) {
  return (n) => e.reduce((r, a) => (r[a] = Zb(t, n), r), {});
}
function D9(e, t, n, r) {
  if (t.indexOf(n) === -1)
    return null;
  const a = R9(n), s = O9(a, r), l = e[n];
  return Ed(e, l, s);
}
function Gz(e, t) {
  const n = Wz(e.theme);
  return Object.keys(e).map((r) => D9(e, t, r, n)).reduce(ub, {});
}
function pi(e) {
  return Gz(e, oS);
}
pi.propTypes = process.env.NODE_ENV !== "production" ? oS.reduce((e, t) => (e[t] = iv, e), {}) : {};
pi.filterProps = oS;
function vi(e) {
  return Gz(e, sS);
}
vi.propTypes = process.env.NODE_ENV !== "production" ? sS.reduce((e, t) => (e[t] = iv, e), {}) : {};
vi.filterProps = sS;
process.env.NODE_ENV !== "production" && T9.reduce((e, t) => (e[t] = iv, e), {});
function M9(e = 8) {
  if (e.mui)
    return e;
  const t = Wz({
    spacing: e
  }), n = (...r) => (process.env.NODE_ENV !== "production" && (r.length <= 4 || console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${r.length}`)), (r.length === 0 ? [1] : r).map((s) => {
    const l = t(s);
    return typeof l == "number" ? `${l}px` : l;
  }).join(" "));
  return n.mui = !0, n;
}
function uS(...e) {
  const t = e.reduce((r, a) => (a.filterProps.forEach((s) => {
    r[s] = a;
  }), r), {}), n = (r) => Object.keys(r).reduce((a, s) => t[s] ? ub(a, t[s](r)) : a, {});
  return n.propTypes = process.env.NODE_ENV !== "production" ? e.reduce((r, a) => Object.assign(r, a.propTypes), {}) : {}, n.filterProps = e.reduce((r, a) => r.concat(a.filterProps), []), n;
}
function Qc(e) {
  return typeof e != "number" ? e : `${e}px solid`;
}
const A9 = fr({
  prop: "border",
  themeKey: "borders",
  transform: Qc
}), P9 = fr({
  prop: "borderTop",
  themeKey: "borders",
  transform: Qc
}), N9 = fr({
  prop: "borderRight",
  themeKey: "borders",
  transform: Qc
}), k9 = fr({
  prop: "borderBottom",
  themeKey: "borders",
  transform: Qc
}), I9 = fr({
  prop: "borderLeft",
  themeKey: "borders",
  transform: Qc
}), L9 = fr({
  prop: "borderColor",
  themeKey: "palette"
}), B9 = fr({
  prop: "borderTopColor",
  themeKey: "palette"
}), z9 = fr({
  prop: "borderRightColor",
  themeKey: "palette"
}), F9 = fr({
  prop: "borderBottomColor",
  themeKey: "palette"
}), $9 = fr({
  prop: "borderLeftColor",
  themeKey: "palette"
}), lS = (e) => {
  if (e.borderRadius !== void 0 && e.borderRadius !== null) {
    const t = Qb(e.theme, "shape.borderRadius", 4, "borderRadius"), n = (r) => ({
      borderRadius: Zb(t, r)
    });
    return Ed(e, e.borderRadius, n);
  }
  return null;
};
lS.propTypes = process.env.NODE_ENV !== "production" ? {
  borderRadius: iv
} : {};
lS.filterProps = ["borderRadius"];
uS(A9, P9, N9, k9, I9, L9, B9, z9, F9, $9, lS);
const cS = (e) => {
  if (e.gap !== void 0 && e.gap !== null) {
    const t = Qb(e.theme, "spacing", 8, "gap"), n = (r) => ({
      gap: Zb(t, r)
    });
    return Ed(e, e.gap, n);
  }
  return null;
};
cS.propTypes = process.env.NODE_ENV !== "production" ? {
  gap: iv
} : {};
cS.filterProps = ["gap"];
const fS = (e) => {
  if (e.columnGap !== void 0 && e.columnGap !== null) {
    const t = Qb(e.theme, "spacing", 8, "columnGap"), n = (r) => ({
      columnGap: Zb(t, r)
    });
    return Ed(e, e.columnGap, n);
  }
  return null;
};
fS.propTypes = process.env.NODE_ENV !== "production" ? {
  columnGap: iv
} : {};
fS.filterProps = ["columnGap"];
const dS = (e) => {
  if (e.rowGap !== void 0 && e.rowGap !== null) {
    const t = Qb(e.theme, "spacing", 8, "rowGap"), n = (r) => ({
      rowGap: Zb(t, r)
    });
    return Ed(e, e.rowGap, n);
  }
  return null;
};
dS.propTypes = process.env.NODE_ENV !== "production" ? {
  rowGap: iv
} : {};
dS.filterProps = ["rowGap"];
const U9 = fr({
  prop: "gridColumn"
}), V9 = fr({
  prop: "gridRow"
}), j9 = fr({
  prop: "gridAutoFlow"
}), W9 = fr({
  prop: "gridAutoColumns"
}), G9 = fr({
  prop: "gridAutoRows"
}), H9 = fr({
  prop: "gridTemplateColumns"
}), Y9 = fr({
  prop: "gridTemplateRows"
}), q9 = fr({
  prop: "gridTemplateAreas"
}), X9 = fr({
  prop: "gridArea"
});
uS(cS, fS, dS, U9, V9, j9, W9, G9, H9, Y9, q9, X9);
function oy(e, t) {
  return t === "grey" ? t : e;
}
const K9 = fr({
  prop: "color",
  themeKey: "palette",
  transform: oy
}), Q9 = fr({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: oy
}), Z9 = fr({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: oy
});
uS(K9, Q9, Z9);
function Hs(e) {
  return e <= 1 && e !== 0 ? `${e * 100}%` : e;
}
const J9 = fr({
  prop: "width",
  transform: Hs
}), ZD = (e) => {
  if (e.maxWidth !== void 0 && e.maxWidth !== null) {
    const t = (n) => {
      var r, a, s;
      return {
        maxWidth: ((r = e.theme) == null || (a = r.breakpoints) == null || (s = a.values) == null ? void 0 : s[n]) || QD[n] || Hs(n)
      };
    };
    return Ed(e, e.maxWidth, t);
  }
  return null;
};
ZD.filterProps = ["maxWidth"];
const eq = fr({
  prop: "minWidth",
  transform: Hs
}), tq = fr({
  prop: "height",
  transform: Hs
}), nq = fr({
  prop: "maxHeight",
  transform: Hs
}), rq = fr({
  prop: "minHeight",
  transform: Hs
});
fr({
  prop: "size",
  cssProperty: "width",
  transform: Hs
});
fr({
  prop: "size",
  cssProperty: "height",
  transform: Hs
});
const iq = fr({
  prop: "boxSizing"
});
uS(J9, ZD, eq, tq, nq, rq, iq);
const aq = {
  border: {
    themeKey: "borders",
    transform: Qc
  },
  borderTop: {
    themeKey: "borders",
    transform: Qc
  },
  borderRight: {
    themeKey: "borders",
    transform: Qc
  },
  borderBottom: {
    themeKey: "borders",
    transform: Qc
  },
  borderLeft: {
    themeKey: "borders",
    transform: Qc
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: lS
  },
  color: {
    themeKey: "palette",
    transform: oy
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: oy
  },
  backgroundColor: {
    themeKey: "palette",
    transform: oy
  },
  p: {
    style: vi
  },
  pt: {
    style: vi
  },
  pr: {
    style: vi
  },
  pb: {
    style: vi
  },
  pl: {
    style: vi
  },
  px: {
    style: vi
  },
  py: {
    style: vi
  },
  padding: {
    style: vi
  },
  paddingTop: {
    style: vi
  },
  paddingRight: {
    style: vi
  },
  paddingBottom: {
    style: vi
  },
  paddingLeft: {
    style: vi
  },
  paddingX: {
    style: vi
  },
  paddingY: {
    style: vi
  },
  paddingInline: {
    style: vi
  },
  paddingInlineStart: {
    style: vi
  },
  paddingInlineEnd: {
    style: vi
  },
  paddingBlock: {
    style: vi
  },
  paddingBlockStart: {
    style: vi
  },
  paddingBlockEnd: {
    style: vi
  },
  m: {
    style: pi
  },
  mt: {
    style: pi
  },
  mr: {
    style: pi
  },
  mb: {
    style: pi
  },
  ml: {
    style: pi
  },
  mx: {
    style: pi
  },
  my: {
    style: pi
  },
  margin: {
    style: pi
  },
  marginTop: {
    style: pi
  },
  marginRight: {
    style: pi
  },
  marginBottom: {
    style: pi
  },
  marginLeft: {
    style: pi
  },
  marginX: {
    style: pi
  },
  marginY: {
    style: pi
  },
  marginInline: {
    style: pi
  },
  marginInlineStart: {
    style: pi
  },
  marginInlineEnd: {
    style: pi
  },
  marginBlock: {
    style: pi
  },
  marginBlockStart: {
    style: pi
  },
  marginBlockEnd: {
    style: pi
  },
  displayPrint: {
    cssProperty: !1,
    transform: (e) => ({
      "@media print": {
        display: e
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  gap: {
    style: cS
  },
  rowGap: {
    style: dS
  },
  columnGap: {
    style: fS
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  boxShadow: {
    themeKey: "shadows"
  },
  width: {
    transform: Hs
  },
  maxWidth: {
    style: ZD
  },
  minWidth: {
    transform: Hs
  },
  height: {
    transform: Hs
  },
  maxHeight: {
    transform: Hs
  },
  minHeight: {
    transform: Hs
  },
  boxSizing: {},
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: !1,
    themeKey: "typography"
  }
}, Hz = aq;
function oq(...e) {
  const t = e.reduce((r, a) => r.concat(Object.keys(a)), []), n = new Set(t);
  return e.every((r) => n.size === Object.keys(r).length);
}
function sq(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function uq() {
  function e(n, r, a, s) {
    const l = {
      [n]: r,
      theme: a
    }, p = s[n];
    if (!p)
      return {
        [n]: r
      };
    const {
      cssProperty: h = n,
      themeKey: y,
      transform: b,
      style: E
    } = p;
    if (r == null)
      return null;
    if (y === "typography" && r === "inherit")
      return {
        [n]: r
      };
    const x = aS(a, y) || {};
    return E ? E(l) : Ed(l, r, (T) => {
      let O = Cx(x, b, T);
      return T === O && typeof T == "string" && (O = Cx(x, b, `${n}${T === "default" ? "" : ob(T)}`, T)), h === !1 ? O : {
        [h]: O
      };
    });
  }
  function t(n) {
    var r;
    const {
      sx: a,
      theme: s = {}
    } = n || {};
    if (!a)
      return null;
    const l = (r = s.unstable_sxConfig) != null ? r : Hz;
    function p(h) {
      let y = h;
      if (typeof h == "function")
        y = h(s);
      else if (typeof h != "object")
        return h;
      if (!y)
        return null;
      const b = E9(s.breakpoints), E = Object.keys(b);
      let x = b;
      return Object.keys(y).forEach((C) => {
        const T = sq(y[C], s);
        if (T != null)
          if (typeof T == "object")
            if (l[C])
              x = ub(x, e(C, T, s, l));
            else {
              const O = Ed({
                theme: s
              }, T, (D) => ({
                [C]: D
              }));
              oq(O, T) ? x[C] = t({
                sx: T,
                theme: s
              }) : x = ub(x, O);
            }
          else
            x = ub(x, e(C, T, s, l));
      }), x9(E, x);
    }
    return Array.isArray(a) ? a.map(p) : p(a);
  }
  return t;
}
const Yz = uq();
Yz.filterProps = ["sx"];
const qz = Yz, lq = ["breakpoints", "palette", "spacing", "shape"];
function JD(e = {}, ...t) {
  const {
    breakpoints: n = {},
    palette: r = {},
    spacing: a,
    shape: s = {}
  } = e, l = Ir(e, lq), p = m9(n), h = M9(a);
  let y = md({
    breakpoints: p,
    direction: "ltr",
    components: {},
    palette: st({
      mode: "light"
    }, r),
    spacing: h,
    shape: st({}, b9, s)
  }, l);
  return y = t.reduce((b, E) => md(b, E), y), y.unstable_sxConfig = st({}, Hz, l == null ? void 0 : l.unstable_sxConfig), y.unstable_sx = function(E) {
    return qz({
      sx: E,
      theme: this
    });
  }, y;
}
function cq(e) {
  return Object.keys(e).length === 0;
}
function fq(e = null) {
  const t = Ze.useContext(Ny);
  return !t || cq(t) ? e : t;
}
const dq = JD();
function Xz(e = dq) {
  return fq(e);
}
const pq = ["variant"];
function p2(e) {
  return e.length === 0;
}
function Kz(e) {
  const {
    variant: t
  } = e, n = Ir(e, pq);
  let r = t || "";
  return Object.keys(n).sort().forEach((a) => {
    a === "color" ? r += p2(r) ? e[a] : ob(e[a]) : r += `${p2(r) ? a : ob(a)}${ob(e[a].toString())}`;
  }), r;
}
const vq = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"];
function hq(e) {
  return Object.keys(e).length === 0;
}
function gq(e) {
  return typeof e == "string" && e.charCodeAt(0) > 96;
}
const mq = (e, t) => t.components && t.components[e] && t.components[e].styleOverrides ? t.components[e].styleOverrides : null, yq = (e, t) => {
  let n = [];
  t && t.components && t.components[e] && t.components[e].variants && (n = t.components[e].variants);
  const r = {};
  return n.forEach((a) => {
    const s = Kz(a.props);
    r[s] = a.style;
  }), r;
}, bq = (e, t, n, r) => {
  var a, s;
  const {
    ownerState: l = {}
  } = e, p = [], h = n == null || (a = n.components) == null || (s = a[r]) == null ? void 0 : s.variants;
  return h && h.forEach((y) => {
    let b = !0;
    Object.keys(y.props).forEach((E) => {
      l[E] !== y.props[E] && e[E] !== y.props[E] && (b = !1);
    }), b && p.push(t[Kz(y.props)]);
  }), p;
};
function WE(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const _q = JD(), Eq = (e) => e.charAt(0).toLowerCase() + e.slice(1);
function H0({
  defaultTheme: e,
  theme: t,
  themeId: n
}) {
  return hq(t) ? e : t[n] || t;
}
function xq(e = {}) {
  const {
    themeId: t,
    defaultTheme: n = _q,
    rootShouldForwardProp: r = WE,
    slotShouldForwardProp: a = WE
  } = e, s = (l) => qz(st({}, l, {
    theme: H0(st({}, l, {
      defaultTheme: n,
      themeId: t
    }))
  }));
  return s.__mui_systemSx = !0, (l, p = {}) => {
    v9(l, (L) => L.filter((k) => !(k != null && k.__mui_systemSx)));
    const {
      name: h,
      slot: y,
      skipVariantsResolver: b,
      skipSx: E,
      overridesResolver: x
    } = p, C = Ir(p, vq), T = b !== void 0 ? b : y && y !== "Root" || !1, O = E || !1;
    let D;
    process.env.NODE_ENV !== "production" && h && (D = `${h}-${Eq(y || "Root")}`);
    let A = WE;
    y === "Root" ? A = r : y ? A = a : gq(l) && (A = void 0);
    const B = p9(l, st({
      shouldForwardProp: A,
      label: D
    }, C)), I = (L, ...k) => {
      const $ = k ? k.map((Y) => typeof Y == "function" && Y.__emotion_real !== Y ? (J) => Y(st({}, J, {
        theme: H0(st({}, J, {
          defaultTheme: n,
          themeId: t
        }))
      })) : Y) : [];
      let U = L;
      h && x && $.push((Y) => {
        const J = H0(st({}, Y, {
          defaultTheme: n,
          themeId: t
        })), Q = mq(h, J);
        if (Q) {
          const Z = {};
          return Object.entries(Q).forEach(([se, pe]) => {
            Z[se] = typeof pe == "function" ? pe(st({}, Y, {
              theme: J
            })) : pe;
          }), x(Y, Z);
        }
        return null;
      }), h && !T && $.push((Y) => {
        const J = H0(st({}, Y, {
          defaultTheme: n,
          themeId: t
        }));
        return bq(Y, yq(h, J), J, h);
      }), O || $.push(s);
      const K = $.length - k.length;
      if (Array.isArray(L) && K > 0) {
        const Y = new Array(K).fill("");
        U = [...L, ...Y], U.raw = [...L.raw, ...Y];
      } else
        typeof L == "function" && L.__emotion_real !== L && (U = (Y) => L(st({}, Y, {
          theme: H0(st({}, Y, {
            defaultTheme: n,
            themeId: t
          }))
        })));
      const X = B(U, ...$);
      if (process.env.NODE_ENV !== "production") {
        let Y;
        h && (Y = `${h}${y || ""}`), Y === void 0 && (Y = `Styled(${yY(l)})`), X.displayName = Y;
      }
      return l.muiName && (X.muiName = l.muiName), X;
    };
    return B.withConfig && (I.withConfig = B.withConfig), I;
  };
}
function Sq(e) {
  const {
    theme: t,
    name: n,
    props: r
  } = e;
  return !t || !t.components || !t.components[n] || !t.components[n].defaultProps ? r : Mz(t.components[n].defaultProps, r);
}
function wq({
  props: e,
  name: t,
  defaultTheme: n,
  themeId: r
}) {
  let a = Xz(n);
  return r && (a = a[r] || a), Sq({
    theme: a,
    name: t,
    props: e
  });
}
function eM(e, t = 0, n = 1) {
  return process.env.NODE_ENV !== "production" && (e < t || e > n) && console.error(`MUI: The value provided ${e} is out of range [${t}, ${n}].`), Math.min(Math.max(t, e), n);
}
function Cq(e) {
  e = e.slice(1);
  const t = new RegExp(`.{1,${e.length >= 6 ? 2 : 1}}`, "g");
  let n = e.match(t);
  return n && n[0].length === 1 && (n = n.map((r) => r + r)), n ? `rgb${n.length === 4 ? "a" : ""}(${n.map((r, a) => a < 3 ? parseInt(r, 16) : Math.round(parseInt(r, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function eg(e) {
  if (e.type)
    return e;
  if (e.charAt(0) === "#")
    return eg(Cq(e));
  const t = e.indexOf("("), n = e.substring(0, t);
  if (["rgb", "rgba", "hsl", "hsla", "color"].indexOf(n) === -1)
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported \`${e}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : bb(9, e));
  let r = e.substring(t + 1, e.length - 1), a;
  if (n === "color") {
    if (r = r.split(" "), a = r.shift(), r.length === 4 && r[3].charAt(0) === "/" && (r[3] = r[3].slice(1)), ["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].indexOf(a) === -1)
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: unsupported \`${a}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : bb(10, a));
  } else
    r = r.split(",");
  return r = r.map((s) => parseFloat(s)), {
    type: n,
    values: r,
    colorSpace: a
  };
}
function pS(e) {
  const {
    type: t,
    colorSpace: n
  } = e;
  let {
    values: r
  } = e;
  return t.indexOf("rgb") !== -1 ? r = r.map((a, s) => s < 3 ? parseInt(a, 10) : a) : t.indexOf("hsl") !== -1 && (r[1] = `${r[1]}%`, r[2] = `${r[2]}%`), t.indexOf("color") !== -1 ? r = `${n} ${r.join(" ")}` : r = `${r.join(", ")}`, `${t}(${r})`;
}
function Rq(e) {
  e = eg(e);
  const {
    values: t
  } = e, n = t[0], r = t[1] / 100, a = t[2] / 100, s = r * Math.min(a, 1 - a), l = (y, b = (y + n / 30) % 12) => a - s * Math.max(Math.min(b - 3, 9 - b, 1), -1);
  let p = "rgb";
  const h = [Math.round(l(0) * 255), Math.round(l(8) * 255), Math.round(l(4) * 255)];
  return e.type === "hsla" && (p += "a", h.push(t[3])), pS({
    type: p,
    values: h
  });
}
function v2(e) {
  e = eg(e);
  let t = e.type === "hsl" || e.type === "hsla" ? eg(Rq(e)).values : e.values;
  return t = t.map((n) => (e.type !== "color" && (n /= 255), n <= 0.03928 ? n / 12.92 : ((n + 0.055) / 1.055) ** 2.4)), Number((0.2126 * t[0] + 0.7152 * t[1] + 0.0722 * t[2]).toFixed(3));
}
function h2(e, t) {
  const n = v2(e), r = v2(t);
  return (Math.max(n, r) + 0.05) / (Math.min(n, r) + 0.05);
}
function Jm(e, t) {
  return e = eg(e), t = eM(t), (e.type === "rgb" || e.type === "hsl") && (e.type += "a"), e.type === "color" ? e.values[3] = `/${t}` : e.values[3] = t, pS(e);
}
function Tq(e, t) {
  if (e = eg(e), t = eM(t), e.type.indexOf("hsl") !== -1)
    e.values[2] *= 1 - t;
  else if (e.type.indexOf("rgb") !== -1 || e.type.indexOf("color") !== -1)
    for (let n = 0; n < 3; n += 1)
      e.values[n] *= 1 - t;
  return pS(e);
}
function Oq(e, t) {
  if (e = eg(e), t = eM(t), e.type.indexOf("hsl") !== -1)
    e.values[2] += (100 - e.values[2]) * t;
  else if (e.type.indexOf("rgb") !== -1)
    for (let n = 0; n < 3; n += 1)
      e.values[n] += (255 - e.values[n]) * t;
  else if (e.type.indexOf("color") !== -1)
    for (let n = 0; n < 3; n += 1)
      e.values[n] += (1 - e.values[n]) * t;
  return pS(e);
}
function Dq(e, t, n) {
  return st({
    toolbar: {
      minHeight: 56,
      [`${e.up("xs")} and (orientation: landscape)`]: {
        minHeight: 48
      },
      [e.up("sm")]: {
        minHeight: 64
      }
    }
  }, n);
}
const Mq = {
  black: "#000",
  white: "#fff"
}, Cb = Mq, Aq = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
}, Pq = Aq, Nq = {
  50: "#f3e5f5",
  100: "#e1bee7",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  600: "#8e24aa",
  700: "#7b1fa2",
  800: "#6a1b9a",
  900: "#4a148c",
  A100: "#ea80fc",
  A200: "#e040fb",
  A400: "#d500f9",
  A700: "#aa00ff"
}, Lm = Nq, kq = {
  50: "#ffebee",
  100: "#ffcdd2",
  200: "#ef9a9a",
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  600: "#e53935",
  700: "#d32f2f",
  800: "#c62828",
  900: "#b71c1c",
  A100: "#ff8a80",
  A200: "#ff5252",
  A400: "#ff1744",
  A700: "#d50000"
}, Bm = kq, Iq = {
  50: "#fff3e0",
  100: "#ffe0b2",
  200: "#ffcc80",
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  600: "#fb8c00",
  700: "#f57c00",
  800: "#ef6c00",
  900: "#e65100",
  A100: "#ffd180",
  A200: "#ffab40",
  A400: "#ff9100",
  A700: "#ff6d00"
}, Y0 = Iq, Lq = {
  50: "#e3f2fd",
  100: "#bbdefb",
  200: "#90caf9",
  300: "#64b5f6",
  400: "#42a5f5",
  500: "#2196f3",
  600: "#1e88e5",
  700: "#1976d2",
  800: "#1565c0",
  900: "#0d47a1",
  A100: "#82b1ff",
  A200: "#448aff",
  A400: "#2979ff",
  A700: "#2962ff"
}, zm = Lq, Bq = {
  50: "#e1f5fe",
  100: "#b3e5fc",
  200: "#81d4fa",
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  600: "#039be5",
  700: "#0288d1",
  800: "#0277bd",
  900: "#01579b",
  A100: "#80d8ff",
  A200: "#40c4ff",
  A400: "#00b0ff",
  A700: "#0091ea"
}, Fm = Bq, zq = {
  50: "#e8f5e9",
  100: "#c8e6c9",
  200: "#a5d6a7",
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  600: "#43a047",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20",
  A100: "#b9f6ca",
  A200: "#69f0ae",
  A400: "#00e676",
  A700: "#00c853"
}, $m = zq, Fq = ["mode", "contrastThreshold", "tonalOffset"], g2 = {
  text: {
    primary: "rgba(0, 0, 0, 0.87)",
    secondary: "rgba(0, 0, 0, 0.6)",
    disabled: "rgba(0, 0, 0, 0.38)"
  },
  divider: "rgba(0, 0, 0, 0.12)",
  background: {
    paper: Cb.white,
    default: Cb.white
  },
  action: {
    active: "rgba(0, 0, 0, 0.54)",
    hover: "rgba(0, 0, 0, 0.04)",
    hoverOpacity: 0.04,
    selected: "rgba(0, 0, 0, 0.08)",
    selectedOpacity: 0.08,
    disabled: "rgba(0, 0, 0, 0.26)",
    disabledBackground: "rgba(0, 0, 0, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(0, 0, 0, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
}, sT = {
  text: {
    primary: Cb.white,
    secondary: "rgba(255, 255, 255, 0.7)",
    disabled: "rgba(255, 255, 255, 0.5)",
    icon: "rgba(255, 255, 255, 0.5)"
  },
  divider: "rgba(255, 255, 255, 0.12)",
  background: {
    paper: "#121212",
    default: "#121212"
  },
  action: {
    active: Cb.white,
    hover: "rgba(255, 255, 255, 0.08)",
    hoverOpacity: 0.08,
    selected: "rgba(255, 255, 255, 0.16)",
    selectedOpacity: 0.16,
    disabled: "rgba(255, 255, 255, 0.3)",
    disabledBackground: "rgba(255, 255, 255, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(255, 255, 255, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};
function m2(e, t, n, r) {
  const a = r.light || r, s = r.dark || r * 1.5;
  e[t] || (e.hasOwnProperty(n) ? e[t] = e[n] : t === "light" ? e.light = Oq(e.main, a) : t === "dark" && (e.dark = Tq(e.main, s)));
}
function $q(e = "light") {
  return e === "dark" ? {
    main: zm[200],
    light: zm[50],
    dark: zm[400]
  } : {
    main: zm[700],
    light: zm[400],
    dark: zm[800]
  };
}
function Uq(e = "light") {
  return e === "dark" ? {
    main: Lm[200],
    light: Lm[50],
    dark: Lm[400]
  } : {
    main: Lm[500],
    light: Lm[300],
    dark: Lm[700]
  };
}
function Vq(e = "light") {
  return e === "dark" ? {
    main: Bm[500],
    light: Bm[300],
    dark: Bm[700]
  } : {
    main: Bm[700],
    light: Bm[400],
    dark: Bm[800]
  };
}
function jq(e = "light") {
  return e === "dark" ? {
    main: Fm[400],
    light: Fm[300],
    dark: Fm[700]
  } : {
    main: Fm[700],
    light: Fm[500],
    dark: Fm[900]
  };
}
function Wq(e = "light") {
  return e === "dark" ? {
    main: $m[400],
    light: $m[300],
    dark: $m[700]
  } : {
    main: $m[800],
    light: $m[500],
    dark: $m[900]
  };
}
function Gq(e = "light") {
  return e === "dark" ? {
    main: Y0[400],
    light: Y0[300],
    dark: Y0[700]
  } : {
    main: "#ed6c02",
    light: Y0[500],
    dark: Y0[900]
  };
}
function Hq(e) {
  const {
    mode: t = "light",
    contrastThreshold: n = 3,
    tonalOffset: r = 0.2
  } = e, a = Ir(e, Fq), s = e.primary || $q(t), l = e.secondary || Uq(t), p = e.error || Vq(t), h = e.info || jq(t), y = e.success || Wq(t), b = e.warning || Gq(t);
  function E(O) {
    const D = h2(O, sT.text.primary) >= n ? sT.text.primary : g2.text.primary;
    if (process.env.NODE_ENV !== "production") {
      const A = h2(O, D);
      A < 3 && console.error([`MUI: The contrast ratio of ${A}:1 for ${D} on ${O}`, "falls below the WCAG recommended absolute minimum contrast ratio of 3:1.", "https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"].join(`
`));
    }
    return D;
  }
  const x = ({
    color: O,
    name: D,
    mainShade: A = 500,
    lightShade: B = 300,
    darkShade: I = 700
  }) => {
    if (O = st({}, O), !O.main && O[A] && (O.main = O[A]), !O.hasOwnProperty("main"))
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${D ? ` (${D})` : ""} provided to augmentColor(color) is invalid.
The color object needs to have a \`main\` property or a \`${A}\` property.` : bb(11, D ? ` (${D})` : "", A));
    if (typeof O.main != "string")
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${D ? ` (${D})` : ""} provided to augmentColor(color) is invalid.
\`color.main\` should be a string, but \`${JSON.stringify(O.main)}\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@mui/material/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });` : bb(12, D ? ` (${D})` : "", JSON.stringify(O.main)));
    return m2(O, "light", B, r), m2(O, "dark", I, r), O.contrastText || (O.contrastText = E(O.main)), O;
  }, C = {
    dark: sT,
    light: g2
  };
  return process.env.NODE_ENV !== "production" && (C[t] || console.error(`MUI: The palette mode \`${t}\` is not supported.`)), md(st({
    common: Cb,
    mode: t,
    primary: x({
      color: s,
      name: "primary"
    }),
    secondary: x({
      color: l,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    error: x({
      color: p,
      name: "error"
    }),
    warning: x({
      color: b,
      name: "warning"
    }),
    info: x({
      color: h,
      name: "info"
    }),
    success: x({
      color: y,
      name: "success"
    }),
    grey: Pq,
    contrastThreshold: n,
    getContrastText: E,
    augmentColor: x,
    tonalOffset: r
  }, C[t]), a);
}
const Yq = ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"];
function qq(e) {
  return Math.round(e * 1e5) / 1e5;
}
const y2 = {
  textTransform: "uppercase"
}, b2 = '"Roboto", "Helvetica", "Arial", sans-serif';
function Xq(e, t) {
  const n = typeof t == "function" ? t(e) : t, {
    fontFamily: r = b2,
    fontSize: a = 14,
    fontWeightLight: s = 300,
    fontWeightRegular: l = 400,
    fontWeightMedium: p = 500,
    fontWeightBold: h = 700,
    htmlFontSize: y = 16,
    allVariants: b,
    pxToRem: E
  } = n, x = Ir(n, Yq);
  process.env.NODE_ENV !== "production" && (typeof a != "number" && console.error("MUI: `fontSize` is required to be a number."), typeof y != "number" && console.error("MUI: `htmlFontSize` is required to be a number."));
  const C = a / 14, T = E || ((A) => `${A / y * C}rem`), O = (A, B, I, L, k) => st({
    fontFamily: r,
    fontWeight: A,
    fontSize: T(B),
    lineHeight: I
  }, r === b2 ? {
    letterSpacing: `${qq(L / B)}em`
  } : {}, k, b), D = {
    h1: O(s, 96, 1.167, -1.5),
    h2: O(s, 60, 1.2, -0.5),
    h3: O(l, 48, 1.167, 0),
    h4: O(l, 34, 1.235, 0.25),
    h5: O(l, 24, 1.334, 0),
    h6: O(p, 20, 1.6, 0.15),
    subtitle1: O(l, 16, 1.75, 0.15),
    subtitle2: O(p, 14, 1.57, 0.1),
    body1: O(l, 16, 1.5, 0.15),
    body2: O(l, 14, 1.43, 0.15),
    button: O(p, 14, 1.75, 0.4, y2),
    caption: O(l, 12, 1.66, 0.4),
    overline: O(l, 12, 2.66, 1, y2)
  };
  return md(st({
    htmlFontSize: y,
    pxToRem: T,
    fontFamily: r,
    fontSize: a,
    fontWeightLight: s,
    fontWeightRegular: l,
    fontWeightMedium: p,
    fontWeightBold: h
  }, D), x, {
    clone: !1
  });
}
const Kq = 0.2, Qq = 0.14, Zq = 0.12;
function Xr(...e) {
  return [`${e[0]}px ${e[1]}px ${e[2]}px ${e[3]}px rgba(0,0,0,${Kq})`, `${e[4]}px ${e[5]}px ${e[6]}px ${e[7]}px rgba(0,0,0,${Qq})`, `${e[8]}px ${e[9]}px ${e[10]}px ${e[11]}px rgba(0,0,0,${Zq})`].join(",");
}
const Jq = ["none", Xr(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), Xr(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), Xr(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), Xr(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), Xr(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), Xr(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), Xr(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), Xr(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), Xr(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), Xr(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), Xr(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), Xr(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), Xr(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), Xr(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), Xr(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), Xr(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), Xr(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), Xr(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), Xr(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), Xr(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), Xr(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), Xr(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), Xr(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), Xr(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)], e7 = Jq, t7 = ["duration", "easing", "delay"], n7 = {
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, bO = {
  shortest: 150,
  shorter: 200,
  short: 250,
  standard: 300,
  complex: 375,
  enteringScreen: 225,
  leavingScreen: 195
};
function _2(e) {
  return `${Math.round(e)}ms`;
}
function r7(e) {
  if (!e)
    return 0;
  const t = e / 36;
  return Math.round((4 + 15 * t ** 0.25 + t / 5) * 10);
}
function i7(e) {
  const t = st({}, n7, e.easing), n = st({}, bO, e.duration);
  return st({
    getAutoHeightDuration: r7,
    create: (a = ["all"], s = {}) => {
      const {
        duration: l = n.standard,
        easing: p = t.easeInOut,
        delay: h = 0
      } = s, y = Ir(s, t7);
      if (process.env.NODE_ENV !== "production") {
        const b = (x) => typeof x == "string", E = (x) => !isNaN(parseFloat(x));
        !b(a) && !Array.isArray(a) && console.error('MUI: Argument "props" must be a string or Array.'), !E(l) && !b(l) && console.error(`MUI: Argument "duration" must be a number or a string but found ${l}.`), b(p) || console.error('MUI: Argument "easing" must be a string.'), !E(h) && !b(h) && console.error('MUI: Argument "delay" must be a number or a string.'), Object.keys(y).length !== 0 && console.error(`MUI: Unrecognized argument(s) [${Object.keys(y).join(",")}].`);
      }
      return (Array.isArray(a) ? a : [a]).map((b) => `${b} ${typeof l == "string" ? l : _2(l)} ${p} ${typeof h == "string" ? h : _2(h)}`).join(",");
    }
  }, e, {
    easing: t,
    duration: n
  });
}
const a7 = {
  mobileStepper: 1e3,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
}, o7 = a7, s7 = ["breakpoints", "mixins", "spacing", "palette", "transitions", "typography", "shape"];
function u7(e = {}, ...t) {
  const {
    mixins: n = {},
    palette: r = {},
    transitions: a = {},
    typography: s = {}
  } = e, l = Ir(e, s7), p = Hq(r), h = JD(e);
  let y = md(h, {
    mixins: Dq(h.breakpoints, h.spacing, n),
    palette: p,
    shadows: e7.slice(),
    typography: Xq(p, s),
    transitions: i7(a),
    zIndex: st({}, o7)
  });
  if (y = md(y, l), y = t.reduce((b, E) => md(b, E), y), process.env.NODE_ENV !== "production") {
    const b = ["active", "checked", "completed", "disabled", "error", "expanded", "focused", "focusVisible", "required", "selected"], E = (x, C) => {
      let T;
      for (T in x) {
        const O = x[T];
        if (b.indexOf(T) !== -1 && Object.keys(O).length > 0) {
          if (process.env.NODE_ENV !== "production") {
            const D = rf("", T);
            console.error([`MUI: The \`${C}\` component increases the CSS specificity of the \`${T}\` internal state.`, "You can not override it like this: ", JSON.stringify(x, null, 2), "", `Instead, you need to use the '&.${D}' syntax:`, JSON.stringify({
              root: {
                [`&.${D}`]: O
              }
            }, null, 2), "", "https://mui.com/r/state-classes-guide"].join(`
`));
          }
          x[T] = {};
        }
      }
    };
    Object.keys(y.components).forEach((x) => {
      const C = y.components[x].styleOverrides;
      C && x.indexOf("Mui") === 0 && E(C, x);
    });
  }
  return y;
}
const l7 = u7(), tM = l7, nM = (e) => WE(e) && e !== "classes", c7 = xq({
  defaultTheme: tM,
  rootShouldForwardProp: nM
}), os = c7;
function Cd({
  props: e,
  name: t
}) {
  return wq({
    props: e,
    name: t,
    defaultTheme: tM
  });
}
const Qz = /* @__PURE__ */ Ze.createContext({});
process.env.NODE_ENV !== "production" && (Qz.displayName = "ListContext");
const _O = Qz;
function f7(e) {
  return rf("MuiList", e);
}
rl("MuiList", ["root", "padding", "dense", "subheader"]);
const d7 = ["children", "className", "component", "dense", "disablePadding", "subheader"], p7 = (e) => {
  const {
    classes: t,
    disablePadding: n,
    dense: r,
    subheader: a
  } = e;
  return rv({
    root: ["root", !n && "padding", r && "dense", a && "subheader"]
  }, f7, t);
}, v7 = os("ul", {
  name: "MuiList",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, !n.disablePadding && t.padding, n.dense && t.dense, n.subheader && t.subheader];
  }
})(({
  ownerState: e
}) => st({
  listStyle: "none",
  margin: 0,
  padding: 0,
  position: "relative"
}, !e.disablePadding && {
  paddingTop: 8,
  paddingBottom: 8
}, e.subheader && {
  paddingTop: 0
})), Zz = /* @__PURE__ */ Ze.forwardRef(function(t, n) {
  const r = Cd({
    props: t,
    name: "MuiList"
  }), {
    children: a,
    className: s,
    component: l = "ul",
    dense: p = !1,
    disablePadding: h = !1,
    subheader: y
  } = r, b = Ir(r, d7), E = Ze.useMemo(() => ({
    dense: p
  }), [p]), x = st({}, r, {
    component: l,
    dense: p,
    disablePadding: h
  }), C = p7(x);
  return /* @__PURE__ */ He(_O.Provider, {
    value: E,
    children: /* @__PURE__ */ qi(v7, st({
      as: l,
      className: ba(C.root, s),
      ref: n,
      ownerState: x
    }, b, {
      children: [y, a]
    }))
  });
});
process.env.NODE_ENV !== "production" && (Zz.propTypes = {
  children: V.exports.node,
  classes: V.exports.object,
  className: V.exports.string,
  component: V.exports.elementType,
  dense: V.exports.bool,
  disablePadding: V.exports.bool,
  subheader: V.exports.node,
  sx: V.exports.oneOfType([V.exports.arrayOf(V.exports.oneOfType([V.exports.func, V.exports.object, V.exports.bool])), V.exports.func, V.exports.object])
});
const h7 = Zz, g7 = ["actions", "autoFocus", "autoFocusItem", "children", "className", "disabledItemsFocusable", "disableListWrap", "onKeyDown", "variant"];
function uT(e, t, n) {
  return e === t ? e.firstChild : t && t.nextElementSibling ? t.nextElementSibling : n ? null : e.firstChild;
}
function E2(e, t, n) {
  return e === t ? n ? e.firstChild : e.lastChild : t && t.previousElementSibling ? t.previousElementSibling : n ? null : e.lastChild;
}
function Jz(e, t) {
  if (t === void 0)
    return !0;
  let n = e.innerText;
  return n === void 0 && (n = e.textContent), n = n.trim().toLowerCase(), n.length === 0 ? !1 : t.repeating ? n[0] === t.keys[0] : n.indexOf(t.keys.join("")) === 0;
}
function q0(e, t, n, r, a, s) {
  let l = !1, p = a(e, t, t ? n : !1);
  for (; p; ) {
    if (p === e.firstChild) {
      if (l)
        return !1;
      l = !0;
    }
    const h = r ? !1 : p.disabled || p.getAttribute("aria-disabled") === "true";
    if (!p.hasAttribute("tabindex") || !Jz(p, s) || h)
      p = a(e, p, n);
    else
      return p.focus(), !0;
  }
  return !1;
}
const e3 = /* @__PURE__ */ Ze.forwardRef(function(t, n) {
  const {
    actions: r,
    autoFocus: a = !1,
    autoFocusItem: s = !1,
    children: l,
    className: p,
    disabledItemsFocusable: h = !1,
    disableListWrap: y = !1,
    onKeyDown: b,
    variant: E = "selectedMenu"
  } = t, x = Ir(t, g7), C = Ze.useRef(null), T = Ze.useRef({
    keys: [],
    repeating: !0,
    previousKeyMatched: !0,
    lastTime: null
  });
  Eb(() => {
    a && C.current.focus();
  }, [a]), Ze.useImperativeHandle(r, () => ({
    adjustStyleForScrollbar: (I, L) => {
      const k = !C.current.style.width;
      if (I.clientHeight < C.current.clientHeight && k) {
        const $ = `${Rz(rc(I))}px`;
        C.current.style[L.direction === "rtl" ? "paddingLeft" : "paddingRight"] = $, C.current.style.width = `calc(100% + ${$})`;
      }
      return C.current;
    }
  }), []);
  const O = (I) => {
    const L = C.current, k = I.key, $ = rc(L).activeElement;
    if (k === "ArrowDown")
      I.preventDefault(), q0(L, $, y, h, uT);
    else if (k === "ArrowUp")
      I.preventDefault(), q0(L, $, y, h, E2);
    else if (k === "Home")
      I.preventDefault(), q0(L, null, y, h, uT);
    else if (k === "End")
      I.preventDefault(), q0(L, null, y, h, E2);
    else if (k.length === 1) {
      const U = T.current, K = k.toLowerCase(), X = performance.now();
      U.keys.length > 0 && (X - U.lastTime > 500 ? (U.keys = [], U.repeating = !0, U.previousKeyMatched = !0) : U.repeating && K !== U.keys[0] && (U.repeating = !1)), U.lastTime = X, U.keys.push(K);
      const Y = $ && !U.repeating && Jz($, U);
      U.previousKeyMatched && (Y || q0(L, $, !1, h, uT, U)) ? I.preventDefault() : U.previousKeyMatched = !1;
    }
    b && b(I);
  }, D = eu(C, n);
  let A = -1;
  Ze.Children.forEach(l, (I, L) => {
    !/* @__PURE__ */ Ze.isValidElement(I) || (process.env.NODE_ENV !== "production" && VD.exports.isFragment(I) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), I.props.disabled || (E === "selectedMenu" && I.props.selected || A === -1) && (A = L));
  });
  const B = Ze.Children.map(l, (I, L) => {
    if (L === A) {
      const k = {};
      return s && (k.autoFocus = !0), I.props.tabIndex === void 0 && E === "selectedMenu" && (k.tabIndex = 0), /* @__PURE__ */ Ze.cloneElement(I, k);
    }
    return I;
  });
  return /* @__PURE__ */ He(h7, st({
    role: "menu",
    ref: D,
    className: p,
    onKeyDown: O,
    tabIndex: a ? 0 : -1
  }, x, {
    children: B
  }));
});
process.env.NODE_ENV !== "production" && (e3.propTypes = {
  autoFocus: V.exports.bool,
  autoFocusItem: V.exports.bool,
  children: V.exports.node,
  className: V.exports.string,
  disabledItemsFocusable: V.exports.bool,
  disableListWrap: V.exports.bool,
  onKeyDown: V.exports.func,
  variant: V.exports.oneOf(["menu", "selectedMenu"])
});
const m7 = e3;
function vS() {
  const e = Xz(tM);
  return process.env.NODE_ENV !== "production" && Ze.useDebugValue(e), e;
}
function y7(e) {
  return rf("MuiPaper", e);
}
rl("MuiPaper", ["root", "rounded", "outlined", "elevation", "elevation0", "elevation1", "elevation2", "elevation3", "elevation4", "elevation5", "elevation6", "elevation7", "elevation8", "elevation9", "elevation10", "elevation11", "elevation12", "elevation13", "elevation14", "elevation15", "elevation16", "elevation17", "elevation18", "elevation19", "elevation20", "elevation21", "elevation22", "elevation23", "elevation24"]);
const b7 = ["className", "component", "elevation", "square", "variant"], x2 = (e) => {
  let t;
  return e < 1 ? t = 5.11916 * e ** 2 : t = 4.5 * Math.log(e + 1) + 2, (t / 100).toFixed(2);
}, _7 = (e) => {
  const {
    square: t,
    elevation: n,
    variant: r,
    classes: a
  } = e, s = {
    root: ["root", r, !t && "rounded", r === "elevation" && `elevation${n}`]
  };
  return rv(s, y7, a);
}, E7 = os("div", {
  name: "MuiPaper",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], !n.square && t.rounded, n.variant === "elevation" && t[`elevation${n.elevation}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => st({
  backgroundColor: e.palette.background.paper,
  color: e.palette.text.primary,
  transition: e.transitions.create("box-shadow")
}, !t.square && {
  borderRadius: e.shape.borderRadius
}, t.variant === "outlined" && {
  border: `1px solid ${e.palette.divider}`
}, t.variant === "elevation" && st({
  boxShadow: e.shadows[t.elevation]
}, e.palette.mode === "dark" && {
  backgroundImage: `linear-gradient(${Jm("#fff", x2(t.elevation))}, ${Jm("#fff", x2(t.elevation))})`
}))), t3 = /* @__PURE__ */ Ze.forwardRef(function(t, n) {
  const r = Cd({
    props: t,
    name: "MuiPaper"
  }), {
    className: a,
    component: s = "div",
    elevation: l = 1,
    square: p = !1,
    variant: h = "elevation"
  } = r, y = Ir(r, b7), b = st({}, r, {
    component: s,
    elevation: l,
    square: p,
    variant: h
  }), E = _7(b);
  return process.env.NODE_ENV !== "production" && vS().shadows[l] === void 0 && console.error([`MUI: The elevation provided <Paper elevation={${l}}> is not available in the theme.`, `Please make sure that \`theme.shadows[${l}]\` is defined.`].join(`
`)), /* @__PURE__ */ He(E7, st({
    as: s,
    ownerState: b,
    className: ba(E.root, a),
    ref: n
  }, y));
});
process.env.NODE_ENV !== "production" && (t3.propTypes = {
  children: V.exports.node,
  classes: V.exports.object,
  className: V.exports.string,
  component: V.exports.elementType,
  elevation: qb(Dz, (e) => {
    const {
      elevation: t,
      variant: n
    } = e;
    return t > 0 && n === "outlined" ? new Error(`MUI: Combining \`elevation={${t}}\` with \`variant="${n}"\` has no effect. Either use \`elevation={0}\` or use a different \`variant\`.`) : null;
  }),
  square: V.exports.bool,
  sx: V.exports.oneOfType([V.exports.arrayOf(V.exports.oneOfType([V.exports.func, V.exports.object, V.exports.bool])), V.exports.func, V.exports.object]),
  variant: V.exports.oneOfType([V.exports.oneOf(["elevation", "outlined"]), V.exports.string])
});
const n3 = t3;
function EO(e, t) {
  return EO = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, a) {
    return r.__proto__ = a, r;
  }, EO(e, t);
}
function r3(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, EO(e, t);
}
const S2 = {
  disabled: !1
};
var x7 = process.env.NODE_ENV !== "production" ? V.exports.oneOfType([V.exports.number, V.exports.shape({
  enter: V.exports.number,
  exit: V.exports.number,
  appear: V.exports.number
}).isRequired]) : null;
process.env.NODE_ENV !== "production" && V.exports.oneOfType([V.exports.string, V.exports.shape({
  enter: V.exports.string,
  exit: V.exports.string,
  active: V.exports.string
}), V.exports.shape({
  enter: V.exports.string,
  enterDone: V.exports.string,
  enterActive: V.exports.string,
  exit: V.exports.string,
  exitDone: V.exports.string,
  exitActive: V.exports.string
})]);
const Rx = Wt.createContext(null);
var S7 = function(t) {
  return t.scrollTop;
}, J0 = "unmounted", Lh = "exited", Bh = "entering", Wm = "entered", xO = "exiting", Rd = /* @__PURE__ */ function(e) {
  r3(t, e);
  function t(r, a) {
    var s;
    s = e.call(this, r, a) || this;
    var l = a, p = l && !l.isMounting ? r.enter : r.appear, h;
    return s.appearStatus = null, r.in ? p ? (h = Lh, s.appearStatus = Bh) : h = Wm : r.unmountOnExit || r.mountOnEnter ? h = J0 : h = Lh, s.state = {
      status: h
    }, s.nextCallback = null, s;
  }
  t.getDerivedStateFromProps = function(a, s) {
    var l = a.in;
    return l && s.status === J0 ? {
      status: Lh
    } : null;
  };
  var n = t.prototype;
  return n.componentDidMount = function() {
    this.updateStatus(!0, this.appearStatus);
  }, n.componentDidUpdate = function(a) {
    var s = null;
    if (a !== this.props) {
      var l = this.state.status;
      this.props.in ? l !== Bh && l !== Wm && (s = Bh) : (l === Bh || l === Wm) && (s = xO);
    }
    this.updateStatus(!1, s);
  }, n.componentWillUnmount = function() {
    this.cancelNextCallback();
  }, n.getTimeouts = function() {
    var a = this.props.timeout, s, l, p;
    return s = l = p = a, a != null && typeof a != "number" && (s = a.exit, l = a.enter, p = a.appear !== void 0 ? a.appear : l), {
      exit: s,
      enter: l,
      appear: p
    };
  }, n.updateStatus = function(a, s) {
    if (a === void 0 && (a = !1), s !== null)
      if (this.cancelNextCallback(), s === Bh) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var l = this.props.nodeRef ? this.props.nodeRef.current : lE.findDOMNode(this);
          l && S7(l);
        }
        this.performEnter(a);
      } else
        this.performExit();
    else
      this.props.unmountOnExit && this.state.status === Lh && this.setState({
        status: J0
      });
  }, n.performEnter = function(a) {
    var s = this, l = this.props.enter, p = this.context ? this.context.isMounting : a, h = this.props.nodeRef ? [p] : [lE.findDOMNode(this), p], y = h[0], b = h[1], E = this.getTimeouts(), x = p ? E.appear : E.enter;
    if (!a && !l || S2.disabled) {
      this.safeSetState({
        status: Wm
      }, function() {
        s.props.onEntered(y);
      });
      return;
    }
    this.props.onEnter(y, b), this.safeSetState({
      status: Bh
    }, function() {
      s.props.onEntering(y, b), s.onTransitionEnd(x, function() {
        s.safeSetState({
          status: Wm
        }, function() {
          s.props.onEntered(y, b);
        });
      });
    });
  }, n.performExit = function() {
    var a = this, s = this.props.exit, l = this.getTimeouts(), p = this.props.nodeRef ? void 0 : lE.findDOMNode(this);
    if (!s || S2.disabled) {
      this.safeSetState({
        status: Lh
      }, function() {
        a.props.onExited(p);
      });
      return;
    }
    this.props.onExit(p), this.safeSetState({
      status: xO
    }, function() {
      a.props.onExiting(p), a.onTransitionEnd(l.exit, function() {
        a.safeSetState({
          status: Lh
        }, function() {
          a.props.onExited(p);
        });
      });
    });
  }, n.cancelNextCallback = function() {
    this.nextCallback !== null && (this.nextCallback.cancel(), this.nextCallback = null);
  }, n.safeSetState = function(a, s) {
    s = this.setNextCallback(s), this.setState(a, s);
  }, n.setNextCallback = function(a) {
    var s = this, l = !0;
    return this.nextCallback = function(p) {
      l && (l = !1, s.nextCallback = null, a(p));
    }, this.nextCallback.cancel = function() {
      l = !1;
    }, this.nextCallback;
  }, n.onTransitionEnd = function(a, s) {
    this.setNextCallback(s);
    var l = this.props.nodeRef ? this.props.nodeRef.current : lE.findDOMNode(this), p = a == null && !this.props.addEndListener;
    if (!l || p) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var h = this.props.nodeRef ? [this.nextCallback] : [l, this.nextCallback], y = h[0], b = h[1];
      this.props.addEndListener(y, b);
    }
    a != null && setTimeout(this.nextCallback, a);
  }, n.render = function() {
    var a = this.state.status;
    if (a === J0)
      return null;
    var s = this.props, l = s.children;
    s.in, s.mountOnEnter, s.unmountOnExit, s.appear, s.enter, s.exit, s.timeout, s.addEndListener, s.onEnter, s.onEntering, s.onEntered, s.onExit, s.onExiting, s.onExited, s.nodeRef;
    var p = Ir(s, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return /* @__PURE__ */ He(Rx.Provider, {
      value: null,
      children: typeof l == "function" ? l(a, p) : Wt.cloneElement(Wt.Children.only(l), p)
    });
  }, t;
}(Wt.Component);
Rd.contextType = Rx;
Rd.propTypes = process.env.NODE_ENV !== "production" ? {
  nodeRef: V.exports.shape({
    current: typeof Element > "u" ? V.exports.any : function(e, t, n, r, a, s) {
      var l = e[t];
      return V.exports.instanceOf(l && "ownerDocument" in l ? l.ownerDocument.defaultView.Element : Element)(e, t, n, r, a, s);
    }
  }),
  children: V.exports.oneOfType([V.exports.func.isRequired, V.exports.element.isRequired]).isRequired,
  in: V.exports.bool,
  mountOnEnter: V.exports.bool,
  unmountOnExit: V.exports.bool,
  appear: V.exports.bool,
  enter: V.exports.bool,
  exit: V.exports.bool,
  timeout: function(t) {
    var n = x7;
    t.addEndListener || (n = n.isRequired);
    for (var r = arguments.length, a = new Array(r > 1 ? r - 1 : 0), s = 1; s < r; s++)
      a[s - 1] = arguments[s];
    return n.apply(void 0, [t].concat(a));
  },
  addEndListener: V.exports.func,
  onEnter: V.exports.func,
  onEntering: V.exports.func,
  onEntered: V.exports.func,
  onExit: V.exports.func,
  onExiting: V.exports.func,
  onExited: V.exports.func
} : {};
function Um() {
}
Rd.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: Um,
  onEntering: Um,
  onEntered: Um,
  onExit: Um,
  onExiting: Um,
  onExited: Um
};
Rd.UNMOUNTED = J0;
Rd.EXITED = Lh;
Rd.ENTERING = Bh;
Rd.ENTERED = Wm;
Rd.EXITING = xO;
const i3 = Rd;
function w7(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function rM(e, t) {
  var n = function(s) {
    return t && OE(s) ? t(s) : s;
  }, r = /* @__PURE__ */ Object.create(null);
  return e && NU.map(e, function(a) {
    return a;
  }).forEach(function(a) {
    r[a.key] = n(a);
  }), r;
}
function C7(e, t) {
  e = e || {}, t = t || {};
  function n(b) {
    return b in t ? t[b] : e[b];
  }
  var r = /* @__PURE__ */ Object.create(null), a = [];
  for (var s in e)
    s in t ? a.length && (r[s] = a, a = []) : a.push(s);
  var l, p = {};
  for (var h in t) {
    if (r[h])
      for (l = 0; l < r[h].length; l++) {
        var y = r[h][l];
        p[r[h][l]] = n(y);
      }
    p[h] = n(h);
  }
  for (l = 0; l < a.length; l++)
    p[a[l]] = n(a[l]);
  return p;
}
function Wh(e, t, n) {
  return n[t] != null ? n[t] : e.props[t];
}
function R7(e, t) {
  return rM(e.children, function(n) {
    return DE(n, {
      onExited: t.bind(null, n),
      in: !0,
      appear: Wh(n, "appear", e),
      enter: Wh(n, "enter", e),
      exit: Wh(n, "exit", e)
    });
  });
}
function T7(e, t, n) {
  var r = rM(e.children), a = C7(t, r);
  return Object.keys(a).forEach(function(s) {
    var l = a[s];
    if (!!OE(l)) {
      var p = s in t, h = s in r, y = t[s], b = OE(y) && !y.props.in;
      h && (!p || b) ? a[s] = DE(l, {
        onExited: n.bind(null, l),
        in: !0,
        exit: Wh(l, "exit", e),
        enter: Wh(l, "enter", e)
      }) : !h && p && !b ? a[s] = DE(l, {
        in: !1
      }) : h && p && OE(y) && (a[s] = DE(l, {
        onExited: n.bind(null, l),
        in: y.props.in,
        exit: Wh(l, "exit", e),
        enter: Wh(l, "enter", e)
      }));
    }
  }), a;
}
var O7 = Object.values || function(e) {
  return Object.keys(e).map(function(t) {
    return e[t];
  });
}, D7 = {
  component: "div",
  childFactory: function(t) {
    return t;
  }
}, iM = /* @__PURE__ */ function(e) {
  r3(t, e);
  function t(r, a) {
    var s;
    s = e.call(this, r, a) || this;
    var l = s.handleExited.bind(w7(s));
    return s.state = {
      contextValue: {
        isMounting: !0
      },
      handleExited: l,
      firstRender: !0
    }, s;
  }
  var n = t.prototype;
  return n.componentDidMount = function() {
    this.mounted = !0, this.setState({
      contextValue: {
        isMounting: !1
      }
    });
  }, n.componentWillUnmount = function() {
    this.mounted = !1;
  }, t.getDerivedStateFromProps = function(a, s) {
    var l = s.children, p = s.handleExited, h = s.firstRender;
    return {
      children: h ? R7(a, p) : T7(a, l, p),
      firstRender: !1
    };
  }, n.handleExited = function(a, s) {
    var l = rM(this.props.children);
    a.key in l || (a.props.onExited && a.props.onExited(s), this.mounted && this.setState(function(p) {
      var h = st({}, p.children);
      return delete h[a.key], {
        children: h
      };
    }));
  }, n.render = function() {
    var a = this.props, s = a.component, l = a.childFactory, p = Ir(a, ["component", "childFactory"]), h = this.state.contextValue, y = O7(this.state.children).map(l);
    return delete p.appear, delete p.enter, delete p.exit, s === null ? /* @__PURE__ */ He(Rx.Provider, {
      value: h,
      children: y
    }) : /* @__PURE__ */ He(Rx.Provider, {
      value: h,
      children: /* @__PURE__ */ He(s, {
        ...p,
        children: y
      })
    });
  }, t;
}(Wt.Component);
iM.propTypes = process.env.NODE_ENV !== "production" ? {
  component: V.exports.any,
  children: V.exports.node,
  appear: V.exports.bool,
  enter: V.exports.bool,
  exit: V.exports.bool,
  childFactory: V.exports.func
} : {};
iM.defaultProps = D7;
const M7 = iM, a3 = (e) => e.scrollTop;
function Tx(e, t) {
  var n, r;
  const {
    timeout: a,
    easing: s,
    style: l = {}
  } = e;
  return {
    duration: (n = l.transitionDuration) != null ? n : typeof a == "number" ? a : a[t.mode] || 0,
    easing: (r = l.transitionTimingFunction) != null ? r : typeof s == "object" ? s[t.mode] : s,
    delay: l.transitionDelay
  };
}
const A7 = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"];
function SO(e) {
  return `scale(${e}, ${e ** 2})`;
}
const P7 = {
  entering: {
    opacity: 1,
    transform: SO(1)
  },
  entered: {
    opacity: 1,
    transform: "none"
  }
}, aM = /* @__PURE__ */ Ze.forwardRef(function(t, n) {
  const {
    addEndListener: r,
    appear: a = !0,
    children: s,
    easing: l,
    in: p,
    onEnter: h,
    onEntered: y,
    onEntering: b,
    onExit: E,
    onExited: x,
    onExiting: C,
    style: T,
    timeout: O = "auto",
    TransitionComponent: D = i3
  } = t, A = Ir(t, A7), B = Ze.useRef(), I = Ze.useRef(), L = vS(), k = Ze.useRef(null), $ = eu(s.ref, n), U = eu(k, $), K = (be) => (_e) => {
    if (be) {
      const Se = k.current;
      _e === void 0 ? be(Se) : be(Se, _e);
    }
  }, X = K(b), Y = K((be, _e) => {
    a3(be);
    const {
      duration: Se,
      delay: Oe,
      easing: re
    } = Tx({
      style: T,
      timeout: O,
      easing: l
    }, {
      mode: "enter"
    });
    let ie;
    O === "auto" ? (ie = L.transitions.getAutoHeightDuration(be.clientHeight), I.current = ie) : ie = Se, be.style.transition = [L.transitions.create("opacity", {
      duration: ie,
      delay: Oe
    }), L.transitions.create("transform", {
      duration: ie * 0.666,
      delay: Oe,
      easing: re
    })].join(","), h && h(be, _e);
  }), J = K(y), Q = K(C), Z = K((be) => {
    const {
      duration: _e,
      delay: Se,
      easing: Oe
    } = Tx({
      style: T,
      timeout: O,
      easing: l
    }, {
      mode: "exit"
    });
    let re;
    O === "auto" ? (re = L.transitions.getAutoHeightDuration(be.clientHeight), I.current = re) : re = _e, be.style.transition = [L.transitions.create("opacity", {
      duration: re,
      delay: Se
    }), L.transitions.create("transform", {
      duration: re * 0.666,
      delay: Se || re * 0.333,
      easing: Oe
    })].join(","), be.style.opacity = "0", be.style.transform = SO(0.75), E && E(be);
  }), se = K(x), pe = (be) => {
    O === "auto" && (B.current = setTimeout(be, I.current || 0)), r && r(k.current, be);
  };
  return Ze.useEffect(() => () => {
    clearTimeout(B.current);
  }, []), /* @__PURE__ */ He(D, st({
    appear: a,
    in: p,
    nodeRef: k,
    onEnter: Y,
    onEntered: J,
    onEntering: X,
    onExit: Z,
    onExited: se,
    onExiting: Q,
    addEndListener: pe,
    timeout: O === "auto" ? null : O
  }, A, {
    children: (be, _e) => /* @__PURE__ */ Ze.cloneElement(s, st({
      style: st({
        opacity: 0,
        transform: SO(0.75),
        visibility: be === "exited" && !p ? "hidden" : void 0
      }, P7[be], T, s.props.style),
      ref: U
    }, _e))
  }));
});
process.env.NODE_ENV !== "production" && (aM.propTypes = {
  addEndListener: V.exports.func,
  appear: V.exports.bool,
  children: Xb.isRequired,
  easing: V.exports.oneOfType([V.exports.shape({
    enter: V.exports.string,
    exit: V.exports.string
  }), V.exports.string]),
  in: V.exports.bool,
  onEnter: V.exports.func,
  onEntered: V.exports.func,
  onEntering: V.exports.func,
  onExit: V.exports.func,
  onExited: V.exports.func,
  onExiting: V.exports.func,
  style: V.exports.object,
  timeout: V.exports.oneOfType([V.exports.oneOf(["auto"]), V.exports.number, V.exports.shape({
    appear: V.exports.number,
    enter: V.exports.number,
    exit: V.exports.number
  })])
});
aM.muiSupportAuto = !0;
const N7 = aM, k7 = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"], I7 = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
}, L7 = {
  enter: bO.enteringScreen,
  exit: bO.leavingScreen
}, o3 = /* @__PURE__ */ Ze.forwardRef(function(t, n) {
  const {
    addEndListener: r,
    appear: a = !0,
    children: s,
    easing: l,
    in: p,
    onEnter: h,
    onEntered: y,
    onEntering: b,
    onExit: E,
    onExited: x,
    onExiting: C,
    style: T,
    timeout: O = L7,
    TransitionComponent: D = i3
  } = t, A = Ir(t, k7), B = vS(), I = Ze.useRef(null), L = eu(s.ref, n), k = eu(I, L), $ = (se) => (pe) => {
    if (se) {
      const be = I.current;
      pe === void 0 ? se(be) : se(be, pe);
    }
  }, U = $(b), K = $((se, pe) => {
    a3(se);
    const be = Tx({
      style: T,
      timeout: O,
      easing: l
    }, {
      mode: "enter"
    });
    se.style.webkitTransition = B.transitions.create("opacity", be), se.style.transition = B.transitions.create("opacity", be), h && h(se, pe);
  }), X = $(y), Y = $(C), J = $((se) => {
    const pe = Tx({
      style: T,
      timeout: O,
      easing: l
    }, {
      mode: "exit"
    });
    se.style.webkitTransition = B.transitions.create("opacity", pe), se.style.transition = B.transitions.create("opacity", pe), E && E(se);
  }), Q = $(x);
  return /* @__PURE__ */ He(D, st({
    appear: a,
    in: p,
    nodeRef: I,
    onEnter: K,
    onEntered: X,
    onEntering: U,
    onExit: J,
    onExited: Q,
    onExiting: Y,
    addEndListener: (se) => {
      r && r(I.current, se);
    },
    timeout: O
  }, A, {
    children: (se, pe) => /* @__PURE__ */ Ze.cloneElement(s, st({
      style: st({
        opacity: 0,
        visibility: se === "exited" && !p ? "hidden" : void 0
      }, I7[se], T, s.props.style),
      ref: k
    }, pe))
  }));
});
process.env.NODE_ENV !== "production" && (o3.propTypes = {
  addEndListener: V.exports.func,
  appear: V.exports.bool,
  children: Xb.isRequired,
  easing: V.exports.oneOfType([V.exports.shape({
    enter: V.exports.string,
    exit: V.exports.string
  }), V.exports.string]),
  in: V.exports.bool,
  onEnter: V.exports.func,
  onEntered: V.exports.func,
  onEntering: V.exports.func,
  onExit: V.exports.func,
  onExited: V.exports.func,
  onExiting: V.exports.func,
  style: V.exports.object,
  timeout: V.exports.oneOfType([V.exports.number, V.exports.shape({
    appear: V.exports.number,
    enter: V.exports.number,
    exit: V.exports.number
  })])
});
const B7 = o3, z7 = ["children", "components", "componentsProps", "className", "invisible", "open", "transitionDuration", "TransitionComponent"], F7 = (e) => {
  const {
    classes: t
  } = e;
  return t;
}, $7 = os("div", {
  name: "MuiBackdrop",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.invisible && t.invisible];
  }
})(({
  ownerState: e
}) => st({
  position: "fixed",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  WebkitTapHighlightColor: "transparent"
}, e.invisible && {
  backgroundColor: "transparent"
})), s3 = /* @__PURE__ */ Ze.forwardRef(function(t, n) {
  var r;
  const a = Cd({
    props: t,
    name: "MuiBackdrop"
  }), {
    children: s,
    components: l = {},
    componentsProps: p = {},
    className: h,
    invisible: y = !1,
    open: b,
    transitionDuration: E,
    TransitionComponent: x = B7
  } = a, C = Ir(a, z7), T = st({}, a, {
    invisible: y
  }), O = F7(T);
  return /* @__PURE__ */ He(x, st({
    in: b,
    timeout: E
  }, C, {
    children: /* @__PURE__ */ He(FY, {
      className: h,
      invisible: y,
      components: st({
        Root: $7
      }, l),
      componentsProps: {
        root: st({}, p.root, (!l.Root || !Zx(l.Root)) && {
          ownerState: st({}, (r = p.root) == null ? void 0 : r.ownerState)
        })
      },
      classes: O,
      ref: n,
      children: s
    })
  }));
});
process.env.NODE_ENV !== "production" && (s3.propTypes = {
  children: V.exports.node,
  classes: V.exports.object,
  className: V.exports.string,
  components: V.exports.shape({
    Root: V.exports.elementType
  }),
  componentsProps: V.exports.shape({
    root: V.exports.object
  }),
  invisible: V.exports.bool,
  open: V.exports.bool.isRequired,
  sx: V.exports.oneOfType([V.exports.arrayOf(V.exports.oneOfType([V.exports.func, V.exports.object, V.exports.bool])), V.exports.func, V.exports.object]),
  transitionDuration: V.exports.oneOfType([V.exports.number, V.exports.shape({
    appear: V.exports.number,
    enter: V.exports.number,
    exit: V.exports.number
  })])
});
const U7 = s3, V7 = ["BackdropComponent", "closeAfterTransition", "children", "components", "componentsProps", "disableAutoFocus", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted"], j7 = (e) => e.classes, W7 = os("div", {
  name: "MuiModal",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, !n.open && n.exited && t.hidden];
  }
})(({
  theme: e,
  ownerState: t
}) => st({
  position: "fixed",
  zIndex: e.zIndex.modal,
  right: 0,
  bottom: 0,
  top: 0,
  left: 0
}, !t.open && t.exited && {
  visibility: "hidden"
})), G7 = os(U7, {
  name: "MuiModal",
  slot: "Backdrop",
  overridesResolver: (e, t) => t.backdrop
})({
  zIndex: -1
}), u3 = /* @__PURE__ */ Ze.forwardRef(function(t, n) {
  var r;
  const a = Cd({
    name: "MuiModal",
    props: t
  }), {
    BackdropComponent: s = G7,
    closeAfterTransition: l = !1,
    children: p,
    components: h = {},
    componentsProps: y = {},
    disableAutoFocus: b = !1,
    disableEnforceFocus: E = !1,
    disableEscapeKeyDown: x = !1,
    disablePortal: C = !1,
    disableRestoreFocus: T = !1,
    disableScrollLock: O = !1,
    hideBackdrop: D = !1,
    keepMounted: A = !1
  } = a, B = Ir(a, V7), [I, L] = Ze.useState(!0), k = {
    closeAfterTransition: l,
    disableAutoFocus: b,
    disableEnforceFocus: E,
    disableEscapeKeyDown: x,
    disablePortal: C,
    disableRestoreFocus: T,
    disableScrollLock: O,
    hideBackdrop: D,
    keepMounted: A
  }, $ = st({}, a, k, {
    exited: I
  }), U = j7($);
  return /* @__PURE__ */ He(i8, st({
    components: st({
      Root: W7
    }, h),
    componentsProps: {
      root: st({}, y.root, (!h.Root || !Zx(h.Root)) && {
        ownerState: st({}, (r = y.root) == null ? void 0 : r.ownerState)
      })
    },
    BackdropComponent: s,
    onTransitionEnter: () => L(!1),
    onTransitionExited: () => L(!0),
    ref: n
  }, B, {
    classes: U
  }, k, {
    children: p
  }));
});
process.env.NODE_ENV !== "production" && (u3.propTypes = {
  BackdropComponent: V.exports.elementType,
  BackdropProps: V.exports.object,
  children: Xb.isRequired,
  classes: V.exports.object,
  closeAfterTransition: V.exports.bool,
  components: V.exports.shape({
    Root: V.exports.elementType
  }),
  componentsProps: V.exports.shape({
    root: V.exports.object
  }),
  container: V.exports.oneOfType([Ey, V.exports.func]),
  disableAutoFocus: V.exports.bool,
  disableEnforceFocus: V.exports.bool,
  disableEscapeKeyDown: V.exports.bool,
  disablePortal: V.exports.bool,
  disableRestoreFocus: V.exports.bool,
  disableScrollLock: V.exports.bool,
  hideBackdrop: V.exports.bool,
  keepMounted: V.exports.bool,
  onBackdropClick: V.exports.func,
  onClose: V.exports.func,
  open: V.exports.bool.isRequired,
  sx: V.exports.oneOfType([V.exports.arrayOf(V.exports.oneOfType([V.exports.func, V.exports.object, V.exports.bool])), V.exports.func, V.exports.object])
});
const H7 = u3;
function Y7(e) {
  return rf("MuiPopover", e);
}
rl("MuiPopover", ["root", "paper"]);
const q7 = ["onEntering"], X7 = ["action", "anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "className", "container", "elevation", "marginThreshold", "open", "PaperProps", "transformOrigin", "TransitionComponent", "transitionDuration", "TransitionProps"];
function w2(e, t) {
  let n = 0;
  return typeof t == "number" ? n = t : t === "center" ? n = e.height / 2 : t === "bottom" && (n = e.height), n;
}
function C2(e, t) {
  let n = 0;
  return typeof t == "number" ? n = t : t === "center" ? n = e.width / 2 : t === "right" && (n = e.width), n;
}
function R2(e) {
  return [e.horizontal, e.vertical].map((t) => typeof t == "number" ? `${t}px` : t).join(" ");
}
function GE(e) {
  return typeof e == "function" ? e() : e;
}
const K7 = (e) => {
  const {
    classes: t
  } = e;
  return rv({
    root: ["root"],
    paper: ["paper"]
  }, Y7, t);
}, Q7 = os(H7, {
  name: "MuiPopover",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), Z7 = os(n3, {
  name: "MuiPopover",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})({
  position: "absolute",
  overflowY: "auto",
  overflowX: "hidden",
  minWidth: 16,
  minHeight: 16,
  maxWidth: "calc(100% - 32px)",
  maxHeight: "calc(100% - 32px)",
  outline: 0
}), l3 = /* @__PURE__ */ Ze.forwardRef(function(t, n) {
  const r = Cd({
    props: t,
    name: "MuiPopover"
  }), {
    action: a,
    anchorEl: s,
    anchorOrigin: l = {
      vertical: "top",
      horizontal: "left"
    },
    anchorPosition: p,
    anchorReference: h = "anchorEl",
    children: y,
    className: b,
    container: E,
    elevation: x = 8,
    marginThreshold: C = 16,
    open: T,
    PaperProps: O = {},
    transformOrigin: D = {
      vertical: "top",
      horizontal: "left"
    },
    TransitionComponent: A = N7,
    transitionDuration: B = "auto",
    TransitionProps: {
      onEntering: I
    } = {}
  } = r, L = Ir(r.TransitionProps, q7), k = Ir(r, X7), $ = Ze.useRef(), U = eu($, O.ref), K = st({}, r, {
    anchorOrigin: l,
    anchorReference: h,
    elevation: x,
    marginThreshold: C,
    PaperProps: O,
    transformOrigin: D,
    TransitionComponent: A,
    transitionDuration: B,
    TransitionProps: L
  }), X = K7(K), Y = Ze.useCallback(() => {
    if (h === "anchorPosition")
      return process.env.NODE_ENV !== "production" && (p || console.error('MUI: You need to provide a `anchorPosition` prop when using <Popover anchorReference="anchorPosition" />.')), p;
    const _e = GE(s), Se = _e && _e.nodeType === 1 ? _e : rc($.current).body, Oe = Se.getBoundingClientRect();
    if (process.env.NODE_ENV !== "production") {
      const re = Se.getBoundingClientRect();
      process.env.NODE_ENV !== "test" && re.top === 0 && re.left === 0 && re.right === 0 && re.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    return {
      top: Oe.top + w2(Oe, l.vertical),
      left: Oe.left + C2(Oe, l.horizontal)
    };
  }, [s, l.horizontal, l.vertical, p, h]), J = Ze.useCallback((_e) => ({
    vertical: w2(_e, D.vertical),
    horizontal: C2(_e, D.horizontal)
  }), [D.horizontal, D.vertical]), Q = Ze.useCallback((_e) => {
    const Se = {
      width: _e.offsetWidth,
      height: _e.offsetHeight
    }, Oe = J(Se);
    if (h === "none")
      return {
        top: null,
        left: null,
        transformOrigin: R2(Oe)
      };
    const re = Y();
    let ie = re.top - Oe.vertical, ce = re.left - Oe.horizontal;
    const le = ie + Se.height, fe = ce + Se.width, ve = _b(GE(s)), ee = ve.innerHeight - C, Ae = ve.innerWidth - C;
    if (ie < C) {
      const he = ie - C;
      ie -= he, Oe.vertical += he;
    } else if (le > ee) {
      const he = le - ee;
      ie -= he, Oe.vertical += he;
    }
    if (process.env.NODE_ENV !== "production" && Se.height > ee && Se.height && ee && console.error(["MUI: The popover component is too tall.", `Some part of it can not be seen on the screen (${Se.height - ee}px).`, "Please consider adding a `max-height` to improve the user-experience."].join(`
`)), ce < C) {
      const he = ce - C;
      ce -= he, Oe.horizontal += he;
    } else if (fe > Ae) {
      const he = fe - Ae;
      ce -= he, Oe.horizontal += he;
    }
    return {
      top: `${Math.round(ie)}px`,
      left: `${Math.round(ce)}px`,
      transformOrigin: R2(Oe)
    };
  }, [s, h, Y, J, C]), Z = Ze.useCallback(() => {
    const _e = $.current;
    if (!_e)
      return;
    const Se = Q(_e);
    Se.top !== null && (_e.style.top = Se.top), Se.left !== null && (_e.style.left = Se.left), _e.style.transformOrigin = Se.transformOrigin;
  }, [Q]), se = (_e, Se) => {
    I && I(_e, Se), Z();
  };
  Ze.useEffect(() => {
    T && Z();
  }), Ze.useImperativeHandle(a, () => T ? {
    updatePosition: () => {
      Z();
    }
  } : null, [T, Z]), Ze.useEffect(() => {
    if (!T)
      return;
    const _e = _Y(() => {
      Z();
    }), Se = _b(s);
    return Se.addEventListener("resize", _e), () => {
      _e.clear(), Se.removeEventListener("resize", _e);
    };
  }, [s, T, Z]);
  let pe = B;
  B === "auto" && !A.muiSupportAuto && (pe = void 0);
  const be = E || (s ? rc(GE(s)).body : void 0);
  return /* @__PURE__ */ He(Q7, st({
    BackdropProps: {
      invisible: !0
    },
    className: ba(X.root, b),
    container: be,
    open: T,
    ref: n,
    ownerState: K
  }, k, {
    children: /* @__PURE__ */ He(A, st({
      appear: !0,
      in: T,
      onEntering: se,
      timeout: pe
    }, L, {
      children: /* @__PURE__ */ He(Z7, st({
        elevation: x
      }, O, {
        ref: U,
        className: ba(X.paper, O.className),
        children: y
      }))
    }))
  }));
});
process.env.NODE_ENV !== "production" && (l3.propTypes = {
  action: Cz,
  anchorEl: qb(V.exports.oneOfType([Ey, V.exports.func]), (e) => {
    if (e.open && (!e.anchorReference || e.anchorReference === "anchorEl")) {
      const t = GE(e.anchorEl);
      if (t && t.nodeType === 1) {
        const n = t.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && n.top === 0 && n.left === 0 && n.right === 0 && n.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", `It should be an Element instance but it's \`${t}\` instead.`].join(`
`));
    }
    return null;
  }),
  anchorOrigin: V.exports.shape({
    horizontal: V.exports.oneOfType([V.exports.oneOf(["center", "left", "right"]), V.exports.number]).isRequired,
    vertical: V.exports.oneOfType([V.exports.oneOf(["bottom", "center", "top"]), V.exports.number]).isRequired
  }),
  anchorPosition: V.exports.shape({
    left: V.exports.number.isRequired,
    top: V.exports.number.isRequired
  }),
  anchorReference: V.exports.oneOf(["anchorEl", "anchorPosition", "none"]),
  children: V.exports.node,
  classes: V.exports.object,
  className: V.exports.string,
  container: V.exports.oneOfType([Ey, V.exports.func]),
  elevation: Dz,
  marginThreshold: V.exports.number,
  onClose: V.exports.func,
  open: V.exports.bool.isRequired,
  PaperProps: V.exports.shape({
    component: xz
  }),
  sx: V.exports.oneOfType([V.exports.arrayOf(V.exports.oneOfType([V.exports.func, V.exports.object, V.exports.bool])), V.exports.func, V.exports.object]),
  transformOrigin: V.exports.shape({
    horizontal: V.exports.oneOfType([V.exports.oneOf(["center", "left", "right"]), V.exports.number]).isRequired,
    vertical: V.exports.oneOfType([V.exports.oneOf(["bottom", "center", "top"]), V.exports.number]).isRequired
  }),
  TransitionComponent: V.exports.elementType,
  transitionDuration: V.exports.oneOfType([V.exports.oneOf(["auto"]), V.exports.number, V.exports.shape({
    appear: V.exports.number,
    enter: V.exports.number,
    exit: V.exports.number
  })]),
  TransitionProps: V.exports.object
});
const J7 = l3;
function c3(e) {
  return rf("MuiMenu", e);
}
const eX = rl("MuiMenu", ["root", "paper", "list"]), tX = eX, nX = ["onEntering"], rX = ["autoFocus", "children", "disableAutoFocusItem", "MenuListProps", "onClose", "open", "PaperProps", "PopoverClasses", "transitionDuration", "TransitionProps", "variant"], iX = {
  vertical: "top",
  horizontal: "right"
}, aX = {
  vertical: "top",
  horizontal: "left"
}, oX = (e) => {
  const {
    classes: t
  } = e;
  return rv({
    root: ["root"],
    paper: ["paper"],
    list: ["list"]
  }, c3, t);
}, sX = os(J7, {
  shouldForwardProp: (e) => nM(e) || e === "classes",
  name: "MuiMenu",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), uX = os(n3, {
  name: "MuiMenu",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})({
  maxHeight: "calc(100% - 96px)",
  WebkitOverflowScrolling: "touch"
}), lX = os(m7, {
  name: "MuiMenu",
  slot: "List",
  overridesResolver: (e, t) => t.list
})({
  outline: 0
}), f3 = /* @__PURE__ */ Ze.forwardRef(function(t, n) {
  const r = Cd({
    props: t,
    name: "MuiMenu"
  }), {
    autoFocus: a = !0,
    children: s,
    disableAutoFocusItem: l = !1,
    MenuListProps: p = {},
    onClose: h,
    open: y,
    PaperProps: b = {},
    PopoverClasses: E,
    transitionDuration: x = "auto",
    TransitionProps: {
      onEntering: C
    } = {},
    variant: T = "selectedMenu"
  } = r, O = Ir(r.TransitionProps, nX), D = Ir(r, rX), A = vS(), B = A.direction === "rtl", I = st({}, r, {
    autoFocus: a,
    disableAutoFocusItem: l,
    MenuListProps: p,
    onEntering: C,
    PaperProps: b,
    transitionDuration: x,
    TransitionProps: O,
    variant: T
  }), L = oX(I), k = a && !l && y, $ = Ze.useRef(null), U = (Y, J) => {
    $.current && $.current.adjustStyleForScrollbar(Y, A), C && C(Y, J);
  }, K = (Y) => {
    Y.key === "Tab" && (Y.preventDefault(), h && h(Y, "tabKeyDown"));
  };
  let X = -1;
  return Ze.Children.map(s, (Y, J) => {
    !/* @__PURE__ */ Ze.isValidElement(Y) || (process.env.NODE_ENV !== "production" && VD.exports.isFragment(Y) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), Y.props.disabled || (T === "selectedMenu" && Y.props.selected || X === -1) && (X = J));
  }), /* @__PURE__ */ He(sX, st({
    classes: E,
    onClose: h,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: B ? "right" : "left"
    },
    transformOrigin: B ? iX : aX,
    PaperProps: st({
      component: uX
    }, b, {
      classes: st({}, b.classes, {
        root: L.paper
      })
    }),
    className: L.root,
    open: y,
    ref: n,
    transitionDuration: x,
    TransitionProps: st({
      onEntering: U
    }, O),
    ownerState: I
  }, D, {
    children: /* @__PURE__ */ He(lX, st({
      onKeyDown: K,
      actions: $,
      autoFocus: a && (X === -1 || l),
      autoFocusItem: k,
      variant: T
    }, p, {
      className: ba(L.list, p.className),
      children: s
    }))
  }));
});
process.env.NODE_ENV !== "production" && (f3.propTypes = {
  anchorEl: V.exports.oneOfType([Ey, V.exports.func]),
  autoFocus: V.exports.bool,
  children: V.exports.node,
  classes: V.exports.object,
  disableAutoFocusItem: V.exports.bool,
  MenuListProps: V.exports.object,
  onClose: V.exports.func,
  open: V.exports.bool.isRequired,
  PaperProps: V.exports.object,
  PopoverClasses: V.exports.object,
  sx: V.exports.oneOfType([V.exports.arrayOf(V.exports.oneOfType([V.exports.func, V.exports.object, V.exports.bool])), V.exports.func, V.exports.object]),
  transitionDuration: V.exports.oneOfType([V.exports.oneOf(["auto"]), V.exports.number, V.exports.shape({
    appear: V.exports.number,
    enter: V.exports.number,
    exit: V.exports.number
  })]),
  TransitionProps: V.exports.object,
  variant: V.exports.oneOf(["menu", "selectedMenu"])
});
const cX = f3, fX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: cX,
  menuClasses: tX,
  getMenuUtilityClass: c3
}, Symbol.toStringTag, { value: "Module" })), dX = /* @__PURE__ */ AO(fX);
Object.defineProperty(UD, "__esModule", {
  value: !0
});
var wO = UD.Menu = void 0, d3 = p3(dX), pX = p3(Ay);
function p3(e) {
  return e && e.__esModule ? e : { default: e };
}
const v3 = (0, pX.default)(d3.default)`
    > .MuiPaper-root {
        color: var(--text-primary-color);
        background-color: var(--bg-color);
        box-shadow: var(--evelation-shadow-1);
    }
`;
wO = UD.Menu = v3;
v3.propTypes = d3.default.propTypes;
var Gh = {};
function h3(e) {
  const {
    className: t,
    classes: n,
    pulsate: r = !1,
    rippleX: a,
    rippleY: s,
    rippleSize: l,
    in: p,
    onExited: h,
    timeout: y
  } = e, [b, E] = Ze.useState(!1), x = ba(t, n.ripple, n.rippleVisible, r && n.ripplePulsate), C = {
    width: l,
    height: l,
    top: -(l / 2) + s,
    left: -(l / 2) + a
  }, T = ba(n.child, b && n.childLeaving, r && n.childPulsate);
  return !p && !b && E(!0), Ze.useEffect(() => {
    if (!p && h != null) {
      const O = setTimeout(h, y);
      return () => {
        clearTimeout(O);
      };
    }
  }, [h, p, y]), /* @__PURE__ */ He("span", {
    className: x,
    style: C,
    children: /* @__PURE__ */ He("span", {
      className: T
    })
  });
}
process.env.NODE_ENV !== "production" && (h3.propTypes = {
  classes: V.exports.object.isRequired,
  className: V.exports.string,
  in: V.exports.bool,
  onExited: V.exports.func,
  pulsate: V.exports.bool,
  rippleSize: V.exports.number,
  rippleX: V.exports.number,
  rippleY: V.exports.number,
  timeout: V.exports.number.isRequired
});
const vX = rl("MuiTouchRipple", ["root", "ripple", "rippleVisible", "ripplePulsate", "child", "childLeaving", "childPulsate"]), Yu = vX, hX = ["center", "classes", "className"];
let hS = (e) => e, T2, O2, D2, M2;
const CO = 550, gX = 80, mX = KD(T2 || (T2 = hS`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`)), yX = KD(O2 || (O2 = hS`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`)), bX = KD(D2 || (D2 = hS`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`)), _X = os("span", {
  name: "MuiTouchRipple",
  slot: "Root"
})({
  overflow: "hidden",
  pointerEvents: "none",
  position: "absolute",
  zIndex: 0,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: "inherit"
}), EX = os(h3, {
  name: "MuiTouchRipple",
  slot: "Ripple"
})(M2 || (M2 = hS`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), Yu.rippleVisible, mX, CO, ({
  theme: e
}) => e.transitions.easing.easeInOut, Yu.ripplePulsate, ({
  theme: e
}) => e.transitions.duration.shorter, Yu.child, Yu.childLeaving, yX, CO, ({
  theme: e
}) => e.transitions.easing.easeInOut, Yu.childPulsate, bX, ({
  theme: e
}) => e.transitions.easing.easeInOut), g3 = /* @__PURE__ */ Ze.forwardRef(function(t, n) {
  const r = Cd({
    props: t,
    name: "MuiTouchRipple"
  }), {
    center: a = !1,
    classes: s = {},
    className: l
  } = r, p = Ir(r, hX), [h, y] = Ze.useState([]), b = Ze.useRef(0), E = Ze.useRef(null);
  Ze.useEffect(() => {
    E.current && (E.current(), E.current = null);
  }, [h]);
  const x = Ze.useRef(!1), C = Ze.useRef(null), T = Ze.useRef(null), O = Ze.useRef(null);
  Ze.useEffect(() => () => {
    clearTimeout(C.current);
  }, []);
  const D = Ze.useCallback((L) => {
    const {
      pulsate: k,
      rippleX: $,
      rippleY: U,
      rippleSize: K,
      cb: X
    } = L;
    y((Y) => [...Y, /* @__PURE__ */ He(EX, {
      classes: {
        ripple: ba(s.ripple, Yu.ripple),
        rippleVisible: ba(s.rippleVisible, Yu.rippleVisible),
        ripplePulsate: ba(s.ripplePulsate, Yu.ripplePulsate),
        child: ba(s.child, Yu.child),
        childLeaving: ba(s.childLeaving, Yu.childLeaving),
        childPulsate: ba(s.childPulsate, Yu.childPulsate)
      },
      timeout: CO,
      pulsate: k,
      rippleX: $,
      rippleY: U,
      rippleSize: K
    }, b.current)]), b.current += 1, E.current = X;
  }, [s]), A = Ze.useCallback((L = {}, k = {}, $) => {
    const {
      pulsate: U = !1,
      center: K = a || k.pulsate,
      fakeElement: X = !1
    } = k;
    if (L.type === "mousedown" && x.current) {
      x.current = !1;
      return;
    }
    L.type === "touchstart" && (x.current = !0);
    const Y = X ? null : O.current, J = Y ? Y.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    };
    let Q, Z, se;
    if (K || L.clientX === 0 && L.clientY === 0 || !L.clientX && !L.touches)
      Q = Math.round(J.width / 2), Z = Math.round(J.height / 2);
    else {
      const {
        clientX: pe,
        clientY: be
      } = L.touches ? L.touches[0] : L;
      Q = Math.round(pe - J.left), Z = Math.round(be - J.top);
    }
    if (K)
      se = Math.sqrt((2 * J.width ** 2 + J.height ** 2) / 3), se % 2 === 0 && (se += 1);
    else {
      const pe = Math.max(Math.abs((Y ? Y.clientWidth : 0) - Q), Q) * 2 + 2, be = Math.max(Math.abs((Y ? Y.clientHeight : 0) - Z), Z) * 2 + 2;
      se = Math.sqrt(pe ** 2 + be ** 2);
    }
    L.touches ? T.current === null && (T.current = () => {
      D({
        pulsate: U,
        rippleX: Q,
        rippleY: Z,
        rippleSize: se,
        cb: $
      });
    }, C.current = setTimeout(() => {
      T.current && (T.current(), T.current = null);
    }, gX)) : D({
      pulsate: U,
      rippleX: Q,
      rippleY: Z,
      rippleSize: se,
      cb: $
    });
  }, [a, D]), B = Ze.useCallback(() => {
    A({}, {
      pulsate: !0
    });
  }, [A]), I = Ze.useCallback((L, k) => {
    if (clearTimeout(C.current), L.type === "touchend" && T.current) {
      T.current(), T.current = null, C.current = setTimeout(() => {
        I(L, k);
      });
      return;
    }
    T.current = null, y(($) => $.length > 0 ? $.slice(1) : $), E.current = k;
  }, []);
  return Ze.useImperativeHandle(n, () => ({
    pulsate: B,
    start: A,
    stop: I
  }), [B, A, I]), /* @__PURE__ */ He(_X, st({
    className: ba(s.root, Yu.root, l),
    ref: O
  }, p, {
    children: /* @__PURE__ */ He(M7, {
      component: null,
      exit: !0,
      children: h
    })
  }));
});
process.env.NODE_ENV !== "production" && (g3.propTypes = {
  center: V.exports.bool,
  classes: V.exports.object,
  className: V.exports.string
});
const xX = g3;
function SX(e) {
  return rf("MuiButtonBase", e);
}
const wX = rl("MuiButtonBase", ["root", "disabled", "focusVisible"]), CX = wX, RX = ["action", "centerRipple", "children", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "LinkComponent", "onBlur", "onClick", "onContextMenu", "onDragLeave", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "tabIndex", "TouchRippleProps", "touchRippleRef", "type"], TX = (e) => {
  const {
    disabled: t,
    focusVisible: n,
    focusVisibleClassName: r,
    classes: a
  } = e, l = rv({
    root: ["root", t && "disabled", n && "focusVisible"]
  }, SX, a);
  return n && r && (l.root += ` ${r}`), l;
}, OX = os("button", {
  name: "MuiButtonBase",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  boxSizing: "border-box",
  WebkitTapHighlightColor: "transparent",
  backgroundColor: "transparent",
  outline: 0,
  border: 0,
  margin: 0,
  borderRadius: 0,
  padding: 0,
  cursor: "pointer",
  userSelect: "none",
  verticalAlign: "middle",
  MozAppearance: "none",
  WebkitAppearance: "none",
  textDecoration: "none",
  color: "inherit",
  "&::-moz-focus-inner": {
    borderStyle: "none"
  },
  [`&.${CX.disabled}`]: {
    pointerEvents: "none",
    cursor: "default"
  },
  "@media print": {
    colorAdjust: "exact"
  }
}), m3 = /* @__PURE__ */ Ze.forwardRef(function(t, n) {
  const r = Cd({
    props: t,
    name: "MuiButtonBase"
  }), {
    action: a,
    centerRipple: s = !1,
    children: l,
    className: p,
    component: h = "button",
    disabled: y = !1,
    disableRipple: b = !1,
    disableTouchRipple: E = !1,
    focusRipple: x = !1,
    LinkComponent: C = "a",
    onBlur: T,
    onClick: O,
    onContextMenu: D,
    onDragLeave: A,
    onFocus: B,
    onFocusVisible: I,
    onKeyDown: L,
    onKeyUp: k,
    onMouseDown: $,
    onMouseLeave: U,
    onMouseUp: K,
    onTouchEnd: X,
    onTouchMove: Y,
    onTouchStart: J,
    tabIndex: Q = 0,
    TouchRippleProps: Z,
    touchRippleRef: se,
    type: pe
  } = r, be = Ir(r, RX), _e = Ze.useRef(null), Se = Ze.useRef(null), Oe = eu(Se, se), {
    isFocusVisibleRef: re,
    onFocus: ie,
    onBlur: ce,
    ref: le
  } = OY(), [fe, ve] = Ze.useState(!1);
  y && fe && ve(!1), Ze.useImperativeHandle(a, () => ({
    focusVisible: () => {
      ve(!0), _e.current.focus();
    }
  }), []), Ze.useEffect(() => {
    fe && x && !b && Se.current.pulsate();
  }, [b, x, fe]);
  function ee(At, at, bt = E) {
    return Zm((Pt) => (at && at(Pt), !bt && Se.current && Se.current[At](Pt), !0));
  }
  const Ae = ee("start", $), he = ee("stop", D), Fe = ee("stop", A), Ne = ee("stop", K), xe = ee("stop", (At) => {
    fe && At.preventDefault(), U && U(At);
  }), oe = ee("start", J), it = ee("stop", X), Le = ee("stop", Y), qe = ee("stop", (At) => {
    ce(At), re.current === !1 && ve(!1), T && T(At);
  }, !1), Tt = Zm((At) => {
    _e.current || (_e.current = At.currentTarget), ie(At), re.current === !0 && (ve(!0), I && I(At)), B && B(At);
  }), Qe = () => {
    const At = _e.current;
    return h && h !== "button" && !(At.tagName === "A" && At.href);
  }, pt = Ze.useRef(!1), en = Zm((At) => {
    x && !pt.current && fe && Se.current && At.key === " " && (pt.current = !0, Se.current.stop(At, () => {
      Se.current.start(At);
    })), At.target === At.currentTarget && Qe() && At.key === " " && At.preventDefault(), L && L(At), At.target === At.currentTarget && Qe() && At.key === "Enter" && !y && (At.preventDefault(), O && O(At));
  }), wt = Zm((At) => {
    x && At.key === " " && Se.current && fe && !At.defaultPrevented && (pt.current = !1, Se.current.stop(At, () => {
      Se.current.pulsate(At);
    })), k && k(At), O && At.target === At.currentTarget && Qe() && At.key === " " && !At.defaultPrevented && O(At);
  });
  let tn = h;
  tn === "button" && (be.href || be.to) && (tn = C);
  const Vn = {};
  tn === "button" ? (Vn.type = pe === void 0 ? "button" : pe, Vn.disabled = y) : (!be.href && !be.to && (Vn.role = "button"), y && (Vn["aria-disabled"] = y));
  const Kt = eu(le, _e), ft = eu(n, Kt), [Gt, xn] = Ze.useState(!1);
  Ze.useEffect(() => {
    xn(!0);
  }, []);
  const gn = Gt && !b && !y;
  process.env.NODE_ENV !== "production" && Ze.useEffect(() => {
    gn && !Se.current && console.error(["MUI: The `component` prop provided to ButtonBase is invalid.", "Please make sure the children prop is rendered in this custom component."].join(`
`));
  }, [gn]);
  const rr = st({}, r, {
    centerRipple: s,
    component: h,
    disabled: y,
    disableRipple: b,
    disableTouchRipple: E,
    focusRipple: x,
    tabIndex: Q,
    focusVisible: fe
  }), Zi = TX(rr);
  return /* @__PURE__ */ qi(OX, st({
    as: tn,
    className: ba(Zi.root, p),
    ownerState: rr,
    onBlur: qe,
    onClick: O,
    onContextMenu: he,
    onFocus: Tt,
    onKeyDown: en,
    onKeyUp: wt,
    onMouseDown: Ae,
    onMouseLeave: xe,
    onMouseUp: Ne,
    onDragLeave: Fe,
    onTouchEnd: it,
    onTouchMove: Le,
    onTouchStart: oe,
    ref: ft,
    tabIndex: y ? -1 : Q,
    type: pe
  }, Vn, be, {
    children: [l, gn ? /* @__PURE__ */ He(xX, st({
      ref: Oe,
      center: s
    }, Z)) : null]
  }));
});
process.env.NODE_ENV !== "production" && (m3.propTypes = {
  action: Cz,
  centerRipple: V.exports.bool,
  children: V.exports.node,
  classes: V.exports.object,
  className: V.exports.string,
  component: xz,
  disabled: V.exports.bool,
  disableRipple: V.exports.bool,
  disableTouchRipple: V.exports.bool,
  focusRipple: V.exports.bool,
  focusVisibleClassName: V.exports.string,
  href: V.exports.any,
  LinkComponent: V.exports.elementType,
  onBlur: V.exports.func,
  onClick: V.exports.func,
  onContextMenu: V.exports.func,
  onDragLeave: V.exports.func,
  onFocus: V.exports.func,
  onFocusVisible: V.exports.func,
  onKeyDown: V.exports.func,
  onKeyUp: V.exports.func,
  onMouseDown: V.exports.func,
  onMouseLeave: V.exports.func,
  onMouseUp: V.exports.func,
  onTouchEnd: V.exports.func,
  onTouchMove: V.exports.func,
  onTouchStart: V.exports.func,
  sx: V.exports.oneOfType([V.exports.arrayOf(V.exports.oneOfType([V.exports.func, V.exports.object, V.exports.bool])), V.exports.func, V.exports.object]),
  tabIndex: V.exports.number,
  TouchRippleProps: V.exports.object,
  touchRippleRef: V.exports.oneOfType([V.exports.func, V.exports.shape({
    current: V.exports.shape({
      pulsate: V.exports.func.isRequired,
      start: V.exports.func.isRequired,
      stop: V.exports.func.isRequired
    })
  })]),
  type: V.exports.oneOfType([V.exports.oneOf(["button", "reset", "submit"]), V.exports.string])
});
const DX = m3, MX = rl("MuiDivider", ["root", "absolute", "fullWidth", "inset", "middle", "flexItem", "light", "vertical", "withChildren", "withChildrenVertical", "textAlignRight", "textAlignLeft", "wrapper", "wrapperVertical"]), A2 = MX, AX = rl("MuiListItemIcon", ["root", "alignItemsFlexStart"]), P2 = AX, PX = rl("MuiListItemText", ["root", "multiline", "dense", "inset", "primary", "secondary"]), N2 = PX;
function y3(e) {
  return rf("MuiMenuItem", e);
}
const NX = rl("MuiMenuItem", ["root", "focusVisible", "dense", "disabled", "divider", "gutters", "selected"]), Gm = NX, kX = ["autoFocus", "component", "dense", "divider", "disableGutters", "focusVisibleClassName", "role", "tabIndex"], IX = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, n.dense && t.dense, n.divider && t.divider, !n.disableGutters && t.gutters];
}, LX = (e) => {
  const {
    disabled: t,
    dense: n,
    divider: r,
    disableGutters: a,
    selected: s,
    classes: l
  } = e, h = rv({
    root: ["root", n && "dense", t && "disabled", !a && "gutters", r && "divider", s && "selected"]
  }, y3, l);
  return st({}, l, h);
}, BX = os(DX, {
  shouldForwardProp: (e) => nM(e) || e === "classes",
  name: "MuiMenuItem",
  slot: "Root",
  overridesResolver: IX
})(({
  theme: e,
  ownerState: t
}) => st({}, e.typography.body1, {
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  minHeight: 48,
  paddingTop: 6,
  paddingBottom: 6,
  boxSizing: "border-box",
  whiteSpace: "nowrap"
}, !t.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, t.divider && {
  borderBottom: `1px solid ${e.palette.divider}`,
  backgroundClip: "padding-box"
}, {
  "&:hover": {
    textDecoration: "none",
    backgroundColor: e.palette.action.hover,
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${Gm.selected}`]: {
    backgroundColor: Jm(e.palette.primary.main, e.palette.action.selectedOpacity),
    [`&.${Gm.focusVisible}`]: {
      backgroundColor: Jm(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  },
  [`&.${Gm.selected}:hover`]: {
    backgroundColor: Jm(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
    "@media (hover: none)": {
      backgroundColor: Jm(e.palette.primary.main, e.palette.action.selectedOpacity)
    }
  },
  [`&.${Gm.focusVisible}`]: {
    backgroundColor: e.palette.action.focus
  },
  [`&.${Gm.disabled}`]: {
    opacity: e.palette.action.disabledOpacity
  },
  [`& + .${A2.root}`]: {
    marginTop: e.spacing(1),
    marginBottom: e.spacing(1)
  },
  [`& + .${A2.inset}`]: {
    marginLeft: 52
  },
  [`& .${N2.root}`]: {
    marginTop: 0,
    marginBottom: 0
  },
  [`& .${N2.inset}`]: {
    paddingLeft: 36
  },
  [`& .${P2.root}`]: {
    minWidth: 36
  }
}, !t.dense && {
  [e.breakpoints.up("sm")]: {
    minHeight: "auto"
  }
}, t.dense && st({
  minHeight: 32,
  paddingTop: 4,
  paddingBottom: 4
}, e.typography.body2, {
  [`& .${P2.root} svg`]: {
    fontSize: "1.25rem"
  }
}))), b3 = /* @__PURE__ */ Ze.forwardRef(function(t, n) {
  const r = Cd({
    props: t,
    name: "MuiMenuItem"
  }), {
    autoFocus: a = !1,
    component: s = "li",
    dense: l = !1,
    divider: p = !1,
    disableGutters: h = !1,
    focusVisibleClassName: y,
    role: b = "menuitem",
    tabIndex: E
  } = r, x = Ir(r, kX), C = Ze.useContext(_O), T = {
    dense: l || C.dense || !1,
    disableGutters: h
  }, O = Ze.useRef(null);
  Eb(() => {
    a && (O.current ? O.current.focus() : process.env.NODE_ENV !== "production" && console.error("MUI: Unable to set focus to a MenuItem whose component has not been rendered."));
  }, [a]);
  const D = st({}, r, {
    dense: T.dense,
    divider: p,
    disableGutters: h
  }), A = LX(r), B = eu(O, n);
  let I;
  return r.disabled || (I = E !== void 0 ? E : -1), /* @__PURE__ */ He(_O.Provider, {
    value: T,
    children: /* @__PURE__ */ He(BX, st({
      ref: B,
      role: b,
      tabIndex: I,
      component: s,
      focusVisibleClassName: ba(A.focusVisible, y)
    }, x, {
      ownerState: D,
      classes: A
    }))
  });
});
process.env.NODE_ENV !== "production" && (b3.propTypes = {
  autoFocus: V.exports.bool,
  children: V.exports.node,
  classes: V.exports.object,
  component: V.exports.elementType,
  dense: V.exports.bool,
  disabled: V.exports.bool,
  disableGutters: V.exports.bool,
  divider: V.exports.bool,
  focusVisibleClassName: V.exports.string,
  role: V.exports.string,
  selected: V.exports.bool,
  sx: V.exports.oneOfType([V.exports.arrayOf(V.exports.oneOfType([V.exports.func, V.exports.object, V.exports.bool])), V.exports.func, V.exports.object]),
  tabIndex: V.exports.number
});
const zX = b3, FX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: zX,
  menuItemClasses: Gm,
  getMenuItemUtilityClass: y3
}, Symbol.toStringTag, { value: "Module" })), $X = /* @__PURE__ */ AO(FX);
Object.defineProperty(Gh, "__esModule", {
  value: !0
});
Gh.MenuItemIcon = Gh.MenuItemDetail = TO = Gh.MenuItem = void 0;
var UX = sM(Wt), ky = sM(Ay), oM = sM($X), Gp = hi;
function sM(e) {
  return e && e.__esModule ? e : { default: e };
}
function k2(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function VX(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? k2(Object(n), !0).forEach(function(r) {
      jX(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : k2(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function jX(e, t, n) {
  return t = WX(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function WX(e) {
  var t = GX(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
function GX(e, t) {
  if (typeof e != "object" || e === null)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (typeof r != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function RO() {
  return RO = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, RO.apply(this, arguments);
}
const _3 = ky.default.div`
    margin-right: 10px;

    > i {
        display: block;
    }
`;
Gh.MenuItemIcon = _3;
_3.displayName = "MenuItemIcon";
const HX = (0, ky.default)(oM.default)`
    color: var(--text-primary-color);
    font-size: 14px;
    height: 38px;

    ${Gp.hoverListItem}
    &:focus-visible {
        background-color: rgba(var(--vcs-color--primary-rgb), 0.15);
    }

    &.Mui-focusVisible {
        background-color: rgba(var(--vcs-color--primary-rgb), 0.15);
    }

    &.Mui-selected {
        ${Gp.selectedListItem}
        &:hover {
            ${Gp.selectedListItem}
        }
        &:focus-visible {
            background-color: rgba(var(--vcs-color--primary-rgb), 0.15);
        }
    }
`, E3 = (e) => /* @__PURE__ */ UX.default.createElement(HX, RO({
  disableRipple: !0
}, e));
var TO = Gh.MenuItem = E3;
E3.propTypes = oM.default.propTypes;
const tl = (0, ky.default)(oM.default)`
    color: var(--text-primary-color);
    font-size: 14px;

    display: flex;
    align-items: flex-start;
    ${Gp.hoverListItem}

    &.Mui-focusVisible {
        background-color: rgba(var(--vcs-color--primary-rgb), 0.15);
    }

    &.Mui-selected {
        ${Gp.selectedListItem}
        &:hover {
            ${Gp.selectedListItem}
        }
        &:focus-visible {
            background-color: rgba(var(--vcs-color--primary-rgb), 0.15);
        }
    }
`;
Gh.MenuItemDetail = tl;
tl.defaultProps = VX({
  disableRipple: !0
}, tl.defaultProps);
tl.displayName = "MenuItemDetail";
tl.Content = ky.default.div`
    display: flex;
    flex-direction: column;
    overflow: hidden;
    min-width: 0;
`;
tl.Content.displayName = "MenuItemDetail.Content";
tl.Title = ky.default.div`
    font-size: 14px;
    font-weight: bold;
    line-height: 32px;
    ${Gp.textOverflow};
`;
tl.Title.displayName = "MenuItemDetail.Title";
tl.Info = ky.default.div`
    ${Gp.textSecondary};
    white-space: normal;
    transition: color 0.25s ease-in;

    ${tl}:hover & {
        color: var(--vcs-color--primary);
    }

    ${tl}.Mui-selected & {
        color: var(--vcs-color--primary);
    }
`;
tl.Info.displayName = "MenuItemDetail.Info";
const I2 = {
  Wrapper: qu.div`
        display: flex;
        align-items: center;
        padding: 8px;

        > * {
            margin: 0 8px;
        }
    `,
  PercentButton: qu(zD)`
        border: none;
    `
}, YX = [10, 25, 50, 75, 100, 125, 200, 300];
function qX(e) {
  var t = null, n = !1;
  return e || (e = window.event), e.wheelDelta ? t = e.wheelDelta / 60 : e.detail && (t = -e.detail / 2), t !== null && (n = t > 0 ? "up" : "down"), n;
}
function uM({
  store: e,
  translations: t,
  ...n
}) {
  const {
    scaleFactor: r,
    setScale: a,
    fit: s,
    zoomIn: l,
    zoomOut: p
  } = e.dimensionStore;
  Wt.useEffect(() => {
    const E = document.getElementById("available-space"), x = (C) => {
      if (C.ctrlKey) {
        C.preventDefault();
        const {
          scrollHeight: T,
          scrollWidth: O
        } = E, D = C.clientX + E.scrollLeft - E.offsetLeft, A = C.clientY + E.scrollTop - E.offsetTop, B = D / O, I = A / T;
        qX(C) === "up" ? l() : p();
        const {
          scrollHeight: L,
          scrollWidth: k
        } = E, $ = k - O, U = L - T;
        E.scrollTo(E.scrollLeft + $ * B, E.scrollTop + U * I);
      }
    };
    return document.body.addEventListener("wheel", x, {
      passive: !1
    }), () => document.body.removeEventListener("wheel", x, {
      passive: !1
    });
  }, []), Wt.useEffect(() => {
    const E = (x) => {
      x.ctrlKey && ["+", "-"].includes(x.key) && (x.preventDefault(), x.key === "+" && l(), x.key === "-" && p());
    };
    return document.body.addEventListener("keydown", E, {
      passive: !1
    }), () => document.body.removeEventListener("keydown", E, {
      passive: !1
    });
  }, []);
  const h = Ih.usePopupState({
    variant: "popper",
    popupId: "zoom"
  }), y = Ih.usePopupState({
    variant: "popper",
    popupId: "zoom-list"
  }), b = (E) => {
    const x = Ih.bindMenu(E);
    return {
      ...x,
      onClose: (C) => {
        x.onClose(C), h.close();
      }
    };
  };
  return /* @__PURE__ */ qi(Wt.Fragment, {
    children: [/* @__PURE__ */ He(rT, {
      ...Ih.bindTrigger(h),
      ...n,
      children: /* @__PURE__ */ He($E, {
        icon: "zoom-in-out"
      })
    }), /* @__PURE__ */ He(wO, {
      ...Ih.bindMenu(h),
      children: /* @__PURE__ */ qi(I2.Wrapper, {
        children: [/* @__PURE__ */ He(I2.PercentButton, {
          variant: "secondary",
          ...Ih.bindTrigger(y),
          children: Math.floor(r * 100) + "%"
        }), /* @__PURE__ */ qi(wO, {
          ...b(y),
          children: [YX.map((E) => /* @__PURE__ */ He(TO, {
            onClick: () => a(E / 100),
            children: E + "%"
          }, E)), /* @__PURE__ */ He(TO, {
            onClick: s,
            style: {
              borderTop: "1px solid var(--border-color)"
            },
            children: t.fit
          }, "fit")]
        }), /* @__PURE__ */ He(rT, {
          onClick: p,
          children: /* @__PURE__ */ He($E, {
            icon: "decrease-value"
          })
        }), /* @__PURE__ */ He(rT, {
          onClick: l,
          children: /* @__PURE__ */ He($E, {
            icon: "increase-value"
          })
        }), /* @__PURE__ */ He(zD, {
          variant: "secondary",
          onClick: s,
          children: t.fit
        })]
      })
    })]
  });
}
uM.propTypes = {
  store: V.exports.instanceOf(XB),
  translations: V.exports.object
};
uM.defaultProps = {
  translations: {
    fit: "Fit"
  }
};
const QX = zx(uM);
export {
  Xl as Action,
  h6 as Editor,
  c6 as Image,
  XB as Store,
  f6 as Text,
  QX as Zoom
};
